import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { setHours, setMinutes, addHours, subHours } from 'date-fns';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import { v4 as uuidv4 } from 'uuid';
import SendEmail from "./SendEmail.js";
import DatePicker from 'react-datepicker'
import SearchIcon from "../../assets/icons/search-icon.svg";
import RefreshIcon from "../../assets/images/refresh-icon.svg";
import * as XLSX from 'xlsx';
import { fetchGridLayout, getHyphenDDMMMYYYYHHMM, getHyphenDDMMYYYYHHMM,saveGridLayout, getHyphenDDMMYYYYHHMMSS,getFormattedLocalStorageArray } from '../common/utils';
import GroupIconRenderer from './GroupIconRenderer.js';
import RoutemapTransitAction from './RoutemapTransitAction.js'
import RoutemapenrouteAction from './routemapenroute.js';
import UpdateFTLConsignments from "./updateFTLConsignments.js";
import moment from "moment";
import { Modal } from 'react-bootstrap';
import CustomDialog from './CustomDialog.js';
import CustomDialogForEditLogs from './CustomDialogForEditLogs.js';
import TimelineModal from './TimelineModal.js';
import CustomDialogForDocumentsViewing from './CustomDialogForDocumentsViewing.js';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import SweetAlert from "react-bootstrap-sweetalert";
import Filter from '../../assets/icons/filters.svg'
import redirectURL from "../redirectURL";
import CourierActions from '../layouts/courierActions.js';
import UpdatePTLConsignments from "./updatePTLConsignments.js";

import MainCounters from './mainCounters.js'
import ViewMap from './ViewMap';
import TransitDelay from './TransitDelay';
import EnrouteException from './EnrouteException';
// import Overspeeding from './Overspeeding';
// import NightDriving from './NightDriving';
import LoadingException from './LoadingException';
import UnloadingException from './UnloadingException';
import DrawMap from '../common/drawmap';
import RoutemapAction from './routemapActionComponent.js';
import RouteNightDrivemap from './routenightdrivemap.js';
import NoGPS from './NoGPS.js';
import NoGPSMap from './NoGPSMap.js';
import ForceClose from './forceClose.jsx';
import CancelCourierConsignments from './cancelConsolidatedCourierConsignments.js';
import CancelLr from './cancelLr.js';
import ConsignmentActions from './ConsignmentActionsComponent';
import ShipmentLegs from "../layouts/shipmentlegs.js";
import onShowTransitDelayIcon from "../layouts/onshowtransitdelay.js";
import onShowNoTrackingIcon from "../layouts/onshownotracking.js";
import onShowstoppagesIcon from "../layouts/onshowstoppages.js";

import CourierShipmentLegs from "../layouts/couriershipmentlegs.js";

import AddDealerConsignments from "./addDealerConsignments.js";
import CourierConsignments from './CourierConsignments';
import BulkForceFileHandler from "../layouts/changebulkuploadhandler";
import FTLConsignments from "./FTLConsignments.js"
import PTLConsignments from "./PTLConsignments.js"
import ConsolidatedCounters from './consolidatedCounters.js';
import CryptoJS from 'crypto-js';
import uploadPOD from '../layouts/uploadPOD.js';
import UpdateConsignments from './updateConsignments.js';
import EditLogsConsignments from './editlogsConsignments.js';
import UploadFTLPod from '../layouts/uploadFTLPod.js';
import { set } from 'react-ga';
import {SubmitBtn} from "../common/utils.js";
import refreshIcon from "../../assets/images/refresh-icon.svg";
import AddConsignmentSlider from "./addConsignment.js";






var map = ''
const locationToPincode = {
    "SEMMENCEHRRY": "600119", "VALARPURAM": "602105", "AHMEDABAD": "382210", "BANGALORE": "562111", "BBSR": "751006", "COCHIN": "682021", "KOLKATA": "712310",
    "DEHRADUN": "248001", "GUWAHATI": "781035", "JAIPUR": "302006", "LUCKNOW": "226004", "BHIWANDI": "421302", "PATNA": "800009", "SONIPAT": "131101", "ZIRAKPUR": "140603", "RANCHI": "834010",
    "BHOPAL": "462022", "VIJAYAWADA": "520007", "CHENNAI": "600119", "AMBAD": "422007", "HARIDWAR": "249403"
};

function Consignments() {
   
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    const user = useMemo(() => JSON.parse(decode(localStorage.getItem("k"))), []);

    var localStorageRole = (localStorage.getItem("role"));
    var localStorageEmail = localStorage.getItem("email")
    var decodedRole = decode(localStorage.getItem("role"))

    let current_defs=[]
    const hasInitializedDefaultTab = useRef(false);
    const navigate = useNavigate();
    const agGridRef = useRef(null);
    const gridApi = useRef(null);
    const gridApi2 = useRef(null);
    const gridApiConsignments = useRef(null);
    const gridColumnApi = useRef(null); 
    const columnApiConsignments = useRef(null);
    const gridApiUpdateConsignments = useRef(null);
    const gridApiTransporterConsignments = useRef(null);
    const gridApiLRConsignments = useRef(null);
    const gridApiDeliveryDateUpdate = useRef(null);
    const columnApiUpdateConsignments = useRef(null);
    const [gridApiF, setGridApif] = useState(null);
    const [selectedOption, setSelectedOption] = useState("");
    const [selectedOption1, setSelectedOption1] = useState("lr");
    var [checkresetfilter, setcheckresetfilter] = useState(0)
    const fileRef1 = useRef(null);
    const [isSliderOpen, setIsSliderOpen] = useState(false);
    const [trackingTimeline, setTrackingTimeline] = useState(false);
    const [errorQueue, setErrorQueue] = useState([]);
    const [currentErrorIndex, setCurrentErrorIndex] = useState(0);


    const reloadPage = useRef(false);
    var [rowData, setRowData] = useState([])
    const [columnwithDefs, setColumnWithDefs] = useState([])
    var [filterToggle, setFilterToggle] = useState(false)
    var [key, setKey] = useState('')
    const [gridColumnState, setGridColumnState] = useState([]);

    const [gridColumnState1, setGridColumnState1] = useState([]);
    const [tptGridColumnState, setTptGridColumnState] = useState([]);
    const [invoiceGridColumnState, setInvoiceGridColumnState] = useState([]);
    const [deliveredGridColumnState, setDeliveredGridColumnState] = useState([]);
    const [deliveredGridColumnState1, setDeliveredGridColumnState1] = useState([]);
    const [allGridColumnState, setAllGridColumnState] = useState([]);
    const [allGridColumnState1, setAllGridColumnState1] = useState([]);

    const [overly, setOverlay] = useState("show-n");
    const [podremarks, setPodRemarks] = useState("");
    const [selectedTab, setSelectedTab] = useState("loading");
    const [transactionData, setTransactionData] = useState();
    const [filterInActive, setFilterInActive] = useState([]);
    const [filterTransporterDefs, setFilterTransporterDefs] = useState([]);

    const [filterActive, setFilterActive] = useState([]);
    const [filterAll, setFilterAll] = useState([]);
    const [filterForceClose, setFilterForceClose] = useState([]);

    const [activeColumnDefs, setActiveColumnDefs] = useState([]);
    const [tptColumnDefs, setTptColumnDefs] = useState([]);
    const [inactiveColumnDefs, setInactiveColumnDefs] = useState([]);

    
    const [deliveredColumnDefs, setDeliveredColumnDefs] = useState([]);
    const [allColumnDefs, setAllColumnDefs] = useState([]);
    const [forceCloseColumnDefs, setForceCloseColumnDefs] = useState([]);
    const [filterComplete, setFilterComplete] = useState([]);
    const [finalGridColState, setFinalGridColState] = useState([]);
    const [finalDeliveredGridColState, setFinalDeliveredColState] = useState([]);
    const [finalAllGridColState, setFinalAllColState] = useState([]);
    const [tptFinalGridColState, setTptFinalGridColState] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(false);
    var [dispatchTime, setDispatchTime] = useState(false);
    var [uploadType, setUploadType] = useState("");
    var [gateOutRow, setGateOutRow] = useState({});
    const [ableRemark, setAbleRemark] = useState(false);
    const [showOthersConsignee, setShowOthersConsignee] = useState([]);
    const [updatelrNo, setUpdateLrNo] = useState('');
    const [showUndelivered, setShowUndelivered] = useState(true);
    const [trackingTypeForDoc, setTrackingTypeForDoc] = useState();
    const [trackingType, setTrackingType] = useState();
    const [selectedViewTab, setSelectedViewTab] = useState('loading'); 
    const [driverNoValidation, setDriverNoValidation] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [transporterValidation, setTransporterValidation] = useState(false);
    const [driverNoMandatory, setDriverNoMandatory] = useState(false);
    const [noOfBoxesMandatory, setNoOfBoxesMandatory] = useState(false);
    const [entityValidation, setEntityValidation] = useState(false);
    const [sourceValidation, setSourceValidation] = useState(false);
    const [loadshowBulkupload, setLoadshowBulkupload] = useState("show-n");
    const [gridLoadshow, setGridLoadshow] = useState("show-n");
    const [dateTypeList, setDateTypeList] = useState([
        { label: "Invoice", value: "Invoice"},
        { label: "Dispatch", value: "Dispatch"},
        { label: "LR Updated", value: "LR Updated"}
    ]);


    const [noOfBoxesValidation, setNoOfBoxesValidation] = useState(false);
    const [totalCBMValidation, setTotalCBMValidation] = useState(false);
    const [totalWeightValidation, setTotalWeightValidation] = useState(false);
    const [modeValidation, setModeValidation] = useState(false);
    const [fuelValidation, setFuelValidation] = useState(false);

    const [truckNoValidation, setTruckNoValidation] = useState(false);
    const [invoiceTypeValidation, setInvoiceTypeValidation] = useState(false);
    const [vehicleTypeValidation, setVehicleTypeValidation] = useState(false);
    const [dispacthdateValidation, setDispatchdateValidation] = useState(false);
    const [timelineData, setTimelineData] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [manualUploadDetails14, setmanualUploadDetails14] = useState({
        dispatch_time:'',
      }); 
      const [shouldReload, setShouldReload] = useState(false);
      var [shipmentId, setShipmentId] = useState("");
      var [updateTracking, setUpdateTracking] = useState({label:"", value:""});
      const [error1, setError1] = useState('');
      const [error2, setError2] = useState('');
      const [errorMsg, setErrorMsg] = useState('');
    const [loadshow, setLoadShow] = useState("show-n")
    const [loadshowBulkLr, setLoadshowBulkLr] = useState("show-n")
    const [overlayBulkUpload, setOverlayBulkUpload] = useState("show-n")
    const [loadshowBulkTpt, setLoadshowBulkTpt] = useState("show-n")
    const [overlayBulkTpt, setOverlayBulkTpt] = useState("show-n")
    const [overlayBulkUpdate, setOverlayBulkUpdate] = useState("show-n")
    const [loadshowBulkUpdate, setLoadshowBulkUpdate] = useState("show-n")
    const [overlayBulkDeliveryUpdate, setOverlayBulkDeliveryUpdate] = useState("show-n")
    const [loadshowBulkDeliveryUpdate, setLoadshowBulkDeliveryUpdate] = useState("show-n")

    const [bulkPtlUpdate, setBulkPtlUpdate] = useState(false)
    const [bulkInvoiceError, setBulkInvoiceError] = useState(false)
    const [bulkLRError, setBulkLRError] = useState(false)
    const [bulkLRErrorMsg, setBulkLRErrorMsg] = useState(false)
    const [trackingTypeState, setTrackingTypeState] = useState("")
    const [invoiceTypeCheck, setInvoiceTypeCheck] = useState(false)
    const [bulkUpdateInvoiceError, setBulkUpdateInvoiceError] = useState(false)
    const [bulkInvoiceTypeError, setBulkInvoiceTypeError] = useState(false)
    const [bulkTrackingError, setBulkTrackingError] = useState(false)

    const [bulkError, setBulkError] = useState(false)
    const [bulkTotalWeightError, setBulkTotalWeightError] = useState(false)
    const [bulkDispatchError, setBulkDispatchError] = useState(false)
    const [bulkUpdateExpectedError, setBulkUpdateExpectedError] = useState(false)
    const [bulkUpdateLastEventTimeError, setBulkUpdateLastEventTimeError] = useState(false)
    const [bulkUpdateStatusError, setBulkUpdateStatusError] = useState(false)
    const [bulkUpdateEventError, setBulkUpdateEventError] = useState(false)
    const [bulkUpdateReasonErr, setBulkUpdateReasonErr] = useState(false)
    const [bulkUpdateCurrentLocationErr, setBulkUpdateCurrentLocationErr] = useState(false)
    const [bulkUpdateDispatchError, setBulkUpdateDispatchError] = useState(false)
    const [bulkModeError, setBulkModeError] = useState(false)
    const [bulkFuelError, setBulkFuelError] = useState(false)
    const [bulkMovementError, setBulkMovementError] = useState(false)
    const [bulkPincodeError, setBulkPincodeError] = useState(false)
    const [bulkDestinationError, setBulkDestinationError] = useState(false)
    const [bulkBoxesError, setBulkBoxesError] = useState(false)
    const [bulkSourceError, setBulkSourceError] = useState(false)
    const [sourceCity, setSourceCity] = useState(false)
    const [bulkEntityError, setBulkEntityError] = useState(false)
    const [bulkVehicleNoError, setBulkVehicleNoError] = useState(false)
    const [bulkVehicleTypeError, setBulkVehicleTypeError] = useState(false)
    const [bulkTptError, setBulkTptError] = useState(false)
    const [tptName, setTptName] = useState()
    const [bulkConsigneeError, setBulkConsigneeError] = useState(false)
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [reasonForceClose, setReasonForceClose] = useState("");
    const [searchConsignee, setSearchConsignee] = useState([{ label: 'All', value: 'all' }]);
    const [movementtype, setMovementtype] = useState({ label: '', value: '' });
    const [searchValue, setSeachValue] = useState('');
    const [selectedBulkSource, setSelectedBulkSource] = useState('');
    const [docRow, setDocRow] = useState();

    const [selectedRows, setSelectedRows] = useState([]);
    const [editDropPoints, setEditDropPoints] = useState([]);
    const [selectedInvoicetoUpdateLr, setSelectInvoicesToUpdate] = useState([])
    const [selectInvoicesToTransporterUpdate, setSelectInvoicesToTransporterUpdate] = useState([])
    const [selectedShipments, setSelectedShipments] = useState([])
    const [selectedTransporterShipments, setSelectedTransporterShipments] = useState([])
    const [consignmentCodeForLRUpdate, setConsignmentCodeForLRUpdate] = useState([])
    const [consignmentCodeForTransporterUpdate, setConsignmentCodeForTransporterUpdate] = useState([])
    const [selectedLRStoUpdateLr, setSelectLRSToUpdate] = useState([])
    const [selectedShipmentUpdate, setSelectShipmentUpdate] = useState([])
    const [selectedTruckUpdate, setSelectTruckUpdate] = useState([])
    const [editLogsData, setEditLogsData] = useState([])
    const [filteredLog, setFilteredLog] = useState([])
    const [editLogsModalOpen, setIsEditLogsModalOpen] = useState(false)
    const [showBgAlert, setShowBgAlert] = useState(false);
    const [bgAlertShown, setBgAlertShown] = useState(false);


    const [bulkTrackingType, setBulkTrackingType] = useState()
    var [Dselected_row, setDselected_row] = useState({});
    var [isMoreInvoices, setIsMoreInvoices] = useState(false);
    var [isBulkUpdate, setIsBulkUpdate] = useState(false);
    var [expectedTripEndTimeStamp, setExpectedTripEnd] = useState("");
    var [revisedTripEndTimeStamp, setRevisedTripsEnd] = useState("");
    var [consignmentStatusForMap , setConsignmentStatus] = useState("");
    var [expectedDistance, setExpectedDistance] = useState("")
    const [actualDeliveryDate, setActualDeliveryDate] = useState("");
    const [deliveryDate, setDeliveryDate] = useState("");
    const [shouldRefreshAfterAlert, setShouldRefreshAfterAlert] = useState(false);
    const [refreshAfterBulkWtVl, setRefreshAfterBulkWtVl] = useState(false);    
    const [lateDeliveryRemarkOptions, setLateDeliveryRemarkOptions] = useState([]);
    const shouldHardReload = useRef(false);

    var statusMap={
        0: "At Source",
        1:"Dispatched from Source",
        2: "In Transit",
        3: "Arrived At Destination",
        4: "Out For Delivery",
        5: "Delivered",
        6: "Force Closure",
        7: "Provision",
        8: "Delivered",
        9: "Cancelled",
        10: "Trip Created",
        11: "Undelivered"
    }
   const fuelToModeMap = {
    diesel: "Road",
    ev: "Road",
    cng: "Road",
    air: "Air",
    rail: "Rail",
    sea: "Sea"
};
    const getActiveTabData = () => {
    switch (tabName.value) {
        case "inactive":
            return inactiveTrips;
        case "active":
            return activeTrips.all;
        case "completed":
            return completedTrips.all;
        case "all":
            return allTrips.all;
        case "transporter":
            return transporterTrips1;
        default:
            return [];
    }
};
const onConfirmAlert = () => {
    if (errorQueue.length > 0) {
        const nextIndex = currentErrorIndex + 1;

        if (nextIndex < errorQueue.length) {
            setCurrentErrorIndex(nextIndex);
            setTitle(errorQueue[nextIndex]);
            return;
        } else {
            setShow(false);
            setErrorQueue([]);
            setCurrentErrorIndex(0);
            return;
        }
    }
    if (type === "success") {
        setShow(false);

        setTimeout(() => {
            window.location.reload();
        }, 100);

        return;
    }
    setShow(false);
};
const isDelayPerformance = (row) => {
    return row && row.ontime_status === 0;
};
const parseGridDate = (value) => {
    if (!value) return null;

    const normalized = normalizeDateToYYYYMMDDHHmm(value);

    if (normalized === "Invalid Date Format") {
        return null;
    }

    // At this point format is GUARANTEED
    return moment(normalized, "YYYY-MM-DD HH:mm", true);
};


const normalizeInvoice = (val) => {
    if (!val) return "";

    const str = val.toString().trim().toLowerCase();

    // numeric-only invoices
    if (/^\d+$/.test(str)) {
        return str;
    }

    return str
        .replace(/\s+/g, "")    // remove spaces
        .replace(/[-_]/g, "/")  // normalize separators
        .replace(/\/+/g, "/");  // collapse multiple slashes
};

    const getExistingInvoiceSet = () => {
        const invoiceSet = new Set();

        if (!gridApiConsignments.current) {
            return invoiceSet;
        }

        gridApiConsignments.current.forEachNode((node) => {
            const rawInvoice = node.data?.invoice_no;
            if (!rawInvoice) return;

            rawInvoice
                .toString()
                .split(",")
                .forEach((inv) => {
                    const normalized = normalizeInvoice(inv);
                    if (normalized) {
                        invoiceSet.add(normalized);
                    }
                });
        });

        return invoiceSet;
    };
    // const getDeliveredLRMap = () => {
    //     const map = new Map();

    //     if (!gridApiConsignments.current) return map;

    //     gridApiConsignments.current.forEachNodeAfterFilterAndSort((node) => {
    //         console.log("TOTAL GRID ROWS:", gridApiConsignments.current?.getDisplayedRowCount());

    //         const row = node.data;
    //         console.log("GRID LR:", row.lr_no);
    //         if (!row?.lr_no) return;

    //         const isDelivered =
    //             row.consignment_status?.toLowerCase() === "delivered" ||
    //             Number(row.status) === 5 ||
    //             Number(row.status) === 8;

    //         if (!isDelivered) return;

    //         const isDelay =
    //             Number(row.ontime_status) === 0 ||
    //             Number(row.transit_delay) === 1;

    //         map.set(row.lr_no, {
    //             isDelay,
    //             actual_delivery_date: row.actual_delivery_date || null
    //         });
    //     });

    //     return map;
    // };
    // const getDeliveredLRMap = () => {
    //     const map = new Map();

    //     if (!gridApiConsignments.current) return map;

    //     gridApiConsignments.current.forEachNode((node) => {
    //         const row = node.data;
    //         if (!row?.lr_no) return;

    //         const lr = row.lr_no
    //             .toString()
    //             .trim()
    //             .toUpperCase();

    //         const isDelay =
    //             Number(row.ontime_status) === 0 ||
    //             Number(row.transit_delay) === 1;

    //         map.set(lr, {
    //             isDelay,
    //             actual_delivery_date: row.actual_delivery_date || null
    //         });
    //     });

    //     return map;
    // };
    const getDeliveredLRMap = () => {
        const map = new Map();

        if (!gridApiConsignments.current) return map;

        const seen = new Set(); // prevent duplicate DB rows

        gridApiConsignments.current.forEachNode((node) => {

            const row = node.data;
            if (!row?.lr_no) return;

            const lr = row.lr_no.toString().trim().toUpperCase();
            const invoice = row.invoice_no?.toString().trim() || "";

            const isDelay =
                Number(row.ontime_status) === 0 ||
                Number(row.transit_delay) === 1;

            // Unique key per DB row
            const key = `${lr}|${invoice}`;

            // Skip duplicates
            if (seen.has(key)) return;

            seen.add(key);

            const record = {
                invoice_no: invoice,
                isDelay,
                actual_delivery_date: row.actual_delivery_date || null
            };

            if (!map.has(lr)) {
                map.set(lr, []);
            }

            map.get(lr).push(record);
        });

        return map;
    };

    const getInvoiceTrackingTypeMap = () => {
        const map = new Map();

        if (!gridApiConsignments.current) {
            return map;
        }

        gridApiConsignments.current.forEachNodeAfterFilterAndSort((node) => {
            const rawInvoice = node.data?.invoice_no;
            const trackingType = node.data?.tracking_type;

            if (!rawInvoice || !trackingType) return;

            rawInvoice
                .toString()
                .split(",")
                .forEach((inv) => {
                    const normalized = normalizeInvoice(inv);
                    if (normalized) {
                        map.set(normalized, trackingType); 
                    }
                });
        });

        return map;
    };


    const validateBulkInvoiceData = (rows) => {
        const existingInvoiceSet = getExistingInvoiceSet();
        const invoiceTrackingMap = getInvoiceTrackingTypeMap();

        const invoiceCountMap = {};
        const duplicateInvoiceSet = new Set();

        rows.forEach((row) => {
            const inv = normalizeInvoice(row.invoice_no);
            if (!inv) return;

            invoiceCountMap[inv] = (invoiceCountMap[inv] || 0) + 1;
        });

        Object.keys(invoiceCountMap).forEach((inv) => {
            if (invoiceCountMap[inv] > 1) {
                duplicateInvoiceSet.add(inv);
            }
        });

        const validatedRows = rows.map((row) => {
            const inv = normalizeInvoice(row.invoice_no);
            const rowTracking = row.tracking_type;

            // const weight = Number(row.total_weight);
            // const cbm = Number(row.total_cbm);
            const weight = row.total_weight;
            const cbm = row.total_cbm;   

            let errorReason = "";

            if (!inv) {
                errorReason = "Invoice is empty";
            } else if (!existingInvoiceSet.has(inv)) {
                errorReason = "Invoice not exists in All tab Invoice view";
            }

            else if (
                invoiceTrackingMap.has(inv) &&
                rowTracking &&
                invoiceTrackingMap.get(inv) !== rowTracking
            ) {
                errorReason = "Tracking Type is not correct";
            }

            else if (duplicateInvoiceSet.has(inv)) {
                errorReason = "Duplicate invoice in file";
            }

            // else if (isNaN(weight) || weight < 0) {
            //     errorReason = "Total Weight must be 0 or greater";
            // }
            // else if (isNaN(cbm) || cbm < 0) {
            //     errorReason = "Total CBM must be 0 or greater";
            // }
            else if (weight === null || weight === undefined || weight === "") {
                errorReason = "Total Weight is mandatory";
            }
            else if (isNaN(Number(weight)) || Number(weight) < 0) {
                errorReason = "Total Weight must be 0 or greater";
            }

            else if (
                cbm !== null &&
                cbm !== undefined &&
                cbm !== "" &&
                (isNaN(Number(cbm)) || Number(cbm) < 0)
            ) {
                errorReason = "Total CBM must be 0 or greater";
            }


            return {
                ...row,
                _hasError: !!errorReason,
                _errorReason: errorReason
            };
        });

        return { validatedRows };
    };
    const normalizeTrackingType = (val) => {
        if (!val) return "";
        return val.toString().trim().toUpperCase();
    };

const handleInvoiceSearch = (value) => {
    setSearchInvoice(value);

    const activeData = getActiveTabData();

    if (!value || value.trim() === "") {
        setRowData(activeData);
        return;
    }

    const filtered = activeData.filter((row) =>
        row.invoice_no &&
        row.invoice_no.toString().toLowerCase().includes(value.toLowerCase())
    );

    setRowData(filtered);
};

    useEffect(() => {
        loadLateDeliveryRemarks();
    }, []);

    const loadLateDeliveryRemarks = async () => {
        try {
            const resp = await redirectURL.post(
                "/consignments/reasonForDelayData",
                {}
            );
            // extract list from new API structure
            const remarks = resp.data?.[0]?.master_data || [];
            setLateDeliveryRemarkOptions(remarks);
        } catch (err) {
            console.error("Failed to load Late Delivery Remarks", err);
            setLateDeliveryRemarkOptions([]);
        }
    };


  
    useEffect(() => {
        const allEntities = [
          { label: "Adlec", value: "Adlec" },
          { label: "Indoasian", value: "Indoasian" },
          { label: "Legrand", value: "Legrand" },
          { label: "Numeric", value: "Numeric" },
          { label: "Valrack", value: "Valrack" },
          { label: "Netrack", value: "Netrack"},
        ];
    
        // Get the stored entities from localStorage
        const storedEntities = localStorage.getItem('entity'); // Assuming 'entity' is the key in localStorage
        

        // Check if storedEntities is not null, undefined, or an empty string
        if (storedEntities && storedEntities !== "null" && storedEntities !== "undefined" && storedEntities.length > 0 && !["all"].some((item)=> entityConversion.includes(item))) {
            const entityArray = storedEntities.split(','); // Split into array based on comma
        
            // Filter the allEntities array to only include the entities that are in localStorage
            const filteredOptions = allEntities.filter(entity =>
                entityArray.includes(entity.value) // Check if entity value is in storedEntities
            );
        
            setEntityList(filteredOptions); // Set the filtered options
        } else {
            // If no valid entities in localStorage, show all entities
            setEntityList(allEntities); // Set all entities as options
        }
        
      }, []);
      useEffect(() => {
        if (!hasInitializedDefaultTab.current) {
          const storedTab = localStorage.getItem(`selectedTab_${processFlowType}`);
      
          if (storedTab) {
            setTabName(JSON.parse(storedTab));
          } else {
            if (processFlowType === "inbound" && !["transporter", "admin"].includes(decodedRoleCase)) {
              const defaultTab = { label: "active", value: "active" };
              setTabName(defaultTab);
              localStorage.setItem(`selectedTab_${processFlowType}`, JSON.stringify(defaultTab));
              decodedRoleCase === "user"
                ? navigate("/consignments/active_inbound_consignments")
                : navigate("/consignments/active_consignments");
            }
            // Similar logic can be added for outbound if needed
          }
      
          hasInitializedDefaultTab.current = true;
        }
      }, [processFlowType]);
      useEffect(() => {
        localStorage.removeItem(`selectedTab_${processFlowType === "inbound" ? "outbound" : "inbound"}`);
      }, [processFlowType]);
   
    const statusOrderPtl =[
        { label: 'In Transit', value: 'In Transit' },
        { label: 'Arrived At Destination', value: 'Arrived At Destination' }, 
        { label: 'Out For Delivery', value: 'Out For Delivery' },
        { label: 'Delivered', value: 'Delivered' }, 
        { label: 'Undelivered', value: 'Undelivered' },
    ]
    const statusOrderFtl =[
        {label: 'Dispatched from Source', value:"Dispatched from Source"},
        { label: 'In Transit', value: 'In Transit' },
        { label: 'Arrived At Destination', value: 'Arrived At Destination' }, 
        { label: 'Out For Delivery', value: 'Out For Delivery' },
        { label: 'Delivered', value: 'Delivered' }, 
        { label: 'Undelivered', value: 'Undelivered' },
    ]
    const bulkStatusOrder =[
        {label: 'Dispatched from Source', value:"Dispatched from Source"},
        { label: 'In Transit', value: 'In Transit' },
        { label: 'Arrived At Destination', value: 'Arrived At Destination' }, 
        { label: 'Out For Delivery', value: 'Out For Delivery' },
        { label: 'Delivered', value: 'Delivered' }, 
        { label: 'Undelivered', value: 'Undelivered' },
    ]
    const [form2Details, setForm2Details] = useState({
        event_status:statusOrderFtl,
        selectedStatus: { label: '', value: '' },
        selectedPincode: {label:'', value:''},
        event_location: "",
        remark: {label:"", value:""},
        reason_for_delay:{label:"", value:""},
        delivered_date:new Date(),
        delivered_time:new Date(),
        errorMessage:''
    })
    const [isValid, setIsValid] = useState(true);
    const [uploadPODTracking, setUploadPODTracking] = useState(false);
    const [selectedStatusUpdate, setSelectedStatusUpdate] = useState("");


    const [counterActive, setCounterActive] = useState("Total");
    const [setLrUpdateBtn, setShowLrUpdateBtn] = useState(false);
    const [setTransporterUpdateBtn, setShowTransporterUpdateBtn] = useState(false);
    // tab states
    const [tabName, setTabName] = useState({ label: "", value: "" });
    const [warehouseTab, setWarehouseTab] = useState({label : "My WH", value : "my_warehouse"})

    // left box fields    
    const [searchType, setSearchType] = useState({ label: "LR No", value: "lr_no" });
    const [searchTrackingType, setSearchTrackingType] = useState({label:"All", value:"All"})
    const [searchViewType, setSearchViewType] = useState({ label: "LR", value: "LR" })
    const [searchPerformance, setSearchPerformance] = useState({label:"", value:""})
    const [searchDateType, setSearchDateType] = useState({ label: "Dispatch", value: "Dispatch"})
    const [searchInvoice, setSearchInvoice] = useState();
    const [filteredvehicles, setFilteredvehicles] = useState([]);
    const [searchVehicle, setSearchVehicle] = useState({ value: "", label: "" })
    const [filteredLrnos, setFilteredLrnos] = useState([]);
    const [lrNo, setLrNo] = useState()
    const [invoicesUploadList, setInvoiceUploadList] = useState([]);
    const [selectedInvoiceUpload, setSelectedInvoiceUpload]= useState();


    // right box fields
    const [startDate, setStartDate] = useState(new Date(moment.parseZone().subtract(1, "month")));
    const [endDate, setEndDate] = useState(new Date(moment.parseZone()));
    const [consignersList, setConsignersList] = useState([]);
    const [searchConsigner, setSearchConsigner] = useState([]);

    const [filterCities, setFilterCities] = useState([]);
    const [searchCity, setSearchCity] = useState([]);
    const [filterConsigneeNames, setFilterConsigneeNames] = useState([]);
    const [searchConsigneeName, setSearchConsigneeName] = useState([]);

    const [searchPodStatus,setSearchPodStatus] = useState([]);
    const [filterStates, setFilterStates] = useState([]);
    const [searchState, setSearchStates] = useState([]);
    const [searchEntity, setSearchEntity] = useState([]);
    const [filterTransporters, setFilterTransporters] = useState([]);
    const [error, setError] = useState(null);
    const [errorMsg1, setErrorMsg1] = useState(false);
    const [invoiceValid, setInvoiceValid] = useState(false);
    const [matchedSource, setMatchedSource] = useState(null);
    const [ sourceList, setSourceList] = useState([]);
    const [ originalSourceList, setOriginalSourceList] = useState([]);
    const [ sourceSeriesList, setSourceSeriesList] = useState([]);

    const [ sourceRecords, setSourceRecords ] = useState([]);
    const [ seriesRecords, setSeriesRecords ] = useState([]);
    const  [ consignees, setConsignees ] = useState([])
    const [ tripConsignees, setTripConsignees ] = useState([])
    const [ dropPointConsignee,setDropPointConsignee ] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    const [isValid1,setIsValid1] = useState(false);
    const [showCustomConsigneeInput, setShowCustomConsigneeInput] = useState({});
    const [ entityList, setEntityList] = useState([
        {label:"Adlec", value:"Adlec"},
        {label:"Indoasian", value:"Indoasian"},
        {label:"Legrand", value: "Legrand"},
        {label:"Numeric", value:"Numeric"},
        {label:"Valrack", value:"Valrack"},
        {label:"Netrack", value:"Netrack"},
    ]);
    const [ podStatusList, setPodStatusList] = useState([
        {label:"Available", value:"Available"},
        {label:"Not Available", value:"Not Available"},
       
    ]);
    const [ fuelTypeList, setFuelTypeList] = useState([
        {label:"Diesel", value:"Diesel"},
        {label:"EV", value:"EV"},
        {label:"CNG", value: "CNG"},
        {label:"Rail", value:"Rail"},
        {label:"Air", value:"Air"},
        {label:"Sea", value:"Sea"},
    ]);
    const [ fuelTypeListForUpdateLR, setFuelTypeListForUpdateLR] = useState([])

    const [ TrackingTypeList, setTrackingTypeList] = useState([
        {label:"FTL", value:"FTL"},
        {label:"PTL", value:"PTL"}
    ]);
    const [ modeList, setModeList] = useState([
        {label:"Road", value:"Road"},
        {label:"Rail", value:"Rail"},
        {label:"Air", value:"Air"},
        {label:"Sea", value:"Sea"},
    ]);
    const [ movementType, setMovementType ] = useState([
        { label:"Internal Movement", value:"Internal Movement" },
        { label:"Customer Delivery", value:"Customer Delivery" },
        { label:"Customer Returns", value:"Customer Returns" },
        { label: "Supplier Movement", value: "Supplier Movement" }
    ])
    const [source, setSource] = useState({label:"", value:""})
    const [searchTransporters, setSearchTransporters] = useState([]);
    const [selectedCounter, setSelectedCounter] = useState('Total');




    const [lrNoOption, setLrOptions] = useState([]);
    const [cancelledLrs, setCancelledLrs] = useState([])
    const [invoiceSelected, setInvoiceSelected] = useState([]);


    const [counter, setCounter] = useState({ label: "Consignments", value: "consignments" });
    var [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [basicTitle, setBasicTitle] = useState('');
    const [basicType, setBasicType] = useState('');
    const [maptruckno, setMaptruckno] = useState('');
    const [deptcode, setDeptcode] = useState('');
    const [sliderRouteTranslate, setSliderRouteTranslate] = useState('');
    const [showDiv, setShowDiv] = useState('');
    const [mapinfo, setMapinfo] = useState({});
    const [dealer, setDealer] = useState('');
    const [consignment_code, setConsignment_code] = useState('');
    const [routeTruck, setRouteTruck] = useState({});
    const [leg_no, setLeg_no] = useState(0);
    const [tolls, setTolls] = useState([]);
    const [devation_flag, setDevation_flag] = useState(false);
    const [sliderCreateConsignmentTranslate, setSliderCreateConsignmentTranslate] = useState("show-n")
    var [selected_row, setselected_row] = useState({});
    var [sliderShow, setSliderShow]=useState('');
    
    const [docremarks, setDocRemarks] = useState("");
    const [loadingdocremarks, setLoadingRemarks] = useState("");
    const [unloadingdocremarks, setUnloadingRemarks] = useState("");

    var [customerDocument1, setCustomerDocument1] = useState('');
    var [epodDoc, setEpodDoc] = useState([]);
    var [customerDocument2, setCustomerDocument2] = useState('');
    var [uploadDoc, setUploadDoc] = useState([]);
    var [isSliderDocumentOpen, setSliderDocumentOpen] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [podDocuments, setPodDocuments] = useState([])
    var [short, setShort]= useState(0);
    var [damage, setDamage]= useState(0);
    var [excess, setExcess]= useState(0);
    var [pilferage, setPilferage]= useState(0);
    
    const [manualUploadSlider, setManualUploadSlider] = useState('show-n');
    const [bulkMarkDeliverSlide, setBulkMarkDeliverSlide] = useState('show-n');
    const [shipmentSlider, setShipmentSlider] = useState('show-n');
    const [shipmentCsvContent, setShipmentCsvContent] = useState([]);
    const [shipmentFile, setShipmentFile] = useState('');
    const [bulkSliderShow, setBulkSliderShow] = useState('show-n');
    const [sliderScanShow, setSliderScanShow] = useState('show-n');
    const [sliderSupportShow, setSliderSupportShow] = useState('show-n');
    const [selectedRowNodes, setSelectedRowNodes] = useState([]);
    const [multiplePodDocs, setMultiplePodDocs] = useState([]);
    const [deliveredDate1, setDeliveredDate1] = useState("");
    const [updateRowSlider, setUpdateRowSlider] = useState("");
    var [sliderShow1, setSliderShow1]=useState('')
    var [lRTrackingType, setLRTrackingType]=useState('')
    var [ValidWeight, setValidWeight]=useState('')
    var [ptlValidWeight, setPtlValidWeight]=useState('')

    var [ftlValidWeight, setFtlValidWeight]=useState('')

    var [invoiceDateValueOfUpdateLr, setInvoiceDateValueOfUpdateLr]=useState('')

    var [addDealer, setAddDealer] = useState(false);
    
    var [isSliderEmailOpen, setSliderEmailOpen] = useState(false);
    var [isSliderDocumentOpen, setSliderDocumentOpen] = useState(false);
    var [isSliderPODDocumentOpen, setSliderPODDocumentOpen] = useState(false);
    var [viewPodRemark, setViewPodRemark] = useState("");
    var [viewRemark, setViewRemark] = useState("");

    var [email, setEmail] = useState("");    
    var [isSliderEmailOpen, setSliderEmailOpen] = useState(false);
    var [data, setData] = useState([]);
    var [whatsapp_no, setWhatsapp_no] = useState("")
    var [activeForm, setActiveForm] = useState("")
    var [expired_time, setexpired_time] = useState({ label: "7 Days", value: 7 })
    var [orginalDetailsForEdit  ,setOrginalDetailsForEdit] = useState([])
    const [ consignmentUidForTruckLevel ,setConsignmentUidForTruckLevel] = useState("")
    const [ dropPointArr, setDropPointArr] = useState([])
    const [manualTripUploadDetails, setManualTripUploadDetails] = useState([
        // {
        //   id: uuidv4(),
        //   lr_no: '',
        //   consignee_name: "",
        //   invoice_no: "",
        //   no_of_boxes: "",
        //   destination_pincode: "",
        //   destination_city: "",
        //   eway_bill_no: "",
        //   customer_mail_id: "",
        // }
    ]);
    const [showAddForm, setshowAddForm] = useState("");
    const [showAddForm1, setshowAddForm1] = useState("");
    const [showAddForm2, setshowAddForm2] = useState("");
    const [showAddForm3, setshowAddForm3] = useState("");
    const [showBulkUpdateForm, setshowBulkUpdateForm] = useState("");
    const [showBulkUpdateDeliveryDate, setshowBulkUpdateDeliveryForm] = useState("");
    const [showBulkTransporterForm, setshowBulkTransporterForm] = useState("");
    const [showBulkLRForm, setshowBulkLRForm] = useState("");

    var [tabActive, settabActive] = useState('ftl')
    var savedProcessFlowType = localStorage.getItem("processFlowType") || (decode(localStorageRole) === "wh-outbound" ? "outbound" : "inbound");
    var [processFlowType, SetProcessFlowType] = useState(savedProcessFlowType);
    var [file, setFile] = useState(null)
    var [file1, setFile1] = useState(null)
    var [file2, setFile2] = useState(null)
    var [file3, setFile3] = useState(null)
    var [file4, setFile4] = useState(null)
    var [csvcontent, setcsvcontent] = useState("")
    
    var [vehicleTypeList, setVehicleTypeList] = useState([]);
    var [courierPartnerList, setCourierPartnerList] = useState([]);
    var [courierPartnerList1, setCourierPartnerList1] = useState([]);
    var [tptRecords, settptRecords] = useState([]);
    var [SIMTrackingTpts, setSimTrackingTpts] = useState([]);
    var [vehicleCapacityList, setVehicleCapacityList] = useState([]);
    var [vehicleFtlTypeList, setVehicleFtlTypeList] = useState([]);
    var [vehiclePtlTypeList, setVehiclePtlTypeList] = useState([]);
    var [vehicleFtlTypeArr1, setVehicleFtlArr1] = useState([]);
    const [ errorMessage,setErrorMssge] = useState("");
    const [ enableSourceField,setEnableSourceField] = useState(false)
    const [ enableVehicleType, setEnableVehicelType ] = useState(false)
    const [ enableVehicleType1, setEnableVehicelType1 ] = useState(false)
    const [ enableCourierType, setEnableCourierType] = useState(false)
    const [ enableVehicleCapacity, setEnableVehicleCapacity ] = useState(false)
    const [ enableConsignee, setEnableConsigee] = useState(false);
    const [ validOtherSource, setValidOtherSource] = useState(null)
    const [ validateTruckNo, setValidTruckNo ] = useState(true);
    const [ validOtherConsigneeName, setValidateOtherConsignee ] = useState(null);
    const [ isOtherConsigneeName, setIsOtherConsigneeName ] = useState(null)
    const [validPincode, setValidPincode] = useState(true);
    const [validCity, setValidCity] = useState(true);
    const [validPincode1, setValidPincode1] = useState(true);
    const [validCity1, setValidCity1] = useState(true);
    const [ enableEdit, setEnableEdit ] = useState(true);
    const [validVehicleCapacity, setValidVehicleCapacity] = useState(null)
    const apiTimeoutRef = useRef(null);
    const [selectedConsignees, setSelectedConsignees] = useState([]);
    const [formData, setFormData] = useState({
        driver_mobile_no:'',
        source:{label:"", value:""},
        truck_no:'',
        truck_seal_no:'',
        other_source:"",
        other_source_pincode:"",
        other_transporter:"",
        other_vehicle_type:"",
        other_consignee_name:"",
        consigner_name:"",
        other_vehicle_capacity:"",
        other_destination_pincode:"",
        other_destination_city:"",
        entity:{label:"", value:""},
        vehicle_type:{label:'', value:''},
        courier_partner:{label:'', value:''},
        eway_bill_expiry_date:'',
        invoice_date:'',
        total_weight:'',
        total_cbm:'',
        cus_mobile_no:'',
        vehicle_capacity:'',
        consignee_name:{label:"", value:""},
        consignee_name1:"",
        movement_type:{label:"", value:""},
        lr_no:'',
        invoice_no:[],
        invoice_no_str:"",
        number_of_boxes:'',
        destination_pincode:'',
        destination_city:'',
        show: false,
        basicType: '',
        basicTitle: '',
        sliderCreateConsignmentTranslate: '',
        loadshow: 'show-n',
        overly: 'show-n',
        disableAddDrop: true,
        disableSubmit: true, 
        dispatch_time:new Date(),
    });
    const [tabOptions, setTabOptions] = useState([
        { label: "Inactive", value: "inactive" },
        { label: "Active", value: "active" },
        { label: "Completed", value: "completed" },
        { label: "All", value: "all" },
        { label: "Force Close", value: "force_close" },
        { label: "Transporter", value: "transporter" },
    ])

    const [warehouseTabOptions, setWarehouseTabOptions] = useState([
        { label: "My WH", value: "my_warehouse" },
        { label: "My Region", value: "my_region" },
    ])

    const [counterOptions, setCounterOptions] = useState([
        { label: "Consignments", value: "consignments" },
        { label: "Transit Delays", value: "transit_delays" },
        { label: "No GPS Available", value: "no_gps_data" },
        { label: "No GPS Available Lifetime", value: "no_gps_data_lifetime" },
        // { label: "Overspeeding", value: "overspeeding" },
        // { label: "Night Driving", value: "night_driving" },
        { label: "Stoppages", value: "stoppages" },
        { label: "Accidents", value: "accidents" },
        { label: "Trip Deviations", value: "trip_deviations" },
        { label: "Loading Delay", value: "loading_delay" },
        { label: "Unloading Delay", value: "unloading_delay" }
    ]);

    // var filterCardStyle1 = { minHeight: "234px" };
    var filterCardStyle2 = { padding: '20px' };
    var mnFilterClass = { marginLeft: "0px", padding: "0px" };
    const [rownode, setRownode] = useState([]);
    const [forceCloseModal, setForceCloseModal] = useState(false);
    const [cancelModal, setCloseCancelModal] = useState(false); 
    const [selectedRecordType , setSelectedRecordType] = useState("")
    const [combinedDate , setCombinedDate] = useState("")
    const [cancelConsignmentForTrackinType, setCancelConsignmentTrackingType] = useState("")
    const [deletionId , setDeletionId] = useState("")
    const [reasonForCancellation, setReasonForCancellation] = useState("")
    var [mapDetails, setMapDetails] = useState([]);
    const [inactiveTrips, setInactiveTrips] = useState([])
    const [closeTrips, setCloseTrips] = useState([])
    const [transporterTrips1, setTransporterTrips] = useState([])
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [activeTrips, setActiveTrips] = useState({
        all: [],
        inTransit: [],
        transit_delay: [],
        no_gps_data: [],
        stoppages: [],
        outForDelivery: [],
        undelivered: [],
        at_source:[],
        dispatched_from_source: [],
        arrived_at_destination:[],
        ftl_sim_issue:[],
        consent_pending:[],
        consent_approved:[],
        location_data_acquired:[]

    })
    const [completedTrips, setCompletedTrips] = useState({
        all: [],
        delivered: [],
        onTime: [],
        delayed: [],
        podPending: [],
        zeroToOneDays:[],
        oneToTwoDays:[],
        threeToFiveDays:[],
        sixToTenDays:[],
        gtTenDays:[],
        ftl_sim_issue: [],
        consent_pending: []
    })
    const [allTrips, setAllTrips] = useState({
        all: [],
        inTransit: [],        
        transit_delay: [],
        no_gps_data: [],
        stoppages: [],
        disabled: [],
        undelivered: [],
        outForDelivery:[],
        delivered: [],
        podPending: [],
        at_source:[],
        dispatched_from_source: [],
        arrived_at_destination:[],
        ftl_sim_issue:[],
        consent_pending:[],
        consent_approved:[],
        location_data_acquired:[]


    })
    var [rowData1, setrowData1] = useState([]);

    const [modalloadData, setModalLoadData] = useState([])
    const [modalBulkUpdateData, setModalBulkUpdateData] = useState([])
    const [modalBulkTransporterData, setModalBulkTransporterData] = useState([])
    const [modalBulkLRData, setModalBulkLRData] = useState([])
    const [modalBulkDeliveryData, setModalBulkDeliveryData] = useState([])
    const [fileName, setFileName] = useState("No file chosen");
    const [plantData, setPlantData] = useState([])
    const [transporters, setTransporters] = useState([])
    const [dealers, setDealers] = useState([])
    const [previousData, setPreviousData] = useState([])
    const fileRef = useRef()
    const [show, setShow] = useState(false)
    const [invoiceNoList, setInvoiceNoList] = useState([]);
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [loader, setLoader] = useState(false)
    var [loadshow1, setloadshow1] = useState('show-n');
    var [truckLocations, setTruckLocations] = useState();

    const [bulkUploadModal, setBulkUploadModal] = useState({
        overly: "show-n",
        bulkPrioritySlide: ""
    })    
    const [showUpdateLrForm, setShowUpdateLrForm] = useState("");
    const [showUpdateTransporterForm, setShowUpdateTransporterForm] = useState("");
    const [editTransporter, setEditTransporter] = useState(false);
    const [manualUploadDetails, setmanualUploadDetails] = useState({
        lr_no: "",
        invoice_no: "",
    });
    
    var [gateOutSlide, setGateOutSlide] = useState("");
    const [manualInTransitStatusUpdate, setManualInTransitStatusUpdate] = useState(
        {dispatch_time:''}
    )
    const [manualUploadDetails1, setmanualUploadDetails1] = useState({
        lr_no: "",
        invoice_no: selected_row.invoice_no || '',
        consignee_name: "",
        consignee_city: "",
        consignee_state: "",
        consignee_pincode: "",
        total_weight: ""
    }); 
    const [otherSource, setOtherSource] = useState(false);
    const [otherVehicleType , setOtherVehicleType] = useState(false);
    const [otherTransporter , setOtherTransporter] = useState(false);
    const [otherConsignee, setOtherConsignee] = useState(false)
    const [otherDestinationPincode, setOtherDestinationPincode] = useState(false);
    const [sourceOptions, setSourceOptions] = useState([]);
    const [ consigneesForTrip, setConsigneesForTrip ] = useState([])
    const [ consignerCityList, setConsignerCityList ] = useState([])
    const [ enabledEDDEmailList, setEnabledEDDEmailList ] = useState([])
    const [ entityMasterData, setEntityMasterData ] = useState([])
    const [ vehicleMasterData, setVehicleMasterData ] = useState([])
    const [ tptMasterData, setTptMasterData ] = useState([])
    const [ tptData, setTptData ] = useState([])
    const [ invoiceMasterData, setInvoiceMasterData ] = useState([])
    const [ invoiceSourceData, setInvoiceSourceData ] = useState([])
    const [ validReasonsData, setValidReasonsDataArr ] = useState([])
    const [ validReasonsOptions, setValidReasonsOptions ] = useState([])
    const [ invoiceSourceSeries, setInvoiceSourceSeries ] = useState([])
    const [ invoiceSourceCategory, setInvoiceSourceCategory ] = useState([])
    const [manualUpdateConsignment, setManualUpdateConsignment] = useState({
        lr_no: "",
        invoice_no: "",
        driver_mobile_no: '',
        source: {label:"", value:""},
        other_source:"",
        other_source_pincode: "",
        truck_no: "",
        truck_seal_no: "",
        entity: {label:"", value:""},
        vehicle_type: {label:"", value:""},
        other_vehicle_type:{label:"", value:""},
        courier_partner:{label:"", value:""},
        other_transporter:{label:"", value:""},
        vehicle_capacity: "",
        other_vehicle_capacity:{label:"", value:""},
        eway_bill_expiry_date:'',
        consignee_name: {label:"", value:""},
        other_consignee_name:{label:"", value:""},
        movement_type:{label:"", value:""},
        no_of_boxes: "",
        destination_pincode: "",
        destination_city:"",
        other_destination_pincode:"",
        other_destination_city:"",
      }); 
      
    const [selectedTransporter, setSelectedTransporter] = useState({label:"", value:""})
    const [manualUpdateLRConsignment, setManualUpdateLRConsignment] = useState({
        lr_no: "",
        invoice_no: "",
        driver_mobile_no: '',
        truck_no: "",
        entity: {label:"", value:""},
        vehicle_type: {label:"", value:""},
        fuel_type:{label:"", value:""},
        other_vehicle_type:"",
        courier_partner:{label:"", value:""},
        other_transporter:{label:"", value:""},
        no_of_boxes: "",
        tracking_type:"",
        total_cbm:"",
        cus_mobile_no:"",
        total_weight:"",
        dispatch_time:"",
        tracking_type_mutliple: {label:"", value:""},
        mode: {label:"", value:""},
        eway_bill_no:"",


    });  
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        lr_no: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const [countersActive, setCountersActive] = useState({
        consignments: 0,
        transit_delays: 0,
        in_transit: 0,
        no_gps_data: 0,
        stoppages: 0,
        outfordelivery: 0,
        undelivered:0,
        at_source:0,
        dispatched_from_source: 0,
        arrived_at_destination:0,
        ftl_sim_issue:0,
        consent_pending:0,
        consent_approved:0,
        location_data_acquired:0
    })
    const [countersCompleted, setCountersCompleted] = useState({
        consignments: 0,
        delivered: 0,
        delayed: 0,
        onTime: 0,
        podPending: 0,
        zeroToOneDays: 0,
        oneToTwoDays: 0,
        threeToFiveDays: 0,
        sixToTenDays: 0,
        gtTenDays: 0,
        ftl_sim_issue: 0,
        consent_pending: 0
    })
    const [countersAll, setCountersAll] = useState({
        consignments: 0,
        inTransit: 0,
        transit_delays: 0,
        no_gps_data: 0,
        stoppages: 0,
        disabled: 0,
        undelivered: 0,
        outforDelivery:0,
        delivered: 0,
        podPending: 0,
        at_source:0,
        dispatched_from_source: 0,
        arrived_at_destination:0,
        ftl_sim_issue:0,
        consent_pending:0,
        consent_approved:0,
        location_data_acquired:0
       })
       const currentDate1 = new Date();
    //    const minDate1 = subHours(currentDate1, 48)
    //    const maxDate1=  currentDate1
    //    const minTime1 = currentDate1;
    //     const maxTime1 = addHours(currentDate1, 8)
        const minDate1 = subHours(currentDate1, 48); // 48 hours ago
const maxDate1 = new Date(currentDate1.getTime() + 8 * 60 * 60 * 1000);// Current date
var [minTime1, setMinTime1]= useState(minDate1);
var [maxTime1, setMaxTime1] = useState(addHours(currentDate1, 8));
const [inactiveColumns, setInactiveColumns] = useState([]);

const [modeDisabled, setModeDisabled] = useState(false);
// const getBulkDeliveryRowStyle = (params) => {
//     if (params.data?.isInvalidPerformance) {
//         return {
//             backgroundColor: "#f8d7da", // light red
//             color: "#721c24",
//             fontWeight: "600"
//         };
//     }
//     return null;
// };

useEffect(() => {
    if (manualUpdateLRConsignment?.fuel_type?.value) {
        const fuel = manualUpdateLRConsignment.fuel_type.value.toLowerCase();
        let autoMode = "";

        if (["diesel", "ev", "cng"].includes(fuel)) {
            autoMode = "Road";
        } else if (fuel === "rail") {
            autoMode = "Rail";
        } else if (fuel === "air") {
            autoMode = "Air";
        } else if (fuel === "sea") {
            autoMode = "Sea";
        }

        if (autoMode) {
            setManualUpdateLRConsignment(prev => ({
                ...prev,
                mode: { label: autoMode, value: autoMode }
            }));
            setModeDisabled(true);
        } else {
            setModeDisabled(false);
        }
    }
}, [manualUpdateLRConsignment?.fuel_type]);//comments


// useEffect(() => {
//     // if (!form2Details.delivered_date) return { minTime: null, maxTime: null };

//     const selectedDate = new Date(form2Details.delivered_date);
//     const today = new Date();
//     const yesterday = new Date();
//     yesterday.setDate(today.getDate() - 1);

//     const startOfDay = new Date(selectedDate).setHours(0, 0, 0, 0);
//     const endOfDay = new Date(selectedDate).setHours(23, 59, 59, 999);
//     const currentTime = new Date(); // Current date & time
//     const maxTimeToday = new Date(Math.min(currentTime.getTime() + 8 * 60 * 60 * 1000, endOfDay));


//     if (selectedDate.toDateString() === today.toDateString()) {
//         // If selected date is today
//         setMinTime1(new Date(startOfDay));
//         setMaxTime1(new Date(maxTimeToday)); // Max time is 8 hours ahead, but within today
//     } else if (selectedDate.toDateString() === yesterday.toDateString()) {
//         // If selected date is yesterday
//         setMinTime1(new Date(startOfDay));
//         setMaxTime1(new Date(endOfDay));
//     } else {
//         // If selected date is before yesterday
//         setMinTime1(new Date(currentTime));
//         setMaxTime1(new Date(endOfDay));
//     }

// },[form2Details.delivered_date]);
    // useEffect(() => {
    //     if (!form2Details.delivered_date) return;
    //     const selectedDate = new Date(form2Details.delivered_date);
    //     const today = new Date();
    //     const yesterday = new Date();
    //     yesterday.setDate(today.getDate() - 1);
    //     const startOfDay = new Date(selectedDate);
    //     startOfDay.setHours(0, 0, 0, 0);
    //     const endOfDay = new Date(selectedDate);
    //     endOfDay.setHours(23, 59, 59, 999);
    //     const currentTime = new Date();
    //     const future8Hours = new Date(currentTime.getTime() + 8 * 60 * 60 * 1000);
    //     if (selectedDate.toDateString() === today.toDateString()) {
    //         setMinTime1(startOfDay);
    //         setMaxTime1(future8Hours > endOfDay ? endOfDay : future8Hours);
    //     } else if (selectedDate.toDateString() === yesterday.toDateString()) {
    //         setMinTime1(startOfDay);
    //         setMaxTime1(endOfDay);
    //     } else {
    //         setMinTime1(startOfDay);
    //         setMaxTime1(endOfDay);
    //     }
    // }, [form2Details.delivered_date]);
      useEffect(() => {

    if (!form2Details.delivered_date) return;

    const selectedDate = new Date(form2Details.delivered_date);

    const startOfDay = new Date(selectedDate);
    startOfDay.setHours(0,0,0,0);

    const endOfDay = new Date(selectedDate);
    endOfDay.setHours(23,59,59,999);

    const now = new Date();
    const futureLimit = new Date(now.getTime() + 8 * 60 * 60 * 1000);

    const selectedStr = selectedDate.toDateString();
    const todayStr = now.toDateString();
    const futureStr = futureLimit.toDateString();

    if (selectedStr === todayStr) {

        // allow entire past of today
        setMinTime1(startOfDay);

        // limit future to +8 hours
        setMaxTime1(futureLimit > endOfDay ? endOfDay : futureLimit);

    } 
    else if (selectedStr === futureStr) {

        // tomorrow within 8hr window
        setMinTime1(startOfDay);
        setMaxTime1(futureLimit);

    } 
    else if (selectedDate > futureLimit) {

        // after 8hr window block
        setMinTime1(startOfDay);
        setMaxTime1(startOfDay);

    } 
    else {

        // past dates
        setMinTime1(startOfDay);
        setMaxTime1(endOfDay);

    }

}, [form2Details.delivered_date]);

       

       
    // var x = [         
    //     {
    //         headerName: "Check",
    //         field: "checkbox",
    //         hide: (tabName.value !== "inactive"),
    //         // colId: "_id",
    //         width: 40,
    //         pinned: 'left',
    //         filter: false, 
    //         resizable: true,
    //         checkboxSelection: true
    //     }       
    // ]

    const [pincodesList, setPincodesList] = useState([{ label: "", value: "" }]);
    const viewOptions = [
        { label: "Inbound", value: "inbound" },
        { label: "Outbound", value: "outbound" }
    ];
    var [tptNFuel, settptNFuel] = useState([]);

    var decodedRoleCase= decode(localStorageRole).toLowerCase()
    var warehouseDisableIcons = ((decodedRoleCase==="warehouse" || decodedRoleCase==="wh-inbound") && processFlowType==="inbound") || (decodedRoleCase==="user" || decodedRoleCase==="user-inbound" || decodedRoleCase==="user-outbound")
    var warehouseDisableIcons1 = (decodedRoleCase==="warehouse" || decodedRoleCase==="user") && (processFlowType==="inbound" || processFlowType ==="outbound") || (decodedRoleCase==="transporter")
    
    
    // Convert all elements to lowercase
    var locationNameConversion = getFormattedLocalStorageArray("location")
     
    var entityConversion = getFormattedLocalStorageArray("entity")
    
    var stateConversion =  getFormattedLocalStorageArray("state")

     
    var zoneConversion = getFormattedLocalStorageArray("zone")   


    


    useEffect(() => {
  // Helper function to load consignment data based on the tab name
  const loadConsignmentDataByTab = () => {
    if (tabName.value !== "inactive" && tabName.value !== "transporter") {
       
      loadConsignmentsData();
    
    } else if (tabName.value === "transporter" ) {
        if(selectedOption1==="invoice"){
            loadTptConsignmentsData({
                sdate: moment.parseZone(new Date(moment().subtract(1, "month"))).format("YYYY-MM-DD"),
                edate: moment.parseZone(new Date()).format("YYYY-MM-DD"),
                date_type: "Invoice", // Default date type
            });
        }
        
      setSearchType({ label: "Invoice No", value: "invoice_no" });
      setSelectedOption1("invoice");
    } else if (tabName.value === "inactive") {
       if(selectedOption1 ==="invoice"){
        loadNotTptConsignmentsData({
            sdate: moment.parseZone(new Date(moment().subtract(1, "month"))).format("YYYY-MM-DD"),
            edate: moment.parseZone(new Date()).format("YYYY-MM-DD"),
            date_type: "Invoice", // Default date type
          });
       }
      
      
      setSearchType({ label: "Invoice No", value: "invoice_no" });
      setSelectedOption1("invoice");
    }
  };
 
  
  localStorage.setItem("processFlowType", processFlowType);
  setCounterActive("Total")

  // Map pathnames to corresponding tab options
  const pathnameToTabNameMap = {
    "/consignments/inactive_inbound_consignments": tabOptions[0],
    "/consignments/inactive_outbound_consignments": tabOptions[0],
    "/consignments/inactive_consignments": tabOptions[0],
    "/consignments/active_inbound_consignments": tabOptions[1],
    "/consignments/active_outbound_consignments": tabOptions[1],
    "/consignments/active_consignments": tabOptions[1],
    "/consignments/delivered_inbound_consignments": tabOptions[2],
    "/consignments/delivered_outbound_consignments": tabOptions[2],
    "/consignments/delivered_consignments": tabOptions[2],
    "/consignments/all_inbound_consignments": tabOptions[3],
    "/consignments/all_outbound_consignments": tabOptions[3],
    "/consignments/all_consignments": tabOptions[3],
    "/consignments/cancelled_inbound_consignments": tabOptions[4],
    "/consignments/cancelled_outbound_consignments": tabOptions[4],
    "/consignments/cancelled_consignments": tabOptions[4],
    "/consignments/transporter_inbound_consignments": tabOptions[5],
    "/consignments/transporter_outbound_consignments": tabOptions[5],
    "/consignments/transporter_consignments": tabOptions[5],
  };

  const currentPathname = window.location.pathname;
  const mappedTab = pathnameToTabNameMap[currentPathname];

  if (mappedTab) {
    setSelectedOption("");
    resetFiltersGrid();
    // resetFilters1();
    setTabName(mappedTab); // Set the correct tab name
  } else {
    console.warn("No tab mapped for pathname:", currentPathname);
  }
  setLrNo("")
  setSearchInvoice("")
  // Only load the data after the tabName has been set or updated
  if (tabName.value) {
    
    loadConsignmentDataByTab();
  }
  if (!hasInitializedDefaultTab.current) {
    if (processFlowType === "inbound" && !["transporter", "admin"].includes(decodedRoleCase)) {
        setTabName({ label: "active", value: "active" });
        decodedRoleCase==="user" ? navigate("/consignments/active_inbound_consignments"): navigate("/consignments/active_consignments"); 
    } else if(decodedRoleCase==="transporter"){
        setTabName({ label: "transporter", value: "transporter" });
        navigate("/consignments/transporter_consignments")
      }else{
      setTabName({ label: "inactive", value: "inactive" });
      decodedRoleCase==="user" ? navigate("/consignments/inactive_outbound_consignments"): navigate("/consignments/inactive_consignments"); 

    }
    hasInitializedDefaultTab.current = true;
    return; // Avoid loading data prematurely
  }

}, [tabName.value, window.location.pathname, processFlowType, searchViewType, selectedOption1]);
 

// Runs only on component mount
    //   if ( tabName.value == "active" ) {
    //     setRowData(activeTrips.all);
    //     setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
    // } else if (tabName.value == "completed") {
    //     setRowData(completedTrips.all)
    //     setDateTypeList((prevList) => [
    //         ...prevList,
    //         { label: "Delivered", value: "Delivered" }
    //     ]);       
    //      }
    // else if (tabName.value == "all") {
    //     setRowData(allTrips.all);
    // } else if(tabName.value == "inactive"){    
    //     setRowData(inactiveTrips)
    //     // setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
    // }else if(tabName.value ==="transporter"){
    //     setRowData(transporterTrips1)
    //     // setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
    
    // }else{
    //     setRowData(closeTrips)
    //     setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
    // }
     
  
    // useEffect(()=>{
    //     if(tabName.value !=="inactive" && tabName.value!=="transporter"){
    //         loadConsignmentsData();
    //     }else{       
    //          loadTptConsignmentsData({
    //         sdate: moment.parseZone(new Date(moment().subtract(1, "month"))).format("YYYY-MM-DD"),
    //         edate: moment.parseZone(new Date()).format("YYYY-MM-DD"),
    //         date_type: "Invoice", // Default date type
    //       });
    //     }
    //        },[])
         
    
    var intransitColDefs =
            [
                {
                    headerName: "Vehicle No" ,
                    field: "truck_no",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "LR No" ,
                    field: "lr_no",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Invoice No" ,
                    field: "invoice_no",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },  
                // here
                {
                    headerName: "Status",
                    field: "status",
                    colId: "status",
                    valueFormatter: (params) => {
                        const consignmentStatus = params.data?.consignment_status;
                        const status = params.data?.status;
                
                        if (consignmentStatus) {
                            return consignmentStatus;
                        } else {
                            if (typeof status === "number") { // Correct check for numeric type
                                return statusMap[status] || "Not Available";
                            } else {
                                return status || "Not Available"; // Ensure fallback if status is undefined or null
                            }
                        }
                    },
                    filterParams: {
                        values: (params) => {
                            const uniqueValues = new Set();
                
                            try {
                                params.api.forEachNodeAfterFilter((node) => {
                                    if (node.data) {
                                        let status;
                                        if (typeof node.data.status === "number") { // Correct check for numeric type
                                            status = statusMap[node.data.status];
                                        } else {
                                            status = node.data.status;
                                        }
                
                                        const consignmentStatus = node.data.consignment_status;
                                        const statusText = consignmentStatus || status || "Not Available";
                                        uniqueValues.add(statusText);
                                    }
                                });
                
                                params.success(Array.from(uniqueValues));
                            } catch (error) {
                                console.error("Error in filterParams.values:", error);
                                params.success([]);
                            }
                        },
                        refreshValuesOnOpen: false,
                    },
                    filterValueGetter: (params) => {
                        const consignmentStatus = params.data?.consignment_status;
                        const status = params.data?.status;
                
                        if (consignmentStatus) {
                            return consignmentStatus;
                        } else {
                            if (typeof status === "number") { // Correct check for numeric type
                                return statusMap[status] || "Not Available";
                            } else {
                                return status || "Not Available";
                            }
                        }
                    },
                }
                ,                
                {
                    headerName: "Invoice Date",
                    field: "invoice_time",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    valueGetter: function (params) {
                        if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Dispatch Date" ,
                    field: "dispatch_date",
                    width: 150,
                    //filter: "agDateColumnFilter",
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,

                    valueGetter: function (params) {
                        const dispatchDate = params.data.dispatch_date;
                        if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                            // Call date formatting only when the dispatch date is valid
                            const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                            // Check if formattedDate is valid, otherwise return "NA"
                            return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                        } else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Customer Name",
                    field: "customer_name",
                    width: 180,
                    filter: "agSetColumnFilter",
                    cellRenderer: '',
                    resizable: true,
                    valueGetter: function (params) {
                        if (params.data.customer_name != "" && params.data.customer_name != "") {
                            return params.data.customer_name
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Entity" ,
                    field: "entity",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },               
                {
                    headerName: "Invoice Type" ,
                    field: "invoice_type",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Transporter",
                    field: "transporter_name",
                    width: 180,
                    filter: "agSetColumnFilter",
                    cellRenderer: '',
                    resizable: true,
                    valueGetter: function (params) {
                        if (params.data.truck_no != "" && params.data.truck_no != undefined) {
                            if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                                return capitalizeWords(params.data.transporter_name)
                            }
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Source City" ,
                    field: "consigner_city",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },  
                {
                    headerName: "Source Pincode" ,
                    field: "consigner_pincode",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Source Zone" ,
                    field: "consigner_zone",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Destination City" ,
                    field: "consignee_city",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Destination Pincode" ,
                    field: "consignee_pincode",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Destination State" ,
                    field: "consignee_state",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Total Weight" ,
                    field: "total_weight",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header',
                    valueFormatter: (params) => {
                        // Ensure the value is a valid number
                        const value = parseFloat(params.value);
                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                    }
                },
                {
                    headerName: "Total CBM" ,
                    field: "total_cbm",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header',
                    valueFormatter: (params) => {
                        // Ensure the value is a valid number
                        const value = parseFloat(params.value);
                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                    }
                },
                {
                    headerName: "Transporter Category" ,
                    field: "tpt_category",
                    width: 190,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Vehicle Type" ,
                    field: "vehicle_type",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Truck Seal No" ,
                    hide: (tabName.value === "inactive"),
                    field: "truck_seal_no",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "ODA",
                    field: "oda",
                    width: 150,
                    cellRenderer: '',
                    headerClass: 'bold-header',
                    resizable: true,
                },
            // till here 
                {
                    headerName: "POD Status" ,
                    field: "pod_status",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                }, 
                {
                    headerName: "TAT" ,
                    field: "transit_time",
                    hide: (tabName.value === "inactive"),
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            }, 
                {
                    headerName: "Expected ETA" , // estimated delivery data
                    field: "expected_trip_end",
                    width: 150,
                    //filter: "agDateColumnFilter",
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    hide: (tabName.value === "inactive"),
                    valueGetter: function (params) {
                        const expectedEta = params.data.expected_trip_end;
                        const tripEndMaster = params.data.expected_trip_end_master;
                
                        if (expectedEta && expectedEta.trim() !== '') {
                            return getHyphenDDMMMYYYYHHMM(expectedEta);
                        } else if (tripEndMaster && tripEndMaster.trim() !== '') {
                            return getHyphenDDMMMYYYYHHMM(tripEndMaster);
                        } else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                
                },
                {
                    headerName: "Revised Estimated Delivery Date",
                    // field: "modified_date",
                    field: "revised_trip_end",
                    width: 240,
                    hide: (tabName.value === "inactive"),
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    valueGetter: function (params) {
                        if (params.data.revised_trip_end != '' && params.data.revised_trip_end != undefined && params.data.revised_trip_end !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Actual Delivery Date",
                    field: "delivery_datetime",
                    width: 180,
                    hide: (tabName.value === "inactive"),
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,
                    valueGetter: function (params) {
                        if (params.data.delivery_datetime != '' && params.data.delivery_datetime != undefined && params.data.delivery_datetime !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Performance" ,
                    field: "delivery_performance",
                    width: 180,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Delay Days",
                    field: "transit_delay_days",
                    width: 180,
                    hide: (tabName.value !== 'completed' && tabName.value !== "all"),
                    resizable: true,
                    headerClass: 'bold-header',
                    valueFormatter: (params) => {
                        const day = params.value;
                        if (day !== undefined && day !== null) {
                            // Convert hours to days and round to the nearest whole number
                            const days = day;  // Round to nearest whole number
                            return `${days}`;
                        }
                        return ''; // Return empty if no value
                    }
                },
                // {
                //     headerName: "Delay Days Bucket" ,
                //     field: "delay_days_bucket",
                //     width: 180,
                //     hide: (tabName.value !== 'completed' && tabName.value !== "all"),
                //     cellRenderer: '', resizable: true,
                //     headerClass: 'bold-header'
                // },

                // add below 
                {
                    headerName: "Reason For Delay" ,
                    field: "reason_for_delay",
                    width: 180,
                    hide: (tabName.value !== 'completed' && tabName.value !== "all"),
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                // from here
                {
                    headerName: "E-Way Bill No" ,
                    field: "eway_bill_no",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                }, 
                {
                    headerName: "Mode" ,
                    field: "shipment_mode",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },   
                {
                    headerName: "Fuel Type" ,
                    field: "fuel_type",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                {
                    headerName: "Disabled Time",
                    field: "cancelled_time",
                    hide: (tabName.value === "inactive" && tabName.value === "inactive"),
                    width: 180,
                    //filter: "agDateColumnFilter",
                    cellRenderer: '', resizable: true,
                    comparator: dateComparator,

                    valueGetter: function (params) {
                        if (params.data.cancelled_time != '' && params.data.cancelled_time != undefined && params.data.cancelled_time !== ' ') {
                            return getHyphenDDMMMYYYYHHMM(params.data.cancelled_time);
                        }
                        else {
                            return "NA";
                        }
                    },
                    headerClass: 'bold-header'
                    // hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyPRT, // this logic was imported from msil so for hero we are commenting this as of 27-07-2022
                },
                {
                    headerName: "No Of Boxes" ,
                    field: "no_of_boxes",
                    width: 150,
                    cellRenderer: '', resizable: true,
                    headerClass: 'bold-header'
                },
                
    ];
var inactiveDefs=[]
var transporterDefs=[]
var activeDefs=[]
var allCodefs=[]
var deliveredDefs=[]
useEffect(()=>{
   var inactivedefs1= [

        
        // {
        //     headerName: "Tracking Mode" ,
        //     field: "tracking_type",
        //     colId: "tracking_type",
        //     // hide: (tabName.value === "inactive"),
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        // {
        //     headerName: "Update Tracking Status",
        //     field: "update_tracking_status",
        //     width: 190,
        //     pinned: "left",
        //     // hide: (tabName.value !== 'active'),
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 if(param.data.manual_tracking === 1 || param.data.status === 1 || param.data.status === 2){                                
        //                     return {
        //                         component: UpdatePTLConsignments,
        //                         params: {
        //                             onClickActive: updateDeliveredDate
        //                         }
        //                     }
        //                 } else {
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },        
        // {
        //     headerName: "Update LR",
        //     field: "update",
        //     width: 100,
        //     pinned: "left",
        //     // hide: tabName.value !== 'inactive',
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: UpdatePTLConsignments,
        //                     params: {
        //                         onClickActive: onClickActive
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },
       
        
        // {
        //     headerName: "LR No" ,
        //     field: "lr_no",
        //     hide: (tabName.value === "inactive"),
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Invoice No" ,
            colId: "invoice_no",
            field: "invoice_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },  
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },       
        // {
        //     headerName: "Vehicle No" ,
        //     field: "truck_no",
        //     // hide: (tabName.value === "inactive"),
        //     colId: "truck_no",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: function(params){
                if(params.data.tpt_assigned ===0){
                    return "Pending Transporter"
                }
            }
        },
        {
            headerName: "Creation Time",
            field: "invoice_upload_time",
            colId: "invoice_upload_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_upload_time != '' && params.data.invoice_upload_time != undefined && params.data.invoice_upload_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_upload_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name != "" && params.data.consigner_name != "") {
                    return params.data.consigner_name
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            }
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_city !=="" && params.data.consignee_city !==" " && params.data.consignee_city !==undefined){
                    return capitalizeWords(params.data.consignee_city)
                }else{
                    return ""
                }
            }
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
          
        },
        {
            headerName: "Total CBM",
            field: "total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Entity",
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                try {
                 
                    const entity = params.data.truck_seal_entity;
                    if (entity) {
                        return capitalizeWords(entity); // Capitalize words only if a valid value is present
                    }
                    return '';   
                } catch (error) {
                    
                } // Return an empty string for invalid or missing values
            },
            headerClass: 'bold-header',
        },
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.invoice_type !=="" && params.data.invoice_type !==" " && params.data.invoice_type !== undefined){
                    return capitalizeWords(params.data.invoice_type)
                }else{
                    return "";
                }
            }
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consigner_city !=="" && params.data.consigner_city !==" " && params.data.consigner_city !== undefined){
                    return capitalizeWords(params.data.consigner_city)
                }else{
                    return "";
                }
            }
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consigner_zone !=="" && params.data.consigner_zone !==" " && params.data.consigner_zone !== undefined){
                    return capitalizeWords(params.data.consigner_zone)
                }else{
                    return "";
                }
            }
        },
       
       
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_state !=="" && params.data.consignee_state !==" " && params.data.consignee_state !== undefined){
                    return capitalizeWords(params.data.consignee_state)
                }else{
                    return "";
                }
            }
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_zone !=="" && params.data.consignee_zone !==" " && params.data.consignee_zone !== undefined){
                    return capitalizeWords(params.data.consignee_zone)
                }else{
                    return "";
                }
            }
            
            // Use valueGetter to dynamically return the correct field based on tracking type
            // valueGetter: (params) => {
            //     if (params.data.tracking_type === "FTL") {
            //         return params.data.consignee_zone; // If tracking is FTL, use consignee_zone
            //     } else if (params.data.tracking_type === "PTL") {
            //         return params.data.zone; // If tracking is PTL, use zone
            //     }
            //     return null; // Return null or empty if neither condition is met
            // }
        },
        {
            headerName: "Customer Mobile Number",
            field: "cus_mobile_no",
            width: 220,
            filter: "agSetColumnFilter",
            resizable: true,
            editable: false,
            headerClass: "bold-header",
            valueSetter: (params) => {
                const value = params.newValue;

                if (/^\d*$/.test(value)) {
                    params.data.cus_mobile_no = value;
                    return true;
                } else {
                    return false;
                }
            },
        },

        // {
        //     headerName: "Status",
        //     field: "status",
        //     colId: "status",
        //     valueFormatter: (params) => {
        //         const statusMap = {
        //             0:"Invoiced",
        //             1: "At Source",
        //             2: "In Transit",
        //             3: "Near Destination",
        //             4: "Delivered",
        //             5: "Left Dealer",
        //             6: "Force Closure",
        //             7: "Provision",
        //             8: "Trip Completed",
        //         };
        
        //         const consignmentStatus = params.data?.consignment_status;
        //         const status = params.data?.status;
        
        //         if (consignmentStatus) {
        //             return consignmentStatus;
        //         }
        //         return statusMap[status] || "Invoiced";
        //     },
        //     filterParams: {
        //         values: (params) => {
        //             // Initialize a Set for unique values
        //             const uniqueValues = new Set();
        
        //             try {
        //                 // Collect unique status values from the filtered rows
        //                 params.api.forEachNodeAfterFilter((node) => {
        //                     if (node.data) {
        //                         const statusMap = {
        //                             0:"Invoiced",
        //                             1: "At Source",
        //                             2: "In Transit",
        //                             3: "Near Destination",
        //                             4: "Delivered",
        //                             5: "Left Dealer",
        //                             6: "Force Closure",
        //                             7: "Provision",
        //                             8: "Trip Completed",
        //                         };
        
        //                         const consignmentStatus = node.data.consignment_status;
        //                         const statusText = consignmentStatus || statusMap[node.data.status] || "Not Available";
        //                         uniqueValues.add(statusText);
        //                     }
        //                 });
        
        //                 // Pass the unique values to the filter dropdown
        //                 params.success(Array.from(uniqueValues));
        //             } catch (error) {
        //                 console.error("Error in filterParams.values:", error);
        //                 // Pass an empty array if there's an error
        //                 params.success([]);
        //             }
        //         },
        //         refreshValuesOnOpen: true,
        //     },
        //     filterValueGetter: (params) => {
        //         const statusMap = {
        //             0:"Invoiced",
        //             1: "At Source",
        //             2: "In Transit",
        //             3: "Near Destination",
        //             4: "Delivered",
        //             5: "Left Dealer",
        //             6: "Force Closure",
        //             7: "Provision",
        //             8: "Trip Completed",
        //         };
        
        //         const consignmentStatus = params.data?.consignment_status;
        //         const status = params.data?.status;
        
        //         if (consignmentStatus) {
        //             return consignmentStatus;
        //         }
        //         return statusMap[status] || "Invoiced";
        //     },
        // },  
      
        // {
        //     headerName: "Assign Transporter",
        //     field: "assign_transporter",
        //     colId: "assign_transporter",
           
        // },  

       
              
                      
        
        // {
        //     headerName: "Transporter",
        //     field: "transporter_name",
        //     colId: "transporter_name",
        //     width: 180,
        //     filter: "agSetColumnFilter",
        //     cellRenderer: '',
        //     resizable: true,
        //     valueGetter: function (params) {
        //         if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    
        //             return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },
       
        
        // {
        //     headerName: "Transporter Category" ,
        //     field: "tpt_category",
        //     colId: "tpt_category",
        //     width: 190,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        // {
        //     headerName: "Vehicle Type" ,
        //     field: "truck_type",
        //     colId: "truck_type",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        // {
        //     headerName: "ODA",
        //     field: "origin_destination_area",
        //     colId: "origin_destination_area",
        //     width: 150,
        //     cellRenderer: '',
        //     headerClass: 'bold-header',
        //     resizable: true,
        // }, 

        // {
        //     headerName: "E-Way Bill No" ,
        //     field: "eway_bill_no",               
        //     colId: "eway_bill_no",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // }, 
        // {
        //     headerName: "Mode" ,
        //     field: "shipment_mode",
        //     colId: "shipment_mode",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },  
        // {
        //     headerName: "Fuel Type" ,
        //     field: "fuel_type",
        //     colId: "fuel_type",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },

        // {
        //     headerName: "No Of Boxes" ,
        //     field: "no_of_boxes",
        //     colId: "no_of_boxes",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // }
    ]
    var transporterDefs1 = [
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Update Tracking Status",
        //     field: "update_tracking_status",
        //     width: 190,
        //     pinned: "left",
        //     // hide: (tabName.value !== 'active'),
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 if(param.data.manual_tracking === 1 || param.data.status === 1 || param.data.status === 2){                                
        //                     return {
        //                         component: UpdatePTLConsignments,
        //                         params: {
        //                             onClickActive: updateDeliveredDate
        //                         }
        //                     }
        //                 } else {
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },        
        // {
        //     headerName: "Update LR",
        //     field: "update",
        //     width: 100,
        //     pinned: "left",
        //     // hide: tabName.value !== 'inactive',
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: UpdatePTLConsignments,
        //                     params: {
        //                         onClickActive: onClickActive
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },
     
        // {
        //     headerName: "LR No" ,
        //     field: "lr_no",
        //     hide: (tabName.value === "inactive"),
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Invoice No" ,
            colId: "invoice_no",
            field: "invoice_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },         
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: function(params){
                if(params.data.tpt_assigned ===1){
                    return "Pending LR Details"
                }
            }
        },
        {
            headerName: "Creation Time",
            field: "tpt_assigned_at",
            colId: "tpt_assigned_at",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tpt_assigned_at != '' && params.data.tpt_assigned_at != undefined && params.data.tpt_assigned_at !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.tpt_assigned_at);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name != "" && params.data.consigner_name != undefined) {
                    return (params.data.consigner_name ? capitalizeWords(params.data.consigner_name):"")
                }
            },
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            }
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
          
        },
        {
            headerName: "Entity",
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                try {
                 
                    const entity = params.data.truck_seal_entity;
                    if (entity) {
                        return capitalizeWords(entity); // Capitalize words only if a valid value is present
                    }
                    return '';   
                } catch (error) {
                    
                } // Return an empty string for invalid or missing values
            },
            headerClass: 'bold-header',
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.invoice_type != "" && params.data.invoice_type != undefined) {
                    return (params.data.invoice_type ? capitalizeWords(params.data.invoice_type):"")
                }
            },
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                }
            },
        },
      
       
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if(params.data.consignee_zone !=="" && params.data.consignee_zone !==" " && params.data.consignee_zone !== undefined){
                    return capitalizeWords(params.data.consignee_zone)
                }else{
                    return "";
                }
            }
            
            // Use valueGetter to dynamically return the correct field based on tracking type
            // valueGetter: (params) => {
            //     if (params.data.tracking_type === "FTL") {
            //         return params.data.consignee_zone; // If tracking is FTL, use consignee_zone
            //     } else if (params.data.tracking_type === "PTL") {
            //         return params.data.zone; // If tracking is PTL, use zone
            //     }
            //     return null; // Return null or empty if neither condition is met
            // }
        },
        {
            headerName: "Customer Mobile Number",
            field: "cus_mobile_no",
            width: 220,
            filter: "agSetColumnFilter",
            resizable: true,
            editable: false,
            headerClass: "bold-header",
            valueSetter: (params) => {
                const value = params.newValue;

                if (/^\d*$/.test(value)) {
                    params.data.cus_mobile_no = value;
                    return true;
                } else {
                    return false;
                }
            },
        },
       
       
    ]
    const extraActiveUpdateCol=[
        {
            headerName: "",
            field: "update",
            colId: "update",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        // if(tabName.value === "active"){
                            let enableUpdateDetailIcon = (decodedRoleCase==="transporter" && param.data.tracking_type==="PTL") || decodedRoleCase==="user";
                            

                            return {
                                component: UpdateConsignments,
                                params: {
                                    onClickActive: onClickActive,
                                    iconType: "edit",
                                    tooltip: "Update Trip Details",
                                    disabled:enableUpdateDetailIcon
                                }
                            // };                           
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },
    ]
    const extraActiveCancelCol=[  
    //     {
    //     headerName: "",
    //     field: "cancel_order",
    //     colId: "cancel_order",
    //     width: 50,
    //     pinned: "left",
    //     filter:false,
    //     cellRendererSelector: function (param) {
    //         try {
    //             const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
    //             const hasLrNo = param.data.hasOwnProperty("lr_no");
    //             var disableIcon=decodedRoleCase==="user";
    //             const isConditionMet = (hasConsignmentStatus || hasLrNo) && 
    //                                    (param.data.consignment_status === "In Transit" || 
    //                                     param.data.consignment_status === "Dispatched from Source" || 
    //                                     param.data.consignment_status === "Invalid docket" ||
    //                                     param.data.consignment_status === "Booked");
    //             if (isConditionMet) {
    //                 return {
    //                     component: CancelCourierConsignments,
    //                     params: {
    //                         onClickActive: onClickCancelActiveCourierConsignemnts,
    //                         disabled: false || disableIcon,
    //                         tracking_type: "PTL1"
    //                     }
    //                 };
    //             } else {
    //                 return {
    //                     component: CancelCourierConsignments,
    //                     params: {
    //                         onClickActive: onShowForceCloseModal,
    //                         tracking_type: "FTL",
    //                         disabled: disableIcon,
    //                     }
    //                 };
    //             }
    
    //         } catch (err) {
    //             console.log(err);
    //         }
    //     },
    //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
    //     headerClass: 'bold-header'
    // }
        {
            headerName: "",
            field: "cancel_order",
            colId: "cancel_order",
            width: 50,
            pinned: "left",
            filter: false,
            cellRendererSelector: function (param) {
                try {
                    const data = param.data || {};
                    const hasShipment = !!data.shipment_id;
                    const createdTime = data.created_at ? new Date(data.created_at) : null;
                    const diffMins = createdTime ? (new Date() - createdTime) / 60000 : 9999;
                    const userRole = (decodedRoleCase || "").toLowerCase();
                    const disableIcon = userRole === "user";

                    // Determine tracking type dynamically (fallback: FTL)
                    const tracking_type = data.tracking_type
                        ? data.tracking_type.toUpperCase()
                        : "FTL";

                    // 15 min restriction
                    const showButton =
                        userRole === "admin" ||
                        (["transporter", "warehouse"].includes(userRole) &&
                            hasShipment &&
                            diffMins <= 15);

                    if (!showButton) return null;

                    // Render cancel icon button
                    return {
                        component: CancelCourierConsignments,
                        params: {
                            onClickActive: onShowForceCloseModal, // handler
                            tracking_type, // "FTL" or "PTL"
                            disabled: disableIcon,
                        },
                    };
                } catch (err) {
                    console.error("Active Tab cancel_order error:", err);
                    return null;
                }
            },
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
            },
            headerClass: "bold-header",
        }


]

    const extraNotUserActiveCol=[
        {
            headerName: "",
            field: "show_stoppages",
            colId: "show_stoppages",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowstoppagesIcon,
                            params: {
                                onShowStoppagesData: onShowStoppagesData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "update_tracking_status",
            colId: "update_tracking_status",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                        let enableUpdateDetailIcon = param.data.status===0;

                        if (hasConsignmentStatus) {                            
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: enableUpdateDetailIcon // Disable the icon
                                }
                            };
                        }
                        // if (hasConsignmentStatus && param.data.manual_tracking === 0) {                            
                        //     return {
                        //         component: UpdatePTLConsignments,
                        //         params: {
                        //             onClickActive: updateDeliveredDate,
                        //             iconType: "tracking",
                        //             disabled: true // Disable the icon
                        //         }
                        //     };
                        // }
                        
                        else if (!hasConsignmentStatus && ( [1, 2, 3, 4, 10].includes(param.data.status))) {
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: enableUpdateDetailIcon 
                                }
                            };
                        } else{
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: enableUpdateDetailIcon
                                }
                            };
                        }  
                        // return{
                        //     component: UpdatePTLConsignments,
                        //     params: {
                        //         onClickActive: updateDeliveredDate,
                        //         iconType: "tracking",
                        //         disabled: true 
                        //     }
                        // }                     
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },        
        {
            headerName: "",
            field: "upload_document",
            colId: "upload_document",
            width: 60,
            filter: false,
            pinned:"left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                // const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                let isDisabledUploadDoc =( [5, 6, 8, 11].includes(param.data.status) || ["Delivered", "Cancelled", "Undelivered"].includes(param.data.consignment_status))
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus && isDisabledUploadDoc) {
                        onShowUploadDoc(param); 
                    // }
                    //  else {
                    //     if(isDisabledUploadDoc)
                    //         onClickUploadPOD(param)
                    // }
                };
                
                return (
                       <div 
                           title="Upload Document"
                           style={{ display: 'inline-block' }}
                       >
                           <button 
                               onClick={handleClick} 
                               style={{ 
                                   border: "none",
                                   backgroundColor: "transparent",
                                   pointerEvents: isDisabledUploadDoc ? "none" : "auto", 
                                   opacity: isDisabledUploadDoc ? 0.5 : 1,
                               }}
                               disabled={isDisabledUploadDoc}
                           >
                               <i 
                                   className="icofont icofont-upload-alt f17" 
                                   style={{ fontSize: "12px", color: isDisabledUploadDoc ? "grey" : "#3a3fa6" }}
                               ></i>
                           </button>
                       </div>
                   
                );
            },
        },
    ]
const extraActiveCheckCol=[
    {
        headerName: "Check",
        field: "checkbox",
        // hide: (tabName.value !== "inactive"),
        colId: "checkbox",
        width: 40,
        pinned: 'left',
        // filter: false, 
        resizable: true,
          // suppressExcelExport: true,
        checkboxSelection: params => params.data.status !== 0,
       //  checkboxSelection: true,
        headerCheckboxSelection: true
    },
]
const extraNotUserAllCol=[
    {
        headerName: "",
        field: "show_stoppages",
        colId: "show_stoppages",
        width: 50,
        pinned: "left",
        filter:false,
        // hide: tabName.value === "inactive",
        cellRendererSelector: function (param) {
            try {
                if (param.data._id != null && param.data._id != undefined) {
                    return {
                        component: onShowstoppagesIcon,
                        params: {
                            onShowStoppagesData: onShowStoppagesData,
                            
                        }
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
        cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    },

    {
        headerName: "",
        field: "update_tracking_status",
        colId: "update_tracking_status",
        width: 50,
        pinned: "left",
        filter:false,
        cellRendererSelector: function (param) {
            try {
                if (param.data._id != null && param.data._id != undefined) {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    var disableIcon=  param.data.status === 0
                    
    
                    if (hasConsignmentStatus && param.data.consignment_status !=="Delivered") {                            
                        return {
                            component: UpdatePTLConsignments,
                            params: {
                                onClickActive: updateDeliveredDate,
                                iconType: "tracking",
                                disabled: false || disableIcon// Disable the icon
                            }
                        };
                    }
                    if (hasConsignmentStatus && (param.data.consignment_status === "Delivered")) {                            
                        return {
                            component: UpdatePTLConsignments,
                            params: {
                                onClickActive: updateDeliveredDate,
                                iconType: "tracking",
                                disabled: true 
                            }
                        };
                    }
                    
                    if (!hasConsignmentStatus && ( [1, 2, 3, 4, 10].includes(param.data.status))) {
                        return {
                            component: UpdatePTLConsignments,
                            params: {
                                onClickActive: updateDeliveredDate,
                                iconType: "tracking",
                                disabled: false || disableIcon
                            }
                        };
                    } 
                    if (!hasConsignmentStatus && ( [0, 5, 6, 8, 11].includes(param.data.status))) {
                        return {
                            component: UpdatePTLConsignments,
                            params: {
                                onClickActive: updateDeliveredDate,
                                iconType: "tracking",
                                disabled: true 
                            }
                        };
                    }                        
                }
            } catch (err) {
                console.log(err);
            }
        },
        cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        headerClass: 'bold-header'
    }, 
    {
        headerName: "",
        field: "upload_document",
        colId: "upload_document",
        width: 60,
        filter: false,
        pinned:"left",
        headerClass: 'bold-header',
        cellRenderer: (param) => {
            // const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
            let isDisabledUploadDoc = ([5, 6, 8, 11].includes(param.data.status) || ["Delivered","Cancelled","Undelivered"].includes(param.data.status))
            const handleClick = (e) => {
                e.stopPropagation();
                // if (!hasConsignmentStatus && isDisabledUploadDoc) {
                    onShowUploadDoc(param); 
                // }
                //  else {
                //     if(isDisabledUploadDoc)
                //         onClickUploadPOD(param)
                // }
            };
            
            return (
                <button 
                    onClick={handleClick} 
                    // title={hasConsignmentStatus ? "Upload Document (Disabled)" : "Upload Document"}
                    title="Upload Document"
                    style={{ 
                        border:"none",
                        backgroundColor:"transparent",
                        pointerEvents: isDisabledUploadDoc ? "none" : "auto", 
                        opacity: isDisabledUploadDoc ? 0.5 : 1, 
                        // cursor: (hasConsignmentStatus && param.data.consignment_status === "Delivered") || (!hasConsignmentStatus && (param.data.status === 4 || param.data.status === 6)) ? "not-allowed" : "pointer" ,
                        // cursor: "pointer" 
                    }}
                    disabled={isDisabledUploadDoc}
                >
                    <i className="icofont icofont-upload-alt f17" style={{ fontSize:"12px",color: isDisabledUploadDoc? "grey":"#3a3fa6" }}></i>
                </button>
            );
        },
    },
]
const extraNotUserAllPodCol =[
    {
        headerName: "",
        field: "upload_pod",
        colId: "upload_pod",
        width: 60,
        filter: false,
        pinned: "left",
        headerClass: 'bold-header',
        cellRendererSelector: function (param) {
            try {
                const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                const isDisable = (hasConsignmentStatus  && (["Dispatched from Source","Cancelled","Arrived At Destination","In Transit","Out For Delivery","Undelivered","Booked"].includes(param.data.consignment_status) || param.data.is_submitted_pod ===1 ))
                const isDisable1 = (!hasConsignmentStatus &&  ( [0, 1, 2, 3, 4,6, 8, 10, 11].includes(param.data.status) ||  param.data.is_submitted_pod ===1)) || decodedRoleCase==="user"
                if (hasConsignmentStatus) {                         
                    return {
                        component: uploadPOD,
                        params: {
                            onClickUploadPOD: onClickUploadPOD,
                            isSubmittedPOD: param.data.is_submitted_pod,
                            disabled: isDisable
                        }
                    }
                }
                
                if (!hasConsignmentStatus) {
                    return {
                        component: uploadPOD,
                        params: {
                            onClickUploadPOD: onClickUploadPOD,
                            isSubmittedPOD: param.data.is_submitted_pod,
                            disabled: isDisable1

                        }
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
    },
]
const extraNotUserDelCol=[
    {
        headerName: "",
        field: "show_stoppages",
        colId: "show_stoppages",
        width: 50,
        pinned: "left",
        filter:false,
        // hide: tabName.value === "inactive",
        cellRendererSelector: function (param) {
            try {
                if (param.data._id != null && param.data._id != undefined) {
                    return {
                        component: onShowstoppagesIcon,
                        params: {
                            onShowStoppagesData: onShowStoppagesData,
                            
                        }
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
        cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    },
    {
        headerName: "",
        field: "upload_pod",
        colId: "upload_pod",
        width: 60,
        filter: false,
        pinned: "left",
        headerClass: 'bold-header',
        cellRendererSelector: function (param) {
            try {
                const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                if (hasConsignmentStatus) {                         
                    return {
                        component: uploadPOD,
                        params: {
                            onClickUploadPOD: onClickUploadPOD,
                            isSubmittedPOD: param.data.is_submitted_pod,
                            // manualTracking: param.data.manual_tracking
                        }
                    }
                }
                
                if (!hasConsignmentStatus) {
                    return {
                        component: uploadPOD,
                        params: {
                            // onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status),
                            // hasUpload: 1
                            onClickUploadPOD: onClickUploadPOD,
                            isSubmittedPOD: param.data.is_submitted_pod,

                        }
                    }
                }
            } catch (err) {
                console.log(err);
            }
        },
    },
]

    var activeDefs1 = [
       
         {
             headerName: "",
             field: "map",
             colId: "map",
             width: 50,
             pinned: "left",
             filter:false,
             cellRendererSelector: function (param) {
                 try {
                     let manual_tracking= param.data.manual_tracking;
                     
                     const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                     const isDisabled = hasConsignmentStatus && 
                                        (param.data.consignment_status === "In Transit" || 
                                         param.data.consignment_status === "Dispatched from Source" || 
                                         param.data.consignment_status === "Out For Delivery" ||
                                         param.data.consignment_status === "Invalid docket");
 
                     if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                         return {
                             component: ViewMap,
                             params: {
                                 onClickShowRoute: onClickShowRoute,
                                 disabled: isDisabled // Set the disabled state based on the consignment status
                             }
                         };
                     }
                     if(hasConsignmentStatus){
                         return {
                             component: CourierActions,
                             params: {
                                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                             }
                         }
                     }
                     if(!hasConsignmentStatus && (manual_tracking ===1)){
                         
                         return {
                             component: CourierActions,
                             params: {
                                 onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                             }
                         }
                     }
 
         
                   
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         }, 
         {
             headerName: "",
             field: "identity",
             colId: "identity",
             width: 50,
             pinned: "left",
             filter:false,
             // hide : (tabName.value == "inactive"),
             cellRendererSelector: function (param) {
                 try {
                     const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
             
                     // if ((hasConsignmentStatus) 
                     //     // && 
                     //     // (param.data.consignment_status === "In Transit" || param.data.consignment_status === "Dispatched from Source")
                     
                     // ) {                            
                     //     return {
                     //         component: CourierActions,
                     //         params: {
                     //             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                     //         }
                     //     }
                     // }
                     if (!hasConsignmentStatus) {
                         return {
                             component: ShipmentLegs,
                             params: {
                                 onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                             }
                         }
                     }else{
                         return {
                             component: CourierShipmentLegs,
                             params: {
                                 onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         // {
         //     headerName: "",
         //     field: "Group",
         //     colId: "Group",
         //     width: 50,
         //     pinned: "left",
         //     // hide: tabName.value === "inactive",
         //     cellRendererSelector: function (param) {
         //         try {
         //             if (param.data._id != null && param.data._id != undefined) {
         //                 return {
         //                     component: GroupIconRenderer,
         //                     params: {
         //                         onShowTransitData: onShowTransitData,
         //                         onShowNoGPSData: onShowNoGPSData,
         //                         onShowStoppagesData: onShowStoppagesData,
         //                         onShowUploadDoc: onShowUploadDoc,
         //                         onShowDocs: onShowDocs,
         //                     }
         //                 }
         //             }
         //         } catch (err) {
         //             //console.log(err);
         //         }
         //     },
         //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         // },
         {
             headerName: "",
             field: "show_transitdelay",
             colId: "show_transitdelay",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowTransitDelayIcon,
                             params: {
                                 onShowTransitData: onShowTransitData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         {
             headerName: "",
             field: "show_tracking",
             colId: "show_tracking",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowNoTrackingIcon,
                             params: {
                                 onShowNoGPSData: onShowNoGPSData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         ...extraNotUserActiveCol,
         {
             headerName: "",
             field: "view_document",
             colId: "view_document",
             width: 60,
             filter: false,
             pinned: "left",
             headerClass: 'bold-header',
             // hide: tabName.value !== 'active',
             cellRenderer: (param) => {
                 const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                 const handleClick = (e) => {
                     e.stopPropagation();
                     // if (!hasConsignmentStatus) {
                     //     onShowDocs(param);  
                     // }
                     onShowDocs(param);  
                 };        
                 return (
                     <button 
                         onClick={handleClick} 
                         title="View Document"
                         // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                         style={{ 
                             border:"none",
                             backgroundColor:"transparent",
                             fontSize:"12px",
                             // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                             // opacity: hasConsignmentStatus ? 0.5 : 1, 
                             // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                             cursor: "pointer" 
                         }}
                         disabled={!enableViewIcon}
                     >
                         <i className="fa fa-eye f17"></i> 
                     </button>
                 );
             },
         },              
       
        //  {
        //      headerName: "",
        //      field: "sendemail",
        //      colId: "sendemail",
        //      width: 50,
        //      filter:false,
        //      // hide: (tabName.value !== 'active'),
        //      cellRenderer:SendEmail,
        //      filter: false,
        //      pinned: "left",
        //      cellRendererSelector: function (param) {
        //          try {
        //              if (param.data._id != null && param.data._id != undefined) {
        //                  // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
        //                      return {
        //                          component: SendEmail,
        //                          params: {
        //                              onClickEmail: onClickEmail
        //                          }
        //                      }
        //                  // }
        //                  // else{
        //                  // }
                        
        //              }
        //          } catch (err) {
        //              console.log(err);
        //          }
        //      },
        //      headerClass: 'bold-header'
        //  },
 // actionables above
         {
             headerName: "Tracking Mode" ,
             field: "tracking_type",
             colId: "tracking_type",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "SIM Consent Status" ,
             field: "sim_consent_status",
             colId: "sim_consent_status",
             hide: (decode(localStorageRole)==="transporter"),
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter:(params)=>{
                 if(params.data.tracking_type ==="PTL"){
                    return ""
                }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                    return "Consent Approved"
                }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                    return "Consent Pending"
                }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
                return ""
                }
            }
         },
         {
             headerName: "LR No" ,
             field: "lr_no",
             colId: "lr_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Invoice No",
             field: "invoice_list",
             colId: "invoice_no",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
         }
         
         ,         
         {
             headerName: "Vehicle No" ,
             field: "truck_no",
             colId: "truck_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        
         
         {
             headerName: "Status",
             field: "status",
             colId: "status",
             valueGetter: (params) => {
               
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
         
                 // Use consignmentStatus if available, otherwise map status number to text
                 return consignmentStatus || statusMap[status] || status || "Not Available";
             },
         
             // filterParams: {
             //     values: (params) => {
             //         const uniqueValues = new Set();
             //         const statusMap = {
             //             0: "Invoiced",
             //             1: "At Source",
             //             2: "In Transit",
             //             3: "Near Destination",
             //             4: "Delivered",
             //             5: "Left Dealer",
             //             6: "Force Closure",
             //             7: "Provision",
             //             8: "Trip Completed",
             //         };
         
             //         try {
             //             // Get current filter model and any previously selected filter values
             //             const currentFilterModel = params.api.getFilterModel();
             //             const selectedFilterValues = currentFilterModel?.status?.values || [];
         
             //             // Loop through all the nodes (visible after applying any filters)
             //             params.api.forEachNodeAfterFilter((node) => {
             //                 if (node.data) {
             //                     let status;
             //                     if (typeof node.data.status === "number") {
             //                         status = statusMap[node.data.status];
             //                     } else {
             //                         status = node.data.status;
             //                     }
         
             //                     const consignmentStatus = node.data.consignment_status;
             //                     const statusText = consignmentStatus || status || "Not Available";
         
             //                     // Add the status to the Set to ensure uniqueness
             //                     // Only add if it's in the selected filter or no filter is applied
             //                     if (selectedFilterValues.length === 0 || selectedFilterValues.includes(statusText)) {
             //                         uniqueValues.add(statusText);
             //                     }
             //                 }
             //             });
         
             //             // Pass the unique status values (labels) to the filter dropdown
             //             params.success(Array.from(uniqueValues));
             //         } catch (error) {
             //             console.error("Error in filterParams.values:", error);
             //             params.success([]);
             //         }
             //     },
             //     refreshValuesOnOpen: true, // Keep it as false to prevent unnecessary refresh on every dropdown open
             // },
         
             // filterValueGetter: (params) => {
             //     const statusMap = {
             //         0: "Invoiced",
             //         1: "At Source",
             //         2: "In Transit",
             //         3: "Near Destination",
             //         4: "Delivered",
             //         5: "Left Dealer",
             //         6: "Force Closure",
             //         7: "Provision",
             //         8: "Trip Completed",
             //     };
         
             //     const consignmentStatus = params.data?.consignment_status;
             //     const status = params.data?.status;
         
             //     // Return consignmentStatus or map the status number to text
             //     return consignmentStatus || statusMap[status] || status || "Not Available";
             // }
         }
         
         
         
         
         ,
         
         {
             headerName: "Gate In" ,
             field: "gate_in_time",
             colId: "gate_in_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const gateInDate = params.data.gate_in_time;
                 if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Gate Out" ,
             field: "gate_out_time",
             colId: "gate_out_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const gateOutDate = params.data.gate_out_time;
                 if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         
         
         
         {
             headerName: "Reason For Delay" ,
             field: "reason_for_delay",
             colId: "reason_for_delay",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },
         {
             headerName: "Undelivered Reason" ,
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (undelivered_reason && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         }, 
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (!["",undefined,null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },                 
         {
             headerName: "Invoice Date",
             field: "invoice_time",
             colId: "invoice_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const invoiceDate = params.data.invoice_time;
                 if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Dispatch Date" ,
             field: "dispatch_date",
             colId: "dispatch_date",
             width: 150,
             //filter: "agDateColumnFilter",
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
 
             valueGetter: function (params) {
                 const dispatchDate = params.data.dispatch_date;
                 if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "LR Updated Date" ,
             field: "created_date",
             colId: "created_date",
             width: 160,
             //filter: "agDateColumnFilter",
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const lrDate = params.data.created_date;
                 if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignor Name",
             field: "consigner_name",
             colId: "consigner_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function (params) {
                 if (params.data.consigner_name !== "" && params.data.consigner_name !== " " && params.data.consigner_name !== undefined) {
                     return capitalizeWords(params.data.consigner_name)
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignee Code",
             field: "consignee_code",
             colId: "consignee_code",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignee Name",
             field: "consginee_name",
             colId: "consginee_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
             headerClass: 'bold-header'
         },
         {
             headerName: "Entity" ,
             field: "truck_seal_entity",
             colId: "truck_seal_entity",
             width: 150,
             cellRenderer: '', resizable: true,
             valueGetter: function (params) {
                 if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                     return capitalizeWords(params.data.truck_seal_entity)
                 }
             },
             headerClass: 'bold-header'
         },               
         {
             headerName: "Invoice Type" ,
             field: "invoice_type",
             colId: "invoice_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter:function (params) {
                 if(params.data.invoice_type !=="" && params.data.invoice_type !== undefined){
                     return (params.data.invoice_type ? capitalizeWords(params.data.invoice_type):"")
                 }
             }
         },
         {
             headerName: "Transporter",
             field: "transporter_name",
             colId: "transporter_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function (params) {
                 if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                     return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Source City" ,
             field: "consigner_city",
             colId: "consigner_city",
             width: 150,
             cellRenderer: '', resizable: true,
             valueGetter: function (params) {
                 if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                     return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                 }
             },
             headerClass: 'bold-header'
         },  
         {
             headerName: "Source Pincode" ,
             field: "consigner_pincode",
             colId: "consigner_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Source Zone" ,
             field: "consigner_zone",
             colId: "consigner_zone",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                     return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                 }
             },
         },
         {
             headerName: "Destination City" ,
             field: "consignee_city",
             colId: "consignee_city",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                     return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                 }
             },
         },
         {
             headerName: "Destination Pincode" ,
             field: "consignee_pincode",
             colId: "consignee_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Destination State" ,
             field: "consignee_state",
             colId: "consignee_state",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                     return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                 }
             },
         },
         {
             headerName: "Destination Zone",
             field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
             colId: "consignee_zone",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                     return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                 }
             },            
         },
         {
             headerName: "Mobile Number" ,
             field: "driver_mobile_no",
             colId: "driver_mobile_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Movement Type" ,
             field: "movement_type",
             colId: "movement_type",
 
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Total Weight",
             field: "lr_total_weight",
             colId: "total_weight",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
            
         },
         {
             headerName: "Total CBM",
             field: "lr_total_cbm",
             colId: "total_cbm",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
         },
         
         {
             headerName: "Transporter Category" ,
             field: "tpt_category",
             colId: "tpt_category",
             width: 190,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Vehicle Type" ,
             field: "truck_type",
             colId: "truck_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
            
         },
         {
             headerName: "Truck Seal No" ,
             // hide: (tabName.value === "inactive"),
             field: "truck_seal_no",
             colId: "truck_seal_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "ODA",
             field: "oda",
             colId: "oda",
             width: 150,
             cellRenderer: '',
             headerClass: 'bold-header',
             resizable: true,
         },
         {
             headerName: "TAT" ,
             field: "transit_time",
             colId: "transit_time",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        
         // {
         //     headerName: "Reached Destination At",
         //     field: "recent_dealer_reported",
         //     colId: "recent_dealer_reported",
         //     width: 180,
         //     resizable: true,
         //     valueGetter: function (params) {
         //         if (params.data.status === 4 || params.data.status === 5) {
         //             // Use 'status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else if (params.data.consignment_status === "Delivered") {
         //             // Use 'consignment_status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else {
         //             // Default to empty string if neither condition is met
         //             return "";
         //         }
         //     }
         // },
         {
             headerName: "Event Location" ,
             field: "last_location",
             colId: "last_location",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.last_location != "" && params.data.last_location != undefined) {
                     return (params.data.last_location ? capitalizeWords(params.data.last_location):"")
                 }
             },
         },
         {
             headerName: "Event Date & Time",
             field: "last_event_time",
             colId: "last_event_time",
             width: 180,
             resizable: true,
             comparator: dateComparator,
             valueGetter: (params) => {
                return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
            },
             headerClass: 'bold-header',
         },
         {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
           
         {
             headerName: "Expected ETA", // Estimated delivery date
             field: "expected_trip_end",
             colId: "expected_trip_end",
             width: 150,
             resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                 }
             },
             headerClass: 'bold-header'
 
         },
         
         {
             headerName: "Revised Estimated Delivery Date",
             field: "revised_trip_end",
             colId: "revised_trip_end",
             width: 240,
             // hide: (tabName.value === "inactive"),
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                 }
             },
             headerClass: 'bold-header'
         },
         // {
         //     headerName: "Actual Delivery Date",
         //     field: "recent_dealer_reported",
         //     width: 180,
         //     hide: (tabName.value === "inactive"),
         //     cellRenderer: '', resizable: true,
         //     comparator: dateComparator,
         //     valueGetter: function (params) {
         //         if (params.data.recent_dealer_reported != '' && params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported !== ' ') {
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         }
         //         else {
         //             return "NA";
         //         }
         //     },
         //     headerClass: 'bold-header'
         // },
         {
             headerName: "Performance" ,
             field: "ontime_status",
             colId: "ontime_status",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
         },
         {
             headerName: "Delay Days",
             field: "transit_delay_days",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                 const day = params.value;
                 if (day !== undefined && day !== null) {
                     // Convert hours to days and round to the nearest whole number
                     const days = day;  // Round to nearest whole number
                     return `${days}`;
                 }
                 return ''; // Return empty if no value
             }
         },
         
         {
             headerName: "Delay Days Bucket",
             field: "delay_days_bucket",
             colId: "delay_days_bucket",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                }
         },
         
         {
             headerName: "E-Way Bill No" ,
             field: "eway_bill_no",
             colId: "eway_bill_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         }, 
         {
             headerName: "Mode" ,
             field: "shipment_mode",
             colId: "shipment_mode",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                     return (params.data.shipment_mode ? capitalizeWords(params.data.shipment_mode):"")
                 }
             },
         },   
         {
             headerName: "Fuel Type" ,
             field: "fuel_type",
             colId: "fuel_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                     return (params.data.fuel_type ? capitalizeWords(params.data.fuel_type):"")
                 }
             },
         },
         {
             headerName: "No Of Boxes" ,
             field: "total_boxes",
             colId: "no_of_boxes",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        //  {
        //      headerName: "Reason" ,
        //      field: "remarks",
        //      colId: "remarks",
        //      width: 180,
        //      resizable: true,
        //      headerClass: 'bold-header',
        //      hide: showUndelivered,
        //      valueGetter: (params) => {
        //          return params?.data?.remarks ? params.data.remarks : null;
        //      },
             
        //      // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //      cellRenderer: (params) => {
        //          if (params.data.consignment_status === 'Undelivered' || params.data.status === 11) {
        //              return params.value; // Show the remark if status is 'Undelivered'
        //          }
        //          return ''; // Return empty string for other statuses
        //      },
             
        //      // hide: false
        //  },
         
     ]
     var tptActiveDefs = [
        {
            headerName: "Check",
            field: "checkbox",
            // hide: (tabName.value !== "inactive"),
            colId: "checkbox",
            width: 40,
            pinned: 'left',
            // filter: false, 
            resizable: true,
              // suppressExcelExport: true,
            checkboxSelection: params => params.data.status !== 0,
           //  checkboxSelection: true,
            headerCheckboxSelection: true
        },
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    let manual_tracking= param.data.manual_tracking;
                    
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const isDisabled = hasConsignmentStatus && 
                                       (param.data.consignment_status === "In Transit" || 
                                        param.data.consignment_status === "Dispatched from Source" || 
                                        param.data.consignment_status === "Out For Delivery" ||
                                        param.data.consignment_status === "Invalid docket");

                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute,
                                disabled: isDisabled // Set the disabled state based on the consignment status
                            }
                        };
                    }
                    if(hasConsignmentStatus){
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                            }
                        }
                    }
                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                        
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                            }
                        }
                    }

        
                  
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        }, 
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            // hide : (tabName.value == "inactive"),
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
            
                    // if ((hasConsignmentStatus) 
                    //     // && 
                    //     // (param.data.consignment_status === "In Transit" || param.data.consignment_status === "Dispatched from Source")
                    
                    // ) {                            
                    //     return {
                    //         component: CourierActions,
                    //         params: {
                    //             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //         }
                    //     }
                    // }
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        ...extraNotUserActiveCol,
        {
            headerName: "",
            field: "view_document",
            colId: "view_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            // hide: tabName.value !== 'active',
            cellRenderer: (param) => {
                const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        title="View Document"
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            cursor: "pointer" 
                        }}
                        disabled={!enableViewIcon}
                    >
                        <i className="fa fa-eye f17"></i> 
                    </button>
                );
            },
         },
         {
             headerName: "",
             field: "cancel_order",
             colId: "cancel_order",
             width: 50,
             pinned: "left",
             filter: false,
             cellRendererSelector: function (param) {
                 try {
                     const data = param.data || {};
                     const hasShipment = !!data.shipment_id;
                     const userRole = (decodedRoleCase || "").toLowerCase();
                     const tracking_type = data.tracking_type
                         ? data.tracking_type.toUpperCase()
                         : "FTL";

                     const formattedDate = getHyphenDDMMMYYYYHHMM(data.created_date);
                     let createdTime = null;

                     if (formattedDate && formattedDate !== "Invalid Date") {
                         const match = formattedDate.match(
                             /(\d{1,2})-([A-Za-z]{3})-(\d{4}) (\d{1,2}):(\d{2})/
                         );
                         if (match) {
                             const [_, day, mon, year, hour, minute] = match;
                             const months = {
                                 Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                                 Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
                             };
                             createdTime = new Date(
                                 parseInt(year),
                                 months[mon],
                                 parseInt(day),
                                 parseInt(hour),
                                 parseInt(minute),
                                 0
                             );
                         }
                     }

                     const now = new Date();
                     const expiryTime =
                         createdTime instanceof Date && !isNaN(createdTime)
                             ? new Date(createdTime.getTime() + 24 * 60 * 60 * 1000)
                             : null;

                     const within15Mins =
                         expiryTime &&
                         createdTime &&
                         now.getTime() >= createdTime.getTime() &&
                         now.getTime() <= expiryTime.getTime();

                     console.log(
                         `LR: ${data.lr_no || "-"} | Formatted: ${formattedDate} | Created: ${createdTime ? createdTime.toLocaleString() : "Invalid"
                         } | Expiry(+15m): ${expiryTime ? expiryTime.toLocaleString() : "Invalid"
                         } | Now: ${now.toLocaleString()} | Within15Mins: ${within15Mins}`
                     );

                     if (
                         data.consignment_status &&
                         ["Delivered", "Undelivered", "Cancelled"].includes(
                             data.consignment_status
                         )
                     ) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onClickCancelActiveCourierConsignemnts,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     if ([5, 6, 8, 11].includes(data.status)) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     if (userRole === "admin") {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: false,
                             },
                         };
                     }

                     if (userRole === "transporter" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 // disabled until creation time passes, or after 15 min expires
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }

                     if (userRole === "warehouse" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }

                     return null;
                 } catch (err) {
                     console.error("All Tabs cancel_order error:", err);
                     return null;
                 }
             },

             cellStyle: {
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 cursor: "pointer",
             },
             headerClass: "bold-header",
         }
         ,

       //  {
       //      headerName: "",
       //      field: "sendemail",
       //      colId: "sendemail",
       //      width: 50,
       //      filter:false,
       //      // hide: (tabName.value !== 'active'),
       //      cellRenderer:SendEmail,
       //      filter: false,
       //      pinned: "left",
       //      cellRendererSelector: function (param) {
       //          try {
       //              if (param.data._id != null && param.data._id != undefined) {
       //                  // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
       //                      return {
       //                          component: SendEmail,
       //                          params: {
       //                              onClickEmail: onClickEmail
       //                          }
       //                      }
       //                  // }
       //                  // else{
       //                  // }
                       
       //              }
       //          } catch (err) {
       //              console.log(err);
       //          }
       //      },
       //      headerClass: 'bold-header'
       //  },
// actionables above
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            hide: (decode(localStorageRole)==="transporter"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        
        ,         
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
       
        
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
                
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                // Use consignmentStatus if available, otherwise map status number to text
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         const statusMap = {
            //             0: "Invoiced",
            //             1: "At Source",
            //             2: "In Transit",
            //             3: "Near Destination",
            //             4: "Delivered",
            //             5: "Left Dealer",
            //             6: "Force Closure",
            //             7: "Provision",
            //             8: "Trip Completed",
            //         };
        
            //         try {
            //             // Get current filter model and any previously selected filter values
            //             const currentFilterModel = params.api.getFilterModel();
            //             const selectedFilterValues = currentFilterModel?.status?.values || [];
        
            //             // Loop through all the nodes (visible after applying any filters)
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     let status;
            //                     if (typeof node.data.status === "number") {
            //                         status = statusMap[node.data.status];
            //                     } else {
            //                         status = node.data.status;
            //                     }
        
            //                     const consignmentStatus = node.data.consignment_status;
            //                     const statusText = consignmentStatus || status || "Not Available";
        
            //                     // Add the status to the Set to ensure uniqueness
            //                     // Only add if it's in the selected filter or no filter is applied
            //                     if (selectedFilterValues.length === 0 || selectedFilterValues.includes(statusText)) {
            //                         uniqueValues.add(statusText);
            //                     }
            //                 }
            //             });
        
            //             // Pass the unique status values (labels) to the filter dropdown
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: true, // Keep it as false to prevent unnecessary refresh on every dropdown open
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Trip Completed",
            //     };
        
            //     const consignmentStatus = params.data?.consignment_status;
            //     const status = params.data?.status;
        
            //     // Return consignmentStatus or map the status number to text
            //     return consignmentStatus || statusMap[status] || status || "Not Available";
            // }
        }
        
        
        
        
        ,
        
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        
        
        
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },                
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const invoiceDate = params.data.invoice_time;
                if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== " " && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consginee_name",
            colId: "consginee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
               if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                   return capitalizeWords(params.data.consignee_name)
               }else{
                   return ""
               }
           },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:function (params) {
                if(params.data.invoice_type !=="" && params.data.invoice_type !== undefined){
                    return (params.data.invoice_type ? capitalizeWords(params.data.invoice_type):"")
                }
            }
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                }
            },
            headerClass: 'bold-header'
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                }
            },            
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",

            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
               // Ensure the value is a valid number
               const value = parseFloat(params.value);
               return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
           }
           
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
               // Ensure the value is a valid number
               const value = parseFloat(params.value);
               return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
           }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
           
        },
        {
            headerName: "Truck Seal No" ,
            // hide: (tabName.value === "inactive"),
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
       
        // {
        //     headerName: "Reached Destination At",
        //     field: "recent_dealer_reported",
        //     colId: "recent_dealer_reported",
        //     width: 180,
        //     resizable: true,
        //     valueGetter: function (params) {
        //         if (params.data.status === 4 || params.data.status === 5) {
        //             // Use 'status' logic
        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
        //         } else if (params.data.consignment_status === "Delivered") {
        //             // Use 'consignment_status' logic
        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
        //         } else {
        //             // Default to empty string if neither condition is met
        //             return "";
        //         }
        //     }
        // },
        {
            headerName: "Event Location" ,
            field: "last_location",
            colId: "last_location",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.last_location != "" && params.data.last_location != undefined) {
                    return (params.data.last_location ? capitalizeWords(params.data.last_location):"")
                }
            },
        },
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
          
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised Estimated Delivery Date",
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Actual Delivery Date",
        //     field: "recent_dealer_reported",
        //     width: 180,
        //     hide: (tabName.value === "inactive"),
        //     cellRenderer: '', resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: function (params) {
        //         if (params.data.recent_dealer_reported != '' && params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported !== ' ') {
        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
        //         }
        //         else {
        //             return "NA";
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
             valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return (params.data.shipment_mode ? capitalizeWords(params.data.shipment_mode):"")
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return (params.data.fuel_type ? capitalizeWords(params.data.fuel_type):"")
                }
            },
        },
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
        
    ]
     var activeDefs2 = [
        {
            headerName: "Check",
            field: "checkbox",
            // hide: (tabName.value !== "inactive"),
            colId: "checkbox",
            width: 40,
            pinned: 'left',
            // filter: false, 
            resizable: true,
              // suppressExcelExport: true,
            checkboxSelection: params => params.data.status !== 0,
           //  checkboxSelection: true,
            headerCheckboxSelection: true
        },
         {
             headerName: "",
             field: "map",
             colId: "map",
             width: 50,
             pinned: "left",
             filter:false,
             cellRendererSelector: function (param) {
                 try {
                     let manual_tracking= param.data.manual_tracking;
                     
                     const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                     const isDisabled = hasConsignmentStatus && 
                                        (param.data.consignment_status === "In Transit" || 
                                         param.data.consignment_status === "Dispatched from Source" || 
                                         param.data.consignment_status === "Out For Delivery" ||
                                         param.data.consignment_status === "Invalid docket");
 
                     if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                         return {
                             component: ViewMap,
                             params: {
                                 onClickShowRoute: onClickShowRoute,
                                 disabled: isDisabled // Set the disabled state based on the consignment status
                             }
                         };
                     }
                     if(hasConsignmentStatus){
                         return {
                             component: CourierActions,
                             params: {
                                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                             }
                         }
                     }
                     if(!hasConsignmentStatus && (manual_tracking ===1)){
                         
                         return {
                             component: CourierActions,
                             params: {
                                 onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                             }
                         }
                     }
 
         
                   
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         }, 
         {
             headerName: "",
             field: "identity",
             colId: "identity",
             width: 50,
             pinned: "left",
             filter:false,
             // hide : (tabName.value == "inactive"),
             cellRendererSelector: function (param) {
                 try {
                     const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
             
                     // if ((hasConsignmentStatus) 
                     //     // && 
                     //     // (param.data.consignment_status === "In Transit" || param.data.consignment_status === "Dispatched from Source")
                     
                     // ) {                            
                     //     return {
                     //         component: CourierActions,
                     //         params: {
                     //             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                     //         }
                     //     }
                     // }
                     if (!hasConsignmentStatus) {
                         return {
                             component: ShipmentLegs,
                             params: {
                                 onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                             }
                         }
                     }else{
                         return {
                             component: CourierShipmentLegs,
                             params: {
                                 onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         // {
         //     headerName: "",
         //     field: "Group",
         //     colId: "Group",
         //     width: 50,
         //     pinned: "left",
         //     // hide: tabName.value === "inactive",
         //     cellRendererSelector: function (param) {
         //         try {
         //             if (param.data._id != null && param.data._id != undefined) {
         //                 return {
         //                     component: GroupIconRenderer,
         //                     params: {
         //                         onShowTransitData: onShowTransitData,
         //                         onShowNoGPSData: onShowNoGPSData,
         //                         onShowStoppagesData: onShowStoppagesData,
         //                         onShowUploadDoc: onShowUploadDoc,
         //                         onShowDocs: onShowDocs,
         //                     }
         //                 }
         //             }
         //         } catch (err) {
         //             //console.log(err);
         //         }
         //     },
         //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         // },
         {
             headerName: "",
             field: "show_transitdelay",
             colId: "show_transitdelay",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowTransitDelayIcon,
                             params: {
                                 onShowTransitData: onShowTransitData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         {
             headerName: "",
             field: "show_tracking",
             colId: "show_tracking",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowNoTrackingIcon,
                             params: {
                                 onShowNoGPSData: onShowNoGPSData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         {
             headerName: "",
             field: "show_stoppages",
             colId: "show_stoppages",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowstoppagesIcon,
                             params: {
                                 onShowStoppagesData: onShowStoppagesData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
        ...extraActiveUpdateCol,
         {
             headerName: "",
             field: "edit_logs",
             colId: "edit_logs",
             width: 50,
             pinned: "left",
             filter:false,
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         // if(tabName.value === "active"){
                             return {
                                 component: EditLogsConsignments,
                                 params: {
                                     onClickActive: onClickEditLogs,
                                     iconType: "edit",
                                     tooltip: "Edit Logs",
                                     disabled: (param.data.trip_edited ===0 || param.data.trip_edited === undefined || param.data.trip_edited ===null)
 
                                 }
                             // };                           
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
             headerClass: 'bold-header'
         },
         {
             headerName: "",
             field: "update_tracking_status",
             colId: "update_tracking_status",
             width: 50,
             pinned: "left",
             filter:false,
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                         const roles = ["user"];
                         let enableUpdateDetailIcon = roles.includes(decodedRoleCase);
 
                         if (hasConsignmentStatus) {                            
                             return {
                                 component: UpdatePTLConsignments,
                                 params: {
                                     onClickActive: updateDeliveredDate,
                                     iconType: "tracking",
                                     disabled: enableUpdateDetailIcon // Disable the icon
                                 }
                             };
                         }
                         // if (hasConsignmentStatus && param.data.manual_tracking === 0) {                            
                         //     return {
                         //         component: UpdatePTLConsignments,
                         //         params: {
                         //             onClickActive: updateDeliveredDate,
                         //             iconType: "tracking",
                         //             disabled: true // Disable the icon
                         //         }
                         //     };
                         // }
                         
                         else if (!hasConsignmentStatus && ( [1, 2, 3, 4, 10].includes(param.data.status))) {

                            return {

                                 component: UpdatePTLConsignments,
                                 params: {
                                     onClickActive: updateDeliveredDate,
                                     iconType: "tracking",
                                     disabled: enableUpdateDetailIcon 
                                 }
                             };
                         } else{
                            
                            
                             return {
                                 component: UpdatePTLConsignments,
                                 params: {
                                     onClickActive: updateDeliveredDate,
                                     iconType: "tracking",
                                     disabled: enableUpdateDetailIcon
                                 }
                             };
                         }  
                         // return{
                         //     component: UpdatePTLConsignments,
                         //     params: {
                         //         onClickActive: updateDeliveredDate,
                         //         iconType: "tracking",
                         //         disabled: true 
                         //     }
                         // }                     
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
             headerClass: 'bold-header'
         },        
         {
             headerName: "",
             field: "upload_document",
             colId: "upload_document",
             width: 60,
             filter: false,
             pinned:"left",
             headerClass: 'bold-header',
             cellRenderer: (param) => {
                 // const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                 let isDisabledUploadDoc = (decodedRoleCase==="user" || [5, 8, 6, 11].includes(param.data.status) || ["Delivered", "Cancelled","Undelivered"].includes(param.data.consignment_status))
                 const handleClick = (e) => {
                     e.stopPropagation();
                     // if (!hasConsignmentStatus && isDisabledUploadDoc) {
                         onShowUploadDoc(param); 
                     // }
                     //  else {
                     //     if(isDisabledUploadDoc)
                     //         onClickUploadPOD(param)
                     // }
                 };
                 
                 return (
                     <button 
                         onClick={handleClick} 
                         // title={hasConsignmentStatus ? "Upload Document (Disabled)" : "Upload Document"}
                         title="Upload Document"
                         style={{ 
                             border:"none",
                             backgroundColor:"transparent",
                             pointerEvents: isDisabledUploadDoc ? "none" : "auto", 
                             opacity: isDisabledUploadDoc ? 0.5 : 1, 
                             // cursor: (hasConsignmentStatus && param.data.consignment_status === "Delivered") || (!hasConsignmentStatus && (param.data.status === 4 || param.data.status === 6)) ? "not-allowed" : "pointer" ,
                             // cursor: "pointer" 
                         }}
                         disabled={isDisabledUploadDoc}
                     >
                         <i className="icofont icofont-upload-alt f17" style={{ fontSize:"12px",color: isDisabledUploadDoc? "grey":"#3a3fa6" }}></i>
                     </button>
                 );
             },
         },         
         {
             headerName: "",
             field: "view_document",
             colId: "view_document",
             width: 60,
             filter: false,
             pinned: "left",
             headerClass: 'bold-header',
             // hide: tabName.value !== 'active',
             cellRenderer: (param) => {
                 const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                 const handleClick = (e) => {
                     e.stopPropagation();
                     // if (!hasConsignmentStatus) {
                     //     onShowDocs(param);  
                     // }
                     onShowDocs(param);  
                 };        
                 return (
                     <button 
                         onClick={handleClick} 
                         title="View Document"
                         // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                         style={{ 
                             border:"none",
                             backgroundColor:"transparent",
                             fontSize:"12px",
                             // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                             // opacity: hasConsignmentStatus ? 0.5 : 1, 
                             // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                             cursor: "pointer" 
                         }}
                         disabled={!enableViewIcon}
                     >
                         <i className="fa fa-eye f17"></i> 
                     </button>
                 );
             },
         },              
       ...extraActiveCancelCol,
        //  {
        //      headerName: "",
        //      field: "sendemail",
        //      colId: "sendemail",
        //      width: 50,
        //      filter:false,
        //      // hide: (tabName.value !== 'active'),
        //      cellRenderer:SendEmail,
        //      filter: false,
        //      pinned: "left",
        //      cellRendererSelector: function (param) {
        //          try {
        //              if (param.data._id != null && param.data._id != undefined) {
        //                  // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
        //                      return {
        //                          component: SendEmail,
        //                          params: {
        //                              onClickEmail: onClickEmail
        //                          }
        //                      }
        //                  // }
        //                  // else{
        //                  // }
                        
        //              }
        //          } catch (err) {
        //              console.log(err);
        //          }
        //      },
        //      headerClass: 'bold-header'
        //  },
 // actionables above
         {
             headerName: "Tracking Mode" ,
             field: "tracking_type",
             colId: "tracking_type",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "SIM Consent Status" ,
             field: "sim_consent_status",
             colId: "sim_consent_status",
             hide: (decode(localStorageRole)==="transporter"),
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter:(params)=>{
                 if(params.data.tracking_type ==="PTL"){
                    return ""
                }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                    return "Consent Approved"
                }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                    return "Consent Pending"
                }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
                return ""
                }
            }
         },
         {
             headerName: "LR No" ,
             field: "lr_no",
             colId: "lr_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Invoice No",
             field: "invoice_list",
             colId: "invoice_no",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
         }
         
         ,         
         {
             headerName: "Vehicle No" ,
             field: "truck_no",
             colId: "truck_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        
         
         {
             headerName: "Status",
             field: "status",
             colId: "status",
             valueGetter: (params) => {
               
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
         
                 // Use consignmentStatus if available, otherwise map status number to text
                 return consignmentStatus || statusMap[status] || status || "Not Available";
             },
         
         }
         
         
         
         
         ,
         
         {
             headerName: "Gate In" ,
             field: "gate_in_time",
             colId: "gate_in_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const gateInDate = params.data.gate_in_time;
                 if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Gate Out" ,
             field: "gate_out_time",
             colId: "gate_out_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const gateOutDate = params.data.gate_out_time;
                 if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Reason For Delay" ,
             field: "reason_for_delay",
             colId: "reason_for_delay",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         }, 
         {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },
         {
             headerName: "Undelivered Reason" ,
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (undelivered_reason && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         }, 
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (!["",undefined,null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },               
         {
             headerName: "Invoice Date",
             field: "invoice_time",
             colId: "invoice_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const invoiceDate = params.data.invoice_time;
                 if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Dispatch Date" ,
             field: "dispatch_date",
             colId: "dispatch_date",
             width: 150,
             //filter: "agDateColumnFilter",
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
 
             valueGetter: function (params) {
                 const dispatchDate = params.data.dispatch_date;
                 if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "LR Updated Date" ,
             field: "created_date",
             colId: "created_date",
             width: 160,
             //filter: "agDateColumnFilter",
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const lrDate = params.data.created_date;
                 if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Event Updated At",
             field: "last_event_dt",
             colId: "last_event_dt",
             width: 160,
             cellRenderer: '',
             resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const lastEventDate = params.data.last_event_dt;
                 return getHyphenDDMMMYYYYHHMM(lastEventDate);
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignor Name",
             field: "consigner_name",
             colId: "consigner_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function (params) {
                 if (params.data.consigner_name != "" && params.data.consigner_name != "" && params.data.consigner_name != undefined) {
                     return capitalizeWords(params.data.consigner_name)
                 }else{
                    return ""
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignee Code",
             field: "consignee_code",
             colId: "consignee_code",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignee Name",
             field: "consginee_name",
             colId: "consginee_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
             headerClass: 'bold-header'
         },
         {
             headerName: "Entity" ,
             field: "truck_seal_entity",
             colId: "truck_seal_entity",
             width: 150,
             cellRenderer: '', resizable: true,
             valueGetter: function (params) {
                 if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                     return capitalizeWords(params.data.truck_seal_entity)
                 }
             },
             headerClass: 'bold-header'
         },               
         {
             headerName: "Invoice Type" ,
             field: "invoice_type",
             colId: "invoice_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter:function (params) {
                 if(params.data.invoice_type !=="" && params.data.invoice_type !== undefined){
                     return (params.data.invoice_type ? capitalizeWords(params.data.invoice_type):"")
                 }
             }
         },
         {
             headerName: "Transporter",
             field: "transporter_name",
             colId: "transporter_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function (params) {
                 if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                     return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Source City" ,
             field: "consigner_city",
             colId: "consigner_city",
             width: 150,
             cellRenderer: '', resizable: true,
             valueGetter: function (params) {
                 if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                     return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                 }
             },
             headerClass: 'bold-header'
         },  
         {
             headerName: "Source Pincode" ,
             field: "consigner_pincode",
             colId: "consigner_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Source Zone" ,
             field: "consigner_zone",
             colId: "consigner_zone",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                     return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                 }
             },
         },
         {
             headerName: "Destination City" ,
             field: "consignee_city",
             colId: "consignee_city",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                     return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                 }
             },
         },
         {
             headerName: "Destination Pincode" ,
             field: "consignee_pincode",
             colId: "consignee_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Destination State" ,
             field: "consignee_state",
             colId: "consignee_state",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                     return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                 }
             },
         },
         {
             headerName: "Destination Zone",
             field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
             colId: "consignee_zone",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                     return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                 }
             },            
         },
         {
             headerName: "Mobile Number" ,
             field: "driver_mobile_no",
             colId: "driver_mobile_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Movement Type" ,
             field: "movement_type",
             colId: "movement_type",
 
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Total Weight",
             field: "lr_total_weight",
             colId: "total_weight",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
            
         },
         {
             headerName: "Total CBM",
             field: "lr_total_cbm",
             colId: "total_cbm",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
          
         },
         
         {
             headerName: "Transporter Category" ,
             field: "tpt_category",
             colId: "tpt_category",
             width: 190,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Vehicle Type" ,
             field: "truck_type",
             colId: "truck_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
            
         },
         {
             headerName: "Truck Seal No" ,
             // hide: (tabName.value === "inactive"),
             field: "truck_seal_no",
             colId: "truck_seal_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "ODA",
             field: "oda",
             colId: "oda",
             width: 150,
             cellRenderer: '',
             headerClass: 'bold-header',
             resizable: true,
         },
        //  {
        //      headerName: "TAT" ,
        //      field: "transit_time",
        //      colId: "transit_time",
        //      // hide: (tabName.value === "inactive"),
        //      width: 150,
        //      cellRenderer: '', resizable: true,
        //      headerClass: 'bold-header'
        //  },
         {
            headerName: "Basic TAT" ,
            field: "basic_tat",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Buffer days" ,
            field: "total_buffer_days",
            width: 170,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Final TAT" ,
            field: "final_tat",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
         // {
         //     headerName: "Reached Destination At",
         //     field: "recent_dealer_reported",
         //     colId: "recent_dealer_reported",
         //     width: 180,
         //     resizable: true,
         //     valueGetter: function (params) {
         //         if (params.data.status === 4 || params.data.status === 5) {
         //             // Use 'status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else if (params.data.consignment_status === "Delivered") {
         //             // Use 'consignment_status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else {
         //             // Default to empty string if neither condition is met
         //             return "";
         //         }
         //     }
         // },
         {
             headerName: "Event Location" ,
             field: "last_location",
             colId: "last_location",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.last_location != "" && params.data.last_location != undefined) {
                     return (params.data.last_location ? capitalizeWords(params.data.last_location):"")
                 }
             },
         },
         {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        //  {
        //      headerName: "Last Data Received On",
        //      field: "last_process_on",
        //      colId: "last_process_on",
        //      width: 200,
        //      cellRenderer: '',
        //      resizable: true,
        //      comparator: dateComparator,
        //      valueGetter: (params) => {
        //          if (params.data.accessed_api_at) {
        //              return params.data.accessed_api_at ? getHyphenDDMMMYYYYHHMM(params.data.accessed_api_at) : "NA";
        //          }
        //          else {
        //              return params.data.last_process_on ? getHyphenDDMMMYYYYHHMM(params.data.last_process_on) : "NA";
        //          }
        //      },
        //      // valueGetter: function (params) {
        //      //     const { data: { tracking_type, truck_no, last_process_on } } = params;
         
        //      //     if (tracking_type === "FTL") {
        //      //         const truckLocation = truckLocations?.find(location => location.truck_no === truck_no);
        //      //         return truckLocation?.latest_sim_packet 
        //      //             ? getHyphenDDMMMYYYYHHMM(truckLocation.latest_sim_packet)
        //      //             : "NA";
        //      //     } 
         
        //      //     if (tracking_type === "PTL") {
        //      //         return last_process_on 
        //      //             ? getHyphenDDMMMYYYYHHMM(last_process_on)
        //      //             : "NA";
        //      //     }
         
        //      //     return "NA";
        //      // },
        //      headerClass: 'bold-header',
        //  },
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
           
         {
             headerName: "Expected ETA", // Estimated delivery date
             field: "expected_trip_end",
             colId: "expected_trip_end",
             width: 150,
             resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                 }
             },
             headerClass: 'bold-header'
 
         },
         
         {
             headerName: "Revised ETA", //"Revised Estimated Delivery Date",(neeraj asked to change 04/06/26)
             field: "revised_trip_end",
             colId: "revised_trip_end",
             width: 240,
             // hide: (tabName.value === "inactive"),
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
            headerName: "Customer Promise Date",
            field: "final_eta_dt",
           
            width: 200,
            resizable: true,
            comparator: dateComparator,
            comparator: dateComparator,
            valueGetter: (params) => {
                return params.data.final_eta_dt ? getHyphenDDMMMYYYYHHMM(params.data.final_eta_dt) : "";
            },
            headerClass: 'bold-header',

        },
         // {
         //     headerName: "Actual Delivery Date",
         //     field: "recent_dealer_reported",
         //     width: 180,
         //     hide: (tabName.value === "inactive"),
         //     cellRenderer: '', resizable: true,
         //     comparator: dateComparator,
         //     valueGetter: function (params) {
         //         if (params.data.recent_dealer_reported != '' && params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported !== ' ') {
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         }
         //         else {
         //             return "NA";
         //         }
         //     },
         //     headerClass: 'bold-header'
         // },
         {
             headerName: "Performance" ,
             field: "ontime_status",
             colId: "ontime_status",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
         },
         {
             headerName: "Delay Days",
             field: "transit_delay_days",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                 const day = params.value;
                 if (day !== undefined && day !== null) {
                     // Convert hours to days and round to the nearest whole number
                     const days = day;  // Round to nearest whole number
                     return `${days}`;
                 }
                 return ''; // Return empty if no value
             }
         },
         
         {
             headerName: "Delay Days Bucket",
             field: "delay_days_bucket",
             colId: "delay_days_bucket",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
         },
         
         {
             headerName: "E-Way Bill No" ,
             field: "eway_bill_no",
             colId: "eway_bill_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         }, 
         {
             headerName: "Mode" ,
             field: "shipment_mode",
             colId: "shipment_mode",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                     return (params.data.shipment_mode ? capitalizeWords(params.data.shipment_mode):"")
                 }
             },
         },   
         {
             headerName: "Fuel Type" ,
             field: "fuel_type",
             colId: "fuel_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                     return (params.data.fuel_type ? capitalizeWords(params.data.fuel_type):"")
                 }
             },
         },
         {
             headerName: "No Of Boxes" ,
             field: "total_boxes",
             colId: "no_of_boxes",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
            headerName: "Customer Mobile Number",
            field: "cus_mobile_no",
            width: 220,
            filter: "agSetColumnFilter",
            resizable: true,
            editable: false,
            headerClass: "bold-header",
            valueSetter: (params) => {
                const value = params.newValue;

                if (/^\d*$/.test(value)) {
                    params.data.cus_mobile_no = value;
                    return true;
                } else {
                    return false;
                }
            },
        },
        //  {
        //      headerName: "Reason" ,
        //      field: "remarks",
        //      colId: "remarks",
        //      width: 180,
        //      resizable: true,
        //      headerClass: 'bold-header',
        //      hide: showUndelivered,
        //      valueGetter: (params) => {
        //          return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //      },
             
        //      // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //      cellRenderer: (params) => {
        //          if (params.data.consignment_status === 'Undelivered') {
        //              return params.value; // Show the remark if status is 'Undelivered'
        //          }
        //          return ''; // Return empty string for other statuses
        //      },
             
        //      // hide: false
        //  },
         
     ]
     var activeDefs3 = [
        {
             headerName: "Check",
             field: "checkbox",
             // hide: (tabName.value !== "inactive"),
             colId: "checkbox",
             width: 40,
             pinned: 'left',
             // filter: false, 
             resizable: true,
               // suppressExcelExport: true,
             checkboxSelection: params => params.data.status !== 0,
            //  checkboxSelection: true,
             headerCheckboxSelection: true
         },
         {
             headerName: "",
             field: "map",
             colId: "map",
             width: 50,
             pinned: "left",
             filter:false,
             cellRendererSelector: function (param) {
                 try {
                     let manual_tracking= param.data.manual_tracking;
                     
                     const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                     const isDisabled = hasConsignmentStatus && 
                                        (param.data.consignment_status === "In Transit" || 
                                         param.data.consignment_status === "Dispatched from Source" || 
                                         param.data.consignment_status === "Out For Delivery" ||
                                         param.data.consignment_status === "Invalid docket");
 
                     if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                         return {
                             component: ViewMap,
                             params: {
                                 onClickShowRoute: onClickShowRoute,
                                 disabled: isDisabled // Set the disabled state based on the consignment status
                             }
                         };
                     }
                     if(hasConsignmentStatus){
                         return {
                             component: CourierActions,
                             params: {
                                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                             }
                         }
                     }
                     if(!hasConsignmentStatus && (manual_tracking ===1)){
                         
                         return {
                             component: CourierActions,
                             params: {
                                 onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                             }
                         }
                     }
 
         
                   
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         }, 
         {
             headerName: "",
             field: "identity",
             colId: "identity",
             width: 50,
             pinned: "left",
             filter:false,
             // hide : (tabName.value == "inactive"),
             cellRendererSelector: function (param) {
                 try {
                     const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
             
                     // if ((hasConsignmentStatus) 
                     //     // && 
                     //     // (param.data.consignment_status === "In Transit" || param.data.consignment_status === "Dispatched from Source")
                     
                     // ) {                            
                     //     return {
                     //         component: CourierActions,
                     //         params: {
                     //             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                     //         }
                     //     }
                     // }
                     if (!hasConsignmentStatus) {
                         return {
                             component: ShipmentLegs,
                             params: {
                                 onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                             }
                         }
                     }else{
                         return {
                             component: CourierShipmentLegs,
                             params: {
                                 onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         // {
         //     headerName: "",
         //     field: "Group",
         //     colId: "Group",
         //     width: 50,
         //     pinned: "left",
         //     // hide: tabName.value === "inactive",
         //     cellRendererSelector: function (param) {
         //         try {
         //             if (param.data._id != null && param.data._id != undefined) {
         //                 return {
         //                     component: GroupIconRenderer,
         //                     params: {
         //                         onShowTransitData: onShowTransitData,
         //                         onShowNoGPSData: onShowNoGPSData,
         //                         onShowStoppagesData: onShowStoppagesData,
         //                         onShowUploadDoc: onShowUploadDoc,
         //                         onShowDocs: onShowDocs,
         //                     }
         //                 }
         //             }
         //         } catch (err) {
         //             //console.log(err);
         //         }
         //     },
         //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         // },
         {
             headerName: "",
             field: "show_transitdelay",
             colId: "show_transitdelay",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowTransitDelayIcon,
                             params: {
                                 onShowTransitData: onShowTransitData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         {
             headerName: "",
             field: "show_tracking",
             colId: "show_tracking",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowNoTrackingIcon,
                             params: {
                                 onShowNoGPSData: onShowNoGPSData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         {
             headerName: "",
             field: "show_stoppages",
             colId: "show_stoppages",
             width: 50,
             pinned: "left",
             filter:false,
             // hide: tabName.value === "inactive",
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         return {
                             component: onShowstoppagesIcon,
                             params: {
                                 onShowStoppagesData: onShowStoppagesData,
                                 
                             }
                         }
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
         },
         {
            headerName: "",
            field: "update",
            colId: "update",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        // if(tabName.value === "active"){
                            let enableUpdateDetailIcon = (decodedRoleCase==="transporter");
                            

                            return {
                                component: UpdateConsignments,
                                params: {
                                    onClickActive: onClickActive,
                                    iconType: "edit",
                                    tooltip: "Update Trip Details",
                                    disabled:enableUpdateDetailIcon
                                }
                            // };                           
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },
                 {
             headerName: "",
             field: "update_tracking_status",
             colId: "update_tracking_status",
             width: 50,
             pinned: "left",
             filter:false,
             cellRendererSelector: function (param) {
                 try {
                     if (param.data._id != null && param.data._id != undefined) {
                         const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                         const roles = ["user"];
                         let enableUpdateDetailIcon = roles.includes(decodedRoleCase) || param.data.status === 0;
 
                         if (hasConsignmentStatus) {                            
                             return {
                                 component: UpdatePTLConsignments,
                                 params: {
                                     onClickActive: updateDeliveredDate,
                                     iconType: "tracking",
                                     disabled: enableUpdateDetailIcon // Disable the icon
                                 }
                             };
                         }
                         // if (hasConsignmentStatus && param.data.manual_tracking === 0) {                            
                         //     return {
                         //         component: UpdatePTLConsignments,
                         //         params: {
                         //             onClickActive: updateDeliveredDate,
                         //             iconType: "tracking",
                         //             disabled: true // Disable the icon
                         //         }
                         //     };
                         // }
                         
                         else if (!hasConsignmentStatus && ([1, 2, 3, 4, 10].includes(param.data.status))) {
                             return {
                                 component: UpdatePTLConsignments,
                                 params: {
                                     onClickActive: updateDeliveredDate,
                                     iconType: "tracking",
                                     disabled: enableUpdateDetailIcon 
                                 }
                             };
                         } else{
                             return {
                                 component: UpdatePTLConsignments,
                                 params: {
                                     onClickActive: updateDeliveredDate,
                                     iconType: "tracking",
                                     disabled: enableUpdateDetailIcon
                                 }
                             };
                         }  
                         // return{
                         //     component: UpdatePTLConsignments,
                         //     params: {
                         //         onClickActive: updateDeliveredDate,
                         //         iconType: "tracking",
                         //         disabled: true 
                         //     }
                         // }                     
                     }
                 } catch (err) {
                     console.log(err);
                 }
             },
             cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
             headerClass: 'bold-header'
         },        
         {
             headerName: "",
             field: "upload_document",
             colId: "upload_document",
             width: 60,
             filter: false,
             pinned:"left",
             headerClass: 'bold-header',
             cellRenderer: (param) => {
                 // const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                 let isDisabledUploadDoc = (decodedRoleCase==="user" || [5, 6, 8, 11].includes(param.data.status) || ["Delivered","Cancelled","Undelivered"].includes(param.data.consignment_status))
                 const handleClick = (e) => {
                     e.stopPropagation();
                     // if (!hasConsignmentStatus && isDisabledUploadDoc) {
                         onShowUploadDoc(param); 
                     // }
                     //  else {
                     //     if(isDisabledUploadDoc)
                     //         onClickUploadPOD(param)
                     // }
                 };
                 
                 return (
                     <button 
                         onClick={handleClick} 
                         // title={hasConsignmentStatus ? "Upload Document (Disabled)" : "Upload Document"}
                         title="Upload Document"
                         style={{ 
                             border:"none",
                             backgroundColor:"transparent",
                             pointerEvents: isDisabledUploadDoc ? "none" : "auto", 
                             opacity: isDisabledUploadDoc ? 0.5 : 1, 
                             // cursor: (hasConsignmentStatus && param.data.consignment_status === "Delivered") || (!hasConsignmentStatus && (param.data.status === 4 || param.data.status === 6)) ? "not-allowed" : "pointer" ,
                             // cursor: "pointer" 
                         }}
                         disabled={isDisabledUploadDoc}
                     >
                         <i className="icofont icofont-upload-alt f17" style={{ fontSize:"12px",color: isDisabledUploadDoc? "grey":"#3a3fa6" }}></i>
                     </button>
                 );
             },
         },         
         {
             headerName: "",
             field: "view_document",
             colId: "view_document",
             width: 60,
             filter: false,
             pinned: "left",
             headerClass: 'bold-header',
             // hide: tabName.value !== 'active',
             cellRenderer: (param) => {
                 const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                 const handleClick = (e) => {
                     e.stopPropagation();
                     // if (!hasConsignmentStatus) {
                     //     onShowDocs(param);  
                     // }
                     onShowDocs(param);  
                 };        
                 return (
                     <button 
                         onClick={handleClick} 
                         title="View Document"
                         // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                         style={{ 
                             border:"none",
                             backgroundColor:"transparent",
                             fontSize:"12px",
                             // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                             // opacity: hasConsignmentStatus ? 0.5 : 1, 
                             // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                             cursor: "pointer" 
                         }}
                         disabled={!enableViewIcon}
                     >
                         <i className="fa fa-eye f17"></i> 
                     </button>
                 );
             },
         },              
        //  {
        //     headerName: "",
        //     field: "cancel_order",
        //     colId: "cancel_order",
        //     width: 50,
        //     pinned: "left",
        //     filter:false,
        //     cellRendererSelector: function (param) {
        //         try {
        //             const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
        //             const hasLrNo = param.data.hasOwnProperty("lr_no");
        //             var disableIcon=decodedRoleCase==="user";
        //             const isConditionMet = (hasConsignmentStatus || hasLrNo) && 
        //                                    (param.data.consignment_status === "In Transit" || 
        //                                     param.data.consignment_status === "Dispatched from Source" || 
        //                                     param.data.consignment_status === "Invalid docket" ||
        //                                     param.data.consignment_status === "Booked");
        //             if (isConditionMet) {
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onClickCancelActiveCourierConsignemnts,
        //                         disabled: false || disableIcon,
        //                         tracking_type: "PTL1"
        //                     }
        //                 };
        //             } else {
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onShowForceCloseModal,
        //                         tracking_type: "FTL",
        //                         disabled: disableIcon,
        //                     }
        //                 };
        //             }
        
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },
        //      {
        //      headerName: "",
        //      field: "sendemail",
        //      colId: "sendemail",
        //      width: 50,
        //      filter:false,
        //      // hide: (tabName.value !== 'active'),
        //      cellRenderer:SendEmail,
        //      filter: false,
        //      pinned: "left",
        //      cellRendererSelector: function (param) {
        //          try {
        //              if (param.data._id != null && param.data._id != undefined) {
        //                  // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
        //                      return {
        //                          component: SendEmail,
        //                          params: {
        //                              onClickEmail: onClickEmail
        //                          }
        //                      }
        //                  // }
        //                  // else{
        //                  // }
                        
        //              }
        //          } catch (err) {
        //              console.log(err);
        //          }
        //      },
        //      headerClass: 'bold-header'
        //  },
         {
             headerName: "",
             field: "cancel_order",
             colId: "cancel_order",
             width: 50,
             pinned: "left",
             filter: false,
             cellRendererSelector: function (param) {
                 try {
                     const data = param.data || {};
                     const hasShipment = !!data.shipment_id;
                     const userRole = (decodedRoleCase || "").toLowerCase();
                     const tracking_type = data.tracking_type
                         ? data.tracking_type.toUpperCase()
                         : "FTL";

                     const formattedDate = getHyphenDDMMMYYYYHHMM(data.created_date);
                     let createdTime = null;

                     if (formattedDate && formattedDate !== "Invalid Date") {
                         const match = formattedDate.match(
                             /(\d{1,2})-([A-Za-z]{3})-(\d{4}) (\d{1,2}):(\d{2})/
                         );
                         if (match) {
                             const [_, day, mon, year, hour, minute] = match;
                             const months = {
                                 Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                                 Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
                             };
                             createdTime = new Date(
                                 parseInt(year),
                                 months[mon],
                                 parseInt(day),
                                 parseInt(hour),
                                 parseInt(minute),
                                 0
                             );
                         }
                     }

                     const now = new Date();
                     const expiryTime =
                         createdTime instanceof Date && !isNaN(createdTime)
                             ? new Date(createdTime.getTime() + 24 * 60 * 60 * 1000)
                             : null;

                     const within15Mins =
                         expiryTime &&
                         createdTime &&
                         now.getTime() >= createdTime.getTime() &&
                         now.getTime() <= expiryTime.getTime();

                     console.log(
                         `LR: ${data.lr_no || "-"} | Formatted: ${formattedDate} | Created: ${createdTime ? createdTime.toLocaleString() : "Invalid"
                         } | Expiry(+15m): ${expiryTime ? expiryTime.toLocaleString() : "Invalid"
                         } | Now: ${now.toLocaleString()} | Within15Mins: ${within15Mins}`
                     );

                     if (
                         data.consignment_status &&
                         ["Delivered", "Undelivered", "Cancelled"].includes(
                             data.consignment_status
                         )
                     ) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onClickCancelActiveCourierConsignemnts,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     if ([5, 6, 8, 11].includes(data.status)) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     if (userRole === "admin") {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: false,
                             },
                         };
                     }

                     if (userRole === "transporter" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 // disabled until creation time passes, or after 15 min expires
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }

                     if (userRole === "warehouse" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }
                     if (userRole === "wh-outbound" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }

                     return null;
                 } catch (err) {
                     console.error("All Tabs cancel_order error:", err);
                     return null;
                 }
             },

             cellStyle: {
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 cursor: "pointer",
             },
             headerClass: "bold-header",
         },
 // actionables above
         {
             headerName: "Tracking Mode" ,
             field: "tracking_type",
             colId: "tracking_type",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "SIM Consent Status" ,
             field: "sim_consent_status",
             colId: "sim_consent_status",
             hide: (decode(localStorageRole)==="transporter"),
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter:(params)=>{
                 if(params.data.tracking_type ==="PTL"){
                    return ""
                }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                    return "Consent Approved"
                }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                    return "Consent Pending"
                }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
                return ""
                }
            }
         },
         {
             headerName: "LR No" ,
             field: "lr_no",
             colId: "lr_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Invoice No",
             field: "invoice_list",
             colId: "invoice_no",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
         }
         
         ,         
         {
             headerName: "Vehicle No" ,
             field: "truck_no",
             colId: "truck_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        
         
         {
             headerName: "Status",
             field: "status",
             colId: "status",
             valueGetter: (params) => {
               
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
         
                 // Use consignmentStatus if available, otherwise map status number to text
                 return consignmentStatus || statusMap[status] || status || "Not Available";
             },
         
             // filterParams: {
             //     values: (params) => {
             //         const uniqueValues = new Set();
             //         const statusMap = {
             //             0: "Invoiced",
             //             1: "At Source",
             //             2: "In Transit",
             //             3: "Near Destination",
             //             4: "Delivered",
             //             5: "Left Dealer",
             //             6: "Force Closure",
             //             7: "Provision",
             //             8: "Trip Completed",
             //         };
         
             //         try {
             //             // Get current filter model and any previously selected filter values
             //             const currentFilterModel = params.api.getFilterModel();
             //             const selectedFilterValues = currentFilterModel?.status?.values || [];
         
             //             // Loop through all the nodes (visible after applying any filters)
             //             params.api.forEachNodeAfterFilter((node) => {
             //                 if (node.data) {
             //                     let status;
             //                     if (typeof node.data.status === "number") {
             //                         status = statusMap[node.data.status];
             //                     } else {
             //                         status = node.data.status;
             //                     }
         
             //                     const consignmentStatus = node.data.consignment_status;
             //                     const statusText = consignmentStatus || status || "Not Available";
         
             //                     // Add the status to the Set to ensure uniqueness
             //                     // Only add if it's in the selected filter or no filter is applied
             //                     if (selectedFilterValues.length === 0 || selectedFilterValues.includes(statusText)) {
             //                         uniqueValues.add(statusText);
             //                     }
             //                 }
             //             });
         
             //             // Pass the unique status values (labels) to the filter dropdown
             //             params.success(Array.from(uniqueValues));
             //         } catch (error) {
             //             console.error("Error in filterParams.values:", error);
             //             params.success([]);
             //         }
             //     },
             //     refreshValuesOnOpen: true, // Keep it as false to prevent unnecessary refresh on every dropdown open
             // },
         
             // filterValueGetter: (params) => {
             //     const statusMap = {
             //         0: "Invoiced",
             //         1: "At Source",
             //         2: "In Transit",
             //         3: "Near Destination",
             //         4: "Delivered",
             //         5: "Left Dealer",
             //         6: "Force Closure",
             //         7: "Provision",
             //         8: "Trip Completed",
             //     };
         
             //     const consignmentStatus = params.data?.consignment_status;
             //     const status = params.data?.status;
         
             //     // Return consignmentStatus or map the status number to text
             //     return consignmentStatus || statusMap[status] || status || "Not Available";
             // }
         }
         
         
         
         
         ,
         
         {
             headerName: "Gate In" ,
             field: "gate_in_time",
             colId: "gate_in_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const gateInDate = params.data.gate_in_time;
                 if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Gate Out" ,
             field: "gate_out_time",
             colId: "gate_out_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const gateOutDate = params.data.gate_out_time;
                 if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         
         
         
         {
             headerName: "Reason For Delay" ,
             field: "reason_for_delay",
             colId: "reason_for_delay",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },
         {
             headerName: "Undelivered Reason" ,
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (undelivered_reason && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         }, 
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (!["",undefined,null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },                 
         {
             headerName: "Invoice Date",
             field: "invoice_time",
             colId: "invoice_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const invoiceDate = params.data.invoice_time;
                 if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Dispatch Date" ,
             field: "dispatch_date",
             colId: "dispatch_date",
             width: 150,
             //filter: "agDateColumnFilter",
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
 
             valueGetter: function (params) {
                 const dispatchDate = params.data.dispatch_date;
                 if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "LR Updated Date" ,
             field: "created_date",
             colId: "created_date",
             width: 160,
             //filter: "agDateColumnFilter",
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const lrDate = params.data.created_date;
                 if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignor Name",
             field: "consigner_name",
             colId: "consigner_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function (params) {
                 if (params.data.consigner_name != "" && params.data.consigner_name != " " && params.data.consigner_name !== undefined) {
                     return capitalizeWords(params.data.consigner_name)
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignee Code",
             field: "consignee_code",
             colId: "consignee_code",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Consignee Name",
             field: "consginee_name",
             colId: "consginee_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
             headerClass: 'bold-header'
         },
         {
             headerName: "Entity" ,
             field: "truck_seal_entity",
             colId: "truck_seal_entity",
             width: 150,
             cellRenderer: '', resizable: true,
             valueGetter: function (params) {
                 if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                     return capitalizeWords(params.data.truck_seal_entity)
                 }
             },
             headerClass: 'bold-header'
         },               
         {
             headerName: "Invoice Type" ,
             field: "invoice_type",
             colId: "invoice_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter:function (params) {
                 if(params.data.invoice_type !=="" && params.data.invoice_type !== undefined){
                     return (params.data.invoice_type ? capitalizeWords(params.data.invoice_type):"")
                 }
             }
         },
         {
             headerName: "Transporter",
             field: "transporter_name",
             colId: "transporter_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function (params) {
                 if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                     return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Source City" ,
             field: "consigner_city",
             colId: "consigner_city",
             width: 150,
             cellRenderer: '', resizable: true,
             valueGetter: function (params) {
                 if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                     return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                 }
             },
             headerClass: 'bold-header'
         },  
         {
             headerName: "Source Pincode" ,
             field: "consigner_pincode",
             colId: "consigner_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Source Zone" ,
             field: "consigner_zone",
             colId: "consigner_zone",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                     return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                 }
             },
         },
         {
             headerName: "Destination City" ,
             field: "consignee_city",
             colId: "consignee_city",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                     return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                 }
             },
         },
         {
             headerName: "Destination Pincode" ,
             field: "consignee_pincode",
             colId: "consignee_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Destination State" ,
             field: "consignee_state",
             colId: "consignee_state",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                     return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                 }
             },
         },
         {
             headerName: "Destination Zone",
             field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
             colId: "consignee_zone",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                     return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                 }
             },            
         },
         {
             headerName: "Mobile Number" ,
             field: "driver_mobile_no",
             colId: "driver_mobile_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Movement Type" ,
             field: "movement_type",
             colId: "movement_type",
 
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Total Weight",
             field: "lr_total_weight",
             colId: "total_weight",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
            
         },
         {
             headerName: "Total CBM",
             field: "lr_total_cbm",
             colId: "total_cbm",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
         },
         
         {
             headerName: "Transporter Category" ,
             field: "tpt_category",
             colId: "tpt_category",
             width: 190,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Vehicle Type" ,
             field: "truck_type",
             colId: "truck_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             
         },
         {
             headerName: "Truck Seal No" ,
             // hide: (tabName.value === "inactive"),
             field: "truck_seal_no",
             colId: "truck_seal_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "ODA",
             field: "oda",
             colId: "oda",
             width: 150,
             cellRenderer: '',
             headerClass: 'bold-header',
             resizable: true,
         },
         {
             headerName: "TAT" ,
             field: "transit_time",
             colId: "transit_time",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        
         // {
         //     headerName: "Reached Destination At",
         //     field: "recent_dealer_reported",
         //     colId: "recent_dealer_reported",
         //     width: 180,
         //     resizable: true,
         //     valueGetter: function (params) {
         //         if (params.data.status === 4 || params.data.status === 5) {
         //             // Use 'status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else if (params.data.consignment_status === "Delivered") {
         //             // Use 'consignment_status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else {
         //             // Default to empty string if neither condition is met
         //             return "";
         //         }
         //     }
         // },
         {
             headerName: "Event Location" ,
             field: "last_location",
             colId: "last_location",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.last_location != "" && params.data.last_location != undefined) {
                     return (params.data.last_location ? capitalizeWords(params.data.last_location):"")
                 }
             },
         },
         {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
         {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
           
         {
             headerName: "Expected ETA", // Estimated delivery date
             field: "expected_trip_end",
             colId: "expected_trip_end",
             width: 150,
             resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                 }
             },
             headerClass: 'bold-header'
 
         },
         
         {
             headerName: "Revised Estimated Delivery Date",
             field: "revised_trip_end",
             colId: "revised_trip_end",
             width: 240,
             // hide: (tabName.value === "inactive"),
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                 }
             },
             headerClass: 'bold-header'
         },
         // {
         //     headerName: "Actual Delivery Date",
         //     field: "recent_dealer_reported",
         //     width: 180,
         //     hide: (tabName.value === "inactive"),
         //     cellRenderer: '', resizable: true,
         //     comparator: dateComparator,
         //     valueGetter: function (params) {
         //         if (params.data.recent_dealer_reported != '' && params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported !== ' ') {
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         }
         //         else {
         //             return "NA";
         //         }
         //     },
         //     headerClass: 'bold-header'
         // },
         {
             headerName: "Performance" ,
             field: "ontime_status",
             colId: "ontime_status",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
              valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
         },
         {
             headerName: "Delay Days",
             field: "transit_delay_days",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                 const day = params.value;
                 if (day !== undefined && day !== null) {
                     // Convert hours to days and round to the nearest whole number
                     const days = day;  // Round to nearest whole number
                     return `${days}`;
                 }
                 return ''; // Return empty if no value
             }
         },
         
         {
             headerName: "Delay Days Bucket",
             field: "delay_days_bucket",
             colId: "delay_days_bucket",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
              valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
         },
         
         {
             headerName: "E-Way Bill No" ,
             field: "eway_bill_no",
             colId: "eway_bill_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         }, 
         {
             headerName: "Mode" ,
             field: "shipment_mode",
             colId: "shipment_mode",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                     return (params.data.shipment_mode ? capitalizeWords(params.data.shipment_mode):"")
                 }
             },
         },   
         {
             headerName: "Fuel Type" ,
             field: "fuel_type",
             colId: "fuel_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                     return (params.data.fuel_type ? capitalizeWords(params.data.fuel_type):"")
                 }
             },
         },
         {
             headerName: "No Of Boxes" ,
             field: "total_boxes",
             colId: "no_of_boxes",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        //  {
        //      headerName: "Reason" ,
        //      field: "remarks",
        //      colId: "remarks",
        //      width: 180,
        //      resizable: true,
        //      headerClass: 'bold-header',
        //      hide: showUndelivered,
        //      valueGetter: (params) => {
        //          return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //      },
             
        //      // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //      cellRenderer: (params) => {
        //          if (params.data.consignment_status === 'Undelivered') {
        //              return params.value; // Show the remark if status is 'Undelivered'
        //          }
        //          return ''; // Return empty string for other statuses
        //      },
             
        //      // hide: false
        //  },
         
     ]
     var activeDefs4 = [
       
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    let manual_tracking= param.data.manual_tracking;
                    
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const isDisabled = hasConsignmentStatus && 
                                       (param.data.consignment_status === "In Transit" || 
                                        param.data.consignment_status === "Dispatched from Source" || 
                                        param.data.consignment_status === "Out For Delivery" ||
                                        param.data.consignment_status === "Invalid docket");

                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute,
                                disabled: isDisabled // Set the disabled state based on the consignment status
                            }
                        };
                    }
                    if(hasConsignmentStatus){
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                            }
                        }
                    }
                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                        
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                            }
                        }
                    }

        
                  
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        }, 
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            // hide : (tabName.value == "inactive"),
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
            
                    // if ((hasConsignmentStatus) 
                    //     // && 
                    //     // (param.data.consignment_status === "In Transit" || param.data.consignment_status === "Dispatched from Source")
                    
                    // ) {                            
                    //     return {
                    //         component: CourierActions,
                    //         params: {
                    //             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //         }
                    //     }
                    // }
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "view_document",
            colId: "view_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            // hide: tabName.value !== 'active',
            cellRenderer: (param) => {
                const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        title="View Document"
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            cursor: "pointer" 
                        }}
                        disabled={!enableViewIcon}
                    >
                        <i className="fa fa-eye f17"></i> 
                    </button>
                );
            },
        },              
      
       //  {
       //      headerName: "",
       //      field: "sendemail",
       //      colId: "sendemail",
       //      width: 50,
       //      filter:false,
       //      // hide: (tabName.value !== 'active'),
       //      cellRenderer:SendEmail,
       //      filter: false,
       //      pinned: "left",
       //      cellRendererSelector: function (param) {
       //          try {
       //              if (param.data._id != null && param.data._id != undefined) {
       //                  // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
       //                      return {
       //                          component: SendEmail,
       //                          params: {
       //                              onClickEmail: onClickEmail
       //                          }
       //                      }
       //                  // }
       //                  // else{
       //                  // }
                       
       //              }
       //          } catch (err) {
       //              console.log(err);
       //          }
       //      },
       //      headerClass: 'bold-header'
       //  },
// actionables above
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            hide: (decode(localStorageRole)==="transporter"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        
        ,         
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
       
        
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
               
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                // Use consignmentStatus if available, otherwise map status number to text
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         const statusMap = {
            //             0: "Invoiced",
            //             1: "At Source",
            //             2: "In Transit",
            //             3: "Near Destination",
            //             4: "Delivered",
            //             5: "Left Dealer",
            //             6: "Force Closure",
            //             7: "Provision",
            //             8: "Trip Completed",
            //         };
        
            //         try {
            //             // Get current filter model and any previously selected filter values
            //             const currentFilterModel = params.api.getFilterModel();
            //             const selectedFilterValues = currentFilterModel?.status?.values || [];
        
            //             // Loop through all the nodes (visible after applying any filters)
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     let status;
            //                     if (typeof node.data.status === "number") {
            //                         status = statusMap[node.data.status];
            //                     } else {
            //                         status = node.data.status;
            //                     }
        
            //                     const consignmentStatus = node.data.consignment_status;
            //                     const statusText = consignmentStatus || status || "Not Available";
        
            //                     // Add the status to the Set to ensure uniqueness
            //                     // Only add if it's in the selected filter or no filter is applied
            //                     if (selectedFilterValues.length === 0 || selectedFilterValues.includes(statusText)) {
            //                         uniqueValues.add(statusText);
            //                     }
            //                 }
            //             });
        
            //             // Pass the unique status values (labels) to the filter dropdown
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: true, // Keep it as false to prevent unnecessary refresh on every dropdown open
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Trip Completed",
            //     };
        
            //     const consignmentStatus = params.data?.consignment_status;
            //     const status = params.data?.status;
        
            //     // Return consignmentStatus or map the status number to text
            //     return consignmentStatus || statusMap[status] || status || "Not Available";
            // }
        }
        
        
        
        
        ,
        
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        
        
        
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },   
         {
             headerName: "Undelivered Reason",
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status
                //  if (undelivered_reason && !["", 8, 5, "Delivered", "delivered", "DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         },
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status
                //  if (!["", undefined, null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered", "delivered", "DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },             
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const invoiceDate = params.data.invoice_time;
                if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== " " && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consginee_name",
            colId: "consginee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
               if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                   return capitalizeWords(params.data.consignee_name)
               }else{
                   return ""
               }
           },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:function (params) {
                if(params.data.invoice_type !=="" && params.data.invoice_type !== undefined){
                    return (params.data.invoice_type ? capitalizeWords(params.data.invoice_type):"")
                }
            }
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                }
            },
            headerClass: 'bold-header'
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                }
            },            
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",

            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
               // Ensure the value is a valid number
               const value = parseFloat(params.value);
               return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
           }
           
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
               // Ensure the value is a valid number
               const value = parseFloat(params.value);
               return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
           }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
           
        },
        {
            headerName: "Truck Seal No" ,
            // hide: (tabName.value === "inactive"),
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
       
        // {
        //     headerName: "Reached Destination At",
        //     field: "recent_dealer_reported",
        //     colId: "recent_dealer_reported",
        //     width: 180,
        //     resizable: true,
        //     valueGetter: function (params) {
        //         if (params.data.status === 4 || params.data.status === 5) {
        //             // Use 'status' logic
        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
        //         } else if (params.data.consignment_status === "Delivered") {
        //             // Use 'consignment_status' logic
        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
        //         } else {
        //             // Default to empty string if neither condition is met
        //             return "";
        //         }
        //     }
        // },
        {
            headerName: "Event Location" ,
            field: "last_location",
            colId: "last_location",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.last_location != "" && params.data.last_location != undefined) {
                    return (params.data.last_location ? capitalizeWords(params.data.last_location):"")
                }
            },
        },
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
       {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
          
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised Estimated Delivery Date",
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Actual Delivery Date",
        //     field: "recent_dealer_reported",
        //     width: 180,
        //     hide: (tabName.value === "inactive"),
        //     cellRenderer: '', resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: function (params) {
        //         if (params.data.recent_dealer_reported != '' && params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported !== ' ') {
        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
        //         }
        //         else {
        //             return "NA";
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
             valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return (params.data.shipment_mode ? capitalizeWords(params.data.shipment_mode):"")
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return (params.data.fuel_type ? capitalizeWords(params.data.fuel_type):"")
                }
            },
        },
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
        
    ]

     var allCodefs1 = [ 
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const disabledStatuses = [
                        "In Transit", 
                        "Dispatched from Source", 
                        "Invalid docket", 
                        "Out For Delivery", 
                        "Undelivered", 
                        "Booked", 
                        "Delivered", 
                        "Cancelled"
                    ];
                    
                    const isDisabled = hasConsignmentStatus && disabledStatuses.includes(param.data.consignment_status);
                    let manual_tracking = param.data.manual_tracking;
                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute,
                                disabled: isDisabled // Set the disabled state based on the consignment status
                            }
                        };
                    }
                    if(hasConsignmentStatus){
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                            }
                        }
                    }
                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                        
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");

            
                    // if (hasConsignmentStatus) {
                            
                    //         return {
                    //             component: CourierActions,
                    //             params: {
                    //                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //             }
                    //         }
                    // }
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },        
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "completed" || tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
      ...extraNotUserAllCol,
        {
            headerName: "",
            field: "view_document",
            colId: "view_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            // hide: tabName.value !== 'active' || tabName.value !== "all,",
            cellRenderer: (param) => {
                const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                const handleClick = (e) => {
                    e.stopPropagation();
                    onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        title="View Document"
                        disabled={!enableViewIcon}
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent"
                            // fontSize:"15px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            // cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-eye f17"></i> 
                    </button>
                );
            },
        },   
       ...extraNotUserAllPodCol,
        {
            headerName: "",
            field: "view_pod_document",
            colId: "view_pod_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                let enableViewIcon = ((param.data.hasOwnProperty('status') && param.data.status === 8 && param.data.hasOwnProperty("is_submitted_pod") && param.data.hasOwnProperty('uploaded_pod_document') && param.data.is_submitted_pod === 1) || (param.data.hasOwnProperty("consignment_status") && param.data.consignment_status === "Delivered" && param.data.hasOwnProperty('is_submitted_pod') && param.data.is_submitted_pod === 1 && param.data.hasOwnProperty('uploaded_pod_document'))) ;
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowPodDoc(param)
                    // onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        disabled={!enableViewIcon}
                        title="View POD Document"
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-file f17"></i> 
                    </button>
                );
            },
        },
      
        // {
        //     headerName: "",
        //     field: "sendemail",
        //     colId: "sendemail",
        //     width: 50,
        //     cellRenderer:SendEmail,
        //     filter: false,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
        //                     return {
        //                         component: SendEmail,
        //                         params: {
        //                             onClickEmail: onClickEmail
        //                         }
        //                     }
        //                 // }
        //                 // if(param.data.status === 4 || param.data.consignment_status === "Delivered"){
        //                 //     return {
        //                 //         component: SendEmail,
        //                 //         params: {
        //                 //             onClickEmail: onClickEmail
        //                 //         }
        //                 //     }
        //                 // }
                       
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },       
        // {
        //     headerName: "View Document",
        //     field: "view_document",
        //     width: 130,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     // hide: tabName.value !== 'active' || tabName.value !== "all",
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_document"));                
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View Document"
        //                 disabled={enableDocument}
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent"
        //                     // fontSize:"15px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     // cursor: "pointer" 
        //                 }}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // }, 
        // {
        //     headerName: "View POD Document",
        //     field: "view_pod_document",
        //     width: 160,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_pod_document"));                

        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             // if (!hasConsignmentStatus) {
        //             //     onShowDocs(param);  
        //             // }
        //             onShowPodDoc(param)
        //             // onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View POD Document"
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent",
        //                     fontSize:"12px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     cursor: "pointer" 
        //                 }}
        //                 disabled={enableDocument}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // },
                
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        ,
                 
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
        
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         0: "Invoiced",
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
            //                         4: "Delivered",
            //                         5: "Left Dealer",
            //                         6: "Force Closure",
            //                         7: "Provision",
            //                         8: "Delivered",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Delivered",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },
         {
             headerName: "Undelivered Reason" ,
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (undelivered_reason && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         }, 
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (!["",undefined,null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },                
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.invoice_type != "" && params.data.invoice_type != undefined) {
                    return capitalizeWords(params.data.invoice_type)
                }
            },
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return capitalizeWords(params.data.consigner_city)
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return capitalizeWords(params.data.consigner_zone)
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return capitalizeWords(params.data.consignee_city)
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return capitalizeWords(params.data.consignee_state)
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return capitalizeWords(params.data.consignee_zone)
                }
            },
           
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Truck Seal No" ,
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised Estimated Delivery Date",
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Actual Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', 
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                try {
                    
                            if (params.data.delivery_datetime && params.data.delivery_datetime.trim() !==""){
                                return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime)
                            }else{
                                return ""
                            }
                      
                } catch (err) {
                    console.log(err);
                    return ""; // In case of an error, return "NA"
                }
            },
            // editable: function (params) {
            //     // Make field editable only if role is 'admin'
            //     return decode(localStorageRole) === "admin";
            // },
            headerClass: 'bold-header'
        },
        
       
        // {
        //     headerName: "Delay Days Bucket" ,
        //     field: "delay_days_bucket",
        //     width: 180,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
            
        },
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return capitalizeWords(params.data.shipment_mode)
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return capitalizeWords(params.data.fuel_type)
                }
            },
        },
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
    ]
     var allCodefs2 = [ 
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const disabledStatuses = [
                        "In Transit", 
                        "Dispatched from Source", 
                        "Invalid docket", 
                        "Out For Delivery", 
                        "Undelivered", 
                        "Booked", 
                        "Delivered", 
                        "Cancelled"
                    ];
                    
                    const isDisabled = hasConsignmentStatus && disabledStatuses.includes(param.data.consignment_status);
                    let manual_tracking = param.data.manual_tracking;
                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute,
                                disabled: isDisabled // Set the disabled state based on the consignment status
                            }
                        };
                    }
                    if(hasConsignmentStatus){
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                            }
                        }
                    }
                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                        
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");

            
                    // if (hasConsignmentStatus) {
                            
                    //         return {
                    //             component: CourierActions,
                    //             params: {
                    //                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //             }
                    //         }
                    // }
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },        
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "completed" || tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_stoppages",
            colId: "show_stoppages",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowstoppagesIcon,
                            params: {
                                onShowStoppagesData: onShowStoppagesData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "update",
            colId: "update",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        let enableUpdateDetailIcon =  (((decodedRoleCase ==="transporter") || decodedRoleCase ==="user") || ([6, 11, 5, 8].includes(param.data.status) || ["Cancelled","Undelivered","Delivered"].includes(param.data.consignment_status)))
                        // if(tabName.value === "active" || tabName.value === "all"){
                            return {
                                component: UpdateConsignments,
                                params: {
                                    onClickActive: onClickActive,
                                    iconType: "edit",
                                    disabled: enableUpdateDetailIcon
                                }
                            };                           
                        // }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },
        {
            headerName: "",
            field: "edit_logs",
            colId: "edit_logs",
            width: 50,
            pinned: "left",
            filter:false,
            hide:(decodedRoleCase !== "admin"),
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        // if(tabName.value === "active"){
                            return {
                                component: EditLogsConsignments,
                                params: {
                                    onClickActive: onClickEditLogs,
                                    iconType: "edit",
                                    tooltip: "Edit Logs",
                                    disabled: (param.data.trip_edited ===0 || param.data.trip_edited === undefined || param.data.trip_edited ===null)

                                }
                            // };                           
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },
        {
            headerName: "",
            field: "update_tracking_status",
            colId: "update_tracking_status",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                        var disableIcon=(decodedRoleCase==="user") 
        
                        if (hasConsignmentStatus && param.data.consignment_status !=="Delivered") {                            
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: false // Disable the icon
                                }
                            };
                        }
                        if (hasConsignmentStatus && (param.data.consignment_status === "Delivered")) {                            
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: true 
                                }
                            };
                        }
                        
                        if (!hasConsignmentStatus && ([ 1, 2, 3, 4, 10].includes(param.data.status))) {
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: false || disableIcon
                                }
                            };
                        } 
                        if (!hasConsignmentStatus && ([5 ,6, 8,0, 11].includes(param.data.status))) {
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: true 
                                }
                            };
                        }                        
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        }, 
        {
            headerName: "",
            field: "upload_document",
            colId: "upload_document",
            width: 60,
            filter: false,
            pinned:"left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                // const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                let isDisabledUploadDoc = (decodedRoleCase==='user' || [5, 6, 8, 11].includes(param.data.status) || ["Delivered","Cancelled","Undelivered"].includes(param.data.consignment_status))
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus && isDisabledUploadDoc) {
                        onShowUploadDoc(param); 
                    // }
                    //  else {
                    //     if(isDisabledUploadDoc)
                    //         onClickUploadPOD(param)
                    // }
                };
                
                return (
                    <button 
                        onClick={handleClick} 
                        // title={hasConsignmentStatus ? "Upload Document (Disabled)" : "Upload Document"}
                        title="Upload Document"
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            pointerEvents: isDisabledUploadDoc ? "none" : "auto", 
                            opacity: isDisabledUploadDoc ? 0.5 : 1, 
                            // cursor: (hasConsignmentStatus && param.data.consignment_status === "Delivered") || (!hasConsignmentStatus && (param.data.status === 4 || param.data.status === 6)) ? "not-allowed" : "pointer" ,
                            // cursor: "pointer" 
                        }}
                        disabled={isDisabledUploadDoc}
                    >
                        <i className="icofont icofont-upload-alt f17" style={{ fontSize:"12px",color: isDisabledUploadDoc? "grey":"#3a3fa6" }}></i>
                    </button>
                );
            },
        },
        {
            headerName: "",
            field: "view_document",
            colId: "view_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            // hide: tabName.value !== 'active' || tabName.value !== "all,",
            cellRenderer: (param) => {
                const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                const handleClick = (e) => {
                    e.stopPropagation();
                    onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        title="View Document"
                        disabled={!enableViewIcon}
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent"
                            // fontSize:"15px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            // cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-eye f17"></i> 
                    </button>
                );
            },
        },   
        {
            headerName: "",
            field: "upload_pod",
            colId: "upload_pod",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const isDisable = (decodedRoleCase==="user") || (hasConsignmentStatus  && (["Cancelled","Dispatched from Source","Arrived At Destination","In Transit","Out For Delivery","Undelivered","Booked"].includes(param.data.consignment_status) || param.data.is_submitted_pod ===1 ))
                    const isDisable1 = (!hasConsignmentStatus &&  ([0,1,2,3,4,6,8,10].includes(param.data.status) || param.data.is_submitted_pod ===1)) || decodedRoleCase==="user"
                    if (hasConsignmentStatus) {                         
                        return {
                            component: uploadPOD,
                            params: {
                                onClickUploadPOD: onClickUploadPOD,
                                isSubmittedPOD: param.data.is_submitted_pod,
                                disabled: isDisable
                            }
                        }
                    }
                    
                    if (!hasConsignmentStatus) {
                        return {
                            component: uploadPOD,
                            params: {
                                onClickUploadPOD: onClickUploadPOD,
                                isSubmittedPOD: param.data.is_submitted_pod,
                                disabled: isDisable1

                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
        },
        {
            headerName: "",
            field: "view_pod_document",
            colId: "view_pod_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                let enableViewIcon = ((param.data.hasOwnProperty('status') && param.data.status === 8 && param.data.hasOwnProperty("is_submitted_pod") && param.data.hasOwnProperty('uploaded_pod_document') && param.data.is_submitted_pod === 1) || (param.data.hasOwnProperty("consignment_status") && param.data.consignment_status === "Delivered" && param.data.hasOwnProperty('is_submitted_pod') && param.data.is_submitted_pod === 1 && param.data.hasOwnProperty('uploaded_pod_document'))) ;
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowPodDoc(param)
                    // onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        disabled={!enableViewIcon}
                        title="View POD Document"
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-file f17"></i> 
                    </button>
                );
            },
        },
        // {
        //     headerName: "",
        //     field: "cancel_order",
        //     colId: "cancel_order",
        //     width: 50,
        //     pinned: "left",
        //     filter:false,
        //     cellRendererSelector: function (param) {
        //         try {
        //             const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
        //             var disableIcon= decodedRoleCase==="user";
        //             const hasLrNo = param.data.hasOwnProperty("lr_no");
        //             const isConditionMet = (hasConsignmentStatus || hasLrNo) && 
        //                                    (param.data.consignment_status === "In Transit" || 
        //                                     param.data.consignment_status === "Dispatched from Source" || 
        //                                     param.data.consignment_status === "Invalid docket" ||
        //                                     param.data.consignment_status === "Booked");
        //             if (isConditionMet) {
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onClickCancelActiveCourierConsignemnts,
        //                         disabled: false || disableIcon,
        //                         tracking_type: "PTL1"
        //                     }
        //                 };
        //             }
        //             if(hasConsignmentStatus && ([ "Delivered", "Undelivered","Cancelled"].includes(param.data.consignment_status))){
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onClickCancelActiveCourierConsignemnts,
        //                         disabled: true ,
        //                         tracking_type: "PTL"
        //                     }
        //                 };
        //             }
        //             else if([5, 6, 8, 11].includes(param.data.status)){
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onShowForceCloseModal,
        //                         disabled: true ,
        //                         tracking_type: "FTL"
        //                     }
        //                 };
        //             }
        //             else {
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onShowForceCloseModal,
        //                         tracking_type: "FTL",
        //                         disabled: disableIcon
        //                     }
        //                 };
        //             }
        
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },
         {
             headerName: "",
             field: "cancel_order",
             colId: "cancel_order",
             width: 50,
             pinned: "left",
             filter: false,
             cellRendererSelector: function (param) {
                 try {
                     const data = param.data || {};
                     const hasShipment = !!data.shipment_id;
                     const createdTime = data.created_at ? new Date(data.created_at) : null;
                     const diffMins = createdTime ? (new Date() - createdTime) / 60000 : 9999;
                     const userRole = (decodedRoleCase || "").toLowerCase();
                     const disableIcon = userRole === "user";

                     // Detect tracking type
                     const tracking_type = data.tracking_type
                         ? data.tracking_type.toUpperCase()
                         : "FTL";

                     // 15 min visibility rule
                     const showButton =
                         userRole === "admin" ||
                         (["transporter", "warehouse"].includes(userRole) &&
                             hasShipment &&
                             diffMins <= 15);

                     // Block button for delivered / undelivered / cancelled
                     if (
                         data.consignment_status &&
                         ["Delivered", "Undelivered", "Cancelled"].includes(data.consignment_status)
                     ) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onClickCancelActiveCourierConsignemnts,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     // Disable for status codes 5,6,8,11
                     if ([5, 6, 8, 11].includes(data.status)) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     // Default case: allow based on timing and role
                     if (showButton) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type, // this goes to modal for fetching invoices
                                 disabled: disableIcon,
                             },
                         };
                     }

                     return null;
                 } catch (err) {
                     console.error("All Tabs cancel_order error:", err);
                     return null;
                 }
             },
             cellStyle: {
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 cursor: "pointer",
             },
             headerClass: "bold-header",
         },



        // {
        //     headerName: "",
        //     field: "sendemail",
        //     colId: "sendemail",
        //     width: 50,
        //     cellRenderer:SendEmail,
        //     filter: false,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
        //                     return {
        //                         component: SendEmail,
        //                         params: {
        //                             onClickEmail: onClickEmail
        //                         }
        //                     }
        //                 // }
        //                 // if(param.data.status === 4 || param.data.consignment_status === "Delivered"){
        //                 //     return {
        //                 //         component: SendEmail,
        //                 //         params: {
        //                 //             onClickEmail: onClickEmail
        //                 //         }
        //                 //     }
        //                 // }
                       
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },       
        // {
        //     headerName: "View Document",
        //     field: "view_document",
        //     width: 130,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     // hide: tabName.value !== 'active' || tabName.value !== "all",
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_document"));                
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View Document"
        //                 disabled={enableDocument}
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent"
        //                     // fontSize:"15px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     // cursor: "pointer" 
        //                 }}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // }, 
        // {
        //     headerName: "View POD Document",
        //     field: "view_pod_document",
        //     width: 160,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_pod_document"));                

        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             // if (!hasConsignmentStatus) {
        //             //     onShowDocs(param);  
        //             // }
        //             onShowPodDoc(param)
        //             // onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View POD Document"
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent",
        //                     fontSize:"12px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     cursor: "pointer" 
        //                 }}
        //                 disabled={enableDocument}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // },
                
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        ,
                 
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         0: "Invoiced",
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
            //                         4: "Delivered",
            //                         5: "Left Dealer",
            //                         6: "Force Closure",
            //                         7: "Provision",
            //                         8: "Delivered",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Delivered",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },  
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         }, 
         {
             headerName: "Undelivered Reason",
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status
                //  if (undelivered_reason && !["", 8, 5, "Delivered", "delivered", "DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         },
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status
                //  if (!["", undefined, null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered", "delivered", "DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },              
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
             headerName: "Event Updated At",
             field: "last_event_dt",
             colId: "last_event_dt",
             width: 160,
             cellRenderer: '',
             resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const lastEventDate = params.data.last_event_dt;
                 return getHyphenDDMMMYYYYHHMM(lastEventDate);
             },
             headerClass: 'bold-header'
         },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.invoice_type != "" && params.data.invoice_type != undefined) {
                    return capitalizeWords(params.data.invoice_type)
                }
            },
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return capitalizeWords(params.data.consigner_city)
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return capitalizeWords(params.data.consigner_zone)
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return capitalizeWords(params.data.consignee_city)
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return capitalizeWords(params.data.consignee_state)
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return capitalizeWords(params.data.consignee_zone)
                }
            },
           
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Truck Seal No" ,
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        // {
        //     headerName: "TAT" ,
        //     field: "transit_time",
        //     colId: "transit_time",
        //     // hide: (tabName.value === "inactive"),
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Basic TAT" ,
            field: "basic_tat",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Buffer days" ,
            field: "total_buffer_days",
            width: 170,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Final TAT" ,
            field: "final_tat",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        // {
        //     headerName: "Last Data Received On",
        //     field: "last_process_on",
        //     colId: "last_process_on",
        //     width: 200,
        //     cellRenderer: '',
        //     resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: (params) => {
        //          if (params.data.accessed_api_at) {
        //              return params.data.accessed_api_at ? getHyphenDDMMMYYYYHHMM(params.data.accessed_api_at) : "NA";
        //          }
        //          else {
        //              return params.data.last_process_on ? getHyphenDDMMMYYYYHHMM(params.data.last_process_on) : "NA";
        //          }
        //      },
        //     // valueGetter: function (params) {
        //     //     const { data: { tracking_type, truck_no, last_process_on } } = params;
        
        //     //     if (tracking_type === "FTL") {
        //     //         const truckLocation = truckLocations?.find(location => location.truck_no === truck_no);
        //     //         return truckLocation?.latest_sim_packet 
        //     //             ? getHyphenDDMMMYYYYHHMM(truckLocation.latest_sim_packet)
        //     //             : "NA";
        //     //     } 
        
        //     //     if (tracking_type === "PTL") {
        //     //         return last_process_on 
        //     //             ? getHyphenDDMMMYYYYHHMM(last_process_on)
        //     //             : "NA";
        //     //     }
        
        //     //     return "NA";
        //     // },
        //     headerClass: 'bold-header',
        // }
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },  
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised ETA", //"Revised Estimated Delivery Date",(neeraj asked to change 04/06/26)
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Customer Promise Date",
            field: "final_eta_dt",
           
            width: 180,
            resizable: true,
            comparator: dateComparator,
            comparator: dateComparator,
            valueGetter: (params) => {
                return params.data.final_eta_dt ? getHyphenDDMMMYYYYHHMM(params.data.final_eta_dt) : "";
            },
            headerClass: 'bold-header',

        },
        // {
        //     headerName: "Actual Delivery Date",
        //     field: "delivery_datetime",
        //     colId: "delivery_datetime",
        //     width: 180,
        //     // hide: (tabName.value === "inactive"),
        //     cellRenderer: '', 
        //     resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: function (params) {
        //         try {
                    
        //                     if (params.data.delivery_datetime && params.data.delivery_datetime.trim() !==""){
        //                         return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime)
        //                     }else{
        //                         return ""
        //                     }
                      
        //         } catch (err) {
        //             console.log(err);
        //             return ""; // In case of an error, return "NA"
        //         }
        //     },
        //     // editable: function (params) {
        //     //     // Make field editable only if role is 'admin'
        //     //     return decode(localStorageRole) === "admin";
        //     // },
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            filter: "agSetColumnFilter",
            filterParams: {
                excelMode: "windows",   
                buttons: [],            
                closeOnApply: true,
                includeBlanksInFilter: true
            },  
            headerClass: "bold-header",
            valueGetter: function (params) {
                try {
                    const data = params.data;

                    const consStatus = data.consignment_status;
                    const status = data.status;

                    const statusText = consStatus || statusMap?.[status] || status;

                    if (data.tracking_type === "FTL" && statusText === "Out For Delivery") {
                        return "";
                    }

                    if (data.delivery_datetime && data.delivery_datetime.trim() !== "") {
                        return getHyphenDDMMMYYYYHHMM(data.delivery_datetime);
                    } else {
                        return "";
                    }

                } catch (err) {
                    console.log(err);
                    return "";
                }
            }

        },
         {
             headerName: "Late Delivery Remarks",
             field: "late_delivery_remarks",
             width: 200,
             resizable: true,
             editable: true,
             cellEditor: 'agTextCellEditor',
             headerClass: 'bold-header',
             valueGetter: (params) => {
                 return params.data.late_delivery_remarks || "";
             }
         },
        // {
        //     headerName: "Delay Days Bucket" ,
        //     field: "delay_days_bucket",
        //     width: 180,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return capitalizeWords(params.data.shipment_mode)
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return capitalizeWords(params.data.fuel_type)
                }
            },
        },
        {
            headerName: "No Of Boxes" ,
            field: "no_of_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
    ]
    var allCodefs3 = [ 
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const disabledStatuses = [
                        "In Transit", 
                        "Dispatched from Source", 
                        "Invalid docket", 
                        "Out For Delivery", 
                        "Undelivered", 
                        "Booked", 
                        "Delivered", 
                        "Cancelled"
                    ];
                    
                    const isDisabled = hasConsignmentStatus && disabledStatuses.includes(param.data.consignment_status);
                    let manual_tracking = param.data.manual_tracking;
                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute,
                                disabled: isDisabled // Set the disabled state based on the consignment status
                            }
                        };
                    }
                    if(hasConsignmentStatus){
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                            }
                        }
                    }
                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                        
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");

            
                    // if (hasConsignmentStatus) {
                            
                    //         return {
                    //             component: CourierActions,
                    //             params: {
                    //                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //             }
                    //         }
                    // }
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },        
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "completed" || tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_stoppages",
            colId: "show_stoppages",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowstoppagesIcon,
                            params: {
                                onShowStoppagesData: onShowStoppagesData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "update",
            colId: "update",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        let enableUpdateDetailIcon =  (((decodedRoleCase ==="transporter") || decodedRoleCase ==="user") || ([6, 11, 5, 8].includes(param.data.status) || ["Cancelled", "Undelivered", "Delivered"].includes(param.data.consignment_status)))
                        // if(tabName.value === "active" || tabName.value === "all"){
                            return {
                                component: UpdateConsignments,
                                params: {
                                    onClickActive: onClickActive,
                                    iconType: "edit",
                                    disabled: enableUpdateDetailIcon
                                }
                            };                           
                        // }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },
       
        {
            headerName: "",
            field: "update_tracking_status",
            colId: "update_tracking_status",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                        var disableIcon=(decodedRoleCase==="user")
        
                        if (hasConsignmentStatus && param.data.consignment_status !=="Delivered") {                            
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: false // Disable the icon
                                }
                            };
                        }
                        if (hasConsignmentStatus && (param.data.consignment_status === "Delivered")) {                            
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: true 
                                }
                            };
                        }
                        
                        if (!hasConsignmentStatus && ( [1, 2, 3,4,10].includes(param.data.status))) {
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: false || disableIcon
                                }
                            };
                        } 
                        if (!hasConsignmentStatus && ([5, 6, 8, 11, 0].includes(param.data.status))) {
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: updateDeliveredDate,
                                    iconType: "tracking",
                                    disabled: true 
                                }
                            };
                        }                        
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        }, 
        {
            headerName: "",
            field: "upload_document",
            colId: "upload_document",
            width: 60,
            filter: false,
            pinned:"left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                // const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                let isDisabledUploadDoc = (decodedRoleCase==='user' || [5, 6, 8, 11].includes(param.data.status) || ["Delivered" , "Cancelled", "Undelivered"].includes(param.data.consignment_status))
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus && isDisabledUploadDoc) {
                        onShowUploadDoc(param); 
                    // }
                    //  else {
                    //     if(isDisabledUploadDoc)
                    //         onClickUploadPOD(param)
                    // }
                };
                
                return (
                    <button 
                        onClick={handleClick} 
                        // title={hasConsignmentStatus ? "Upload Document (Disabled)" : "Upload Document"}
                        title="Upload Document"
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            pointerEvents: isDisabledUploadDoc ? "none" : "auto", 
                            opacity: isDisabledUploadDoc ? 0.5 : 1, 
                            // cursor: (hasConsignmentStatus && param.data.consignment_status === "Delivered") || (!hasConsignmentStatus && (param.data.status === 4 || param.data.status === 6)) ? "not-allowed" : "pointer" ,
                            // cursor: "pointer" 
                        }}
                        disabled={isDisabledUploadDoc}
                    >
                        <i className="icofont icofont-upload-alt f17" style={{ fontSize:"12px",color: isDisabledUploadDoc? "grey":"#3a3fa6" }}></i>
                    </button>
                );
            },
        },
        {
            headerName: "",
            field: "view_document",
            colId: "view_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            // hide: tabName.value !== 'active' || tabName.value !== "all,",
            cellRenderer: (param) => {
                const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                const handleClick = (e) => {
                    e.stopPropagation();
                    onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        title="View Document"
                        disabled={!enableViewIcon}
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent"
                            // fontSize:"15px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            // cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-eye f17"></i> 
                    </button>
                );
            },
        },   
        {
            headerName: "",
            field: "upload_pod",
            colId: "upload_pod",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const isDisable = (decodedRoleCase==="user") || (hasConsignmentStatus  && (["Cancelled","Dispatched from Source" ,"Arrived At Destination" ,"In Transit" ,"Out For Delivery" ,"Undelivered"].includes(param.data.consignment_status) || param.data.is_submitted_pod ===1 || param.data.consignment_status ==="Booked"))
                    const isDisable1 = (!hasConsignmentStatus &&  ([6, 1 , 2 , 3 ,8, 4, 11].includes(param.data.status) || param.data.is_submitted_pod ===1)) || decodedRoleCase==="user"
                    if (hasConsignmentStatus) {                         
                        return {
                            component: uploadPOD,
                            params: {
                                onClickUploadPOD: onClickUploadPOD,
                                isSubmittedPOD: param.data.is_submitted_pod,
                                disabled: isDisable
                            }
                        }
                    }
                    
                    if (!hasConsignmentStatus) {
                        return {
                            component: uploadPOD,
                            params: {
                                onClickUploadPOD: onClickUploadPOD,
                                isSubmittedPOD: param.data.is_submitted_pod,
                                disabled: isDisable1

                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
        },
        {
            headerName: "",
            field: "view_pod_document",
            colId: "view_pod_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                let enableViewIcon = ((param.data.hasOwnProperty('status') && param.data.status === 8 && param.data.hasOwnProperty("is_submitted_pod") && param.data.hasOwnProperty('uploaded_pod_document') && param.data.is_submitted_pod === 1) || (param.data.hasOwnProperty("consignment_status") && param.data.consignment_status === "Delivered" && param.data.hasOwnProperty('is_submitted_pod') && param.data.is_submitted_pod === 1 && param.data.hasOwnProperty('uploaded_pod_document'))) ;
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowPodDoc(param)
                    // onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        disabled={!enableViewIcon}
                        title="View POD Document"
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-file f17"></i> 
                    </button>
                );
            },
        },
        // {
        //     headerName: "",
        //     field: "cancel_order",
        //     colId: "cancel_order",
        //     width: 50,
        //     pinned: "left",
        //     filter:false,
        //     cellRendererSelector: function (param) {
        //         try {
        //             const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
        //             var disableIcon= decodedRoleCase==="user";
        //             const hasLrNo = param.data.hasOwnProperty("lr_no");
        //             const isConditionMet = (hasConsignmentStatus || hasLrNo) && 
        //                                    (param.data.consignment_status === "In Transit" || 
        //                                     param.data.consignment_status === "Dispatched from Source" || 
        //                                     param.data.consignment_status === "Invalid docket" ||
        //                                     param.data.consignment_status === "Booked");
        //             if (isConditionMet) {
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onClickCancelActiveCourierConsignemnts,
        //                         disabled: false || disableIcon,
        //                         tracking_type: "PTL1"
        //                     }
        //                 };
        //             }
        //             if(hasConsignmentStatus && (param.data.consignment_status === "Delivered" || param.data.consignment_status === "Cancelled")){
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onClickCancelActiveCourierConsignemnts,
        //                         disabled: true ,
        //                         tracking_type: "PTL"
        //                     }
        //                 };
        //             }
        //             else if( param.data.status === 4 || param.data.status === 6 || param.data.status==8){
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onShowForceCloseModal,
        //                         disabled: true ,
        //                         tracking_type: "FTL"
        //                     }
        //                 };
        //             }
        //             else {
        //                 return {
        //                     component: CancelCourierConsignments,
        //                     params: {
        //                         onClickActive: onShowForceCloseModal,
        //                         tracking_type: "FTL",
        //                         disabled: disableIcon
        //                     }
        //                 };
        //             }
        
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        //     headerClass: 'bold-header'
        // },
        // {
        //     headerName: "",
        //     field: "sendemail",
        //     colId: "sendemail",
        //     width: 50,
        //     cellRenderer:SendEmail,
        //     filter: false,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
        //                     return {
        //                         component: SendEmail,
        //                         params: {
        //                             onClickEmail: onClickEmail
        //                         }
        //                     }
        //                 // }
        //                 // if(param.data.status === 4 || param.data.consignment_status === "Delivered"){
        //                 //     return {
        //                 //         component: SendEmail,
        //                 //         params: {
        //                 //             onClickEmail: onClickEmail
        //                 //         }
        //                 //     }
        //                 // }
                       
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },       
        // {
        //     headerName: "View Document",
        //     field: "view_document",
        //     width: 130,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     // hide: tabName.value !== 'active' || tabName.value !== "all",
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_document"));                
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View Document"
        //                 disabled={enableDocument}
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent"
        //                     // fontSize:"15px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     // cursor: "pointer" 
        //                 }}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // }, 
        // {
        //     headerName: "View POD Document",
        //     field: "view_pod_document",
        //     width: 160,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_pod_document"));                

        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             // if (!hasConsignmentStatus) {
        //             //     onShowDocs(param);  
        //             // }
        //             onShowPodDoc(param)
        //             // onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View POD Document"
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent",
        //                     fontSize:"12px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     cursor: "pointer" 
        //                 }}
        //                 disabled={enableDocument}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // },
         {
             headerName: "",
             field: "cancel_order",
             colId: "cancel_order",
             width: 50,
             pinned: "left",
             filter: false,
             cellRendererSelector: function (param) {
                 try {
                     const data = param.data || {};
                     const hasShipment = !!data.shipment_id;
                     const userRole = (decodedRoleCase || "").toLowerCase();
                     const tracking_type = data.tracking_type
                         ? data.tracking_type.toUpperCase()
                         : "FTL";

                     const formattedDate = getHyphenDDMMMYYYYHHMM(data.created_date);
                     let createdTime = null;

                     if (formattedDate && formattedDate !== "Invalid Date") {
                         const match = formattedDate.match(
                             /(\d{1,2})-([A-Za-z]{3})-(\d{4}) (\d{1,2}):(\d{2})/
                         );
                         if (match) {
                             const [_, day, mon, year, hour, minute] = match;
                             const months = {
                                 Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                                 Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
                             };
                             createdTime = new Date(
                                 parseInt(year),
                                 months[mon],
                                 parseInt(day),
                                 parseInt(hour),
                                 parseInt(minute),
                                 0
                             );
                         }
                     }

                     const now = new Date();
                     const expiryTime =
                         createdTime instanceof Date && !isNaN(createdTime)
                             ? new Date(createdTime.getTime() + 24 * 60 * 60 * 1000)
                             : null;

                     const within15Mins =
                         expiryTime &&
                         createdTime &&
                         now.getTime() >= createdTime.getTime() &&
                         now.getTime() <= expiryTime.getTime();

                     console.log(
                         `LR: ${data.lr_no || "-"} | Formatted: ${formattedDate} | Created: ${createdTime ? createdTime.toLocaleString() : "Invalid"
                         } | Expiry(+15m): ${expiryTime ? expiryTime.toLocaleString() : "Invalid"
                         } | Now: ${now.toLocaleString()} | Within15Mins: ${within15Mins}`
                     );

                     if (
                         data.consignment_status &&
                         ["Delivered", "Undelivered", "Cancelled"].includes(
                             data.consignment_status
                         )
                     ) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onClickCancelActiveCourierConsignemnts,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     if ([5, 6, 8, 11].includes(data.status)) {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: true,
                             },
                         };
                     }

                     if (userRole === "admin") {
                         return {
                             component: CancelCourierConsignments,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: false,
                             },
                         };
                     }

                     if (userRole === "transporter" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 // disabled until creation time passes, or after 15 min expires
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }

                     if (userRole === "warehouse" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }
                     if (userRole === "wh-outbound" && hasShipment) {
                         const isBeforeCreation =
                             createdTime && now.getTime() < createdTime.getTime();

                         return {
                             component: CancelLr,
                             params: {
                                 onClickActive: onShowForceCloseModal,
                                 tracking_type,
                                 disabled: isBeforeCreation || !within15Mins,
                             },
                         };
                     }

                     return null;
                 } catch (err) {
                     console.error("All Tabs cancel_order error:", err);
                     return null;
                 }
             },

             cellStyle: {
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 cursor: "pointer",
             },
             headerClass: "bold-header",
         },       
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        ,
                 
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
               
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         0: "Invoiced",
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
            //                         4: "Delivered",
            //                         5: "Left Dealer",
            //                         6: "Force Closure",
            //                         7: "Provision",
            //                         8: "Delivered",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Delivered",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },   
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         }, 
         {
             headerName: "Undelivered Reason" ,
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (undelivered_reason && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         }, 
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status 
                //  if (!["",undefined,null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered","delivered","DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },             
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                }
            },
           
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Truck Seal No" ,
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },   
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised Estimated Delivery Date",
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Actual Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', 
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                try {
                    
                            if (params.data.delivery_datetime && params.data.delivery_datetime.trim() !==""){
                                return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime)
                            }else{
                                return ""
                            }
                      
                } catch (err) {
                    console.log(err);
                    return ""; // In case of an error, return "NA"
                }
            },
            // editable: function (params) {
            //     // Make field editable only if role is 'admin'
            //     return decode(localStorageRole) === "admin";
            // },
            headerClass: 'bold-header'
        },
        
       
        // {
        //     headerName: "Delay Days Bucket" ,
        //     field: "delay_days_bucket",
        //     width: 180,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
             valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return (params.data.shipment_mode ? capitalizeWords(params.data.shipment_mode):"")
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return (params.data.fuel_type ? capitalizeWords(params.data.fuel_type):"")
                }
            },
        },
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
    ]
    var allCodefs4 = [ 
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const disabledStatuses = [
                        "In Transit", 
                        "Dispatched from Source", 
                        "Invalid docket", 
                        "Out For Delivery", 
                        "Undelivered", 
                        "Booked", 
                        "Delivered", 
                        "Cancelled"
                    ];
                    
                    const isDisabled = hasConsignmentStatus && disabledStatuses.includes(param.data.consignment_status);
                    let manual_tracking = param.data.manual_tracking;
                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking===null)){
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute,
                                disabled: isDisabled // Set the disabled state based on the consignment status
                            }
                        };
                    }
                    if(hasConsignmentStatus){
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                            }
                        }
                    }
                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                        
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");

            
                    // if (hasConsignmentStatus) {
                            
                    //         return {
                    //             component: CourierActions,
                    //             params: {
                    //                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //             }
                    //         }
                    // }
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },        
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "completed" || tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
       
        {
            headerName: "",
            field: "view_document",
            colId: "view_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            // hide: tabName.value !== 'active' || tabName.value !== "all,",
            cellRenderer: (param) => {
                const enableViewIcon = param.data.hasOwnProperty("uploaded_document") || param.data.hasOwnProperty("is_submitted_loading_document") || param.data.hasOwnProperty("is_submitted_unloading_document");                
                const handleClick = (e) => {
                    e.stopPropagation();
                    onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        title="View Document"
                        disabled={!enableViewIcon}
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent"
                            // fontSize:"15px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            // cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-eye f17"></i> 
                    </button>
                );
            },
        },   
       
        {
            headerName: "",
            field: "view_pod_document",
            colId: "view_pod_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                let enableViewIcon = ((param.data.hasOwnProperty('status') && param.data.status === 8 && param.data.hasOwnProperty("is_submitted_pod") && param.data.hasOwnProperty('uploaded_pod_document') && param.data.is_submitted_pod === 1) || (param.data.hasOwnProperty("consignment_status") && param.data.consignment_status === "Delivered" && param.data.hasOwnProperty('is_submitted_pod') && param.data.is_submitted_pod === 1 && param.data.hasOwnProperty('uploaded_pod_document'))) ;
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowPodDoc(param)
                    // onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        disabled={!enableViewIcon}
                        title="View POD Document"
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-file f17"></i> 
                    </button>
                );
            },
        },
      
        // {
        //     headerName: "",
        //     field: "sendemail",
        //     colId: "sendemail",
        //     width: 50,
        //     cellRenderer:SendEmail,
        //     filter: false,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
        //                     return {
        //                         component: SendEmail,
        //                         params: {
        //                             onClickEmail: onClickEmail
        //                         }
        //                     }
        //                 // }
        //                 // if(param.data.status === 4 || param.data.consignment_status === "Delivered"){
        //                 //     return {
        //                 //         component: SendEmail,
        //                 //         params: {
        //                 //             onClickEmail: onClickEmail
        //                 //         }
        //                 //     }
        //                 // }
                       
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },       
        // {
        //     headerName: "View Document",
        //     field: "view_document",
        //     width: 130,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     // hide: tabName.value !== 'active' || tabName.value !== "all",
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_document"));                
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View Document"
        //                 disabled={enableDocument}
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent"
        //                     // fontSize:"15px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     // cursor: "pointer" 
        //                 }}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // }, 
        // {
        //     headerName: "View POD Document",
        //     field: "view_pod_document",
        //     width: 160,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_pod_document"));                

        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             // if (!hasConsignmentStatus) {
        //             //     onShowDocs(param);  
        //             // }
        //             onShowPodDoc(param)
        //             // onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View POD Document"
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent",
        //                     fontSize:"12px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     cursor: "pointer" 
        //                 }}
        //                 disabled={enableDocument}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // },
                
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        ,
                 
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
        
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         0: "Invoiced",
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
            //                         4: "Delivered",
            //                         5: "Left Dealer",
            //                         6: "Force Closure",
            //                         7: "Provision",
            //                         8: "Delivered",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Delivered",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },
         {
             headerName: "Undelivered Reason",
             field: "un_delivery_remark",
             colId: "un_delivery_remark",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const undelivered_reason = params.data.un_delivery_remark
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status
                //  if (undelivered_reason && !["", 8, 5, "Delivered", "delivered", "DELIVERED"].includes(delivered_status)) {
                if (!["",undefined,null].includes(undelivered_reason)) {
                     return undelivered_reason || "NA"
                 } else {
                     return "NA";
                 }
             },
         },
         {
             headerName: "Undelivered Timestamp",
             field: "un_delivery_datetime",
             colId: "un_delivery_datetime",
             width: 200,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const undelivered_timestamp = params.data.un_delivery_datetime;
                 const consignmentStatus = params.data?.consignment_status;
                 const status = params.data?.status;
                 const delivered_status = consignmentStatus || statusMap[status] || status
                //  if (!["", undefined, null].includes(undelivered_timestamp) && !["", 8, 5, "Delivered", "delivered", "DELIVERED"].includes(delivered_status)) {
                 if (!["",undefined,null].includes(undelivered_timestamp)) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(undelivered_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "NA";
                 }
             },
             headerClass: 'bold-header'
         },                
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
             headerName: "Event Updated At",
             field: "last_event_dt",
             colId: "last_event_dt",
             width: 160,
             cellRenderer: '',
             resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const lastEventDate = params.data.last_event_dt;
                 return getHyphenDDMMMYYYYHHMM(lastEventDate);
             },
             headerClass: 'bold-header'
         },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.invoice_type != "" && params.data.invoice_type != undefined) {
                    return capitalizeWords(params.data.invoice_type)
                }
            },
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return capitalizeWords(params.data.consigner_city)
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return capitalizeWords(params.data.consigner_zone)
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return capitalizeWords(params.data.consignee_city)
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return capitalizeWords(params.data.consignee_state)
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return capitalizeWords(params.data.consignee_zone)
                }
            },
           
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Truck Seal No" ,
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "Basic TAT" ,
            field: "basic_tat",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Buffer days" ,
            field: "total_buffer_days",
            width: 170,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
       {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },   
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised Estimated Delivery Date",
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Customer Promise Date",
            field: "final_eta_dt",
           
            width: 180,
            resizable: true,
            comparator: dateComparator,
            comparator: dateComparator,
            valueGetter: (params) => {
                return params.data.final_eta_dt ? getHyphenDDMMMYYYYHHMM(params.data.final_eta_dt) : "";
            },
            headerClass: 'bold-header',

        },
        {
            headerName: "Actual Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', 
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                try {
                    
                            if (params.data.delivery_datetime && params.data.delivery_datetime.trim() !==""){
                                return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime)
                            }else{
                                return ""
                            }
                      
                } catch (err) {
                    console.log(err);
                    return ""; // In case of an error, return "NA"
                }
            },
            // editable: function (params) {
            //     // Make field editable only if role is 'admin'
            //     return decode(localStorageRole) === "admin";
            // },
            headerClass: 'bold-header'
        },
        {
             headerName: "Late Delivery Remarks",
             field: "late_delivery_remarks",
             width: 200,
             resizable: true,
             editable: true,
             cellEditor: 'agTextCellEditor',
             headerClass: 'bold-header',
             valueGetter: (params) => {
                 return params.data.late_delivery_remarks || "";
             }
         },
        
       
        // {
        //     headerName: "Delay Days Bucket" ,
        //     field: "delay_days_bucket",
        //     width: 180,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
             valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return capitalizeWords(params.data.shipment_mode)
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return capitalizeWords(params.data.fuel_type)
                }
            },
        },
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
    ]

    var deliveredDefs1 = [
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const isDisabled = hasConsignmentStatus && 
                                       (param.data.consignment_status === "In Transit" || 
                                        param.data.consignment_status === "Dispatched from Source" || 
                                        param.data.consignment_status === "Invalid docket" ||
                                        param.data.consignment_status === "Delivered"
                                    );
                                    let manual_tracking= param.data.manual_tracking;
                                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking === null)){
                                        return {
                                            component: ViewMap,
                                            params: {
                                                onClickShowRoute: onClickShowRoute,
                                                disabled: isDisabled // Set the disabled state based on the consignment status
                                            }
                                        };
                                    }
                                    if(hasConsignmentStatus){
                                        return {
                                            component: CourierActions,
                                            params: {
                                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                                            }
                                        }
                                    }
                                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                                        
                                        return {
                                            component: CourierActions,
                                            params: {
                                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                                            }
                                        }
                                    }
                
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },   
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            // hide : (tabName.value == "inactive"),
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    // if (hasConsignmentStatus) {                         
                    //     return {
                    //         component: CourierActions,
                    //         params: {
                    //             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //         }
                    //     }
                    // }
                    
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
      
        {
            headerName: "",
            field: "view__pod_document",
            colId: "view__pod_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                let enableViewIcon = param.data.hasOwnProperty("is_submitted_pod") && param.data.hasOwnProperty('uploaded_pod_document')  && param.data.is_submitted_pod === 1;
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowPodDoc(param)
                    // onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        disabled={!enableViewIcon}
                        title="View POD Document"
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-file f17"></i> 
                    </button>
                );
            },
        },
        // {
        //     headerName: "",
        //     field: "view_document",
        //     width: 50,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     hide: tabName.value !== 'active',
        //     cellRenderer: (param) => {
        //         const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");                
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             // if (!hasConsignmentStatus) {
        //             //     onShowDocs(param);  
        //             // }
        //             onShowDocs(param);  
        //         };        
        //         return (
        //             <span 
        //                 onClick={handleClick} 
        //                 title="View Document"
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     fontSize:"12px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     cursor: "pointer" 
        //                 }}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </span>
        //         );
        //     },
        // },   
        // {
        //     headerName: "",
        //     field: "Group",
        //     width: 50,
        //     pinned: "left",
        //     hide: tabName.value === "completed" || tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        // {
        //     headerName: "Upload POD",
        //     field: "upload_pod",
        //     width: 130,
        //     filter: false,
        //     pinned:"left",
        //     cellRenderer: (param) => {

        //         const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");            
        //             if (hasConsignmentStatus) {                            
                            
        //         //console.log(param, "PPPPPPPPPPPPPPPPP");
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             onClickUploadPOD(param);  // Assuming this is a function defined in your functional component or passed as a prop
        //         };
            
        //         return (
        //         <button
        //             onClick={handleClick}
        //             className="btn btn-info"
        //             style={{ padding: "2px 10px", fontSize: "12px", margin: "0" }}
        //             title="Upload POD"
        //             disabled={param.data.epod_uploaded=== 1}
        //         >
        //             Upload POD
        //         </button>
        //         );
        //             }
        // 
                        
                        
        //             }
               
        //     },
        //     headerClass: 'bold-header'
        // },
        //    start        
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No" ,
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
        
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                if (consignmentStatus) {
                    return consignmentStatus;
                } else {
                    if (typeof status === "number") { // Correct check for numeric type
                        return statusMap[status] || "Not Available";
                    } else {
                        return status || "Not Available"; // Ensure fallback if status is undefined or null
                    }
                }
            },
//             filterParams: {
//                 values: (params) => {
//                     const uniqueValues = new Set();
            
//                     try {
//                         // ✅ Respect the already selected filters
//                         const currentFilterModel = params.api.getFilterModel();
//                         const selectedFilterValues = currentFilterModel?.status?.values || [];
            
//                         params.api.forEachNodeAfterFilter((node) => {
//                             if (node.data) {
//                                 const statusMap = {
//                                     0: "Invoiced",
//                                     1: "At Source",
//                                     2: "In Transit",
//                                     3: "Near Destination",
//                                     4: "Delivered",
//                                     5: "Left Dealer",
//                                     6: "Force Closure",
//                                     7: "Provision",
//                                     8: "Trip Completed",
//                                 };
            
//                                 let status;
//                                 if (typeof node.data.status === "number") {
//                                     status = statusMap[node.data.status];
//                                 } else {
//                                     status = node.data.status;
//                                 }
            
//                                 const consignmentStatus = node.data.consignment_status;
//                                 const statusText = consignmentStatus || status || "Not Available";
            
//                                 // ✅ Ensure we only keep selected values if any filter is active
//                                 if (selectedFilterValues.length === 0 || selectedFilterValues.includes(statusText)) {
//                                     uniqueValues.add(statusText);
//                                 }
// 7}
//                         });
            
//                         params.success(Array.from(uniqueValues));
//                     } catch (error) {
//                         console.error("Error in filterParams.values:", error);
//                         params.success([]);
//                     }
//                 },
//                 refreshValuesOnOpen: true, // ❌ Don't refresh every time it's opened
//             },
            
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Trip Completed",
            //     };
            
            //     const consignmentStatus = params.data?.consignment_status;
            //     const status = params.data?.status;
            
            //     if (consignmentStatus) {
            //         return consignmentStatus;
            //     } else {
            //         if (typeof status === "number") {
            //             return statusMap[status] || "Not Available";
            //         } else {
            //             return status || "Not Available";
            //         }
            //     }
            // },
            
        }
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },   
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },         
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.invoice_type != "" && params.data.invoice_type != undefined) {
                    return capitalizeWords(params.data.invoice_type)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return capitalizeWords(params.data.consigner_city)
                }
            },
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return capitalizeWords(params.data.consigner_zone)
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return capitalizeWords(params.data.consignee_city)
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return capitalizeWords(params.data.consignee_state)
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return capitalizeWords(params.data.consignee_zone)
                }
            },
           
        },
        {
            headerName: "Recent Destination",
            field: "last_location",
            colId: "last_location",
            width: 180,
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.last_location != "" && params.data.last_location != undefined) {
                    return capitalizeWords(params.data.last_location)
                }
            },
        },
        {
            headerName: "Delivery Station",
            field: "delivery_station",
            colId: "delivery_station",
            width: 150,
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
           
        },
        {
            headerName: "Truck Seal No" ,
            // hide: (tabName.value === "inactive"),
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "POD Status" ,
            field: "pod_status",
            colId: "pod_status",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if (params.data.pod_status !=="" && params.data.pod_status !==undefined){
                    return params.data.pod_status
                }else{
                    return "Pending"
                }
            }
        }, 
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
       {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },  
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        // {
        //     headerName: "Revised Estimated Delivery Date",
        //     field: "revised_trip_end",
        //     colId: "revised_trip_end",
        //     width: 240,
        //     // hide: (tabName.value === "inactive"),
        //     cellRenderer: '', resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: function (params) {
        //         if (params.data.tracking_type === "FTL") {
        //             // Check if expected_trip_end is not null or undefined
        //             return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
        //         } else {
        //             // Use expected_eta for non-FTL tracking types
        //             return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Actual Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            cellEditor: DateEditor,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    return params.data.recent_dealer_reported_modified
                        ? getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported_modified)
                        : getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
                } else if (params.data.tracking_type === "PTL") {
                    return params.data.delivery_datetime_modified
                        ? getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime_modified)
                        : getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
                }
                return "";
            },
            valueSetter: (params) => {
                const { newValue, data } = params;
        
                if (newValue) {
                    // Convert dispatch_date and newValue to comparable Date objects
                    const dispatchDate = new Date(data.dispatch_date);
                    const newDeliveryDate = new Date(newValue);
        
                    if (newDeliveryDate > dispatchDate) {
                        if (data.tracking_type === "FTL") {
                            data.recent_dealer_reported_modified = newValue;
                        } else if (data.tracking_type === "PTL") {
                            data.delivery_datetime_modified = newValue;
                        }
        
                        params.api.applyTransaction({ update: [data] }); // Commit changes
                        params.api.refreshCells({ rowNodes: [params.node] }); // Refresh the grid
        
                        return true;
                    } else {
                        alert("Actual Delivery Date must be greater than Dispatch Date.");
                        return false;
                    }
                }
                return false;
            },
            editable: function (params) {
                return decode(localStorageRole) === "admin";
            },
            headerClass: "bold-header"
        }
        
        ,
        
       
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                 if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return capitalizeWords(params.data.shipment_mode)
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return capitalizeWords(params.data.fuel_type)
                }
            },
        },        
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
    ]

    var deliveredDefs2 = [
         {
            headerName: "Check",
            field: "checkbox",
            colId: "checkbox",
            width: 40,
            pinned: 'left',
            resizable: true,
            checkboxSelection: params => params.data.status !== 0,
            hide: decode(localStorageRole) != "admin" &&
                decode(localStorageRole) !== "transporter",
            headerCheckboxSelection: true
        },
        {
            headerName: "",
            field: "map",
            colId: "map",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    const isDisabled = hasConsignmentStatus && 
                                       (param.data.consignment_status === "In Transit" || 
                                        param.data.consignment_status === "Dispatched from Source" || 
                                        param.data.consignment_status === "Invalid docket" ||
                                        param.data.consignment_status === "Delivered"
                                    );
                                    let manual_tracking= param.data.manual_tracking;
                                    if (!hasConsignmentStatus && (!manual_tracking || manual_tracking ===0 || manual_tracking===undefined || manual_tracking === null)){
                                        return {
                                            component: ViewMap,
                                            params: {
                                                onClickShowRoute: onClickShowRoute,
                                                disabled: isDisabled // Set the disabled state based on the consignment status
                                            }
                                        };
                                    }
                                    if(hasConsignmentStatus){
                                        return {
                                            component: CourierActions,
                                            params: {
                                                onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                                            }
                                        }
                                    }
                                    if(!hasConsignmentStatus && (manual_tracking ===1)){
                                        
                                        return {
                                            component: CourierActions,
                                            params: {
                                                onShowCourierTrack: (params) => onShowFtlTrack(params, param.data.status)
                                            }
                                        }
                                    }
                
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },   
        {
            headerName: "",
            field: "identity",
            colId: "identity",
            width: 50,
            pinned: "left",
            filter:false,
            // hide : (tabName.value == "inactive"),
            cellRendererSelector: function (param) {
                try {
                    const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
                    // if (hasConsignmentStatus) {                         
                    //     return {
                    //         component: CourierActions,
                    //         params: {
                    //             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
                    //         }
                    //     }
                    // }
                    
                    if (!hasConsignmentStatus) {
                        return {
                            component: ShipmentLegs,
                            params: {
                                onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
                            }
                        }
                    }else{
                        return {
                            component: CourierShipmentLegs,
                            params: {
                                onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "show_transitdelay",
            colId: "show_transitdelay",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowTransitDelayIcon,
                            params: {
                                onShowTransitData: onShowTransitData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "show_tracking",
            colId: "show_tracking",
            width: 50,
            pinned: "left",
            filter:false,
            // hide: tabName.value === "inactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: onShowNoTrackingIcon,
                            params: {
                                onShowNoGPSData: onShowNoGPSData,
                                
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
      ...extraNotUserDelCol,
        {
            headerName: "",
            field: "view__pod_document",
            colId: "view__pod_document",
            width: 60,
            filter: false,
            pinned: "left",
            headerClass: 'bold-header',
            cellRenderer: (param) => {
                let enableViewIcon = param.data.hasOwnProperty("is_submitted_pod") && param.data.hasOwnProperty('uploaded_pod_document')  && param.data.is_submitted_pod === 1;
                const handleClick = (e) => {
                    e.stopPropagation();
                    // if (!hasConsignmentStatus) {
                    //     onShowDocs(param);  
                    // }
                    onShowPodDoc(param)
                    // onShowDocs(param);  
                };        
                return (
                    <button 
                        onClick={handleClick} 
                        disabled={!enableViewIcon}
                        title="View POD Document"
                        // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
                        style={{ 
                            border:"none",
                            backgroundColor:"transparent",
                            fontSize:"12px",
                            // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
                            // opacity: hasConsignmentStatus ? 0.5 : 1, 
                            // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
                            cursor: "pointer" 
                        }}
                    >
                        <i className="fa fa-file f17"></i> 
                    </button>
                );
            },
        },
        // {
        //     headerName: "",
        //     field: "view_document",
        //     width: 50,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     hide: tabName.value !== 'active',
        //     cellRenderer: (param) => {
        //         const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");                
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             // if (!hasConsignmentStatus) {
        //             //     onShowDocs(param);  
        //             // }
        //             onShowDocs(param);  
        //         };        
        //         return (
        //             <span 
        //                 onClick={handleClick} 
        //                 title="View Document"
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     fontSize:"12px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     cursor: "pointer" 
        //                 }}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </span>
        //         );
        //     },
        // },   
        // {
        //     headerName: "",
        //     field: "Group",
        //     width: 50,
        //     pinned: "left",
        //     hide: tabName.value === "completed" || tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        // {
        //     headerName: "Upload POD",
        //     field: "upload_pod",
        //     width: 130,
        //     filter: false,
        //     pinned:"left",
        //     cellRenderer: (param) => {

        //         const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");            
        //             if (hasConsignmentStatus) {                            
                            
        //         //console.log(param, "PPPPPPPPPPPPPPPPP");
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             onClickUploadPOD(param);  // Assuming this is a function defined in your functional component or passed as a prop
        //         };
            
        //         return (
        //         <button
        //             onClick={handleClick}
        //             className="btn btn-info"
        //             style={{ padding: "2px 10px", fontSize: "12px", margin: "0" }}
        //             title="Upload POD"
        //             disabled={param.data.epod_uploaded=== 1}
        //         >
        //             Upload POD
        //         </button>
        //         );
        //             }
        // 
                        
                        
        //             }
               
        //     },
        //     headerClass: 'bold-header'
        // },
        //    start        
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No" ,
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
        
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                if (consignmentStatus) {
                    return consignmentStatus;
                } else {
                    if (typeof status === "number") { // Correct check for numeric type
                        return statusMap[status] || "Not Available";
                    } else {
                        return status || "Not Available"; // Ensure fallback if status is undefined or null
                    }
                }
            },
//             filterParams: {
//                 values: (params) => {
//                     const uniqueValues = new Set();
            
//                     try {
//                         // ✅ Respect the already selected filters
//                         const currentFilterModel = params.api.getFilterModel();
//                         const selectedFilterValues = currentFilterModel?.status?.values || [];
            
//                         params.api.forEachNodeAfterFilter((node) => {
//                             if (node.data) {
//                                 const statusMap = {
//                                     0: "Invoiced",
//                                     1: "At Source",
//                                     2: "In Transit",
//                                     3: "Near Destination",
//                                     4: "Delivered",
//                                     5: "Left Dealer",
//                                     6: "Force Closure",
//                                     7: "Provision",
//                                     8: "Trip Completed",
//                                 };
            
//                                 let status;
//                                 if (typeof node.data.status === "number") {
//                                     status = statusMap[node.data.status];
//                                 } else {
//                                     status = node.data.status;
//                                 }
            
//                                 const consignmentStatus = node.data.consignment_status;
//                                 const statusText = consignmentStatus || status || "Not Available";
            
//                                 // ✅ Ensure we only keep selected values if any filter is active
//                                 if (selectedFilterValues.length === 0 || selectedFilterValues.includes(statusText)) {
//                                     uniqueValues.add(statusText);
//                                 }
// 7}
//                         });
            
//                         params.success(Array.from(uniqueValues));
//                     } catch (error) {
//                         console.error("Error in filterParams.values:", error);
//                         params.success([]);
//                     }
//                 },
//                 refreshValuesOnOpen: true, // ❌ Don't refresh every time it's opened
//             },
            
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Trip Completed",
            //     };
            
            //     const consignmentStatus = params.data?.consignment_status;
            //     const status = params.data?.status;
            
            //     if (consignmentStatus) {
            //         return consignmentStatus;
            //     } else {
            //         if (typeof status === "number") {
            //             return statusMap[status] || "Not Available";
            //         } else {
            //             return status || "Not Available";
            //         }
            //     }
            // },
            
        }
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },           
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Actual Dispatch Date",
            field: "actual_dispatch_date",
            colId: "actual_dispatch_date",
            width: 180,
            resizable: true,
            comparator: dateComparator,

            // Only admin sees
            // hide: decode(localStorageRole) !== "admin",
            initialHide: decode(localStorageRole) !== "admin",
            suppressFiltersToolPanel: decode(localStorageRole) !== "admin",
            suppressColumnsToolPanel: decode(localStorageRole) !== "admin",

            editable: false,
            valueGetter: (params) => {
                const val = params.data?.actual_dispatch_date;

                if (!val) return "";

                return getHyphenDDMMMYYYYHHMM(val);
            },
            headerClass: "bold-header"
        },

        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.invoice_type != "" && params.data.invoice_type != undefined) {
                    return capitalizeWords(params.data.invoice_type)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return capitalizeWords(params.data.consigner_city)
                }
            },
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return capitalizeWords(params.data.consigner_zone)
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return capitalizeWords(params.data.consignee_city)
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return capitalizeWords(params.data.consignee_state)
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return capitalizeWords(params.data.consignee_zone)
                }
            },
           
        },
        // {
        //     headerName: "Recent Destination",
        //     field: "last_location",
        //     colId: "last_location",
        //     width: 180,
        //     cellRenderer: '',
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     valueGetter: function (params) {
        //         if (params.data.last_location != "" && params.data.last_location != undefined) {
        //             return capitalizeWords(params.data.last_location)
        //         }
        //     },
        // },
        // {
        //     headerName: "Delivery Station",
        //     field: "delivery_station",
        //     colId: "delivery_station",
        //     width: 150,
        //     cellRenderer: '',
        //     resizable: true,
        //     headerClass: 'bold-header'
        // },
        
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
           
        },
        {
            headerName: "Truck Seal No" ,
            // hide: (tabName.value === "inactive"),
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "POD Status" ,
            field: "pod_status",
            colId: "pod_status",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if (params.data.pod_status !=="" && params.data.pod_status !==undefined){
                    return params.data.pod_status
                }else{
                    return "Pending"
                }
            }
        }, 
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        // {
        //     headerName: "Last Data Received On",
        //     field: "last_process_on",
        //     colId: "last_process_on",
        //     width: 200,
        //     cellRenderer: '',
        //     resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: (params) => {
        //          if (params.data.accessed_api_at) {
        //              return params.data.accessed_api_at ? getHyphenDDMMMYYYYHHMM(params.data.accessed_api_at) : "NA";
        //          }
        //          else {
        //              return params.data.last_process_on ? getHyphenDDMMMYYYYHHMM(params.data.last_process_on) : "NA";
        //          }
        //      },
        //     // valueGetter: function (params) {
        //     //     const { data: { tracking_type, truck_no, last_process_on } } = params;
        
        //     //     if (tracking_type === "FTL") {
        //     //         const truckLocation = truckLocations?.find(location => location.truck_no === truck_no);
        //     //         return truckLocation?.latest_sim_packet 
        //     //             ? getHyphenDDMMMYYYYHHMM(truckLocation.latest_sim_packet)
        //     //             : "NA";
        //     //     } 
        
        //     //     if (tracking_type === "PTL") {
        //     //         return last_process_on 
        //     //             ? getHyphenDDMMMYYYYHHMM(last_process_on)
        //     //             : "NA";
        //     //     }
        
        //     //     return "NA";
        //     // },
        //     headerClass: 'bold-header',
        // }
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
        
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        // {
        //     headerName: "Revised Estimated Delivery Date",
        //     field: "revised_trip_end",
        //     colId: "revised_trip_end",
        //     width: 240,
        //     // hide: (tabName.value === "inactive"),
        //     cellRenderer: '', resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: function (params) {
        //         if (params.data.tracking_type === "FTL") {
        //             // Check if expected_trip_end is not null or undefined
        //             return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
        //         } else {
        //             // Use expected_eta for non-FTL tracking types
        //             return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },
        // {
        //     headerName: "Delivery Date",
        //     field: "delivery_datetime",
        //     colId: "delivery_datetime",
        //     width: 180,
        //     resizable: true,
        //     comparator: dateComparator,
        //     cellEditor: DateEditor,
        //     valueGetter: function (params) {
        //         if (params.data.tracking_type === "FTL") {
        //             return params.data.recent_dealer_reported_modified
        //                 ? getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported_modified)
        //                 : getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
        //         } else if (params.data.tracking_type === "PTL") {
        //             return params.data.delivery_datetime_modified
        //                 ? getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime_modified)
        //                 : getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
        //         }
        //         return "";
        //     },
        //     valueSetter: (params) => {
        //         const { newValue, data } = params;
        //         if (newValue) {
        //             // Convert dispatch_date and newValue to comparable Date objects
        //             const dispatchDate = new Date(data.dispatch_date);
        //             const newDeliveryDate = new Date(newValue);
        
        //             if (newDeliveryDate > dispatchDate) {
        //                 if (data.tracking_type === "FTL") {
        //                     data.actual_delivery_date = newValue;  //pms id 3860
        //                 } else if (data.tracking_type === "PTL") {
        //                     data.actual_delivery_date = newValue;
        //                 }
        
        //                 params.api.applyTransaction({ update: [data] }); // Commit changes
        //                 params.api.refreshCells({ rowNodes: [params.node] }); // Refresh the grid
        
        //                 return true;
        //             } else {
        //                 alert("Actual Delivery Date must be greater than Dispatch Date.");
        //                 return false;
        //             }
        //         }
        //         return false;
        //     },
        //     editable: function (params) {
        //         return decode(localStorageRole) === "admin";
        //     },
        //     headerClass: "bold-header"
        // },
        {
            headerName: "Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            cellEditor: DateEditor,
            valueGetter: function (params) {
                const { data } = params;
                let deliveryDate = "";

                if (data.tracking_type === "FTL") {
                    deliveryDate = data.recent_dealer_reported_modified || data.delivery_datetime;
                }

                else if (data.tracking_type === "PTL") {
                    deliveryDate = data.delivery_datetime_modified || data.delivery_datetime;
                }

                if (deliveryDate) {
                    if (!deliveryDate.includes("T")) {
                        deliveryDate = `${deliveryDate}T23:59:59`;
                    }
                }

                return deliveryDate ? getHyphenDDMMMYYYYHHMM(deliveryDate) : "";
            },
            valueSetter: (params) => {
                const { newValue, data } = params;
                if (newValue) {
                    const dispatchDate = new Date(data.dispatch_date);
                    const newDeliveryDate = new Date(newValue);

                    if (newDeliveryDate > dispatchDate) {
                        data.actual_delivery_date = newValue;
                        params.api.applyTransaction({ update: [data] });
                        params.api.refreshCells({ rowNodes: [params.node] });
                        return true;
                    } else {
                        alert("Actual Delivery Date must be greater than Dispatch Date.");
                        return false;
                    }
                }
                return false;
            },

            editable: function (params) {
                return decode(localStorageRole) === "admin";
            },
            headerClass: "bold-header"
        },


        {
            headerName: "Actual Delivery Date",
            field: "actual_delivery_date",
            colId: "actual_delivery_date",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            cellEditor: DateEditor,
            valueGetter: function (params) {
                if (params.data.actual_delivery_date) {
                    return getHyphenDDMMMYYYYHHMM(params.data.actual_delivery_date)
                } else {
                    return "";
                }
            },
            headerClass: "bold-header"
        },
        {
            headerName: "Late Delivery Remarks",
            field: "late_delivery_remarks",
            width: 200,
            resizable: true,
            editable: true,
            cellEditor: 'agTextCellEditor',
            headerClass: 'bold-header',
            valueGetter: (params) => {
                return params.data.late_delivery_remarks || "";
            }
        },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }   
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
           valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.shipment_mode != "" && params.data.shipment_mode != undefined) {
                    return capitalizeWords(params.data.shipment_mode)
                }
            },
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.fuel_type != "" && params.data.fuel_type != undefined) {
                    return capitalizeWords(params.data.fuel_type)
                }
            },
        },        
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
    ]


    if(!warehouseDisableIcons){
        
        const extraInactiveColumns = [{
            headerName: "Check",
            field: "checkbox",
            // hide: (tabName.value !== "inactive"),
            colId: "checkbox",
            width: 40,
            pinned: 'left',
            filter: false, 
            resizable: true,
            checkboxSelection: true
        },
        {
            headerName: "",
            field: "cancel_order",
            colId: "cancel_order",
            width: 50,
            pinned: "left",
            // hide: (((tabName.value !== 'active' || tabName.value !=="inactive") && tabName.value=="completed")),
            cellRendererSelector: function (param) {
                try {
                        var disableIcon = decodedRoleCase==="user"
                   
                        return {
                            component: CancelCourierConsignments,
                            params: {
                                onClickActive: onClickCancelActiveCourierConsignemnts,
                                tracking_type: "none",
                                tab_active: "inactive",
                                disabled: disableIcon
                            }
                    }
            
            
                } catch (err) {
                    //console.log(err);
                }
            },            
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },
    ]
        const extraTransporterColumns =[ {
            headerName: "Check",
            field: "checkbox",
            // hide: (tabName.value !== "inactive"),
            colId: "checkbox",
            width: 40,
            pinned: 'left',
            filter: false, 
            resizable: true,
            checkboxSelection: true
        },
        {
            headerName: "",
            field: "cancel_order",
            colId: "cancel_order",
            width: 50,
            pinned: "left",
            // hide: (((tabName.value !== 'active' || tabName.value !=="inactive") && tabName.value=="completed")),
            cellRendererSelector: function (param) {
                try {
                    var disableIcon= decodedRoleCase==="user";

                   
                        return {
                            component: CancelCourierConsignments,
                            params: {
                                onClickActive: onClickCancelActiveCourierConsignemnts,
                                tracking_type: "none",
                                tab_active: "inactive",
                                disabled:disableIcon
                            }
                    }
            
            
                } catch (err) {
                    //console.log(err);
                }
            },            
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        },
        {
            headerName: "",
            field: "update_tpt",
            colId: "update_tpt",
            width: 50,
            pinned: "left",
            filter:false,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        // if(tabName.value === "active"){
                            const roles = ["transporter", "user"];
                            let enableUpdateDetailIcon = roles.includes(decodedRoleCase);
                            

                            return {
                                component: UpdateConsignments,
                                params: {
                                    onClickActive: onClickTransporterEdit,
                                    iconType: "edit",
                                    tooltip: "Update Transporter",
                                    disabled:enableUpdateDetailIcon
                                }
                            // };                           
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
            headerClass: 'bold-header'
        }] 
        const extraTransporterColumnsForTptLoign =[ {
            headerName: "Check",
            field: "checkbox",
            // hide: (tabName.value !== "inactive"),
            colId: "checkbox",
            width: 40,
            pinned: 'left',
            filter: false, 
            resizable: true,
            checkboxSelection: true
        }
     ] 

    
    if(decodedRoleCase==="admin"){
        inactiveDefs=[...extraInactiveColumns,...inactivedefs1]
        transporterDefs=[...extraTransporterColumns, ...transporterDefs1]
    
        activeDefs=[...activeDefs2]
        allCodefs=[...allCodefs2]
        deliveredDefs=[...deliveredDefs2]
    }else if(decodedRoleCase==="transporter"){
        inactiveDefs=[...extraInactiveColumns,...inactivedefs1]
        transporterDefs=[...extraTransporterColumnsForTptLoign, ...transporterDefs1]
        deliveredDefs=[...deliveredDefs2]
        activeDefs=[...tptActiveDefs]
        allCodefs=[...allCodefs1]

    
    }else{
        inactiveDefs=[...extraInactiveColumns,...inactivedefs1]
        transporterDefs=[...extraTransporterColumns, ...transporterDefs1]
        activeDefs=[...activeDefs3]
        allCodefs=[...allCodefs3]
        deliveredDefs=[...deliveredDefs2]
    }
    }
    else if(["user", "user-inbound", "user-outbound"].includes(decodedRoleCase)){
        inactiveDefs=[...inactivedefs1]
        transporterDefs=[...transporterDefs1]
        activeDefs=[...activeDefs4]
        allCodefs=[...allCodefs4]
        deliveredDefs=[...deliveredDefs1]
    }
    else{
        // setInactiveColumns([])
        inactiveDefs=[...inactivedefs1]
        transporterDefs=[...transporterDefs1]
        activeDefs=[...activeDefs1]
        allCodefs=[...allCodefs1]
        deliveredDefs=[...deliveredDefs2]
       
    }
    inactiveDefs.forEach(e => {
        e.cellClass = function (params) {
            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                return "bgColorDangerDark";
            } else {
                return null;
            }
        };
    });
    activeDefs.forEach(e => {
        e.cellClass = function (params) {
            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                return "bgColorDangerDark";
            } else {
                return null;
            }
        };
    });
    activeDefs.forEach(e => {
        if (e.field === "ontime_status") {
            e.cellStyle = function (params) {
                if(params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes"){
                    return null
                }
                else if (params.data && params.data.hasOwnProperty("ontime_status") && params.data["ontime_status"] === 0) {
                    return { backgroundColor: "#ff7289"} // Red background for this specific cell
                }
                return null; // No style for other cells
            };
        }
    });
    allCodefs.forEach(e => {
        e.cellClass = function (params) {
            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                return "bgColorDangerDark";
            } else {
                return null;
            }
        };
    });
    allCodefs.forEach(e => {
        if (e.field === "ontime_status") {
            e.cellStyle = function (params) {
                if(params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes"){
                    return null
                }
                else if (params.data && params.data.hasOwnProperty("ontime_status") && params.data["ontime_status"] === 0) {
                    return { backgroundColor: "#ff7289"} // Red background for this specific cell
                }
                return null; // No style for other cells
            };
        }
    });
    deliveredDefs.forEach(e => {
        e.cellClass = function (params) {
            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                return "bgColorDangerDark";
            } else if(params.data && params.data.hasOwnProperty("ontime_status") && params.data.ontime_status ===0){

            }else{
                return null;
            }
        };
    });
    deliveredDefs.forEach(e => {
        if (e.field === "ontime_status") {
            e.cellStyle = function (params) {
                if(params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes"){
                    return null
                }
                else if (params.data && params.data.hasOwnProperty("ontime_status") && params.data["ontime_status"] === 0) {
                    return { backgroundColor: "#ff7289"} // Red background for this specific cell
                }
                return null; // No style for other cells
            };
        }
    });
}, [processFlowType, tabName.value, searchViewType])



  

  
    
    
    
    var activeConsignmentDefs = [
 // actionables above
            {
                headerName: "Invoice No",
                field: "invoice_no",
                colId: "invoice_no",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            },
            {
                headerName: "LR No" ,
                field: "lr_no",
                colId: "lr_no",
                // hide: (tabName.value === "inactive"),
                width: 150,
                cellRenderer: '', resizable: true,
                headerClass: 'bold-header'
            },
         {
             headerName: "Tracking Mode" ,
             field: "tracking_type",
             colId: "tracking_type",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "SIM Consent Status" ,
             field: "sim_consent_status",
             colId: "sim_consent_status",
             // hide: (tabName.value === "inactive"),
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
         },
        
         
         
         {
             headerName: "Vehicle No" ,
             field: "truck_no",
             colId: "truck_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        
         
         {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
        
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
                                    
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
 
         
         
         
         {
             headerName: "Reason For Delay" ,
             field: "reason_for_delay",
             colId: "reason_for_delay",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },  
         {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },              
         {
             headerName: "Invoice Date",
             field: "invoice_time",
             colId: "invoice_time",
             width: 180,
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 const invoiceDate = params.data.invoice_time;
                 if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Dispatch Date" ,
             field: "dispatch_date",
             colId: "dispatch_date",
             width: 150,
             //filter: "agDateColumnFilter",
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
 
             valueGetter: function (params) {
                 const dispatchDate = params.data.dispatch_date;
                 if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                     // Call date formatting only when the dispatch date is valid
                     const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                     // Check if formattedDate is valid, otherwise return "NA"
                     return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                 } else {
                     return "";
                 }
             },
             headerClass: 'bold-header'
         },
         {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
         {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
         {
             headerName: "Consignee Name",
             field: "consginee_name",
             colId: "consginee_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
             headerClass: 'bold-header'
         },
         {
             headerName: "Entity" ,
             field: "truck_seal_entity",
             colId: "truck_seal_entity",
             width: 150,
             cellRenderer: '', resizable: true,
             valueGetter: function (params) {
                 if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                     return capitalizeWords(params.data.truck_seal_entity)
                 }
             },
             headerClass: 'bold-header'
         },               
         {
             headerName: "Invoice Type" ,
             field: "invoice_type",
             colId: "invoice_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Transporter",
             field: "transporter_name",
             colId: "transporter_name",
             width: 180,
             filter: "agSetColumnFilter",
             cellRenderer: '',
             resizable: true,
             valueGetter: function (params) {
                 if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                     return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                 }
             },
             headerClass: 'bold-header'
         },
         {
             headerName: "Source City" ,
             field: "consigner_city",
             colId: "consigner_city",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                }
            },
         },  
         {
             headerName: "Source Pincode" ,
             field: "consigner_pincode",
             colId: "consigner_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Source Zone" ,
             field: "consigner_zone",
             colId: "consigner_zone",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                }
            },
         },
         {
             headerName: "Destination City" ,
             field: "consignee_city",
             colId: "consignee_city",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                }
            },
         },
         {
             headerName: "Destination Pincode" ,
             field: "consignee_pincode",
             colId: "consignee_pincode",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Destination State" ,
             field: "consignee_state",
             colId: "consignee_state",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                }
            },
         },
         {
             headerName: "Destination Zone",
             field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
             colId: "consignee_zone",
             width: 180,
             resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                }
            },
            
         },
         {
             headerName: "Mobile Number" ,
             field: "driver_mobile_no",
             colId: "driver_mobile_no",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Movement Type" ,
             field: "movement_type",
             colId: "movement_type",
 
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Total Weight",
             field: "total_weight",
             colId: "total_weight",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
         },
         {
             headerName: "Total CBM",
             field: "total_cbm",
             colId: "total_cbm",
             width: 150,
             resizable: true,
             headerClass: 'bold-header',
             valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
         },
         
         {
             headerName: "Transporter Category" ,
             field: "tpt_category",
             colId: "tpt_category",
             width: 190,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Vehicle Type" ,
             field: "truck_type",
             colId: "truck_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "Truck Seal No" ,
             // hide: (tabName.value === "inactive"),
             field: "truck_seal_no",
             colId: "truck_seal_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "ODA",
             field: "oda",
             colId: "oda",
             width: 150,
             cellRenderer: '',
             headerClass: 'bold-header',
             resizable: true,
         },
         {
             headerName: "TAT" ,
             field: "transit_time",
             colId: "transit_time",
             // hide: (tabName.value === "inactive"),
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        
         // {
         //     headerName: "Reached Destination At",
         //     field: "recent_dealer_reported",
         //     colId: "recent_dealer_reported",
         //     width: 180,
         //     resizable: true,
         //     valueGetter: function (params) {
         //         if (params.data.status === 4 || params.data.status === 5) {
         //             // Use 'status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else if (params.data.consignment_status === "Delivered") {
         //             // Use 'consignment_status' logic
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         } else {
         //             // Default to empty string if neither condition is met
         //             return "";
         //         }
         //     }
         // },
         {
             headerName: "Event Location" ,
             field: "last_location",
             colId: "last_location",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },
           
         {
             headerName: "Expected ETA", // Estimated delivery date
             field: "expected_trip_end",
             colId: "expected_trip_end",
             width: 150,
             resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                 }
             },
             headerClass: 'bold-header'
 
         },
         
         {
             headerName: "Revised Estimated Delivery Date",
             field: "revised_trip_end",
             colId: "revised_trip_end",
             width: 240,
             // hide: (tabName.value === "inactive"),
             cellRenderer: '', resizable: true,
             comparator: dateComparator,
             valueGetter: function (params) {
                 if (params.data.tracking_type === "FTL") {
                     // Check if expected_trip_end is not null or undefined
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                 } else {
                     // Use expected_eta for non-FTL tracking types
                     return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                 }
             },
             headerClass: 'bold-header'
         },
         // {
         //     headerName: "Actual Delivery Date",
         //     field: "recent_dealer_reported",
         //     width: 180,
         //     hide: (tabName.value === "inactive"),
         //     cellRenderer: '', resizable: true,
         //     comparator: dateComparator,
         //     valueGetter: function (params) {
         //         if (params.data.recent_dealer_reported != '' && params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported !== ' ') {
         //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
         //         }
         //         else {
         //             return "NA";
         //         }
         //     },
         //     headerClass: 'bold-header'
         // },
         {
             headerName: "Performance" ,
             field: "ontime_status",
             colId: "ontime_status",
             width: 180,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
              valueGetter: (params)=>{
                 if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
         },
         {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
           valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
         {
             headerName: "E-Way Bill No" ,
             field: "eway_bill_no",
             colId: "eway_bill_no",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         }, 
         {
             headerName: "Mode" ,
             field: "shipment_mode",
             colId: "shipment_mode",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },   
         {
             headerName: "Fuel Type" ,
             field: "fuel_type",
             colId: "fuel_type",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
         {
             headerName: "No Of Boxes" ,
             field: "no_of_boxes",
             colId: "no_of_boxes",
             width: 150,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header'
         },
        //  {
        //      headerName: "Reason" ,
        //      field: "remarks",
        //      colId: "remarks",
        //      width: 180,
        //      resizable: true,
        //      headerClass: 'bold-header',
        //      hide: showUndelivered,
        //      valueGetter: (params) => {
        //          return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //      },
             
        //      // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //      cellRenderer: (params) => {
        //          if (params.data.consignment_status === 'Undelivered') {
        //              return params.value; // Show the remark if status is 'Undelivered'
        //          }
        //          return ''; // Return empty string for other statuses
        //      },
             
        //      // hide: false
        //  }
         
     ]   
    var allConsignmentDefs = [
        {
            headerName: "Invoice No",
            field: "invoice_no",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        , {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
       
        
                 
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
        
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
            //                         4: "Delivered",
            //                         5: "Left Dealer",
            //                         6: "Force Closure",
            //                         7: "Provision",
            //                         8: "Delivered",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Delivered",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        
        ,
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },     
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },           
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                }
            },
          
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Truck Seal No" ,
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            },  
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised Estimated Delivery Date",
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Actual Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            hide: (tabName.value === "active"),
            cellRenderer: '', 
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                try {
                    
                            if (params.data.delivery_datetime && params.data.delivery_datetime.trim() !==""){
                                return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime)
                            }else{
                                return ""
                            }
                      
                } catch (err) {
                    console.log(err);
                    return ""; // In case of an error, return "NA"
                }
            },
            // editable: function (params) {
            //     // Make field editable only if role is 'admin'
            //     return decode(localStorageRole) === "admin";
            // },
            headerClass: 'bold-header'
        },
        
        
        // {
        //     headerName: "Delay Days Bucket" ,
        //     field: "delay_days_bucket",
        //     width: 180,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
             valueGetter: (params)=>{
                 if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            colId:"transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "No Of Boxes" ,
            field: "no_of_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
    ];
    var completedConsignmentDefs = [
       
     
        //    start 
        {
            headerName: "Invoice No" ,
            field: "invoice_no",
            colId: "invoice_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },  
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },     
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
       
      
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
        
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         4: "Delivered",
            //                         8: "Delivered",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         4: "Delivered",
            //         8: "Delivered",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        ,   
        {
            headerName: "Gate In" ,
            field: "gate_in_time",
            colId: "gate_in_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateInDate = params.data.gate_in_time;
                if (gateInDate && gateInDate.trim() !== '' && gateInDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateInDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Gate Out" ,
            field: "gate_out_time",
            colId: "gate_out_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const gateOutDate = params.data.gate_out_time;
                if (gateOutDate && gateOutDate.trim() !== '' && gateOutDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(gateOutDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
             headerName: "Reason For Delay Timestamp",
             field: "reason_for_delay_timestamp",
             colId: "reason_for_delay_timestamp",
             width: 200,
             cellRenderer: '', resizable: true,
             headerClass: 'bold-header',
             valueGetter: function (params) {
                 const reason_timestamp = params.data.reason_for_delay_timestamp;
                 if (reason_timestamp) {
                     const formattedDate = getHyphenDDMMMYYYYHHMM(reason_timestamp);
                     return formattedDate !== "Invalid Date" ? formattedDate : "";
                 } else {
                     return "";
                 }
             },
         },         
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return (params.data.consigner_city ? capitalizeWords(params.data.consigner_city):"")
                }
            },
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_zone != "" && params.data.consigner_zone != undefined) {
                    return (params.data.consigner_zone ? capitalizeWords(params.data.consigner_zone):"")
                }
            },
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_city != "" && params.data.consignee_city != undefined) {
                    return (params.data.consignee_city ? capitalizeWords(params.data.consignee_city):"")
                }
            },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return (params.data.consignee_state ? capitalizeWords(params.data.consignee_state):"")
                }
            },
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_zone != "" && params.data.consignee_zone != undefined) {
                    return (params.data.consignee_zone ? capitalizeWords(params.data.consignee_zone):"")
                }
            },
           
        },
        {
            headerName: "Recent Destination",
            field: "last_location",
            colId: "last_location",
            width: 150,
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Delivery Station",
            field: "delivery_station",
            colId: "delivery_station",
            width: 150,
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        {
            headerName: "Total CBM",
            field: "total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Truck Seal No" ,
            // hide: (tabName.value === "inactive"),
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "POD Status" ,
            field: "pod_status",
            colId: "pod_status",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function(params){
                if (params.data.pod_status !=="" && params.data.pod_status !==undefined){
                    return params.data.pod_status
                }else{
                    return "Pending"
                }
            }
        }, 
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
       {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            }, 
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        // {
        //     headerName: "Revised Estimated Delivery Date",
        //     field: "revised_trip_end",
        //     colId: "revised_trip_end",
        //     width: 240,
        //     // hide: (tabName.value === "inactive"),
        //     cellRenderer: '', resizable: true,
        //     comparator: dateComparator,
        //     valueGetter: function (params) {
        //         if (params.data.tracking_type === "FTL") {
        //             // Check if expected_trip_end is not null or undefined
        //             return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
        //         } else {
        //             // Use expected_eta for non-FTL tracking types
        //             return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
        //         }
        //     },
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Actual Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            cellEditor: DateEditor,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    return params.data.recent_dealer_reported_modified
                        ? getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported_modified)
                        : getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
                } else if (params.data.tracking_type === "PTL") {
                    return params.data.delivery_datetime_modified
                        ? getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime_modified)
                        : getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
                }
                return "";
            },
            valueSetter: (params) => {
                const { newValue, data } = params;
        
                if (newValue) {
                    if (data.tracking_type === "FTL") {
                        data.recent_dealer_reported_modified = newValue;
                        //console.log("FTL Updated:", newValue);
                    } else if (data.tracking_type === "PTL") {
                        data.delivery_datetime_modified = newValue;
                        //console.log("PTL Updated:", newValue);
                    }
                    // setIsEdited(true) 
        
                    params.api.applyTransaction({ update: [data] }); // Commit changes
                    params.api.refreshCells({ rowNodes: [params.node] }); // Refresh the grid
        
                    return true;
                }
                return false;
            },
            editable: function (params) {
                return decode(localStorageRole) === "admin";
            },
            headerClass: "bold-header"
        }
        ,
        
       
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                 if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            colId: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        {
            headerName: "Delay Days Bucket",
            field: "delay_days_bucket",
            colId: "delay_days_bucket",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                    return getDelayDaysBucket(params.data.transit_delay_days, params.data.transit_delay_hours, params.data.transit_delay);
                },
        },
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },        
        {
            headerName: "No Of Boxes" ,
            field: "no_of_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
    ]
    completedConsignmentDefs.forEach(e => {
        e.cellClass = function (params) {
            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                return "bgColorDangerDark";
            } else if(params.data && params.data.hasOwnProperty("ontime_status") && params.data.ontime_status ===0){

            }else{
                return null;
            }
        };
    });
    allConsignmentDefs.forEach(e => {
        e.cellClass = function (params) {
            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                return "bgColorDangerDark";
            } else {
                return null;
            }
        };
    })
    activeConsignmentDefs.forEach(e => {
        e.cellClass = function (params) {
            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                return "bgColorDangerDark";
            } else {
                return null;
            }
        };
    })

   
    let submitCol = {
        headerName: "",
        field: "submit_btn",
        colId: "submit_btn",
        width: 80,
        filter:false, 
        resizable: true,
        cellRendererSelector: function (param) {
            try {
                // Check if any edit was made (i.e., if isEdited is true)
               
                    return {
                        component: SubmitBtn,
                        params: {
                            onClickEditDeliveryDate: onClickEditDeliveryDate,
                        }
                    };
              
            } catch (err) {
                console.log(err);
            }
        },
    }
    let EDDCol = 
    // {
    //     headerName: "Estimated Delivery Date",
    //     field: "estimated_delivery_date",
    //     colId: "estimated_delivery_date",
    //     width: 200,
    //     cellRenderer: '', resizable: true,
    //     comparator: dateComparator,
    //     valueGetter: function (params) {
    //         if (!!params.data.estimated_delivery_date) {
    //             return getHyphenDDMMMYYYYHHMM(params.data.estimated_delivery_date);
    //         }
    //         else {
    //             return "";
    //         }
    //     },
    //     headerClass: 'bold-header'
    // }
    {
        headerName: "Estimated Delivery Date",
        field: "estimated_delivery_date",
        colId: "estimated_delivery_date",
        width: 200,
        cellRenderer: '',
        resizable: true,
        comparator: dateComparator,
        valueGetter: function (params) {
            const estimated = params.data?.estimated_delivery_date;
            const initial = params.data?.initial_delivery_date;
            const dateToShow = estimated || initial;
            if (dateToShow) {
                return getHyphenDDMMMYYYYHHMM(dateToShow);
            }
            return "";
        },
        headerClass: 'bold-header'
    }
    
    useEffect(() => {
        // Check if the role is 'admin' and the data is populated
        if (decodedRoleCase === "admin") {
            // Ensure deliveredDefs has data before manipulating
            if (deliveredDefs.length > 0) {
                // Find the index of Actual Delivery Date if already exists
                const actualDeliveryDateIndex = deliveredDefs.findIndex(col => col.field === "delivery_datetime");

                if (actualDeliveryDateIndex !== -1) {
                    // If Actual Delivery Date exists, insert Submit button right after it
                    deliveredDefs.splice(actualDeliveryDateIndex + 1, 0, submitCol);
                } else {
                    // If Actual Delivery Date doesn't exist, add both columns together at the end
                    deliveredDefs.push(submitCol);
                }

                // Update the state with the modified deliveredDefs
            }
        }
        // if(enabledEDDEmailList?.includes(decode(localStorageEmail))){
            if (allCodefs.length > 0 || allConsignmentDefs.length >0 || activeDefs.length > 0 || activeConsignmentDefs.length>0 || completedConsignmentDefs.length>0 || deliveredDefs.length>0) {
                // Find the index of Actual Delivery Date if already exists
                const revisedEDDDateIndexAll = allCodefs.findIndex(col => col.field === "revised_trip_end");
                const revisedEDDDateIndexForInvoicesAll = allConsignmentDefs.findIndex(col => col.field === "revised_trip_end");

                const revisedEDDDateIndexActive = activeDefs.findIndex(col => col.field === "revised_trip_end");
                const revisedEDDDateIndexForInvoicesActive = activeConsignmentDefs.findIndex(col => col.field === "revised_trip_end");


                const expectedEDDDateIndexDel = deliveredDefs.findIndex(col => col.field === "expected_trip_end");
                const expectedEDDDateIndexForInvoicesDel = completedConsignmentDefs.findIndex(col => col.field === "expected_trip_end");


                if (revisedEDDDateIndexAll !== -1 || revisedEDDDateIndexForInvoicesAll !== -1 || revisedEDDDateIndexActive !== -1 || revisedEDDDateIndexForInvoicesActive !== -1 || expectedEDDDateIndexDel !==-1 || expectedEDDDateIndexForInvoicesDel !== -1) {
                    // If Actual Delivery Date exists, insert Submit button right after it
                    allCodefs.splice(revisedEDDDateIndexAll + 1, 0, EDDCol);
                    allConsignmentDefs.splice(revisedEDDDateIndexForInvoicesAll + 1, 0, EDDCol)

                    activeDefs.splice(revisedEDDDateIndexActive + 1, 0, EDDCol);
                    activeConsignmentDefs.splice(revisedEDDDateIndexForInvoicesActive + 1, 0, EDDCol)

                    deliveredDefs.splice(expectedEDDDateIndexDel + 1, 0, EDDCol);
                    completedConsignmentDefs.splice(expectedEDDDateIndexForInvoicesDel + 1, 0, EDDCol)
                } else {
                    // If Actual Delivery Date doesn't exist, add both columns together at the end
                    activeDefs.push(EDDCol);
                    activeConsignmentDefs.push(EDDCol);

                    deliveredDefs.push(EDDCol);
                    completedConsignmentDefs.push(EDDCol);

                    allCodefs.push(EDDCol);
                    allConsignmentDefs.push(EDDCol);

                }

                // Update the state with the modified deliveredDefs
            }
        // }
    }, [decodedRoleCase, deliveredDefs,completedConsignmentDefs, activeDefs, activeConsignmentDefs, allCodefs, allConsignmentDefs, localStorageEmail]);    
    
    // var forceCloseCodefs = [ 
    //     {
    //         headerName: "",
    //         field: "map",
    //         colId: "map",
    //         width: 50,
    //         pinned: "left",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
    //                 const disabledStatuses = [
    //                     "In Transit", 
    //                     "Dispatched from Source", 
    //                     "Invalid docket", 
    //                     "Out For Delivery", 
    //                     "Undelivered", 
    //                     "Booked", 
    //                     "Delivered", 
    //                     "Cancelled"
    //                 ];
                    
    //                 const isDisabled = hasConsignmentStatus && disabledStatuses.includes(param.data.consignment_status);
        
    //                 if (!hasConsignmentStatus){
    //                     return {
    //                         component: ViewMap,
    //                         params: {
    //                             onClickShowRoute: onClickShowRoute,
    //                             disabled: isDisabled // Set the disabled state based on the consignment status
    //                         }
    //                     };
    //                 }else{
    //                     return {
    //                         component: CourierActions,
    //                         params: {
    //                             onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
    //                         }
    //                     }
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    //     },
    //     {
    //         headerName: "",
    //         field: "identity",
    //         colId: "identity",
    //         width: 50,
    //         pinned: "left",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");

            
    //                 // if (hasConsignmentStatus) {
                            
    //                 //         return {
    //                 //             component: CourierActions,
    //                 //             params: {
    //                 //                 onShowCourierTrack: (params) => onShowCourierTrack(params, param.data.consignment_status)
    //                 //             }
    //                 //         }
    //                 // }
    //                 if (!hasConsignmentStatus) {
    //                     return {
    //                         component: ShipmentLegs,
    //                         params: {
    //                             onClickShowShipmentLegs: (params) => onClickShowShipmentLegs(params, param.data.status)
    //                         }
    //                     }
    //                 }else{
    //                     return {
    //                         component: CourierShipmentLegs,
    //                         params: {
    //                             onClickShowCourierShipmentLegs: (params) => onClickShowCourierShipmentLegs(params, param.data.consignment_status)
    //                         }
    //                     }
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    //     },        
    //     // {
    //     //     headerName: "",
    //     //     field: "Group",
    //     //     colId: "Group",
    //     //     width: 50,
    //     //     pinned: "left",
    //     //     // hide: tabName.value === "completed" || tabName.value === "inactive",
    //     //     cellRendererSelector: function (param) {
    //     //         try {
    //     //             if (param.data._id != null && param.data._id != undefined) {
    //     //                 return {
    //     //                     component: GroupIconRenderer,
    //     //                     params: {
    //     //                         onShowTransitData: onShowTransitData,
    //     //                         onShowNoGPSData: onShowNoGPSData,
    //     //                         onShowStoppagesData: onShowStoppagesData,
    //     //                         onShowUploadDoc: onShowUploadDoc,
    //     //                         onShowDocs: onShowDocs,
    //     //                     }
    //     //                 }
    //     //             }
    //     //         } catch (err) {
    //     //             //console.log(err);
    //     //         }
    //     //     },
    //     //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    //     // },
    //     {
    //         headerName: "",
    //         field: "show_transitdelay",
    //         colId: "show_transitdelay",
    //         width: 50,
    //         pinned: "left",
    //         // hide: tabName.value === "inactive",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 if (param.data._id != null && param.data._id != undefined) {
    //                     return {
    //                         component: onShowTransitDelayIcon,
    //                         params: {
    //                             onShowTransitData: onShowTransitData,
                                
    //                         }
    //                     }
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    //     },
    //     {
    //         headerName: "",
    //         field: "show_tracking",
    //         colId: "show_tracking",
    //         width: 50,
    //         pinned: "left",
    //         // hide: tabName.value === "inactive",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 if (param.data._id != null && param.data._id != undefined) {
    //                     return {
    //                         component: onShowNoTrackingIcon,
    //                         params: {
    //                             onShowNoGPSData: onShowNoGPSData,
                                
    //                         }
    //                     }
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    //     },
    //     {
    //         headerName: "",
    //         field: "show_stoppages",
    //         colId: "show_stoppages",
    //         width: 50,
    //         pinned: "left",
    //         // hide: tabName.value === "inactive",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 if (param.data._id != null && param.data._id != undefined) {
    //                     return {
    //                         component: onShowstoppagesIcon,
    //                         params: {
    //                             onShowStoppagesData: onShowStoppagesData,
                                
    //                         }
    //                     }
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
    //     },
    //     {
    //         headerName: "",
    //         field: "update",
    //         colId: "update",
    //         width: 50,
    //         pinned: "left",
    //         // hide: true,
    //         cellRendererSelector: function (param) {
    //             try {
    //                 if (param.data._id != null && param.data._id != undefined) {
    //                     let enableUpdateDetailIcon =(param.data.status === 6 || param.data.consignment_status === "Cancelled" || param.data.status === 9 || param.data.consignment_status === "Undelivered" || param.data.consignment_status === "Arrived At Destination" || param.data.status=== 4 || param.data.consignment_status === "Delivered" || param.data.status ===8)
    //                     // if(tabName.value === "active" || tabName.value === "all"){
    //                         return {
    //                             component: UpdateConsignments,
    //                             params: {
    //                                 onClickActive: onClickActive,
    //                                 iconType: "edit",
    //                                 disabled: enableUpdateDetailIcon
    //                             }
    //                         };                           
    //                     // }
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "",
    //         field: "update_tracking_status",
    //         colId: "update_tracking_status",
    //         width: 50,
    //         pinned: "left",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 if (param.data._id != null && param.data._id != undefined) {
    //                     const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
        
    //                     if (hasConsignmentStatus && param.data.consignment_status !=="Delivered" && param.data.manual_tracking ===1) {                            
    //                         return {
    //                             component: UpdatePTLConsignments,
    //                             params: {
    //                                 onClickActive: updateDeliveredDate,
    //                                 iconType: "tracking",
    //                                 // disabled: true // Disable the icon
    //                             }
    //                         };
    //                     }
    //                     if (hasConsignmentStatus && (param.data.consignment_status === "Delivered" || param.data.consignment_status ==="Undelivered" || param.data.manual_tracking ===0 || param.data.consignment_status ==="Cancelled")) {                            
    //                         return {
    //                             component: UpdatePTLConsignments,
    //                             params: {
    //                                 onClickActive: updateDeliveredDate,
    //                                 iconType: "tracking",
    //                                 disabled: true 
    //                             }
    //                         };
    //                     }
                        
    //                     if (!hasConsignmentStatus && (param.data.manual_tracking === 1 || param.data.status === 1 || param.data.status === 2 || param.data.status ===3)) {
    //                         return {
    //                             component: UpdatePTLConsignments,
    //                             params: {
    //                                 onClickActive: updateDeliveredDate,
    //                                 iconType: "tracking",
    //                                 disabled: false 
    //                             }
    //                         };
    //                     } 
    //                     if (!hasConsignmentStatus && (param.data.status ===6 || param.data.status === 4 || param.data.status === 8 || param.data.status===9)) {
    //                         return {
    //                             component: UpdatePTLConsignments,
    //                             params: {
    //                                 onClickActive: updateDeliveredDate,
    //                                 iconType: "tracking",
    //                                 disabled: true 
    //                             }
    //                         };
    //                     }                        
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
    //         headerClass: 'bold-header'
    //     }, 
    //     {
    //         headerName: "",
    //         field: "upload_document",
    //         colId: "upload_document",
    //         width: 60,
    //         filter: false,
    //         pinned:"left",
    //         headerClass: 'bold-header',
    //         cellRenderer: (param) => {
    //             // const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
    //             let isDisabledUploadDoc = (param.data.status === 6 || param.data.status === 9 || param.data.consignment_status === "Cancelled" || param.data.consignment_status ==="Undelivered")
    //             const handleClick = (e) => {
    //                 e.stopPropagation();
    //                 // if (!hasConsignmentStatus && isDisabledUploadDoc) {
    //                     onShowUploadDoc(param); 
    //                 // }
    //                 //  else {
    //                 //     if(isDisabledUploadDoc)
    //                 //         onClickUploadPOD(param)
    //                 // }
    //             };
                
    //             return (
    //                 <button 
    //                     onClick={handleClick} 
    //                     // title={hasConsignmentStatus ? "Upload Document (Disabled)" : "Upload Document"}
    //                     title="Upload Document"
    //                     style={{ 
    //                         border:"none",
    //                         backgroundColor:"transparent",
    //                         pointerEvents: isDisabledUploadDoc ? "none" : "auto", 
    //                         opacity: isDisabledUploadDoc ? 0.5 : 1, 
    //                         // cursor: (hasConsignmentStatus && param.data.consignment_status === "Delivered") || (!hasConsignmentStatus && (param.data.status === 4 || param.data.status === 6)) ? "not-allowed" : "pointer" ,
    //                         // cursor: "pointer" 
    //                     }}
    //                     disabled={isDisabledUploadDoc}
    //                 >
    //                     <i className="icofont icofont-upload-alt f17" style={{ fontSize:"12px",color: isDisabledUploadDoc? "grey":"#3a3fa6" }}></i>
    //                 </button>
    //             );
    //         },
    //     },
    //     {
    //         headerName: "",
    //         field: "view_document",
    //         colId: "view_document",
    //         width: 60,
    //         filter: false,
    //         pinned: "left",
    //         headerClass: 'bold-header',
    //         // hide: tabName.value !== 'active' || tabName.value !== "all",
    //         cellRenderer: (param) => {
    //             const enableDocument = (!param.data.hasOwnProperty("is_submitted_document") || !param.data.hasOwnProperty("is_submitted_loading_document") || !param.data.hasOwnProperty("is_submitted_unloading_document") || (param.data.consignment_status ==="Undelivered") || (param.data.consignment_status ==="Cancelled") || (param.data.status === 4) || (param.data.status === 6));                
    //             const handleClick = (e) => {
    //                 e.stopPropagation();
    //                 onShowDocs(param);  
    //             };        
    //             return (
    //                 <button 
    //                     onClick={handleClick} 
    //                     title="View Document"
    //                     disabled={enableDocument}
    //                     // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
    //                     style={{ 
    //                         border:"none",
    //                         backgroundColor:"transparent"
    //                         // fontSize:"15px",
    //                         // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
    //                         // opacity: hasConsignmentStatus ? 0.5 : 1, 
    //                         // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
    //                         // cursor: "pointer" 
    //                     }}
    //                 >
    //                     <i className="fa fa-eye f17"></i> 
    //                 </button>
    //             );
    //         },
    //     },   
    //     {
    //         headerName: "",
    //         field: "upload_pod",
    //         colId: "upload_pod",
    //         width: 60,
    //         filter: false,
    //         pinned: "left",
    //         headerClass: 'bold-header',
    //         cellRendererSelector: function (param) {
    //             try {
    //                 const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
    //                 const isDisable = hasConsignmentStatus && (param.data.consignment_status === "Cancelled" || param.data.consignment_status==="Dispatched from Source" || param.data.consignment_status==="Arrived At Destination" || param.data.consignment_status==="In Transit" || param.data.consignment_status==="Out For Delivery" || param.data.consignment_status==="Undelivered" || param.data.is_submitted_pod ===1 || param.data.consignment_status ==="Booked")
    //                 const isDisable1 = !hasConsignmentStatus && (param.data.status === 6 || param.data.status === 1 || param.data.status === 2 || param.data.status === 3 || param.data.status ===8 || param.data.is_submitted_pod ===1)
    //                 if (hasConsignmentStatus) {                         
    //                     return {
    //                         component: uploadPOD,
    //                         params: {
    //                             onClickUploadPOD: onClickUploadPOD,
    //                             isSubmittedPOD: param.data.is_submitted_pod,
    //                             disabled: isDisable
    //                         }
    //                     }
    //                 }
                    
    //                 if (!hasConsignmentStatus) {
    //                     return {
    //                         component: uploadPOD,
    //                         params: {
    //                             onClickUploadPOD: onClickUploadPOD,
    //                             isSubmittedPOD: param.data.is_submitted_pod,
    //                             disabled: isDisable1

    //                         }
    //                     }
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //     },
    //     {
    //         headerName: "",
    //         field: "view_pod_document",
    //         colId: "view_pod_document",
    //         width: 60,
    //         filter: false,
    //         pinned: "left",
    //         headerClass: 'bold-header',
    //         cellRenderer: (param) => {
    //             let enableViewIcon = ((param.data.hasOwnProperty('status') && param.data.status === 8 && param.data.hasOwnProperty("is_submitted_pod") && param.data.hasOwnProperty('uploaded_pod_document') && param.data.is_submitted_pod === 1) || (param.data.hasOwnProperty("consignment_status") && param.data.consignment_status === "Delivered" && param.data.hasOwnProperty('is_submitted_pod') && param.data.is_submitted_pod === 1 && param.data.hasOwnProperty('uploaded_pod_document'))) ;
    //             const handleClick = (e) => {
    //                 e.stopPropagation();
    //                 // if (!hasConsignmentStatus) {
    //                 //     onShowDocs(param);  
    //                 // }
    //                 onShowPodDoc(param)
    //                 // onShowDocs(param);  
    //             };        
    //             return (
    //                 <button 
    //                     onClick={handleClick} 
    //                     disabled={!enableViewIcon}
    //                     title="View POD Document"
    //                     style={{ 
    //                         border:"none",
    //                         backgroundColor:"transparent",
    //                         fontSize:"12px",
    //                         cursor: "pointer" 
    //                     }}
    //                 >
    //                     <i className="fa fa-file f17"></i> 
    //                 </button>
    //             );
    //         },
    //     },
    //     {
    //         headerName: "",
    //         field: "cancel_order",
    //         colId: "cancel_order",
    //         width: 50,
    //         pinned: "left",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 const hasConsignmentStatus = param.data.hasOwnProperty("consignment_status");
    //                 const hasLrNo = param.data.hasOwnProperty("lr_no");
    //                 const isConditionMet = (hasConsignmentStatus || hasLrNo) && 
    //                                        (param.data.consignment_status === "In Transit" || 
    //                                         param.data.consignment_status === "Dispatched from Source" || 
    //                                         param.data.consignment_status === "Invalid docket" ||
    //                                         param.data.consignment_status === "Booked");
    //                 if (isConditionMet) {
    //                     return {
    //                         component: CancelCourierConsignments,
    //                         params: {
    //                             onClickActive: onClickCancelActiveCourierConsignemnts,
    //                             disabled: false ,
    //                             tracking_type: "PTL1"
    //                         }
    //                     };
    //                 }
    //                 if(hasConsignmentStatus && (param.data.consignment_status === "Delivered" || param.data.consignment_status === "Cancelled")){
    //                     return {
    //                         component: CancelCourierConsignments,
    //                         params: {
    //                             onClickActive: onClickCancelActiveCourierConsignemnts,
    //                             disabled: true ,
    //                             tracking_type: "PTL"
    //                         }
    //                     };
    //                 }
    //                 else if( param.data.status === 4 || param.data.status === 6 || param.data.status==8 || param.data.status ===9){
    //                     return {
    //                         component: CancelCourierConsignments,
    //                         params: {
    //                             onClickActive: onShowForceCloseModal,
    //                             disabled: true ,
    //                             tracking_type: "FTL"
    //                         }
    //                     };
    //                 }
    //                 else {
    //                     return {
    //                         component: CancelCourierConsignments,
    //                         params: {
    //                             onClickActive: onShowForceCloseModal,
    //                             tracking_type: "FTL"
    //                         }
    //                     };
    //                 }
        
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "",
    //         field: "sendemail",
    //         colId: "sendemail",
    //         width: 50,
    //         cellRenderer:SendEmail,
    //         filter: false,
    //         pinned: "left",
    //         cellRendererSelector: function (param) {
    //             try {
    //                 if (param.data._id != null && param.data._id != undefined) {
    //                     // if(param.data.status == 2 || param.data.status == 3 || param.data.consignment_status ==="Dispatched from Source" || param.data.consignment_status ==="Out For Delivery" || param.data.consignment_status === "In Transit"){
    //                         return {
    //                             component: SendEmail,
    //                             params: {
    //                                 onClickEmail: onClickEmail
    //                             }
    //                         }
    //                     // }
    //                     // if(param.data.status === 4 || param.data.consignment_status === "Delivered"){
    //                     //     return {
    //                     //         component: SendEmail,
    //                     //         params: {
    //                     //             onClickEmail: onClickEmail
    //                     //         }
    //                     //     }
    //                     // }
                       
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //             }
    //         },
    //         headerClass: 'bold-header'
    //     },       
    //     // {
    //     //     headerName: "View Document",
    //     //     field: "view_document",
    //     //     width: 130,
    //     //     filter: false,
    //     //     pinned: "left",
    //     //     headerClass: 'bold-header',
    //     //     // hide: tabName.value !== 'active' || tabName.value !== "all",
    //     //     cellRenderer: (param) => {
    //     //         const enableDocument = (!param.data.hasOwnProperty("uploaded_document"));                
    //     //         const handleClick = (e) => {
    //     //             e.stopPropagation();
    //     //             onShowDocs(param);  
    //     //         };        
    //     //         return (
    //     //             <button 
    //     //                 onClick={handleClick} 
    //     //                 title="View Document"
    //     //                 disabled={enableDocument}
    //     //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
    //     //                 style={{ 
    //     //                     border:"none",
    //     //                     backgroundColor:"transparent"
    //     //                     // fontSize:"15px",
    //     //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
    //     //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
    //     //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
    //     //                     // cursor: "pointer" 
    //     //                 }}
    //     //             >
    //     //                 <i className="fa fa-eye f15"></i> 
    //     //             </button>
    //     //         );
    //     //     },
    //     // }, 
    //     // {
    //     //     headerName: "View POD Document",
    //     //     field: "view_pod_document",
    //     //     width: 160,
    //     //     filter: false,
    //     //     pinned: "left",
    //     //     headerClass: 'bold-header',
    //     //     cellRenderer: (param) => {
    //     //         const enableDocument = (!param.data.hasOwnProperty("uploaded_pod_document"));                

    //     //         const handleClick = (e) => {
    //     //             e.stopPropagation();
    //     //             // if (!hasConsignmentStatus) {
    //     //             //     onShowDocs(param);  
    //     //             // }
    //     //             onShowPodDoc(param)
    //     //             // onShowDocs(param);  
    //     //         };        
    //     //         return (
    //     //             <button 
    //     //                 onClick={handleClick} 
    //     //                 title="View POD Document"
    //     //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
    //     //                 style={{ 
    //     //                     border:"none",
    //     //                     backgroundColor:"transparent",
    //     //                     fontSize:"12px",
    //     //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
    //     //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
    //     //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
    //     //                     cursor: "pointer" 
    //     //                 }}
    //     //                 disabled={enableDocument}
    //     //             >
    //     //                 <i className="fa fa-eye f15"></i> 
    //     //             </button>
    //     //         );
    //     //     },
    //     // },
                
    //     {
    //         headerName: "Tracking Mode" ,
    //         field: "tracking_type",
    //         colId: "tracking_type",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "SIM Consent Status" ,
    //         field: "sim_consent_status",
    //         colId: "sim_consent_status",
    //         // hide: (tabName.value === "inactive"),
    //         width: 200,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header',
    //         valueGetter:(params)=>{
    //             if(params.data.sim_issue===0){
    //                 return "Consent Approved"
    //             }else if(params.data.sim_issue>0 ){
    //                 return "Consent Pending"
    //             }else{
    //                 return ""
    //             }
    //         }
    //     },
    //     {
    //         headerName: "LR No" ,
    //         field: "lr_no",
    //         colId: "lr_no",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Invoice No",
    //         field: "invoice_no",
    //         colId: "invoice_no",
    //         width: 150,
    //         resizable: true,
    //         headerClass: 'bold-header',
    //     }
    //     ,
                 
    //     {
    //         headerName: "Vehicle No" ,
    //         field: "truck_no",
    //         colId: "truck_no",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Status",
    //         field: "status",
    //         colId: "status",
    //         filter: "agSetColumnFilter",
    //         valueFormatter: (params) => {
    //             const statusMap = {
    //                 0:"Invoiced",
    //                 1: "At Source",
    //                 2: "In Transit",
    //                 3: "Near Destination",
    //                 4: "Reached Destination",
    //                 5: "Left Dealer",
    //                 6: "Force Closure",
    //                 7: "Provision",
    //                 8: "Trip Completed"
    //             };
    
    //             const consignmentStatus = params.data?.consignment_status;
    //             const status = params.data?.status;
    
    //             if (consignmentStatus) {
    //                 return consignmentStatus;
    //             }
    //             return statusMap[status] || "Not Available";
    //         },
    //         filterParams: {
    //             values: (params) => {
    //                 const statusMap = {
    //                     1: "At Source",
    //                     2: "In Transit",
    //                     3: "Near Destination",
    //                     4: "Reached Destination",
    //                     5: "Left Dealer",
    //                     6: "Force Closure",
    //                     7: "Provision",
    //                     8: "Trip Completed",
    //                     9: "Cancelled"
    //                 };
    
    //                 const uniqueValues = new Set();
    //                 params.api.forEachNode((node) => {
    //                     if (node.data) {
    //                         const consignmentStatus = node.data.consignment_status;
    //                         const statusText = consignmentStatus
    //                             ? consignmentStatus
    //                             : statusMap[node.data.status] || "Not Available";
    //                         uniqueValues.add(statusText);
    //                     }
    //                 });
    
    //                 params.success(Array.from(uniqueValues));
    //             },
    //             refreshValuesOnOpen: true
    //         },
    //         filterValueGetter: (params) => {
    //             const statusMap = {
    //                 1: "At Source",
    //                 2: "In Transit",
    //                 3: "Near Destination",
    //                 4: "Reached Destination",
    //                 5: "Left Dealer",
    //                 6: "Force Closure",
    //                 7: "Provision",
    //                 8: "Trip Completed"
    //             };
    
    //             const consignmentStatus = params.data?.consignment_status;
    //             const status = params.data?.status;
    
    //             if (consignmentStatus) {
    //                 return consignmentStatus;
    //             }
    //             return statusMap[status] || "Not Available";
    //         }
    //     },
    //     {
    //         headerName: "Reason For Delay" ,
    //         field: "reason_for_delay",
    //         colId: "reason_for_delay",
    //         width: 180,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },                
    //     {
    //         headerName: "Invoice Date",
    //         field: "invoice_time",
    //         colId: "invoice_time",
    //         width: 180,
    //         cellRenderer: '', resizable: true,
    //         comparator: dateComparator,
    //         valueGetter: function (params) {
    //             if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
    //                 return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
    //             }
    //             else {
    //                 return "NA";
    //             }
    //         },
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Dispatch Date" ,
    //         field: "dispatch_date",
    //         colId: "dispatch_date",
    //         width: 150,
    //         //filter: "agDateColumnFilter",
    //         cellRenderer: '', resizable: true,
    //         comparator: dateComparator,

    //         valueGetter: function (params) {
    //             const dispatchDate = params.data.dispatch_date;
    //             if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
    //                 // Call date formatting only when the dispatch date is valid
    //                 const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
    //                 // Check if formattedDate is valid, otherwise return "NA"
    //                 return formattedDate !== "Invalid Date" ? formattedDate : "NA";
    //             } else {
    //                 return "NA";
    //             }
    //         },
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Consignee Name",
    //         field: "consignee_name",
    //         colId: "consignee_name",
    //         width: 180,
    //         filter: "agSetColumnFilter",
    //         cellRenderer: '',
    //         resizable: true,
    //         valueGetter: function (params) {
    //             if (params.data.customer_name != "" && params.data.customer_name != "") {
    //                 return params.data.customer_name
    //             }
    //         },
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Entity" ,
    //         field: "truck_seal_entity",
    //         colId: "truck_seal_entity",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         valueGetter: function (params) {
    //             if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != "") {
    //                 return capitalizeWords(params.data.truck_seal_entity)
    //             }
    //         },
    //         headerClass: 'bold-header'
    //     },               
    //     {
    //         headerName: "Invoice Type" ,
    //         field: "invoice_type",
    //         colId: "invoice_type",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Transporter",
    //         field: "transporter_name",
    //         colId: "transporter_name",
    //         width: 180,
    //         filter: "agSetColumnFilter",
    //         cellRenderer: '',
    //         resizable: true,
    //         valueGetter: function (params) {
    //             if (params.data.transporter_name != "" && params.data.transporter_name != "") {
    //                 return capitalizeWords(params.data.transporter_name)
    //             }
    //         },
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Source City" ,
    //         field: "consigner_city",
    //         colId: "consigner_city",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },  
    //     {
    //         headerName: "Source Pincode" ,
    //         field: "consigner_pincode",
    //         colId: "consigner_pincode",
    //         width: 180,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Source Zone" ,
    //         field: "consigner_zone",
    //         colId: "consigner_zone",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Destination City" ,
    //         field: "consignee_city",
    //         colId: "consignee_city",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Destination Pincode" ,
    //         field: "consignee_pincode",
    //         colId: "consignee_pincode",
    //         width: 180,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Destination State" ,
    //         field: "consignee_state",
    //         colId: "consignee_state",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Destination Zone",
    //         field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
    //         colId: "consignee_zone",
    //         width: 150,
    //         resizable: true,
    //         headerClass: 'bold-header',
            
    //         // Use valueGetter to dynamically return the correct field based on tracking type
    //         valueGetter: (params) => {
    //             if (params.data.tracking_type === "FTL") {
    //                 return params.data.consignee_zone; // If tracking is FTL, use consignee_zone
    //             } else if (params.data.tracking_type === "PTL") {
    //                 return params.data.zone; // If tracking is PTL, use zone
    //             }
    //             return null; // Return null or empty if neither condition is met
    //         }
    //     },
    //     {
    //         headerName: "Mobile Number" ,
    //         field: "driver_mobile_no",
    //         colId: "driver_mobile_no",
    //         // hide: (tabName.value === "inactive"),
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Movement Type" ,
    //         field: "movement_type",
    //         colId: "movement_type",
    //         // hide: (tabName.value === "inactive"),
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Total Weight",
    //         field: "total_weight",
    //         colId: "total_weight",
    //         width: 150,
    //         resizable: true,
    //         headerClass: 'bold-header',
          
    //     },
    //     {
    //         headerName: "Total CBM",
    //         field: "total_cbm",
    //         colId: "total_cbm",
    //         width: 150,
    //         resizable: true,
    //         headerClass: 'bold-header',
           
    //     },
        
    //     {
    //         headerName: "Transporter Category" ,
    //         field: "tpt_category",
    //         colId: "tpt_category",
    //         width: 190,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Vehicle Type" ,
    //         field: "truck_type",
    //         colId: "truck_type",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Truck Seal No" ,
    //         field: "truck_seal_no",
    //         colId: "truck_seal_no",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "ODA",
    //         field: "origin_destination_area",
    //         colId: "origin_destination_area",
    //         width: 150,
    //         cellRenderer: '',
    //         headerClass: 'bold-header',
    //         resizable: true,
    //     },
    //     {
    //         headerName: "TAT" ,
    //         field: "transit_time",
    //         colId: "transit_time",
    //         // hide: (tabName.value === "inactive"),
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
        
    //     {
    //         headerName: "Event Date & Time",
    //         field: "event_date_time",
    //         colId: "event_date_time",
    //         width: 180,
    //         resizable: true,
    //         comparator: dateComparator,
    //         valueGetter: function (params) {
    //             if (params.data.status === 2) {
    //                 // Use 'status' logic
    //                 return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
    //             }  else if (params.data.status === 3 || params.data.status === 4 || params.data.status === 8) {
    //                 // Use 'consignment_status' logic
    //                 return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
    //             }else  if (params.data.status === 6) {
    //                 // Use 'status' logic
    //                 return getHyphenDDMMMYYYYHHMM(params.data.force_closure_time);
    //             }
    //             else if (params.data.tracking_type === "PTL") {
    //                 // Use 'consignment_status' logic
    //                 return getHyphenDDMMMYYYYHHMM(params.data.last_event_time);
    //             } else {
    //                 // Default to empty string if neither condition is met
    //                 return "";
    //             }
    //         },
    //         headerClass: 'bold-header',
    //     },
    //     {
    //         headerName: "Last Data Received On",
    //         field: "last_process_on",
    //         colId: "last_process_on",
    //         width: 180,
    //         cellRenderer: '',
    //         resizable: true,
    //         comparator: dateComparator,
    //         valueGetter: function (params) {
    //             const { data: { tracking_type, truck_no, last_process_on } } = params;
        
    //             if (tracking_type === "FTL") {
    //                 const truckLocation = truckLocations?.find(location => location.truck_no === truck_no);
    //                 return truckLocation?.latest_sim_packet 
    //                     ? getHyphenDDMMMYYYYHHMM(truckLocation.latest_sim_packet)
    //                     : "NA";
    //             } 
        
    //             if (tracking_type === "PTL") {
    //                 return last_process_on 
    //                     ? getHyphenDDMMMYYYYHHMM(last_process_on)
    //                     : "NA";
    //             }
        
    //             return "NA";
    //         },
    //         headerClass: 'bold-header',
    //     }
    //     ,    
    //     {
    //         headerName: "Expected ETA", // Estimated delivery date
    //         field: "expected_trip_end",
    //         colId: "expected_trip_end",
    //         width: 150,
    //         resizable: true,
    //         comparator: dateComparator,
    //         valueGetter: function (params) {
    //             if (params.data.tracking_type === "FTL") {
    //                 // Check if expected_trip_end is not null or undefined
    //                 return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
    //             } else {
    //                 // Use expected_eta for non-FTL tracking types
    //                 return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
    //             }
    //         },
    //         headerClass: 'bold-header'

    //     },
        
    //     {
    //         headerName: "Revised Estimated Delivery Date",
    //         field: "revised_trip_end",
    //         colId: "revised_trip_end",
    //         width: 240,
    //         // hide: (tabName.value === "inactive"),
    //         cellRenderer: '', resizable: true,
    //         comparator: dateComparator,
    //         valueGetter: function (params) {
    //             if (params.data.tracking_type === "FTL") {
    //                 // Check if expected_trip_end is not null or undefined
    //                 return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
    //             } else {
    //                 // Use expected_eta for non-FTL tracking types
    //                 return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
    //             }
    //         },
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Actual Delivery Date",
    //         field: "recent_dealer_reported",
    //         colId: "recent_dealer_reported",
    //         width: 180,
    //         // hide: (tabName.value === "inactive"),
    //         cellRenderer: '', 
    //         resizable: true,
    //         comparator: dateComparator,
    //         valueGetter: function (params) {
    //             try {
    //                 // Check if consignment_status exists and determine if it's disabled
    //                 const hasConsignmentStatus = params.data.hasOwnProperty("consignment_status");
    //                 const isDisable = hasConsignmentStatus && (
    //                     params.data.consignment_status === "Cancelled" || 
    //                     params.data.consignment_status === "Dispatched from Source" || 
    //                     params.data.consignment_status === "In Transit" || 
    //                     params.data.consignment_status === "Out For Delivery" || 
    //                     params.data.consignment_status === "Undelivered" || 
    //                     params.data.consignment_status === "Booked"
    //                 );
    //                 const isDisable1 = !hasConsignmentStatus && (
    //                     params.data.status === 6 || 
    //                     params.data.status === 1 || 
    //                     params.data.status === 2 || 
    //                     params.data.status === 3 
    //                 );
        
    //                 // Return actual delivery date only if not disabled, otherwise return "NA"
    //                 if (!isDisable && !isDisable1) {
    //                     if (params.data.tracking_type === "FTL"){
    //                         if (params.data.recent_dealer_reported && params.data.recent_dealer_reported.trim() !==""){
    //                             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported)
    //                         }else{
    //                             return ""
    //                         }
    //                     }else if(params.data.tracking_type === 'PTL'){
    //                         if (params.data.delivery_datetime && params.data.delivery_datetime.trim() !==""){
    //                             return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime)
    //                         }else{
    //                             return ""
    //                         }
    //                     }
    //                     else {
    //                         return "";
    //                     }
    //                 } else {
    //                     return ""; // If conditions are disabled, return "NA"
    //                 }
    //             } catch (err) {
    //                 //console.log(err);
    //                 return ""; // In case of an error, return "NA"
    //             }
    //         },
    //         editable: function (params) {
    //             // Make field editable only if role is 'admin'
    //             return decode(localStorageRole) === "admin";
    //         },
    //         headerClass: 'bold-header'
    //     },
        
    //     {
    //         headerName: "Delay Days",
    //         field: "transit_delay_hours",
    //         colId: "transit_delay_hours",
    //         width: 180,
    //         // hide: (tabName.value !== 'completed' && tabName.value !== "all"),
    //         resizable: true,
    //         headerClass: 'bold-header',
    //         valueFormatter: (params) => {
    //             const hours = params.value;
    //             if (hours !== undefined && hours !== null) {
    //                 // Convert hours to days and round to the nearest whole number
    //                 const days = Math.round(hours / 24);  // Round to nearest whole number
    //                 return `${days}`;
    //             }
    //             return ''; // Return empty if no value
    //         }
    //     },
    //     // {
    //     //     headerName: "Delay Days Bucket" ,
    //     //     field: "delay_days_bucket",
    //     //     width: 180,
    //     //     cellRenderer: '', resizable: true,
    //     //     headerClass: 'bold-header'
    //     // },
    //     {
    //         headerName: "Performance" ,
    //         field: "ontime_status",
    //         width: 180,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header',
    //         valueGetter: (params)=>{
    //             if(params.data.ontime_status ===1){
    //                 return "Ontime"
    //             }else  if(params.data.ontime_status ===0){
    //                 return "Delay"
    //             }
    //         }
    //     },
    //     {
    //         headerName: "E-Way Bill No" ,
    //         field: "eway_bill_no",
    //         colId: "eway_bill_no",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     }, 
    //     {
    //         headerName: "Mode" ,
    //         field: "shipment_mode",
    //         colId: "shipment_mode",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },   
    //     {
    //         headerName: "Fuel Type" ,
    //         field: "fuel_type",
    //         colId: "fuel_type",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "No Of Boxes" ,
    //         field: "no_of_boxes",
    //         colId: "no_of_boxes",
    //         width: 150,
    //         cellRenderer: '', resizable: true,
    //         headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Reason" ,
    //         field: "remarks",
    //         colId: "remarks",
    //         width: 180,
    //         resizable: true,
    //         headerClass: 'bold-header',
    //         hide: showUndelivered,
    //         valueGetter: (params) => {
    //             return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
    //         },
            
    //         // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
    //         cellRenderer: (params) => {
    //             if (params.data.consignment_status === 'Undelivered') {
    //                 return params.value; // Show the remark if status is 'Undelivered'
    //             }
    //             return ''; // Return empty string for other statuses
    //         },
            
    //         // hide: false
    //     },
    // ]
    var forceCloseCodefs = [ 
            
        // {
        //     headerName: "",
        //     field: "Group",
        //     colId: "Group",
        //     width: 50,
        //     pinned: "left",
        //     // hide: tabName.value === "completed" || tabName.value === "inactive",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: GroupIconRenderer,
        //                     params: {
        //                         onShowTransitData: onShowTransitData,
        //                         onShowNoGPSData: onShowNoGPSData,
        //                         onShowStoppagesData: onShowStoppagesData,
        //                         onShowUploadDoc: onShowUploadDoc,
        //                         onShowDocs: onShowDocs,
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
       
       
         
       
       
       
             
        // {
        //     headerName: "View Document",
        //     field: "view_document",
        //     width: 130,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     // hide: tabName.value !== 'active' || tabName.value !== "all",
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_document"));                
        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View Document"
        //                 disabled={enableDocument}
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent"
        //                     // fontSize:"15px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     // cursor: "pointer" 
        //                 }}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // }, 
        // {
        //     headerName: "View POD Document",
        //     field: "view_pod_document",
        //     width: 160,
        //     filter: false,
        //     pinned: "left",
        //     headerClass: 'bold-header',
        //     cellRenderer: (param) => {
        //         const enableDocument = (!param.data.hasOwnProperty("uploaded_pod_document"));                

        //         const handleClick = (e) => {
        //             e.stopPropagation();
        //             // if (!hasConsignmentStatus) {
        //             //     onShowDocs(param);  
        //             // }
        //             onShowPodDoc(param)
        //             // onShowDocs(param);  
        //         };        
        //         return (
        //             <button 
        //                 onClick={handleClick} 
        //                 title="View POD Document"
        //                 // title={hasConsignmentStatus ? "View Document (Disabled)" : "View Document"}
        //                 style={{ 
        //                     border:"none",
        //                     backgroundColor:"transparent",
        //                     fontSize:"12px",
        //                     // pointerEvents: hasConsignmentStatus ? "none" : "auto", 
        //                     // opacity: hasConsignmentStatus ? 0.5 : 1, 
        //                     // cursor: hasConsignmentStatus ? "not-allowed" : "pointer"
        //                     cursor: "pointer" 
        //                 }}
        //                 disabled={enableDocument}
        //             >
        //                 <i className="fa fa-eye f15"></i> 
        //             </button>
        //         );
        //     },
        // },
                
        {
            headerName: "Tracking Mode" ,
            field: "tracking_type",
            colId: "tracking_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "LR No" ,
            field: "lr_no",
            colId: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            colId: "invoice_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        }
        ,
                 
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            colId: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            colId: "status",
            valueGetter: (params) => {
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;
        
                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        
            // filterParams: {
            //     values: (params) => {
            //         const uniqueValues = new Set();
            //         try {
            //             params.api.forEachNodeAfterFilter((node) => {
            //                 if (node.data) {
            //                     const statusMap = {
            //                         0: "Invoiced",
            //                         1: "At Source",
            //                         2: "In Transit",
            //                         3: "Near Destination",
            //                         4: "Delivered",
            //                         5: "Left Dealer",
            //                         6: "Force Closure",
            //                         7: "Provision",
            //                         8: "Trip Completed",
            //                     };
        
            //                     let status = statusMap[node.data.status] || node.data.status;
            //                     let consignmentStatus = node.data.consignment_status;
        
            //                     let statusText = consignmentStatus || status || "Not Available";
            //                     uniqueValues.add(statusText);
            //                 }
            //             });
        
            //             params.success(Array.from(uniqueValues));
            //         } catch (error) {
            //             console.error("Error in filterParams.values:", error);
            //             params.success([]);
            //         }
            //     },
            //     refreshValuesOnOpen: false, // ✅ Ensure filter dropdown updates dynamically
            // },
        
            // filterValueGetter: (params) => {
            //     const statusMap = {
            //         0: "Invoiced",
            //         1: "At Source",
            //         2: "In Transit",
            //         3: "Near Destination",
            //         4: "Delivered",
            //         5: "Left Dealer",
            //         6: "Force Closure",
            //         7: "Provision",
            //         8: "Trip Completed",
            //     };
        
            //     return params.data?.consignment_status || statusMap[params.data?.status] || params.data?.status || "Not Available";
            // }
        }
        
        ,
        {
            headerName: "Reason For Delay" ,
            field: "reason_for_delay",
            colId: "reason_for_delay",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },                
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            colId: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            colId: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date" ,
            field: "created_date",
            colId: "created_date",
            width: 160,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const lrDate = params.data.created_date;
                if (lrDate && lrDate.trim() !== '' && lrDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(lrDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignor Name",
            field: "consigner_name",
            colId: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name !== "" && params.data.consigner_name !== undefined) {
                    return capitalizeWords(params.data.consigner_name)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            colId: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            colId: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function(params){
                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                    return capitalizeWords(params.data.consignee_name)
                }else{
                    return ""
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            colId: "truck_seal_entity",
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },               
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            colId: "invoice_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
            colId: "transporter_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name):"")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City" ,
            field: "consigner_city",
            colId: "consigner_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },  
        {
            headerName: "Source Pincode" ,
            field: "consigner_pincode",
            colId: "consigner_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Source Zone" ,
            field: "consigner_zone",
            colId: "consigner_zone",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            colId: "consignee_city",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            colId: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            colId: "consignee_state",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination Zone",
            field: "consignee_zone", // This can be the default field, but will be dynamically overridden by valueGetter
            colId: "consignee_zone",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
           
        },
        {
            headerName: "Mobile Number" ,
            field: "driver_mobile_no",
            colId: "driver_mobile_no",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Movement Type" ,
            field: "movement_type",
            colId: "movement_type",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Total Weight",
            field: "lr_total_weight",
            colId: "total_weight",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
          
        },
        {
            headerName: "Total CBM",
            field: "lr_total_cbm",
            colId: "total_cbm",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                // Ensure the value is a valid number
                const value = parseFloat(params.value);
                return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
            }
        },
        
        {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Vehicle Type" ,
            field: "truck_type",
            colId: "truck_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Truck Seal No" ,
            field: "truck_seal_no",
            colId: "truck_seal_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "ODA",
            field: "oda",
            colId: "oda",
            width: 150,
            cellRenderer: '',
            headerClass: 'bold-header',
            resizable: true,
        },
        {
            headerName: "TAT" ,
            field: "transit_time",
            colId: "transit_time",
            // hide: (tabName.value === "inactive"),
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Event Date & Time",
            field: "last_event_time",
            colId: "last_event_time",
            width: 180,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
               return params.data.last_event_time ? getHyphenDDMMMYYYYHHMM(params.data.last_event_time) : "NA";
           },
            headerClass: 'bold-header',
        },
        {
                headerName: "Last Data Received On",
                field: "last_process_on",
                width: 200,
                resizable: true,
                comparator: dateComparator,
                valueGetter: (params) => {
                    const lastProcess = params.data.last_process_on ? moment.parseZone(new Date(params.data.last_process_on)).subtract(5, 'hours').subtract(30, 'minutes') : null;
                    const accessedApi = params.data.accessed_api_at ? moment.parseZone(new Date(params.data.accessed_api_at)).subtract(5, 'hours').subtract(30, 'minutes') : null;

                    let latestDate = null;
                    if (lastProcess && accessedApi) {
                        latestDate = lastProcess > accessedApi ? lastProcess : accessedApi;
                    } else if (lastProcess) {
                        latestDate = lastProcess;
                    } else if (accessedApi) {
                        latestDate = accessedApi;
                    }

                    return latestDate ? getHyphenDDMMMYYYYHHMM(latestDate) : "NA";
                },
                headerClass: 'bold-header'
            }, 
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            colId: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                }
            },
            headerClass: 'bold-header'

        },
        
        {
            headerName: "Revised Estimated Delivery Date",
            field: "revised_trip_end",
            colId: "revised_trip_end",
            width: 240,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.tracking_type === "FTL") {
                    // Check if expected_trip_end is not null or undefined
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                } else {
                    // Use expected_eta for non-FTL tracking types
                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Actual Delivery Date",
            field: "delivery_datetime",
            colId: "delivery_datetime",
            width: 180,
            // hide: (tabName.value === "inactive"),
            cellRenderer: '', 
            resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                try {
                    
                            if (params.data.delivery_datetime && params.data.delivery_datetime.trim() !==""){
                                return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime)
                            }else{
                                return ""
                            }
                      
                } catch (err) {
                    console.log(err);
                    return ""; // In case of an error, return "NA"
                }
            },
            // editable: function (params) {
            //     // Make field editable only if role is 'admin'
            //     return decode(localStorageRole) === "admin";
            // },
            headerClass: 'bold-header'
        },
        
        {
            headerName: "Delay Days",
            field: "transit_delay_days",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueFormatter: (params) => {
                const day = params.value;
                if (day !== undefined && day !== null) {
                    // Convert hours to days and round to the nearest whole number
                    const days = day;  // Round to nearest whole number
                    return `${days}`;
                }
                return ''; // Return empty if no value
            }
        },
        
        // {
        //     headerName: "Delay Days Bucket" ,
        //     field: "delay_days_bucket",
        //     width: 180,
        //     cellRenderer: '', resizable: true,
        //     headerClass: 'bold-header'
        // },
        {
            headerName: "Performance" ,
            field: "ontime_status",
            colId: "ontime_status",
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params)=>{
                 if (params.data && typeof params.data.sla_considered === "string" && params.data.sla_considered.toLowerCase() === "yes") {
                    return "Ontime";
                }
                else if(params.data.ontime_status ===1 && params.data.transit_delay ===0){
                     return "Ontime"
                 }else  if(params.data.ontime_status ===0 || params.data.transit_delay ===1){
                     return "Delay"
                 }
             }
        },
        {
            headerName: "E-Way Bill No" ,
            field: "eway_bill_no",
            colId: "eway_bill_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        }, 
        {
            headerName: "Mode" ,
            field: "shipment_mode",
            colId: "shipment_mode",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },   
        {
            headerName: "Fuel Type" ,
            field: "fuel_type",
            colId: "fuel_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "No Of Boxes" ,
            field: "total_boxes",
            colId: "no_of_boxes",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        // {
        //     headerName: "Reason" ,
        //     field: "remarks",
        //     colId: "remarks",
        //     width: 180,
        //     resizable: true,
        //     headerClass: 'bold-header',
        //     hide: showUndelivered,
        //     valueGetter: (params) => {
        //         return params.data.consignment_status === 'Undelivered' ? params.data.remarks : null;
        //     },
            
        //     // Optionally, use cellRenderer to show an empty cell or some message if not "Undelivered"
        //     cellRenderer: (params) => {
        //         if (params.data.consignment_status === 'Undelivered') {
        //             return params.value; // Show the remark if status is 'Undelivered'
        //         }
        //         return ''; // Return empty string for other statuses
        //     },
            
        //     // hide: false
        // },
    ]
   
    
    useEffect(() => {
        // Update columnDefs based on the selected view type
        const selectedActiveColumnDefs = searchViewType.value === "LR" ? activeDefs : activeConsignmentDefs;
        const selectedDeliveredColumnDefs = searchViewType.value === "LR" ? deliveredDefs : completedConsignmentDefs;
        const selectedAllColumnDefs = searchViewType.value === "LR" ? allCodefs : allConsignmentDefs;
        const selectedGridColState = searchViewType.value === "LR" ? gridColumnState : gridColumnState1;
        const selectedDeliveredGridColState = searchViewType.value === "LR" ? deliveredGridColumnState : deliveredGridColumnState1;
        const selectedAllGridColState = searchViewType.value === "LR" ? allGridColumnState : allGridColumnState1;
        // const selectedForceColDefs = searchViewType.value === "LR" ? forceCloseCodefs : activeConsignmentDefs;
        const selectedInactiveColumnDefs = searchViewType.value === "LR" ?  inactiveDefs: inactiveDefs;

        const selectedTptColumnDefs = searchViewType.value === "LR" ? transporterDefs : transporterDefs;

        setInactiveColumnDefs(selectedInactiveColumnDefs)
        setTptColumnDefs(selectedTptColumnDefs)
        setActiveColumnDefs(selectedActiveColumnDefs);
        setDeliveredColumnDefs(selectedDeliveredColumnDefs);
        setAllColumnDefs(selectedAllColumnDefs);
        // setForceCloseColumnDefs(selectedForceColDefs);
        setFinalGridColState(selectedGridColState);
        setFinalDeliveredColState(selectedDeliveredGridColState)
        setFinalAllColState(selectedAllGridColState)

        
    }, [searchViewType, processFlowType, tabName.value]); // Only depend on searchViewType
    useEffect(() => {
        // Update columns visibility and lock state when tab changes
        updateColumnVisibilityAndLock();
    }, [tabName.value, counterActive]); // Trigger update when tab changes or counterActive changes
    
    useEffect(() => {
        // Helper function to merge gridColumnState with columnDefs
        const mergeColumnDefs = (gridState, columnDefs) => {
            return gridState.map((header) => {
                const matchingDef = columnDefs.find((def) => def.colId === header.colId);
                return {
                    ...header,
                    ...(matchingDef || {}), // Preserve custom properties like cellRenderer
                };
            });
        };
    
        // Merge gridColumnState with active, delivered, and all columnDefs
        const gridColumnStateDefsInactive = invoiceGridColumnState.length > 0 
            ? mergeColumnDefs(invoiceGridColumnState, inactiveColumnDefs) 
            : inactiveColumnDefs;
        setFilterInActive(gridColumnStateDefsInactive);

        const gridColumnStateDefsTransporter = tptGridColumnState.length > 0 
            ? mergeColumnDefs(tptGridColumnState, tptColumnDefs) 
            : tptColumnDefs;
        setFilterTransporterDefs(gridColumnStateDefsTransporter);
    
        const gridColumnStateDefsActive = finalGridColState.length > 0 
            ? mergeColumnDefs(finalGridColState, activeColumnDefs) 
            : activeColumnDefs;
        setFilterActive(gridColumnStateDefsActive);
    
        const gridColumnStateDefsDelivered = finalDeliveredGridColState.length > 0 
            ? mergeColumnDefs(finalDeliveredGridColState, deliveredColumnDefs) 
            : deliveredColumnDefs;
        setFilterComplete(gridColumnStateDefsDelivered);
        const gridColumnStateDefsForceClose = finalGridColState.length > 0 
            ? mergeColumnDefs(finalGridColState,forceCloseCodefs) 
            : forceCloseCodefs;
        setFilterForceClose(gridColumnStateDefsForceClose);
    
        const gridColumnStateDefsAll = finalAllGridColState.length > 0 
            ? mergeColumnDefs(finalAllGridColState, allColumnDefs) 
            : allColumnDefs;
        setFilterAll(gridColumnStateDefsAll);
    }, [processFlowType,finalGridColState,finalDeliveredGridColState,finalAllGridColState,tptGridColumnState,invoiceGridColumnState,activeColumnDefs, deliveredColumnDefs, allColumnDefs,inactiveColumnDefs, tptColumnDefs, tabName.value]); // Ensure dependencies are in sync
    var deliveredColDefs = [...intransitColDefs];

    const nogpscols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPSMap,
                            params: {
                                onShowNoGPSRouteMap: onShowNoGPSRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Last Data Received",
            field: "last_packet_datetime",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.last_packet_datetime);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Data Received on",
            field: "packet_received_on",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.packet_received_on);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const transitdelaycols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapTransitAction,
                            params: {
                                onShowTransitRouteMap: onShowTransitRouteMap
                            }
                        }
                    }
                } catch (err) {
                    //console.log(err);
                }
            },
            width: 50,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Leg Start Time", field: "leg_start", width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_start);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Leg End Time", field: "leg_end_eta",
            width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_end_eta);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Exp. Leg Distance (KM)",
            field: "leg_expected_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.leg_expected_distance);
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Actual Leg Distance Covered (KM)",
            field: "actual_leg_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_leg_distance != '' && params.data.actual_leg_distance != undefined) {
                    return Math.round(params.data.actual_leg_distance);
                }
                else {
                    return 0;
                }
            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exp. Distance from Trip Start(KM)",
            field: "expected_distance_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.expected_distance_start_to_leg != '' && params.data.expected_distance_start_to_leg != undefined) {
                    return Math.round(params.data.expected_distance_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }

        },
        {
            headerName: "Actual Distance from Trip Start (KM)",
            field: "actual_distance_traveled_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_distance_traveled_start_to_leg != '' && params.data.actual_distance_traveled_start_to_leg != undefined) {
                    return Math.round(params.data.actual_distance_traveled_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },

        {
            headerName: "Google Distance from Start (KM)",
            field: "actual_start_to_leg_google_distance",
            width: 140,
            resizable: true,
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },
        {
            headerName: "GPS Data Available",
            field: "no_gps_data",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.no_gps_data == 1) {
                    return "Not Available";
                }
                if (params.data.no_gps_data == 0) {
                    return "Available";
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },


        {
            headerName: "Trip Completed",
            field: "trip_completed",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.trip_completed == 1) {
                    return "Yes";
                }
                if (params.data.trip_completed == 2) {
                    return "";
                }
                if (params.data.trip_completed == 0) {
                    return "";
                }

            },
            cellclassName: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const stoppagescols = [
        // {
        //     headerName: "",
        //     field: "_id",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: RoutemapenrouteAction,
        //                     params: {
        //                         onShowEnrouteRouteMap: onShowEnrouteRouteMap
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             //console.log(err);
        //         }
        //     },
        //     width: 50,
        //     suppressSizeToFit: true,
        // },
        {
            headerName: "Break Start",
            // field: "stoppage_start_time",
            field: "break_start",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.break_start != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.break_start)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break End",
            // field: "reset_datetime",
            field: "break_end",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.break_end != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.break_end)
                }
                else {
                    return '';
                }

            }
        },
        // {
        //     headerName: "Exception Closed On",
        //     field: "modified_date",
        //     width: 220,
        //     resizable: true,
        //     valueGetter: function (params) {
        //         if (params.data.exception_closed == 1) {

        //             if (params.data.modified_date != undefined) {
        //                 return getHyphenDDMMMYYYYHHMM(params.data.modified_date)
        //             }
        //             else {
        //                 return '';
        //             }
        //         }
        //         else {
        //             return '';
        //         }

        //     }
        // },
        // {
        //     headerName: "Break Time",
        //     // field: "elaped_time_from_last_moved_seconds",
        //     field: "break_time_seconds",
        //     width: 180,
        //     resizable: true,
        //     valueGetter: function (params) {
        //         if (params.data.exception_closed == 1) {
        //             var sdate = moment.parseZone(params.data.stoppage_start_time).format("x");
        //             if (typeof params.data.reset_datetime == 'undefined') {
        //                 var edate = moment.parseZone().format("x");
        //             }
        //             else {
        //                 var edate = moment.parseZone(params.data.reset_datetime).format("x");
        //             }
        //             var diff = (edate - sdate) / 1000;
        //             return secondsToString(diff);
        //         }
        //         else {
        //             return '';
        //         }
        //     }
        // },
        {
            headerName: "Break Time",
            // field: "elaped_time_from_last_moved_seconds",
            field: "break_time_seconds",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.break_time_seconds!= undefined) {
                    var diff = params.data.break_time_seconds
                    return secondsToString(diff);                }
                else {
                    return '';
                }
                    
                }
               
            },
        {
            headerName: "Break Address",
            field: "break_address",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.break_address) {
                    return params.data.break_address
                }
                else {
                    return '';
                }

            }

        }
    ]
    

    deliveredColDefs.splice(16, 0, {
        headerName: "Recent Destination",
        field: "last_location",
        width: 150,
        cellRenderer: '',
        resizable: true,
        headerClass: 'bold-header'
    });

    deliveredColDefs.push({
        headerName: "Delivery Station",
        field: "delivery_station",
        width: 150,
        cellRenderer: '',
        resizable: true,
        headerClass: 'bold-header'
    });

    var allColDefs = [...deliveredColDefs];
    var lrNoOptions = []
    const CounterClick = (ecounter) => {
        
        if (tabName.value == "active") {
          switch (ecounter) {
            case "Total":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                  
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.all);
              break;
            case "In Transit":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.inTransit);
              lrBasedSegData = activeTrips.inTransit.reduce((acc, cur) => {
                let curLrno = cur.lr_no;
                if (!acc[curLrno]) {
                  acc[curLrno] = new Set();
                }
                acc[curLrno].add(cur.invoice_no);
                return acc;
              }, []);
              lrNoOptions = Object.entries(lrBasedSegData)
                .map(([key, set]) => {
                  return Array.from(set).map((item) => ({
                    value: key,
                    label: item,
                  }));
                })
                .flat()
                .filter(
                  (option) =>
                    option.value && option.label && option.value !== "undefined"
                );
              setLrOptions(lrNoOptions);
              break;
            case "Out For Delivery":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.outForDelivery);
              break;
         case "Arrived At Destination":
            columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true                  );
              columnApiConsignments.current.setColumnsVisible(["remarks"], false);
            setCounterActive(ecounter);
            setColumnWithDefs(filterActive);
            setRowData(activeTrips.arrived_at_destination);
            break;
                case "SIM Issues":
                    columnApiConsignments.current.setColumnsVisible(
                        [
                          "cancel_order",
                          "map",
                          "shipmentlegs",
                          "Group",
                          "view_document",
                          "sendemail",
                        ],
                        true                  );
                      columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                    setCounterActive(ecounter);
                    setColumnWithDefs(filterActive);
                    setRowData(activeTrips.ftl_sim_issue);
                    break;
                case "Consent Pending":
                        columnApiConsignments.current.setColumnsVisible(
                            [
                              "cancel_order",
                              "map",
                              "shipmentlegs",
                              "Group",
                              "view_document",
                              "sendemail",
                            ],
                            true                  );
                        columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                        setCounterActive(ecounter);
                        setColumnWithDefs(filterActive);
                        setRowData(activeTrips.consent_pending);
                        break;
                case "Consent Acquired":
                            columnApiConsignments.current.setColumnsVisible(
                                [
                                  "cancel_order",
                                  "map",
                                  "shipmentlegs",
                                  "Group",
                                  "view_document",
                                  "sendemail",
                                ],
                                true                  );
                              columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                            setCounterActive(ecounter);
                            setColumnWithDefs(filterActive);
                            setRowData(activeTrips.consent_approved);
                            break;
                case "Location Data Acquired":
                                columnApiConsignments.current.setColumnsVisible(
                                    [
                                      "cancel_order",
                                      "map",
                                      "shipmentlegs",
                                      "Group",
                                      "view_document",
                                      "sendemail",
                                    ],
                                    true                  );
                                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                                setCounterActive(ecounter);
                                setColumnWithDefs(filterActive);
                                setRowData(activeTrips.location_data_acquired);
                                break;
            case "Disabled":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.cancelled);
              break;
            case "Tracking N/A":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.tracking_na);
              break;
            case "Transit Delays":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.transit_delay);
              break;
            case "Stoppages":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.stoppages);
              break;
            case "Dispatched From Source":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                setCounterActive(ecounter);
                setColumnWithDefs(filterActive);
                setRowData(activeTrips.dispatched_from_source);
                break;    
            case "At Source":
                     columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true                  );
              columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                    setCounterActive(ecounter);
                    setColumnWithDefs(filterActive);
                    setRowData(activeTrips.at_source);
                break;        
            case "accidents":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              current_defs = [...intransitColDefs];
              setRowData(activeTrips.accidents);
              break;
            case "trip_deviations":
                columnApiConsignments.current.setColumnsVisible(
                    [
                      "cancel_order",
                      "map",
                      "shipmentlegs",
                      "Group",
                      "view_document",
                      "sendemail",
                    ],
                    true                  );
                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              current_defs = [...intransitColDefs];
              setRowData(activeTrips.trip_deviations);
              break;
              case "Undelivered":
                columnApiConsignments.current.setColumnsVisible(
                  [
                    "cancel_order",
                    "map",
                    "shipmentlegs",
                    "Group",
                    "view_document",
                    "sendemail",
                  ],
                  true
                );
                columnApiConsignments.current.setColumnsVisible(["remarks"], true);
                setShowUndelivered(false);
                setCounterActive(ecounter);
                setRowData(activeTrips.undelivered);
                break;
            case "Loading Delay":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              setRowData(activeTrips.loading_delay);
              break;
            case "Unloading Delay":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              setRowData(activeTrips.unloading_delay);
              break;
            case "No GPS Available":
              setCounterActive("Tracking N/A");
              setColumnWithDefs(filterActive);
              setRowData(activeTrips.no_gps_data);
              break;
            case "no_gps_data_lifetime":
              setCounterActive(ecounter);
              setColumnWithDefs([...intransitColDefs]);
              setRowData(activeTrips.no_gps_data_lifetime);
              break;
            default:
              break;
          }
        } else if (tabName.value == "completed") {
          columnApiConsignments.current.setColumnsVisible(
            ["cancel_order"],
            false
          );
          switch (ecounter) {
            case "Total":
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.all);
              break;
            case "Delivered":
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.delivered);
              break;
            case "Delayed":
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.delayed);
              break;
            case "On Time":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                false
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.onTime);
              break;
            case "POD Pending":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.podPending);
              break;
            case "0-1 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.zeroToOneDays);
              break;
            case "1-2 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              {
                //console.log(completedTrips.oneToTwoDays, "2daysrowdata");
              }
              setRowData(completedTrips.oneToTwoDays);
              break;
            case "3-5 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.threeToFiveDays);
              break;
            case "6-10 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.sixToTenDays);
              break;
            case ">10 Days":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              columnApiConsignments.current.setColumnsVisible(
                ["upload_pod"],
                true
              );
              setCounterActive(ecounter);
              setRowData(completedTrips.gtTenDays);
              break;
            case "SIM Issues":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.ftl_sim_issue);
              break;
            case "Consent Pending":
              columnApiConsignments.current.setColumnsVisible(["Group"], false);
              setCounterActive(ecounter);
              setRowData(completedTrips.consent_pending);
              break;
            default:
              break;
          }
        } else if (tabName.value == "all") {
          switch (ecounter) {
            case "Total":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.all);
              break;
            case "At Source":
                columnApiConsignments.current.setColumnsVisible(
                  [
                    "cancel_order",
                    "map",
                    "shipmentlegs",
                    "Group",
                    "view_document",
                    "sendemail",
                  ],
                  true
                );
                columnApiConsignments.current.setColumnsVisible(
                  ["remarks"],
                  false
                );
                setShowUndelivered(true);
                setCounterActive(ecounter);
                setRowData(allTrips.at_source);
                break;
             case "Arrived At Destination":
                columnApiConsignments.current.setColumnsVisible(
                  [
                    "cancel_order",
                    "map",
                    "shipmentlegs",
                    "Group",
                    "view_document",
                    "sendemail",
                  ],
                  true
                );
                columnApiConsignments.current.setColumnsVisible(
                  ["remarks"],
                  false
                );
                setShowUndelivered(true);
                setCounterActive(ecounter);
                setRowData(allTrips.arrived_at_destination);
                break;
                case "SIM Issues":
                    columnApiConsignments.current.setColumnsVisible(
                      [
                        "cancel_order",
                        "map",
                        "shipmentlegs",
                        "Group",
                        "view_document",
                        "sendemail",
                      ],
                      true
                    );
                    columnApiConsignments.current.setColumnsVisible(
                      ["remarks"],
                      false
                    );
                    setShowUndelivered(true);
                    setCounterActive(ecounter);
                    setRowData(allTrips.ftl_sim_issue);
                    break;     
                    case "Consent Pending":
                        columnApiConsignments.current.setColumnsVisible(
                            [
                              "cancel_order",
                              "map",
                              "shipmentlegs",
                              "Group",
                              "view_document",
                              "sendemail",
                            ],
                            true                  );
                        columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                        setCounterActive(ecounter);
                        setRowData(allTrips.consent_pending);
                        break;
                case "Consent Acquired":
                            columnApiConsignments.current.setColumnsVisible(
                                [
                                  "cancel_order",
                                  "map",
                                  "shipmentlegs",
                                  "Group",
                                  "view_document",
                                  "sendemail",
                                ],
                                true                  );
                              columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                            setCounterActive(ecounter);
                            setRowData(allTrips.consent_approved);
                            break;
                case "Location Data Acquired":
                                columnApiConsignments.current.setColumnsVisible(
                                    [
                                      "cancel_order",
                                      "map",
                                      "shipmentlegs",
                                      "Group",
                                      "view_document",
                                      "sendemail",
                                    ],
                                    true                  );
                                  columnApiConsignments.current.setColumnsVisible(["remarks"], false);
                                setCounterActive(ecounter);
                                setRowData(allTrips.location_data_acquired);
                                break;   
            case "Dispatched From Source":
                    columnApiConsignments.current.setColumnsVisible(
                      [
                        "cancel_order",
                        "map",
                        "shipmentlegs",
                        "Group",
                        "view_document",
                        "sendemail",
                      ],
                      true
                    );
                    columnApiConsignments.current.setColumnsVisible(
                      ["remarks"],
                      false
                    );
                    setShowUndelivered(true);
                    setCounterActive(ecounter);
                    setRowData(allTrips.dispatched_from_source);
                    break;
            case "In Transit":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.inTransit);
              break;
            case "Delivered":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.delivered);
              break;
            case "Tracking N/A":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive("Tracking N/A");
              setRowData(allTrips.tracking_na);
              break;
            case "Undelivered":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(["remarks"], true);
              setShowUndelivered(false);
              setCounterActive(ecounter);
              setRowData(allTrips.undelivered);
              break;
            case "Disabled":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                false
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.disabled);
              break;
            case "Transit Delays":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.transit_delay);
              break;
            case "Stoppages":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.stoppages);
              break;
            case "Out For Delivery":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.outForDelivery);
              break;
            case "Delivered":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.delivered);
              break;
           
            case "POD Pending":
              columnApiConsignments.current.setColumnsVisible(
                [
                  "cancel_order",
                  "map",
                  "shipmentlegs",
                  "Group",
                  "view_document",
                  "sendemail",
                ],
                true
              );
              columnApiConsignments.current.setColumnsVisible(
                ["remarks"],
                false
              );
              setShowUndelivered(true);
              setCounterActive(ecounter);
              setRowData(allTrips.podPending);
              break;
            case "accidents":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.accidents);
              break;
            case "trip_deviations":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.trip_deviations);
              break;
            case "Loading Delay":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.loading_delay);
              break;
            case "Unloading Delay":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.unloading_delay);
              break;
            case "No GPS Available":
              setCounterActive("Tracking N/A");
              setShowUndelivered(true);
              setRowData(allTrips.no_gps_data);
              break;
            case "no_gps_data_lifetime":
              setCounterActive(ecounter);
              setShowUndelivered(true);
              setRowData(allTrips.no_gps_data_lifetime);
              break;
            default:
              break;
          }
        } else if (tabName.value == "inactive") {
          columnApiConsignments.current.setColumnsVisible(["identity"], false);
          columnApiConsignments.current.setColumnsVisible(["Group"], false);
          columnApiConsignments.current.setColumnsVisible(
            ["update_tracking_status"],
            false
          );
          setRowData(inactiveTrips);
        }else if (tabName.value == "transporter") {
            columnApiConsignments.current.setColumnsVisible(["identity"], false);
            columnApiConsignments.current.setColumnsVisible(["Group"], false);
            columnApiConsignments.current.setColumnsVisible(
              ["update_tracking_status"],
              false
            );
            setRowData(transporterTrips1);
          }else if (tabName.value == "force_close") {
            columnApiConsignments.current.setColumnsVisible(["identity"], false);
            columnApiConsignments.current.setColumnsVisible(["Group"], false);
            columnApiConsignments.current.setColumnsVisible(
              ["update_tracking_status"],
              false
            );
            setRowData(closeTrips);
          }
    }
    const validateFormOrder = () => {
        const {
            lr_no, invoice_no, driver_mobile_no, source, truck_no, truck_seal_no, entity,
            vehicle_type, courier_partner, eway_bill_expiry_date, vehicle_capacity,
            consignee_name, movement_type, number_of_boxes, destination_pincode, destination_city
        } = formData;
    
        // Validate fields in order; return true if all fields are filled
        if (!lr_no) return false;
        if (!invoice_no) return false;
        if (!driver_mobile_no) return false;
        if (!source.value) return false;
        if (!truck_no) return false;
        if (!truck_seal_no) return false;
        if (!entity) return false;
        if (!vehicle_type.value) return false;
        if (!courier_partner.value) return false;
        if (!eway_bill_expiry_date) return false;
        if (!vehicle_capacity.value) return false;
        if (!consignee_name) return false;
        if (!movement_type) return false;
        if (!number_of_boxes) return false;
        if (!destination_pincode) return false;
        if (!destination_city) return false;
    
        return true; // All fields are filled
    };
    
const onCloseEmail = () => {
    // Close the slider
    setSliderEmailOpen(false);
    setEmail("")
    setWhatsapp_no("")
    setActiveForm("")
  }
  const handleCloseModal = () => {
    setIsEditLogsModalOpen(false); // Close the modal
    setFilteredLog(null); // Clear filtered log
    setOverlay("show-n")
};
  var onSubmitEmail = async (event) => {
    event.preventDefault(); 
    onCloseEmail();
    // (!email || !validateEmail(email)) 
    if(!activeForm){
        return;
    }
    if (activeForm === 'email') {
        if (!email || !validateEmail(email)) {
            setShow(true); 
            setTitle('Please Enter a Valid Email ID');
            setType('warning');
            setActiveForm("")
            return; // Stop the function if email validation fails
        }
    } else if (activeForm === 'whatsapp') {
        if (!whatsapp_no || !validatePhoneNumber(whatsapp_no)) {
            setShow(true); 
            setTitle('Please Enter a Valid Phone Number');
            setType('warning');
            setActiveForm("")
            return; // Stop the function if phone number validation fails
        }
    }

    setOverlay("show-m");
    await setLoadShow("show-m");

    var current_date = new Date()
    var current_date = new Date(current_date.setHours(current_date.getHours() - 1))


    var gateouttime = moment.parseZone(data.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
    if (data.gate_out_time ==="" || data.gate_out_time === undefined) {
        // if (data.dispatch_date) {
        //     gateouttime = moment.parseZone(data.dispatch_date).format('YYYY-MM-DD HH:mm:ss');
        // }
        if (data.shipment_time) {
            gateouttime = moment.parseZone(data.shipment_time).format('YYYY-MM-DD HH:mm:ss');
        }
    }

    var end_date;
    var edate;
    if(data.hasOwnProperty('status')){
        
        if (data.status == 6) {
            if (data.force_closure_time) {
                let splitT = data.force_closure_time.split('T');
                let yMD = splitT[0];
                let hMS = splitT[1];
                let hms1 = hMS.split('.');
                let finalHms = hms1[0];
                let final_end_date = yMD + ' ' + finalHms;
                end_date = final_end_date;
                edate = final_end_date;
            }
        } else if (data.status == 2 || data.status == 3) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            edate = getHyphenDDMMYYYYHHMMSS(end_date);
        } else if (data.status == 5) {
            if (data.left_dealer_marked) {
                end_date = data.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").replace(".855", " ").trim();
                edate = getHyphenDDMMYYYYHHMMSS(data.left_dealer_marked);
            }
        } else if (data.status == 4 || data.status == 8) {
            if (data.recent_dealer_reported) {
                end_date = data.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMYYYYHHMMSS(data.recent_dealer_reported);
            }
        } else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            edate = getHyphenDDMMYYYYHHMMSS(end_date);
        }
    
        if (!end_date) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        
        let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);

        var map_link = ["API", "Manual Upload"].includes(data.tpt_category) ? "" :"https://legrandgroup.autometrics.in/map/" + encryptedVal;
        // var map_link = "https://legrandgroup.autometrics.in/map/" + encryptedVal;
    
        var event_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        var event_date1 = getHyphenDDMMYYYYHHMMSS(event_date);
    
        if (email && validateEmail(email)){
            
            // Fetch the current status from the statusMap based on data.status
            let currentStatus = statusMap[data.status] || "Unknown Status";
           
            var dispatchDateFormat;
            if(data.dispatch_date!==""){
                // formatAdjustedDate(data.dispatch_date)
                // var date1 = moment(data.dispatch_date);
                // var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                // var time1 = adjustedTime1.toDate()
                // var timeString = time1.toDateString()
                // const date = new Date(timeString);

                // // Format date as "DD-MM-YYYY HH:mm:ss"
                // const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                dispatchDateFormat=formatAdjustedDate(data.dispatch_date)
                
            }
            const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat : "";
            var expectedDateFormat;
            if(data.expected_eta!==""){
                expectedDateFormat=formatAdjustedDate(data.expected_eta)
                
            }
            const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";
            
            let reqData = {
                tracking_type: data.tracking_type,
                truck_no: data.truck_no,
                Lr_no: data.lr_no,
                transporter_name: data?.transporter_name ?? "",
                dispatch_date: dispatchDateFormatted,                
                source: data?.consigner_city ?? "",
                destination: data?.consignee_city ?? "",
                current_eta: expectedDateFormatted,
                current_status: currentStatus,
                screen: "consignment",
                email: email,
                map_param: 1,
                map_link: map_link,
                shipment_id: data.shipment_id
            };
    
            var emailLogs = {
                dept_code: localStorage.getItem("dept_code"),
                useremail: decode(localStorage.getItem("email")),
                role: decode(localStorageRole),
                event_date: event_date1,
                screen: "FTL Consignments Email share link ",
                activity: "On sending tracking link to email",
                email_receiver:email
            }
            var combinedParams ={
                reqData,
                emailLogs
            }
        
            redirectURL.post("/consignments/sentemail", combinedParams)
                .then((response) => {
                    setLoadShow("show-m");
                    setOverlay("show-m");
                    try {
                        var records = response.data;
                        if (records.status == "Failure") {
                            setShow(true);
                            setTitle("No Route data available");
                            setType("danger");
                            setOverlay("show-n");
                            setLoadShow("show-n");
                        } else {
                            setShow(true);
                            setTitle("Email Sent Successfully");
                            setType("success");
                            setLoadShow("show-n");
                            setOverlay("show-n");
                        }
                    } catch (e) {
                        //console.log("e ", e);
                        setShow(true);
                        setTitle("No Route data available");
                        setType("danger");
                    } finally {
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                });
        }
        if (whatsapp_no && validatePhoneNumber(whatsapp_no)){
            
            
            if (whatsapp_no.length == 10) {
                expired_time = current_date.getTime() + (expired_time.value) * 24 * 60 * 60 * 1000
                let expired_date = moment.parseZone(new Date(expired_time)).format('YYYY-MM-DD HH:mm:ss')
                let expiry_date = await handleEncrypt(expired_date)
     
                // var from_date = moment.parseZone(new Date(current_date)).format('YYYY-MM-DD HH:mm:ss')
                var from_date = moment.parseZone(data.gate_out_time).format('YYYY-MM-DD HH:mm:ss');

                if(data.gate_out_time ==='' || data.gate_out_time === undefined){
                    // var from_date = moment.parseZone(data.dispatch_date).format('YYYY-MM-DD HH:mm:ss');
                    if (data.shipment_time) {
                        from_date = moment.parseZone(data.shipment_time).format('YYYY-MM-DD HH:mm:ss');
                    }
                }
               
                
                // var from_date = await handleEncrypt(from_date)
                var params={
                    shipment_id: data.shipment_id,
                    tracking_type: data.tracking_type
                }
                var updated_time;
                await redirectURL.post("/consignments/fetchLastUpdateTime", params).then((resp)=>{
                    if(resp.data.status==="success"){
                        updated_time= data.updated_time
                    }
                })
     
                // var link = `https://enmovil.io/truckdetails/sharelink/tptlogin/${data.truck_no}/${(from_date)}/${(expiry_date)}`
                let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);
                var link = "https://legrandgroup.autometrics.in/map/" + encryptedVal;                
                
                // Fetch the current status from the statusMap based on data.status
                const currentStatus = statusMap[data.status] || "Unknown Status";
                var dispatchDateFormat;
            if(data.dispatch_date!==""){
                dispatchDateFormat=formatAdjustedDate(data.dispatch_date)
                
            }
                const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat : "";
                var expectedDateFormat;
                if(data.expected_eta!==""){
                    expectedDateFormat=formatAdjustedDate(data.expected_eta)
                    
                }
                const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";

                var updateTimeDate;
                if(updated_time!==""){
                    updateTimeDate=formatAdjustedDate(updated_time)
                    
                }
                const updateTimeDateFormatted = updated_time ? updateTimeDate : "";

               

                var eventDateTime;
                if(data.status === 2){
                    eventDateTime=formatAdjustedDate(data.gate_out_time)

                }else if (data.status === 3 || data.status === 4 || data.status === 8) {
                    // Use 'consignment_status' logic
                    eventDateTime=formatAdjustedDate(data.recent_dealer_reported)

                }else  if (data.status === 6) {
                    // Use 'status' logic
                    eventDateTime=formatAdjustedDate(data.force_closure_time)

                }
                const eventTimeDateFormatted = eventDateTime ?eventDateTime:"" ;

                var lastLocation = data.last_location? data.last_location:"";


                // var message = `Truck Details:
                // Vehicle No: ${data.truck_no}
                // LR.No: ${data.lr_no}
                // Transporter: ${data.transporter_name}
                // Dispatch Date: ${dispatchDateFormatted}
                // Source: ${data.consigner_city}
                // Destination: ${data.consignee_city}
                // Current ETA: ${data.expected_eta}
                // Current Status: ${currentStatus}
                // Tracking Link: ${link}`;
                var message = `Truck Details:\nVehicle No: ${data.truck_no},\nLR.No: ${data.lr_no},\nTransporter: ${data.transporter_name},\nDispatch Date: ${dispatchDateFormatted},\nSource: ${data.consigner_city},\nDestination: ${data.consignee_city},\nCurrent ETA: ${expectedDateFormatted},\nLast Update Date: ${updateTimeDateFormatted},\nCurrent Status: ${currentStatus}, \nEvent Date & Time: ${eventTimeDateFormatted} \nEvent Location: ${lastLocation}`;

                if(!(["API", "Manual Upload"].includes(data.tpt_category))){
                    message+= `, \nTracking Link:`
                }
                const encodedMessage = encodeURIComponent(message);
                

                let message1 = `${encodedMessage}`;
                if(!(["API", "Manual Upload"].includes(data.tpt_category))){
                    message1+= `%0A${link}`
                }
                // Open WhatsApp with the truck details and the map link

                window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${message1}`, '_blank');


                // Open WhatsApp with the truck details and the map link
                // window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodeURIComponent(link)}`);
               
                // var message = `Truck Details:
                // Vehicle No: ${data.truck_no}
                // LR.No: ${data.lr_no}
                // Transporter: ${data.transporter_name}
                // Dispatch Date: ${dispatchDateFormatted}
                // Source: ${data.consigner_city}
                // Destination: ${data.consignee_city}
                // Current ETA: ${data.expected_eta}
                // Current Status- ${currentStatus}
                // Tracking Link: `;
                // // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}/${from_date}/${expiry_date}`)
                // // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}`)
                // // window.open(`https://api.whatsapp.com/send?text=${link}` , '_blank')
     
                // window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodeURIComponent(link)}`)
                
                setShow(true);
                setTitle("Whatsapp Sent Successfully");
                setType("success");
                setLoadShow("show-n");
                setOverlay("show-n")
                setActiveForm("");
                setexpired_time({ label: "7 Day", value: 7 })
                setWhatsapp_no("")
            }
            else {
                setShow(true);
                setTitle("WhatApp Number should be 10 Digits");
                setType("danger");
                setLoadShow("show-n");
                setOverlay("show-n");
               
            }
     
        
        }
    } 
    else{
        let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);

        // let encryptedVal = window.btoa(`${data.truck_no},${data.dispatch_date},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);
        var map_link = ["API", "Manual Upload"].includes(data.tpt_category) ? "" :"https://legrandgroup.autometrics.in/map/" + encryptedVal;
    
        var event_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        var event_date1 = getHyphenDDMMYYYYHHMMSS(event_date);
        var dispatchDateFormat;
            if(data.dispatch_date!==""){
                var date1 = moment(data.dispatch_date);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                dispatchDateFormat=formattedDate
                
            }
            var expectedDateFormat;
            if(data.expected_eta!==""){
                var date1 = moment(data.expected_eta);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                expectedDateFormat=formattedDate
                
            }
    
        if (email && validateEmail(email)){
            const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat : "";
            const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";

            
            let reqData = {
                tracking_type: data.tracking_type,
                lr_no: data.lr_no,
                truck_no: data.truck_no,
                transporter_name: data?.transporter_name ?? "",
                dispatch_date: dispatchDateFormatted,                
                source: data?.consigner_city ?? "",
                destination: data?.consignee_city ?? "",
                current_eta: expectedDateFormatted,
                current_status: data.consignment_status,
                screen: "consignment",
                email: email,
                shipment_id: data.shipment_id

            };
    
            let emailLogs = {
                dept_code: localStorage.getItem("dept_code"),
                useremail: decode(localStorage.getItem("email")),
                role: decode(localStorageRole),
                event_date: event_date1,
                screen: "PTL Courier Consignments Email share link ",
                activity: "On sending tracking Details to email",
                email_receiver:email
            }
            var combinedParams ={
                reqData,
                emailLogs
            }
        
            redirectURL.post("/consignments/sentemail", combinedParams)
                .then((response) => {
                    setLoadShow("show-m");
                    setOverlay("show-m");
                    try {
                        var records = response.data;
                        if (records.status == "Failure") {
                            setShow(true);
                            setTitle("No Route data available");
                            setType("danger");
                            setOverlay("show-n");
                            setLoadShow("show-n");
                        } else {
                            setShow(true);
                            setTitle("Email Sent Successfully");
                            setType("success");
                            setLoadShow("show-n");
                            setOverlay("show-n");
                        }
                    } catch (e) {
                        //console.log("e ", e);
                        setShow(true);
                        setTitle("No Route data available");
                        setType("danger");
                    } finally {
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                });
        }
        if (whatsapp_no && validatePhoneNumber(whatsapp_no)){
            var dispatchDateFormat;
            if(data.dispatch_date!==""){
                var date1 = moment(data.dispatch_date);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                dispatchDateFormat=formattedDate
                
            }
            var expectedDateFormat;
            if(data.expected_eta!==""){
                var date1 = moment(data.expected_eta);
                var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                var time1 = adjustedTime1.toDate()
                var timeString = time1.toDateString()
                const date = new Date(timeString);

                // Format date as "DD-MM-YYYY HH:mm:ss"
                const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                expectedDateFormat=formattedDate
                
            }
            
            
            if (whatsapp_no.length == 10) {
                expired_time = current_date.getTime() + (expired_time.value) * 24 * 60 * 60 * 1000
                let expired_date = moment.parseZone(new Date(expired_time)).format('YYYY-MM-DD HH:mm:ss')
                let expiry_date = await handleEncrypt(expired_date)
     
                var from_date = moment.parseZone(new Date(current_date)).format('YYYY-MM-DD HH:mm:ss')
                var from_date = await handleEncrypt(from_date)
                const dispatchDateFormatted = data?.dispatch_date ? dispatchDateFormat: "";
                const expectedDateFormatted = data?.expected_eta ? expectedDateFormat : "";

                var params={
                    shipment_id: data.shipment_id,
                    tracking_type: data.tracking_type
                }
                var updated_time;
                await redirectURL.post("/consignments/fetchLastUpdateTime", params).then((resp)=>{
                    if(resp.data.status==="success"){
                        
                    updated_time=resp.data.updated_time;
                    }
                })
                var updateTimeDate;
                if(updated_time!==""){
                    var date1 = moment(updated_time);
                    var adjustedTime1= date1.subtract(5, "hours").subtract(30, 'minutes')
                    var time1 = adjustedTime1.toDate()
                    var timeString = time1.toDateString()
                    const date = new Date(timeString);
    
                    // Format date as "DD-MM-YYYY HH:mm:ss"
                    const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                    updateTimeDate=formattedDate
                    
                }
                const updateTimeDateFormatted = updated_time ? updateTimeDate : "";

                var eventDateTime;
                if (data.last_event_time) {
                    eventDateTime=formatAdjustedDate(data.last_event_time)

                    // Use 'consignment_status' logic
                }
                const eventTimeDateFormatted = eventDateTime ?eventDateTime:"" ;

                var lastLocation = data.last_location? data.last_location:"";




     
                let encryptedVal = window.btoa(`${data.truck_no},${gateouttime},${end_date},${data.lr_no},${data.consignee_code},${data.consignment_code}`);
                var link = "https://legrandgroup.autometrics.in/map/" + encryptedVal;  
                
                
                // Fetch the current status from the statusMap based on data.status
                const currentStatus = data.consignment_status || "Unknown Status";              
                
                // var message = `<p>Courier Track Details:<br>
                // \tLR.No: ${data.lr_no}<br>
                // \tVehicle No: ${data.truck_no}
                // \tTransporter: ${data.transporter_name}<br>
                // \tDispatch Date: ${dispatchDateFormatted}<br>
                // \tSource: ${data.consigner_city}<br>
                // \tDestination: ${data.consignee_city}<br>
                // \tCurrent ETA: ${data.expected_eta}<br>
                // \tCurrent Status- ${data.consignment_status}</p>
                // `;
                var message = `Courier Track Details:\nVehicle No: ${data.truck_no},\nLR.No: ${data.lr_no},\nTransporter: ${data.transporter_name},\nDispatch Date: ${dispatchDateFormatted},\nSource: ${data.consigner_city},\nDestination: ${data.consignee_city},\nCurrent ETA: ${expectedDateFormatted},\nLast Update Date: ${updateTimeDateFormatted},\nCurrent Status: ${currentStatus}, \nEvent Date & Time: ${eventTimeDateFormatted}, \nEvent Location: ${lastLocation}`;
                // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}/${from_date}/${expiry_date}`)
                // window.open(`/truckdetails/sharelink/tptlogin/${data.truck_no}`)
                // window.open(`https://api.whatsapp.com/send?text=${link}` , '_blank')
                const encodedMessage = encodeURIComponent(message);

                // var link1 = <a href="${link}" target="_blank"></a>
                // var linkHtml = <a href={link} target="_blank">Click here to view the map</a>

     
                window.open(`https://web.whatsapp.com/send?phone=${whatsapp_no}&text=${encodedMessage}`, '_blank');
                
                setShow(true);
                setTitle("Whatsapp Sent Successfully");
                setType("success");
                setLoadShow("show-n");
                setOverlay("show-n")
                setActiveForm("");
                setexpired_time({ label: "7 Day", value: 7 })
                setWhatsapp_no("")
            }
            else {
                setShow(true);
                setTitle("WhatApp Number should be 10 Digits");
                setType("danger");
                setLoadShow("show-n");
                setOverlay("show-n");
               
            }
     
        
        }
    }
   
    
}

var changeEmail = (event) => {
    setEmail(event.target.value)
}
var changeWhatsapp = (event) => {
    setWhatsapp_no(event.target.value)
}
var changeExpiredTime = (event) => {
    setexpired_time({label:event.target.value, value:event.target.value})
}

const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        onSubmitEmail();
}
} 
const onCloseDocument = () => {
  // Close the slider
  setSelectedViewTab("loading")
  setSliderDocumentOpen(false);
}
const onClosePodDocument = () => {
    setSliderPODDocumentOpen(false)
}
const validatePhoneNumber = (phoneNumber) => {
    
    if (!phoneNumber || phoneNumber === ""){
        return false
    }else{
        const re = /^[0-9]{10}$/; // Adjust the regex pattern according to your requirements
        return re.test(String(phoneNumber));
    }
    
}
const validateEmail = (email) => {
    if (!email || email ===""){
        return false
    }else{
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return re.test(String(email).toLowerCase());
    }
}
const handleEncrypt = (word) => {
    const plaintext = word;
    const key = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const iv = CryptoJS.enc.Hex.parse('0102030405060708090a0b0c0d0e0f00');
    const encryptedBytes = CryptoJS.AES.encrypt(plaintext, key, {
        iv: iv
    });
    const encryptedBase64 = encryptedBytes.toString();
    const encryptedText = encodeURIComponent(encryptedBase64);
    return encryptedText;
};
// const uploadDocument = async(event) => {
//     event.preventDefault();
//     if (Array.isArray(rownode) && rownode[0]?.tracking_type === "FTL"){
//         //console.log(selectedInvoiceUpload, "selectedInvoiceUpload");
//         const invoiceNos = selectedInvoiceUpload.map(invoice => invoice.value);
//          const params = {
//         invoiceNos: invoiceNos
//     };
//  try {
//         const response = await redirectURL.post("/consignments/getshipmentrowid", params);
//         //console.log(response.data, "Row IDs retrieved for selected invoices");
//         const rowIds = response.data.map(item => item._id);       
//          // Handle response data as needed
//     } catch (error) {
//         console.error("Error fetching row IDs:", error);
//     }        
//     }
//     if (podremarks === "") {
//         setShow(true);
//         setType("warning");
//         setTitle("Please enter remarks");
//         setPodRemarks("");
//         // setEpodDoc([]);
//     } 
//     else if (rownode.length > 0) { // for single pod upload
//         //console.log(rownode,"rownodeeeee");
//             const rowid = rownode[0]._id;
//             const shipment_id = rownode[0].shipment_id;
//             const tracking_type = rownode[0].tracking_type;
//             const rownodes = rownode;
//             const formData = new FormData();
//             formData.append("shipmentId", shipment_id);
//             formData.append("podDoc", epodDoc);
//             formData.append("podremarks", podremarks);
//             formData.append("rowid", rowid);
//             formData.append("rownodes", JSON.stringify(rownodes));
//             formData.append("damage", damage);
//             formData.append("short", short);
//             formData.append("excess", excess);
//             formData.append("pilferage", pilferage);
//             formData.append("trackingType", tracking_type);
//             //console.log(formData,"savingPOD");
//             await redirectURL.post("/savePoddocument", formData, {
//                 headers: {
//                     'content-type': 'multipart/form-data',
//                     'Access-Control-Allow-Origin': "*",
//                     'Access-Control-Allow-Methods': 'POST',
//                     'Access-Control-Allow-Headers': 'Origin, Content-Type'
//                 }
//             })
//                 .then((resp) => {
//                     if (resp.data.status === 'success') {
//                         document.getElementById("formPOD").reset();
//                         // setRowNode([]);
//                         setShow(true);
//                         // setSlider('show-n');
//                         setTitle("Success.");
//                         setType("success");
//                         setPodRemarks("");
//                         setSliderShow("");
//                         setOverlay("show-n");
//                         setEpodDoc([]);

//                         // setLoadshow('show-n');
//                         // window.location.reload();

//                     }
//                 })
//                 .catch((error) => {
//                     console.error("Error uploading document:", error);
//                     // Handle error here, e.g., show a message
//                 });
//         }
    
// };
const uploadDocument = async (event) => {
    event.preventDefault();

    // Validation for podremarks
    // if (podremarks === "") {
    //     setShow(true);
    //     setType("warning");
    //     setTitle("Please enter remarks");
    //     setPodRemarks("");
    //     return;
    // }
    
    // Check if tracking_type is "FTL" and selectedInvoiceUpload is empty
    if (Array.isArray(rownode) && rownode[0]?.tracking_type === "FTL") {
        // if (!selectedInvoiceUpload || selectedInvoiceUpload.length === 0) {
        //     setShow(true);
        //     setType("warning");
        //     setTitle("Please select an LR No");
        //     return;
        // }
        
        // //console.log(selectedInvoiceUpload, "selectedInvoiceUpload");
        
        // const invoiceNos = selectedInvoiceUpload.map(invoice => invoice.value);
        // const params = { invoiceNos: invoiceNos };
        const rowid = rownode[0]._id;
        await savePodDocument(rowid);
        
        // try {
        //     const response = await redirectURL.post("/consignments/getshipmentrowid", params);
        //     //console.log(response.data, "Row IDs retrieved for selected invoices");
            
        //     const rowIds = response.data.map(item => item._id);

        //     // Handle single or multiple rowIds
        //     if (rowIds.length === 1) {
        //         // Single rowId, proceed with one request
        //         await savePodDocument(rowIds[0]);
        //     } else {
        //         // Multiple rowIds, loop through each one and make a request
        //         for (const rowid of rowIds) {
        //             await savePodDocument(rowid);
        //         }
        //     }
        // } catch (error) {
        //     console.error("Error fetching row IDs:", error);
        // }        
    } else if (rownode.length > 0) {
        // PTL Case: Only one row ID from rownode[0]
        const rowid = rownode[0]._id;
        await savePodDocument(rowid);
    }
};
const isValidProgression = (currentStatus, newStatus) => {
    const normalizeStatus = (status) => {
        if (!status) return ""; // Handle null/undefined safely
        return status.replace(/\s+/g, '').toLowerCase();
    };

    const getStatusValue = (status) => {
        if (!status) return ""; // Handle null/undefined safely
        return isBulkUpdate ? status : status.value;
    };

    // Check FTL tracking type
 
        if (normalizeStatus(currentStatus) === "undelivered") {
            const allowedStatuses = ["outfordelivery", "delivered", "undelivered"];
            const normalizedNewStatus = normalizeStatus(getStatusValue(newStatus));

            return allowedStatuses.includes(normalizedNewStatus); // Ensure the status is one of the allowed ones
        }

        let currentIndex;
        let newIndex;

        if (isBulkUpdate) {
            currentIndex = bulkStatusOrder.findIndex(
                (status) => normalizeStatus(status.value) === normalizeStatus(currentStatus)
            );
            console.log(newStatus, getStatusValue(newStatus), "bulk status"); // This should now log both newStatus and getStatusValue
            newIndex = bulkStatusOrder.findIndex(
                (status) => normalizeStatus(status.value) === normalizeStatus(getStatusValue(newStatus))
            );
        } else {
            currentIndex = statusOrderPtl.findIndex(
                (status) => normalizeStatus(status.value) === normalizeStatus(currentStatus)
            );
            newIndex = statusOrderPtl.findIndex(
                (status) => normalizeStatus(status.value) === normalizeStatus(getStatusValue(newStatus))
            );
        }


        // Normal progression for other statuses in PTL

        return newIndex >= currentIndex; // Ensure progression for PTL

};




// const handleStatusChange = (e) => {
//     const newStatus = { label: e.value, value: e.value };

    
//     // Check if the status selection is valid
//     if(selectedStatusUpdate.toLowerCase()==="undelivered"){
//         setForm2Details(prev => ({
//             ...prev,
//             selectedStatus: newStatus,
//             errorMessage: ''  // Clear error if valid
//           }));
//     }else{
        
        
//         if (isValidProgression(selectedStatusUpdate, newStatus)) {
//             //console.log("noerrorrrrrr");
            
//           setForm2Details(prev => ({
//             ...prev,
//             selectedStatus: newStatus,
//             errorMessage: ''  // Clear error if valid
//           }));
//         } else {
//             //console.log("noerrorrrrrr1");
    
//           setForm2Details(prev => ({
//             ...prev,
//             selectedStatus: newStatus,
//             errorMessage: 'You cannot select a previous status.'  // Set error if invalid
//           }));
//         }
//     }
    
    
//   };


// Helper function to handle the POD document upload
const handleStatusChange = (e) => {
    const newStatus = { label: e.value, value: e.value };

    if (e.value !== "Delivered" && e.value !== "Reached Destination") {
        setUploadPODTracking(false);
        setEpodDoc([]);
        setPodRemarks("");
        setDamage(0);
        setExcess(0);
        setShort(0);
        setPilferage(0);
        const podInput = document.getElementById("epodDoc");
        if (podInput) podInput.value = "";
    }
    if(selectedStatusUpdate.toLowerCase()==="undelivered"){
        setForm2Details(prev => ({
            ...prev,
            selectedStatus: newStatus,
            errorMessage: ''
        }));
    }else{
        if (isValidProgression(selectedStatusUpdate, newStatus)) {
            setForm2Details(prev => ({
                ...prev,
                selectedStatus: newStatus,
                errorMessage: ''
            }));
        } else {
            setForm2Details(prev => ({
                ...prev,
                selectedStatus: newStatus,
                errorMessage: 'You cannot select a previous status.'
            }));
        }
    }
};
const savePodDocument = async (rowid) => {
    // //console.log(Dselected_row, "test54");
    
    const shipment_id = rownode?.[0]?.shipment_id || Dselected_row?.shipment_id;
    const tracking_type = rownode?.[0]?.tracking_type || Dselected_row?.tracking_type;
        // const rownodes = rownode;
    
    const formData = new FormData();
    formData.append("shipmentId", shipment_id);
    formData.append("podDoc", epodDoc);
    formData.append("podremarks", podremarks);
    formData.append("rowid", rowid);
    // formData.append("rownodes", JSON.stringify(rownodes));
    formData.append("damage", damage);
    formData.append("short", short);
    formData.append("excess", excess);
    formData.append("pilferage", pilferage);
    formData.append("trackingType", tracking_type);
    formData.append("source_from", "web");
    formData.append("email", user.email);
    
    //console.log(formData, "savingPOD");

    try {
        const resp = await redirectURL.post("/savePoddocument", formData, {
            headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        });

        if (resp.data.status === 'success') {
            if(uploadPODTracking){
                return true;
            }else{
                document.getElementById("formPOD").reset();
                setShow(true);
                setTitle("POD uploaded successfully");
                setType("success");
                setPodRemarks("");
                setSliderShow("");
                setOverlay("show-n");
                setEpodDoc([]);
                setShort(0)
                setExcess(0)
                setDamage(0)
                setPilferage(0)
            }
           
        }
    } catch (error) {
        console.error("Error uploading document:", error);
    }
};
const changeHandler1 = (event) => {
    
    const { name, value } = event.target;
    
    // Assuming you're using setFormData for other fields, make sure to handle podremarks separately
    if (name === "podremarks") {
        setPodRemarks(value);  // Update the podremarks state
    }else if (name ==="docremarks"){
        setDocRemarks(value);
    }else if (name==="loadingdocremarks"){
        setLoadingRemarks(value)
    }else if (name==="unloadingdocremarks"){
        setUnloadingRemarks(value)
    }
     else {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }
};

var hideSlideBlock = () => {
    // Clear React state for form fields
    setDamage(0); 
    setExcess(0); 
    setPilferage(0); 
    setShort(0); 
    setPodRemarks(""); // This will clear the textarea
    
    // Resetting other states
    setSliderShow(''); 
    setOverlay('show-n'); 
    setManualUploadSlider('show-n'); 
    setBulkMarkDeliverSlide('show-n'); 
    setShipmentSlider('show-n'); 
    setShipmentCsvContent([]); 
    setShipmentFile(''); 
    setBulkSliderShow('show-n'); 
    setSliderScanShow('show-n'); 
    setSliderSupportShow('show-n'); 
    setSelectedRowNodes([]); 
    setLoadShow('show-n'); 
    setMultiplePodDocs([]); 
    setDeliveredDate1(""); 
    setUpdateRowSlider("");

    // Clear the file input field by DOM manipulation (because it's an uncontrolled input)
    document.getElementById("epodDoc").value = ""; 

    // Optionally reset the whole form if needed
    document.getElementById("formPOD").reset();
};


const changeFileHandlerForUploadDoc = (event) => {
    try {
        const files = Array.from(event.target.files);
        if (files && files.length > 0) {
            const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp',
                'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

            // Check each file type for validity
            const isValidFile = files.every(file => validTypes.includes(file.type));

            if (!isValidFile) {
                alert("Please select only PDF, image, or Excel files.");
                setCustomerDocument2(null);
                setUploadDoc(null);
                // document.getElementById("customer_document_2").value = ""; // Reset the file input
                document.getElementById("uploadDoc").value = ""; // Reset the file input
                return; // Exit the function
            }
            
            setCustomerDocument2(files);
            setUploadDoc(null);

            setUploadDoc(files);
            setUploadType(event.target.name)
           
        }
    } catch (e) {
        setCustomerDocument2(null);
        setUploadDoc(null);

        const fileInput = document.getElementById("uploadDoc");
        if (fileInput) {
            fileInput.value = "";
        } else {
            console.error("Element with ID 'uploadDoc' not found");
        }

        // document.getElementById("customer_document_2").value = "";
    }
};
const hideSlideBlockForDocument = () => {
    // $("#podDoc").val("")
    setSliderShow1("")
    setOverlay("show-n")
    document.getElementById("uploadDoc").value = "";
    setDocRemarks("")

//    this.setState({
//        delivered_date :""
//    })
    // document.getElementById("formBulkPOD").reset();
    document.getElementById("formDocument").reset();
    // document.getElementById("formBulkSingle").reset();
}
const onClickEmail = (rowNode) => {
    setData(rowNode.data);
    setSliderEmailOpen(true)
}
const onClickCancelActiveCourierConsignemnts = (e) => {
    setDeletionId(e.data._id)
    
    setCancelConsignmentTrackingType(e.data.tracking_type)
    setCloseCancelModal(true)
    setRownode(e.data)
    setReasonForCancellation("");    

    if(tabName.value !== "inactive" && tabName.value !=="transporter"){
        let invoiceData = e.data.invoice_no
        let invoiceNo1 = invoiceData.split(",")
        var arrofInvoices = invoiceNo1.map(item=>({
            label:item, value:item
        }))
        
        
        // let x = activeTrips.inTransit.filter((e)=> e.tracking_type === "PTL")
        // lrBasedSegData = x.reduce((acc, cur)=>{
        //     let curLrno = cur.lr_no;
        //     if(!acc[curLrno]){
        //         acc[curLrno] = new Set();
        //     }
        //     acc[curLrno].add(cur.invoice_no);
        //     return acc;
        // }, [])
        // lrNoOptions = Object.entries(lrBasedSegData).map(([key, set]) => {
        //     return Array.from(set).map(item => ({ value: key, label: item }));
        // }).flat().filter(option => option.value && option.label && option.value !== "undefined"); 
        // const filteredLrOptions = lrNoOptions.filter(m => {
        //     return m.label !== "undefined" && m.value === e.data.lr_no;
        // });
        setLrOptions(arrofInvoices)
    } else {
        setLrOptions([])
        let x = [{label: e.data.invoice_no, value: e.data.invoice_no}]
        setLrOptions(x)
    }
}
const uploadPODInTracking=()=>{
    // e.preventDefault(); 
    setUploadPODTracking(!uploadPODTracking)
}
// const onCellValueChanged = (params) => {
//     //console.log("Updated Value1",params.newValue ); // Check the updated value

//     // This will get the updated value after the user edits the cell
//     const updatedData = params.data;
//     const updatedValue = params.newValue;

//     // Check if it's the correct column (e.g., 'recent_dealer_reported' or 'delivery_datetime')
//     if (params.colDef.field === "recent_dealer_reported" || params.colDef.field === "delivery_datetime") {
//         //console.log("Updated Value:", updatedValue); // Check the updated value
//         updatedData[params.colDef.field] = updatedValue

//         // Optionally, you can update any other data or state here
//     }
//     params.api.refreshCells({ rowNodes: [params.node] });
// };

// const onClickEditDeliveryDate = (rowdata) => {
//     // setreload(true)
    
//     var row = rowdata.data 
//     var tracking_type= row.tracking_type;
//     var shipment_id = row.shipment_id;
//     var consignee_city = row.consignee_city;
//     var consignment_code = row.consignment_code;
//     var delivery_date
//    if(tracking_type==="FTL"){
//     delivery_date= row.recent_dealer_reported_modified ? row.recent_dealer_reported_modified : row.delivery_datetime;
//    }else if(tracking_type==="PTL"){
//     delivery_date= row.delivery_datetime_modified? row.delivery_datetime_modified: row.delivery_datetime;

//    }
//     var data={'delivery_date': delivery_date,'consignee_city': consignee_city,'consignment_code':consignment_code,'shipment_id': shipment_id, "tracking_type":tracking_type}

    
    
//     var params = {
//         data:data
//     }
//     //console.log(data, "delviery date updated ");
   
    
//     redirectURL.post('/consignments/uploadBulkuploadforDeliverydates',params).then((resp)=>{
//         if(resp.data.status=='success'){
//             setShow(true)
//             setTitle(resp.data.message)
//             setType("success")
//         }
//         else{
//             setShow(true)
//             setTitle(resp.data.message)
//             setType("danger")
        
            
//         }
//        })
//     // redirectURL.post('/consignments/editProductionDate', params).then((resp) => {
//     //     if (resp.data.status == 'success') {
//     //         setshow(true)
//     //         setbasicTitle("Successfully Updated")
//     //         setbasicType("success")
//     //     }
//     // })
// }

    const onClickEditDeliveryDate = (rowdata) => {
        const row = rowdata.data;
        console.log(row.dispatch_date,row.delivery_datetime,row.actual_delivery_date,"9876543")
        const formatUTCtoISTFormat = (date) => {
            return moment.utc(date).toISOString();
        };


        // const payload = [
        //     {
        //         lr_no: row.lr_no,
        //         tracking_type: row.tracking_type,
        //         dispatch_date: formatUTCtoISTFormat(row.dispatch_date),
        //         delivery_datetime: formatUTCtoISTFormat(row.delivery_datetime),
        //         actual_delivery_date: formatUTCtoISTFormat(row.actual_delivery_date),
        //         late_delivery_remarks: "",
        //         sla_considered: "No", 
        //         transporter_name: row.transporter_name
        //     }
        // ];
        const payload = [
            {
                lr_no: row.lr_no,
                tracking_type: row.tracking_type,
                dispatch_date: formatUTCtoISTFormat(row.dispatch_date),
                delivery_datetime: formatUTCtoISTFormat(row.delivery_datetime),
                sla_considered: "No",
                transporter_name: row.transporter_name,

                ...(row.actual_delivery_date &&
                    typeof row.actual_delivery_date === "string" &&
                    row.actual_delivery_date.trim() !== "" &&
                    row.actual_delivery_date !== "Invalid Date Format" && {
                    actual_delivery_date: formatUTCtoISTFormat(row.actual_delivery_date)
                }),

                ...(row.late_delivery_remarks &&
                    typeof row.late_delivery_remarks === "string" &&
                    row.late_delivery_remarks.trim() !== "" && {
                    late_delivery_remarks: row.late_delivery_remarks.trim()
                })
            }
        ];
        payload.forEach(obj => {
            Object.keys(obj).forEach(key => {
                if (obj[key] === "" || obj[key] == null) {
                    delete obj[key];
                }
            });
        });
console.log(
  "FINAL PAYLOAD BEING SENT:",
  JSON.stringify(payload, null, 2)
);

        // const params = { lr_data : payload , email: decode(localStorageEmail) };
        const params = {
            lr_data: payload,
            email: decode(localStorageEmail),
            role: decodedRole   // whatever variable you have
        };
        redirectURL
            .post("/bulkUploadDeliveryDate", params)
            .then((resp) => {
                if (resp.data.status === "Success") {
                    setShow(true);
                    setTitle(resp.data.message);
                    setType("success");
                } else {
                    setShow(true);
                    setTitle(resp.data.message);
                    setType("danger");
                }
            })
            .catch((err) => {
                console.error("API error:", err);
                setShow(true);
                setTitle("Something went wrong");
                setType("danger");
            });
    };

    
const onShowDocs = (e) => {
    
    setDocuments([]); // Clear existing documents
    let params = {};
    setDocRow(e);
    setTrackingType(e.data.tracking_type);

    if (e.data.tracking_type === "FTL") {
        if (e.data.uploaded_loading_document) {
            params.uploaded_loading_document = e.data.uploaded_loading_document;
            setSelectedViewTab('loading');
        } else if (e.data.uploaded_unloading_document) {
            params.uploaded_unloading_document = e.data.uploaded_unloading_document;
            setSelectedViewTab('unloading');
        } else {
            setSelectedViewTab('loading'); // Default tab even if no documents
        }
    } else {
        params.uploaded_document = e.data.uploaded_document;
        params.lr_no = e.data.lr_no;
    }

    // API Call to fetch documents
    redirectURL
        .post("/consignments/downloadUploadDocument", params)
        .then((res) => {
            setDocuments(res.data); // Update documents state with API response
            setSliderDocumentOpen(true); // Open the slider for documents
        })
        .catch((error) => {
            console.error(error);
        });
};



const onShowDocs1 = (tab) => {
    let params = {};
        if (tab === 'loading') {
            // Send uploaded_loading_document if 'loading' tab is selected
            if (docRow.data.uploaded_loading_document !== undefined && docRow.data.uploaded_loading_document !== null) {
              params.uploaded_loading_document = docRow.data.uploaded_loading_document;
            }
          } else if (tab === 'unloading') {
            // Send uploaded_unloading_document if 'unloading' tab is selected
            if (docRow.data.uploaded_unloading_document !== undefined && docRow.data.uploaded_unloading_document !== null) {
              params.uploaded_unloading_document = docRow.data.uploaded_unloading_document;
            }
          }
   
    redirectURL.post("/consignments/downloadUploadDocument", params
    //     , {
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': localStorage.getItem("userid")
    //     }
    // }
).then(res => {
    //console.log(res.data, "HHHHHHH");
    if(res.data ==="No documents provided"){
        setDocuments([])
    }else{
        setDocuments(res.data);  
    }
    
    
    // setViewRemark(e.data.doc_remarks)
    setSliderDocumentOpen(true)
}).catch(error => {
    console.error(error);
});
}
const onShowPodDoc = (e) => {
    setTrackingTypeForDoc(e.data.tracking_type)
    // if (e.data.tracking_type === "FTL") {
    //     let query = {
    //         truck_no: e.data.truck_no,
    //         shipment_id: e.data.shipment_id
    //     };

    //     redirectURL.post('/consignments/getShipmentDetails', query)
    //     .then(resp => {
    //         //console.log("resp", resp.data.consignments);
    //         const allPodDocuments = resp.data.consignments.flatMap(consignment => consignment.uploaded_pod_document);
    //         //console.log(allPodDocuments, "allPodDocuments");

    //         // Set params only after allPodDocuments is available
    //         let params = { uploaded_document: allPodDocuments };
    //         setPodDocuments([]); // Reset before new data

    //         redirectURL.post("/consignments/downloadUploadDocument", params)
    //         .then(res => {
    //             setPodDocuments(res.data);  
    //             setSliderPODDocumentOpen(true);
    //         })
    //         .catch(error => {
    //             console.error(error);
    //         });
    //     })
    //     .catch((e) => {
    //         //console.log(e, "error");
    //     });
    // } else {
        // Handle the PTL case directly since it doesn't require async data
        let params = {
            uploaded_document: e.data.uploaded_pod_document,
            lr_no: e.data.lr_no
        };

        redirectURL.post("/consignments/downloadUploadDocument", params)
        .then(res => {
            
            
            setPodDocuments(res.data); 
            setViewPodRemark(e.data.podremarks); 
            setSliderPODDocumentOpen(true);
        })
        .catch(error => {
            console.error(error);
        });
    // }
};

useEffect(()=>{
    if(formData.consignee_name.value === "Other"){
        setEnableConsigee(true)
    }else{
        setEnableConsigee(false)
    }
},[formData.consignee_name.value])

useEffect(()=>{
    redirectURL.post("/consignments/getTruckLocations").then(resp=>{
        // //console.log(resp.data.trucks_locations, "respp788");
        setTruckLocations(resp.data.trucks_locations);
    })
}, [])

// useEffect(() => {
//     const invoiceNo = formData.invoice_no;
//     // if (validateInput(invoiceNo)) {
//     //     setErrorMssge(""); 
//     // let invoiceLength = invoiceNo.length;
    
        
//         if (invoiceNo.length > 0  && /[\/]/.test(invoiceNo[0])) {
//             const isValid = validateInput(invoiceNo); // Perform validation

//             if (isValid) {
//                 filterSources(invoiceNo); // Call filterSources only if validation passes
//             } else {
//                 setErrorMssge("All invoices should have the same series.");
//             } // Call filterSources if the value contains a slash
//         } 
//     // if (/[\/]/.test(invoiceNo[0])) {

//     //     let invoiceNumber = 
//     //     let source = invoiceNo.split('/')[1];
        
//     //     let filteredSource = sourceList.filter(e => e.value === source);
        
//     //     // filteredSource.push({ label: "Others", value: "Others" });

//     //     // Set the filtered source list
//     //     setSourceList(filteredSource);
//     // // } else {
//     // //     setErrorMssge("Invalid Invoice Number"); 
//     // // }
//     // }
// }, [formData.invoice_no]);
// useEffect(() => {
//     const lastThreeLetters = manualUpdateConsignment.invoice_no;
//     const matchingSource = sourceList.find((item) => item.value.endsWith(lastThreeLetters));

//     if (manualUpdateConsignment.invoice_no !== '') {
//       if (matchingSource) {
//         setManualUpdateConsignment((prev) => ({ ...prev, source: matchingSource }));
//         setSourceOptions([matchingSource, { value: 'Other', label: 'Other' }]);
//       } else {
//         setSourceOptions([{ value: 'Other', label: 'Other' }]);
//       }
//     }
//   }, [manualUpdateConsignment.invoice_no, sourceList]);
    useEffect(()=>{
        if(form2Details.selectedStatus.value === "Undelivered"){
            setAbleRemark(true)
        } else {
            setAbleRemark(false)
        }
    }, [form2Details.selectedStatus])
    
    
    // useEffect(() => {
    //     const isFormValid = validateFormOrder();
    
    //     setFormData((prev) => ({
    //         ...prev,
    //         disableAddDrop: !isFormValid,  // Disable if form is invalid
    //         disableSubmit: !isFormValid,   // Disable if form is invalid
    //     }));
    // }, [formData]);
    useEffect(()=>{
        redirectURL.post('/consignments/getVehicleMaster')
        .then(resp => {
            var records = resp.data.vehicleMaster
            var ftlVehicleArr = records.filter((e)=> e.tracking_type==="FTL");
            var ptlVehicleArr = records.filter((e)=> e.tracking_type==="PTL");


            var vehicleFtlArr = ftlVehicleArr.map((e)=> e.vehicle_type);
            var vehiclePtlArr = ptlVehicleArr.map((e)=> e.vehicle_type);
            var vehicleArr = records.map((e)=> e.vehicle_type);
            var vehicleCapacityArr = records.map((e)=> e.vehicle_capacity);
            var vehicleTypeList=[]
            var vehicleCapacityList=[]
            var vehicleTypeFtlList =[]
            var vehicleTypePtlList =[]
            var vehicleTypeFtlArr=[]
            for (let i of vehicleFtlArr){
                vehicleTypeFtlList.push({label:i, value: i})
                vehicleTypeFtlArr.push(i.toLowerCase())
            }
            for (let i of vehiclePtlArr){
                vehicleTypePtlList.push({label:i, value: i})
            }
            for (let i of vehicleArr){
                vehicleTypeList.push({label:i, value: i})
            }
            for (let i of vehicleCapacityArr){
                vehicleCapacityList.push({label:i, value: i})
            }
            
            
            // vehicleTypeList.push({label:"Other", value:"Other"});
            vehicleCapacityList.push({label:"Others", value:"Others"});
            vehicleTypeList.push({label:"Others", value:"Others"});
            vehicleTypeFtlList.push({label:"Others", value:"Others"});
            vehicleTypePtlList.push({label:"Others", value:"Others"});
            setVehicleTypeList(vehicleTypeList)
            setVehicleCapacityList(vehicleCapacityList)
            setVehicleFtlTypeList(vehicleTypeFtlList)
            setVehiclePtlTypeList(vehicleTypePtlList)
            setVehicleFtlArr1(vehicleTypeFtlArr)

        }) 
        redirectURL.post('/consignments/getTransportersList')
        .then(resp => {
            var records = resp.data.tptMaster;
            var simTrackingtps = records.filter((e)=> e.transporter_type==="FTL" && e.tracking_type ==="Sim Tracking").map((e)=> e.transporter_name.toLowerCase());
            // console.log(simTrackingtps, "simTrackingTpts99");
            
            setSimTrackingTpts(simTrackingtps);
            var tptNames = records.filter((e)=> e.transporter_type == "FTL" || e.transporter_type === "FTL/PTL").map((e)=> e.transporter_name);
            settptRecords(records)

            var tptNamesList=[]
            for (let i of tptNames){
                tptNamesList.push({label:i, value: i})
            }
            var tptNFueltypes = records.map(e=> ({label: e.transporter_name.toLowerCase(), value: e.fuel_type}))
            settptNFuel(tptNFueltypes)
            

            var tptNames1 = records
            .filter(e => e.transporter_name && e.transporter_name !== "") // Filter records with valid transporter_name
            .map(e => e.transporter_name); // Extract only transporter_name
        
            var tptNamesList1=[]
            for (let i of tptNames1){
                tptNamesList1.push({label:i, value: i})
            }
            // tptNamesList.push({label:"Others", value:"Others"});
            setCourierPartnerList(tptNamesList)
            setCourierPartnerList1(tptNamesList1)
        }) 
        redirectURL.post("/consignments/getSourceTypes")
        .then(resp => {
            let records = resp.data.sourceMaster;
            let sourceList=[]
            let sourceSeries=[]

            let sourceSet = new Set();
            let seriesSet= new Set();
            for (let i of records){
                if(i.invoice_source !== "Nan"){
                    if(!sourceSet.has(i.invoice_source)){
                        sourceList.push({label:i.invoice_source, value: i.invoice_source})
                        sourceSet.add(i.invoice_source)
                }
                    if(!seriesSet.has(i.invoice_series)){
                        sourceSeries.push({label:i.invoice_source, value: i.invoice_series})
                        seriesSet.add(i.invoice_series)
                    }
                }
            }
            
            var arr1 = Array.from(sourceSet)
            var arr2 = Array.from(seriesSet)
            sourceList.push({label:"Others", value:"Others"})
            
            setOriginalSourceList(sourceList)
            
            setSourceList(sourceList)
            setSourceRecords(arr1);
            setSeriesRecords(arr2);
            setSourceSeriesList(sourceSeries)
            // setCourierPartnerList(tptNamesList)
        }) 
        redirectURL.post("/consignments/getConsigners")
        .then(resp => {
            let records = resp.data.consignerMaster;

            // var sources = records.filter((e)=> e.transporter_type == "FTL").map((e)=> e.transporter_name);
            let consignerList=[]
            let consignerSet = new Set();
            for (let i of records){
                if(i.consigner_code && i.consigner_name){
                    if(!consignerSet.has(i.consigner_code)){
                        //console.log(i.consignee_name, "9990000");
                        
                        consignerList.push({label:i.consigner_name, value: i.consigner_code})
                        consignerSet.add(i.consigner_code)
                    }
                }
            }
            consignerList.push({label:"Others", value:"Others"})
            //console.log(consigneeList, "consigneeList556");
            
            
            setConsignees(consignerList)
            setTripConsignees(consignerList)
        })
        
       
    },[])
    // useEffect(() => {
    //     if ( tabName.value == "active" ) {
    //         setRowData(activeTrips.all);
    //         setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
    //     } else if (tabName.value == "completed") {
    //         setRowData(completedTrips.all)
    //         setDateTypeList((prevList) => [
    //             ...prevList,
    //             { label: "Delivered", value: "Delivered" }
    //         ]);       
    //          }
    //     else if (tabName.value == "all") {
    //         setRowData(allTrips.all);
    //     } else if(tabName.value == "inactive"){    
    //         setRowData(inactiveTrips)
    //         // setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
    //     }else if(tabName.value ==="transporter"){
    //         setRowData(transporterTrips1)
    //         // setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
        
    //     }else{
    //         setRowData(closeTrips)
    //         setDateTypeList((prevList) => prevList.filter(item => item.value !== "Delivered"));
    //     }
        
    // }, [tabName.value,searchViewType.value])
   
    
    useEffect(()=>{
        setShowLrUpdateBtn(true)
        setShowTransporterUpdateBtn(true)
    }, [selectedRows])
  
    useEffect( () => {
        let key = ''
        if(tabName.value!==""){
            redirectURL.post('/details')
            .then((response) => {
                if (response.data.status === 'success') {
                    setKey(response.data.output[0].g_key);
                    key = response.data.output[0].g_key
                    loadScript("https://maps.googleapis.com/maps/api/js?key=" + key + "&libraries=places,drawing&callback=initMap");
                    window.initMap = async () => {
                        var lt = 28.4519751;
                        var ln = 77.0310713;
                        map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                            zoom: 13,
                            center: new window.google.maps.LatLng(lt, ln),
                            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
        }
       
            var params1 ={}
            var params ={
                dept_code: "SNDG"
            }
            if(decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All"){
                params1.transporter_name = localStorage.getItem("transporter")
                params.transporter_name = localStorage.getItem("transporter")
            }

            if (["warehouse", "wh-inbound"].includes(decodedRoleCase) && processFlowType === "inbound" && warehouseTab.value == "my_warehouse" && !["All Sites"].includes(locationNameConversion)) {
                const resultPincodes = locationNameConversion.map(city => locationToPincode[city.toUpperCase()]).filter(Boolean);
                params1.consignee_pincode = resultPincodes
                params1.invoice_type = "STOCK TRANSFER"
                params.consignee_pincode = resultPincodes
                params.invoice_type = "STOCK TRANSFER"

            }
            // else{
            if (
                zoneConversion &&
                zoneConversion.length > 0 &&
                !zoneConversion.includes("all")
            ) {
                if (["user", "warehouse", "user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
                    if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
                        params1.consignee_zone = zoneConversion;
                        params.consignee_zone = zoneConversion;
                    } else if (processFlowType === "inbound") {
                        params1.consignee_zone = zoneConversion;
                        params.consignee_zone = zoneConversion;
                    }
                }
                else {
                    params1.consignee_zone = zoneConversion;
                    params.consignee_zone = zoneConversion;
                }
            }
            if (
                stateConversion &&
                stateConversion.length > 0 &&
                !stateConversion.includes("all")
            ) {
                if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {
                    if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
                        params1.consignee_state = stateConversion;
                        params.consignee_state = stateConversion;
                    } else if (processFlowType === "inbound") {
                        params1.consignee_state = stateConversion;
                        params.consignee_state = stateConversion;
                    }
                }
                else {
                    params1.consignee_state = stateConversion;
                    params.consignee_state = stateConversion;
                }
            }
        // }

          
         
                if (
                    locationNameConversion &&
                    locationNameConversion.length > 0 &&
                    !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
                ) {            
                    if(["user","user-outbound", "wh-outbound", "warehouse"].includes(decodedRoleCase)){
                        if(["user-outbound", "wh-outbound"].includes(decodedRoleCase)){
                            params1.consigner_name = locationNameConversion;
                            params1.consigner_code = locationNameConversion;
                            params.consigner_name = locationNameConversion;
                            params.consigner_code = locationNameConversion;
                        }else if(processFlowType === "outbound"){
                            params1.consigner_name = locationNameConversion;
                            params1.consigner_code = locationNameConversion;
                            params.consigner_name = locationNameConversion;
                            params.consigner_code = locationNameConversion;
                        }
                }
            else{
                params1.consigner_name = locationNameConversion;
                params1.consigner_code = locationNameConversion;
                params.consigner_name = locationNameConversion;
                params.consigner_code = locationNameConversion;
            }
        }
         
                //  }
                    if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
                        params1.truck_seal_entity = entityConversion
                        params.truck_seal_entity = entityConversion
                    } 
               
                       params1.tabName = tabName.value;
                       
        if(tabName.value !==""){
            redirectURL.post('consignments/getCollectiveConsigner', params1)
            .then((response) => {
                let formattedOptions = response.data.records.map(record => ({
                    label: capitalizeWords(record.label),
                    value: (record.value)
                  }));
                setConsignersList(formattedOptions)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
        } 
              
                  params.tabName = tabName.value;  

                  
                if(tabName.value!==""){
                    redirectURL.post("/consignments/getCombinedStateAndCitiesNewFilterKeys", params)
                    .then((resp) => {
                     
                        var filteredCitiesarr = extractUniqueValuesOfCities(resp?.data?.cities);
                        var filteredCities=[{value:"all",label:"All"}]
                        if(filteredCitiesarr.length > 0)
                        {
                            filteredCitiesarr.map((itm) => {
                                filteredCities.push(itm)
                            })
                        }
                        var filteredStates = extractUniqueValues(resp?.data?.states);
                    
                    
                        setFilterCities(filteredCities);
                        setFilterStates(filteredStates);
                       
                    })        
                    .catch(error => {
                        console.error("Error fetching data:", error);
                    });
                    redirectURL.post("/consignments/getCombinedTptsNVehiclesNewFilterKeys", params)
                    .then((resp) => {
            
                        let transporterSet = new Set();
                        var transporters = resp.data.transporters;
                        var filterTransporters = [];
                        if (transporters != undefined) {
                            if (transporters.length > 0) {
                                transporters.map(function (t) {
                                    if(!transporterSet.has(t.toUpperCase())){
                                        transporterSet.add(t.toUpperCase())
                                        filterTransporters.push({
                                            label: capitalizeWords(t),
                                            value: t,
                                        });
                                    }                            
                                });
                            }
                        }
                        //console.log(resp?.data?.invoices, "invoices55555")
                        // var filteredVehicles = extractUniqueValues(resp?.data?.vehicles);
                        setFilterTransporters(filterTransporters);
                        // setFilteredvehicles(filteredVehicles);
                        
                    
                    })        
                    .catch(error => {
                        console.error("Error fetching data:", error);
                    });
                    // redirectURL.post("/consignments/getCombinedLRnosNewFilterKeys", params)
                    // .then((resp) => {
                    //     var filteredLrnos = extractUniqueValuesOfLrnos(resp?.data?.lrNos);
                    //     //console.log(filterTransporters, "filterTransporters")
                    
                        
                    //     console.log(filteredLrnos, "filteredLrnos99999");
                        
                    //     setFilteredLrnos(filteredLrnos);
                    
                    // })        
                    // .catch(error => {
                    //     console.error("Error fetching data:", error);
                    // });
                }
      
        if(searchViewType.value==="LR"){
            if(tabName.value==="active"){
                fetchGridLayout(user.email, "consignments")
            .then(res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setGridColumnState(res.data.data[0].columnState)
                }
            })
            }
            
            if(tabName.value==="completed"){
                fetchGridLayout(user.email, "delivered_consignments")
                .then(res => {
                    if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                        setDeliveredGridColumnState(res.data.data[0].columnState)
                    }
                })
            }
            if(tabName.value==="all"){
                fetchGridLayout(user.email, "all_consignments")
                .then(res => {
                    if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                        setAllGridColumnState(res.data.data[0].columnState)
                    }
                })
            }
        }else{
            if(tabName.value ==="active"){
                fetchGridLayout(user.email, "invoice_consignments")
                .then(res => {
                    if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                        setGridColumnState1(res.data.data[0].columnState)
                    }
                })
            }
         
            if(tabName.value==="completed"){
                fetchGridLayout(user.email, "invoice_delivered_consignments")
                .then(res => {
                    if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                        setDeliveredGridColumnState1(res.data.data[0].columnState)
                    }
                })
            }
            if(tabName.value==="all"){
                fetchGridLayout(user.email, "invoice_all_consignments")
                .then(res => {
                    if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                        setAllGridColumnState1(res.data.data[0].columnState)
                    }
                })
            }
        }
            
        
           
            
            if(tabName.value==="transporter"){
                fetchGridLayout(user.email, "tpt_consignments")
                .then(res => {
                    if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                        setTptGridColumnState(res.data.data[0].columnState)
                    }
                })
            }
            if(tabName.value==="inactive"){
                fetchGridLayout(user.email, "invoice_details")
                .then(res => {
                    if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                        setInvoiceGridColumnState(res.data.data[0].columnState)
                    }
                })
            }
    }, [processFlowType,searchViewType.value, tabName.value])
    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        pivot: false,
        // cellStyle: { fontSize: '15px' }         
    }
    // const columnDef = [
        
    //     // {
    //     //     headerName: "LR No",
    //     //     field: "lr_no",
    //     //     width: 150,
    //     //     editable: true, // Allow editing
    //     //     resizable: true,
    //     //     headerClass: 'bold-header',
        
    //         // valueSetter: (params) => {
    //         //     const newValue = params.newValue;
    //         //     params.data.lr_no = newValue; // Set the edited value directly to the data
    //         //     return true; // Return true to indicate successful update
    //         // },
        
    //         // valueFormatter: (params) => {
    //         //     return validateLRNo(params.value); // Use validation function to format value
    //         // },
        
    //         // cellStyle: (params) => {
    //         //     const isValid = validateLRNo(params.value) !== "Invalid LR No";
        
    //         //     // If the LR number is invalid, apply a red background
    //         //     if (!isValid) {
    //         //         return { backgroundColor: "#c85f62" }; // Light red background for invalid LR No
    //         //     }
    //         //     return null; // Default cell style for valid LR numbers
    //         // }
    //     // },
    //     {
    //         headerName: "Invoice No",
    //         field: "invoice_no",
    //         width: 150,
    //         resizable: true,
    //         editable: true,
    //         headerClass: 'bold-header',
    //         valueGetter:function(params){
    //             const invoiceValue = params.data.invoice_no;
    //             if(invoiceValue==="" || invoiceValue===null || invoiceValue===undefined){
    //                 //console.log("invoiceErrorrr");
                    
    //                 setBulkInvoiceError(true);
    //                 return params.data.invoice_no
    //             }
    //             else if (!(invoiceValue.includes("/"))) {
    //                 //console.log("invoiceIncludes444");
    //                 setInvoiceTypeCheck(true);
    //                 setBulkInvoiceError(false); // No error for values without slash
    //                 return params.data.invoice_no; // Return the invoice value as is
    //             }
    //             else{
    //                 setInvoiceTypeCheck(false);
    //                 return params.data.invoice_no; // Return the invoice value as is
    //             }
    //         },
    //         valueSetter: function (params) {
    //             const invoiceValue = params.newValue;
            
    //             // If invoice value is empty
    //             if (!invoiceValue) {
    //                 setBulkInvoiceError(true);
    //                 return ""; // Return empty and show error
    //             }
            
    //             // Check if the invoice does NOT have a slash
    //             if (!(invoiceValue.includes("/"))) {
    //                 //console.log("invoiceIncludes444");
    //                 params.data.invoice_no = invoiceValue;
    //                 setInvoiceTypeCheck(true);
    //                 setBulkInvoiceError(false); // No error for values without slash
    //                 return true; // Return the invoice value as is
    //             }
            
    //             // If it has a slash, validate the invoice
    //             const isValid = validateInvoice(invoiceValue, sourceRecords);
            
    //             if (isValid !== "") {
    //                 let invoiceNo =  isValid.split("/")[1]
    //                 setSelectedBulkSource(invoiceNo.toUpperCase())
    //                 //console.log(invoiceNo.toUpperCase(),"invoiceIncludes555");
    //                 params.data.invoice_no = isValid;
    //                 setInvoiceTypeCheck(false);

    //                 setBulkInvoiceError(false); // Validation successful
    //                 return true; // Return the validated value
    //             } else {
    //                 setBulkInvoiceError(true); // Validation failed
    //                 return false; // Return empty to indicate error
    //             }
    //         },
            
    //         cellStyle: function (params) {
    //             // Apply red background if value is empty (invalid or failed validation)
    //             if (!params.value) {
    //                 return {
    //                     backgroundColor: "#c85f62", // Light red background for invalid input
    //                 };
    //             }
    //             return null; // Default styling for valid input
    //         },            

    //     },
    //     {
    //         headerName: "Invoice Date",
    //         field: "invoice_date",
    //         editable: true,
    //         valueGetter: (params) => {
    //           const date = params.data.invoice_date;
    //           // Check if date is in DD-MM-YYYY format
    //           const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
    //           if (date && datePattern.test(date)) {
    //             setBulkError(false)
    //             return date;
    //           } else {
    //             setBulkError(true)

    //             return "";
    //           }
    //         },
    //         valueSetter: (params) => {
    //           const newValue = params.newValue;
    //           const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
    //           // Check if the new value follows the DD-MM-YYYY format
    //           if (newValue && datePattern.test(newValue)) {
    //             params.data.invoice_date = newValue; // Set the new value if valid
    //             return true;
    //           } else {
    //             return false; // Reject the value if it's in an invalid format
    //           }
    //         },
    //         cellStyle: (params) => {
    //           const date = params.value;
    //           // Apply red background if the date format is invalid
    //           if (date === "") {
    //             return { "backgroundColor": "#c85f62" };
    //           }
    //           return null;
    //         },
    //       },
    //       {
    //         headerName: "Consignee Name",
    //         field: "customer_name",
    //         width: 180,
    //         filter: "agSetColumnFilter",
    //         cellRenderer: '',
    //         resizable: true,
    //         editable:true,
    //         valueGetter: function (params) {
    //             if (params.data.customer_name != "" && params.data.customer_name != "") {
    //                 setBulkConsigneeError(false)
    //                 return params.data.customer_name
    //             }else{
    //                 setBulkConsigneeError(true)

    //                 return ""
    //             }
    //         },
    //         cellStyle: function (params) {
    //             // If the customer_name is empty, apply red background color
    //             if (params.value === "") {
    //                 return {
    //                     backgroundColor: "#c85f62"  // Light red background for empty customer_name
    //                 };
    //             }
    //             return null;  // No special styling if the customer_name is not empty
    //         },

    //             headerClass: 'bold-header'
    //     },
    //     {
    //         headerName: "Destination City" ,
    //         field: "destination_city",
    //         width: 150,
    //         editable:true,

    //         cellRenderer: '', resizable: true,
    //             headerClass: 'bold-header',
    //             valueGetter: (params) => {
    //                 const destinationCity = params.data.destination_city;
                   
                
    //                 if (destinationCity !=="") {
    //                     setBulkDestinationError(false)

    //                   return destinationCity;
    //                 } else {
    //                     setBulkDestinationError(true)

    //                   return "";
    //                 }
    //               },
    //               cellStyle: (params) => {
    //                 const destinationCity = params.value;
    //                 // Apply red background if the date format is invalid
    //                 if (destinationCity === "") {
    //                   return { "backgroundColor": "#c85f62" };
    //                 }
    //                 return null;
    //               },
    //     },
    //     {
    //         headerName: "Destination Pincode" ,
    //         field: "destination_pincode",
    //         width: 180,
    //         editable:true,

    //         cellRenderer: '', resizable: true,
    //             headerClass: 'bold-header',
    //             valueGetter: (params) => {
    //                 const destinationPincode = params.data.destination_pincode;
                    
                
    //                 if (destinationPincode !=="" && /^\d{6}$/.test(destinationPincode)) {
    //                     setBulkPincodeError(false)
    //                   return destinationPincode;
    //                 } else {
    //                     setBulkPincodeError(true)

    //                   return "";
    //                 }
    //               },
    //               cellStyle: (params) => {
    //                 const destinationPincode = params.value;
    //                 // Apply red background if the date format is invalid
    //                 if (destinationPincode === "") {
    //                   return { "backgroundColor": "#c85f62" };
    //                 }
    //                 return null;
    //               },
    //     },
    //     {
    //         headerName: "Total Weight", // Column header name
    //         field: "total_weight", // Field in the data associated with this column
    //         width: 150, // Width of the column
    //         resizable: true, // Allow column resizing
    //         headerClass: 'bold-header', // Custom CSS class for the header
    //         editable: true, // Enable editing of the cell value
        
    //         // Value Getter: Determines what value to display in the cell
    //         valueGetter: (params) => {
    //             if (params.data.total_weight === "") {
    //                 // If the total_weight is empty, set an error state
    //                 setBulkTotalWeightError(true); // Track the error state globally
    //                 return ""; // Display an empty string in the cell
    //             }
    //             return params.data.total_weight; // Return the total_weight value from data
    //         },
        
    //         // Value Setter: Handles updates to the cell value
    //         valueSetter: (params) => {
    //             const newValue = params.newValue; // Get the new value entered by the user
        
    //             // Check if the new value is a valid number
    //             if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
    //                 params.data.total_weight = parseFloat(newValue); // Convert and set the value
    //                 return true; // Indicate successful value update
    //             } else {
    //                 console.warn("Invalid input: Only numeric values are allowed.");
    //                 params.data.total_weight = ''; // Reset the value to empty
    //                 return false; // Indicate failed value update
    //             }
    //         },
        
    //         // Cell Style: Applies conditional styling for invalid cells
    //         cellStyle: (params) => {
    //             let isGridValid = true; // Track the validity of the entire grid
        
    //             // Iterate through all rows to check for invalid values
    //             params.api.forEachNode((node) => {
    //                 const totalWeight = node.data.total_weight;
    //                 if (isNaN(totalWeight) || totalWeight === "") {
    //                     isGridValid = false; // Mark as invalid if any cell is invalid
    //                 }
    //             });
        
    //             // Update global error state based on validation
    //             setBulkTotalWeightError(!isGridValid);
        
    //             // Apply red background for the current cell if it is invalid
    //             if (isNaN(params.value) || params.value === "") {
    //                 return { backgroundColor: "#c85f62" }; // Highlight invalid cells
    //             }
    //             return null; // No special styling for valid cells
    //         },
    //     }
    //     ,
        
    //     // {
    //     //     headerName: "Source City",
    //     //     field: "source_city",
    //     //     editable: true,
    //     //     valueGetter: (params) => {
    //     //         const sourceCity = params.data.source_city;
            
    //     //         // Check if the source_city is empty or not in the consignerCityList
    //     //         if (!sourceCity || !consignerCityList.includes(sourceCity.toLowerCase())) {
    //     //             params.data.source_city = ""; // Set the value to an empty string if invalid
    //     //             setBulkSourceError(true); // Set the error state
    //     //             return ""; // Return an empty string for invalid value
    //     //         }
            
    //     //         setBulkSourceError(false); // Clear the error state for valid value
    //     //         return sourceCity; // Return the valid source_city value
    //     //     },
    //     //     valueSetter: async (params) => {
    //     //         const newValue = params.newValue;
        
    //     //         // Check if the value is empty
    //     //         if (newValue === "" || newValue.trim() === "") {
    //     //             params.data.source_city = "";
    //     //             setBulkSourceError(true);
    //     //             return false;
    //     //         }
        
    //     //         if (selectedBulkSource !== "") {
    //     //             const matchingItem = invoiceSourceSeries.find(
    //     //                 (e) => e.label === selectedBulkSource
    //     //             );
        
    //     //             if (matchingItem) {
    //     //                 if (matchingItem.value.toLowerCase() === newValue.toLowerCase()) {
    //     //                     params.data.source_city = newValue;
    //     //                     setSourceCity(newValue);
    //     //                     setBulkSourceError(false);
    //     //                     return true;
    //     //                 } else {
    //     //                     params.data.source_city = "";
    //     //                     setBulkSourceError(true);
    //     //                     return false;
    //     //                 }
    //     //             }
    //     //         }
        
    //     //         // Validate against consignerCityList
    //     //         const isValid = consignerCityList.includes(newValue.toLowerCase());
        
    //     //         if (!isValid) {
    //     //             //console.log("Invalid Source City!");
    //     //             params.data.source_city = "";
    //     //             setBulkSourceError(true);
    //     //             return false;
    //     //         }
        
    //     //         // If valid, update the source_city field
    //     //         params.data.source_city = newValue;
    //     //         setSourceCity(newValue);
        
    //     //         return true;
    //     //     },
        
    //     //     cellStyle: (params) => {
    //     //         let isGridValid = true; // Track overall validity of the grid
        
    //     //         // Iterate through all rows to check source_city validity
    //     //         params.api.forEachNode((node) => {
    //     //             const sourceCity = node.data.source_city;
    //     //             if (!sourceCity || !consignerCityList.includes(sourceCity.toLowerCase())) {
    //     //                 isGridValid = false; // Mark as invalid if any value is invalid
    //     //             }
    //     //         });
        
    //     //         // Update global error state based on grid validation
    //     //         setBulkSourceError(!isGridValid);
        
    //     //         // Apply red background for invalid cells
    //     //         if (!params.value || !consignerCityList.includes(params.value.toLowerCase())) {
    //     //             return {
    //     //                 backgroundColor: "#c85f62", // Light red background for invalid input
    //     //             };
    //     //         }
        
    //     //         return null; // Default styling for valid input
    //     //     },
    //     // },
        
        
    //     // {
    //     //     headerName: "Driver Mobile No",
    //     //     field: "driver_mobile_no",
    //     //     editable: true
    //     // },
    //     // {
    //     //     headerName: "Vehicle No",
    //     //     field: "truck_no",
    //     //     width: 150,
    //     //     resizable: true,
    //     //     editable: true,
    //     //     headerClass: "bold-header",
    //     //     valueGetter: function (params) {
    //     //         // Return the value if it's not empty
    //     //         if (params.data.truck_no && params.data.truck_no.trim() !== "") {
    //     //             setBulkVehicleNoError(false);
    //     //             return params.data.truck_no;
    //     //         }else if(params.data.truck_no===""){
    //     //             const tptCategory = tptData.find(e=> e.label.toLowerCase() === (params.data.courier_partner).toLowerCase())
    //     //             if(tptCategory && tptCategory.value?.toLowerCase()==="ptl"){
    //     //                 setBulkVehicleNoError(false);
    //     //                 return "";
    //     //             }else if(tptCategory && tptCategory.value?.toLowerCase() === "ftl"){
    //     //                 setBulkVehicleNoError(true);
    //     //                 return "";
    //     //             }
                    
                      
    //     //         }

    //     //     },
    //     //     valueSetter: function (params) {
    //     //         const newValue = params.newValue?.trim();
    //     //         const tptCategory = tptData.find(e=> e.label.toLowerCase() === (params.data.courier_partner).toLowerCase())

    //     //         // Validate only when mode is "FTL"
    //     //         if (
    //     //             tptCategory && tptCategory.value?.toLowerCase() === "ftl" &&
    //     //             (!newValue || newValue === "")
    //     //         ) {
    //     //             params.data.truck_no = ""; // Empty value for invalid input
    //     //             setBulkVehicleNoError(true);
    //     //             return true; // Trigger UI refresh
    //     //         }
        
    //     //         // Valid input
    //     //         params.data.truck_no = newValue;
    //     //         setBulkVehicleNoError(false);
    //     //         return true;
    //     //     },
    //     //     cellStyle: function (params) {
    //     //         // Find the tptCategory based on courier_partner
    //     //         const tptCategory = tptData.find(
    //     //             (e) => e.label.toLowerCase() === (params.data.courier_partner || "").toLowerCase()
    //     //         );
            
    //     //         // Check if tptCategory is found and has a valid value
    //     //         if (
    //     //             tptCategory &&
    //     //             tptCategory.value?.toLowerCase() === "ftl" &&
    //     //             (!params.value || params.value.trim() === "")
    //     //         ) {
    //     //             return { backgroundColor: "#c85f62" }; // Red background
    //     //         }
            
    //     //         // Default case: no special styling
    //     //         return null;
    //     //     }
    //     // },
    //     // {
    //     //     headerName: "Entity",
    //     //     field: "entity",
    //     //     width: 150,
    //     //     resizable: true,
    //     //     editable: true,
    //     //     valueGetter: (params)=>{
    //     //         if(params.data.entity==="" || !entityMasterData.includes((params.data.entity).toLowerCase())){
    //     //             setBulkEntityError(true);
    //     //             return ""
    //     //         }
    //     //         return params.data.entity
    //     //     },
    //     //     valueSetter: async (params) => {
    //     //         const newValue = params.newValue;
        
    //     //         // Check if the value is empty (empty string, null, or undefined)
    //     //         if (!newValue || newValue.trim() === "") {
    //     //             params.data.entity = ""
    //     //             setBulkEntityError(true);
    //     //             return ""; // Prevent the empty value from being set
    //     //         }
        
    //     //         // Validate the value against the master data
    //     //         const isValid = entityMasterData.includes(newValue.toLowerCase());
        
    //     //         if (!isValid) {
    //     //             //console.log("Invalid Entity!"); // Debugging log for invalid value
    //     //             params.data.entity = ""
    //     //             setBulkEntityError(true);
    //     //             return ""; // Prevent invalid value from being set
    //     //         }
        
    //     //         // If valid, set the value
    //     //         params.data.entity = newValue;
    //     //         setBulkEntityError(false);
    //     //         return "";
    //     //     },
    //     //     cellStyle: (params) => {
    //     //         // Check if the value is empty or not in entityMasterData
    //     //         if (
    //     //             params.value==="" || 
    //     //             !entityMasterData.includes(params.value.toLowerCase())
    //     //         ) {
    //     //             return {

    //     //                 backgroundColor: "#c85f62", // Light red for invalid or empty input
    //     //                 // color: "#ffffff", // White text for better visibility
    //     //             };
    //     //         }
    //     //         return null; // Default styling for valid input
    //     //     },
    //     //     headerClass: 'bold-header',
    //     // },
        
    //     // {
    //     //     headerName: "Vehicle Type" ,
    //     //     field: "vehicle_type",
    //     //     width: 150,
    //     //     cellRenderer: '', resizable: true,
    //     //     editable: true,
    //     //     valueGetter : (params)=>{
    //     //         if(params.data.vehicle_type==="" || !vehicleMasterData.includes((params.data.vehicle_type).toLowerCase())){
    //     //             setBulkVehicleTypeError(true);
    //     //             return ""
    //     //         }
    //     //         return params.data.vehicle_type
    //     //     },
    //     //     valueSetter: async (params) => {
    //     //         const newValue = params.newValue;
        
    //     //         // Check if the value is empty (empty string, null, or undefined)
    //     //         if (!newValue || newValue.trim() === "") {
    //     //             params.data.vehicle_type = ""
    //     //             setBulkVehicleTypeError(true);
    //     //             return ""; // Prevent the empty value from being set
    //     //         }
        
    //     //         // Validate the value against the master data
    //     //         const isValid = vehicleMasterData.includes(newValue.toLowerCase());
        
    //     //         if (!isValid) {
    //     //             //console.log("Invalid Entity!"); // Debugging log for invalid value
    //     //             params.data.vehicle_type = ""
    //     //             setBulkVehicleTypeError(true);
    //     //             return ""; // Prevent invalid value from being set
    //     //         }
        
    //     //         // If valid, set the value
    //     //         params.data.vehicle_type = newValue;
    //     //         setBulkVehicleTypeError(false);
    //     //         return "";
    //     //     },
    //     //     cellStyle: (params) => {
    //     //         // Check if the value is empty or not in entityMasterData
    //     //         if (
    //     //             !params.value || 
    //     //             !vehicleMasterData.includes(params.value.toLowerCase())
    //     //         ) {
    //     //             return {

    //     //                 backgroundColor: "#c85f62", // Light red for invalid or empty input
    //     //                 // color: "#ffffff", // White text for better visibility
    //     //             };
    //     //         }
    //     //         return null; // Default styling for valid input
    //     //     },
    //     //     headerClass: 'bold-header',
    //     // },
    //     // {
    //     //     headerName: "Customer Code",
    //     //     field: "customer_code",
    //     //     width: 200,
    //     //     cellRenderer: '',
    //     //     resizable: true,
    //     //         headerClass: 'bold-header'
    //     // },
    //     // {
    //     //     headerName: "Transporter" ,
    //     //     field: "courier_partner",
    //     //     width: 150,
    //     //     cellRenderer: '', resizable: true,
    //     //     editable:true,
    //     //     valueGetter: (params)=>{
    //     //         if(params.data.courier_partner===""){

    //     //             return ""
    //     //         }else if(!tptMasterData.includes(params.data.courier_partner.toLowerCase())){

    //     //             return ""
    //     //         }
    //     //         else{
    //     //             return params.data.courier_partner
    //     //         }
    //     //     },
    //     //     valueSetter: async (params) => {
    //     //         const newValue = params.newValue;
        
    //     //         // Check if the value is empty (empty string, null, or undefined)
    //     //         if (newValue==="" || newValue.trim() === "") {
    //     //             // Set the value to "Invalid Field Value" and prevent the update
    //     //             params.data.courier_partner = "";
    //     //             return false; // Prevent the empty value from being set
    //     //         }
        
    //     //         // Fetch consigners from the database
    //     //         const newValueLowerCase = newValue.toLowerCase();
    //     //         const isValid = tptMasterData.includes(newValueLowerCase);
                
        
    //     //         // If the consigner is invalid, set "Invalid Field Value" and prevent the update
    //     //         if (!isValid) {
    //     //             //console.log("Invalid Transporter!"); // Debugging log for invalid value
    //     //             params.data.courier_partner = "";
    //     //             return false; // Prevent invalid value from being set
    //     //         }
        
    //     //         // If valid, update the source_city field
    //     //         setTptName(newValue)
    //     //         params.data.courier_partner = newValue;

    //     //         return true; // Return true to indicate successful update
    //     //     },
        
    //     //     cellStyle: (params) => {
    //     //         // Check if the source_city is invalid or empty and apply red background
    //     //         if(!params.data.courier_partner || 
    //     //         !tptMasterData.includes(params.data.courier_partner.toLowerCase())){
    //     //             setBulkTptError(true)

    //     //             return {
    //     //                 backgroundColor: "#c85f62" // Light red background for invalid or empty input
    //     //             };
    //     //         }
    //     //         setBulkTptError(false)

    //     //         return null; // Default styling for valid input
    //     //     },
    //     //         headerClass: 'bold-header'
    //     // },
       
    //     // {
    //     //     headerName: "Movement Type",
    //     //     field: "movement_type",
    //     //     editable: true,
    //     //     valueGetter:(params)=>{
    //     //         if(params.data.movement_type!=""){
    //     //             return params.data.movement_type
    //     //         }else{
    //     //             setBulkMovementError(true)

    //     //             return ""
    //     //         }
    //     //     },
    //     //     valueSetter: (params)=>{
    //     //         const newValue = params.newValue;
    //     //         const validMovementType=["internal movement", "customer delivery", "customer returns"]
                
    //     //         const newValueLowerCase = newValue?.toLowerCase();
    //     //         const isValid = validMovementType.includes(newValueLowerCase);
    //     //         if(isValid){
    //     //             setBulkMovementError(false)
    //     //             params.data.movement_type= newValue;
    //     //             return true;
    //     //         }else{
    //     //             // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
    //     //             // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
    //     //             params.data.movement_type=""
    //     //             return false;
    //     //         }
    //     //     },
    //     //     cellStyle: (params) => {
              
    //     //         // If the value is not valid, apply red background
    //     //         if (params.value ==="") {
    //     //             return {
    //     //                 backgroundColor: "#c85f62"  // Light red background for invalid movement_type
    //     //             };
    //     //         }
    //     //         return null; // Default cell style for valid values
    //     //     }
            
    //     // },
    //     // {
    //     //     headerName: "Number Of Boxes",
    //     //     field: "no_of_boxes",
    //     //     width: 200,
    //     //     resizable: true,
    //     //     headerClass: 'bold-header',
    //     //     editable:true,
        
    //     //     // Add valueSetter for numeric validation
    //     //     valueSetter: (params) => {
    //     //         const newValue = params.newValue;
        
    //     //         // Check if the new value is a valid number
    //     //         if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
    //     //             // Set the value if it's a valid number
    //     //             params.data.no_of_boxes = parseFloat(newValue);
    //     //             setBulkBoxesError(false)
    //     //             return ; // Indicate that the value was successfully set
    //     //         } else {
    //     //             console.warn("Invalid input: Only numeric values are allowed.");
    //     //             params.data.no_of_boxes = '';
    //     //             setBulkBoxesError(true)

    //     //             return ""; // Prevent invalid values from being set
    //     //         }
    //     //     },
        
    //     //     // Add cellRenderer to display the value
    //     //     // cellRenderer: (params) => {
    //     //     //     return params.value || 0; // Display 0 if no value is set
    //     //     // },
        
    //     //     cellStyle: (params) => {
    //     //         if(isNaN(params.value)&& params.value!==""){
    //     //             return { backgroundColor: "#c85f62" }
    //     //         }
                
    //     //     },
    //     // },
    //       {
    //         headerName: "Total CBM",
    //         field: "total_cbm",
    //         width: 150,
    //         resizable: true,
    //         headerClass: 'bold-header',
    //         editable:true,
            
    //         // Value Setter for Numeric Validation
    //         valueSetter: (params) => {
    //             const newValue = params.newValue;
        
    //             // Check if the input is a valid float or integer
    //             if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
    //                 // Convert the value to a float (to accept decimals)
    //                 params.data.total_cbm = parseFloat(newValue);
    //                 return ; // Accept the value
    //             } else if(isNaN(newValue)) {
    //                 params.data.total_cbm =""
    //                 console.warn("Invalid input: Only numeric values (integer or float) are allowed.");
    //                 return ""; // Reject the value
    //             }
    //         },
        
    //         // Cell Renderer to Display the Value Properly
            
    //         cellStyle: (params) => {
    //             if(isNaN(params.value) && params.value!==""){
    //                 return { backgroundColor: "#c85f62" }
    //             }
                
    //         },
    //     },
    //     // {
    //     //     headerName: "Dispatch Date",
    //     //     field: "dispatch_date",
    //     //     editable: true,
    //     //     valueGetter: (params) => {
    //     //       const date = params.data.dispatch_date;
    //     //       // Check if date is empty or in DD-MM-YYYY format
    //     //       const datePattern = /^\d{2}-\d{2}-\d{4}$/;
    //     //       if (!date || datePattern.test(date)) {
    //     //         setBulkDispatchError(false); // Set error state for empty value

    //     //         return date || ""; // Return empty string if the date is empty
    //     //       } else {
    //     //         setBulkDispatchError(true); // Set error state for empty value
    //     //         return "Invalid Date Format";
    //     //       }
    //     //     },
    //     //     valueSetter: (params) => {
    //     //       const newValue = params.newValue;
    //     //       const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
    //     //       // Accept empty value or a valid DD-MM-YYYY formatted date
    //     //       if (newValue!=="" && datePattern.test(newValue)) {
    //     //         params.data.dispatch_date = newValue || ""; // Allow empty values
    //     //         setBulkDispatchError(false)
    //     //         return true;
    //     //       } else {
    //     //         params.data.dispatch_date = ""
    //     //         setBulkDispatchError(true)
    //     //         return false; // Reject invalid formats
    //     //       }
    //     //     },
    //     //     cellStyle: (params) => {
    //     //       const date = params.value;
    //     //       const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
    //     //       // Apply red background only if the value is invalid and not empty
    //     //       if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
    //     //         return { backgroundColor: "#c85f62" };
    //     //       }
    //     //       return null; // No style if valid or empty
    //     //     },
    //     //   },
          
          
    //     // {
    //     //     headerName: "Mode (Road/Air)",
    //     //     field: "shipment_mode",
    //     //     width: 190,
    //     //     cellRenderer: '',
    //     //     resizable: true,
    //     //     editable:true,
    //     //     valueGetter:(params)=>{
    //     //         const modeValue = (params.data.shipment_mode).toLowerCase();
    //     //         const validModeType=["air", "road"]
    //     //         if(validModeType.includes(modeValue)){
    //     //             setBulkModeError(false)

    //     //             return params.data.shipment_mode
    //     //         }else{
    //     //             setBulkModeError(true)

    //     //             return ""
    //     //         }
    //     //     },
    //     //     valueSetter: (params)=>{
    //     //         const newValue = params.newValue;
    //     //         const validModeType=["air", "road"]
                
    //     //         const newValueLowerCase = newValue?.toLowerCase();
    //     //         const isValid = validModeType.includes(newValueLowerCase);
    //     //         if(isValid){
    //     //             setBulkModeError(false)
    //     //             params.data.shipment_mode= newValue;
    //     //             return true;
    //     //         }else{
    //     //             // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
    //     //             // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
    //     //             setBulkModeError(true)
    //     //             params.data.shipment_mode=""
    //     //             return false;
    //     //         }
    //     //     },
    //     //     cellStyle: (params) => {
              
    //     //         // If the value is not valid, apply red background
    //     //         if (params.value ==="") {
    //     //             return {
    //     //                 backgroundColor: "#c85f62"  // Light red background for invalid movement_type
    //     //             };
    //     //         }
    //     //         return null; // Default cell style for valid values
    //     //     },
    //     //         headerClass: 'bold-header'
    //     // },
    //     // {
    //     //     headerName: "E-Way Bill No",
    //     //     field: "eway_bill_no",
    //     //     width: 150,
    //     //     cellRenderer: '',
    //     //     resizable: true,
    //     //         headerClass: 'bold-header'
    //     // },
       
    //     // {
    //     //     headerName: "Customer Mail ID",
    //     //     field: "customer_mail_id",
    //     //     width: 200,
    //     //     cellRenderer: '',
    //     //     resizable: true,
    //     //         headerClass: 'bold-header'
    //     // },
    //     // {
    //     //     headerName: "Tracking Mode (FTL/PTL)",
    //     //     field: "mode",
    //     //     editable: true,
    //     //     width:250,
    //     //     valueGetter: function (params) {
    //     //         if (params.data.mode !== "" && params.data.mode !== "") {
    //     //             setBulkTrackingError(false)
    //     //             return params.data.mode
    //     //         }else{
    //     //             setBulkTrackingError(true)
    //     //             return ""
    //     //         }
    //     //     },
    //     //     valueSetter: (params)=>{
    //     //         const newValue = params.newValue;
    //     //         if (!newValue || newValue.trim() === "") {
    //     //             params.data.mode = "";
    //     //             setBulkTrackingError(true); // Mark as error
    //     //             return ""; // Prevent update
    //     //         }
    //     //         params.data.mode = newValue;
    //     //         setBulkTrackingError(false); // Valid value
    //     //         return true


    //     //     },
    //     //     cellStyle: function (params) {
    //     //         // If the customer_name is empty, apply red background color
    //     //         if (params.value === "") {
    //     //             return {
    //     //                 backgroundColor: "#c85f62"  // Light red background for empty customer_name
    //     //             };
    //     //         }
    //     //         return null;  // No special styling if the customer_name is not empty
    //     //     },

    //     //         headerClass: 'bold-header'
    //     // },
    //     // {
    //     //     headerName: "Invoice Type",
    //     //     field: "invoice_type",
    //     //     editable: true,
    //     //     valueGetter: (params) => {
    //     //         if (params.data.invoice_no && params.data.invoice_no.includes("/")) {
    //     //             // Return the existing value when invoice_no contains a slash
    //     //             return params.data.invoice_type;
    //     //         }else{
    //     //             return "";
    //     //         }
    //     //         // Return empty value if invoice_no does not contain a slash
    //     //     },
            
    //     //     valueSetter: async (params) => {
    //     //         const newValue = params.newValue;
        
    //     //         if (!newValue || newValue.trim() === "") {
    //     //             params.data.invoice_type = "";
    //     //             setBulkInvoiceTypeError(false); // Mark as error
    //     //             return ""; // Prevent update
    //     //         }
        
    //     //         if (sourceCity !== "") {
    //     //             let matchingItem = invoiceSourceCategory.find(
    //     //                 (e) => e.label.toLowerCase() === sourceCity.toLowerCase()
    //     //             );
    //     //             if (matchingItem) {
    //     //                 if (matchingItem.value.toLowerCase() === newValue.toLowerCase()) {
    //     //                     params.data.invoice_type = newValue;
    //     //                     setBulkInvoiceTypeError(false); // Valid value
    //     //                     return true; // Update successful
    //     //                 } else {
    //     //                     params.data.invoice_type = "";
    //     //                     setBulkInvoiceTypeError(true); // Invalid value
    //     //                     return false; // Prevent update
    //     //                 }
    //     //             }
    //     //         }
        
    //     //         params.data.invoice_type = newValue; // Set the value
    //     //         setBulkInvoiceTypeError(false); // Clear error
    //     //         return true;
    //     //     },
    //     //     // cellStyle: (params) => {
    //     //     //     if (!params.value && params.data.invoice_no && params.data.invoice_no.includes("/")) {
    //     //     //         // Red background for invalid invoice_type when invoice_no has a slash
    //     //     //         return { backgroundColor: "#c85f62" };
    //     //     //     }
    //     //     //     return null; // Default styling
    //     //     // }
    //     // },
        
       
        
    //     // {
    //     //     headerName: "Fuel Type",
    //     //     field: "fuel_type",
    //     //     width: 190,
    //     //     cellRenderer: '',
    //     //     resizable: true,
    //     //     editable:true,
    //     //     valueGetter:(params)=>{
    //     //         const fuelValue = (params.data.fuel_type).toLowerCase();
    //     //         const validFuelType=["diesel", "ev", "cng","rail","air","sea",""]
    //     //         if(validFuelType.includes(fuelValue)){
    //     //             setBulkFuelError(false)

    //     //             return params.data.fuel_type
    //     //         }else{
    //     //             setBulkFuelError(true)

    //     //             return ""
    //     //         }
    //     //     },
    //     //     valueSetter: (params)=>{
    //     //         const newValue = params.newValue;
    //     //         const validFuelType=["diesel", "ev", "cng","rail","air","sea",""]
                
    //     //         const newValueLowerCase = newValue?.toLowerCase();
    //     //         const isValid = validFuelType.includes(newValueLowerCase);
    //     //         if(isValid){
    //     //             setBulkFuelError(false)
    //     //             params.data.fuel_type= newValue;
    //     //             return true;
    //     //         }else{
    //     //             // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
    //     //             // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
    //     //             setBulkFuelError(true)
    //     //             params.data.fuel_type=""
    //     //             return false;
    //     //         }
    //     //     },
    //     //     cellStyle: (params) => {
    //     //         // Define the list of valid fuel types
    //     //         const validFuelType = ["diesel", "ev", "cng", "rail", "air", "sea", ""];
            
    //     //         // Access the fuel type value from the data object
    //     //         const fuelValue = params.data.fuel_type?.toLowerCase();
    //     //         const isValid = validFuelType.includes(fuelValue);
    //     //         // Check if the fuel type is valid
    //     //         if (!isValid) {
    //     //             return {
    //     //                 backgroundColor: "#c85f62", // Light red background for invalid fuel_type
    //     //                 color: "#ffffff", // Optional: White text color for better visibility
    //     //             };
    //     //         }
            
    //     //         return null; // Default cell style for valid values
    //     //     },
    //     //         headerClass: 'bold-header'
    //     // },
    //     // {
    //     //     headerName: "Driver Name",
    //     //     field: "driver_name",
    //     //     editable: true,
    //     //     // cellStyle: params => {
    //     //     //     if (params.data.driver_name == undefined || params.data.driver_name == "" ) {

    //     //     //         return {
    //     //     //             "backgroundColor": '#c85f62'
    //     //     //         };
    //     //     //     }
    //     //     // }
    //     // },
       
        
    // ]
    const showTrackingTimeline=()=>{
        setTrackingTimeline(prev=> !prev)
        setShowModal(prev=> !prev)
    }
    const columnDef = [
        {
            headerName: "Invoice No",
            field: "invoice_no",
            width: 150,
            resizable: true,
            editable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                // Return the current invoice value
                return params.data.invoice_no || ""; // Ensure empty string if undefined/null
            },
            valueSetter: function (params) {
                const invoiceValue = params.newValue && params.newValue.trim(); // Trim whitespace
                if (!invoiceValue) {
                    // If the value is empty, mark the field as invalid
                    params.data.invoice_no = ""; // Keep it empty
                    return false; // Indicate failure to set
                } else {
                    // Update the value and indicate success
                    params.data.invoice_no = invoiceValue;
                    return true; // Indicate success
                }
            },
            cellStyle: (params) => {
                const invoiceNo = params.data.invoice_no;
                if (!invoiceNo || invoiceNo.trim() === "") {
                    // Apply red background and white text for invalid cells
                    return { "backgroundColor": "#c85f62"};
                }
                return null; // No special styling for valid cells
            },
        },
        {
            headerName: "Invoice Series",
            field: "invoice_series",
            width: 150,
            resizable: true,
            editable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                // Return the current invoice value
                return params.data.invoice_series || ""; // Ensure empty string if undefined/null
            },
            valueSetter: function (params) {
                const invoiceSeries = params.newValue && params.newValue.trim(); // Trim whitespace
                if (!invoiceSeries) {
                    // If the value is empty, keep it empty
                    params.data.invoice_series = ""; // Keep it empty
                    return false; // Indicate failure to set
                } else {
                    // Update the value and indicate success
                    params.data.invoice_series = invoiceSeries;
                    return true; // Indicate success
                }
            }
        }
        ,
        {
            headerName: "Invoice Type" ,
            field: "invoice_type",
            width: 200,
            cellRenderer: '', resizable: true,
            editable:true,
            valueGetter: (params)=>{
               
                    return params.data.invoice_type
                
            },
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                // Check if the value is empty (empty string, null, or undefined)
                if (newValue==="" || newValue.trim() === "") {
                    // Set the value to "Invalid Field Value" and prevent the update
                    params.data.invoice_type = "";
                    return false; // Prevent the empty value from being set
                }
        
                // Fetch consigners from the database
                const newValueLowerCase = newValue.toLowerCase();
                const isValid = invoiceMasterData.includes(newValueLowerCase);
                
        
                // If the consigner is invalid, set "Invalid Field Value" and prevent the update
                // if (!isValid) {
                //     params.data.invoice_type = "";
                //     return false; // Prevent invalid value from being set
                // }
        
                // If valid, update the source_city field
                params.data.invoice_type = newValue;

                return true; // Return true to indicate successful update
            },
        
            cellStyle: (params) => {
                // Check if the source_city is invalid or empty and apply red background
                if(params.data.invoice_type !=="" && !invoiceMasterData.includes(params.data.invoice_type.toLowerCase())){

                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid or empty input
                        color:"#c85f62"

                    };
                }

                return null; // Default styling for valid input
            },
                headerClass: 'bold-header'
        },
        
        {
            headerName: "Invoice Date",
            field: "invoice_date",
            // colId: "invoice_date",
            // comparator: dateComparator,
            // cellEditor: DateEditor,
            editable: true,
            valueGetter: (params) => {
              const date = params.data.invoice_date;
              // Check if date is in DD-MM-YYYY format
              const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}$/;
          
              if (date && datePattern.test(date)) {
                return date;
              } else {

                return "";
              }
            },
            valueSetter: (params) => {
              const newValue = params.newValue;
              const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}$/;
          
              // Check if the new value follows the DD-MM-YYYY format
              if (newValue && datePattern.test(newValue)) {
                params.data.invoice_date = newValue; // Set the new value if valid
                return true;
              } else {
                params.data.invoice_date = ""; // Set the new value if valid
                return false; // Reject the value if it's in an invalid format
              }
            },
            cellStyle: (params) => {
              const date = params.value;
              // Apply red background if the date format is invalid
              if (date === "") {
                return { "backgroundColor": "#c85f62" };
              }
              return null;
            },
          },
          {
            headerName: "Entity" ,
            field: "truck_seal_entity",
            width: 200,
            cellRenderer: '', resizable: true,
            editable:true,
            valueGetter: (params)=>{
                    return params.data.truck_seal_entity
            },
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                // Check if the value is empty (empty string, null, or undefined)
                if (newValue==="" || newValue.trim() === "") {
                    // Set the value to "Invalid Field Value" and prevent the update
                    params.data.truck_seal_entity = "";
                    return false; // Prevent the empty value from being set
                }
        
                // Fetch consigners from the database
                const newValueLowerCase = newValue.toLowerCase();
                const isValid = entityMasterData.includes(newValueLowerCase);
                
        
                // If the consigner is invalid, set "Invalid Field Value" and prevent the update
                // if (!isValid) {
                //     params.data.truck_seal_entity = "";
                //     return false; // Prevent invalid value from being set
                // }
        
                // If valid, update the source_city field
                params.data.truck_seal_entity = newValue;

                return true; // Return true to indicate successful update
            },
        
            cellStyle: (params) => {
                // Check if the source_city is invalid or empty and apply red background
                if(params.data.truck_seal_entity !=="" && !entityMasterData.includes(params.data.truck_seal_entity.toLowerCase())){

                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid or empty input
                        color:"#c85f62"

                    };
                }

                return null; // Default styling for valid input
            },
                headerClass: 'bold-header'
        },
        
          {
            headerName: "Consignor Name",
            field: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            editable:true,
            // valueGetter: function (params) {
            //     if (params.data.consignee_name != "" && params.data.consignee_name != "") {
            //         return params.data.consignee_name
            //     }else{
            //         return ""
            //     }
            // },
            // valueSetter: function(params){
            //     const newValue = params.newValue;
            //     if (newValue != "" && newValue != "") {
            //         params.data.consignee_name = newValue;
            //         return true
            //     }else{
            //         params.data.consignee_name = "";
            //         return false
            //     }

            // },
            // cellStyle: function (params) {
            //     // If the customer_name is empty, apply red background color
            //     if (params.value === "") {
            //         return {
            //             backgroundColor: "#c85f62"  // Light red background for empty customer_name
            //         };
            //     }
            //     return null;  // No special styling if the customer_name is not empty
            // },

                headerClass: 'bold-header'
        },
        {
            headerName: "Source" ,
            field: "consigner_city",
            width: 200,
            cellRenderer: '', resizable: true,
            editable:true,
            valueGetter: (params)=>{
              
                    return params.data.consigner_city
            },
            valueSetter: async (params) => {
                const newValue = params.newValue;
        
                // Check if the value is empty (empty string, null, or undefined)
                if (newValue==="" || newValue.trim() === "") {
                    // Set the value to "Invalid Field Value" and prevent the update
                    params.data.consigner_city = "";
                    return false; // Prevent the empty value from being set
                }
        
                // Fetch consigners from the database
                const newValueLowerCase = newValue.toLowerCase();
                const isValid = invoiceSourceData.includes(newValueLowerCase);
                
        
                // If the consigner is invalid, set "Invalid Field Value" and prevent the update
                // if (!isValid) {
                //     params.data.consigner_city = "";
                //     return false; // Prevent invalid value from being set
                // }
        
                // If valid, update the source_city field
                params.data.consigner_city = newValue;

                return true; // Return true to indicate successful update
            },
        
            cellStyle: (params) => {
                // Check if the source_city is invalid or empty and apply red background
                if(params.data.consigner_city !=="" && !invoiceSourceData.includes(params.data.consigner_city.toLowerCase())){
                    params.data.consigner_city=""

                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid or empty input
                        color:"#c85f62"
                    };
                }

                return null; // Default styling for valid input
            },
                headerClass: 'bold-header'
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            editable:true,
            // valueGetter: function (params) {
            //     if (params.data.consignee_name != "" && params.data.consignee_name != "") {
            //         return params.data.consignee_name
            //     }else{
            //         return ""
            //     }
            // },
            // valueSetter: function(params){
            //     const newValue = params.newValue;
            //     if (newValue != "" && newValue != "") {
            //         params.data.consignee_name = newValue;
            //         return true
            //     }else{
            //         params.data.consignee_name = "";
            //         return false
            //     }

            // },
            // cellStyle: function (params) {
            //     // If the customer_name is empty, apply red background color
            //     if (params.value === "") {
            //         return {
            //             backgroundColor: "#c85f62"  // Light red background for empty customer_name
            //         };
            //     }
            //     return null;  // No special styling if the customer_name is not empty
            // },

                headerClass: 'bold-header'
        },
          {
            headerName: "Consignee Name",
            field: "consignee_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            editable:true,
            valueGetter: function (params) {
                if (params.data.consignee_name != "" && params.data.consignee_name != "") {
                    return params.data.consignee_name
                }else{
                    return ""
                }
            },
            valueSetter: function(params){
                const newValue = params.newValue;
                if (newValue != "" && newValue != "") {
                    params.data.consignee_name = newValue;
                    return true
                }else{
                    params.data.consignee_name = "";
                    return false
                }

            },
            cellStyle: function (params) {
                // If the customer_name is empty, apply red background color
                if (params.value === "") {
                    return {
                        backgroundColor: "#c85f62"  // Light red background for empty customer_name
                    };
                }
                return null;  // No special styling if the customer_name is not empty
            },

                headerClass: 'bold-header'
        },
        {
            headerName: "Destination City" ,
            field: "consignee_city",
            width: 150,
            editable:true,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                const destinationCity = params.data.consignee_city;
                    if (destinationCity !=="") {
                      return destinationCity;
                    } else {
                      return "";
                    }
            },
            valueSetter : function (params){
                const newValue = params.newValue;
                    if (newValue != "" && newValue != "") {
                        params.data.consignee_city = newValue;
                        return true
                    }else{
                        params.data.consignee_city = "";
                        return false
            }},
            cellStyle: (params) => {
                    const destinationCity = params.value;
                    // Apply red background if the date format is invalid
                    if (destinationCity === "") {
                      return { "backgroundColor": "#c85f62" };
                    }
                    return null;
                  },
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            width: 180,
            editable:true,

            cellRenderer: '', resizable: true,
                headerClass: 'bold-header',
                valueGetter: (params) => {
                    const destinationPincode = params.data.consignee_pincode;
                    if (destinationPincode !=="" && /^\d{6}$/.test(destinationPincode)) {
                      return destinationPincode;
                    } else {
                      return "";
                    }
                  },
                  valueSetter: (params) => {
                    const newValue = params.newValue;
                    if (newValue != "" && newValue != "" && /^\d{6}$/.test(newValue)) {
                        params.data.consignee_pincode = newValue;
                        return true
                    }else{
                        params.data.consignee_pincode = "";
                        return false
                    }
                  },
                  cellStyle: (params) => {
                    const destinationPincode = params.value;
                    // Apply red background if the date format is invalid
                    if (destinationPincode === "") {
                      return { "backgroundColor": "#c85f62" };
                    }
                    return null;
                  },
        },
        {
            headerName: "Total Weight", // Column header name
            field: "total_weight", // Field in the data associated with this column
            width: 150, // Width of the column
            resizable: true, // Allow column resizing
            headerClass: 'bold-header', // Custom CSS class for the header
            editable: true, // Enable editing of the cell value
        
            // Value Getter: Determines what value to display in the cell
            valueGetter: (params) => {
                const weight = params.data.total_weight;
                
                if (weight === "" || weight === null || weight === undefined || isNaN(weight)) {
                    params.data.total_weight="";
                    return ""; // Display an empty string for invalid or empty values
                }
                return parseFloat(weight); // Ensure the value is numeric
            },
        
            // Value Setter: Handles updates to the cell value
            valueSetter: (params) => {
                const newValue = params.newValue; // Get the new value entered by the user
        
                // Check if the new value is a valid number
                if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
                    params.data.total_weight = parseFloat(newValue); // Convert and set the value
                    return true; // Indicate successful value update
                } else {
                    console.warn("Invalid input: Only numeric values are allowed.");
                    params.data.total_weight = ''; // Reset the value to empty
                    return false; // Indicate failed value update
                }
            },
        
            // Cell Style: Applies conditional styling for invalid cells
            cellStyle: (params) => {
                // Apply red background for the current cell if it is invalid
                if (isNaN(params.value)) {
                    return { backgroundColor: "#c85f62" }; // Highlight invalid cells
                }
                return null; // No special styling for valid cells
            },
        }
        ,
        
        {
            headerName: "Total CBM", // Column header name
            field: "total_cbm", // Field in the data associated with this column
            width: 150, // Width of the column
            resizable: true, // Allow column resizing
            headerClass: 'bold-header', // Custom CSS class for the header
            editable: true, // Enable editing of the cell value
        
            // Value Getter: Determines what value to display in the cell
            valueGetter: (params) => {
                const cbm = params.data.total_cbm;
                if (cbm === "" || cbm === null || cbm === undefined || isNaN(cbm)) {
                    params.data.total_cbm=""
                    return ""; // Display an empty string for invalid or empty values
                }
                return parseFloat(cbm); // Ensure the value is numeric
            },
        
            // Value Setter: Handles updates to the cell value
            valueSetter: (params) => {
                const newValue = params.newValue; // Get the new value entered by the user
        
                // Check if the new value is a valid number
                if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
                    params.data.total_cbm = parseFloat(newValue); // Convert and set the value
                    return true; // Indicate successful value update
                } else {
                    console.warn("Invalid input: Only numeric values are allowed.");
                    params.data.total_cbm = ''; // Reset the value to empty
                    return false; // Indicate failed value update
                }
            },
        
            // Cell Style: Applies conditional styling for invalid cells
            cellStyle: (params) => {
                // Apply red background for the current cell if it is invalid
                if (isNaN(params.value)) {
                    return { backgroundColor: "#c85f62" }; // Highlight invalid cells
                }
                return null; // No special styling for valid cells
            },
        },
        {
            headerName: "Customer Mobile Number",
            field: "cus_mobile_no",
            width: 220,
            filter: "agSetColumnFilter",
            resizable: true,
            editable: true,
            headerClass: "bold-header",
            valueSetter: (params) => {
                const value = params.newValue;

                if (/^\d*$/.test(value)) {
                    params.data.cus_mobile_no = value;
                    return true;
                } else {
                    return false;
                }
            },
        }

        
    ]
    const columnTransporterDef = [
        {
            headerName: "Invoice No",
            field: "invoice_no",
            width: 150,
            resizable: true,
            editable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                // Return the current invoice value
                return params.data.invoice_no || ""; // Ensure empty string if undefined/null
            },
            valueSetter: function (params) {
                const invoiceValue = params.newValue && params.newValue.trim(); // Trim whitespace
                if (!invoiceValue) {
                    // If the value is empty, mark the field as invalid
                    params.data.invoice_no = ""; // Keep it empty
                    return false; // Indicate failure to set
                } else {
                    // Update the value and indicate success
                    params.data.invoice_no = invoiceValue;
                    return true; // Indicate success
                }
            },
            cellStyle: (params) => {
                const invoiceNo = params.data.invoice_no;
                if (!invoiceNo || invoiceNo.trim() === "") {
                    // Apply red background and white text for invalid cells
                    return { "backgroundColor": "#c85f62"};
                }
                return null; // No special styling for valid cells
            },
        },

        {
                    headerName: "Transporter Name" ,
                    field: "transporter_name",
                    width: 200,
                    cellRenderer: '', resizable: true,
                    editable:true,
                    valueGetter: (params)=>{
                        if(params.data.transporter_name===""){
        
                            return ""
                        }else if(!tptMasterData.includes(params.data.transporter_name.toLowerCase())){
        
                            return ""
                        }
                        else{
                            return params.data.transporter_name
                        }
                    },
                    valueSetter: async (params) => {
                        const newValue = params.newValue;
                
                        // Check if the value is empty (empty string, null, or undefined)
                        if (newValue==="" || newValue.trim() === "") {
                            // Set the value to "Invalid Field Value" and prevent the update
                            params.data.transporter_name = "";
                            return false; // Prevent the empty value from being set
                        }
                
                        // Fetch consigners from the database
                        const newValueLowerCase = newValue.toLowerCase();
                        const isValid = tptMasterData.includes(newValueLowerCase);
                        
                
                        // If the consigner is invalid, set "Invalid Field Value" and prevent the update
                        if (!isValid) {
                            //console.log("Invalid Transporter!"); // Debugging log for invalid value
                            params.data.transporter_name = "";
                            return false; // Prevent invalid value from being set
                        }
                
                        // If valid, update the source_city field
                        params.data.transporter_name = newValue;
        
                        return true; // Return true to indicate successful update
                    },
                
                    cellStyle: (params) => {
                        // Check if the source_city is invalid or empty and apply red background
                        if(!params.data.transporter_name || 
                        !tptMasterData.includes(params.data.transporter_name.toLowerCase())){
        
                            return {
                                backgroundColor: "#c85f62" // Light red background for invalid or empty input
                            };
                        }
        
                        return null; // Default styling for valid input
                    },
                        headerClass: 'bold-header'
                },
        
    ]
     const columnLRDef = [
        {
            headerName: "Invoice No",
            field: "invoice_no",
            width: 150,
            resizable: true,
            editable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                // Return the current invoice value
                return params.data.invoice_no || ""; // Ensure empty string if undefined/null
            },
            valueSetter: function (params) {
                const invoiceValue = params.newValue && params.newValue.trim(); // Trim whitespace
                if (!invoiceValue) {
                    // If the value is empty, mark the field as invalid
                    params.data.invoice_no = ""; // Keep it empty
                    return false; // Indicate failure to set
                } else {
                    // Update the value and indicate success
                    params.data.invoice_no = invoiceValue;
                    return true; // Indicate success
                }
            },
            cellStyle: (params) => {
                const invoiceNo = params.data.invoice_no;
                if (!invoiceNo || invoiceNo.trim() === "") {
                    // Apply red background and white text for invalid cells
                    return { "backgroundColor": "#c85f62"};
                }
                return null; // No special styling for valid cells
            },
        },

        {
                    headerName: "Transporter Name" ,
                    field: "transporter_name",
                    width: 200,
                    cellRenderer: '', resizable: true,
                    editable:true,
                    valueGetter: (params)=>{
                        if(params.data.transporter_name===""){
        
                            return ""
                        }else if(!tptMasterData.includes(params.data.transporter_name.toLowerCase())){
        
                            return ""
                        }
                        else{
                            return params.data.transporter_name
                        }
                    },
                    valueSetter: async (params) => {
                        const newValue = params.newValue;
                
                        // Check if the value is empty (empty string, null, or undefined)
                        if (newValue==="" || newValue.trim() === "") {
                            // Set the value to "Invalid Field Value" and prevent the update
                            params.data.transporter_name = "";
                            return false; // Prevent the empty value from being set
                        }
                
                        // Fetch consigners from the database
                        const newValueLowerCase = newValue.toLowerCase();
                        const isValid = tptMasterData.includes(newValueLowerCase);
                        
                
                        // If the consigner is invalid, set "Invalid Field Value" and prevent the update
                        if (!isValid) {
                            //console.log("Invalid Transporter!"); // Debugging log for invalid value
                            params.data.transporter_name = "";
                            return false; // Prevent invalid value from being set
                        }
                
                        // If valid, update the source_city field
                        params.data.transporter_name = newValue;
        
                        return true; // Return true to indicate successful update
                    },
                
                    cellStyle: (params) => {
                        // Check if the source_city is invalid or empty and apply red background
                        if(!params.data.transporter_name || 
                        !tptMasterData.includes(params.data.transporter_name.toLowerCase())){
        
                            return {
                                backgroundColor: "#c85f62" // Light red background for invalid or empty input
                            };
                        }
        
                        return null; // Default styling for valid input
                    },
                        headerClass: 'bold-header'
                },
        {
            headerName: "LR No",
            field: "lr_no",
            width: 150,
            editable: true, // Allow editing
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                // Return the current invoice value
                return params.data.lr_no || ""; // Ensure empty string if undefined/null
            },
            valueSetter: function (params) {
                const lrValue = params.newValue && params.newValue.trim(); // Trim whitespace
                if (!lrValue) {
                    // If the value is empty, mark the field as invalid
                    params.data.lr_no = ""; // Keep it empty
                    return false; // Indicate failure to set
                } else {
                    // Update the value and indicate success
                    params.data.lr_no = lrValue;
                    return true; // Indicate success
                }
            },
            cellStyle: (params) => {
                const lrNo = params.data.lr_no;
                if (!lrNo || lrNo.trim() === "") {
                    // Apply red background and white text for invalid cells
                    return { "backgroundColor": "#c85f62"};
                }
                return null; // No special styling for valid cells
            },
        },
            {
            headerName: "Dispatch Date",
            field: "dispatch_date",
            editable: true,
            valueGetter: (params) => {
              const date = params.data.dispatch_date;
              // Check if date is empty or in DD-MM-YYYY format
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
              if (!date || datePattern.test(date)) {

                return date || ""; // Return empty string if the date is empty
              } else {
                return "Invalid Date Format";
              }
            },
            valueSetter: (params) => {
              const newValue = params.newValue;
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
              // Accept empty value or a valid DD-MM-YYYY formatted date
              if (newValue!=="" && datePattern.test(newValue)) {
                params.data.dispatch_date = newValue || ""; // Allow empty values
                return true;
              } else {
                params.data.dispatch_date = ""
                return false; // Reject invalid formats
              }
            },
            cellStyle: (params) => {
              const date = params.value;
              const datePattern = /^\d{2}-\d{2}-\d{4}$/;
          
              // Apply red background only if the value is invalid and not empty
              if ((date==="" || date == "Invalid Date Format") && !datePattern.test(date)) {
                return { backgroundColor: "#c85f62" };
              }
              return null; // No style if valid or empty
            },
          },
          {
            headerName: "Vehicle No",
            field: "truck_no",
            width: 150,
            resizable: true,
            editable: true,
            headerClass: "bold-header",
        
            valueGetter: function (params) {
                if (params.data.truck_no && params.data.truck_no.trim() !== "") {
                    return params.data.truck_no.replace(/\s+/g, ""); // Return the value if not empty
                } else if (params.data.truck_no === "") {
                    const tptCategory = tptData.find(
                        (e) => e.label.toLowerCase() === (params.data.transporter_name || "").toLowerCase()
                    );
                    if (tptCategory && tptCategory.value?.toLowerCase() === "ptl") {
                        return ""; // Allow empty for PTL
                    } else if (tptCategory && tptCategory.value?.toLowerCase() === "ftl") {
                        return ""; // Allow empty for FTL but validate it
                    }
                }
            },
        
            valueSetter: function (params) {
                const newValue = params.newValue?.replace(/\s+/g, "");;
                const transporterName = (params.data.transporter_name || "").toLowerCase();
                const trackingType = (params.data.tracking_type || "").toLowerCase();
                const tptCategory = tptData.find((e) => e.label.toLowerCase() === transporterName);
        
                // Determine if the field is mandatory
                let isMandatory = false;
                if (tptCategory && tptCategory.value?.toLowerCase() === "ftl") {
                    isMandatory = true; // FTL requires vehicle no
                } else if (tptCategory && tptCategory.value?.toLowerCase() === "ptl") {
                    isMandatory = false; // PTL allows empty
                } else if (trackingType === "ftl") {
                    isMandatory = true; // Fallback to tracking_type for FTL
                } else if (trackingType === "ptl") {
                    isMandatory = false; // Fallback to tracking_type for PTL
                }
        
                // **Ensure the input contains both letters and numbers and is 8-10 characters long**
                const isValidTruckNo = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,10}$/.test(newValue);
        
                // Validation for PTL: Allow empty, but if entered, must be valid
                if (!isMandatory) {
                    if (!newValue) {
                        params.data.truck_no = ""; // Allow empty values for PTL
                        return true;
                    }
                    if (!isValidTruckNo) {
                        console.warn("Invalid truck number for PTL:", newValue);
                        params.data.truck_no =newValue; // Keep the invalid value but highlight it
                        return false; // Do not reset invalid value, just highlight it
                    }
                    params.data.truck_no = newValue; // Accept valid input
                    return true;
                }
        
                // Validation for FTL: Must contain both letters & numbers (8-10 characters)
                if (isMandatory && (!newValue || !isValidTruckNo)) {
                    console.warn("Invalid truck number for FTL:", newValue);
                    params.data.truck_no = ""; // Keep invalid value but highlight it
                    return false; // Do not reset invalid value, just highlight it
                }
        
                // Accept valid input for FTL
                params.data.truck_no = newValue;
                return true;
            },
        
            cellStyle: function (params) {
                const transporterName = (params.data.transporter_name || "").toLowerCase();
                const trackingType = (params.data.tracking_type || "").toLowerCase();
                const tptCategory = tptData.find((e) => e.label.toLowerCase() === transporterName);
        
                // Determine if the field is mandatory
                let isMandatory = false;
                if (tptCategory && tptCategory.value?.toLowerCase() === "ftl") {
                    isMandatory = true; // FTL requires vehicle no
                } else if (tptCategory && tptCategory.value?.toLowerCase() === "ptl") {
                    isMandatory = false; // PTL allows empty
                } else if (trackingType === "ftl") {
                    isMandatory = true; // Fallback to tracking_type for FTL
                } else if (trackingType === "ptl") {
                    isMandatory = false; // Fallback to tracking_type for PTL
                }
        
                // **Ensure the input contains both letters & numbers (8-10 characters)**
                const isValidTruckNo = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,10}$/.test(params.value || "");
        
                // Highlight invalid FTL values
                if (isMandatory && (!params.value || params.value.trim() === "" || !isValidTruckNo)) {
                    return { backgroundColor: "#c85f62" }; // Red background for invalid FTL input
                }
        
                // Highlight invalid PTL values (if not empty but invalid)
                if (!isMandatory && params.value && !isValidTruckNo) {
                    return { backgroundColor: "#c85f62",color: "#c85f62"}; // Red background for invalid PTL input
                }

        
                // Default case: no special styling
                return null;
            },
        },
        
        
        
        
     
        {
            headerName: "Vehicle Type",
            field: "truck_type",
            width: 150,
            resizable: true,
            editable: true,
        
            // Updated valueGetter
            valueGetter: (params) => {
                const vehicleType = params.data?.truck_type?.toLowerCase?.() || ""; // Safe check
                return vehicleFtlTypeArr1.includes(vehicleType) ? params.data.truck_type : params.data.truck_type; // Only return if valid for FTL
            },
        
            // Updated valueSetter
            valueSetter: (params) => {
                const newValue = params.newValue?.toLowerCase()|| "";
        
                // Check if the transporter defines FTL/PTL
                const transporterName = params.data?.transporter_name?.toLowerCase() || "";
                const tpt = tptData.find(e => e.label.toLowerCase() === transporterName);
                const tptType = tpt?.value?.toLowerCase() || "";
        
                let isMandatory;
                if (tptType === "ftl") {
                    isMandatory = true; // Vehicle type is required for FTL
                } else if (tptType === "ptl") {
                    isMandatory = false; // Vehicle type can be empty for PTL
                } else {
                    const trackingType = params.data?.tracking_type?.toLowerCase() || "";
                    isMandatory = trackingType === "ftl"; // Default to FTL rule if undefined
                }
        
                // Validation for PTL: Allow any value, including empty
                if (!isMandatory) {
                    params.data.truck_type = newValue || ""; // Allow empty or any value for PTL
                    return true; // Always accept
                }
                console.log(vehicleFtlTypeArr1, "vehicleFtlTypeArr1");
                
                // Validation for FTL: Must exist in vehicleFtlTypeArr1
                if (!vehicleFtlTypeArr1.includes(newValue)) {
                    console.warn("Invalid truck type for FTL:", params.newValue);
                    params.data.truck_type = ""; // Reset for invalid input
                    return false; // Reject invalid value
                }
        
                params.data.truck_type = params.newValue;
                return true; // Accept valid value
            },
        
            // Updated cellStyle
            cellStyle: (params) => {
                const value = params.value?.toLowerCase() || "";
        
                // Determine if vehicle type is mandatory
                const transporterName = params.data?.transporter_name?.toLowerCase() || "";
                const tpt = tptData.find(e => e.label.toLowerCase() === transporterName);
                const tptType = tpt?.value?.toLowerCase() || "";
        
                let isMandatory;
                if (tptType === "ftl") {
                    isMandatory = true; // Vehicle type is required for FTL
                } else if (tptType === "ptl") {
                    isMandatory = false; // Vehicle type can be empty for PTL
                } else {
                    const trackingType = params.data?.tracking_type?.toLowerCase() || "";
                    isMandatory = trackingType === "ftl"; // Default to FTL rule if undefined
                }
        
                const isValid = vehicleFtlTypeArr1.includes(value);
        
                // Apply red background if FTL and invalid
                if (isMandatory && (!value || !isValid)) {
                    return { backgroundColor: "#c85f62" }; // Highlight invalid input for FTL
                }
        
                return null; // Default style for valid input or PTL
            },
        
            headerClass: "bold-header",
        }
        ,
        // {
        //     headerName: "Fuel Type",
        //     field: "fuel_type",
        //     width: 190,
        //     cellRenderer: '',
        //     resizable: true,
        //     editable:true,
        //     valueGetter:(params)=>{
                
        //         const validFuelType1=tptNFuel.filter(e=> (e.label.toLowerCase()===params.data.transporter_name.toLowerCase())).map(e=>e.value).flat()
        //         const validFuelType = validFuelType1.map(fuel=> fuel.toLowerCase())
        //         const fuelValue = (params.data.fuel_type).toLowerCase();
        //         if(validFuelType.includes(fuelValue)){
        //             return params.data.fuel_type
        //         }else{
        //             return ""
        //         }
        //     },
        //     valueSetter: (params)=>{
        //         const newValue = params.newValue;
        //         const validFuelType1=tptNFuel.filter(e=> (e.label.toLowerCase()===params.data.transporter_name.toLowerCase())).map(e=>e.value).flat()
        //         const validFuelType = validFuelType1.map(fuel=> fuel.toLowerCase())
        //         const newValueLowerCase = newValue?.toLowerCase();
        //         const isValid = validFuelType.includes(newValueLowerCase);
        //         if(isValid){
        //             params.data.fuel_type= newValue;
        //             return true;
        //         }else{
        //             // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
        //             // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
        //             params.data.fuel_type=""
        //             return false;
        //         }
        //     },
        //     cellStyle: (params) => {
        //         // Define the list of valid fuel types
        //         const validFuelType1=tptNFuel.filter(e=> (e.label.toLowerCase()===params.data.transporter_name.toLowerCase())).map(e=>e.value).flat()
        //         const validFuelType = validFuelType1.map(fuel=> fuel.toLowerCase())
        //         // Access the fuel type value from the data object
        //         const fuelValue = params.data.fuel_type?.toLowerCase();
        //         const isValid = validFuelType.includes(fuelValue);
        //         // Check if the fuel type is valid
        //         if (!isValid) {
        //             return {
        //                 backgroundColor: "#c85f62", // Light red background for invalid fuel_type
        //                 // color: "#ffffff", // Optional: White text color for better visibility
        //             };
        //         }
            
        //         return null; // Default cell style for valid values
        //     },
        //         headerClass: 'bold-header'
        // },
         {
             headerName: "Fuel Type",
             field: "fuel_type",
             width: 190,
             editable: true,
             resizable: true,
             valueGetter: (params) => {
                 return params.data.fuel_type || "";
             },
             valueSetter: (params) => {
                 const newValue = params.newValue;
                 params.data.fuel_type = newValue;
                 const fuelToModeMap = {
                     diesel: "Road",
                     ev: "Road",
                     cng: "Road",
                     air: "Air",
                     rail: "Rail",
                     sea: "Sea"
                 };
                 const fuel = newValue?.toLowerCase()?.trim();
                 const matchedKey = Object.keys(fuelToModeMap).find(key =>
                     fuel?.includes(key)
                 );
                 params.data.mode = matchedKey ? fuelToModeMap[matchedKey] : "";
                 return true;
             },
             headerClass: 'bold-header'
         },
                {
            headerName: "Tracking Mode (FTL/PTL)",
            field: "tracking_type",
            editable: true,
            width:250,
            valueGetter: function (params) {
                if (params.data.tracking_type !== "" && params.data.tracking_type !== "") {
                    return params.data.tracking_type
                }else{
                    return ""
                }
            },
            valueSetter: (params)=>{
                const newValue = params.newValue;
                if (!newValue || newValue.trim() === "") {
                    params.data.tracking_type = "";
                    return ""; // Prevent update
                }
                params.data.tracking_type = newValue;
                return true


            },
            cellStyle: function (params) {
                // If the customer_name is empty, apply red background color
                if (params.value === "") {
                    return {
                        backgroundColor: "#c85f62"  // Light red background for empty customer_name
                    };
                }
                return null;  // No special styling if the customer_name is not empty
            },

                headerClass: 'bold-header'
        },
        {
            headerName: "E-Way Bill No",
            field: "eway_bill_no",
            editable: true
        },
        //         {
        //     headerName: "Mode",
        //     field: "mode",
        //     width: 190,
        //     cellRenderer: '',
        //     resizable: true,
        //     editable:true,
        //     valueGetter:(params)=>{
        //         const modeValue = (params.data.mode).toLowerCase();
        //         const validModeType=["air", "road", "rail", "sea"]
        //         if(validModeType.includes(modeValue)){
        //             return params.data.mode
        //         }else{
        //             return ""
        //         }
        //     },
        //     valueSetter: (params)=>{
        //         const newValue = params.newValue;
        //         const validModeType=["air", "road","rail", "sea"]
                
        //         const newValueLowerCase = newValue?.toLowerCase();
        //         const isValid = validModeType.includes(newValueLowerCase);
        //         if(isValid){
        //            params.data.mode= newValue;
        //             return true;
        //         }else{
        //             // params.api.flashCells({ rowNodes: [params.node], columns: ['movement_type'] }); // Flash the invalid cell
        //             // alert("Invalid Movement Type! Please enter 'Internal Movement' or 'Customer Movement'."); // Optional alert
        //             params.data.mode=""
        //             return false;
        //         }
        //     },
        //     cellStyle: (params) => {
              
        //         // If the value is not valid, apply red background
        //         if (params.value ==="") {
        //             return {
        //                 backgroundColor: "#c85f62"  // Light red background for invalid movement_type
        //             };
        //         }
        //         return null; // Default cell style for valid values
        //     },
        //         headerClass: 'bold-header'
        // },
         {
             headerName: "Mode",
             field: "mode",
             width: 190,
             editable: false,
             resizable: true,

             valueGetter: (params) => {
                 const fuelToModeMap = {
                     diesel: "Road",
                     ev: "Road",
                     cng: "Road",
                     air: "Air",
                     rail: "Rail",
                     sea: "Sea"
                 };

                 const fuel = params.data.fuel_type?.toLowerCase()?.trim();

                 const matchedKey = Object.keys(fuelToModeMap).find(key =>
                     fuel?.includes(key)
                 );

                 if (matchedKey) {
                     const mode = fuelToModeMap[matchedKey];
                     params.data.mode = mode;
                     return mode;
                 }

                 return "";
             },

             cellStyle: (params) => {
                 if (!params.value) {
                     return { backgroundColor: "#c85f62" };
                 }
                 return null;
             },

             headerClass: "bold-header"
         },

        {
            headerName: "Number Of Boxes",
            field: "no_of_boxes",
            width: 200,
            resizable: true,
            headerClass: 'bold-header',
            editable: true,
        
            // ValueGetter to ensure valid numeric values
            valueGetter: (params) => {
                const value = params.data.no_of_boxes;
        
                // Return the value if it's a valid number; otherwise, return an empty string
                if (!isNaN(value) && value !== "" && value !== null) {
                    return value;
                }
                return ""; // For invalid values
            },
        
            // ValueSetter for numeric validation
            valueSetter: (params) => {
                const newValue = params.newValue;
        
                // Validate if the value is numeric and not empty
                if (!isNaN(newValue) && newValue !== "" && newValue !== null) {
                    params.data.no_of_boxes = parseFloat(newValue); // Set the value
                    return true; // Indicate successful update
                } else {
                    console.warn("Invalid input: Only numeric values are allowed.");
                    params.data.no_of_boxes = ""; // Reset to empty for invalid input
                    return false; // Indicate unsuccessful update
                }
            },
        
            // CellStyle for validation
            cellStyle: (params) => {
                // Define the transporter array
                const tptArray = ["Univelox", "Abhilash Logistics", "Sri Ranga Transport", "Patil Transport"];
        
                // Check if the transporter name is in the array
                const isMandatory = tptArray.includes(params.data.transporter_name);
        
                // Apply red background if:
                // 1. Value is empty when mandatory
                // 2. Value is not numeric
                if (
                    (isMandatory && (!params.value || isNaN(params.value))) || // Mandatory and invalid
                    (!isMandatory && isNaN(params.value)) // Non-mandatory but invalid
                ) {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid input
                    };
                }
        
                return null; // Default style for valid inputs
            },
        },
        
        {
            headerName: "Driver Mobile No",
            field: "driver_mobile_no",
            editable: true,
        
            // ValueGetter
            valueGetter: (params) => {
                const value = params.data.driver_mobile_no;
        
                // Return the value if it's a valid 10-digit number or empty
                if (!value || (/^\d{10}$/.test(value))) {
                    return value;
                }
                return ""; // Return empty for invalid input
            },
        
            // CellStyle for validation
            cellStyle: (params) => {
                var tptName = (params.data.transporter_name).toLowerCase()
                const isMandatory = SIMTrackingTpts?.includes(tptName);
                const value = params.value;
        
                // Apply red background if:
                // 1. The transporter name is in SIMTrackingTpts, and the field is empty
                // 2. The entered value is not a valid 10-digit mobile number
                if (
                    (isMandatory && (!value || value.trim() === "")) || // Mandatory and empty
                    (value && !/^\d{10}$/.test(value)) // Non-empty but not 10 digits
                ) {
                    return {
                        backgroundColor: "#c85f62", // Light red background for invalid input
                    };
                }
        
                return null; // Default style for valid inputs
            },
        
            // ValueSetter
            valueSetter: (params) => {
                const newValue = params.newValue;
        
                // Validate if the value is a valid 10-digit number
                if (/^\d{10}$/.test(newValue)) {
                    params.data.driver_mobile_no = newValue; // Set the value
                    return true; // Indicate successful update
                } else {
                    console.warn("Invalid input: Mobile number must be a 10-digit number.");
                    params.data.driver_mobile_no = ""; // Reset to empty for invalid input
                    return false; // Indicate unsuccessful update
                }
            },
        
            headerClass: 'bold-header',
        },
    ]
   
    const parseDate = (dateString) => {
        //console.log("Parsing Date String:", dateString);
    
        const [day, month, yearTime] = dateString?.split("-");
        const [year, time] = yearTime.split(" ");
        const [hours, minutes] = time.split(":");
    
        const parsedDate = new Date(year, month - 1, day, hours, minutes);
        //console.log("Parsed Date Object:", parsedDate);
        return parsedDate;
    };
    const parseDate1 = (dateString) => {
        const [day, month, year, hours, minutes] = dateString
            .match(/\d+/g)
            .map((val) => parseInt(val));
        return new Date(year, month - 1, day, hours, minutes); // Month is 0-indexed
    };

    const parseDate2 = (dateString) => {
        if (!dateString) return new Date("");

        // Convert slashes to dashes
        const cleaned = dateString.replace(/\//g, "-");

        const [day, month, yearTime] = cleaned.split("-");
        const [year, time] = yearTime.split(" ");
        const [hours, minutes] = time.split(":");

        return new Date(year, month - 1, day, hours, minutes);
    };


    const getHyphenDDMMYYYYHHMM1 = (date) => {
        if (!date) return "";
    
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
    
        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
        //console.log("Formatted Date:", formattedDate);
        return formattedDate;
    };
    
    
    const isValidDateRange = (eventDate, currentDate) => {
        const fortyEightHoursAgo = new Date(currentDate.getTime() - 48 * 60 * 60 * 1000); // 48 hours ago
        const eightHoursAhead = new Date(currentDate.getTime() + 8 * 60 * 60 * 1000); // 8 hours ahead
        //console.log(eventDate >= fortyEightHoursAgo && eventDate <= eightHoursAhead, "vvvvvvvv");
        
        return eventDate >= fortyEightHoursAgo && eventDate <= eightHoursAhead;
    };
    const isAdminValidDateRange = (eventDate, currentDate) => {
        const eightHoursAhead = new Date(currentDate.getTime() + 8 * 60 * 60 * 1000); // 8 hours ahead
        //console.log(eventDate >= fortyEightHoursAgo && eventDate <= eightHoursAhead, "vvvvvvvv");
        
        return eventDate <= eightHoursAhead;
    };
    const validateAllRows = (api) => {
        const allRows = [];
        api.forEachNode((node) => allRows.push(node.data));
    
        let hasError = false;
    
        for (const row of allRows) {
            const date = row.current_event_date_time;
    
            //console.log("Row Data:", row);
            //console.log("Raw Date:", date);
    
            if (!date) {
                hasError = true;
                console.error("Empty date detected");
                break;
            }
    
            const dateTimePattern = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/;
            if (!dateTimePattern.test(date)) {
                hasError = true;
                console.error("Invalid format detected:", date);
                break;
            }
    
            const eventDate = parseDate(date);
            const currentDate = new Date();
            if (!eventDate || !isValidDateRange(eventDate, currentDate)) {
                hasError = true;
                console.error("Out-of-range date detected:", eventDate);
                break;
            }
        }
    
        //console.log("Validation Complete. Error:", hasError);
    
        setBulkUpdateEventError(hasError); // Update global error state
    };

    const validateBulkDeliveryRows = (gridApi) => {
        const errors = [];
        const now = new Date();

        gridApi.forEachNode((node) => {
            const data = node.data;
            const lrNo = data.lr_no || "(missing)";

            const requiredFields = [
                'lr_no', 'transporter_name', 'dispatch_date',
                'delivery_datetime', 'tracking_type',
                // 'actual_delivery_date', 
                // 'late_delivery_remarks',
                //  'sla_considered'
            ];

            for (const field of requiredFields) {
                if (data[field] === undefined || data[field] === null || data[field].toString().trim() === '') {
                    errors.push(`Missing value for '${field}' for LR No '${lrNo}'`);
                }
            }

            // const dateFields = ['dispatch_date', 'delivery_datetime', 'actual_delivery_date'];
            // const parsedDates = {};

            // for (const field of dateFields) {
            //     const value = data[field];
            //     const parsed = moment(value, 'YYYY-MM-DD HH:mm', true);

            //     if (!parsed.isValid()) {
            //         errors.push(`Invalid date in '${field}' for LR No '${lrNo}'`);
            //     } else {
            //         if (parsed.toDate() > now) {
            //             errors.push(`Future date not allowed in '${field}' for LR No '${lrNo}'`);
            //         }
            //         // ✅ Store parsed date for later comparison
            //         parsedDates[field] = parsed;
            //     }
            // }
            const dateFields = ['dispatch_date', 'delivery_datetime','actual_dispatch_date'];//'actual_delivery_date'
            const parsedDates = {};

            for (const field of dateFields) {
                const parsed = parseGridDate(data[field]);

                if (!parsed) {
                    errors.push(`Invalid date in '${field}' for LR No '${lrNo}'`);
                } else {
                    if (parsed.toDate() > now) {
                        errors.push(`Future date not allowed in '${field}' for LR No '${lrNo}'`);
                    }
                    parsedDates[field] = parsed;
                    if (field === "actual_dispatch_date" && parsed) {
                        data.actual_dispatch_date =
                            parsed.format("YYYY-MM-DD HH:mm");
                    }
                }
            }

            // Check if actual_delivery_date >= dispatch_date
            if (parsedDates['actual_delivery_date'] && parsedDates['dispatch_date']) {
                if (parsedDates['actual_delivery_date'].isBefore(parsedDates['dispatch_date'])) {
                    errors.push(`'Actual Delivery Date' must be after or same as 'Dispatch Date' for LR No '${lrNo}'`);
                }
            }

            // Check sla_considered value (should be Yes or No, case-insensitive)
            // const slaValue = (data['sla_considered'] || '').toString().trim().toLowerCase();
            // if (slaValue !== 'yes' && slaValue !== 'no') {
            //     errors.push(`'SLA considered' should be 'Yes' or 'No' for LR No '${lrNo}'`);
            // }
            const slaRaw = data['sla_considered'];
            if (slaRaw !== undefined && slaRaw !== null && slaRaw.toString().trim() !== '') {
                const slaValue = slaRaw.toString().trim().toLowerCase();
                if (slaValue !== 'yes' && slaValue !== 'no') {
                    errors.push(`'SLA considered' should be 'Yes' or 'No' for LR No '${lrNo}'`);
                }
            }
            // const remarkRaw = data['late_delivery_remarks'];

            // if (!remarkRaw || remarkRaw.toString().trim() === '') {
            //     errors.push(`Missing 'Late Delivery Remarks' for LR No '${lrNo}'`);
            // } else {
            //     if (!LATE_DELIVERY_REMARK_OPTIONS.includes(remarkRaw)) {
            //         errors.push(
            //             `Invalid Late Delivery Remark for LR No '${lrNo}'. Allowed values: ${LATE_DELIVERY_REMARK_OPTIONS.join(', ')}`
            //         );
            //     }
            // }
            const remarkRaw = data['late_delivery_remarks'];

            // if (
            //     remarkRaw &&
            //     !LATE_DELIVERY_REMARK_OPTIONS.includes(remarkRaw)
            // ) {
            //     errors.push(
            //         `Invalid Late Delivery Remark for LR No '${lrNo}'. Allowed values: ${LATE_DELIVERY_REMARK_OPTIONS.join(', ')}`
            //     );
            // }
            if (
                remarkRaw &&
                !LATE_DELIVERY_REMARK_LOOKUP[remarkRaw.toString().trim().toLowerCase()]
            ) {
                errors.push(
                    `Invalid Late Delivery Remark for LR No '${lrNo}'. Allowed values: ${lateDeliveryRemarkOptions.join(", ")}`
                );
            }
            if (data.actual_delivery_date) {
                if (!validateActualDeliveryDate(data)) {
                    errors.push(
                        `In LR No '${lrNo}', Actual Delivery Date cannot be before Dispatch / Actual Dispatch Date`
                    );
                    data.isInvalidPerformance = true;
                    data._errorReason =
                        "Actual Delivery Date cannot be before Dispatch / Actual Dispatch Date";
                }
            }

        });

        return errors;
    };
    const columnBulkInvoiceWeightDef = [
        {
            headerName: "Invoice No",
            field: "invoice_no",
            editable: true,

            tooltipValueGetter: (params) =>
                params.data?._hasError ? params.data._errorReason : "",

            valueSetter: (params) => {
                const rawValue = params.newValue;
                if (!rawValue) return false;

                params.data.invoice_no = rawValue;
                const { validatedRows } = validateBulkInvoiceData(
                    modalBulkUpdateData.map((row) =>
                        row === params.data
                            ? { ...row, invoice_no: rawValue }
                            : row
                    )
                );

                setModalBulkUpdateData(validatedRows);
                return true;
            }
        },

        {
            headerName: "Total Weight",
            field: "total_weight",
            editable: true,
            valueSetter: (params) => {
                const val = params.newValue;

                if (val === null || val === undefined || val === "") {
                    return false;
                }

                const num = Number(val);

                if (isNaN(num) || num < 0) {
                    return false;
                }

                const updatedRow = {
                    ...params.data,
                    total_weight: num
                };

                const { validatedRows } = validateBulkInvoiceData(
                    modalBulkUpdateData.map(row =>
                        row === params.data ? updatedRow : row
                    )
                );

                setModalBulkUpdateData(validatedRows);
                return true;
            }
        },

        {
            headerName: "Total CBM",
            field: "total_cbm",
            editable: true,
            valueSetter: (params) => {
                const val = params.newValue;

                if (val === null || val === undefined || val === "") {
                    const updatedRow = {
                        ...params.data,
                        total_cbm: ""
                    };
                    const { validatedRows } = validateBulkInvoiceData(
                        modalBulkUpdateData.map(row =>
                            row === params.data ? updatedRow : row
                        )
                    );
                    setModalBulkUpdateData(validatedRows);
                    return true;
                }

                const num = Number(val);

                if (isNaN(num) || num < 0) {
                    return false;
                }
                const updatedRow = {
                    ...params.data,
                    total_cbm: num
                };
                const { validatedRows } = validateBulkInvoiceData(
                    modalBulkUpdateData.map(row =>
                        row === params.data ? updatedRow : row
                    )
                );

                setModalBulkUpdateData(validatedRows);
                return true;
            }
        },


        {
            headerName: "Tracking Type",
            field: "tracking_type",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["FTL", "PTL"]
            },
            valueSetter: (params) => {
                const val = params.newValue;

                if (!val) return false;

                const normalized = val.toString().trim().toUpperCase();

                if (normalized !== "FTL" && normalized !== "PTL") {
                    return false;
                }
                if (params.data.tracking_type === normalized) {
                    return false;
                }
                const updatedRow = {
                    ...params.data,
                    tracking_type: normalized
                };
                const { validatedRows } = validateBulkInvoiceData(
                    modalBulkUpdateData.map(row =>
                        row === params.data ? updatedRow : row
                    )
                );
                setModalBulkUpdateData(validatedRows);
                return true;
            }
        }

    ];


    const columnBulkUpdateDef = [

        {
            headerName: "LR No",
            field: "lr_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        
            // Validate and retrieve LR No
            valueGetter: (params) => {
                const lrNo = params.data.lr_no;
                // const invoiceNo = params.data.invoice_no;
            
        
                // Return the LR No if valid
                // setBulkLRError(false)
                return lrNo || ""; // Default to an empty string if no LR No is provided
            },
        
            // Optional: Style the cell based on the validation result
            // cellStyle: (params) => {
            //     const lrNo = params.data.lr_no;
            //     // const invoiceNo = params.data.invoice_no;
            //     const allData = activeTrips.all;
        
            //     // Check if the combination is valid
            //     const isDuplicate = allData.some(
            //         (item) => item.lr_no === lrNo && item.invoice_no !== invoiceNo
            //     );
        
            //     if (isDuplicate) {
            //         return { backgroundColor: "#c85f62"}; // Red background for invalid combination
            //     }
            //     return null; // Default style for valid data
            // },
        },
        
       
        {
            headerName: "Dispatch Date",
            field: "dispatch_date",
            // editable: true,
            valueGetter: (params) => {
              const date = params.data.dispatch_date;
              // Check if date is empty or in DD-MM-YYYY format
              const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;
              if (!date || datePattern.test(date)) {
                setBulkUpdateDispatchError(false); // Set error state for empty value

                return date || ""; // Return empty string if the date is empty
              } else if(date ===""){
                setBulkUpdateDispatchError(false); // Set error state for empty value

                return date || ""; 
              }
                else if(date && !(datePattern.test(date))){
                    setBulkUpdateDispatchError(true); // Set error state for empty value
                return "Invalid Date Format";
              }
            },
           
            cellStyle: (params) => {
              const date = params.value;
              const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;

          
              // Apply red background only if the value is invalid and not empty
              if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
                return { backgroundColor: "#c85f62" };
              }
              return null; // No style if valid or empty
            },
          },
    
        {
            headerName: "Consignee Name",
            field: "customer_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            // editable:true,
            // valueGetter: function (params) {
            //     if (params.data.customer_name != "" && params.data.customer_name != "") {
            //         setBulkConsigneeError(false)
            //         return params.data.customer_name
            //     }else{
            //         setBulkConsigneeError(true)

            //         return ""
            //     }
            // },
            // cellStyle: function (params) {
            //     // If the customer_name is empty, apply red background color
            //     if (params.value === "") {
            //         return {
            //             backgroundColor: "#c85f62"  // Light red background for empty customer_name
            //         };
            //     }
            //     return null;  // No special styling if the customer_name is not empty
            // },

                headerClass: 'bold-header'
        },
        {
            headerName: "Destination City" ,
            field: "destination_city",
            width: 150,
            // editable:true,

            cellRenderer: '', resizable: true,
                headerClass: 'bold-header',
                // valueGetter: (params) => {
                //     const destinationCity = params.data.destination_city;
                   
                
                //     if (destinationCity !=="") {
                //         setBulkDestinationError(false)

                //       return destinationCity;
                //     } else {
                //         setBulkDestinationError(true)

                //       return "";
                //     }
                //   },
                //   cellStyle: (params) => {
                //     const destinationCity = params.value;
                //     // Apply red background if the date format is invalid
                //     if (destinationCity === "") {
                //       return { "backgroundColor": "#c85f62" };
                //     }
                //     return null;
                //   },
        },
        {
            headerName: "Expected ETA", // Estimated delivery date
            field: "expected_trip_end",
            width: 150,
            resizable: true,
            comparator: dateComparator,
            valueGetter: (params) => {
                const date = params.data.expected_trip_end;
                // Check if date is empty or in DD-MM-YYYY format
                const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;
                if (!date || datePattern.test(date)) {
                  setBulkUpdateExpectedError(false); // Set error state for empty value
  
                  return date || ""; // Return empty string if the date is empty
                } else if(date ===""){
                  setBulkUpdateExpectedError(false); // Set error state for empty value
  
                  return date || ""; 
                }
                  else if(date && !(datePattern.test(date))){
                  setBulkUpdateExpectedError(true); // Set error state for empty value
                  return "Invalid Date Format";
                }
              },
              // valueSetter: (params) => {
              //   const newValue = params.newValue;
              //   const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            
              //   // Accept empty value or a valid DD-MM-YYYY formatted date
              //   if (!newValue || datePattern.test(newValue)) {
              //     params.data.dispatch_date = newValue || ""; // Allow empty values
              //     return true;
              //   } else {
              //     return false; // Reject invalid formats
              //   }
              // },
              cellStyle: (params) => {
                const date = params.value;
                const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;

            
                // Apply red background only if the value is invalid and not empty
                if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
                  return { backgroundColor: "#c85f62" };
                }
                return null; // No style if valid or empty
              },
            headerClass: 'bold-header'

        },
        {
            headerName: "Status",
            field: "status",
            // editable: true,
            // cellStyle: params => {
            //     if (params.data.status == undefined || params.data.status == "" ) {

            //         return {
            //             "backgroundColor": '#c85f62'
            //         };
            //         // return ""

            //     }
            // }
        },
        {
            headerName: "Event Location",
            field: "last_location",
            // editable: true,
            // cellStyle: params => {
            //     if (params.data.last_location == undefined || params.data.last_location == "" ) {

            //         return {
            //             "backgroundColor": '#c85f62'
            //         };
            //         // return ""
            //     }
            // }
        },
        {
            headerName: "Event Date & Time", // Estimated delivery date
            field: "last_event_time",
            width: 200,
            resizable: true,
            comparator: dateComparator,
            // valueGetter: (params) => {
            //     const date = params.data.event_date_time;
            //     // Check if date is empty or in DD-MM-YYYY format
            //     const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            //     if (!date || datePattern.test(date)) {
            //       setBulkUpdateLastEventTimeError(false); // Set error state for empty value
  
            //       return date || ""; // Return empty string if the date is empty
            //     } else if(date ===""){
            //         setBulkUpdateLastEventTimeError(false); // Set error state for empty value
  
            //       return date || ""; 
            //     }
            //       else if(date && !(datePattern.test(date))){
            //         setBulkUpdateLastEventTimeError(true); // Set error state for empty value
            //       return "Invalid Date Format";
            //     }
            //   },
              // valueSetter: (params) => {
              //   const newValue = params.newValue;
              //   const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            
              //   // Accept empty value or a valid DD-MM-YYYY formatted date
              //   if (!newValue || datePattern.test(newValue)) {
              //     params.data.dispatch_date = newValue || ""; // Allow empty values
              //     return true;
              //   } else {
              //     return false; // Reject invalid formats
              //   }
              // },
            //   cellStyle: (params) => {
            //     const date = params.value;
            //     const datePattern = /^\d{2}-\d{2}-\d{4}$/;
            
            //     // Apply red background only if the value is invalid and not empty
            //     if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
            //       return { backgroundColor: "#c85f62" };
            //     }
            //     return null; // No style if valid or empty
            //   },
            valueGetter: (params) => {
                const date = params.data.last_event_time;
                // Check if date is empty or in DD-MM-YYYY format
                const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;
                if (!date || datePattern.test(date)) {
  
                  return date || ""; // Return empty string if the date is empty
                } else if(date ===""){
  
                  return date || ""; 
                }
                  else if(date && !(datePattern.test(date))){
                  return "Invalid Date Format";
                }
              },
              cellStyle: (params) => {
                const date = params.value;
                const datePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;
            
                // Apply red background only if the value is invalid and not empty
                if (date!="" && date == "Invalid Date Format" && !datePattern.test(date)) {
                  return { backgroundColor: "#c85f62" };
                }
                return null; // No style if valid or empty
              },
            headerClass: 'bold-header'

        },
        {
    headerName: "Current Status",
    field: "current_status",
    editable: true,
    valueGetter: (params) => {
        const currentStatus = params.data.current_status;

        // Check for validity
        if (isValidProgression(params.data.status, currentStatus)) {
            setBulkUpdateStatusError(false);
            return currentStatus; // Valid value
        } else if (!currentStatus) {
            // Empty or null value
            setBulkUpdateStatusError(true);
            return ""; // Show empty value
        } else {
            // Invalid value
            setBulkUpdateStatusError(true);
            return ""; // Show empty value for invalid status
        }
        return params.data.current_status
    },
    valueSetter: (params) => {
        const newValue = params.newValue;

        // Validate the new value
        if (isValidProgression(params.data.status, newValue)) {
            params.data.current_status = newValue; // Update the value
            return ""; // Indicate successful update
        } else {
            params.data.current_status = ""; // Reset to empty if invalid
            return ""; // Indicate failed update
        }

        params.data.current_status = newValue;
        return ""
    },
    cellStyle: (params) => {
        const currentStatus = params.data.current_status;

        // Highlight invalid or empty values
        if (!currentStatus || !isValidProgression(params.data.status, currentStatus)) {
            setBulkUpdateStatusError(true);

            return { backgroundColor: "#c85f62"}; // Red background for invalid
        }else{
            setBulkUpdateStatusError(false);
        }
        return null; // Default style for valid values
    },
}
,
{
    headerName: "Current Location",
    field: "current_location",
    editable: true,
    valueGetter: (params) => {
        if (params.data.current_location === "") {
            setBulkUpdateCurrentLocationErr(true);
            return "";
        }
        return params.data.current_location;
    },
    valueSetter: (params) => {
        const newValue = params.newValue.trim(); // Trim the new value
        if (newValue === "") {
            console.error("Current Location cannot be empty.");
            params.data.current_location = ""; // Reset to an empty string
            return false; // Indicate failed update
        }

        params.data.current_location = newValue; // Update the value if valid
        return true; // Indicate successful update
    },
    cellStyle: (params) => {
        const current_status = params.data.current_status;
        const isEmptyLocation = !params.data.current_location; // Check if empty
        
        // Apply red background only if status is NOT "Undelivered" or "Delivered"
        if (isEmptyLocation && current_status !=="Undelivered" && current_status !== "Delivered") {
            setBulkUpdateCurrentLocationErr(true);
            return {
                backgroundColor: '#c85f62', // Red background for invalid or empty cells
            };
        } else {
            setBulkUpdateCurrentLocationErr(false);
        }
        return null; // Default styling for valid cells
    },
}

,
{
    headerName: "Current Event Date & Time",
    field: "current_event_date_time",
    colId:"current_event_date_time",
    width: 200,
    resizable: true,
    editable: true,
    comparator: dateComparator, // Custom date comparator for sorting
    cellEditor: DateEditor,

    // Retrieve and validate the date and time value
    valueGetter: (params) => {
        const date = params.data.current_event_date_time;
    
        // Call validateAllRows to ensure all rows are checked
        // validateAllRows(params.api);
    
        // Regex pattern for DD-MM-YYYY HH:mm format
        const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;        
    
        if (date && dateTimePattern.test(date)) {
            const currentDate = new Date();
            const eventDate = parseDate(date);
    
            //console.log("ValueGetter - Event Date:", eventDate, "Current Date:", currentDate);
    
            // Check if the date is within the valid range
            if (isValidDateRange(eventDate, currentDate) && decodedRoleCase!=="admin") {
                //console.log("ValueGetter - Valid Date:", date);
                return (date); // Return formatted date
            } else if(isAdminValidDateRange(eventDate, currentDate) && decodedRoleCase==="admin"){
                return (date)
            }else{
                console.error("ValueGetter - Out-of-Range Date:", eventDate);
                return "";
            }
        } else if (date) {
            console.error("ValueGetter - Invalid Date Format:", date);
        }
    
        // Default case: return an empty string for invalid or missing dates
        return "";
    },
    

    // Validate and update the date and time value
    valueSetter: (params) => {
        const newValue = getHyphenDDMMYYYYHHMM1(params.newValue?.trim());

        // //console.log("ValueSetter - New Value:", newValue);

        const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;

        if (newValue && dateTimePattern.test(newValue)) {
            const currentDate = new Date();
            const eventDate = parseDate(newValue);

            //console.log("ValueSetter - Parsed Value:", newValue, "Current Date:", currentDate, "Event Date:", eventDate);

            if (isValidDateRange(eventDate, currentDate) && decodedRoleCase!=="admin") {
                //console.log("ValueSetter - Date is valid. Setting event_date_time.");
                params.data.current_event_date_time = newValue;
                validateAllRows(params.api);
                return true;
            } else if (isAdminValidDateRange(eventDate, currentDate) && decodedRoleCase==="admin") {
                //console.log("ValueSetter - Date is valid. Setting event_date_time.");
                params.data.current_event_date_time = newValue;
                validateAllRows(params.api);
                return true;
            }else {
                console.error("ValueSetter - Date is out of range. Clearing event_date_time.");
                params.data.current_event_date_time = "";
                validateAllRows(params.api);
                return false;
            }
        } else {
            console.error("ValueSetter - Invalid date or format.");
            params.data.current_event_date_time = "";
            validateAllRows(params.api);
            return false;
        }
    },

    // Apply conditional styling based on validity
    cellStyle: (params) => {
        const date = params.data?.current_event_date_time?.trim(); // Ensure we check for empty or whitespace
        const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4}\s\d{2}:\d{2}$/;
    
        // 🔴 Apply red background if the cell is empty or does not match the date pattern
        if (!date || !dateTimePattern.test(date)) {
            return { backgroundColor: "#c85f62", color: "#ffffff" }; // Red background with white text for visibility
        }
    
        const currentDate = new Date();
        const eventDate = parseDate(date);
    
        // 🔴 Apply red background if the date is out of range
        if (!isValidDateRange(eventDate, currentDate) && decodedRoleCase!== "admin") {
            return { backgroundColor: "#c85f62", color: "#ffffff" }; // Red background for invalid date range
        }else if(!isAdminValidDateRange(eventDate, currentDate) && decodedRoleCase=== "admin"){
            return { backgroundColor: "#c85f62", color: "#ffffff" }; // Red background for invalid date range
        }
    
        return null; // ✅ Default style for valid dates
    },
    

    headerClass: 'bold-header',
}
        ,       
        // {
        //     headerName: "Reason For Delay",
        //     field: "reason_for_delay",
        //     colId: "reason_for_delay",
        //     editable: true,
        //     headerClass: 'bold-header',

        //     valueGetter: (params) => {
        //         const { reason_for_delay: reason, current_event_date_time: eventDateTime, expected_trip_end: expectedETA } = params.data;
        //         const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;

        //         if (eventDateTime && expectedETA && dateTimePattern.test(eventDateTime) && dateTimePattern.test(expectedETA)) {
        //             const eventDate = parseDate2(eventDateTime);
        //             const expectedDate = parseDate2(expectedETA);

        //             if (eventDate > expectedDate && (!reason || reason.trim() === "")) {
        //                 setBulkUpdateReasonErr(true);
        //                 return "";
        //             }
        //         }

        //         setBulkUpdateReasonErr(false);
        //         return reason || "";
        //     },

        //     valueSetter: (params) => {
        //         const newValue = params.newValue?.trim();
        //         const { current_event_date_time: eventDateTime, expected_trip_end: expectedETA, current_status: customStatus } = params.data;
        //         const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;

        //         const shouldCheckReason =
        //             (eventDateTime && expectedETA && dateTimePattern.test(eventDateTime) && dateTimePattern.test(expectedETA) &&
        //                 parseDate2(eventDateTime) > parseDate2(expectedETA)) ||
        //             customStatus === "undelivered";

        //         if (shouldCheckReason) {
        //             if (!newValue) {
        //                 setBulkUpdateReasonErr(true);
        //                 params.data.reason_for_delay = "";
        //                 return false;
        //             }

        //             const validReason = validReasonsData.some(valid => valid.toLowerCase() === newValue.toLowerCase());
        //             if (!validReason) {
        //                 setBulkUpdateReasonErr(true);
        //                 params.data.reason_for_delay = "";
        //                 return false;
        //             }
        //         }

        //         setBulkUpdateReasonErr(false);
        //         params.data.reason_for_delay = newValue;
        //         if (customStatus?.toLowerCase() === "undelivered") {
        //             params.data.remarks = newValue;
        //         }
        //         return true;
        //     },

        //     cellStyle: (params) => {
        //         const { reason_for_delay: reasonRaw, current_event_date_time: eventDateTime, expected_trip_end: expectedETA, current_status: customStatus } = params.data;
        //         const reason = reasonRaw?.trim() || "";
        //         const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;

        //         const isEventAfterETA = (
        //             eventDateTime && expectedETA &&
        //             dateTimePattern.test(eventDateTime) &&
        //             dateTimePattern.test(expectedETA) &&
        //             parseDate(eventDateTime) > parseDate(expectedETA)
        //         );

        //         const isInvalidReason = !validReasonsData.some(valid => valid.toLowerCase() === reason.toLowerCase());

        //         if ((isEventAfterETA || customStatus === "undelivered") && isInvalidReason) {
        //             return { backgroundColor: "#c85f62" }; // Red background for invalid reason
        //         }
        //         return null;
        //     },
        // },
        {
            headerName: "Reason For Delay",
            field: "reason_for_delay",
            colId: "reason_for_delay",
            editable: true,
            headerClass: 'bold-header',
            cellEditor: "agSelectCellEditor",
            cellEditorParams: () => ({
                values: validReasonsData || []
            }),
            singleClickEdit: true,

            valueGetter: (params) => {
                const {
                    reason_for_delay: reason,
                    current_event_date_time: eventDateTime,
                    expected_trip_end: expectedETA
                } = params.data;

                const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;
                const normalized = reason?.trim().toLowerCase();
                const isValidReason = normalized
                    ? validReasonsData.some(
                        r => r.toLowerCase() === normalized
                    )
                    : false;

                if (reason && !isValidReason) {
                    params.data.reason_for_delay = "";
                    setBulkUpdateReasonErr(true);
                    setTimeout(() => {
                        params.api.refreshCells({
                            rowNodes: [params.node],
                            columns: ["reason_for_delay"],
                            force: true
                        });
                    }, 0);

                    return "";
                }
                if (
                    eventDateTime &&
                    expectedETA &&
                    dateTimePattern.test(eventDateTime) &&
                    dateTimePattern.test(expectedETA)
                ) {
                    const eventDate = parseDate2(eventDateTime);
                    const expectedDate = parseDate2(expectedETA);

                    if (eventDate > expectedDate && !normalized) {
                        setBulkUpdateReasonErr(true);
                        return "";
                    }
                }

                setBulkUpdateReasonErr(false);
                return reason || "";
            },

            valueSetter: (params) => {
                const newValue = params.newValue?.trim() || "";
                const {
                    current_event_date_time: eventDateTime,
                    expected_trip_end: expectedETA,
                    current_status: customStatus
                } = params.data;
                const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;

                const isEventAfterETA =
                    eventDateTime &&
                    expectedETA &&
                    dateTimePattern.test(eventDateTime) &&
                    dateTimePattern.test(expectedETA) &&
                    parseDate2(eventDateTime) > parseDate2(expectedETA);
                const isUndelivered =
                    customStatus?.toLowerCase() === "undelivered";
                const isValidReason =
                    newValue &&
                    validReasonsData.some(
                        valid => valid.toLowerCase() === newValue.toLowerCase()
                    );

                if (isAdmin) {
                    if (newValue && !isValidReason) {
                        params.data.reason_for_delay = "";
                        return false;
                    }

                    params.data.reason_for_delay = newValue;
                    return true;
                }
                const mustHaveReason = isEventAfterETA || isUndelivered;
                if (mustHaveReason) {
                    if (!newValue || !isValidReason) {
                        params.data.reason_for_delay = "";
                        return false;
                    }
                }

                params.data.reason_for_delay = newValue;
                return true;
            },

            cellStyle: (params) => {
                const {
                    reason_for_delay: reasonRaw,
                    current_event_date_time: eventDateTime,
                    expected_trip_end: expectedETA,
                    current_status: customStatus
                } = params.data;
                const reason = reasonRaw?.trim() || "";
                const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;

                const isEventAfterETA =
                    eventDateTime &&
                    expectedETA &&
                    dateTimePattern.test(eventDateTime) &&
                    dateTimePattern.test(expectedETA) &&
                    parseDate(eventDateTime) > parseDate(expectedETA);

                const isUndelivered =
                    customStatus?.toLowerCase() === "undelivered";

                const isValidReason =
                    reason &&
                    validReasonsData.some(
                        valid => valid.toLowerCase() === reason.toLowerCase()
                    );

                if (isAdmin) {
                    if (reason && !isValidReason) {
                        return {
                            backgroundColor: "#c85f62",
                            color: "#fff",
                            fontWeight: "bold"
                        };
                    }
                    return null; // empty allowed
                }

                const mustHaveReason = isEventAfterETA || isUndelivered;
                if (mustHaveReason && (!reason || !isValidReason)) {
                    return {
                        backgroundColor: "#c85f62",
                        color: "#fff",
                        fontWeight: "bold"
                    };
                }

                return null;
            },
        },

    ]
    const isAdmin = decodedRoleCase === "admin";
    const isTransporter = decodedRoleCase === "transporter";

    /**
     * Transporter can edit Late Delivery Remarks only ONCE per LR
     * Admin can edit anytime
     */
    const canEditLateDeliveryRemark = (params) => {
        if (isAdmin) return true;

        if (isTransporter) {
            return !params.data?.late_delivery_edited_by_transporter;
        }

        return false;
    };
    const normalizeDateToYYYYMMDDHHmm = (raw) => {
        if (!raw) return "";

        let dateObj = null;

        if (raw instanceof Date && !isNaN(raw)) {
            dateObj = raw;
        }

        else if (typeof raw === "number") {
            const excelEpoch = new Date(Date.UTC(1899, 11, 30));

            const days = Math.floor(raw);
            const timeFraction = raw - days;

            const date = new Date(excelEpoch.getTime() + days * 86400000);
            const timeMs = Math.round(timeFraction * 86400000);

            dateObj = new Date(date.getTime() + timeMs);
        }

        else if (typeof raw === "string") {
            const parsed = moment(
                raw.trim(),
                [
                    "DD/MM/YYYY HH:mm",
                    "DD-MM-YYYY HH:mm",
                    "YYYY/MM/DD HH:mm",
                    "YYYY-MM-DD HH:mm",
                    "DD/MM/YYYY hh:mm A",
                    "DD-MM-YYYY hh:mm A",
                    "YYYY-MM-DDTHH:mm:ss",
                    "YYYY/MM/DDTHH:mm:ss"
                ],
                true
            );

            if (parsed.isValid()) {
                dateObj = parsed.toDate();
            }
        }

        if (!dateObj || isNaN(dateObj)) return "Invalid Date Format";

        const yyyy = dateObj.getFullYear();
        const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
        const dd = String(dateObj.getDate()).padStart(2, "0");
        const hh = String(dateObj.getHours()).padStart(2, "0");
        const mi = String(dateObj.getMinutes()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
    };

    // const LATE_DELIVERY_REMARK_OPTIONS = [
    //     "Local/Public holidays",
    //     "Natural Calamity",
    //     "Transporter Issue",
    //     "Customer Issue"
    // ];
    // const LATE_DELIVERY_REMARK_LOOKUP = LATE_DELIVERY_REMARK_OPTIONS.reduce(
    //     (acc, option) => {
    //         acc[option.trim().toLowerCase()] = option; // canonical
    //         return acc;
    //     },
    //     {}
    // );
    const LATE_DELIVERY_REMARK_LOOKUP = useMemo(() => {
        return lateDeliveryRemarkOptions.reduce((acc, option) => {
            acc[option.trim().toLowerCase()] = option;
            return acc;
        }, {});
    }, [lateDeliveryRemarkOptions]);

    const normalizeLateDeliveryRemarkFromExcel = (excelValue) => {
        if (!excelValue) return "";

        const key = excelValue.toString().trim().toLowerCase();
        return LATE_DELIVERY_REMARK_LOOKUP[key] || "";
    };
    const validateActualDeliveryDate = (row) => {
        const dispatch = parseGridDate(row.dispatch_date);
        const actualDispatch = parseGridDate(row.actual_dispatch_date);
        const actualDelivery = parseGridDate(row.actual_delivery_date);
        if (!actualDelivery) return true;
        let baseDate = dispatch;
        if (actualDispatch && actualDispatch.isAfter(dispatch)) {
            baseDate = actualDispatch;
        }
        if (!baseDate) return true;
        return actualDelivery.isAfter(baseDate);
    };

    const columnBulkDeliveryDateDef = [

        {
            headerName: "LR No",
            field: "lr_no",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                const lrNo = params.data.lr_no;
                return lrNo || "";
            },
            cellStyle: (params) => {
                var value = params.value
                if(params.value == ""){
                    return { backgroundColor: "#c85f62", color: "#ffffff" };
                }
            }
        },
        {
            headerName: "Transporter Name",
            field: "transporter_name",
            width: 180,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                const transporter_name = params.data.transporter_name;
                return transporter_name || "";
            },
            cellStyle: (params) => {
                var value = params.value
                if(params.value == ""){
                    return { backgroundColor: "#c85f62", color: "#ffffff" };
                }
            }
        },
        {
            headerName: "Tracking Type",
            field: "tracking_type",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
            valueGetter: (params) => {
                const tracking_type = params.data.tracking_type;
                return tracking_type || "";
            },
            cellStyle: (params) => {
                var value = params.value
                if(params.value == ""){
                    return { backgroundColor: "#c85f62", color: "#ffffff" };
                }
            }
        },
        {
            headerName: "Dispatch Date",
            field: "dispatch_date",
            // cellEditor: DateEditor,
            // editable: () => isAdmin,
            valueGetter: (params) => {
                return normalizeDateToYYYYMMDDHHmm(params.data.dispatch_date);
            },
            cellStyle: (params) => {
                if (!params.value || params.value === "Invalid Date Format") {
                    return {
                        backgroundColor: "#c85f62",
                        color: "#ffffff",
                        fontWeight: "bold"
                    };
                }
                return null;
            }
        },
        {
            headerName: "Actual Dispatch Date",
            field: "actual_dispatch_date",
            cellEditor: DateEditor,
             hide: !isAdmin,
            // Only Admin can edit
            editable: () => isAdmin,

            // Show only actual_dispatch_date
            valueGetter: (params) => {
                const val = params.data?.actual_dispatch_date;

                if (!val) return "";

                return normalizeDateToYYYYMMDDHHmm(val);
            },

            cellStyle: (params) => {
                if (params.value === "Invalid Date Format") {
                    return {
                        backgroundColor: "#c85f62",
                        color: "#ffffff",
                        fontWeight: "bold"
                    };
                }
                return null;
            },


            // Store only if edited
            valueSetter: (params) => {

                if (!isAdmin) return false;

                const val = params.newValue?.trim();

                if (!val) {
                    delete params.data.actual_dispatch_date;
                    return true;
                }

                const parsed = moment(
                    val,
                    [
                        "YYYY-MM-DD HH:mm",
                        "DD-MM-YYYY HH:mm",
                        "DD/MM/YYYY HH:mm",
                        "YYYY/MM/DD HH:mm",
                        "YYYY-MM-DDTHH:mm:ss"
                    ],
                    true
                );

                if (!parsed.isValid()) {
                    return false;
                }

                // Save only valid value
                params.data.actual_dispatch_date =
                    parsed.format("YYYY-MM-DD HH:mm");

                params.api.applyTransaction({ update: [params.data] });

                return true;
            },

            headerClass: "bold-header"
        },

        {
            headerName: "Delivery Date",
            field: "delivery_datetime",
            valueGetter: (params) => {
                return normalizeDateToYYYYMMDDHHmm(params.data.delivery_datetime);
            },
            cellStyle: (params) => {
                if (!params.value || params.value === "Invalid Date Format") {
                    return {
                        backgroundColor: "#c85f62",
                        color: "#ffffff",
                        fontWeight: "bold"
                    };
                }
                return null;
            }
        },
        // {
        //     headerName: "Actual Delivery Date",
        //     field: "actual_delivery_date",
        //     cellEditor: DateEditor,
        //     editable: true,

        //     valueGetter: (params) => {
        //         const date = params.data.actual_delivery_date;
        //         const datePattern = /^\d{4}[-/]\d{2}[-/]\d{2} \d{2}:\d{2}$/; // Accepts both "-" and "/"

        //         if (!date) return "";
        //         return datePattern.test(date) ? date : "Invalid Date Format";
        //     },

        //     cellStyle: (params) => {
        //         const value = params.value;

        //         if (!value) {
        //             return { backgroundColor: "#c85f62", color: "#ffffff" };
        //         }

        //         if (value === "Invalid Date Format") {
        //             return { backgroundColor: "#c85f62", color: "white", fontWeight: "bold" };
        //         }

        //         return null;
        //     },

        //     valueSetter: (params) => {
        //         const rawInput = params.newValue?.trim();

        //         // Accept only if not empty
        //         if (!rawInput) {
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         // Accept both / and - formats in input
        //         const inputPattern = /^\d{4}[-/]\d{2}[-/]\d{2} \d{2}:\d{2}$/;
        //         if (!inputPattern.test(rawInput)) {
        //             console.error("ValueSetter - Invalid format.");
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         // Normalize to hyphen format
        //         const normalized = rawInput.replace(/\//g, "-");
        //         const eventDate = parseDate(normalized);
        //         const currentDate = new Date();

        //         if (decodedRoleCase !== "admin" && !isValidDateRange(eventDate, currentDate)) {
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         if (decodedRoleCase === "admin" && !isAdminValidDateRange(eventDate, currentDate)) {
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         params.data.actual_delivery_date = normalized;
        //         validateAllRows(params.api);
        //         return true;
        //     },
        // },
        // {
        //     headerName: "Actual Delivery Date",
        //     field: "actual_delivery_date",
        //     cellEditor: DateEditor,
        //     editable: () => isAdmin,

        //     valueGetter: (params) => {
        //         return normalizeDateToYYYYMMDDHHmm(params.data.actual_delivery_date);
        //     },

        //     cellStyle: (params) => {
        //         if (!params.value || params.value === "Invalid Date Format") {
        //             return {
        //                 backgroundColor: "#c85f62",
        //                 color: "#ffffff",
        //                 fontWeight: "bold"
        //             };
        //         }
        //         return null;
        //     },

        //     valueSetter: (params) => {
        //         const rawInput = params.newValue?.trim();
        //         if (!rawInput) {
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         const parsed = moment(rawInput, [
        //             "YYYY-MM-DD HH:mm",
        //             "YYYY/MM/DD HH:mm",
        //             "DD-MM-YYYY HH:mm",
        //             "DD/MM/YYYY HH:mm",
        //             "MM-DD-YYYY HH:mm",
        //             "MM/DD/YYYY HH:mm",
        //             "YYYY-MM-DDTHH:mm:ss",
        //             "YYYY/MM/DDTHH:mm:ss",
        //             "DD-MM-YYYY hh:mm A",
        //             "DD/MM/YYYY hh:mm A"
        //         ], true);

        //         if (!parsed.isValid()) {
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         const eventDate = parsed.toDate();
        //         const currentDate = new Date();

        //         if (decodedRoleCase !== "admin" && !isValidDateRange(eventDate, currentDate)) {
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         if (decodedRoleCase === "admin" && !isAdminValidDateRange(eventDate, currentDate)) {
        //             params.data.actual_delivery_date = "";
        //             validateAllRows(params.api);
        //             return false;
        //         }

        //         params.data.actual_delivery_date = parsed.format("YYYY-MM-DD HH:mm");
        //         validateAllRows(params.api);
        //         return true;
        //     }
        // },
        {
            headerName: "Actual Delivery Date",
            field: "actual_delivery_date",
            cellEditor: DateEditor,

            //  Transporter cannot edit
            editable: () => isAdmin,

            valueGetter: (params) => {
                if (!isAdmin) {
                    const val = params.data?.actual_delivery_date;
                    if (!val) return "";

                    // ISO string → display-friendly (NO format change logic)
                    if (typeof val === "string" && val.includes("T")) {
                        return val.replace("T", " ").replace(".000Z", "");
                    }

                    return val;
                }


                return normalizeDateToYYYYMMDDHHmm(
                    params.data?.actual_delivery_date
                );
            },

            cellStyle: (params) => {
                const row = params.data;
                if (!row?.actual_delivery_date) return null;
                const isValid = validateActualDeliveryDate(row);
                if (!isValid) {
                    return {
                        backgroundColor: "#c85f62",
                        color: "#fff",
                        fontWeight: "bold"
                    };
                }
                return null;
            },


            valueSetter: (params) => {
                if (!isAdmin) return false;

                const rawInput = params.newValue?.trim();
                if (!rawInput) {
                    params.data.actual_delivery_date = "";
                    validateAllRows(params.api);
                    return true;
                }

                const parsed = moment(
                    rawInput,
                    [
                        "YYYY/MM/DD HH:mm",
                        "DD-MM-YYYY HH:mm",
                        "DD/MM/YYYY HH:mm",
                        "MM-DD-YYYY HH:mm",
                        "MM/DD/YYYY HH:mm",
                        "YYYY-MM-DDTHH:mm:ss",
                        "YYYY/MM/DDTHH:mm:ss",
                        "DD-MM-YYYY hh:mm A",
                        "DD/MM/YYYY hh:mm A"
                    ],
                    true
                );

                if (!parsed.isValid()) {
                    params.data.actual_delivery_date = "";
                    validateAllRows(params.api);
                    return false;
                }

                // params.data.actual_delivery_date =
                //     parsed.format("YYYY-MM-DD HH:mm");

                // validateAllRows(params.api);
                // return true;
                params.data.actual_delivery_date =
                    parsed.format("YYYY-MM-DD HH:mm");

                if (!validateActualDeliveryDate(params.data)) {
                    params.data.isInvalidPerformance = true;
                    params.data._errorReason =
                        "Actual Delivery Date cannot be before Dispatch / Actual Dispatch Date";
                } else {
                    params.data.isInvalidPerformance = false;
                    params.data._errorReason = "";
                }
                params.api.refreshCells({ rowNodes: [params.node] });
                return true;
            }
        },
        // {
        //     headerName: "Late Delivery Remarks",
        //     field: "late_delivery_remarks",
        //     width: 200,
        //     resizable: true,
        //     editable: true,
        //     cellEditor: 'agTextCellEditor',
        //     headerClass: 'bold-header',

        //     valueGetter: (params) => {
        //         return params.data.late_delivery_remarks || "";
        //     },

        //     cellStyle: (params) => {
        //         const value = params.value;
        //         if (!value || value.trim() === "") {
        //             return { backgroundColor: "#c85f62" };
        //         }
        //         return null;
        //     },

        //     valueSetter: (params) => {
        //         const newValue = params.newValue?.trim();
        //         if (!newValue) {
        //             params.data.late_delivery_remarks = "";
        //             return false;
        //         }
        //         params.data.late_delivery_remarks = newValue;
        //         return true;
        //     }
        // },
        // {
        //     headerName: "Late Delivery Remarks",
        //     field: "late_delivery_remarks",
        //     width: 220,
        //     resizable: true,
        //     editable: canEditLateDeliveryRemark,
        //     headerClass: "bold-header",

        //     cellEditor: "agSelectCellEditor",
        //     cellEditorParams: {
        //         values: LATE_DELIVERY_REMARK_OPTIONS
        //     },

        //     // Always show canonical value
        //     valueGetter: (params) => params.data?.late_delivery_remarks || "",

        //     // Red only if invalid
        //     cellStyle: (params) => {
        //         if (!canEditLateDeliveryRemark(params)) {
        //             return { backgroundColor: "#e0e0e0", color: "#666" };
        //         }

        //         if (!params.data?.late_delivery_remarks) {
        //             return {
        //                 backgroundColor: "#c85f62",
        //                 color: "#ffffff",
        //                 fontWeight: "bold"
        //             };
        //         }

        //         return null;
        //     }
        // },
        {
            headerName: "Late Delivery Remarks",
            field: "late_delivery_remarks",
            width: 220,
            resizable: true,
            headerClass: "bold-header",

            cellEditor: "agSelectCellEditor",
            cellEditorParams: () => ({
                values: lateDeliveryRemarkOptions
            }),

            valueGetter: (params) =>
                params.data?.late_delivery_remarks || "",

            editable: () => {
                if (isAdmin) return true;
                if (isTransporter) return true;
                return false;
            },
            cellStyle: (params) => {
                if (
                    isTransporter &&
                    !params.data?.late_delivery_remarks
                ) {
                    return {
                        backgroundColor: "#c85f62",
                        color: "#ffffff",
                        fontWeight: "bold"
                    };
                }
                return null;
            },
            valueSetter: (params) => {
                const value = params.newValue?.trim();

                if (isTransporter) {
                    if (!value) {
                        return false;
                    }
                }
                const normalized =
                    value && LATE_DELIVERY_REMARK_LOOKUP[value.toLowerCase()];

                params.data.late_delivery_remarks = normalized || "";

                validateAllRows(params.api);
                return true;
            }
        },


        // {
        //     headerName: "SLA considered",
        //     field: "sla_considered",
        //     width: 150,
        //     resizable: true,
        //     editable: true,
        //     cellEditor: 'agSelectCellEditor',
        //     cellEditorParams: {
        //         values: ['Yes', 'No'],
        //     },
        //     headerClass: 'bold-header',

        //     valueGetter: (params) => {
        //         return params.data.sla_considered || "";
        //     },

        //     cellStyle: (params) => {
        //         const value = params.value;
        //         if (!value || value.trim() === "") {
        //             return { backgroundColor: "#c85f62" };
        //         }
        //         return null;
        //     },

        //     valueSetter: (params) => {
        //         const newValue = params.newValue?.trim();
        //         if (!newValue) {
        //             params.data.sla_considered = "";
        //             return false;
        //         }
        //         params.data.sla_considered = newValue;
        //         return true;
        //     }
        // },
        {
            headerName: "SLA considered",
            field: "sla_considered",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["Yes", "No"]
            }
        }

    ]


    var inactiveColDefs = [];




    const onClickShowRoute = (rownode) => {
        setLoader(true)
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        var s_date;
        if (e.gate_out_time !== "" && e.gate_out_time !== undefined) {
            s_date = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        } else {
            s_date = moment.parseZone(e.shipment_time).format('YYYY-MM-DD HH:mm:ss');
        }

        var gateouttime = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        var edate = '';
        var end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.recent_dealer_reported);
            }
        }
        else if (e.status == 5 || e.status == 8) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            }
            else if (e.left_dealer_marked) {
                end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
            }
            else if(e.actual_delivery_date){
                end_date = e.actual_delivery_date.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.actual_delivery_date);
            }
            else if(e.delivery_datetime){
                end_date = e.delivery_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.delivery_datetime);
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = getHyphenDDMMMYYYYHHMM(e.force_closure_time);
            }
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        if ((e.transit_time) > 0) {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + ((e.transit_time + 1) * 24 * 60 * 60 * 1000));
        }
        else {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
        }

        var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();

        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        /* PMS ID 6747 */
        if(e.expected_trip_end){ 
            setExpectedTripEnd(e.expected_trip_end)
        }
        else{
            setExpectedTripEnd("")
        }
        if(e.distance_in_km){
            setExpectedDistance(e.distance_in_km)
        }
        else{
            setExpectedDistance("")
        }
        if(e.revised_trip_end){
            setRevisedTripsEnd(e.revised_trip_end)
        }
        else{
            setRevisedTripsEnd("")
        }
        if (e.consignment_status || e.status) {
            const consignmentStatus = e?.consignment_status;
            const status = e?.status;
            var consStatus = consignmentStatus || statusMap[status] || status || ""
            setConsignmentStatus(consStatus)
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: s_date,
            seconddate: end_date,
            screen: "consignment",
            consignment_code: e.consignment_code
        }
        // if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;               
                setTimelineData(response.data.tracking_timeline)
                //console.log(records, "mapinfoooo");
                
                
                // this.setState({
                //     loadshow: 'show-m'
                // });
                try {
                    if (records.coords.length == 0) {
                        setShow(true);
                        setTitle("No Tracking data available")
                        setType("danger")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            var edate = '';
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = getHyphenDDMMMYYYYHHMM(end_date);
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = getHyphenDDMMMYYYYHHMM(end_date);
                                }
                            }
                            if (e.deviation_flag == 1) {
                                let consignee_city;
                                consignee_city = e.consignee_city
                                var params = {
                                    "base_route_id": e.base_route_id,
                                    "consigner_code": e.consigner_code,
                                    "consignee_city": consignee_city
                                }
                                redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                                    params).then((resp) => {
                                        var baseRouteCoords = eval(resp.data.route_coords);
                                        setOpenMap({
                                            overly: "show-m",
                                            sliderRouteTranslate: "slider-translate-60p",
                                            mapinfo: records,
                                            dealer: e.consignee_code,
                                            lr_no: "LR No. : " + e.lr_no,
                                            maptruckno: e.truck_no,
                                            routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                            loadshow: 'show-n',
                                            sidebarSubHeader: "Consignment Information",
                                            rownode: e,
                                            leg_no: 0,
                                            tolls: records.tolls,
                                            baseRouteCoords: baseRouteCoords
                                        })
                                    })
                                setLoadShow("show-n")
                            }
                            else {
                                var params =
                                {
                                    consignee_code: e.consignee_code,
                                    dept_code: e.dept_code
                                }
                                redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                    var records1 = response.data.records;
                                    let parkingGeodata = []
                                    if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                    var geofence_coords = []
                                    if (records1.length) {
                                        geofence_coords = records1[0].geofence_coordinates;
                                    }
                                    setOpenMap({
                                        sliderRouteTranslate: "slider-translate-60p",
                                        showDiv: 'show-m',
                                        mapinfo: records,
                                        dealer: e.consignee_code,
                                        lr_no: "LR No. : " + e.lr_no,
                                        maptruckno: e.truck_no,
                                        geofence_coordinates: geofence_coords,
                                        parking_coordinates: parkingGeodata,
                                        routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                        loadshow: 'show-n',
                                        sidebarSubHeader: "Consignment Information",
                                        overly: 'show-m',
                                        rownode: e,
                                        leg_no: 0,
                                        tolls: records.tolls
                                    })
                                    setLoadShow("show-n")
                                })
                            }
                        }
                    }
                }
                catch (e) {

                    setShow(true)
                    setTitle("No Tracking data available")
                    setType("danger")
                    setLoadShow("show-n")
                    setOverlay("show-n")
                }

            })
            .catch(function (error) {
                //console.log(error);
            });
        setLoader(false)
    }
    
const handleEwayDate = (date) => {
    if (!date) return; // Ensure a valid date is passed
    // Save the raw Date object for DatePicker
    
    setFormData(prev => ({ ...prev, eway_bill_expiry_date: date }));
    setManualUpdateConsignment(prev => ({...prev, eway_bill_expiry_date: date}))
};
const handleDispatchDate = (date) => {
    if (!date) return; // Ensure a valid date is passed
    // Save the raw Date object for DatePicker
    
        setFormData((prev) => ({
            ...prev,
            dispatch_time: date,
        }));
        
};
 const handleEditable = (params) => {
        setRowData(prevUsers =>
    prevUsers.map(row =>
      row._id === params.data._id ? { ...row, disabled:false  } : row
    )
  );
    }
const handleInvoiceDate = (date) => {
    if (!date) return; // Ensure a valid date is passed
    // Save the raw Date object for DatePicker
    
        setFormData((prev) => ({
            ...prev,
            invoice_date: date,
        }));
        
};

    const closeCancelModal = (e) => {
        setCloseCancelModal(false)
        setReasonForCancellation('')
        setRownode([])
    }
    const closeforceCloseModal = (e) => {
        setForceCloseModal(false)
        setReasonForCancellation('')
        setRownode([])
    }
    const cancelForceCloseFormCloseHandler = (e) => {
        e.preventDefault();
        let invoices_list = invoiceNoList.map((e)=> e.label)
        let reqData = {
            truck_no: rownode.truck_no,
            invoices_selected: invoices_list,
            reasonForCancellation: reasonForCancellation
        }
        redirectURL.post("/consignments/updateFtlConsignmentCancellation", reqData)
            .then(async (response) => {
                if (response.data.status == 'success') {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("success")
                    closeCancelModal();
                    setRownode([]);
                    setLrOptions([]);
                    setReasonForCancellation("");
                    setshowAddForm3('')
                    // window.location.reload();
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")                    
                    closeCancelModal();
                }
            })
            .catch(function (e) {
                //console.log("Error ", e)
            })
    }
    const cancelFormCloseHandler = (e) => {
        e.preventDefault();
        let invoices_list = lrNoOption.map((e)=> e.label)
        let reqData = {
            truck_no: rownode.truck_no,
            lrNo: rownode.lr_no,
            invoices_selected: invoices_list,
            reasonForCancellation: reasonForCancellation,
            trackingType: cancelConsignmentForTrackinType,
            row_id: rownode._id,
            tabName: tabName.value
        }
        redirectURL.post("/consignments/updateConsignmentCancellation", reqData)
            .then(async (response) => {
                if (response.data.status == 'success') {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("success")
                    closeCancelModal();
                    setRownode([]);
                    setLrOptions([]);
                    setReasonForCancellation("");
                    window.location.reload();
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")                    
                    closeCancelModal();
                }
            })
            .catch(function (e) {
                //console.log("Error ", e)
            })
    }
    // const   onShowCourierTrack = async (params, consignmentStatus) => {
    //         // if (googleAnalytics.page.enableGA) {
    //         // 	let pageTitle = this.state.pageTitle;
    //         // 	// let eventOptions = {
    //         // 	// 	"category": pageTitle,
    //         // 	// 	"action": this.state.eventGridAction,
    //         // 	// 	"label": googleAnalytics.page.action.trackCourier,
    //         // 	// }
    //         // 	// googleAnalytics.logEvent(eventOptions);
    //         // }
    
    //         redirectURL.post('/consignments/trackcourier',{consignment_code :params.data.consignment_code} )
    //         .then(resp => {
    //             if (resp.data.consignments?.length > 0) {
    //                 params.node.setExpanded(!params.node.expanded)
    //                 const columnDefs =  [
                                
    //                     {
    //                         headerName: "Transit Date",
    //                         field: "transitdatetime",
    //                         valueGetter: function(params) {
    //                             let transitDateTime = params.data.transitdatetime;
                        
    //                             if (!transitDateTime) {
    //                                 return '';
    //                             }
                        
    //                             let momentDate;
                        
    //                             // Parse ISO format and check other formats as well
    //                             if (moment(transitDateTime, moment.ISO_8601, true).isValid()) {
    //                                 momentDate = moment(transitDateTime).utc();  // Use UTC here
    //                             }
    //                             else if (moment(transitDateTime, "DD-MM-YYYY HH:mm:ss", true).isValid()) {
    //                                 momentDate = moment(transitDateTime, "DD-MM-YYYY HH:mm:ss").utc();
    //                             } 
    //                             else if (moment(transitDateTime, "DD-MMM-YYYY HH:mm", true).isValid()) {
    //                                 momentDate = moment(transitDateTime, "DD-MMM-YYYY HH:mm").utc();
    //                             } 
    //                             else if (params.data.transitdatetimeseconds) {
    //                                 momentDate = moment.utc(parseInt(params.data.transitdatetimeseconds));  // Use UTC here for epoch time
    //                             }
                        
    //                             // If the moment object is not valid, return the original string
    //                             if (!momentDate) {
    //                                 return transitDateTime;
    //                             }
                        
    //                             // Format as DD-MM-YYYY HH:mm in UTC
    //                             return momentDate.format("DD-MM-YYYY HH:mm");
    //                         },
                        
    //                         filter: true,
    //                         resizable: true
    //                     },
                        
    //                     { 
    //                         headerName: "Location",
    //                         field: "intransit_location", 
    //                         filter:true,
    //                         resizable:true 
    //                     },
    //                     { 
    //                         headerName: "Status",
    //                         field: "intransit_status", 
    //                         filter:true ,
    //                         resizable:true
    //                     },
    //                     {
    //                         headerName: "Force Closure Reason",
    //                         field: "force_closure_reason",
    //                         width: 160,
    //                         hide:consignmentStatus!=="Cancelled",
    //                         filter: "agSetColumnFilter",
    //                         cellRenderer: '', resizable: true
    //                     },
    //                 ];
    //                 columnDefs.forEach(e => {
    //                     e.cellClass = function (params) {
    //                         if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
    //                             return "bgColorDangerDark"; // Apply your custom CSS class here
    //                         } else {
    //                             return null;
    //                         }
    //                     };
    //                 });
    //                 setdetailCellRendererParams({
    //                     detailGridOptions: {
    //                         columnDefs: columnDefs,
    //                         defaultColDef: {
    //                             flex: 3,
    //                         },
    //                     },
    //                     getDetailRowData: (params) => {
    //                         // params.successCallback(resp.data);
    //                         params.successCallback(resp.data.consignments);
    //                     },
    //                 })
    //             }})
    //     }
   
    
        const onClickUploadPOD = async(rownode) => {
        // for FTL POD Upload
            if (rownode.data.tracking_type ==='FTL'){
                var params = {
                    truck_no: rownode.data.truck_no,
                    shipment_id: rownode.data.shipment_id
                }
                await redirectURL.post('consignments/gettruckrecord', params).then
                (resp => {
                    //console.log(resp.data, "lr12")
                    var data= resp.data;
                    let truck_level_invoice = rownode.data.invoice_no;
                    // let invoicesList = data
                    // .filter(e => e.is_submitted_pod !== 1) // Filter out invoices with is_submitted_pod === 1
                    // .map(e => ({ label: e.invoice_no, value: e.invoice_no }));                    
                    // //console.log(invoicesList, "invoicesList123");
                    // setInvoiceUploadList(invoicesList)

                    let LRList = data
                    .filter(e => e.is_submitted_pod !== 1) // Filter out invoices with is_submitted_pod === 1
                    .map(e => e.lr_no) // Get only the lr_no values
                    .filter((value, index, self) => self.indexOf(value) === index); 
                    setInvoiceUploadList(LRList)
                    
                })
            }
            
            setSliderShow("slider-translate-30p")
            setOverlay("show-m")
            setRownode([rownode.data])
    
        }
      
        const onClickShowShipmentLegs = async (params, status) => {
            
            let query = {
                truck_no: params.data.truck_no,
                shipment_id: params.data.shipment_id
            }
            redirectURL.post('/consignments/getShipmentDetails', query)
            .then(resp => {
                if (resp.data.consignments?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    const columnDefs = [
                        // {
                        //     headerName: "",
                        //     field: "legs_map",
                        //     colId: "legs_map",
                        //     width: 40,
                        //     pinned: 'left',
                        //     cellRenderer:function(params){
                        //         var htmloption = '<i className="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
                        //         return htmloption;
                        //     } ,
                        //     filter: false, resizable: true
        
                        // },
                        {
                            headerName: "Invoice No",
                            field: "invoice_no",
                            width: 120,
                            resizable:true
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        {
                            headerName: "Invoice Date",
                            field: "invoice_time",
                            colId: "invoice_time",
                            width: 150,
                            cellRenderer: '', resizable: true,
                            comparator: dateComparator,
                            valueGetter: function (params) {
                                const invoiceDate = params.data.invoice_time;
                                if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                                    // Call date formatting only when the dispatch date is valid
                                    const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                                    // Check if formattedDate is valid, otherwise return "NA"
                                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                                } else {
                                    return "";
                                }
                            },
                            headerClass: 'bold-header'
                        },
                        
                        // {
                        //     headerName: "Consignment",
                        //     field: "consignment_code",
                        //     width: 140,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        // {
                        //     headerName: "Expected ETA",
                        //     field: "expected_eta",
                        //     width: 150,
                        //     valueGetter: function (params) {
                        //         return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
                        //     },
                        //     cellclassName: function (params) {
                        //         if (params.data.transit_delay == 1) {
                        //             return 'lightred';
                        //         }
                        //         else {
                        //             return '';
                        //         }
                        //     },

                        // },
                        {
                            headerName: "Expected ETA", // Estimated delivery date
                            field: "expected_trip_end",
                            colId: "expected_trip_end",
                            width: 150,
                            resizable: true,
                            comparator: dateComparator,
                            valueGetter: function (params) {
                                if (params.data.tracking_type === "FTL") {
                                    // Check if expected_trip_end is not null or undefined
                                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                                } else {
                                    // Use expected_eta for non-FTL tracking types
                                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                                }
                            },
                            headerClass: 'bold-header'
                
                        },
                        {
                            headerName: "Revised Estimated Delivery Date",
                            field: "revised_trip_end",
                            colId: "revised_trip_end",
                            width: 260,
                            resizable:true,
                            hide: params.data &&([8,4].includes(params.data.status)),
                            cellRenderer: '', resizable: true,
                            comparator: dateComparator,
                            valueGetter: function (params) {
                                if (params.data.tracking_type === "FTL") {
                                    // Check if expected_trip_end is not null or undefined
                                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                                } else {
                                    // Use expected_eta for non-FTL tracking types
                                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                                }
                            },
                            headerClass: 'bold-header'
                        },
                        {
                            headerName: "Status",
                            field: "status",
                            width: 140,
                            resizable:true,

                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // },
                            

                            valueGetter: function (params) {
                                if (params.data.status == 0) {
                                    return "At Source"
                                }
                                else if (params.data.status == 1) {
                                    return "Dispatched from Source"
                                }
                                else if (params.data.status == 2) {
                                    return "In Transit"
                                }
                                else if (params.data.status == 3) {
                                    return "Near Destination"
                                }
                                else if (params.data.status == 4) {
                                    return "Out For Delivery"
                                }

                                else if (params.data.status == 5) {
                                    return "Delivered"
                                }
                                else if (params.data.status == 6) {
                                    return "Force Closed"
                                }
                                else if (params.data.status == 8) {
                                    return "Delivered"
                                }else if(params.data.status == 9){
                                    return "Cancelled"
                                }else if(params.data.status == 10){
                                    return "Trip Created"
                                }
                                else if(params.data.status == 11){
                                    return "Undelivered"
                                }
                                else {
                                    return ""
                                }

                            }
                        },
                        // {
                        //     headerName: "Zone",
                        //     field: "zone",
                        //     width: 100,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        // {
                        //     headerName: "Dealer Code",
                        //     field: "consignee_code",
                        //     width: 140,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        {
                            headerName: "Destination City",
                            field: "consignee_city",
                            width: 150,
                            resizable: true,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },

                        {
                            headerName: "Consignee Name",
                            field: "consignee_name",
                            width: 200,
                            resizable: true,
                            valueGetter: function(params){
                                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                                    return capitalizeWords(params.data.consignee_name)
                                }else{
                                    return ""
                                }
                            },
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        {
                            headerName: "Trip Distance (KM)",
                            field: "distance_in_km",
                            width: 100,
                            resizable: true,
                            valueGetter: params =>{
                                if(params.data.distance_in_km>0){
                                    return params.data.distance_in_km
                                }else{
                                    return 0
                                }
                            }
                            ,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        {
                            headerName: "Distance from Dealer (KM)",
                            field: "distance_from_dealer_location",
                            width: 220,
                            resizable:true,
                            valueGetter: function (params) {
                                if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
                                    return params.data.distance_from_dealer_location;
                                }
                                else {
                                    return "";
                                }
                            },
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        // {
                        //     headerName: "Reached Destination At",
                        //     field: "recent_dealer_reported",
                        //     width: 180,
                        //     resizable:true,

                        //     //cellRenderer:'dateFormater',
                        //     valueGetter: function (params) {
                        //         if (params.data.status == 4 || params.data.status == 5) {
                        //             return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
                        //         }
                        //         else {
                        //             return "";
                        //         }

                        //     },
                        //     resizable: true,

                        // },
                        // {
                        //     headerName: "Left Destination At",
                        //     field: "left_dealer_marked",
                        //     width: 150,
                        //     //filter: "agDateColumnFilter",
                        //     //cellRenderer:'dateFormater',
                        //     valueGetter: function (params) {
                        //         if (params.data.status == 5) {
                        //             return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                        //         }
                        //         else {
                        //             return "";
                        //         }

                        //     },
                        //     resizable: true,

                        // },
                        {
                            headerName: "Transit Time (Days)",
                            field: "transit_time",
                            width: 170,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        {
                            headerName: "Transit Delay Hours",
                            field: "transit_delay_hours",
                            width: 180,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        // {
                        //     headerName: "Upload POD",
                        //     field: "upload_pod",
                        //     width: 200,
                        //     filter: false,
                        //     hide:tabName.value !=='completed',
                        //     cellRendererSelector: function (param) {
                        //         try {
                        //             return {
                        //                 component: uploadPOD,
                        //                 params: {
                        //                     onClickUploadPOD: onClickUploadPOD,
                        //                     isSubmittedPOD: param.data.is_submitted_pod
                        //                 }
                        //             }
                        //         } catch (err) {
                        //             //console.log(err);
                        //         }
                        //     }
                            // cellRenderer: (params) => {
                            //     const handleClick = (e) => {
                            //         e.stopPropagation();
                            //         onClickUploadPOD(params);  
                            //     };
                            //     //console.log(params,"disballelee");
                            //     return (
                            //         <button
                            //             onClick={handleClick}
                            //             // className="btn btn-info"
                            //             // style={{
                            //             //     padding: "8px 10px",
                            //             //     fontSize: "13px",
                            //             //     margin: "0",
                            //             //     display: "flex",           
                            //             //     alignItems: "center",      
                            //             //     justifyContent: "center",  
                            //             //     height: "100%",            
                            //             //     boxSizing: "border-box"    
                            //             // }}
                            //             style={{border:"none"}}
                            //             title="Upload POD"
                            //             disabled={params.data.epod_uploaded === 1}
                            //         >
                            //             <i
                            //                 className="icofont icofont-upload-alt f15"
                            //                 style={{
                            //                     fontSize: "15px",
                            //                     color: "#3a3fa6",
                            //                     lineHeight: "1",       
                            //                 }}
                            //             ></i>
                            //         </button>
                            //     );
                            // }
                            
                            // },
                            {
                                headerName: "Force Closure Reason",
                                field: "force_closure_reason",
                                width: 160,
                                hide:status!==6,
                                filter: "agSetColumnFilter",
                                cellRenderer: '', resizable: true
                            },
                            // {
                            //     headerName: "Upload POD",
                            //     field: "upload_pod",
                            //     width: 200,
                            //     filter: false,
                            //     hide:tabName.value !=='all',
                            //     cellRendererSelector: function (param) {
                            //         try {
                            //             // //console.log(param,"subbbbblegggg");
                            //             return {
                            //                 component: UploadFTLPod,
                            //                 params: {
                            //                     onClickUploadPOD: onClickUploadPOD,
                            //                 }
                            //             }
                            //         } catch (err) {
                            //             //console.log(err);
                            //         }
                            //     }
                                // cellRenderer: (params) => {
                                //     const handleClick = (e) => {
                                //         e.stopPropagation();
                                //         onClickUploadPOD(params);  
                                //     };
                                //     //console.log(params,"disballelee");
                                //     return (
                                //         <button
                                //             onClick={handleClick}
                                //             // className="btn btn-info"
                                //             // style={{
                                //             //     padding: "8px 10px",
                                //             //     fontSize: "13px",
                                //             //     margin: "0",
                                //             //     display: "flex",           
                                //             //     alignItems: "center",      
                                //             //     justifyContent: "center",  
                                //             //     height: "100%",            
                                //             //     boxSizing: "border-box"    
                                //             // }}
                                //             style={{border:"none"}}
                                //             title="Upload POD"
                                //             disabled={params.data.epod_uploaded === 1}
                                //         >
                                //             <i
                                //                 className="icofont icofont-upload-alt f15"
                                //                 style={{
                                //                     fontSize: "15px",
                                //                     color: "#3a3fa6",
                                //                     lineHeight: "1",       
                                //                 }}
                                //             ></i>
                                //         </button>
                                //     );
                                // }
                                
                                // },
                                {
                                    headerName: "Total Weight",
                                    field: "total_weight",
                                    colId: "total_weight",
                                    width: 130,
                                    resizable: true,
                                    headerClass: 'bold-header',
                                    valueFormatter: (params) => {
                                        // Ensure the value is a valid number
                                        const value = parseFloat(params.value);
                                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                                    }
                                   
                                },
                                {
                                    headerName: "Total CBM",
                                    field: "total_cbm",
                                    colId: "total_cbm",
                                    width: 110,
                                    resizable: true,
                                    headerClass: 'bold-header',
                                    valueFormatter: (params) => {
                                        // Ensure the value is a valid number
                                        const value = parseFloat(params.value);
                                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                                    }
                                 
                                },
                                {
                                    headerName: "No Of Boxes" ,
                                    field: "no_of_boxes",
                                    colId: "no_of_boxes",
                                    width: 125,
                                    cellRenderer: '', resizable: true,
                                    headerClass: 'bold-header'
                                },
                               
                                
                            
                    ];
                    columnDefs.forEach(e => {
                        e.cellClass = function (params) {
                            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                                return "bgColorDangerDark"; // Apply your custom CSS class here
                            } else {
                                return null;
                            }
                        };
                    });
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: columnDefs
                            // defaultColDef: {
                            //     flex: 3,
                            // },
                        },
                        getDetailRowData: (params) => {
                            // params.successCallback(resp.data);
                            params.successCallback(resp.data.consignments);
                        },
                    })
                // }
            // })
            // .catch(err => {
            //     //console.log(err);
            // })
        }})}
        const onClickShowCourierShipmentLegs = async (params, status) => {
            
            let query = {
                // truck_no: params.data.truck_no,
                shipment_id: params.data.shipment_id
            }
            redirectURL.post('/consignments/getCourierShipmentDetails', query)
            .then(resp => {
                if (resp.data.courier_consignments?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    const columnDefs = [
                        // {
                        //     headerName: "",
                        //     field: "legs_map",
                        //     colId: "legs_map",
                        //     width: 40,
                        //     pinned: 'left',
                        //     cellRenderer:function(params){
                        //         var htmloption = '<i className="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
                        //         return htmloption;
                        //     } ,
                        //     filter: false, resizable: true
        
                        // },
                        {
                            headerName: "Invoice No",
                            field: "invoice_no",
                            width: 150,
                            resizable:true,

                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        {
                            headerName: "Invoice Date",
                            field: "invoice_time",
                            colId: "invoice_time",
                            width: 150,
                            cellRenderer: '', resizable: true,
                            comparator: dateComparator,
                            valueGetter: function (params) {
                                const invoiceDate = params.data.invoice_time;
                                if (invoiceDate && invoiceDate.trim() !== '' && invoiceDate !== undefined) {
                                    // Call date formatting only when the dispatch date is valid
                                    const formattedDate = getHyphenDDMMMYYYYHHMM(invoiceDate);
                                    // Check if formattedDate is valid, otherwise return "NA"
                                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                                } else {
                                    return "";
                                }
                            },
                            headerClass: 'bold-header'
                        },
                        
                        // {
                        //     headerName: "Consignment",
                        //     field: "consignment_code",
                        //     width: 140,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        {
                            headerName: "Expected ETA", // Estimated delivery date
                            field: "expected_trip_end",
                            colId: "expected_trip_end",
                            width: 150,
                            resizable: true,
                            comparator: dateComparator,
                            valueGetter: function (params) {
                                if (params.data.tracking_type === "FTL") {
                                    // Check if expected_trip_end is not null or undefined
                                    return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end) || "";
                                } else {
                                    // Use expected_eta for non-FTL tracking types
                                    return getHyphenDDMMMYYYYHHMM(params.data.expected_eta) || "";
                                }
                            },
                            headerClass: 'bold-header'
                
                        },
                        {
                            headerName: "Revised Estimated Delivery Date",
                            field: "revised_trip_end",
                            colId: "revised_trip_end",
                            width: 260,
                            resizable:true,
                            hide: params.data &&(["Delivered", "Trip Completed"].includes(params.data.consignment_status)),
                          cellRenderer: '', 
                          resizable: true,
                            comparator: dateComparator,
                            valueGetter: function (params) {
                                
                                if (params.data.tracking_type === "FTL") {
                                    // Check if expected_trip_end is not null or undefined
                                    return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end) || "";
                                } else {
                                    // Use expected_eta for non-FTL tracking types
                                    return getHyphenDDMMMYYYYHHMM(params.data.revised_eta) || "";
                                }
                            },
                            headerClass: 'bold-header'
                        },
                        
                        {
                            headerName: "Status",
                            field: "consignment_status",
                            width: 140,
                            resizable:true
                            // cfellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // },
                            

                           
                        },
                        // {
                        //     headerName: "Zone",
                        //     field: "zone",
                        //     width: 100,
                        //     // cellclassName: function (params) {
                        //     // 	if (params.data.transit_delay == 1) {
                        //     // 		return 'lightred';
                        //     // 	}
                        //     // 	else {
                        //     // 		return '';
                        //     // 	}

                        //     // }
                        // },
                        
                        // {
                        //     headerName: "Dealer Code",
                        //     field: "consignee_code",
                        //     width: 140,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        {
                            headerName: "Destination City",
                            field: "consignee_city",
                            width: 150,
                            resizable: true,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },

                        {
                            headerName: "Consignee Name",
                            field: "consignee_name",
                            width: 200,
                            resizable: true,
                            valueGetter: function(params){
                                if(params.data.consignee_name !=="" && params.data.consignee_name !==" " && params.data.consignee_name !== undefined && params.data.consignee_name !== null){
                                    return capitalizeWords(params.data.consignee_name)
                                }else{
                                    return ""
                                }
                            },
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        },
                        // {
                        //     headerName: "Trip Distance (KM)",
                        //     field: "distance_in_km",
                        //     width: 100,
                        //     resizable: true,
                        //     valueGetter: params =>{
                        //         if(params.data.distance_in_km>0){
                        //             return params.data.distance_in_km
                        //         }else{
                        //             return 0
                        //         }
                        //     }
                        //     ,
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        // {
                        //     headerName: "Distance from Dealer (KM)",
                        //     field: "distance_from_dealer_location",
                        //     width: 200,
                        //     resizable:true,
                        //     valueGetter: function (params) {
                        //         if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
                        //             return params.data.distance_from_dealer_location;
                        //         }
                        //         else {
                        //             return "";
                        //         }
                        //     },
                            // cellclassName: function (params) {
                            // 	if (params.data.transit_delay == 1) {
                            // 		return 'lightred';
                            // 	}
                            // 	else {
                            // 		return '';
                            // 	}

                            // }
                        // },
                        // {
                        //     headerName: "Reached Destination At",
                        //     field: "recent_dealer_reported",
                        //     width: 180,
                        //     resizable: true,

                        // },
                        // {
                        //     headerName: "Left Destination At",
                        //     field: "left_dealer_marked",
                        //     width: 150,
                        //     //filter: "agDateColumnFilter",
                        //     //cellRenderer:'dateFormater',
                        //     valueGetter: function (params) {
                        //         if (params.data.status == 5) {
                        //             return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                        //         }
                        //         else {
                        //             return "";
                        //         }

                        //     },
                        //     resizable: true,

                        // },
                        {
                            headerName: "Transit Time (Days)",
                            field: "transit_time",
                            width: 170,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        {
                            headerName: "Transit Delay Hours",
                            field: "transit_delay_hours",
                            width: 180,
                            filter: "agSetColumnFilter",
                            cellRenderer: '', resizable: true
                        },
                        // {
                        //     headerName: "Upload POD",
                        //     field: "upload_pod",
                        //     width: 200,
                        //     filter: false,
                        //     hide:tabName.value !=='completed',
                        //     cellRendererSelector: function (param) {
                        //         try {
                        //             return {
                        //                 component: uploadPOD,
                        //                 params: {
                        //                     onClickUploadPOD: onClickUploadPOD,
                        //                     isSubmittedPOD: param.data.is_submitted_pod
                        //                 }
                        //             }
                        //         } catch (err) {
                        //             //console.log(err);
                        //         }
                        //     }
                            // cellRenderer: (params) => {
                            //     const handleClick = (e) => {
                            //         e.stopPropagation();
                            //         onClickUploadPOD(params);  
                            //     };
                            //     //console.log(params,"disballelee");
                            //     return (
                            //         <button
                            //             onClick={handleClick}
                            //             // className="btn btn-info"
                            //             // style={{
                            //             //     padding: "8px 10px",
                            //             //     fontSize: "13px",
                            //             //     margin: "0",
                            //             //     display: "flex",           
                            //             //     alignItems: "center",      
                            //             //     justifyContent: "center",  
                            //             //     height: "100%",            
                            //             //     boxSizing: "border-box"    
                            //             // }}
                            //             style={{border:"none"}}
                            //             title="Upload POD"
                            //             disabled={params.data.epod_uploaded === 1}
                            //         >
                            //             <i
                            //                 className="icofont icofont-upload-alt f15"
                            //                 style={{
                            //                     fontSize: "15px",
                            //                     color: "#3a3fa6",
                            //                     lineHeight: "1",       
                            //                 }}
                            //             ></i>
                            //         </button>
                            //     );
                            // }
                            
                            // },
                            // {
                            //     headerName: "Force Closure Reason",
                            //     field: "force_closure_reason",
                            //     width: 160,
                            //     hide:status!==6,
                            //     filter: "agSetColumnFilter",
                            //     cellRenderer: '', resizable: true
                            // },
                            // {
                            //     headerName: "Upload POD",
                            //     field: "upload_pod",
                            //     width: 200,
                            //     filter: false,
                            //     hide:tabName.value !=='all',
                            //     cellRendererSelector: function (param) {
                            //         try {
                            //             // //console.log(param,"subbbbblegggg");
                            //             return {
                            //                 component: UploadFTLPod,
                            //                 params: {
                            //                     onClickUploadPOD: onClickUploadPOD,
                            //                 }
                            //             }
                            //         } catch (err) {
                            //             //console.log(err);
                            //         }
                            //     }
                                // cellRenderer: (params) => {
                                //     const handleClick = (e) => {
                                //         e.stopPropagation();
                                //         onClickUploadPOD(params);  
                                //     };
                                //     //console.log(params,"disballelee");
                                //     return (
                                //         <button
                                //             onClick={handleClick}
                                //             // className="btn btn-info"
                                //             // style={{
                                //             //     padding: "8px 10px",
                                //             //     fontSize: "13px",
                                //             //     margin: "0",
                                //             //     display: "flex",           
                                //             //     alignItems: "center",      
                                //             //     justifyContent: "center",  
                                //             //     height: "100%",            
                                //             //     boxSizing: "border-box"    
                                //             // }}
                                //             style={{border:"none"}}
                                //             title="Upload POD"
                                //             disabled={params.data.epod_uploaded === 1}
                                //         >
                                //             <i
                                //                 className="icofont icofont-upload-alt f15"
                                //                 style={{
                                //                     fontSize: "15px",
                                //                     color: "#3a3fa6",
                                //                     lineHeight: "1",       
                                //                 }}
                                //             ></i>
                                //         </button>
                                //     );
                                // }
                                
                                // },
                                {
                                    headerName: "Total Weight",
                                    field: "total_weight",
                                    colId: "total_weight",
                                    width: 130,
                                    resizable: true,
                                    headerClass: 'bold-header',
                                    valueFormatter: (params) => {
                                        // Ensure the value is a valid number
                                        const value = parseFloat(params.value);
                                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                                    }
                                   
                                },
                                {
                                    headerName: "Total CBM",
                                    field: "total_cbm",
                                    colId: "total_cbm",
                                    width: 110,
                                    resizable: true,
                                    headerClass: 'bold-header',
                                    valueFormatter: (params) => {
                                        // Ensure the value is a valid number
                                        const value = parseFloat(params.value);
                                        return !isNaN(value) ? value.toFixed(2) : ''; // Return empty string if it's not a valid number
                                    }
                                 
                                },
                                {
                                    headerName: "No Of Boxes" ,
                                    field: "no_of_boxes",
                                    colId: "no_of_boxes",
                                    width: 125,
                                    cellRenderer: '', resizable: true,
                                    headerClass: 'bold-header'
                                },
                               
                                
                            
                    ];
                    columnDefs.forEach(e => {
                        e.cellClass = function (params) {
                            if (params.data && params.data.hasOwnProperty(`${e.field}_modified`) && params.data[`${e.field}_modified`] === 1) {
                                return "bgColorDangerDark"; // Apply your custom CSS class here
                            } else {
                                return null;
                            }
                        };
                    });
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: columnDefs
                            // defaultColDef: {
                            //     flex: 3,
                            // },
                        },
                        getDetailRowData: (params) => {
                            // params.successCallback(resp.data);
                            params.successCallback(resp.data.courier_consignments);
                        },
                    })
                // }
            // })
            // .catch(err => {
            //     //console.log(err);
            // })
        }})}
        const changeFileHandlerForPod = (event) => {
            try {

                const files = event.target.files;
                
        
                if (files && files.length > 0) {
                    const file = files[0];
                    const fileType = file.type;
        
                    // Define the allowed MIME types (PDF and images)
                    const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
        
                    // Check if the file type is valid
                    if (!validTypes.includes(fileType)) {
                        alert("Please select a valid PDF or image file.");
                        setCustomerDocument1(null);
                        setEpodDoc(null);
                        event.target.value = ""; 
                        return; // Exit the function
                    }
        
                    // If the file is valid, proceed to set the document
                    setCustomerDocument1(files);
                    setEpodDoc(files[0]);
        
                   
                }
            } catch (e) {
                setCustomerDocument1(null);
                setEpodDoc(null);
                const fileInput = document.getElementById("epodDoc");
                if (fileInput) {
                    fileInput.value = "";
                } else {
                    console.error("Element with ID 'customer_document_1' not found");
                }
        
                // document.getElementById("customer_document_1").value = "";
            }
        };                  
        const onCloseSliderDiv = () => {
                        // Clear the state for all inputs to reset their values
                        setDamage(0);            // Reset damage input
                        setExcess(0);            // Reset excess input
                        setPilferage(0);         // Reset pilferage input
                        setShort(0);             // Reset short input
                        setPodRemarks("");       // Reset remarks textarea
                    
                        // Clear file input fields via DOM manipulation as they are uncontrolled components
                        if (document.getElementById("epodDoc")) {
                            document.getElementById("epodDoc").value = "";
                        }
                        if (document.getElementById("File")) {
                            document.getElementById("File").value = "";
                        }
                        if (document.getElementById("podDoc")) {
                            document.getElementById("podDoc").value = "";
                        }
                    
                        // Reset other states related to the UI
                        setSliderShow(''); 
                        setOverlay('show-n'); 
                        setManualUploadSlider('show-n');
                        setBulkMarkDeliverSlide('show-n');
                        setShipmentSlider('show-n');
                        setShipmentCsvContent([]); 
                        setShipmentFile(''); 
                        setBulkSliderShow('show-n');
                        setSliderScanShow('show-n');
                        setSliderSupportShow('show-n');
                        setSelectedRowNodes([]); 
                        setLoadShow('show-n'); 
                        setMultiplePodDocs([]); 
                        setDeliveredDate1(""); 
                        setUpdateRowSlider("");
};
                    

const onCloseSliderDiv1 = () => {
    setSliderShow1('');
    setOverlay('show-n');
    setDocRemarks("")
    setSelectedTab("loading")
    document.getElementById("uploadDoc").value = "";
    document.getElementById("File").value = "";
    setLoadShow('show-n');
    setPodRemarks("");
};
const onShowUploadDoc = (rownode) => {
    if(rownode.data.status ===4){
        setSelectedDoc(true)
    }
    setSliderShow1("slider-translate-30p")
    setOverlay("show-m")
    setRownode([rownode.data])

}

const onShowTransitData = (params) => {
    let query = {
        truck_no: params.data.truck_no,
        consignment_code: params.data.consignment_code,
        consignee_code: params.data.consignee_code
    }
    redirectURL.post('/consignments/transitdelay', query)
        .then(resp => {
            if (resp.data?.length > 0) {
                params.node.setExpanded(!params.node.expanded)
                setdetailCellRendererParams({
                    detailGridOptions: {
                        columnDefs: transitdelaycols,
                        defaultColDef: {
                        },
                    },
                    getDetailRowData: (params) => {
                        params.successCallback(resp.data);
                    },
                })
            }
        })
        .catch(err => {
            //console.log(err);
        })
}
const onShowStoppagesData = (params) => {
    
    let query = {
        truck_no: params.data.truck_no,
        // consignment_code: params.data.consignment_code
        shipment_id:params.data.shipment_id
    }
    redirectURL.post('/consignments/enroutes', query)
        .then(resp => {
            if (resp.data?.length > 0) {
                params.node.setExpanded(!params.node.expanded)
                setdetailCellRendererParams({
                    detailGridOptions: {
                        columnDefs: stoppagescols,
                        defaultColDef: {
                            flex: 1,
                        },
                        statusBar: {
                            statusPanels: [
                                {
                                    statusPanel: "customBreakSummaryPanel",
                                }
                            ]
                        },
                        frameworkComponents: {
                            customBreakSummaryPanel: (props) => {
                                const rows = [];
                                props.api.forEachNodeAfterFilterAndSort((node) => {
                                    if (node.data) rows.push(node.data);
                                });

                                const totalBreaks = rows.length;
                                const totalSeconds = rows.reduce((sum, row) => sum + (row.break_time_seconds || 0), 0);

                                return (
                                    <div className="d-flex" style={{ fontWeight: 'bold', color: '#1A1A1A' ,fontSize : "13px"}}>
                                        <div className = "" style={{marginRight:"-713px"}}></div>
                                        <div className = "" style={{margin : "2px", marginLeft : "-574px"}}>
                                            <span style={{ color: 'rgba(154, 147, 147)' }}>Total Breaks: </span>
                                             <span style={{ color: 'rgba(48, 38, 38, 1)' }}>{totalBreaks}</span>
                                        </div>
                                        <div className = "" style = {{marginLeft : "768px"}}>
                                            <span style={{ color: 'rgba(154, 147, 147)' }}>Total Break Time: </span>
                                            <span style={{ color: 'rgba(48, 38, 38, 1)' }}>{secondsToString(totalSeconds)}</span>
                                            </div>
                                    </div>
                                );
                            }
                        }
                    },
                    getDetailRowData: (params) => {
                        params.successCallback(resp.data);
                    },
                })
            }
        })
        .catch(err => {
            //console.log(err);
        })
}
const onShowNoGPSData = (params) => {
    params.node.setExpanded(!params.node.expanded)
    setdetailCellRendererParams({
        detailGridOptions: {
            columnDefs: nogpscols,
            defaultColDef: {
                flex: 1,
            },
        },
        getDetailRowData: (params) => {
            let nogpsrecords = []
            redirectURL.post('/consignments/nogpsdata', {
                consignment_code: params.data.consignment_code,
                truck_no: params.data.truck_no
            })
                .then(async (response) => {
                    nogpsrecords = response.data;
                    params.successCallback(nogpsrecords);

                });
        },
    })
}
const uploaddocSubmission=async(rownode)=>{
    if (rownode.length > 0) { 
        const rowid = rownode[0]._id;
        const rownodes = rownode;
        const formData = new FormData();
        uploadDoc?.forEach((file) => {
            formData.append("uploadDocs", file);
        });      
        if (uploadType ==="loading"){
            formData.append("loadingdocremarks", loadingdocremarks);
        }else if(uploadType ==="unloading"){
            
            formData.append("unloadingdocremarks", unloadingdocremarks);
        }else{
            formData.append("docremarks", docremarks);
        }
             
        formData.append("rowid", rowid);
        formData.append("rownodes", JSON.stringify(rownodes));
        formData.append("tracking_type", rownode[0].tracking_type)
        formData.append("source_from", "web");
        formData.append("email", user.email);

        await redirectURL.post("/saveuploaddocument", formData, {
            headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
            .then((resp) => {
                if (resp.data.status === 'success') {
                    document.getElementById("formDocument").reset();
                    // setRowNode([]);
                    setShow(true);
                    setUploadDoc([]);
                    // setSlider('show-n');
                    setTitle("Documents uploaded successfully");
                    setType("success");
                    setDocRemarks("");
                    setSliderShow1("");
                    setOverlay("show-n");
                    setUnloadingRemarks("");
                    setLoadingRemarks("")
                    // setLoadshow('show-n');
                // window.location.reload();
                }
            })
            .catch((error) => {
                console.error("Error uploading document:", error);
                // Handle error here, e.g., show a message
            });
    }
}


const uploadDocument1 = async(event) => {
    event.preventDefault();
    if(rownode[0].tracking_type === 'FTL'){
        if (selectedTab === "loading" ? (loadingdocremarks === "") : (unloadingdocremarks === "")) {
            setShow(true);
            setType("warning");
            setTitle("Please enter remarks");
            setDocRemarks("");
            // setUploadDoc([]);
        }else{
            uploaddocSubmission(rownode)
        }

    }else{
        if (docremarks === "") {
            setShow(true);
            setType("warning");
            setTitle("Please enter remarks");
            setDocRemarks("");
            // setUploadDoc([]);
        } else{
            uploaddocSubmission(rownode)
        }
    }
    
    
};
const onClickTransporterEdit = (e)=>{
    const data = e.data
    
    const x = {label:data.invoice_no, value: data.invoice_no}

    const y = (data.consignment_code)
    const z = {label:data.shipment_id, value:data.shipment_id}
    //console.log(selectedRows, "998811");
    setShowUpdateTransporterForm('slider-translate-30p');
    setOverlay('show-m'); 
    setEditTransporter(true)
    setSelectedTransporter({label: data.transporter_name, value: data.transporter_name})

    setConsignmentCodeForTransporterUpdate(y)
    setSelectedTransporterShipments(z)
    
    setSelectInvoicesToTransporterUpdate(x);
}
const onClickActive = async(e) => {
    
    // Check if e.data is valid and contains necessary fields
    if (!e.data || !e.data.consignment_uid || !e.data.shipment_id) {
        console.error("Invalid data provided", e.data);
        return;
    }
    const editdata = e.data

    setConsignmentUidForTruckLevel(e.data.consignment_uid);

    let reqDetail = {
        consignment_code: e.data.shipment_id,
        lr_no: e.data.lr_no,
        tracking_type: e.data.tracking_type
    };

    // If tracking type is "ptl", adjust the request details
    if ((e.data.tracking_type).toLowerCase() === "ptl") {
        reqDetail = {
            consignment_code: e.data.consignment_code,
            lr_no: e.data.lr_no,
            tracking_type: e.data.tracking_type
        };
    }

    // Ensure sourceList exists before filtering
    let selectedSource = sourceList?.filter((k) => k.label.toLowerCase() === e.data.consigner_city.toLowerCase());
    
    // Make the post request for drop point details
    await redirectURL.post("/consignments/getDropPointDetailsForShipment", reqDetail)
        .then((response) => {
            if (response.data.status === 'Success') {

                const drpPoint = response.data.data.slice(1);
                const selectedKeys = drpPoint.map(item => ({
                    consignee_name: item.consignee_name,
                    lr_no: item.lr_no,
                    invoice_no: item.invoice_no,
                    consignee_pincode: item.consignee_pincode,
                    consignee_city: item.consignee_city,
                    consignment_uid: item?.consignment_uid ?? ""
                }));
                setDropPointArr(selectedKeys);

                const newCvArray = response.data.data.map((item) => {

                    return {
                        lr_no: item.lr_no,
                        invoice_no: item.invoice_no,
                        consignee_name: item.consignee_name ? item.consignee_name : "",
                        no_of_boxes: "",
                        destination_pincode: item.consignee_pincode ?? "",
                        destination_city: item.consignee_city ?? "",
                        eway_bill_no: "",
                        customer_mail_id: "",
                        other_consignee_name: item.other_consignee ?? "",
                        other_consignee_pincode: item.other_consignee_pincode ?? "",
                        other_consignee_city: item.other_consignee_city ?? "",
                        consignment_uid: item.consignment_uid ?? "",
                    };
                }).filter(item => item !== null);

                if (newCvArray.length > 0) {
                    let x = newCvArray.splice(0, 1);
                    setManualTripUploadDetails(newCvArray);
                } else {
                    console.error("newCvArray is empty or not populated as expected.");
                }
            } else {
                console.error("Error from drop point API");
            }
        })
        .catch((err) => {
            console.error("Error in API call", err);
        });

    // Ensure the state is updated only if necessary
    setselected_row(e.data);

    setmanualUploadDetails1((prev) => ({
        ...prev,
        invoice_no: e.data.invoice_no,
        consignee_name: e.data.customer_name,
        consignee_city: e.data.consignee_city,
        consignee_state: e.data.consignee_state,
        consignee_pincode: e.data.consignee_pincode,
        total_weight: e.data.total_weight
    }));

    setmanualUploadDetails((prev) => ({
        ...prev,
        invoice_no: e.data.invoice_no,
        lr_no: e.data.lr_no
    }));


    setShipmentId(e.data.shipment_id);

    // Initialize a variable for ewayBillExpiryDate
    var ewayBillExpiryDate = null; // Start with null as default value

    // Check if the date exists
    if (e.data.eway_bill_expiry_date) {
        const dateStr = e.data.eway_bill_expiry_date; // Trim any extra spaces
    
        // Regex to match DD-MM-YYYY HH:MM format
        const ddmmyyRegex = /^(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})$/;
    
        if (ddmmyyRegex.test(dateStr)) {
            // If the date matches the regex, format it to YYYY-MM-DDTHH:MM:SS
            const matches = dateStr.match(ddmmyyRegex);
            const formattedDate = `${matches[3]}-${matches[2]}-${matches[1]}T${matches[4]}:${matches[5]}:00`;
            ewayBillExpiryDate = new Date(formattedDate);
        } else {
            // If the date is not in the expected format, try parsing it directly
            ewayBillExpiryDate = new Date(dateStr);
        }
    
        // Check if the date is valid (i.e., not "Invalid Date")
        if (ewayBillExpiryDate instanceof Date && !isNaN(ewayBillExpiryDate.getTime())) {
            // Adjust the time by subtracting 5 hours and 30 minutes (to account for India Standard Time)
            ewayBillExpiryDate.setMinutes(ewayBillExpiryDate.getMinutes() - 330);
        } else {
            console.error("Invalid date format", dateStr);
            ewayBillExpiryDate = null; // If the date is invalid, set it to null
        }
    } else {
        ewayBillExpiryDate = null; // If no date exists, set it to null
    }
    
    // Ensure the date is valid before assigning it to editdata
    if (ewayBillExpiryDate && ewayBillExpiryDate instanceof Date && !isNaN(ewayBillExpiryDate.getTime())) {
        let date1 = new Date(ewayBillExpiryDate);
        editdata.eway_bill_expiry_date = new Date(date1.getTime() + (330 * 60 * 1000)); // Add back 5 hours 30 minutes
    } else {
        editdata.eway_bill_expiry_date = null; // If the date is invalid, set to null or handle accordingly
    }
    setOrginalDetailsForEdit(editdata);


    
    

    setManualUpdateConsignment((prev) => ({
        ...prev,
        lr_no: e.data.lr_no ?? "",  // If lr_no is null or undefined, set it to an empty string
        invoice_no: e.data.invoice_no ?? "",  // Default to empty string if null or undefined
        driver_mobile_no: e.data.driver_mobile_no ?? "",  // Default to empty string if null or undefined
        truck_no: e.data.truck_no ?? "",  // Default to empty string if null or undefined
        truck_seal_no: e.data.truck_seal_no ?? "",  // Default to empty string if null or undefined
        entity: { 
            label: e.data.truck_seal_entity ?? "", 
            value: e.data.truck_seal_entity ?? "" 
        },
        vehicle_type: { 
            label: e.data.truck_type ?? "", 
            value: e.data.truck_type ?? "" 
        },
        courier_partner: { 
            label: e.data.transporter_name ?? "", 
            value: e.data.transporter_name ?? "" 
        },
        vehicle_capacity: e.data.vehicle_capacity ?? "",  // Default to empty string if null or undefined
        eway_bill_expiry_date: ewayBillExpiryDate ?? "",  // Default to empty string if null or undefined
        no_of_boxes: e.data.no_of_boxes ?? "",  // Default to empty string if null or undefined
        movement_type: { 
            label: e.data.movement_type ?? "", 
            value: e.data.movement_type ?? "" 
        },
        consignee_name: { 
            label: e.data.customer_name ?? "", 
            value: e.data.customer_name ?? "" 
        },
        destination_pincode: e.data.consignee_pincode ?? "",  // Default to empty string if null or undefined
        destination_city: e.data.consignee_city ?? "",  // Default to empty string if null or undefined
        other_consignee_name: e.data.other_consignee ?? "",  // Default to empty string if null or undefined
        other_destination_pincode: e.data.other_consignee_pincode ?? "",  // Default to empty string if null or undefined
        other_destination_city: e.data.other_consignee_city ?? "",  // Default to empty string if null or undefined
        other_transporter: "",
        other_vehicle_capacity: "",
        other_source: "",
        source: { 
            label: e.data.consigner_city ?? "", 
            value: e.data.consigner_city ?? "" 
        },
        other_vehicle_type: "",
    }));
    

    let intialConsignmentConsigneeDetails = [{
        consignee_name: e.data.consignee_name,
        destination_city: e.data.consignee_city,
        destination_pincode: e.data.consignee_pincode
    }];


    setConsigneesForTrip(intialConsignmentConsigneeDetails);

    if (e.data.tracking_type === "FTL") {

        setshowAddForm3('slider-translate-30p');
    } else {
        setshowAddForm3('slider-translate-30p');
    }

    setOverlay("show-m");
};

    const onClickEditLogs = (e) => {
        //console.log(e, "eeee1234");
       
        // setOrginalDetailsForEdit(e.data)
        var params = {
            shipment_id: e.data.shipment_id,
        }
       
        // let selectedSource = e.data.source_city
        redirectURL.post("/consignments/getEditLogsData", params)
        .then((response) => {
            if (response.data.status == 'Success') {
                //console.log(response, "editlogsresp");
                if((response.data.edit_logs_data).length>0){
                    setEditLogsData(response.data.edit_logs_data); // Store all logs
                setFilteredLog(response.data.edit_logs_data[0]); // Default to first log
                setIsEditLogsModalOpen(true);
                }else{
                    setShow(true);
                    setTitle("No edit logs are currently available for this consignment.");
                    setType("danger")
                    setOverlay("show-n")
                }
                
            }
        })
        .catch(function (e) {
            //console.log("Error ", e)
        })  
      

        // if(e.data.tracking_type === "FTL"){
        //     setshowAddForm3('slider-translate-30p');
        // } else {
        //     // setshowAddForm("slider-translate-30p");
        //     setshowAddForm3('slider-translate-30p');
        // }
        setOverlay("show-m");
    };
    
    const updateLrs = async() => {
               setOverlay("show-m")
               
        var isValid = selectedRows.every(row=> row.tracking_type === selectedRows[0].tracking_type);
        var isValid1 = selectedRows.every(row=> row.transporter_name === selectedRows[0].transporter_name);
        var isValid2 = selectedRows.every(row=> row.truck_no === selectedRows[0].truck_no);

        let weightValid=false;
        var ftlValidWeight1 = selectedRows.every(row=> parseInt(row.total_weight) >= 800);
        var ptlValidWeight1 = selectedRows.every(row=> parseInt(row.total_weight) <800);
        var ValidWeight1 = selectedRows.every(row=> !row.total_weight);
        var bothTrackingType = selectedRows.every(row=> row.tracking_type === "FTL/PTL");

        if(ftlValidWeight1){
            weightValid=true
        }else if(ptlValidWeight1){
            weightValid=true
        }else if(ValidWeight1){
            weightValid=true
        }

        setFtlValidWeight(ftlValidWeight1);
        setPtlValidWeight(ptlValidWeight1);
        setValidWeight(ValidWeight1)


        //console.log(selectedRows, "rows44455");
        var trackingTypeLR = selectedRows[0].tracking_type;
        var data = selectedRows[0];
        setLRTrackingType(trackingTypeLR)
        setInvoiceDateValueOfUpdateLr(selectedRows[0].invoice_time)
        var timeString;
        if (data.dispatch_date && moment(data.dispatch_date, moment.ISO_8601, true).isValid()) {
            var date1 = moment(data.dispatch_date);
            var adjustedTime1 = date1.subtract(5, "hours").subtract(30, "minutes");
            var time1 = adjustedTime1.toDate();
            var timeString = time1.toDateString();
        
            //console.log("Adjusted Time:", timeString);
        } 
        const date = new Date(timeString);
        
        // const date = moment(data.dispatch_date).utcOffset("+05:30");
        // //console.log("test",moment(data.dispatch_date).format("YYYY-MM-DD HH:mm:ss"), new Date(moment(data.dispatch_date).format("YYYY-MM-DD HH:mm:ss")))
        var fuelType1 =data.fuel_type.length>1 ? {label:"", value:""}:{label:data.fuel_type[0], value:data.fuel_type[0]};

        await redirectURL.post('/consignments/getMaxFuelType').then((response)=>{
            
            if(response.data.status==="success"){
                let tptNfuelData = response.data.result;
                
                let validMaxFuelType = tptNfuelData[data.transporter_name.toUpperCase()]
                
                if(validMaxFuelType !==""){
                    
                    setManualUpdateLRConsignment((prev)=>({
                        ...prev,
                        fuel_type: {label:validMaxFuelType, value:validMaxFuelType}
                    
                }))
                }else{
                    setManualUpdateLRConsignment((prev)=>({
                        ...prev,
                        fuel_type: fuelType1
                    
                }))
                }
                
            }
        })

       var validFuelType=tptNFuel.filter(e=> (e.label.toLowerCase()===data.transporter_name.toLowerCase())).map(e=>e.value).flat()

       var validFuelTypes = validFuelType.map(e=> ({label:e, value:e}))
       
       setFuelTypeListForUpdateLR(validFuelTypes)
       



      
        setManualUpdateLRConsignment((prev)=> {
            
            return {
            ...prev,
            driver_mobile_no: data.driver_mobile_no,
            truck_no: data.truck_no,
            entity: {label: data.truck_seal_entity, value: data.truck_seal_entity },
            // fuel_type:{label:data.fuel_type, value:data.fuel_type},
            // fuel_type: fuelType1,
            vehicle_type: {label:data.truck_type, value:data.truck_type},
            courier_partner:{label:data.transporter_name, value:data.transporter_name},
            no_of_boxes:data.no_of_boxes ,
            tracking_type:data.tracking_type,
            total_cbm:data.total_cbm,
            total_weight:data.total_weight,
            dispatch_time: data.dispatch_time ? new Date(data.dispatch_time) : new Date(),
            tracking_type_mutliple: {label:"", value:""},
            mode: {label:data.shipment_mode, value:data.shipment_mode},
            eway_bill_no:data.eway_bill_no

        }
    }
    )

        

        if(!isValid){
            setShow(true)
            setTitle("Please select the same tracking mode consignments")
            setType("danger")
            setOverlay("show-n")

            return;

        }
        if(!isValid1){
            setShow(true)
            setTitle("Please select the same transporter consignments")
            setType("danger")
            setOverlay("show-n")

            return;

        }
        if(!isValid2){
            setShow(true)
            setTitle("Please select the same truck no consignments")
            setType("danger")
            setOverlay("show-n")

            return ;

        }
        if(bothTrackingType && (!weightValid)){
            setShow(true)
            setTitle("Please select the consignments where the total weight is either greater than or equal to 800, less than 800, or empty.")
            setType("danger")
            setOverlay("show-n")

            return ;

        }
       
        else{
            const x = selectedRows.map((e)=> ({label:e.invoice_no, value: e.invoice_no}))

            const y = selectedRows.flatMap((e)=> (e.consignment_code))
            const z = selectedRows.map((e)=> ({label:e.shipment_id, value:e.shipment_id}))
            //console.log(selectedRows, "998811");
            
            const selectedTransporter = selectedRows[0].transporter_name;
            // console.log(selectedTransporter, "selectedTransporter");
            const tptName = selectedTransporter.toLowerCase()
            // console.log(tptName, "tptName")
            const convertedTpt = convertTpt(selectedTransporter)
            // console.log(convertedTpt, "covertedTpt")
            // console.log(SIMTrackingTpts, "SIMTrackingTpts999")
            const driveNoMandatory = SIMTrackingTpts.includes(tptName)
            // console.log(driveNoMandatory, "driveNoMandatory")

            let tptArray = ["Univelox", "Abhilash Logistics", "Sri Ranga Transport", "Patil Transport"]
            const boxesMandatory = tptArray.includes(convertedTpt);

            setNoOfBoxesMandatory(boxesMandatory)

            setDriverNoMandatory(driveNoMandatory)
            
            var transporterName = selectedRows.every(row => {
                return row.transporter_name === "" || typeof row.transporter_name === 'undefined';
            });  
            //console.log(transporterName, "transporterNamevalidation");
            
            setTransporterValidation(transporterName);
            var entity = selectedRows.every(row => row.truck_seal_entity === "" || typeof row.truck_seal_entity === "undefined");
            setEntityValidation(entity);

            var noOfBoxes = selectedRows.every(row => row.no_of_boxes === "" || typeof row.no_of_boxes === "undefined");
            setNoOfBoxesValidation(noOfBoxes);

            var totalCBM = selectedRows.every(row => row.total_cbm === "" || typeof row.total_cbm === "undefined");
            setTotalCBMValidation(totalCBM);

            var totalWeight = selectedRows.every(row => row.total_weight === "" || typeof row.total_weight === "undefined");
            setTotalWeightValidation(totalWeight);

            var dispatchDate = selectedRows.every(row => row.dispatch_date === "" || typeof row.dispatch_date === "undefined");
            setDispatchdateValidation(dispatchDate);

            var mode = selectedRows.every(row => row.shipment_mode === "" || typeof row.shipment_mode === "undefined");
            setModeValidation(mode);

            // var multipleModes = selectedRows.every(row => (row.shipment_mode).length>0);
            // setModeValidation(mode);

            var fuelType = selectedRows.every(row => row.fuel_type === "" || typeof row.fuel_type === "undefined");
            setFuelValidation(fuelType);


            var invoiceType = selectedRows.every(row => row.invoice_type === "" || typeof row.invoice_type === "undefined");
            setInvoiceTypeValidation(invoiceType);

            var driverNoValidation = selectedRows.every(row => row.driver_mobile_no === "" || typeof row.driver_mobile_no === "undefined");
            setDriverNoValidation(driverNoValidation);

            var truckNo = selectedRows.every(row => row.truck_no === "" || typeof row.truck_no === "undefined");
            setTruckNoValidation(truckNo);

            var vehicleType = selectedRows.every(row => row.truck_type === "" || typeof row.truck_type === "undefined");
            setVehicleTypeValidation(vehicleType);
            ;




            
            setShowUpdateLrForm('slider-translate-30p');
            setOverlay('show-m'); 
    
            setConsignmentCodeForLRUpdate(y)
            setSelectedShipments(z)
            
            setSelectInvoicesToUpdate(x);
        }

       
    }
    const updateTransporter = () => {
      
            const x = selectedRows.map((e)=> ({label:e.invoice_no, value: e.invoice_no}))

            const y = selectedRows.flatMap((e)=> (e.consignment_code))
            const z = selectedRows.map((e)=> ({label:e.shipment_id, value:e.shipment_id}))
            //console.log(selectedRows, "998811");
            setShowUpdateTransporterForm('slider-translate-30p');
            setOverlay('show-m'); 
    
            setConsignmentCodeForTransporterUpdate(y)
            setSelectedTransporterShipments(z)
            
            setSelectInvoicesToTransporterUpdate(x);

       
    }
    const onClickHideAll = () => {
        setshowAddForm2("")
        setSourceValidation(false)
        // setManualInTransitStatusUpdate.dispatch_time("")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            lr_no: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setDselected_row({})        
        document.getElementById("uploadDoc").value = "";
        // document.getElementById("File").value = "";
        setSliderShow1("")
        setSliderShow("");
        setDocRemarks("")
        setshowAddForm2("");
        setInvoiceValid(false)
        setValidTruckNo(true);
        setForm2Details({
            event_status: statusOrderFtl,
            selectedStatus: {value: 'In Transit', label: 'In Transit'},
            selectedPincode: {value: '', label: ''},
            event_location: "",
            remark: {label:"", value:""},
            reason_for_delay:{label:"", value:""},
            delivered_date:new Date(),
            delivered_time:new Date(),
            errorMessage:''
        })
        setshowAddForm("")
        setshowAddForm3("")
        setErrorMssge("");
        setEnableSourceField(false);
        
        setShowUpdateLrForm("")
        setSliderCreateConsignmentTranslate("")
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setLoadShow("show-n")
        setSliderCreateConsignmentTranslate("")
        setManualTripUploadDetails([])
        setManualUpdateConsignment({
            driver_number: '',
            source: "",
            truck_no: "",
            truck_seal_no: "",
            vehicle_type: "",
            courier_partner:"",
            vehicle_capacity: "",
            consignee_name: "",
            lr_no: "",
            invoice_no: "",
            no_of_boxes: "",
            destination_pincode: "",
            destination_city:""
          })
        document.getElementById("epodDoc").value = "";
        setDamage("")
        setExcess("")
        setPilferage("")
        setShort("")
        setPodRemarks("")
        document.getElementById("formPOD").reset();
        setFormData({
            driver_mobile_no:'',
            source:'',
            other_source:'',
            other_source_pincode:'',
            truck_no:'',
            truck_seal_no:'',
            entity:'',
            vehicle_type:{label:'', value:''},
            courier_partner:{label:'', value:''},
            eway_bill_expiry_date:'',
            invoice_date:'',
            total_weight:'',
            total_cbm:'',
            vehicle_capacity:'',
            consignee_name:'',
            movement_type:'',
            lr_no:'',
            invoice_no:[],
            invoice_no_str:"",
            consigner_name:"",
            consignee_name1:"",
            number_of_boxes:'',
            destination_pincode:'',
            destination_city:'',
            show: false,
            basicType: '',
            basicTitle: '',
            sliderCreateConsignmentTranslate: '',
            loadshow: 'show-n',
            overly: 'show-n',
            dispatch_time:new Date()
        })
        setSourceList(originalSourceList)
    }
    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setReasonForceClose('')
        setRownode([])
    }

    // const onShowForceCloseModal = (e) => {
        
    //     setForcecloseModal(true)
    //     setRownode(e)
    //     setReasonForceClose('')
    //     setReasonForCancellation("");
    //     let query = {
    //         truck_no: e.data.truck_no,
    //         shipment_id: e.data.shipment_id,
    //     }
    //     redirectURL.post('/consignments/getShipmentDetails', query)
    //     .then(resp => {
    //         if (resp.data.consignments?.length > 0) {
    //             var records = resp.data.consignments

    //         const invoiceNos =    records.map(each => ({
    //                 label:each.invoice_no,
    //                 value: each.invoice_no
    //         }))
            
    //         setInvoiceNoList(invoiceNos)
    //         }})
        
    //     const filteredLrOptions = lrNoOptions.filter(m => {
    //         return m.label !== "undefined" && m.value === e.data.lr_no;
    //     });
    //     setLrOptions(filteredLrOptions)
    // }
    const onShowForceCloseModal = async (param) => {
        try {
            const data = param.data || {};
            console.log("Full Grid Row Data:", data);

            setForcecloseModal(true);
            setRownode(data);
            setReasonForceClose('');
            setSelectedInvoices([]);

            let invoices = [];

            if (Array.isArray(data.invoice_list) && data.invoice_list.length > 0) {
                invoices = data.invoice_list;
            }
            else if (data.invoice_no && data.invoice_no.trim() !== "") {
                invoices = [data.invoice_no.trim()];
            }

            const formattedInvoices = invoices.map(inv => ({
                label: inv,
                value: inv
            }));

            setInvoiceNoList(formattedInvoices);
            setSelectedInvoices(formattedInvoices);

            console.log("Invoices fetched for modal:", formattedInvoices);
        } catch (err) {
            console.error("❌ Error fetching shipment details:", err);
        }
    };


    const saveGrid = async (e) => {
        let coloumnState = columnApiConsignments.current.getColumnState()
        let temp;
        
        if(tabName.value!=="inactive" && tabName.value!=="transporter"){
            if(searchViewType.value==="LR"){
                if(tabName.value==="active"){
                    temp = await saveGridLayout(user.email, "consignments", coloumnState)
                }else if(tabName.value==="completed"){
                    temp = await saveGridLayout(user.email, "delivered_consignments", coloumnState)
                }else{
                    temp = await saveGridLayout(user.email, "all_consignments", coloumnState)
                }
            }else{
                if(tabName.value==="active"){
                    temp = await saveGridLayout(user.email, "invoice_consignments", coloumnState)
                }else if(tabName.value==="completed"){
                    temp = await saveGridLayout(user.email, "invoice_delivered_consignments", coloumnState)
                }else{
                    temp = await saveGridLayout(user.email, "invoice_all_consignments", coloumnState)
                }    
            }
        }else if(tabName.value==="transporter"){
            
            temp = await saveGridLayout(user.email, "tpt_consignments", coloumnState)
        }else if(tabName.value==="inactive"){
            temp = await saveGridLayout(user.email, "invoice_details", coloumnState)
        } 
        
        
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Save grid successfully updated")
            setType("success")
            // reloadPage.current = true
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = []
        let temp;
        if(tabName.value!=="inactive" && tabName.value!=="transporter"){
            if(searchViewType.value==="LR"){
                if(tabName.value==="active"){
                    temp = await saveGridLayout(user.email, "consignments", coloumnState)
                }else if(tabName.value==="completed"){
                    temp = await saveGridLayout(user.email, "delivered_consignments", coloumnState)
                }else{
                    temp = await saveGridLayout(user.email, "all_consignments", coloumnState)
                }          
         }else{
            if(tabName.value==="active"){
                temp = await saveGridLayout(user.email, "invoice_consignments", coloumnState)
            }else if(tabName.value==="completed"){
                temp = await saveGridLayout(user.email, "invoice_delivered_consignments", coloumnState)
            }else{
                temp = await saveGridLayout(user.email, "invoice_all_consignments", coloumnState)
            }     
            }
        }else if(tabName.value==="transporter"){
            temp = await saveGridLayout(user.email, "tpt_consignments", coloumnState)
        }else if(tabName.value==="inactive"){
            temp = await saveGridLayout(user.email, "invoice_details", coloumnState)
        }       
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Reset grid successfully updated")
            setType("success")
            // reloadPage.current = true
            window.location.reload()
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }
   
    const resetFiltersGrid = () => {
            if (gridApiF) {
                gridApiF.setFilterModel(null); // Reset all filters
                gridApiF.onFilterChanged();   // Trigger grid to refresh
            }
          };
    
    // deselect all rows
    const deselectAllRows = () => {
        if (agGridRef.current && agGridRef.current.api) {
            agGridRef.current.api.deselectAll();
        }
    };

    const onClickHideLrUpdateForm = () => {
        setOverlay("show-n")
        setShowUpdateLrForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToUpdate([]);
        deselectAllRows();
        setShowLrUpdateBtn(false);
        setUpdateLrNo("")
        setError1("")
        setManualUpdateLRConsignment({
            lr_no: "",
            invoice_no: "",
            driver_mobile_no: '',
            truck_no: "",
            entity: {label:"", value:""},
            fuel_type:{label:"", value:""},
            vehicle_type: {label:"", value:""},
            other_vehicle_type:"",
            courier_partner:{label:"", value:""},
            other_transporter:{label:"", value:""},
            no_of_boxes: "",
            tracking_type:"",
            total_cbm:"",
            total_weight:"",
            dispatch_time:"",
            tracking_type_mutliple: {label:"", value:""},
            mode: {label:"", value:""},
            eway_bill_no:""

        })
    }
    const onClickHideTransporterUpdateForm = () => {
        setShowUpdateTransporterForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToTransporterUpdate([]);
        deselectAllRows();
        setShowTransporterUpdateBtn(false);
        setError1("")
        setSelectedTransporter({label:"",value:""})
        setEditTransporter(false)

    }
    
    const cancelUpdateLrNo = () => {
        setShowUpdateLrForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToUpdate([]);
        deselectAllRows();
        setShowLrUpdateBtn(false);
        setUpdateLrNo("")
    }
    const cancelUpdateTransporterNo = () => {
        setShowUpdateTransporterForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToTransporterUpdate([]);
        deselectAllRows();
        setShowTransporterUpdateBtn(false);
        setEditTransporter(false)
        setSelectedTransporter({label:"", value:""})
    }
    const viewTypeChange=(e)=>{
        //console.log("change view", e);
        
        setSearchViewType(e)
        // setCounter({ label: "Consignments", value: "Total" })
        setSelectedCounter("Total")
        setTimeout(async () => {

            if(e.value==="LR"){
                if(tabName.value==="active"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: gridColumnState,
                        applyOrder: true,
                    })
                }else if(tabName.value==="completed"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: deliveredGridColumnState,
                        applyOrder: true,
                    })
                }else{
                    await columnApiConsignments.current.applyColumnState({
                
                        state: allGridColumnState,
                        applyOrder: true,
                    })
                }
                
            }else{
                if(tabName.value==="active"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: gridColumnState1,
                        applyOrder: true,
                    })
                }else if(tabName.value==="completed"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: deliveredGridColumnState1,
                        applyOrder: true,
                    })
                }else{
                    await columnApiConsignments.current.applyColumnState({
                
                        state: allGridColumnState1,
                        applyOrder: true,
                    })
                }
                
            }
            
        }, 1500);
    }
    
    const onSubmitLrUpdateForm = (e) => {
        e.preventDefault()
        deselectAllRows();
        const extractedInvoices = selectedInvoicetoUpdateLr.map(e => e.value)
        const extractedShipmentIds = selectedShipments.map(e=> e.value)
        
        var lrNoUpdate =showAddForm === "slider-translate-30p"? manualUploadDetails.lr_no :updatelrNo.trim();
        var data = {
            invoice_no: showAddForm === "slider-translate-30p"? [manualUploadDetails.invoice_no] :extractedInvoices,
            shipment_id: extractedShipmentIds.length> 0 ? extractedShipmentIds:""
            // consignment_code: consignmentCodeForLRUpdate
        }
        // data.invoice_no = JSON.stringify(data.invoice_no);
        // data.shipment_id = JSON.stringify(data.shipment_id);
        var fieldsCheck=true;
        var fieldsCheck1=true;
        
        const mandatoryCheck1 =  updatelrNo !=="" && extractedInvoices.length>0 && manualUpdateLRConsignment.courier_partner?.value !=="" && 
        manualUpdateLRConsignment.tracking_type !=="" && manualUpdateLRConsignment.dispatch_time !=="" && manualUpdateLRConsignment.fuel_type?.value !==""

        var mandatoryCheck= false;
        // if(mandatoryCheck1){
        //     console.log("inside111");

            
        //     if( manualUpdateLRConsignment.tracking_type==="FTL" && manualUpdateLRConsignment.truck_no && manualUpdateLRConsignment.driver_mobile_no &&manualUpdateLRConsignment.vehicle_type.value){
        //         //console.log("inside222");
        //         mandatoryCheck= true
        //     }else if(manualUpdateLRConsignment.tracking_type==="PTL"){
        //         //console.log("inside333");

        //         mandatoryCheck= true
        //     }
        // }else{
        //     mandatoryCheck= false
        // }
        // if(transporterValidation){
        //     //console.log(manualUpdateLRConsignment.courier_partner.value, "tsttttt")
        //     if(
        //         (manualUpdateLRConsignment.courier_partner.value==="") 
        //         && ((driverNoValidation && manualUpdateLRConsignment.driver_mobile_no !=="") || (fuelValidation && manualUpdateLRConsignment.fuel_type ==="") || (truckNoValidation && manualUpdateLRConsignment.truck_no !=="") || (entityValidation && manualUpdateLRConsignment.entity.value !=="") || (vehicleTypeValidation && manualUpdateLRConsignment.vehicle_type.value !=="") || (noOfBoxesValidation && manualUpdateLRConsignment.no_of_boxes !=="") ) ){
        //         fieldsCheck=false;
        //         fieldsCheck1=false;
        //         //console.log("TESTTTTT");

        //     }else if(lrNoUpdate!==""){
        //         if(manualUpdateLRConsignment.courier_partner.value ===""){
        //             //console.log("TEST555");

        //             fieldsCheck=false;
        //         }else{
        //             //console.log("TESTT3");
                    
        //             fieldsCheck=true;
        //         }
        //     }else if (lrNoUpdate ==="" && ((driverNoValidation && manualUpdateLRConsignment.driver_mobile_no ==="") || (fuelValidation && manualUpdateLRConsignment.fuel_type ==="") || (truckNoValidation && manualUpdateLRConsignment.truck_no ==="") || (entityValidation && manualUpdateLRConsignment.entity.value ==="") || (vehicleTypeValidation && manualUpdateLRConsignment.vehicle_type.value ==="") || (noOfBoxesValidation && manualUpdateLRConsignment.no_of_boxes ==="") )){
        //         //console.log("TESTT4");
        //         fieldsCheck=true;
        //     }else if((driverNoValidation && manualUpdateLRConsignment.driver_mobile_no ==="") || (truckNoValidation && manualUpdateLRConsignment.truck_no ==="") || (fuelValidation && manualUpdateLRConsignment.fuel_type ==="") || (entityValidation && manualUpdateLRConsignment.entity.value ==="") || (vehicleTypeValidation && manualUpdateLRConsignment.vehicle_type.value ==="") || (noOfBoxesValidation && manualUpdateLRConsignment.no_of_boxes ==="")){
        //         //console.log("TESTT5");
        //         fieldsCheck=false;
        //         fieldsCheck1=false;
        //     }
        // }
        //console.log(fieldsCheck, "fieldsCheck");
        //console.log(fieldsCheck1, "fieldsCheck1");
        // const invoice_time1 = moment(selectedRows[0].invoice_time);  // Parse the date from your data source
        // const adjustedTime = invoice_time1.subtract(5, 'hours').subtract(30, 'minutes');
        // const invoice_time= adjustedTime.toDate()

        // const selectedDate = new Date(manualUpdateLRConsignment?.dispatch_time);  // The date you're passing to the function
    
        // // Log for debugging
        // //console.log(selectedDate, invoice_time, "selectedDate and invoice_time");
    
        // // Check if the selected date is the same day as the invoice date
        // const isSameDay = selectedDate.toDateString() === invoice_time.toDateString();
        
        // var dispatchTime;
        // if (isSameDay) {
        //     // If the selected date is the same day, ensure the time is greater than or equal to the invoice time
        //     if (selectedDate >= invoice_time) {
        //         // If selected date and time is greater than or equal to invoice time
        //         dispatchTime=manualInTransitStatusUpdate.dispatch_time
        //     } else {
        //         // If selected time is earlier than invoice time
        //         setShow(true);
        //         setTitle("Dispatch time should be greater than or equal to invoice time");
        //         setType("danger");
        //     }
        // } else if (selectedDate > invoice_time) {
        //     // If the selected date is later than the invoice date, it's valid
        //     dispatchTime=manualInTransitStatusUpdate.dispatch_time

        // } else {
        //     // If the selected date is earlier than the invoice date, it's invalid
        //     setShow(true);
        //     setTitle("Dispatch date should be greater than invoice date");
        //     setType("danger");
        //     return;
        // }    
        let validTracking;
        if(manualUpdateLRConsignment?.tracking_type === "FTL/PTL" && ftlValidWeight){
            validTracking = "FTL"
        }else if(manualUpdateLRConsignment?.tracking_type === "FTL/PTL" && ptlValidWeight){
            validTracking = "PTL"
        }else if(manualUpdateLRConsignment?.tracking_type === "FTL/PTL" && (ValidWeight || lRTrackingType==="FTL/PTL")){
            validTracking=manualUpdateLRConsignment?.tracking_type_mutliple?.value
        }else{
           validTracking = manualUpdateLRConsignment?.tracking_type; 
        }
        
        
        var updateData={
            lr_no: showAddForm === "slider-translate-30p"? manualUploadDetails.lr_no :updatelrNo.trim(),

            driver_mobile_no: manualUpdateLRConsignment?.driver_mobile_no || '',
            truck_no: manualUpdateLRConsignment?.truck_no || "",
            entity: manualUpdateLRConsignment?.entity.value || {label: "", value: ""},
            truck_type: manualUpdateLRConsignment?.vehicle_type.value || {label: "", value: ""},
            // other_vehicle_type: manualUpdateLRConsignment?.other_vehicle_type || "",
            transporter_name: manualUpdateLRConsignment?.courier_partner.value || {label: "", value: ""},
            fuel_type:manualUpdateLRConsignment?.fuel_type.value || {label:"", value:""},
            // other_transporter: manualUpdateLRConsignment?.other_transporter || {label: "", value: ""},
            no_of_boxes: manualUpdateLRConsignment?.no_of_boxes || "",
            tracking_type :validTracking,
                            // total_cbm: manualUpdateLRConsignment?.total_cbm || "",
            // total_weight: manualUpdateLRConsignment?.total_weight || "",
            dispatch_date: formatDate1(manualUpdateLRConsignment?.dispatch_time) || "",  // Convert the dispatch time to the desired timezone
            mode:manualUpdateLRConsignment?.mode.value || "",
            eway_bill_no: manualUpdateLRConsignment.eway_bill_no || "",
            email: decode(localStorageEmail),
            source_from: "web"
        }
        if(updateData.vehicle_type === "Others"){
            updateData.vehicle_type = manualUpdateLRConsignment.other_vehicle_type
        }

        const dispatchDate = new Date(manualUpdateLRConsignment?.dispatch_time);
        const invoiceDate = new Date(invoiceDateValueOfUpdateLr);
        

        // var tracking_type1 = tptRecords.filter(e=> e.transporter_name===updateData.transporter_name).map(e=> e.transporter_type)
        // updateData.tracking_type= tracking_type1[0]
        

        if ((driverNoMandatory && !manualUpdateLRConsignment?.driver_mobile_no) || (manualUpdateLRConsignment?.fuel_type.value===undefined) || (noOfBoxesMandatory && !manualUpdateLRConsignment?.no_of_boxes) || (updateData.tracking_type==="") || (manualUpdateLRConsignment.tracking_type_mutliple.value==="FTL" && !manualUpdateLRConsignment.driver_mobile_no) || (manualUpdateLRConsignment.tracking_type_mutliple.value==="FTL" && !manualUpdateLRConsignment.truck_no)||(manualUpdateLRConsignment.tracking_type_mutliple.value==="FTL" && !manualUpdateLRConsignment.vehicle_type.value) || !mandatoryCheck1) {
            // console.error("Driver mobile number is mandatory when driverNoValidation is true.");
            // setShow(true)
            // setTitle("Driver mobile number is mandatory")
            // setType("danger")
            // return; // Exit the function or handle this error appropriately
            
            mandatoryCheck=false;
        }else{
            mandatoryCheck=true;
        }



        Object.keys(updateData).forEach(key => {
            if (updateData[key] && (typeof updateData[key] === 'object' ? updateData[key].value !== "" : updateData[key] !== "")) {
                data[key] = updateData[key];
            }
        })
         
        
        
        
       
        if(dispatchDate> invoiceDate){
            if(mandatoryCheck ){
                // if(fieldsCheck){
                    // if(showAddForm === "slider-translate-30p" || ((invoiceSelected && invoiceSelected.value!=''))){
                        redirectURL.post('/consignments/updateLRno', data).then((resp) => {
                            if (resp.data.status == 'Success') {
                                setTitle("LR details have been successfully updated. Please wait 2 to 5 minutes for the update to reflect.");
                                setShow(true)
                                if(selectedRows.length>1){
                                    setTitle(`LR details have been successfully updated. Please wait 2 to 5 minutes for the update to reflect.`);
                                } else {
                                    setTitle("LR details have been successfully updated. Please wait 2 to 5 minutes for the update to reflect.");
                                }
                                setOverlay("show-n")
                                setType("success");
                                setLoadShow('show-n');
                                setOverlay('show-n');
                                setShowUpdateLrForm('');
                                deselectAllRows();
                                setUpdateLrNo('');
                                setSelectInvoicesToUpdate([]);
                                setError1("");
                                setManualUpdateLRConsignment({
                                    lr_no: "",
                                    invoice_no: "",
                                    driver_mobile_no: '',
                                    truck_no: "",
                                    entity: {label:"", value:""},
                                    vehicle_type: {label:"", value:""},
                                    fuel_type:{label:"", value:""},
                                    other_vehicle_type:"",
                                    courier_partner:{label:"", value:""},
                                    other_transporter:{label:"", value:""},
                                    no_of_boxes: "",
                                    tracking_type:"",
                                    tracking_type_mutliple: {label:"", value:""},
                                    total_cbm:"",
                                    total_weight:"",
                                    dispatch_time:"",
                                     mode: {label:"", value:""},
                                    eway_bill_no:""
                                })
                                
                                // window.location.reload();
                            }else if(resp.data.message =="For invalid records email with remarks will be sent."){
                                setShow(true)
                                setTitle(resp.data.message);
                                setType("warning")
                                setLoadShow('show-n')
                                setOverlay('show-n');
                                setShowUpdateLrForm('');
                                deselectAllRows();
                                setUpdateLrNo('');
                                setSelectInvoicesToUpdate([]);
                                setError1("");
                                setManualUpdateLRConsignment({
                                    lr_no: "",
                                    invoice_no: "",
                                    driver_mobile_no: '',
                                    truck_no: "",
                                    entity: {label:"", value:""},
                                    vehicle_type: {label:"", value:""},
                                    fuel_type:{label:"", value:""},
                                    other_vehicle_type:"",
                                    courier_partner:{label:"", value:""},
                                    other_transporter:{label:"", value:""},
                                    no_of_boxes: "",
                                    tracking_type:"",
                                    tracking_type_mutliple: {label:"", value:""},
                                    total_cbm:"",
                                    total_weight:"",
                                    dispatch_time:"",
                                     mode: {label:"", value:""},
                                    eway_bill_no:""
                                })
                            }

                            else{
                                setShow(true)
                                setTitle(resp.data.message)
                                setType("danger")
                                setLoadShow('show-n')
                                setOverlay('show-n');
                                // setShowUpdateLrForm('');
                                // deselectAllRows();
                                // setUpdateLrNo('');
                                // setSelectInvoicesToUpdate([]);
                            }
                        })
                    // }
                    // else if(!invoiceSelected){
                    //     setShow(true)
                    //     setTitle("Please Selected Invoice")
                    //     setType("danger")
                    //     setLoadShow('show-n')
                    //     setOverlay('show-n')
                    // } 
                    // else {
                    //     setShow(true)
                    //     setTitle("Please Enter Lr'no")
                    //     setType("danger")
                    //     setLoadShow('show-n')
                    //     setOverlay('show-n')
                    // }
                // }else{
                //     if(fieldsCheck1){
                //         setTitle("Please select transporter as LR No provided");
                //     }else{
                //         setTitle("Please select transporter first as relevant fields are provided");
                //     }
                //     setShow(true);
                //     setType("danger")
                // }
            }else{
                setShow(true)
                setTitle("Please fill all the mandatory field's")
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n')
            }
        }else{
            setShow(true)
                setTitle("Dispatch Date should be greater than invoice date")
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n')
        }
        
        
       
        
       
        
        // setShowUpdateLrForm('');
        // deselectAllRows();
        // setUpdateLrNo('');
        // setSelectInvoicesToUpdate([]);
    }  
    const onSubmitTransporterUpdateForm = async(e) => {
        e.preventDefault()
        deselectAllRows();
        const extractedInvoices = Array.isArray(selectInvoicesToTransporterUpdate) ? selectInvoicesToTransporterUpdate.map(e => e.value): [selectInvoicesToTransporterUpdate.value]
        // const extractedShipmentIds = Array.isArray(selectedTransporterShipments) ? selectedTransporterShipments.map(e=> e.value) : [selectedTransporterShipments.value]
        
        var data = {
            invoice_no: extractedInvoices,
            // shipment_id: extractedShipmentIds.length> 0 ? extractedShipmentIds:"",
            transporter_name: selectedTransporter.value,
            email: decode(localStorageEmail)
            // consignment_code: consignmentCodeForLRUpdate
        }
        
        if(selectedTransporter.value !== ""){
            await redirectURL.post('/consignments/updateTransporterName', data).then((resp) => {
                if (resp.data.status == 'Success') {
                    setTitle("Transporter has been successfully assigned.");
                    setShow(true)
                    if(selectedRows.length>1){
                        setTitle(`Transporter has been successfully assigned.`);
                    } else {
                        setTitle("Transporter has been successfully assigned.");
                    }
                    
                    setType("success");
                    setLoadShow('show-n');
                    setOverlay('show-n');
                    setShowUpdateTransporterForm('');
                    deselectAllRows();
                    setSelectInvoicesToTransporterUpdate([]);
                    setError1("");
                    setSelectedTransporter({label:"", value:""})
                    
                    // window.location.reload();
                }
                else{
                    setShow(true)
                    setTitle("Please Upload Valid Details")
                    setType("danger")
                    setLoadShow('show-n')
                    setOverlay('show-n');
                    // setShowUpdateLrForm('');
                    // deselectAllRows();
                    // setUpdateLrNo('');
                    // setSelectInvoicesToUpdate([]);
                }
            })
        }else{
            setShow(true)
            setTitle("Please fill the mandatory field's")
            setType("danger")
            setLoadShow('show-n')
            setOverlay('show-n')
        }
       
    }  
    
    function onSelectionChanged(params) {
        setTimeout(async () => {

            if(searchViewType.value ==="LR"){

                if(tabName.value==="active"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: gridColumnState,
                        applyOrder: true,
                    })
                }else if(tabName.value==="completed"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: deliveredGridColumnState,
                        applyOrder: true,
                    })
                }else{
                    await columnApiConsignments.current.applyColumnState({
                
                        state: allGridColumnState,
                        applyOrder: true,
                    })
                }           
             }else{
                if(tabName.value==="active"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: gridColumnState1,
                        applyOrder: true,
                    })
                }else if(tabName.value==="completed"){
                    await columnApiConsignments.current.applyColumnState({
                
                        state: deliveredGridColumnState1,
                        applyOrder: true,
                    })
                }else{
                    await columnApiConsignments.current.applyColumnState({
                
                        state: allGridColumnState1,
                        applyOrder: true,
                    })
                } 
             }
           
        }, 1500);
        const selectedNodes = params.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => node.data);
        setSelectedRows(selectedData);
    };
    const formForceCloseHandler = (e) => {
        e.preventDefault()
        var consignemnt = rownode;
        var consignment_code = consignemnt.consignment_code;
        var truck_no = consignemnt.truck_no;
        var dept_code = "SNDG";
        var email = user?.email;
        var username = user?.username;
        var reqdata = {
            truck_no: rownode.data.truck_no,
            shipment_ids: JSON.stringify([rownode.data.shipment_id]),
            username: username,
            user_email: email,
            reasonforceclose: reasonForceClose,
        }
        if(reqdata.reasonforceclose.trim()===""){
            setShow(true)
            setTitle("Please Enter The Reason")
            setType("danger")
        } else {
            redirectURL.post("/consignments/updateConsignmentForceClose", reqdata)
                .then((response) => {
                    if (response.data.status == 'Success') {
                        setShow(true)
                        setTitle("Successfully Force Closed the consignment")
                        setType("success")
                        closeForceCloseModal()
                        reloadPage.current = true
                    }
                    else {
                        setShow(true)
                        setTitle("Failed to Force Close")
                        setType("danger")
                    }
                })
                .catch(function (e) {
                    //console.log("Error ", e)
                })
        }

    }
    // const processForceCloseHandler = async (e) => {
    //     e.preventDefault();

    //     if (!reasonForceClose.trim()) {
    //         setShow(true);
    //         setTitle("Please enter a reason");
    //         setType("danger");
    //         return;
    //     }

    //     const selectedInvoiceValues = selectedInvoices.map(item => item.value);

    //     const payload = {
    //         lr_no: rownode?.lr_no || rownode?.data?.lr_no || "",
    //         shipment_id: rownode?.shipment_id || rownode?.data?.shipment_id || "",
    //         tracking_type: rownode?.tracking_type || rownode?.data?.tracking_type || "",
    //         reason: reasonForceClose,
    //         user: user?.username || decode(localStorage || ""),
    //         email: user?.email || decode(localStorage || ""),
    //         invoice_nos: selectedInvoiceValues
    //     };

    //     console.log("Sending Force Close Payload:", payload);

    //     try {
    //         const resp = await redirectURL.post("/consignments/forceCloseShipment", payload);

    //         if (resp?.data?.status === "success") {
    //             setShow(true);
    //             setTitle("Shipment successfully force closed");
    //             setType("success");
    //             setForcecloseModal(false);
    //             if (reloadPage && typeof reloadPage === "object") reloadPage.current = true;
    //         } else {
    //             setShow(true);
    //             setTitle(resp?.data?.message || "Force close failed");
    //             setType("danger");
    //         }
    //     } catch (err) {
    //         console.error("Force close error:", err);
    //         setShow(true);
    //         setTitle("Something went wrong");
    //         setType("danger");
    //     }
    // };
    const processForceCloseHandler = async (e) => {
        e.preventDefault();

        if (!reasonForceClose.trim()) {
            setShow(true);
            setTitle("Please enter a reason");
            setType("danger");
            return;
        }

        const userRole = (decodedRoleCase || "").toLowerCase();
        if ((userRole === "transporter"|| userRole === "warehouse" || userRole === "wh-outbound") && rownode?.created_date) {
            try {
                const formattedDate = getHyphenDDMMMYYYYHHMM(rownode.created_date);
                let createdTime = null;

                const match = formattedDate.match(
                    /(\d{1,2})-([A-Za-z]{3})-(\d{4}) (\d{1,2}):(\d{2})/
                );
                if (match) {
                    const [_, day, mon, year, hour, minute] = match;
                    const months = {
                        Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                        Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
                    };
                    createdTime = new Date(
                        parseInt(year),
                        months[mon],
                        parseInt(day),
                        parseInt(hour),
                        parseInt(minute),
                        0
                    );
                }

                const now = new Date();
                const expiryTime =
                    createdTime instanceof Date && !isNaN(createdTime)
                        ? new Date(createdTime.getTime() + 24 * 60 * 60 * 1000)
                        : null;

                if (expiryTime && now.getTime() > expiryTime.getTime()) {
                    setShow(true);
                    setTitle("This Cancel LR option is disabled. Please contact the Admin.");
                    setType("danger");
                    setForcecloseModal(false);
                    return;
                }
            } catch (err) {
                console.error("Time validation error:", err);
            }
        }

        const selectedInvoiceValues = selectedInvoices.map(item => item.value);

        const payload = {
            lr_no: rownode?.lr_no || rownode?.data?.lr_no || "",
            shipment_id: rownode?.shipment_id || rownode?.data?.shipment_id || "",
            tracking_type: rownode?.tracking_type || rownode?.data?.tracking_type || "",
            reason: reasonForceClose,
            user: user?.username || decode(localStorage || ""),
            email: user?.email || decode(localStorage || ""),
            invoice_nos: selectedInvoiceValues
        };

        console.log("Sending Force Close Payload:", payload);

        try {
            const resp = await redirectURL.post("/consignments/forceCloseShipment", payload);

            if (resp?.data?.status === "success") {
                setShow(true);
                setTitle("LR successfully cancelled.");
                setType("success");
                setForcecloseModal(false);
                if (reloadPage && typeof reloadPage === "object") reloadPage.current = true;
            } else {
                setShow(true);
                setTitle(resp?.data?.message || "LR cancel failed");
                setType("danger");
            }
        } catch (err) {
            console.error("Force close error:", err);
            setShow(true);
            setTitle("Something went wrong");
            setType("danger");
        }
    };
    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };
    // async onClickShowShipmentLegs(params) {
	// 	//console.log("params", params)
	// 	if (params != 0) {
	// 		var transitedelaydata = [];

	// 		await this.setState({

	// 			detailCellRendererParams: {
	// 				suppressRefresh: true,
	// 				detailGridOptions: {
	// 					headerHeight: 50,
	// 					columnDefs: [
	// 						{
	// 							headerName: "",
	// 							field: "legs_map",
	// 							colId: "legs_map",
	// 							width: 40,
	// 							pinned: 'left',
	// 							cellRenderer:function(params){
	// 								var htmloption = '<i class="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
	// 								return htmloption;
	// 							} ,
	// 							filter: false, resizable: true
			
	// 						},
	// 						{
	// 							headerName: "Invoice No",
	// 							field: "invoice_no",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Consignment",
	// 							field: "consignment_code",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Original ETA",
	// 							field: "expected_eta",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}
	// 							},

	// 						},
	// 						{
	// 							headerName: "Revised ETA",
	// 							field: "revised_eta",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}

	// 							}
	// 						},
							
	// 						{
	// 							headerName: "Status",
	// 							field: "status",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// },
								

	// 							valueGetter: function (params) {
	// 								////console.log("GPS ", params.data.gps_data_available);
	// 								if (params.data.status == 1) {
	// 									return "Inside Plant"
	// 								}
	// 								else if (params.data.status == 2) {
	// 									return "In Transit"
	// 								}
	// 								else if (params.data.status == 3) {
	// 									return "Near Destination"
	// 								}
	// 								else if (params.data.status == 4) {
	// 									return "Reached Destination"
	// 								}

	// 								else if (params.data.status == 5) {
	// 									return "Left Destination"
	// 								}
	// 								else if (params.data.status == 6) {
	// 									return "Force Closed"
	// 								}
	// 								else if (params.data.status == 8) {
	// 									return "Crossdock"
	// 								}else if(params.data.status == 9){
	// 									return "Trip Completed"
	// 								}
	// 								else {
	// 									return ""
	// 								}

	// 							}
	// 						},
	// 						{
	// 							headerName: "Zone",
	// 							field: "zone",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
							
	// 						{
	// 							headerName: "Dealer Code",
	// 							field: "consignee_code",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Dealer City",
	// 							field: "consignee_city",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},

	// 						{
	// 							headerName: "Dealer Name",
	// 							field: "consignee_name",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Trip Distance (KM)",
	// 							field: "distance_in_km",
	// 							width: 120,
	// 							resizable: true,
	// 							valueGetter: params =>{
	// 								if(params.data.distance_in_km>0){
	// 									return params.data.distance_in_km
	// 								}else{
	// 									return 0
	// 								}
	// 							}
	// 							,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Distance from Dealer (KM)",
	// 							field: "distance_from_dealer_location",
	// 							width: 160,
	// 							valueGetter: function (params) {
	// 								if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
	// 									return params.data.distance_from_dealer_location;
	// 								}
	// 								else {
	// 									return "";
	// 								}
	// 							},
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Reached Destination At",
	// 							field: "first_dealer_reported",
	// 							width: 180,


	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Left Destination At",
	// 							field: "left_dealer_marked",
	// 							width: 180,
	// 							//filter: "agDateColumnFilter",
	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 5) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Transit Time (Days)",
	// 							field: "transit_time",
	// 							width: 200,
	// 							filter: "agSetColumnFilter",
	// 							cellRenderer: '', resizable: true
	// 						},
							
	// 					],
	// 					overlayNoRowsTemplate: 'No rows to show',
	// 					onCellClicked:(leg_params) =>{
	// 						if(leg_params.colDef.field =="legs_map"){
	// 							if(leg_params.data.status==8){
	// 								this.setState({
	// 									show: true,
	// 									basicTitle: 'No Route data available',
	// 									basicType: "danger",
	// 									loadshow: 'show-n'
	// 								});
	// 							}else{
								
	// 								var leg_params = leg_params.data
	// 								this.setState({
	// 									loadshow: 'show-m',
	// 									maptruckno: leg_params.truck_no
	// 								});
							
	// 								// If gateouttime is current time - It shows "No Route data available"
	// 								if (leg_params.invoice_time) {
	// 									var gateouttime = moment.parseZone(leg_params.invoice_time).format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								else {
	// 									if (leg_params.gate_in_time) {
	// 										var gateouttime = moment.parseZone(leg_params.gate_in_time).format('YYYY-MM-DD HH:mm:ss');
	// 									}
	// 									else {
	// 										if (leg_params.gate_out_time) {
	// 											var gateouttime = moment.parseZone(leg_params.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
	// 										}
	// 									}
	// 								}
							
	// 								var edate = '';
	// 								var end_date;
	// 								if (leg_params.status <= 2) {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}
	// 								else if (leg_params.status == 3 || leg_params.status == 4) {
	// 									if (leg_params.recent_dealer_reported) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 										end_date = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 									}
	// 								}
	// 								else if (leg_params.status == 5) {
	// 									if (leg_params.left_dealer_marked) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 										end_date =  getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 									}
	// 								}
	// 								else if (leg_params.status == 6) {
	// 									if (leg_params.force_closure_time) {
	// 										let splitT = leg_params.force_closure_time.split('T')
	// 										let yMD = splitT[0]
	// 										let hMS = splitT[1]
	// 										let hms1 = hMS.split('.')
	// 										let finalHms = hms1[0]
	// 										let final_end_date = yMD + ' ' + finalHms
	// 										end_date = final_end_date;
	// 										edate = final_end_date
	// 									}
	// 								}
	// 								else {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}							
	// 								if ((leg_params.transit_time) > 0) {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + ((leg_params.transit_time + 1) * 24 * 60 * 60 * 1000));
	// 								}
	// 								else {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
	// 								}
							
	// 								var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();
							
	// 								if (!end_date) {
	// 									// When end date is unavailable then current date is considered as end date.
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								var reqData = {
	// 									truck_no: leg_params.truck_no,
	// 									consignment_code: leg_params.invoice_no,
	// 									consignee_code: leg_params.consignee_code,
	// 									gate_out_time: gateouttime,
	// 									seconddate: end_date,
	// 									screen: "consignment"
	// 								}
	// 								if (["2", "3", "4"].includes(leg_params.status)) reqData.mapMode = 2
							
	// 								redirectURL.post('/consignments/maproutes', reqData, {
	// 									headers: {
	// 										'content-type': 'application/json'
	// 									}
	// 								})
	// 									.then((response) => {
	// 										var records = response.data;
	// 										//console.log(records,"record3535")
	// 										this.setState({
	// 											loadshow: 'show-m'
	// 										});
	// 										try {
	// 											if (records.coords.length == 0 || records.status == "failure") {
	// 												this.setState({
	// 													show: true,
	// 													basicTitle: 'No Route data available',
	// 													basicType: "danger",
	// 													loadshow: 'show-n'
	// 												});
	// 											}
	// 											else {
	// 												if (records != '') {
	// 													var sdate = leg_params.gate_out_time;
	// 													if (leg_params.invoice_time) {
	// 														var sdate = leg_params.invoice_time;
	// 													}
	// 													else {
	// 														if (leg_params.gate_in_time) {
	// 															var sdate = leg_params.gate_in_time;
	// 														}
	// 														else {
	// 															if (leg_params.gate_out_time) {
	// 																var sdate = leg_params.gate_out_time;
	// 															}
	// 														}
	// 													}
							
							
	// 													var edate = '';
	// 													var end_date = ""
	// 													//console.log(leg_params.recent_dealer_reported , "recent_dealer_reported")
	// 													if (leg_params.status < 4) {
	// 														end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 														edate = getHyphenDDMMYYYYHHMMSS(end_date);
							
	// 													}
	// 													else if (leg_params.status == 4 ) {
	// 														//console.log("end_time", leg_params)
	// 														edate = getHyphenDDMMYYYYHHMMSS(leg_params.end_time);
	// 														end_date = leg_params.recent_dealer_reported
	// 													}
	// 													else if (leg_params.status == 5) {
	// 														if (leg_params.left_dealer_marked) {
	// 															edate = getHyphenDDMMYYYYHHMMSS(leg_params.left_dealer_marked);
	// 															end_date = leg_params.left_dealer_marked
							
	// 														}
	// 														else {
	// 															end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 															edate = getHyphenDDMMYYYYHHMMSS(end_date);
	// 														}
	// 													}
	// 													if (leg_params.deviation_flag == 1 && this.state.deptcode == "LOG-PRT") {
	// 														var params = {
	// 															"base_route_id": leg_params.base_route_id
	// 														}
	// 														redirectURL.post("/consignments/getLiveRouteDeviationBaseRoute",
	// 															params).then((resp) => {
	// 																this.setState({
	// 																	sliderRouteTranslate: "slider-translate-60p",
	// 																	showDiv: 'show-m',
	// 																	mapinfo: records,
	// 																	dealer: leg_params.consignee_code,
	// 																	consignment_code: "Truck No : " + leg_params.truck_no,
	// 																	maptruckno: leg_params.truck_no,
	// 																	routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 																	loadshow: 'show-n',
	// 																	sidebarSubHeader: "Consignment Information",
	// 																	overly: 'show-m',
	// 																	rownode: leg_params,
	// 																	leg_no: 0,
	// 																	tolls: records.tolls,
	// 																	baseRouteCoords: resp.data.alteredHeroPRTBaseRoute,
	// 																	devation_flag: true
	// 																});
	// 																this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 																this.renderMap();
	// 															})
	// 													}
	// 													else {
	// 														this.setState({
	// 															sliderRouteTranslate: "slider-translate-60p",
	// 															showDiv: 'show-m',
	// 															mapinfo: records,
	// 															dealer: leg_params.consignee_code,
	// 															consignment_code: "Invoice No : " + leg_params.invoice_no,
	// 															maptruckno: leg_params.truck_no,
	// 															routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 															loadshow: 'show-n',
	// 															sidebarSubHeader: "Consignment Information",
	// 															overly: 'show-m',
	// 															rownode: leg_params,
	// 															leg_no: 0,
	// 															tolls: records.tolls
	// 														});
	// 														this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 														this.renderMap();
	// 													}
	// 												}
	// 											}
	// 										}
	// 										catch (e) {
	// 											this.setState({
	// 												show: true,
	// 												basicTitle: 'No Route data available',
	// 												basicType: "danger",
	// 												loadshow: 'show-n'
	// 											});
	// 										}
							
	// 									})
	// 									.catch(function (error) {
	// 										//console.log(error);
	// 									});
	// 							}
	// 						}
	// 					}
	// 				},
	// 				getDetailRowData: function (params) {
	// 					//console.log("Step 4 ", transitedelaydata)
	// 					//console.log("Step 4 ", params)
	// 					redirectURL.post('/consignments/getShipmentDetails', {
	// 						shipment_id: params.data.shipment_id
	// 					})
	// 						.then(async (response) => {
	// 							//console.log(response.data , "srinu")
	// 							params.successCallback(response.data || []);
	// 							////console.log("Step 2 ",response.data)

	// 						});

	// 				}
	// 			}
	// 		});

	// 		//if( params.column.colId == 'transit_delay' || params.column.colId == 'transit_delay_1' ||   params.column.colId == 'no_gps_data' || params.column.colId == 'no_gps_data_1')
	// 		if (params.column.colDef.field == 'shipmentlegs') {
	// 			params.node.setExpanded(!params.node.expanded);
	// 			////console.log("expanded ",params.node.expanded)
	// 			if (params.node.expanded == false) {
	// 				transitedelaydata = []
	// 			}
	// 		}
	// 		else {

	// 			params.node.setExpanded(false);
	// 		}
	// 		////console.log("detailCellRendererParams ", this.state.detailCellRendererParams);

	// 	}

	// }
// })};
    // const handleCellClick = (leg_params) => {
    //     setLoadshow('show-m');
    //     setMaptruckno(leg_params.data.truck_no);

    //     let gateouttime = getGateOutTime(leg_params.data);

    //     let end_date = getEndDate(leg_params.data);
    //     let edate = getHyphenYYYYMMDDHHMMSS(end_date);

    //     let sdate = getSecondDate(leg_params.data);

    //     if (!end_date) {
    //         end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
    //         edate = getHyphenYYYYMMDDHHMMSS(end_date);
    //     }

    //     const reqData = {
    //         truck_no: leg_params.data.truck_no,
    //         consignment_code: leg_params.data.invoice_no,
    //         consignee_code: leg_params.data.consignee_code,
    //         gate_out_time: gateouttime,
    //         seconddate: end_date,
    //         screen: "consignment"
    //     };

    //     if (["2", "3", "4"].includes(leg_params.data.status)) reqData.mapMode = 2;

    //     redirectURL.post('/consignments/maproutes', reqData, {
    //         headers: {
    //             'content-type': 'application/json'
    //         }
    //     })
    //         .then(response => handleRouteResponse(response, leg_params.data))
    //         .catch(error => console.error(error));
    // };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };

    const onShowCourierTrack = async (params) => {
        try {
            const lateDeliveryRemarks = params.data.late_delivery_remarks;
            const actualDeliveryDatetime = params.data.actual_delivery_date;
            const consignmentStatus = params.data?.consignment_status;
            const undeliveredRemarks = params.data.un_delivery_remark;
            const expected_eta = params.data?.expected_eta;
            const revised_eta = params.data?.revised_eta;
            const status = params.data?.status;
            let remarks = "";
            let undelivered_remarks = ""
            if (
                (consignmentStatus === "Delivered" ||
                    statusMap[status] === "Delivered" ||
                    [5, 8].includes(status)) &&
                actualDeliveryDatetime &&
                lateDeliveryRemarks?.trim()
            ) {
                remarks = lateDeliveryRemarks.trim();
            }
            if (
                (consignmentStatus === "Undelivered" ||
                    statusMap[status] === "Undelivered" ||
                    [11].includes(status)) &&
                undeliveredRemarks?.trim()
            ) {
                undelivered_remarks = undeliveredRemarks.trim();
            }
            const response = await redirectURL.post('/consignments/trackcourier', { consignment_code: params.data.consignment_code, shipment_id: params.data.shipment_id });
            if (response.data.consignments?.length > 0) {
                const updatedRecords = response.data.consignments.map(item => {
                    if ((item.status == "Delivered" || item.intransit_status == "Delivered") && remarks) {
                        return { ...item, late_delivery_remarks: remarks};
                    }
                    if((item.status == "Undelivered" || item.intransit_status == "Undelivered") && undeliveredRemarks){
                        return { ...item, undeliveredRemarks};
                    }
                    // setExpectedTripEnd(expected_eta ? expected_eta : "");
                    // setRevisedTripsEnd(revised_eta ? revised_eta : "");
                    setExpectedTripEnd(expected_eta || "");

                    const gridDeliveryDate = params.colDef?.valueGetter
                        ? params.colDef.valueGetter(params)
                        : params.data?.delivery_datetime;

                    let finalDeliveryDate = "";
                    if (params.data?.delivery_datetime) {
                        const dateOnly = params.data.delivery_datetime.split("T")[0];
                        finalDeliveryDate = `${dateOnly}T23:59:59`;
                    } else if (gridDeliveryDate) {
                        const dateOnly = gridDeliveryDate.split("T")[0];
                        finalDeliveryDate = `${dateOnly}T23:59:59`;
                    } else if (params.data?.actual_delivery_date) {
                        finalDeliveryDate = params.data.actual_delivery_date;
                    } else if (revised_eta) {
                        finalDeliveryDate = revised_eta;
                    }

                    setRevisedTripsEnd(finalDeliveryDate || "");

                    setActualDeliveryDate(params.data?.actual_delivery_date || "");
                    setDeliveryDate(params.data?.delivery_date || "");


                    return item;
                });
                setTimelineData(updatedRecords);
                setShowModal(true);

            }
        } catch (error) {
            console.error("Error fetching consignment data: ", error);
        }
    };
    const onShowFtlTrack = async (params) => {
        try {
            const lateDeliveryRemarks = params.data.late_delivery_remarks;
            const actualDeliveryDatetime = params.data.actual_delivery_date;
            const undeliveredRemarks = params.data.un_delivery_remark;
            const consignmentStatus = params.data?.consignment_status;
            const status = params.data?.status;
            const expected_eta = params.data?.expected_trip_end;
            const revised_eta = params.data?.revised_trip_end;
            let remarks = "";
            let undelivered_remarks = ""
            if (
                (consignmentStatus === "Delivered" ||
                    statusMap[status] === "Delivered" ||
                    [5, 8].includes(status)) &&
                actualDeliveryDatetime &&
                lateDeliveryRemarks?.trim()
            ) {
                remarks = lateDeliveryRemarks.trim();
            }
            if (
                (consignmentStatus === "Undelivered" ||
                    statusMap[status] === "Undelivered" ||
                    [11].includes(status)) &&
                undeliveredRemarks?.trim()
            ) {
                undelivered_remarks = undeliveredRemarks.trim();
            }
            const response = await redirectURL.post('/consignments/trackftlconsignments', { shipment_id: params.data.shipment_id });
            if (response.data.consignments?.length > 0) {
                const updatedRecords = response.data.consignments.map(item => {
                    if ((item.status == "Delivered" || item.intransit_status == "Delivered") && remarks) {
                        return { ...item, late_delivery_remarks: remarks};
                    }
                    if((item.status == "Undelivered" || item.intransit_status == "Undelivered") && undeliveredRemarks){
                        return { ...item, undeliveredRemarks};
                    }
                    // setExpectedTripEnd(expected_eta || "");
                    // if (params.data?.delivery_datetime) {
                    //     setRevisedTripsEnd(params.data.delivery_datetime);
                    // } else if (params.data?.actual_delivery_date) {
                    //     setRevisedTripsEnd(params.data.actual_delivery_date);
                    // } else if (revised_eta) {
                    //     setRevisedTripsEnd(revised_eta);
                    // } else {
                    //     setRevisedTripsEnd("");
                    // }
                    // setActualDeliveryDate(params.data?.actual_delivery_date || "");
                    // setDeliveryDate(params.data?.delivery_date || "");      
                    setExpectedTripEnd(expected_eta || "");

                    const gridDeliveryDate = params.colDef?.valueGetter
                        ? params.colDef.valueGetter(params)
                        : params.data?.delivery_datetime;

                    let finalDeliveryDate = "";
                    if (params.data?.delivery_datetime) {
                        const dateOnly = params.data.delivery_datetime.split("T")[0];
                        finalDeliveryDate = `${dateOnly}T23:59:59`;
                    } else if (gridDeliveryDate) {
                        const dateOnly = gridDeliveryDate.split("T")[0];
                        finalDeliveryDate = `${dateOnly}T23:59:59`;
                    } else if (params.data?.actual_delivery_date) {
                        finalDeliveryDate = params.data.actual_delivery_date;
                    } else if (revised_eta) {
                        finalDeliveryDate = revised_eta;
                    }

                    setRevisedTripsEnd(finalDeliveryDate || "");

                    setActualDeliveryDate(params.data?.actual_delivery_date || "");
                    setDeliveryDate(params.data?.delivery_date || "");


                    return item;
                });
                setTimelineData(updatedRecords);
                setShowModal(true); // Show modal on success
            }
        } catch (error) {
            console.error("Error fetching consignment data: ", error);
        }
    };

    const onCloseModal = () => {
        setShowModal(false); // Close the modal
        if(trackingTimeline){
            setTrackingTimeline(prev=> !prev)
        }
    };


    const onShowTransitRouteMap = (rownode) => {
        var d = new Date(rownode.leg_start);
        var r = new Date(rownode.leg_end_eta);
        var fintance = rownode.leg_start.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.leg_end_eta.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No Tracking data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';

                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        // consignment_code: "Vehicle No. : " + rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                //console.log(error);
            });

    }
    const onShowEnrouteRouteMap = (rownode) => {
        var fintance = rownode.stoppage_start_time.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        if (rownode.reset_datetime) {
            var eintance = rownode.reset_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        }
        else {
            var eintance = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                let records = response.data
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    if (response.data.route_details.start_time != "" && response.data.route_details.start_time != undefined) {
                        sdate = records.route_details.start_time;
                    }
                    if (response.data.route_details.end_time != "" && response.data.route_details.end_time != undefined) {
                        edate = records.route_details.end_time;
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        // consignment_code: "Vehicle No. : " + rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                //console.log(error);
            });
    }
    const onShowNightDriveRouteMap = (rownode) => {
        var fintance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        // consignment_code: rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        defTransitCoords: { "lat": rownode.first_lat, "lng": rownode.first_lng },
                        maptruckno: rownode.truck_no,
                        routeTruck: {
                            "truck_no": rownode.truck_no, "startTime": response.data['route_details']['start_time'],
                            "endTime": response.data['route_details']['end_time']
                        },
                        loadshow: 'show-n',
                        tolls: response.data.tolls
                    })
                }
            })
            .catch(function (error) {
                //console.log(error);
            });

    }
    const onShowRouteMap = (rownode) => {
        var d = new Date(rownode.first_instance);
        var r = new Date(rownode.recent_instance);
        var finstance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var rinstance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: finstance,
            recent_instance: rinstance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/overspeedgpsroutes', params)
            .then((response) => {
                setOpenMap({
                    overly: "show-m",
                    sliderRouteTranslate: "slider-translate-60p",
                    mapinfo: response.data,
                    dealer: rownode.consignee_code,
                    // consignment_code: "Vehicle No. : " + rownode.truck_no,
                    lr_no: "LR No. : "+ rownode.lr_no,
                    maptruckno: rownode.truck_no,
                    routeTruck: { "truck_no": rownode.truck_no, "startTime": finstance, "endTime": rinstance },
                    loadshow: 'show-n',
                    sidebarSubHeader: "Consignment Leg Information",
                    overly: 'show-m',
                    rownode: rownode,
                    leg_no: rownode.leg_no,
                    tolls: response.data.tolls,
                    defTransitCoords: rownode.consignee_coordinates,
                })
            })
            .catch(function (error) {
                //console.log(error);
            });
    }
    const onShowNoGPSRouteMap = (rownode) => {
        var fintance = rownode.last_packet_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        eintance = eintance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim()
        if ((rownode.hasOwnProperty("exception_closed") && rownode.exception_closed == 1) || rownode.hasOwnProperty("packet_received_on"))
            eintance = rownode.packet_received_on.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        // consignment_code: "Vehicle No. : " + rownode.truck_no,
                        lr_no: "LR No. : "+ rownode.lr_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                //console.log(error);
            });


    }
    const onClickOpenBulkUploadModal = (e) => {
        setOverlay("show-m")
        setBulkUploadModal({
            overly: "show-m",
            bulkPrioritySlide: "slider-translate-84p"
        })
    }
    const closeBulkUploadModal = () => {
        setFile(null); 

        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setModalLoadData([])
        setLoadshowBulkupload("show-n")

    }
    const onClickHideManualUpload2 = () => {
        setshowAddForm2("");
        setUploadPODTracking(false)

        setOverlay("show-n");        
        setManualInTransitStatusUpdate((prev)=>({
            ...prev,
            dispatch_time: ""
        }))
        setForm2Details({
            event_status:statusOrderFtl,
            selectedStatus: { label: 'In Transit', value: 'In Transit' }, // Add a new state variable to store the selected status
            selectedPincode: {label:'', value:''},
            event_location: "",
            remark: {label:"", value:""},
            reason_for_delay:{label:"", value:""},
            delivered_date:new Date(),
            delivered_time:new Date(),
            errorMessage:''
            })
      };
      const onClickHideManualUpload4 = () => {
        setshowBulkUpdateForm("");
        setUploadPODTracking(false)
        setOverlayBulkUpdate("show-n")
        setFile1(null); 
        setLoadshowBulkUpdate("show-n")

        
        setOverlay("show-n")
        setModalBulkUpdateData([])      
        // setManualInTransitStatusUpdate((prev)=>({
        //     ...prev,
        //     dispatch_time: ""
        // }))
        // setForm2Details({
        //     event_status: statusOrderPtl,
        //     selectedStatus: {value: 'In Transit', label: 'In Transit'},
        //     selectedPincode: {value: '', label: ''},
        //     event_location: "",
        //     remark: "",
        //     delivered_date:'',
        //     errorMessage:''
        // })
      };
      const onClickHideManualUpload5 = () => {
        setshowBulkTransporterForm("");
        // setUploadPODTracking(false)

        setFile2(null); 
        setLoadshowBulkTpt("show-n")
        setOverlayBulkTpt("show-n")
        
        setOverlay("show-n")
        setModalBulkTransporterData([])      
        // setManualInTransitStatusUpdate((prev)=>({
        //     ...prev,
        //     dispatch_time: ""
        // }))
        // setForm2Details({
        //     event_status: statusOrderPtl,
        //     selectedStatus: {value: 'In Transit', label: 'In Transit'},
        //     selectedPincode: {value: '', label: ''},
        //     event_location: "",
        //     remark: "",
        //     delivered_date:'',
        //     errorMessage:''
        // })
      };
      const onClickHideManualUpload6 = () => {
        setshowBulkLRForm("");
        setFile3(null); 
        setOverlay("show-n")
        setModalBulkLRData([])   
        setLoadshowBulkLr("show-n")
        setOverlayBulkUpload("show-n")   
      };

    const onClickHideManualUpload7 = () => {
        setshowBulkUpdateDeliveryForm("");
        setUploadPODTracking(false)
        setOverlayBulkDeliveryUpdate("show-n")
        setFile4(null);
        setLoadshowBulkDeliveryUpdate("show-n")
        setOverlay("show-n")
        setModalBulkDeliveryData([])
    };
    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            lr_no: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setMapDetails()
    }
    var lrBasedSegData = [];
    

    useEffect(() => {
        if ((gridColumnState.length > 0 || gridColumnState1.length > 0 || deliveredGridColumnState.length>0 || allGridColumnState.length>0 || deliveredGridColumnState1.length>0 || allGridColumnState1.length>0 || tptGridColumnState.length>0 || invoiceGridColumnState.length>0) && columnApiConsignments.current) {
            //console.log("test22")
            // columnApiConsignments.current.applyColumnState({
            //     state: gridColumnState,
            //     applyOrder: true,
            // })
            setTimeout(async () => {
                if(tabName.value!=="inactive" && tabName.value!=="transporter"){
                    if(searchViewType.value ==="LR"){
    
                        if(tabName.value==="active"){
                            await columnApiConsignments.current.applyColumnState({
                        
                                state: gridColumnState,
                                applyOrder: true,
                            })
                        }else if(tabName.value==="completed"){
                            await columnApiConsignments.current.applyColumnState({
                        
                                state: deliveredGridColumnState,
                                applyOrder: true,
                            })
                        }else{
                            await columnApiConsignments.current.applyColumnState({
                        
                                state: allGridColumnState,
                                applyOrder: true,
                            })
                        }          
                     }else{
                        if(tabName.value==="active"){
                            await columnApiConsignments.current.applyColumnState({
                        
                                state: gridColumnState1,
                                applyOrder: true,
                            })
                        }else if(tabName.value==="completed"){
                            await columnApiConsignments.current.applyColumnState({
                        
                                state: deliveredGridColumnState1,
                                applyOrder: true,
                            })
                        }else{
                            await columnApiConsignments.current.applyColumnState({
                        
                                state: allGridColumnState1,
                                applyOrder: true,
                            })
                        }
                     }
                }else if(tabName.value==="transporter"){
                    await columnApiConsignments.current.applyColumnState({
                        state: tptGridColumnState,
                        applyOrder: true,
                    })
                }else if(tabName.value==="inactive"){
                    await columnApiConsignments.current.applyColumnState({
                        state: invoiceGridColumnState,
                        applyOrder: true,
                    })
                }
                
               
            }, 1500);
          
        }
    }, [gridColumnState,gridColumnState1,deliveredGridColumnState,allGridColumnState,deliveredGridColumnState1,allGridColumnState1,tptGridColumnState,invoiceGridColumnState, columnApiConsignments, processFlowType])
    const invalidFileData = async(e) => {
        let params ={
            transaction_id: transactionData
        }
        await redirectURL.post("consignments/getInvalidConsignments", params)
            .then(resp => {
                //console.log("ressss", resp);
                
                // setModalLoadData(resp)
            })
            .catch(err => console.log(err))
    };

    const changeFileHandler = (e) => {
        const selectedFile = e.target.files[0];
    
        // Check if a file is selected
        if (!selectedFile) {
            // Reset state if no file is selected
            setFile(null);
            setModalLoadData([]);
            return; // Exit early
        }
        //console.log(selectedFile, "selectedFile44");
        setShow(false);
        setTitle('');
        setType('');
    
        setFile(selectedFile);
        setLoader(true);
    
        // e.target.value = null;
        const formData = new FormData();
        formData.append("fileUpload", selectedFile);
    
        redirectURL.post("/readExcel1", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
        .then((response) => {
            if (response.data.status === "success") {
                if (response.data.data.length > 0) {
                    const loadedData = response.data.data;

                    // var errorMessages ="";
                    // var row=[];
                    // const lrMap = new Map();

                    // loadedData.forEach((record,index) => {
                    //     const {lr_no, courier_partner} = record;

                    //     if (lr_no && lr_no.trim() !== "") {
                    //     if(lrMap.has(lr_no)){
                    //         const existingTpt = lrMap.get(lr_no);

                    //         // if (existingTpt !== courier_partner || existingTruckNo !== truck_no){
                    //         if(existingTpt !=  courier_partner){
                    //             // errorMessages.push(`LR No ${lr_no} has different transporters at record ${index + 1} and previous records.`);  
                    //             // errorMessages = "Same LR No has been assigned with different transporters or truck numbers.";
                    //             //console.log(existingTpt, lr_no, lrMap, "lrmap99");
                                
                    //             errorMessages="Same LR No has assigned with different transporters. ";  
                    //             // row.push(`${index+1}`)
                    //          }
                    //     }else{
                    //         // lrMap.set(lr_no, { existingTpt: courier_partner, existingTruckNo: truck_no });
                    //         lrMap.set(lr_no, courier_partner)
                    //     }
                    // }
                    // })
                    // if(errorMessages !==""){
                    //     // const msg="Please check this rows "+row+" in excel"
                    //     const msg ="Please check in uploaded excel"
                    //     setShow(true);
                    // setTitle(errorMessages+msg);
                    // setType("danger");
                    // setModalLoadData([]);
                    // }
                    // else{
                        setModalLoadData(response.data.data);
                    // }
                } else {
                    setModalLoadData([]);
                }
            } else {
                // Handle non-success response
                setShow(true);
                setTitle(response.data.message);
                setType("danger");
                setModalLoadData([]);
            }
        })
        .catch(error => {
            console.error("Error uploading file:", error);
            setShow(true);
            setTitle("File upload failed");
            setType("danger");
            setModalLoadData([]);
        })
        .finally(() => {
            setLoader(false); // Ensure the loader is hidden after processing
        });
    };

    const changeBulkStatusFileHandler = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) {
            setFile1(null);
            setModalBulkUpdateData([]);
            return;
        }
        setShow(false);
        setTitle("");
        setType("");
        setFile1(selectedFile);
        setLoader(true);
        const formData = new FormData();
        formData.append("fileUpload", selectedFile);
        const apiUrl =
            tabName.value === "all"
                ? "/readBulkInvoiceWeightCBMExcel"
                : "/readBulkStatusExcel";

        redirectURL
            .post(apiUrl, formData)
            .then((response) => {
                if (response.data.status === "success") {
                    const uploadedRows = response.data.data || [];

                    if (uploadedRows.length === 0) {
                        setModalBulkUpdateData([]);
                        return;
                    }

                    if (tabName.value === "all") {
                        const { validatedRows } = validateBulkInvoiceData(uploadedRows);
                        setModalBulkUpdateData(validatedRows);
                    } else {
                        setModalBulkUpdateData(uploadedRows);
                    }
                } else {
                    setShow(true);
                    setTitle(response.data.message);
                    setType("danger");
                    setModalBulkUpdateData([]);
                }
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
                setShow(true);
                setTitle("File upload failed");
                setType("danger");
                setModalBulkUpdateData([]);
            })
            .finally(() => {
                setLoader(false);
            });
    };

    const changeBulkTransporterFileHandler = (e) => {
        const selectedFile = e.target.files[0];
    
        // Check if a file is selected
        if (!selectedFile) {
            // Reset state if no file is selected
            setFile2(null);
            setModalBulkTransporterData([]);
            return; // Exit early
        }
        setShow(false);
        setTitle('');
        setType('');
    
        setFile2(selectedFile);
        setLoader(true);
        const formData = new FormData();
        formData.append("fileUpload", selectedFile);
    
        redirectURL.post("/readBulkTransporterExcel", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
        .then((response) => {
            if (response.data.status === "success") {
                if (response.data.data.length > 0) {
                    
                   
                    // setShow(true);
                    // setTitle(response.data.message);
                    // setType("Success");
                    setModalBulkTransporterData(response.data.data);
                }else{
                    setModalBulkTransporterData([]);
                    }
            } else {
                // Handle non-success response
                setShow(true);
                setTitle(response.data.message);
                setType("danger");
                setModalBulkTransporterData([]);

            }
        })
        .catch(error => {
            console.error("Error uploading file:", error);
            setShow(true);
            setTitle("File upload failed");
            setType("danger");
            modalBulkTransporterData([]);

        })
        .finally(() => {
            setLoader(false); // Ensure the loader is hidden after processing
        });
    }
    const changeBulkLRFileHandler = (e) => {
        const selectedFile = e.target.files[0];
    
        // // Reset file input field to ensure the same file triggers onChange
        // e.target.value = "";
    
        // Check if a file is selected
        if (!selectedFile) {
            setFile3(null);
            // setFileName("No file chosen");
            setModalBulkLRData([]);
            return; // Exit early
        }
    
        
        // setFileName(selectedFile.name);
        setFile3(selectedFile);
        setLoader(true);
        
        const formData = new FormData();
        formData.append("fileUpload", selectedFile);
    
        redirectURL.post("/readBulkLRExcel", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
        .then((response) => {
            if (response.data.status === "success") {
                if (response.data.data.length > 0) {
                    setModalBulkLRData(response.data.data);
                } else {
                    setModalBulkLRData([]);
                }
            } else {
                setShow(true);
                setTitle(response.data.message);
                setType("danger");
                setModalBulkLRData([]);
            }
        })
        .catch(error => {
            console.error("Error uploading file:", error);
            setShow(true);
            setTitle("File upload failed");
            setType("danger");
            setModalBulkLRData([]);
        })
        .finally(() => {
            setLoader(false); // Ensure the loader is hidden after processing
        });
    };
    // const validateBulkDeliveryRow = (row, deliveredLRMap, duplicateLRs) => {
    //     const lr = row.lr_no?.trim();
    //     const remark = row.late_delivery_remarks?.trim();

    //     if (
    //         remark &&
    //         !LATE_DELIVERY_REMARK_OPTIONS.includes(remark)
    //     ) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason:
    //                 "Invalid Late Delivery Remark. Allowed values: Local/Public holidays, Natural Calamity, Transporter Issue, Customer Issue"
    //         };
    //     }

    //     if (duplicateLRs.includes(lr)) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason: "Duplicate LR No. found in uploaded file"
    //         };
    //     }

    //     if (!deliveredLRMap.has(lr)) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason: "LR not found in Delivered consignments"
    //         };
    //     }

    //     const { isDelay } = deliveredLRMap.get(lr);

    //     if (!isDelay) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason: "Bulk update allowed only for Delayed LRs"
    //         };
    //     }

    //     return {
    //         isInvalidPerformance: false,
    //         _errorReason: ""
    //     };
    // };
    // const validateBulkDeliveryRow = (
    //     row,
    //     deliveredLRMap,
    //     duplicateLRs,
    //     isTransporter
    // ) => {
    //     // const lr = row.lr_no?.trim();
    //     const lr = row.lr_no?.toString().trim().toUpperCase();
    //     // console.log("CHECK:", {
    //     //     excelLR: lr,
    //     //     mapHas: deliveredLRMap.has(lr),
    //     //     mapValue: deliveredLRMap.get(lr)
    //     // });

    //     const remark = row.late_delivery_remarks?.trim();

    //     if (duplicateLRs.includes(lr)) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason: "Duplicate LR No. found in uploaded file"
    //         };
    //     }
    //     if (!deliveredLRMap.has(lr)) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason: "LR not found in Delivered consignments"
    //         };
    //     }
    //     const { isDelay } = deliveredLRMap.get(lr);
    //     if (!isDelay) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason: "Bulk update allowed only for Delayed LRs"
    //         };
    //     }
    //     if (isTransporter && !remark) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason: "Late Delivery Remarks is mandatory for Transporter"
    //         };
    //     }
    //     // if (
    //     //     remark &&
    //     //     !LATE_DELIVERY_REMARK_OPTIONS.includes(remark)
    //     // ) {
    //     //     return {
    //     //         isInvalidPerformance: true,
    //     //         _errorReason:
    //     //             "Invalid Late Delivery Remark. Allowed values: Local/Public holidays, Natural Calamity, Transporter Issue, Customer Issue"
    //     //     };
    //     // }
    //     if (
    //         remark &&
    //         !LATE_DELIVERY_REMARK_LOOKUP[remark.toLowerCase()]
    //     ) {
    //         return {
    //             isInvalidPerformance: true,
    //             _errorReason:
    //                 `Invalid Late Delivery Remark. Allowed values: ${lateDeliveryRemarkOptions.join(", ")}`
    //         };
    //     }

    //     return {
    //         isInvalidPerformance: false,
    //         _errorReason: ""
    //     };
    // };
const validateBulkDeliveryRow = (
    row,
    deliveredLRMap,
    duplicateLRs,
    isTransporter
) => {

    const lr = row.lr_no
        ?.toString()
        .trim()
        .toUpperCase();

    const remark = row.late_delivery_remarks?.trim();

    const records = deliveredLRMap.get(lr);

    if (!records) {
        return {
            isInvalidPerformance: true,
            _errorReason: "LR not found in Delivered consignments"
        };
    }

    // Allow only if LR has delay
    const hasDelay = records.some(r => r.isDelay === true);

    if (!hasDelay) {
        return {
            isInvalidPerformance: true,
            _errorReason: "Bulk update allowed only for Delayed LRs"
        };
    }

    if (isTransporter && !remark) {
        return {
            isInvalidPerformance: true,
            _errorReason: "Late Delivery Remarks is mandatory for Transporter"
        };
    }

    if (
        remark &&
        !LATE_DELIVERY_REMARK_LOOKUP[remark.toLowerCase()]
    ) {
        return {
            isInvalidPerformance: true,
            _errorReason:
                `Invalid Late Delivery Remark. Allowed values: ${lateDeliveryRemarkOptions.join(", ")}`
        };
    }

    return {
        isInvalidPerformance: false,
        _errorReason: ""
    };
};





    // const onBulkDeliveryCellValueChanged = (params) => {
    //     const row = params.data;

    //     const deliveredLRMap = getDeliveredLRMap();

    //     // rebuild duplicate LR list from CURRENT grid
    //     const lrCount = {};
    //     params.api.forEachNode((node) => {
    //         const lr = node.data.lr_no?.trim();
    //         if (!lr) return;
    //         lrCount[lr] = (lrCount[lr] || 0) + 1;
    //     });

    //     const duplicateLRs = Object.keys(lrCount).filter(
    //         lr => lrCount[lr] > 1
    //     );

    //     const validation = validateBulkDeliveryRow(
    //         row,
    //         deliveredLRMap,
    //         duplicateLRs
    //     );

    //     row.isInvalidPerformance = validation.isInvalidPerformance;
    //     row._errorReason = validation._errorReason;

    //     params.api.refreshCells({
    //         rowNodes: [params.node],
    //         force: true
    //     });
    // };
    const onBulkDeliveryCellValueChanged = (params) => {

        const row = params.data;

        const deliveredLRMap = getDeliveredLRMap();

        // rebuild duplicate LR list from CURRENT grid (NORMALIZED)
        const lrCount = {};

        params.api.forEachNode((node) => {

            const lr = node.data.lr_no
                ?.toString()
                .trim()
                .toUpperCase()
                .replace(/\s+/g, "")
                .replace(/-/g, "");

            if (!lr) return;

            lrCount[lr] = (lrCount[lr] || 0) + 1;
        });

        const duplicateLRs = Object.keys(lrCount).filter(
            lr => lrCount[lr] > 1
        );

        const validation = validateBulkDeliveryRow(
            row,
            deliveredLRMap,
            duplicateLRs
        );

        row.isInvalidPerformance = validation.isInvalidPerformance;
        row._errorReason = validation._errorReason;

        params.api.refreshCells({
            rowNodes: [params.node],
            force: true
        });
    };
    const formatDBDate = (dateStr) => {

        if (!dateStr) return null;

        // If already in correct format
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(dateStr)) {
            return dateStr.slice(0, 16);
        }

        // Handle ISO format without timezone conversion
        if (dateStr.includes("T")) {

            // Example: 2026-02-06T19:00:00.000Z
            const [datePart, timePart] = dateStr.split("T");

            const time = timePart.split(".")[0]; // 19:00:00

            const [hh, mm] = time.split(":");

            return `${datePart} ${hh}:${mm}`;
        }

        // Fallback: return as-is
        return dateStr;
    };
    const changeBulkDeliveryDateFileHandler = (e) => {
        const isTransporter = decodedRoleCase === "transporter";
        const selectedFile = e.target.files[0];
        if (!selectedFile) {
            setFile4(null);
            setModalBulkDeliveryData([]);
            return;
        }
        setShow(false);
        setTitle("");
        setType("");
        setFile4(selectedFile);
        setLoader(true);
        const formData = new FormData();
        formData.append("fileUpload", selectedFile);
        redirectURL
            .post("/readBulKDeliveryDateExcel", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "POST",
                    "Access-Control-Allow-Headers": "Origin, Content-Type",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,

                }
            })
            .then((response) => {
                if (response.data.status === "success") {
                    const fileData = response.data.data || [];
                    const cleanedFileData = fileData.filter(row => {
                        if (!row) return false;

                        return (
                            row.lr_no?.toString().trim() ||
                            row.invoice_no?.toString().trim() ||
                            row.delivery_date?.toString().trim()
                        );
                    });


                    if (fileData.length === 0) {
                        setModalBulkDeliveryData([]);
                        return;
                    }
                    const lrCountMap = {};
                    fileData.forEach((row) => {
                        const lr = row.lr_no?.trim();
                        if (!lr) return;
                        lrCountMap[lr] = (lrCountMap[lr] || 0) + 1;
                    });

                    const duplicateLRs = Object.keys(lrCountMap).filter(
                        (lr) => lrCountMap[lr] > 1
                    );

                    const deliveredLRMap = getDeliveredLRMap();

                    // const updatedData = cleanedFileData.map(row => {

                    //     const normalizedRemark =
                    //         normalizeLateDeliveryRemarkFromExcel(row.late_delivery_remarks);

                    //     const normalizedRow = {
                    //         ...row,
                    //         late_delivery_remarks: normalizedRemark
                    //     };

                    //     const validation = validateBulkDeliveryRow(
                    //         normalizedRow,
                    //         deliveredLRMap,
                    //         duplicateLRs
                    //     );

                    //     return {
                    //         ...normalizedRow,
                    //         ...validation
                    //     };
                    // });
                    const updatedData = cleanedFileData.map(row => {

                        const normalizedRemark =
                            normalizeLateDeliveryRemarkFromExcel(row.late_delivery_remarks);

                        const normalizedRow = {
                            ...row,
                            late_delivery_remarks: normalizedRemark,
                            isDelay: false
                        };

                        if (isTransporter) {
                            const lr = normalizedRow.lr_no?.trim();

                            // if (lr && deliveredLRMap.has(lr)) {
                            //     normalizedRow.actual_delivery_date =
                            //         deliveredLRMap.get(lr)?.actual_delivery_date || null;
                            // } else {
                            //     normalizedRow.actual_delivery_date = null;
                            // }
                            if (lr && deliveredLRMap.has(lr)) {

                                const records = deliveredLRMap.get(lr);

                                // Decide delay from grid (safe way)
                                const hasDelay = records.some(r => r.isDelay === true);

                                if (hasDelay) {

                                    normalizedRow.actual_delivery_date =
                                        records.find(r => r.isDelay)?.actual_delivery_date || null;

                                    normalizedRow.isDelay = true;

                                } else {

                                    normalizedRow.isDelay = false;
                                    normalizedRow.actual_delivery_date = null;
                                }

                            } else {

                                normalizedRow.actual_delivery_date = null;
                                normalizedRow.isDelay = false;
                            }




                            delete normalizedRow.delivery_date;
                            delete normalizedRow.actualDeliveryDate;
                            delete normalizedRow._errorReason;
                            delete normalizedRow.actual_delivery_date_error;

                        }
                        if (
                            normalizedRow.actual_delivery_date &&
                            !validateActualDeliveryDate(normalizedRow)
                        ) {
                            normalizedRow.isInvalidPerformance = true;
                            normalizedRow._errorReason =
                                "Actual Delivery Date cannot be before Dispatch / Actual Dispatch Date";
                        }

                        const validation = validateBulkDeliveryRow(
                            normalizedRow,
                            deliveredLRMap,
                            duplicateLRs
                        );

                        return {
                            ...normalizedRow,
                            ...validation
                        };
                    });
                    // AUTO REMOVE ONTIME ROWS FOR DUPLICATE LRs
                    // FINAL FILTER: Keep only LRs that are delayed in grid
                    const usedRecords = new Set();

                    const finalData = [];

                    updatedData.forEach(row => {

                        const lr = row.lr_no
                            ?.toString()
                            .trim()
                            .toUpperCase();

                        if (!lr) return;

                        const records = deliveredLRMap.get(lr);

                        if (!records) return;

                        // Get only delayed records
                        const delayRecords = records.filter(r => r.isDelay === true);

                        // Find first unused delay record
                        const nextRec = delayRecords.find(rec => {
                            const key = `${lr}|${rec.invoice_no}`;
                            return !usedRecords.has(key);
                        });

                        if (!nextRec) return; // No more delay records left

                        // Mark this DB record as used
                        const recordKey = `${lr}|${nextRec.invoice_no}`;
                        usedRecords.add(recordKey);

                        // Push mapped row
                        finalData.push({
                            lr_no: row.lr_no,
                            transporter_name: row.transporter_name,
                            tracking_type: row.tracking_type,
                            dispatch_date: row.dispatch_date,
                            actual_dispatch_date: row.actual_dispatch_date,
                            delivery_datetime: row.delivery_datetime,
                            late_delivery_remarks: row.late_delivery_remarks,

                            invoice_no: nextRec.invoice_no,
                            // actual_delivery_date: nextRec.actual_delivery_date || null,
                            // actual_delivery_date: formatDBDate(nextRec.actual_delivery_date),
                            actual_delivery_date: row.actual_delivery_date, 


                            isDelay: true
                        });
                    });

                    setModalBulkDeliveryData(finalData);








                } else {
                    setShow(true);
                    setTitle(response.data.message);
                    setType("danger");
                    setModalBulkDeliveryData([]);
                }
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
                setShow(true);
                setTitle("File upload failed");
                setType("danger");
                setModalBulkDeliveryData([]);
            })
            .finally(() => {
                setLoader(false);
            });
    };




  
    // const loadConsignmentsData = async (setGridLoadshow=null) => {
    //     let params = {}
        
    //     if(decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All"){
    //         params.transporter_name = localStorage.getItem("transporter")
    //     }

    //     if (["warehouse", "wh-inbound"].includes(decodedRoleCase) && processFlowType === "inbound" && warehouseTab.value == "my_warehouse" && !["All Sites"].includes(locationNameConversion)) {
    //         const resultPincodes = locationNameConversion.map(city => locationToPincode[city.toUpperCase()]).filter(Boolean);
    //         params.consignee_pincode = resultPincodes
    //         params.invoice_type = ["STOCK TRANSFER", "Delivery Challan"]
    //     }
    //     // else {
    //         if (
    //             zoneConversion &&
    //             zoneConversion.length > 0 &&
    //             !zoneConversion.includes("all")
    //         ) {
    //             if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {
    //                 if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
    //                     params.consignee_zone = zoneConversion;
    //                 } else if (processFlowType === "inbound") {
    //                     params.consignee_zone = zoneConversion;
    //                 }
    //             }
    //             else {
    //                 params.consignee_zone = zoneConversion;
    //             }
    //         }
    //         if (
    //             stateConversion &&
    //             stateConversion.length > 0 &&
    //             !stateConversion.includes("all")
    //         ) {
    //             if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {
    //                 if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
    //                     params.consignee_state = stateConversion;
    //                 }
    //                 else if (processFlowType === "inbound") {
    //                     params.consignee_state = stateConversion;
    //                 }
    //             }
    //             else {
    //                 params.consignee_state = stateConversion;
    //             }
    //         }
    //     // }

    //         if (
    //             locationNameConversion &&
    //             locationNameConversion.length > 0 &&
    //             !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
    //     ) {            
    //     if(["user", "user-outbound", "wh-outbound",  "warehouse"].includes(decodedRoleCase)){
    //         if(["user-outbound", "wh-outbound"].includes(decodedRoleCase)){
    //             params.consigner_name = locationNameConversion;
    //             params.consigner_code = locationNameConversion;
    //         } else if(processFlowType === "outbound"){
    //             params.consigner_name = locationNameConversion;
    //             params.consigner_code = locationNameConversion;
    //         } 
    //         }
    //     else{
    //         params.consigner_name = locationNameConversion;
    //         params.consigner_code = locationNameConversion;
    //     }
    // }
          
    //         if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
    //                 params.truck_seal_entity = entityConversion
    //             }
           
    //             if(searchDateType.value!==""){
    //                 params["date_type"] =searchDateType.value
    //             }else{
    //                 params["date_type"] =searchDateType.value
    //             }
    //             if (startDate == '' || startDate == "NaN-NaN-NaN") {
    //                 var sDate = "";
    //             }
    //             else {
    //                 params["sdate"] = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
    //             }
        
    //             if (endDate == '' || endDate == "NaN-NaN-NaN") {
    //                 var eDate = "";
    //             }
    //             else {
    //                 params["edate"] = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
    //             }

    //    if(setGridLoadshow==null)
    //    setLoadShow("show-m")
    // else
    // setGridLoadshow('show-m')
    // console.log(params,"check_params")
    // await redirectURL.post("consignments/getConsolidatedConsignments", params)
    //         .then(resp => {

    //             fragmentData(resp,setGridLoadshow=setGridLoadshow)
                

                
    //         })
    //         .catch(err => console.log(err))
    // }
    const loadConsignmentsData = async (setGridLoadshow = null) => {
        let params = {}
        params.tab = warehouseTab.value;
        if (decodedRoleCase === "transporter" && localStorage.getItem("transporter") !== "All") {
            params.transporter_name = localStorage.getItem("transporter")
        }
        if (
            ["warehouse", "wh-inbound"].includes(decodedRoleCase) &&
            processFlowType === "inbound" &&
            warehouseTab.value === "my_warehouse" &&
            !["All Sites"].includes(locationNameConversion)
        ) {
            const resultPincodes = locationNameConversion
                .map(city => locationToPincode[city.toUpperCase()])
                .filter(Boolean);
            if (resultPincodes.length > 0) {
                params.consignee_pincode = resultPincodes;
            }
            params.consignee_name = locationNameConversion;
            params.invoice_type = ["STOCK TRANSFER", "DELIVERY CHALLAN"];
        }
        if (warehouseTab.value === "my_region") {
            params.exclude_invoice_type = "DELIVERY CHALLAN";
        }
        if (
            zoneConversion &&
            zoneConversion.length > 0 &&
            !zoneConversion.includes("all")
        ) {
            if (
                warehouseTab.value !== "my_warehouse" ||
                !params.consignee_pincode
            ) {
                if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {

                    if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
                        params.consignee_zone = zoneConversion
                    }
                    else if (processFlowType === "inbound") {
                        params.consignee_zone = zoneConversion
                    }
                } else {
                    params.consignee_zone = zoneConversion
                }
            }
        }
        if (
            stateConversion &&
            stateConversion.length > 0 &&
            !stateConversion.includes("all")
        ) {
            if (
                warehouseTab.value !== "my_warehouse" ||
                !params.consignee_pincode
            ) {
                if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {

                    if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
                        params.consignee_state = stateConversion
                    }
                    else if (processFlowType === "inbound") {
                        params.consignee_state = stateConversion
                    }

                } else {
                    params.consignee_state = stateConversion
                }
            }
        }
        if (
            locationNameConversion &&
            locationNameConversion.length > 0 &&
            !["all numeric shipments", "all sites", "all shipment"]
                .some(item => locationNameConversion.includes(item))
        ) {
            if (["user", "user-outbound", "wh-outbound", "warehouse"].includes(decodedRoleCase)) {
                if (["user-outbound", "wh-outbound"].includes(decodedRoleCase)) {
                    params.consigner_name = locationNameConversion
                    params.consigner_code = locationNameConversion
                }
                else if (processFlowType === "outbound") {
                    params.consigner_name = locationNameConversion
                    params.consigner_code = locationNameConversion
                }
            } else {
                params.consigner_name = locationNameConversion
                params.consigner_code = locationNameConversion
            }
        }
        if (entityConversion && entityConversion.length > 0 && !entityConversion.includes("all")) {
            params.truck_seal_entity = entityConversion
        }
        params.date_type = searchDateType.value
        if (startDate && startDate !== "NaN-NaN-NaN") {
            params.sdate = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
        }
        if (endDate && endDate !== "NaN-NaN-NaN") {
            params.edate = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
        }
        if (setGridLoadshow == null) {
            setLoadShow("show-m")
        } else {
            setGridLoadshow("show-m")
        }
        console.log(params, "check_params")
        await redirectURL.post(
            "consignments/getConsolidatedConsignments",
            params
        )
            .then(resp => {
                fragmentData(resp, setGridLoadshow = setGridLoadshow)
            })
            .catch(err => console.log(err))
    }
    const loadNotTptConsignmentsData = async (passedParams,setGridLoadshow=null ) => {
        // Initialize params
        const params = { ...passedParams }; // Merge with any externally passed parameters
    
        if (decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All") {
            params.transporter_name = localStorage.getItem("transporter");
        }
        if(setGridLoadshow==null)
            setLoadShow("show-m")
         else
         setGridLoadshow('show-m')
         if (
            zoneConversion &&
            zoneConversion.length > 0 &&
            !zoneConversion.includes("all")
        ) {            
            if(["user","user-inbound",  "wh-inbound",  "warehouse"].includes(decodedRoleCase)){
                if(["user-inbound", "wh-inbound"].includes(decodedRoleCase)){
                    params.consignee_zone = zoneConversion;
                }else if(processFlowType === "inbound"){
                    params.consignee_zone = zoneConversion;
                }
        }
    else{
        params.consignee_zone = zoneConversion;
    }
}
            if (
                stateConversion &&
                stateConversion.length > 0 &&
                !stateConversion.includes("all")
            ) {            
                if(["user","user-inbound", "wh-inbound",  "warehouse"].includes(decodedRoleCase)){
                    if(["user-inbound", "wh-inbound"].includes(decodedRoleCase)){
                        params.consignee_state = stateConversion;
                    }
                    else if(processFlowType === "inbound"){
                        params.consignee_state = stateConversion;
                    }  
            }
            else{
            params.consignee_state = stateConversion;
            }
            }


        // if (decode(localStorageRole).toLowerCase() === "user") {
            if (
                locationNameConversion &&
                locationNameConversion.length > 0 &&
                !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
        ) {            
                if(["user", "user-outbound", "wh-outbound",  "warehouse"].includes(decodedRoleCase)){
                    if(["user-outbound", "wh-outbound"].includes(decodedRoleCase)){
                        params.consigner_name = locationNameConversion;
                        params.consigner_code = locationNameConversion;
                    } else if(processFlowType === "outbound"){
                        params.consigner_name = locationNameConversion;
                        params.consigner_code = locationNameConversion;
                    }
            }
        else{
            params.consigner_name = locationNameConversion;
            params.consigner_code = locationNameConversion;
        }
    }

    if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
        params.truck_seal_entity = entityConversion
    }
    
        // Set date type
        
        
    
        try {
           
                const notAssignedResponse = await redirectURL.post(
                    "consignments/getTptNotAssignedConsignments",
                    params
                );
                let consigneeNames = notAssignedResponse.data.consignee_names;
                let consigneeNameOptions = consigneeNames?.map(name => ({
                    label: convertTpt(name),
                    value: convertTpt(name)
                }))
                setFilterConsigneeNames(consigneeNameOptions)

                 
    
                noTptTabData(notAssignedResponse);
              
                if(setGridLoadshow==null)
                    setLoadShow("show-n")
                 else
                 setGridLoadshow('show-n')            
    
           
        } catch (error) {
            console.error("Error loading consignments data:", error);
        }
    };
    const loadTptConsignmentsData = async (passedParams,setGridLoadshow=null) => {
        // Initialize params
        const params = { ...passedParams }; // Merge with any externally passed parameters
        if(setGridLoadshow==null)
            setLoadShow("show-m")
         else
         setGridLoadshow('show-m')
        if (decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All") {
            params.transporter_name = localStorage.getItem("transporter");
        }
        if (
            zoneConversion &&
            zoneConversion.length > 0 &&
            !zoneConversion.includes("all")
        ) {            
            if(["user", "user-inbound", "wh-inbound",  "warehouse"].includes(decodedRoleCase)){
                if(["user-inbound", "wh-inbound"].includes(decodedRoleCase)){
                    params.consignee_zone = zoneConversion;
                }else if(processFlowType === "inbound"){
                    params.consignee_zone = zoneConversion;
                }
        }
    else{
        params.consignee_zone = zoneConversion;
    }
}
            if (
                stateConversion &&
                stateConversion.length > 0 &&
                !stateConversion.includes("all")
            ) {            
                if(["user","user-inbound", "wh-inbound",  "warehouse"].includes(decodedRoleCase)){
                    if(["user-inbound", "wh-inbound"].includes(decodedRoleCase)){
                        params.consignee_state = stateConversion;
                    }
                    else if(processFlowType === "inbound"){
                        params.consignee_state = stateConversion;
                    }
            }
            else{
            params.consignee_state = stateConversion;
            }
            }

    
        // if (decode(localStorageRole).toLowerCase() === "user") {
            if (
                locationNameConversion &&
                locationNameConversion.length > 0 &&
                !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
        ) {            
                if(["user","user-outbound", "wh-outbound",  "warehouse"].includes(decodedRoleCase)){
                     if(["user-outbound", "wh-outbound"].includes(decodedRoleCase)){
                        params.consigner_name = locationNameConversion;
                        params.consigner_code = locationNameConversion;
                    }else if(processFlowType === "outbound"){
                        params.consigner_name = locationNameConversion;
                        params.consigner_code = locationNameConversion;
                    } 
            }
        else{
            params.consigner_name = locationNameConversion;
            params.consigner_code = locationNameConversion;
        }
    }

    
    if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
        params.truck_seal_entity = entityConversion
    }
    
        // Set date type
        
    
        try {
           
                 const assignedResponse = await redirectURL.post(
                "consignments/getTptAssignedConsignments",
                params
            );
            tptTabData(assignedResponse);
            
 if(setGridLoadshow==null)
       setLoadShow("show-n")
    else
    setGridLoadshow('show-n')            
    
           
        } catch (error) {
            console.error("Error loading consignments data:", error);
        }
    };

    // const tptTabData = async(resp) => {
    //     if (resp.data.status == "success") {
    //         //console.log(searchViewType, "searchViewType");
    //         var transporterTrips =[];
            
                 
    //         if (Array.isArray(resp.data.tpt_assigned_details) && resp.data.tpt_assigned_details.length > 0) {
    //             transporterTrips = resp.data.tpt_assigned_details;
    //             // transporterTrips.push(...invoice_tpt_assigned);
    //         }
           
    //             setRowData(transporterTrips)
    //             // setTabName(tabOptions[5])
    //             setTransporterTrips(transporterTrips)

            
    //         setLoadShow("show-n")
    //     }
    // }
    const tptTabData = async (resp) => {
        if (resp.data.status == "success") {
            var transporterTrips = [];
            if (
                Array.isArray(resp.data.tpt_assigned_details) &&
                resp.data.tpt_assigned_details.length > 0
            ) {
                transporterTrips = resp.data.tpt_assigned_details;
            }
            if (searchConsigner?.length > 0) {
                const selectedOrigins = searchConsigner.map(
                    item => item.value.trim().toLowerCase()
                );
                transporterTrips = transporterTrips.filter(row =>
                    selectedOrigins.includes(
                        (row.consigner_city || "")
                            .trim()
                            .toLowerCase()
                    )
                );
            }
            setRowData(transporterTrips);
            setTransporterTrips(transporterTrips);
            setLoadShow("show-n");
        }
    }
    const noTptTabData = async(resp) => {
        if (resp.data.status == "success") {
            //console.log(searchViewType, "searchViewType");
            var inactiveTrips =[];
            
                 
            if (Array.isArray(resp.data.tpt_not_assigned_details) && resp.data.tpt_not_assigned_details.length > 0) {
                inactiveTrips = resp.data.tpt_not_assigned_details;
                // transporterTrips.push(...invoice_tpt_assigned);
            }
                
                
                setRowData(inactiveTrips)
                // setTabName(tabOptions[0])
                setInactiveTrips(inactiveTrips)

            
            setLoadShow("show-n")
        }
    }

    
    
    const fragmentData = async(resp,setGridLoadshow=null) => {
        if (resp.data.status == "success") {
            //console.log(searchViewType, "searchViewType");
            var inactive_trips = [];
            var transporterTrips =[];
            var active_trips=[];
            var completed_trips=[];
            var all_trips=[];
            
                if(searchViewType.value==="LR"){
                    let active_tripsar = resp.data.totalConsignments?.filter(e => ( (((e.hasOwnProperty("lr_no") && e.lr_no !== "" && e.lr_no !== undefined && e.tracking_type)  && (e.hasOwnProperty("tracking_type"))) && (([0, 1, 2, 3, 4, 10, 11].includes(e.status)) || (e.tracking_type === "PTL" && (["Dispatched from Source", "Arrived At Destination", "In Transit", "Out For Delivery", "Undelivered"].includes(e.consignment_status)))))))
                    
                    if (active_tripsar.length > 0) {
                        active_tripsar.forEach((itm) => {
                            // Check if transit_delay_hours exists and is valid
                            if (itm.transit_delay_hours !== "" && itm.transit_delay_hours !== undefined && itm.transit_delay_hours !== null) {
                                var hrs = itm.transit_delay_hours;
                                itm["transit_delay_days"] = Math.ceil(hrs / 24); // Convert hours to days
                            } else {
                                itm["transit_delay_days"] = 0; // Set default value if transit_delay_hours is invalid or missing
                            }
                            
                            // Push the processed item to active_trips
                            active_trips.push(itm);
                        });
                    }
                    let completed_tripsar = resp.data.totalConsignments.filter(e => ( ((e.hasOwnProperty("lr_no") && e.lr_no !== "" && e.lr_no !== undefined && e.tracking_type) && e.hasOwnProperty("tracking_type")) && ([5, 8].includes(e.status) || ["Delivered", "Trip Completed"].includes(e.consignment_status))))
                    if(completed_tripsar.length > 0)
                        {
                            completed_tripsar.forEach((itm) => {
                                if (itm.transit_delay_hours !== "" && itm.transit_delay_hours !== undefined && itm.transit_delay_hours !== null) {
                                    var hrs = itm.transit_delay_hours;
                                    itm["transit_delay_days"] = Math.ceil(hrs / 24); // Convert hours to days
                                } else {
                                    itm["transit_delay_days"] = 0; // Set default value if transit_delay_hours is invalid or missing
                                }
                                itm["disabled"] = true;

                                completed_trips.push(itm);

                            })
                        }
                        let all_tripsar = resp.data.totalConsignments.filter(e => 
                            e.hasOwnProperty("tracking_type") &&
                            ((e.tracking_type === "FTL" && e.status !== 6 && e.status !== 9) || (e.tracking_type === "PTL" && e.consignment_status !== "Cancelled")) &&
                            e.hasOwnProperty("lr_no") && e.lr_no !== "" && e.lr_no !== undefined
                          );                    
                          if(all_tripsar.length > 0)
                        {
                            all_tripsar.forEach((itm) => {
                                if (itm.transit_delay_hours !== "" && itm.transit_delay_hours !== undefined && itm.transit_delay_hours !== null) {
                                    var hrs = itm.transit_delay_hours;
                                    itm["transit_delay_days"] = Math.ceil(hrs / 24); // Convert hours to days
                                } else {
                                    itm["transit_delay_days"] = 0; // Set default value if transit_delay_hours is invalid or missing
                                }
                                    all_trips.push(itm);
                                
                            })
                        }
                    }else if(searchViewType.value==="Invoice"){
                        
                        let active_tripsar = resp.data.consignments?.filter(e => ( (((e.hasOwnProperty("lr_no") && e.lr_no !== "" && e.lr_no !== undefined && e.tracking_type)  && (e.hasOwnProperty("tracking_type"))) && (([0, 1, 2, 3, 4, 10, 11].includes(e.status)) || (e.tracking_type === "PTL" && (["Dispatched from Source", "Arrived At Destination", "In Transit", "Out For Delivery", "Undelivered"].includes(e.consignment_status)))))))
    
                        if (active_tripsar.length > 0) {
                            active_tripsar.forEach((itm) => {
                                // Check if transit_delay_hours exists and is valid
                                if (itm.transit_delay_hours !== "" && itm.transit_delay_hours !== undefined && itm.transit_delay_hours !== null) {
                                    var hrs = itm.transit_delay_hours;
                                    itm["transit_delay_days"] = Math.ceil(hrs / 24); // Convert hours to days
                                } else {
                                    itm["transit_delay_days"] = 0; // Set default value if transit_delay_hours is invalid or missing
                                }
                                
                                // Push the processed item to active_trips
                                active_trips.push(itm);
                            });
                        }
                        let completed_tripsar = resp.data.consignments.filter(e => ( ((e.hasOwnProperty("lr_no") && e.lr_no !== "" && e.lr_no !== undefined && e.tracking_type) && e.hasOwnProperty("tracking_type")) && ([5, 8].includes(e.status) || ["Delivered", "Trip Completed"].includes(e.consignment_status))))
                        if(completed_tripsar.length > 0)
                                {
                                    completed_tripsar.forEach((itm) => {
                                        if (itm.transit_delay_hours !== "" && itm.transit_delay_hours !== undefined && itm.transit_delay_hours !== null) {
                                            var hrs = itm.transit_delay_hours;
                                            itm["transit_delay_days"] = Math.ceil(hrs / 24); // Convert hours to days
                                        } else {
                                            itm["transit_delay_days"] = 0; // Set default value if transit_delay_hours is invalid or missing
                                        }

                                        itm["disabled"] = true;

                                        completed_trips.push(itm);
        
                                    })
                                }
                                let all_tripsar = resp.data.consignments.filter(e => 
                                    e.hasOwnProperty("tracking_type") &&
                                    ((e.tracking_type === "FTL" && e.status !== 6 && e.status !== 9) || (e.tracking_type === "PTL" && e.consignment_status !== "Cancelled")) &&
                                    e.hasOwnProperty("lr_no") && e.lr_no !== "" && e.lr_no !== undefined
                                  );                             
                                  if(all_tripsar.length > 0)
                                {
                                    all_tripsar.forEach((itm) => {
                                        if (itm.transit_delay_hours !== "" && itm.transit_delay_hours !== undefined && itm.transit_delay_hours !== null) {
                                            var hrs = itm.transit_delay_hours;
                                            itm["transit_delay_days"] = Math.ceil(hrs / 24); // Convert hours to days
                                        } else {
                                            itm["transit_delay_days"] = 0; // Set default value if transit_delay_hours is invalid or missing
                                        }
                                            all_trips.push(itm);
                                        
                                    })
                                }
                        }
            
            
           
            // var inactive_ftl_trips = (resp.data.consignments || []).filter(e => (((!e.lr_no_updated && e.lr_no_updated===undefined && e.invoice_no && e.tracking_type)&& (e.status ==="" || e.status ===null || e.status===0)) &&  e.tracking_type === "FTL" ));
            // var inactive_ptl_trips = (resp.data.consignments || []).filter(e => (((!e.lr_no_updated || e.lr_no_updated===0) && e.invoice_no && e.tracking_type)&& ( e.consignment_status === "" || e.consignment_status === null || e.consignment_status === "Invoiced"  ) &&  e.tracking_type === "PTL" ));
            // var close_trips = (resp.data.consignments || []).filter(e => (( e.consignment_status ==="Cancelled" || e.status ===6 || e.status ===9)));
            // inactive_trips = [...inactive_ftl_trips, ...inactive_ptl_trips]

           


            


            let active_in_transit = []; // In Transit
            let active_transit_delay = [] // transit_delay
            let active_stoppages = [] // stoppages
            let active_no_gps_data = [] // tracking N/A
            let active_out_for_delivery = [] // out for delivery
            let active_undelivered =[]
            let active_atsource=[]
            let active_dispatched =[]
            let active_arrived_at_dest =[]
            let active_sim_issues =[]
            let active_consent_pending=[]
            let active_consent_approved=[]
            let active_location_data=[]

            let completed_pod_pending = [] // POD Pending
            let completed_delayed = [] // delayed PTL
            let completed_on_time = [] // ontime PTL
            let completed_zero_one_days = []
            let completed_one_two_days = []
            let completed_three_five_days = []
            let completed_six_ten_days = []
            let completed_gt_ten_days = []
            let completed_sim_issues = []
            let completed_consent_pending = []

            let all_in_transit = []; 
            let all_transit_delay = [];
            let all_no_gps_data = [];
            let all_stoppages = [];
            let all_disabled = []; 
            let all_undelivered = []; 
            let all_out_for_delivery=[];
            let all_delivered =[];
            let all_pod_pending=[];
            let all_atsource=[]
            let all_dispatched =[]
            let all_arrived_at_dest =[]
            let all_sim_issues =[]
            let all_consent_pending=[]
            let all_consent_approved=[]
            let all_location_data=[]
            


            // CATEGORIZING SET
            active_trips.map(each => {                
                if (
                    (
                        (each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no") && each.lr_no !=="" )) 
                            && 
                        (each.consignment_status === "In Transit")
                    )
                     ||
                    ( 
                        each.hasOwnProperty("status") && each.hasOwnProperty("lr_no") && each.lr_no !="" 
                            && 
                        ( each.status == 2)
                    )
                ){
                    active_in_transit.push(each);
                }
                if (each.transit_delay > 0) {
                    active_transit_delay.push(each);
                }
                if (each.hasOwnProperty("ftl_sim_issue") && each.ftl_sim_issue === 1) {
                    active_sim_issues.push(each);
                }
                if(each.consignment_status==="Dispatched from Source" || each.status===1) {
                    active_dispatched.push(each)
                }  
                if(each.status===0 || each.status === 10) {
                    //console.log(each, "67777");
                    
                    active_atsource.push(each)
                } 
                if (each.consignment_status === "Arrived At Destination" || each.status=== 3) {
                    active_arrived_at_dest.push(each);
                }            
                // if (each.hasOwnProperty("last_process_on") && each.consignment_status && each.consignment_status.toLowerCase() !== "delivered") {
                //     const lastProcessOnDate = new Date(each.last_process_on);
                //     const today = new Date();
                //     const diffInMs = today.getTime() - lastProcessOnDate.getTime();
                //     const diffInDays = diffInMs / (1000 * 3600 * 24);
                //     if (diffInDays > 1) {
                //         active_no_gps_data.push(each);
                //     }
                // } 
                             
                if (each.hasOwnProperty("no_tracking_data") && each.no_tracking_data == 1) {
                    active_no_gps_data.push(each)
                }                
                if (each.hasOwnProperty("stoppage_alert") && each.stoppage_alert == 1) {
                    active_stoppages.push(each)
                }  
                if (
                    each.consignment_status === "Undelivered" || each.status ===11
                  ) {
                    active_undelivered.push(each);
                  }              
                if (
                    (each.hasOwnProperty("consignment_status") &&
                    (
                      each.consignment_status === "Out For Delivery"
                    )) ||( each.hasOwnProperty("status") &&
                    (
                      each.status === 4
                    ))
                  ) {
                    active_out_for_delivery.push(each);
                  }  
                if(each.hasOwnProperty("sim_issue") && each.sim_issue===1 ){
                    active_consent_pending.push(each)
                }
                if(each.hasOwnProperty("sim_issue") && each.sim_issue===0 ){
                    active_consent_approved.push(each)
                }   
                if(each.hasOwnProperty("sim_packet_rec") && each.sim_packet_rec===1 ){
                    active_location_data.push(each)
                }             
            })
            completed_trips.map(each => {              
                // if (
                //   each.tracking_type && 
                //   (each.consignment_status === "Delivered" || each.status === 8) && 
                //   each.is_submitted_pod === 1
                // ) {
                //   completed_delivered.push(each);
                // }
              
                if (
                  each.hasOwnProperty("ontime_status") && 
                  each.ontime_status === 0
                ) {
                  completed_delayed.push(each);
                }
              
                if (
                  each.hasOwnProperty("ontime_status") && 
                  each.ontime_status === 1
                ) {
                  completed_on_time.push(each);
                }

                if (
                    each.hasOwnProperty("transit_delay_hours") && 
                    each.transit_delay_hours >= 0 && 
                    each.transit_delay_hours < 24                  ) {
                    completed_zero_one_days.push(each);
                  }
                  if (
                    each.hasOwnProperty("transit_delay_hours") && 
                    each.transit_delay_hours >= 24 && 
                    each.transit_delay_hours < 48            ) {
                    completed_one_two_days.push(each);
                  }

                  if (
                    each.hasOwnProperty("transit_delay_hours") && 
                    each.transit_delay_hours >= 72 && 
                    each.transit_delay_hours < 120       ) {
                    completed_three_five_days.push(each);
                  }
                  if (
                    each.hasOwnProperty("transit_delay_hours") && 
                    each.transit_delay_hours >= 144 && 
                    each.transit_delay_hours < 240       ) {
                    completed_six_ten_days.push(each);
                  }
                  if (
                    each.hasOwnProperty("transit_delay_hours") && 
                    each.transit_delay_hours > 240      ) {
                    completed_gt_ten_days.push(each);
                  }
              
                if (
                    // each.tracking_type && 
                    (
                      !each.hasOwnProperty("is_submitted_pod") || each.is_submitted_pod ==0
                     
                    ) && (each.status == 5 || each.consignment_status == 'Delivered')
                    //  && 
                    // each.consignment_status !== "Delivered" && 
                    // (
                    //   !each.hasOwnProperty("epod_uploaded") || 
                    //   each.epod_uploaded === 0
                    // )
                  ) {
                    completed_pod_pending.push(each);
                  }
                if (each.hasOwnProperty("ftl_sim_issue") && each.ftl_sim_issue === 1) {
                    completed_sim_issues.push(each);
                }
                if (each.hasOwnProperty("sim_issue") && each.sim_issue === 1) {
                    completed_consent_pending.push(each);
                }
              }

            );
              

              
            all_trips.map(each => {                
                if (
                    (
                        (each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no") && each.lr_no !=="" )) 
                            && 
                        (each.consignment_status === "In Transit")
                    )
                     ||
                    ( 
                        each.hasOwnProperty("status") && each.hasOwnProperty("lr_no") && each.lr_no !="" 
                            && 
                        ( each.status == 2)
                    )
                
                ) {
                  all_in_transit.push(each);
                }
                if (
                  each.tracking_type && (
                  
                    ( 
                     each.consignment_status === "Out For Delivery")  || (each.status === 4)
                  
               
                )
                ) {
                  all_out_for_delivery.push(each);
                }
                if (
                    (
                    (
                      ( 
                       each.consignment_status === "Delivered") 
                    ) || 
                    (each.status && [5, 8].includes(each.status)))
                  ) {
                    all_delivered.push(each);
                  }

            
                if (
                  each.transit_delay > 0
                ) {
                  all_transit_delay.push(each);
                }
                if(each.consignment_status==="Dispatched from Source" || each.status===1) {
                    all_dispatched.push(each)
                }  
                if([0, 10].includes(each.status)) {
                    all_atsource.push(each)
                } 
                if (each.hasOwnProperty("ftl_sim_issue") && each.ftl_sim_issue === 1) {
                    all_sim_issues.push(each);
                }
                if ((each.consignment_status === "Arrived At Destination") || (each.status === 3)) {
                    all_arrived_at_dest.push(each);
                }
            
                // if (each.hasOwnProperty("last_process_on") && each.consignment_status.toLowerCase() !== "Delivered") {
                //     const lastProcessOnDate = new Date(each.last_process_on);
                //     const today = new Date();
                //     const diffInMs = today.getTime() - lastProcessOnDate.getTime();
                //     const diffInDays = diffInMs / (1000 * 3600 * 24);
                //     if (diffInDays > 1) {
                //         all_no_gps_data.push(each);
                //     }
                // }                
                if (each.hasOwnProperty("no_tracking_data") && each.no_tracking_data == 1) {
                    all_no_gps_data.push(each)
                }    
                if (
                  each.tracking_type && 
                  each.stoppage_alert=== 1
                ) {
                  all_stoppages.push(each);
                }
            
                if (
                  each.consignment_status === "Undelivered" ||  each.status === 11
                ) {
                  all_undelivered.push(each);
                }
            
                if (
                  each.consignment_status === "Cancelled" || each.status === 6
                ) {
                  all_disabled.push(each);
                }
                if (
                    (each.status == 5 || each.consignment_status == 'Delivered') &&
                    (each.is_submitted_pod ==0 || !each.hasOwnProperty('is_submitted_pod'))
                  ) {
                    all_pod_pending.push(each);
                  }
                if(each.hasOwnProperty("sim_issue") && each.sim_issue===1 ){
                    all_consent_pending.push(each)
                }
                if(each.hasOwnProperty("sim_issue") && each.sim_issue===0 ){
                    all_consent_approved.push(each)
                }   
                if(each.hasOwnProperty("sim_packet_rec") && each.sim_packet_rec===1 ){
                    all_location_data.push(each)
                }  

            });
            //console.log(all_atsource, "all_atsource");
            
            
            // COUNTERS SET
            setCountersActive({
                consignments: active_trips.length,
                inTransit: active_in_transit.length,
                transit_delays: active_transit_delay.length,
                stoppages: active_stoppages.length,
                no_gps_data: active_no_gps_data.length,
                outfordelivery: active_out_for_delivery.length,
                undelivered: active_undelivered.length,
                at_source:active_atsource.length,
                dispatched_from_source: active_dispatched.length,
                arrived_at_destination: active_arrived_at_dest.length,
                ftl_sim_issue: active_sim_issues.length,
                consent_pending: active_consent_pending.length,
                consent_approved: active_consent_approved.length,
                location_data_acquired: active_location_data.length

            })
            //console.log(counterActive.at_source, "at_source_countersss");
            
             
            setCountersCompleted({
                consignments: completed_trips.length,
                // delivered: completed_delivered.length,
                onTime: completed_on_time.length,
                delayed: completed_delayed.length,
                podPending: completed_pod_pending.length,
                zeroToOneDays: completed_zero_one_days.length,
                oneToTwoDays: completed_one_two_days.length,
                threeToFiveDays: completed_three_five_days.length,
                sixToTenDays: completed_six_ten_days.length,
                gtTenDays: completed_gt_ten_days.length,
                ftl_sim_issue: completed_sim_issues.length,
                consent_pending: completed_consent_pending.length
            })
            setCountersAll({
                consignments:all_trips.length,
                inTransit: all_in_transit.length,
                transit_delays: all_transit_delay.length,
                no_gps_data: all_no_gps_data.length,
                stoppages: all_stoppages.length,
                disabled: all_disabled.length,
                undelivered: all_undelivered.length,
                delivered: all_delivered.length,
                outfordelivery: all_out_for_delivery.length,
                podPending: all_pod_pending.length,
                at_source: all_atsource.length,
                dispatched_from_source: all_dispatched.length,
                arrived_at_destination: all_arrived_at_dest.length,
                ftl_sim_issue: all_sim_issues.length,
                consent_pending: all_consent_pending.length,
                consent_approved: all_consent_approved.length,
                location_data_acquired: all_location_data.length


            })
            
            // RECORDS SET
            setActiveTrips({
                all: active_trips,
                inTransit: active_in_transit,
                transit_delay: active_transit_delay,
                no_gps_data: active_no_gps_data,
                stoppages: active_stoppages,
                outForDelivery: active_out_for_delivery,
                undelivered: active_undelivered,
                at_source:active_atsource,
                dispatched_from_source: active_dispatched,
                arrived_at_destination: active_arrived_at_dest,
                ftl_sim_issue: active_sim_issues,
                consent_pending:active_consent_pending,
                consent_approved:active_consent_approved,
                location_data_acquired:active_location_data
        

            })
            setCompletedTrips({
                all: completed_trips,
                // delivered: completed_delivered,
                onTime: completed_on_time,
                delayed: completed_delayed,
                podPending: completed_pod_pending,
                zeroToOneDays:completed_zero_one_days,
                oneToTwoDays:completed_one_two_days,
                threeToFiveDays:completed_three_five_days,
                sixToTenDays:completed_six_ten_days,
                gtTenDays:completed_gt_ten_days,
                ftl_sim_issue: completed_sim_issues,
                consent_pending: completed_consent_pending
            })
            setAllTrips({
                all: all_trips,
                inTransit: all_in_transit,
                transit_delay: all_transit_delay,
                no_gps_data: all_no_gps_data,
                stoppages: all_stoppages,
                disabled: all_disabled,
                undelivered: all_undelivered,
                outForDelivery: all_out_for_delivery,
                delivered: all_delivered,
                podPending: all_pod_pending,
                at_source:all_atsource,
                dispatched_from_source: all_dispatched,
                arrived_at_destination: all_arrived_at_dest,
                ftl_sim_issue: all_sim_issues,
                consent_pending:all_consent_pending,
                consent_approved:all_consent_approved,
                location_data_acquired:all_location_data
            })
            
            // if(window.location.pathname === "/consignments/inactive_inbound_consignments" || window.location.pathname === "/consignments/inactive_outbound_consignments" || window.location.pathname === "/consignments/inactive_consignments"){
                
            //     setRowData(inactive_trips)
            //     setTabName(tabOptions[0])
            //     setInactiveTrips(inactive_trips)
            // }
            if (window.location.pathname === "/consignments/active_inbound_consignments" || window.location.pathname === "/consignments/active_outbound_consignments" || window.location.pathname == "/consignments/active_consignments" ) {
                setRowData(active_trips)
                setTabName(tabOptions[1])
            }
            else if (window.location.pathname === "/consignments/delivered_inbound_consignments" || window.location.pathname === "/consignments/delivered_outbound_consignments" || window.location.pathname == "/consignments/delivered_consignments") {
                setRowData(completed_trips)
                setTabName(tabOptions[2])
            }
            else if (window.location.pathname === "/consignments/all_inbound_consignments" || window.location.pathname === "/consignments/all_outbound_consignments" || window.location.pathname == "/consignments/all_consignments") {
                setRowData(all_trips)
                setTabName(tabOptions[3])
            }
            // else if (window.location.pathname === "/consignments/cancelled_inbound_consignments" || window.location.pathname === "/consignments/cancelled_outbound_consignments" || window.location.pathname == "/consignments/cancelled_consignments") {
            //     setRowData(close_trips)
            //     setTabName(tabOptions[4])
            //     setCloseTrips(close_trips)

            // }
            // else if (window.location.pathname === "/consignments/transporter_inbound_consignments" || window.location.pathname === "/consignments/transporter_outbound_consignments" || window.location.pathname == "/consignments/transporter_consignments") {
            //     console.log("ttttpppttt");
                
            //     setRowData(transporterTrips)
            //     setTabName(tabOptions[5])
            //     setTransporterTrips(transporterTrips)

            // }
            if(setGridLoadshow==null)
            setLoadShow("show-n")
        else
        setGridLoadshow('show-n')
        }
    }
    
    // firstboxfunction
    const getTruckConsignments = async (e) => {
        
        setLoader(true)
        setOverlay("show-m")
        e.preventDefault();
        setcheckresetfilter(1)

        // const tracking_type2 = filteredLrnos.find(record => record.label === lrNo)?.value;

        //console.log(tracking_type1, "tracking_type111");
        
        let params = {}
        if (searchType && searchType.value === "truck_no" && searchVehicle?.value) {
            params.truck_no = searchVehicle.value;
            params.tabType = tabName.value;
        } else if (searchType && searchType.value === "lr_no" && lrNo?.trim()) {
            params.lr_no = lrNo.trim();
            params.tabType = tabName.value;
            // params.tracking_type = tracking_type2;
        } else if (searchType && searchType.value === "invoice_no" && searchInvoice?.trim()) {
            params.invoice_no = searchInvoice.trim().toUpperCase();
            params.tabType = tabName.value;
        }
        
        if(decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All"){
            params.transporter_name = [localStorage.getItem("transporter")]
        } 
        params.tabType=tabName.value;
        params.data_type = counterActive;

        if (
            zoneConversion &&
            zoneConversion.length > 0 &&
            !zoneConversion.includes("all")
        ) {            
            if(["user","user-inbound","wh-inbound", "warehouse"].includes(decodedRoleCase)){
                if(["user-inbound", "wh-inbound"].includes(decodedRoleCase)){
                    params.consignee_zone = zoneConversion;
                }else if(processFlowType === "inbound"){
                    params.consignee_zone = zoneConversion;
                }
        }
    else{
        params.consignee_zone = zoneConversion;
    }
}
            if (
                stateConversion &&
                stateConversion.length > 0 &&
                !stateConversion.includes("all")
            ) {            
                if(["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)){
                    if(["user-inbound", "wh-inbound"].includes(decodedRoleCase)){
                        params.consignee_state = stateConversion;
                    }
                    else if(processFlowType === "inbound"){
                        params.consignee_state = stateConversion;
                    } 
            }
            else{
            params.consignee_state = stateConversion;
            }
            }


            if (
                locationNameConversion &&
                locationNameConversion.length > 0 &&
                !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
        ) {            
                if(["user",  "user-outbound",  "wh-outbound", "warehouse"].includes(decodedRoleCase)){
                   if(["user-outbound", "wh-outbound"].includes(decodedRoleCase)){
                        params.consigner_name = locationNameConversion;
                        params.consigner_code = locationNameConversion;
                    }else if(processFlowType === "outbound"){
                        params.consigner_name = locationNameConversion;
                        params.consigner_code = locationNameConversion;
                    } 
            }
        else{
            params.consigner_name = locationNameConversion;
            params.consigner_code = locationNameConversion;
        }
    }
       
            //  }
            if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
                params.truck_seal_entity = entityConversion
            }
           
                   if(searchDateType.value!==""){
                    params["date_type"] =searchDateType.value
                }else{
                    params["date_type"] =searchDateType.value
                }
                if (startDate == '' || startDate == "NaN-NaN-NaN") {
                    var sDate = "";
                }
                else {
                    params["sdate"] = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
                }
        
                if (endDate == '' || endDate == "NaN-NaN-NaN") {
                    var eDate = "";
                }
                else {
                    params["edate"] = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
                }
        setLoadShow("show-m")
                var lrNoCheck= (lrNo==="" || lrNo===undefined || lrNo==="undefined")
                var invoiceNoCheck = (searchInvoice==="" || searchInvoice===undefined || searchInvoice==="undefined")

                   if(tabName.value === "transporter"){
                    if((selectedOption1==="lr" && lrNoCheck)||(selectedOption1==="invoice" && invoiceNoCheck)){
                        setShow(true);
                        setTitle("Please select a valid search value to proceed.");
                        setType("danger");
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        setcheckresetfilter(0)
                    }else{
                        await redirectURL.post("consignments/filtertptConsignments", params)
                        .then(resp => {
                            if(resp.data.tpt_assigned_details?.length>0){
                                tptTabData(resp)
                                setOverlay("show-n")
                                setLoadShow("show-n")
                
                            }else{
                                setRowData([]);
                                setLoadShow("show-n")
                                setOverlay("show-n")
                
                            }
                        })
                    }
                   
                   }else if(tabName.value ==="inactive"){
                    
                    if((selectedOption1==="lr" && lrNoCheck)||(selectedOption1==="invoice" && invoiceNoCheck)){
                        setShow(true);
                        setTitle("Please select a valid search value to proceed.");
                        setType("danger");
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        setcheckresetfilter(0)
                    }else{
                        await redirectURL.post("consignments/filterNotptConsignments", params)
                        .then(resp => {
                            if(resp.data.tpt_not_assigned_details?.length>0){
                                noTptTabData(resp)
                                setOverlay("show-n")
                                setLoadShow("show-n")
                
                            }else{
                                setRowData([]);
                                setLoadShow("show-n")
                                setOverlay("show-n")
                
                            }
                        })
                    }
                   
                   }
      else{
        if((selectedOption1==="lr" && lrNoCheck)||(selectedOption1==="invoice" && invoiceNoCheck)){
            setShow(true);
            setTitle("Please select a valid search value to proceed.");
            setType("danger");
            setOverlay("show-n")
            setLoadShow("show-n")   
            setcheckresetfilter(0)
        }else{
            await redirectURL.post("consignments/filterCombinedConsignments", params)
            .then(resp => {                 
                if(resp.data.totalConsignments.length > 0 || resp.data.consignments.length > 0){
                    fragmentData(resp)
                    setSearchVehicle({value:"", label:""})
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }else {
                    setCountersActive({
                        consignments: 0,
                        inTransit: 0,
                        transit_delays: 0,
                        stoppages: 0,
                        no_gps_data: 0,
                        outfordelivery: 0,
                        at_source:0,
                        dispatched_from_source:0,
                        arrived_at_destination:0,
                        ftl_sim_issue:0
                    })
                    setCountersCompleted({
                        consignments:0,
                        // delivered: completed_delivered.length,
                        onTime: 0,
                        delayed: 0,
                        podPending: 0,
                        zeroToOneDays: 0,
                        oneToTwoDays: 0,
                        threeToFiveDays: 0,
                        sixToTenDays: 0,
                        gtTenDays: 0,
                        ftl_sim_issue: 0,
                        consent_pending: 0
                    })
                    setCountersAll({
                        consignments:0,
                        inTransit: 0,
                        transit_delays: 0,
                        no_gps_data: 0,
                        stoppages: 0,
                        disabled: 0,
                        undelivered: 0,
                        delivered: 0,
                        outfordelivery:0,
                        podPending: 0,
                        at_source:0,
                        dispatched_from_source:0,
                        arrived_at_destination:0,
                        ftl_sim_issue:0



                    })
                    setActiveTrips({
                        all: [],
                        inTransit: [],
                        transit_delay: [],
                        no_gps_data: [],
                        stoppages: [],
                        outForDelivery: [],
                        undelivered: [],
                        at_source: [],
                        dispatched_from_source: [],
                        arrived_at_destination: [],
                        ftl_sim_issue: []
                    })
                    setCompletedTrips({
                        all: [],
                        // delivered: completed_delivered,
                        onTime: [],
                        delayed: [],
                        podPending: [],
                        zeroToOneDays:[],
                        oneToTwoDays:[],
                        threeToFiveDays:[],
                        sixToTenDays:[],
                        gtTenDays:[],
                        ftl_sim_issue: [],
                        consent_pending: []
                    })
                    setAllTrips({
                        all: [],
                        inTransit: [],
                        transit_delay:[],
                        no_gps_data: [],
                        stoppages: [],
                        disabled: [],
                        undelivered: [],
                        outForDelivery: [],
                        delivered: [],
                        podPending: [],
                        at_source:[],
                        dispatched_from_source: [],
                        arrived_at_destination: [],
                        ftl_sim_issue: []

                    })
                    // setShow(true)
                    // setTitle("No Records Found")
                    // setType("danger")
                    setRowData([])
                    setOverlay("show-n")
                    setLoadShow("show-n")
    
    
                }
            })
            .catch(err => console.log(err))
        }
       
      }
        
       
    }
    let role = decode(localStorageRole)
    const handleDocTab=(e)=>{
        setSelectedTab(e)
    }
    const handleSearchInvoiceClick = () => {
        setSelectedOption((prevOption) => (prevOption === "invoice" ? "" : "invoice"));  
        setSearchType({ label: "Invoice No", value: "invoice_no" })

        resetFilters(setGridLoadshow)  
            // Add functionality for the Search button here
      };
      const handleSearchLRClick = () => {
        setSelectedOption((prevOption) => (prevOption === "lr" ? "" : "lr")); 
        setSearchType( { label: "LR No", value: "lr_no" })
 
        resetFilters(setGridLoadshow)  
            // Add functionality for the Search button here
      };
      const handleViewLRClick = (e) => {
        setSelectedOption1((prevOption) => (prevOption === "lr" ? "lr" : "lr")); 
        setSearchType( { label: "LR No", value: "lr_no" })

        viewTypeChange({ label: "LR", value: "LR" })
        setcheckresetfilter(0)
        // setLrNo("")

            // Add functionality for the Search button here
      };
      const handleViewInvoiceClick = (e) => {
        setSelectedOption1((prevOption) => (prevOption === "invoice" ? "invoice" : "invoice"));
        setSearchType({ label: "Invoice No", value: "invoice_no" })
 
        viewTypeChange({ label: "Invoice", value: "Invoice" })
        setcheckresetfilter(0)
        // setSearchInvoice("")
            // Add functionality for the Search button here
      };
      const handleFilterClick = () => {
        setSelectedOption((prevOption) => (prevOption === "filter" ? "" : "filter"));   
        resetFilters1(setGridLoadshow)
             // Add functionality for the Filter button here

      };
    const handleTabChange = (newTab) => {
        localStorage.setItem(`selectedTab_${processFlowType}`, JSON.stringify(newTab));
            if (role.toLowerCase() === "user") {
                switch(newTab){
                    case 'inactive':

                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], false);
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                        setTabName(tabOptions[0]);
                        setRowData(inactiveTrips)
                        setSelectedOption1("invoice")
                        navigate(`/consignments/${newTab}_${processFlowType}_consignments`);
                        setcheckresetfilter(0)

                        break;
                    case 'transporter':

                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], false);
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                        setTabName(tabOptions[5]);
                        setRowData(transporterTrips1)
                        setSelectedOption1("invoice")
                        setcheckresetfilter(0)

                        navigate(`/consignments/${newTab}_${processFlowType}_consignments`);
                        break;
                    case 'force_close':

                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], false);
                        setTabName(tabOptions[4]);
                        setRowData(closeTrips)
                        setSearchViewType({ label: "LR", value: "LR" })
                        navigate(`/consignments/${newTab}_${processFlowType}_consignments`);
                        setcheckresetfilter(0)

                        break;
                    case 'active':
                
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                        setCounterActive("Total")
                        setTabName(tabOptions[1]);
                        setRowData(activeTrips.all)
                        setSelectedOption1("lr")
                        setSearchViewType({ label: "LR", value: "LR" })
                        navigate(`/consignments/${newTab}_${processFlowType}_consignments`);
                        setcheckresetfilter(0)

                        break;
                    case 'delivered':
                
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], false);
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                        setCounterActive("Total")
                        setTabName(tabOptions[2]); 
                        setRowData(completedTrips.all)
                        setSelectedOption1("lr")
                        setSearchViewType({ label: "LR", value: "LR" })
                        navigate(`/consignments/${newTab}_${processFlowType}_consignments`);
                        setcheckresetfilter(0)

                        break;
                    case 'all':
                
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], false);
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                        setCounterActive("Total")
                        setTabName(tabOptions[3]); 
                        setRowData(allTrips.all)
                        setSelectedOption1("lr")
                        setSearchViewType({ label: "LR", value: "LR" })
                        navigate(`/consignments/${newTab}_${processFlowType}_consignments`);
                        setcheckresetfilter(0)

                        break;
                    default:
                        navigate("/consignments");
                        break;
                }
            } else {
                switch(newTab){
                    case 'inactive':
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], false);
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                        // columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                        // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible=true
                        // console.log("Checkbox lockVisible after Inactive tab change: ", columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible);
                        setCounterActive("Total")
                        setTabName(tabOptions[0]);
                        setRowData(inactiveTrips);
                        setSelectedOption1("invoice")
                        
                        navigate(`/consignments/${newTab}_consignments`);                        
                        setSearchConsigner([]);
                        setSearchTransporters([]);
                        setSearchStates([]);
                        setSearchEntity([]);
                        setSearchCity([]);
                        setSearchPodStatus([]);
                        setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                        setEndDate(new Date(moment.parseZone()));
                        setSeachValue("");
                        setLrNo("");
                        setSearchType({ label: "Invoice No", value: "invoice_no" })
                        setSearchInvoice();
                        setSearchVehicle({ value:"", label:"" });
                        setcheckresetfilter(0)
                        break;
                    case 'transporter':
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], false);
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                        // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible=true
                        // console.log("Checkbox lockVisible after Transporter tab change: ", columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible);
                        setCounterActive("Total")
                        setTabName(tabOptions[5]);
                        setRowData(transporterTrips1);
                        setSelectedOption1("invoice")

                        navigate(`/consignments/${newTab}_consignments`);                        
                        setSearchConsigner([]);
                        setSearchTransporters([]);
                        setSearchStates([]);
                        setSearchEntity([]);
                        setSearchCity([]);
                        setSearchPodStatus([]);
                        setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                        setEndDate(new Date(moment.parseZone()));
                        setSeachValue("");
                        setLrNo("");
                        setSearchType({ label: "Invoice No", value: "invoice_no" })
                        setSearchInvoice();
                        setSearchVehicle({ value:"", label:"" });
                        setcheckresetfilter(0)

                        break;
                    case 'force_close':
                            columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                            columnApiConsignments.current.setColumnsVisible(["checkbox"], false);
                            setCounterActive("Total")
                            setTabName(tabOptions[4]);
                            setRowData(closeTrips);
                            navigate(`/consignments/${newTab}_consignments`);                        
                            setSearchConsigner([]);
                            setSearchTransporters([]);
                            setSearchStates([]);
                            setSearchEntity([]);
                            setSearchCity([]);
                            setSearchPodStatus([]);
                            setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                            setEndDate(new Date(moment.parseZone()));
                            setSeachValue("");
                            setLrNo("");
                            setSearchType({label: "LR No", value: "lr_no" })
                            setSearchInvoice();
                            setSearchVehicle({ value:"", label:"" });
                            setcheckresetfilter(0)

                            break;
                    case 'active':
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                        setCounterActive("Total")
                        setTabName(tabOptions[1]);
                        setRowData(activeTrips.all)
                        setSelectedOption1("lr")
                        setSearchViewType({ label: "LR", value: "LR" })
                        navigate(`/consignments/${newTab}_consignments`);
                        setSearchConsigner([]);
                        setSearchTransporters([]);
                        setSearchStates([]);
                        setSearchEntity([]);
                        setSearchCity([]);
                        setSearchPodStatus([]);
                        setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                        setEndDate(new Date(moment.parseZone()));
                        setSeachValue("");
                        setLrNo("");
                        setSearchType({ label: "LR No", value: "lr_no" })
                        setSearchInvoice();
                        setSearchVehicle({ value:"", label:"" });
                        setcheckresetfilter(0)

                        break;
                    case 'delivered':
                
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], false);
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                        setCounterActive("Total")
                        setTabName(tabOptions[2]); 
                        setRowData(completedTrips.all)
                        setSelectedOption1("lr")
                        setSearchViewType({ label: "LR", value: "LR" })
                        navigate(`/consignments/${newTab}_consignments`);
                        setSearchConsigner([]);
                        setSearchTransporters([]);
                        setSearchStates([]);
                        setSearchEntity([]);
                        setSearchCity([]);
                        setSearchPodStatus([]);
                        setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                        setEndDate(new Date(moment.parseZone()));
                        setSeachValue("");
                        setLrNo("");
                        setSearchType({ label: "LR No", value: "lr_no" })
                        setSearchInvoice();
                        setSearchVehicle({ value:"", label:"" });
                        setcheckresetfilter(0)

                        break;
                    case 'all':
                        columnApiConsignments.current.setColumnsVisible(["checkbox"], false);
                        columnApiConsignments.current.setColumnsVisible(["upload_pod","view_document", "upload_document","map","shipmentlegs","group","sendemail"], true);
                        setCounterActive("Total")
                        setTabName(tabOptions[3]); 
                        setRowData(allTrips.all)
                        setSelectedOption1("lr")
                        setSearchViewType({ label: "LR", value: "LR" })
                        navigate(`/consignments/${newTab}_consignments`);
                        setSearchConsigner([]);
                        setSearchTransporters([]);
                        setSearchStates([]);
                        setSearchEntity([]);
                        setSearchCity([]);
                        setSearchPodStatus([]);
                        setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                        setEndDate(new Date(moment.parseZone()));
                        setSeachValue("");
                        setLrNo("");
                        setSearchType({label: "LR No", value: "lr_no"})
                        setSearchInvoice();
                        setSearchVehicle({ value:"", label:"" });
                        setcheckresetfilter(0)

                        break;
                    default:
                    navigate("/consignments/");
                    break;
                }
            } 
    }

    const handleInboundTabChange = (newTab) => {
        localStorage.setItem(`warehouse_${processFlowType}`, JSON.stringify(newTab));
        localStorage.setItem(`selectedTab_${processFlowType}`, JSON.stringify("active"));
        switch (newTab) {
            case 'my_warehouse':
                setWarehouseTab(warehouseTabOptions[0])
                setTabName(tabOptions[1]);
                navigate(`/consignments/active_consignments`);
                setCounterActive("Total")
                setRowData(activeTrips.all)
                columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                columnApiConsignments.current.setColumnsVisible(["upload_pod", "view_document", "upload_document", "map", "shipmentlegs", "group", "sendemail"], true);
                setSelectedOption1("lr")
                setSearchViewType({ label: "LR", value: "LR" })
                setSearchConsigner([]);
                setSearchTransporters([]);
                setSearchStates([]);
                setSearchEntity([]);
                setSearchCity([]);
                setSearchPodStatus([]);
                setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                setEndDate(new Date(moment.parseZone()));
                setSeachValue("");
                setLrNo("");
                setSearchType({ label: "LR No", value: "lr_no" })
                setSearchInvoice();
                setSearchVehicle({ value: "", label: "" });
                setcheckresetfilter(0)
                break;
            case 'my_region':
                setWarehouseTab(warehouseTabOptions[1])
                setCounterActive("Total")
                setTabName(tabOptions[1]);
                navigate(`/consignments/active_consignments`);
                setRowData(activeTrips.all)
                columnApiConsignments.current.setColumnsVisible(["checkbox"], true);
                columnApiConsignments.current.setColumnsVisible(["upload_pod", "view_document", "upload_document", "map", "shipmentlegs", "group", "sendemail"], true);
                setSelectedOption1("lr")
                setSearchViewType({ label: "LR", value: "LR" })
                setSearchConsigner([]);
                setSearchTransporters([]);
                setSearchStates([]);
                setSearchEntity([]);
                setSearchCity([]);
                setSearchPodStatus([]);
                setStartDate(new Date(moment.parseZone().subtract(1, "month")));
                setEndDate(new Date(moment.parseZone()));
                setSeachValue("");
                setLrNo("");
                setSearchType({ label: "LR No", value: "lr_no" })
                setSearchInvoice();
                setSearchVehicle({ value: "", label: "" });
                setcheckresetfilter(0)
                break;
            default:
                navigate("/consignments/");
                break;
        }
    }
    const saveConsignments = async (e) => {
        
        e.preventDefault();
        setLoadshowBulkupload("show-m")
        if (gridApi.current) {
            gridApi.current.stopEditing();
            const gridRowData = [];
            gridApi.current.forEachNode((node) => {
                    gridRowData.push(node.data)
            })

            if (gridRowData.length > 0) {
                    await redirectURL.post("/bulkUploadConsignments1", { consignments: gridRowData, email: decode(localStorageEmail) })
                    .then(response => {
                        setLoadshowBulkupload("show-n")

                        if (response.data.status == "Success" && (!response.data.transaction_id || response.data.transaction_id === null) && (response.data.message !=="Valid records will be updated successfully, and invalid records with remarks will be sent via email.")) {

                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setBulkUploadModal(false)
                            setModalLoadData([])
                            setOverlay("show-n")
                            setFile(null); 
                            // window.location.reload()

                        }else if(response.data.message =="Valid records will be updated successfully and invalid records with remarks will be sent via email."){
                            setShow(true)
                            setTitle(response.data.message);
                            setType("warning")
                            setBulkUploadModal(false)
                            setOverlay("show-n")
                            setFile(null); 
                            // window.location.reload()
                            // loadConsignmentsData()



                        }
                        else if(response.data.transactionId){
                            setTransactionData(response.data.transaction_id)
                            setShow(true)
                            setTitle("This consignment creation has some invalid data");
                            setType("warning")
                            setBulkUploadModal(false)
                            setOverlay("show-n")

                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoadshowBulkupload("show-n")

                        }
                    })
                    .catch(err => console.log(err))
           
                }
                
                
        }
    }
    // const saveConsignments = async (e) => {
        
    //     e.preventDefault();
    //     // //console.log("bullllllk999999",bulkError,bulkInvoiceError,bulkTptError,bulkBoxesError,bulkVehicleNoError,bulkEntityError,bulkTrackingError,bulkSourceError,bulkVehicleTypeError,bulkInvoiceTypeError,bulkConsigneeError,bulkDestinationError,bulkDispatchError,bulkTotalWeightError,bulkModeError,bulkMovementError,bulkPincodeError);


    //     setLoadshowBulkupload("show-m")
    //     if (gridApi.current) {
    //         gridApi.current.stopEditing();
    //         const gridRowData = [];
    //         gridApi.current.forEachNode((node) => {
    //             // if (node.data.plant_code == "" || node.data.fo_number == "" || node.data.order_number == "" || node.data.invoice_date == "" || node.data.transporter_code == "" || node.data.dealer_code == "" || node.data.quantity == "" || node.data.execution_date == "" || node.data.expected_date == "" || node.data.expected_return_to_plant_date == "" || node.data.plant_code == undefined || node.data.fo_number == undefined || node.data.order_number == undefined || node.data.invoice_date == undefined || node.data.transporter_code == undefined || node.data.dealer_code == undefined || node.data.quantity == undefined || node.data.execution_date == undefined || node.data.expected_date == undefined || node.data.expected_return_to_plant_date == undefined) {
    //             //     setShow(true)
    //             //     setTitle("Please fill the required fields")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (!plantData.some(e => e.consigner_code == node.data.plant_code)) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid Plant Code")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if ((!moment(node.data.invoice_date, "YYYY-MM-DD HH:mm:ss", true).isValid())) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid Invoice Date (YYYY-MM-DD HH:mm:ss)")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (!transporters.some(e => e.transporter_code == node.data.transporter_code)) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid Plant Code")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (!dealers.some(e => e.consignee_code == node.data.dealer_code)) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid Dealer Code")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (isNaN(node.data.quantity)) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid quantity")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (!moment(node.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid Execution Date (YYYY-MM-DD HH:mm:ss)")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (!moment(node.data.expected_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid Expected Date (YYYY-MM-DD HH:mm:ss)")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (!moment(node.data.expected_return_to_plant_date, "YYYY-MM-DD HH:mm:ss").isValid()) {
    //             //     setShow(true)
    //             //     setTitle("Please give a valid Expected Return to Plant Date (YYYY-MM-DD HH:mm:ss)")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else if (previousData.some(e => ((e.order_number == node.data.order_number) && (e.fo_number == node.data.fo_number)))) {
    //             //     setShow(true)
    //             //     setTitle("Order number and FO number combination already exist for previous consignments")
    //             //     setType("danger")
    //             //     gridApi.current.refreshCells()
    //             //     return
    //             // }
    //             // else
    //                 gridRowData.push(node.data)
    //         })

    //         if (gridRowData.length > 0) {
                

    // if(!bulkError && !bulkInvoiceError && !bulkTptError && !bulkBoxesError && !bulkVehicleNoError && !bulkEntityError && !bulkTrackingError &&  !bulkSourceError && !bulkVehicleTypeError && !bulkInvoiceTypeError && !bulkConsigneeError && !bulkDestinationError && !bulkDispatchError && !bulkTotalWeightError && !bulkModeError && !bulkFuelError && !bulkMovementError && !bulkPincodeError){
    //                 await redirectURL.post("/bulkUploadConsignments", { consignments: gridRowData, email: decode(localStorageEmail) })
    //                 .then(response => {
                        
    //                     if (response.data.status == "Success" && (!response.data.transaction_id || response.data.transaction_id === null) && (response.data.message !=="Valid records will be updated successfully, and invalid records with remarks will be sent via email.")) {

    //                         setShow(true)
    //                         setTitle(response.data.message)
    //                         setType("success")
    //                         setLoadshowBulkupload("show-n")
    //                         setBulkUploadModal(false)
    //                         setModalLoadData([])
    //                         setOverlay("show-n")
    //                         setFile(null); 
    //                         loadConsignmentsData()
    //                         // window.location.reload()

    //                     }else if(response.data.message =="Valid records will be updated successfully and invalid records with remarks will be sent via email."){
    //                         setShow(true)
    //                         setTitle(response.data.message);
    //                         setType("warning")
    //                         setLoadshowBulkupload("show-n")
    //                         setBulkUploadModal(false)
    //                         setOverlay("show-n")
    //                         setFile(null); 

    //                         loadConsignmentsData()



    //                     }
    //                     else if(response.data.transactionId){
    //                         setTransactionData(response.data.transaction_id)
    //                         setShow(true)
    //                         setTitle("This consignment creation has some invalid data");
    //                         setType("warning")
    //                         setLoadshowBulkupload("show-n")
    //                         setBulkUploadModal(false)
    //                         setOverlay("show-n")

    //                     }
    //                     else {
    //                         setShow(true)
    //                         setTitle(response.data.message)
    //                         setType("danger")
    //                         setLoadshowBulkupload("show-n")

    //                     }
    //                 })
    //                 .catch(err => console.log(err))
    //         }else{
    //             if(bulkFuelError){
    //                 setShow(true)
    //                 setTitle("Please upload valid fuel type")
    //                 setType("danger")
    //                 setLoadshowBulkupload("show-n")

    //             }else{
    //                 setShow(true)
    //                 setTitle("Please upload mandatory fields")
    //                 setType("danger")
    //                 setLoadshowBulkupload("show-n")
    //             }
                    

    //             }    
    //             }
                
                
    //     }
    // }
    // const uploadFormHandler = async (e) => {
    //     e.preventDefault();
    //     // setLoader(true)
    //     //console.log(bulkLRError,bulkUpdateInvoiceError,bulkUpdateDispatchError,bulkUpdateExpectedError,bulkUpdateLastEventTimeError, bulkUpdateStatusError,bulkUpdateCurrentLocationErr,bulkUpdateEventError, bulkUpdateReasonErr, "bulkUpdateEventError");
    //     setLoadshowBulkUpdate("show-m")
    //     setOverlay("show-m")
    //     setOverlayBulkUpdate("show-m")
    //     if (gridApiUpdateConsignments.current) {
    //         gridApiUpdateConsignments.current.stopEditing();
    //         const gridRowData = [];
    //         gridApiUpdateConsignments.current.forEachNode((node) => {
    //                 gridRowData.push(node.data)
    //         })
    //         if (gridRowData.length > 0) {
    //             const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;

    //             const invalidRows = gridRowData.filter((row) => {
    //                 const eventDateTime = row.current_event_date_time;
    //                 const expectedETA = row.expected_trip_end;
    //                 const isUndelivered = row.current_status?.toLowerCase() === "undelivered";

    //                 const isEventAfterETA =
    //                     eventDateTime && expectedETA &&
    //                     dateTimePattern.test(eventDateTime) &&
    //                     dateTimePattern.test(expectedETA) &&
    //                     parseDate(eventDateTime) > parseDate(expectedETA);
    //                 const isReasonMissing = !row.reason_for_delay || row.reason_for_delay.trim() === "";

    //                 return (isUndelivered || isEventAfterETA) && isReasonMissing;
    //             });

    //             if (invalidRows.length > 0) {
    //                 const rowIds = invalidRows.map(row => `${row.lr_no || "N/A"}`).join(", ");

    //                 setShow(true);
    //                 setTitle(`Reason is mandatory for delayed and undelivered LR's ${rowIds}`);
    //                 setType("danger");
    //                 setLoader(false);
    //                 setLoadshowBulkUpdate("show-n");
    //                 setOverlayBulkUpdate("show-n");
    //                 return;
    //             }
            
    //             // if(!bulkLRError && !bulkUpdateInvoiceError && !bulkUpdateDispatchError && !bulkUpdateExpectedError && !bulkUpdateLastEventTimeError && !bulkUpdateStatusError && !bulkUpdateCurrentLocationErr && !bulkUpdateEventError && !bulkUpdateReasonErr){
    //                 await redirectURL.post("/bulkUploadStatusConsignments", { consignments: gridRowData, email: decode(localStorageEmail) })
    //                 .then(response => {
                        
    //                     if (response.data.status == "Success") {
    //                         setShow(true)
    //                         setTitle(response.data.message)
    //                         setType("success")
    //                         setLoader(false)
    //                         setLoadshowBulkUpdate("show-n")
    //                         setModalBulkUpdateData([])
    //                         setOverlay("show-n")
    //                         setFile1(null); 
    //                         setshowBulkUpdateForm("")
    //                         setOverlayBulkUpdate("show-n")
    //                         setIsBulkUpdate(false)

    //                         // window.location.reload()

    //                     }
    //                     else {
    //                         setShow(true)
    //                         setTitle(response.data.message)
    //                         setType("danger")
    //                         setLoader(false)
    //                         setLoadshowBulkUpdate("show-n")
    //                         setOverlayBulkUpdate("show-n")
    //                         // setOverlay("show-n")

    //                     }
    //                 })
    //                 .catch(err => console.log(err))
    //             // }else{
    //             //     setShow(true)
    //             //     setTitle("Please upload mandatory fields")
    //             //     setType("danger")
    //             //     setLoader(false)
    //             //     setLoadShow("show-n")

    //             // }
    //         }
    //             }
                
                
    // }
    const uploadFormHandler = async (e) => {
        e.preventDefault();

        setLoadshowBulkUpdate("show-m");
        setOverlay("show-m");
        setOverlayBulkUpdate("show-m");

        if (!gridApiUpdateConsignments.current) return;

        gridApiUpdateConsignments.current.stopEditing();

        const gridRowData = [];
        gridApiUpdateConsignments.current.forEachNode((node) => {
            gridRowData.push(node.data);
        });

        if (gridRowData.length === 0) return;

        if (tabName.value !== "all") {
            const dateTimePattern = /^\d{2}[-/]\d{2}[-/]\d{4} \d{2}:\d{2}$/;

            // const invalidRows = gridRowData.filter((row) => {
            //     const eventDateTime = row.current_event_date_time;
            //     const expectedETA = row.expected_trip_end;
            //     const isUndelivered = row.current_status?.toLowerCase() === "undelivered";

            //     const isEventAfterETA =
            //         eventDateTime &&
            //         expectedETA &&
            //         dateTimePattern.test(eventDateTime) &&
            //         dateTimePattern.test(expectedETA) &&
            //         parseDate(eventDateTime) > parseDate(expectedETA);

            //     const isReasonMissing =
            //         !row.reason_for_delay || row.reason_for_delay.trim() === "";

            //     return (isUndelivered || isEventAfterETA) && isReasonMissing;
            // });
            const invalidRows = gridRowData.filter((row) => {
                const eventDateTime = row.current_event_date_time;
                const expectedETA = row.expected_trip_end;
                const isUndelivered = row.current_status?.toLowerCase() === "undelivered";

                const isEventAfterETA =
                    eventDateTime &&
                    expectedETA &&
                    dateTimePattern.test(eventDateTime) &&
                    dateTimePattern.test(expectedETA) &&
                    parseDate(eventDateTime) > parseDate(expectedETA);

                const reason = row.reason_for_delay?.trim() || "";

                const isValidReason =
                    reason &&
                    validReasonsData.some(
                        r => r.toLowerCase() === reason.toLowerCase()
                    );

                if (isAdmin) {
                    if (reason && !isValidReason) {
                        return true; // block only if invalid text
                    }
                    return false; // allow empty
                }

                const isReasonMissing = !reason || !isValidReason;

                return (isUndelivered || isEventAfterETA) && isReasonMissing;
            });

            if (invalidRows.length > 0) {
                const rowIds = invalidRows
                    .map((row) => row.lr_no || "N/A")
                    .join(", ");

                setShow(true);
                setTitle(`Reason is mandatory for delayed and undelivered LR's ${rowIds}`);
                setType("danger");
                setLoadshowBulkUpdate("show-n");
                setOverlayBulkUpdate("show-n");
                return;
            }
        }

        if (tabName.value === "all") {
            const invalidTrackingRows = gridRowData.filter(
                row => !row.tracking_type || !["FTL", "PTL"].includes(row.tracking_type)
            );

            if (invalidTrackingRows.length > 0) {
                setShow(true);
                setTitle("Tracking Type is mandatory and must be FTL or PTL");
                setType("danger");
                setLoadshowBulkUpdate("show-n");
                setOverlayBulkUpdate("show-n");
                return;
            }
        }
        if (tabName.value === "all") {
            const errorRows = modalBulkUpdateData.filter(r => r._hasError);

            if (errorRows.length > 0) {

                const firstErrorRowIndex = modalBulkUpdateData.findIndex(
                    r => r._hasError
                );

                if (
                    firstErrorRowIndex >= 0 &&
                    gridApiUpdateConsignments.current
                ) {
                    gridApiUpdateConsignments.current.ensureIndexVisible(
                        firstErrorRowIndex,
                        "middle"
                    );
                }

                const invalidInvoices = new Set();
                const duplicateInvoices = new Set();
                const invalidWeights = new Set();
                const invalidCbms = new Set();
                const invalidTrackingTypes = new Set();

                errorRows.forEach((r) => {
                    if (r._errorReason === "Invoice not exists in All tab Invoice view" ||
                        r._errorReason === "Invoice not exists") {
                        invalidInvoices.add(r.invoice_no);
                    }

                    if (r._errorReason === "Duplicate invoice in file") {
                        duplicateInvoices.add(r.invoice_no);
                    }

                    if (
                        r._errorReason === "Total Weight is mandatory" ||
                        r._errorReason === "Total Weight must be 0 or greater"
                    ) {
                        invalidWeights.add(r.invoice_no);
                    }

                    if (r._errorReason === "Total CBM must be 0 or greater") {
                        invalidCbms.add(r.invoice_no);
                    }

                    if (r._errorReason === "Tracking Type is not correct") {
                        invalidTrackingTypes.add(r.invoice_no);
                    }
                });

                const errorMessages = [];

                if (invalidInvoices.size > 0) {
                    errorMessages.push(
                        `Invoice No. not exists: ${[...invalidInvoices].join(", ")}`
                    );
                }

                if (duplicateInvoices.size > 0) {
                    errorMessages.push(
                        `Duplicate invoice numbers: ${[...duplicateInvoices].join(", ")}`
                    );
                }
                if (invalidWeights.size > 0) {
                    errorMessages.push(
                        `Total Weight is mandatory and must be 0 or greater for invoices: ${[...invalidWeights].join(", ")}`
                    );
                }

                if (invalidCbms.size > 0) {
                    errorMessages.push(
                        `Total CBM must be 0 or greater for invoices: ${[...invalidCbms].join(", ")}`
                    );
                }
                if (invalidTrackingTypes.size > 0) {
                    errorMessages.push(
                        `Tracking Type is not correct for invoices: ${[...invalidTrackingTypes].join(", ")}`
                    );
                }

                if (errorMessages.length > 0) {
                    setErrorQueue(errorMessages);
                    setCurrentErrorIndex(0);
                    setTitle(errorMessages[0]);
                    setType("danger");
                    setShow(true);

                    setLoadshowBulkUpdate("show-n");
                    setOverlayBulkUpdate("show-n");
                    return;
                }
            }

        }

        const apiUrl =
            tabName.value === "all"
                ? "/bulkUploadInvoiceWeightCBM"
                : "/bulkUploadStatusConsignments";

        const payload =
            tabName.value === "all"
                ? {
                    consignments: gridRowData,
                    type_consignments: gridRowData[0].tracking_type,
                    email: decode(localStorageEmail),
                }
                : {
                    consignments: gridRowData,
                    email: decode(localStorageEmail),
                };

        try {
            const response = await redirectURL.post(apiUrl, payload);

            if (response.data.status === "Success") {
                setShow(true);
                setTitle(response.data.message);
                setType("success");
                shouldHardReload.current = true;
                setRefreshAfterBulkWtVl(true);
                setShouldRefreshAfterAlert(true);

                setLoadshowBulkUpdate("show-n");
                setModalBulkUpdateData([]);
                setOverlay("show-n");
                setFile1(null);
                setshowBulkUpdateForm("");
                setOverlayBulkUpdate("show-n");
                setIsBulkUpdate(false);
            } else {
                setShow(true);
                setTitle(response.data.message);
                setType("danger");
                setLoadshowBulkUpdate("show-n");
                setOverlayBulkUpdate("show-n");
            }
        } catch (err) {
            console.error(err);
            setShow(true);
            setTitle("Something went wrong");
            setType("danger");
            setLoadshowBulkUpdate("show-n");
            setOverlayBulkUpdate("show-n");
        }
    };
    const uploadTransporters = async (e) => {
        e.preventDefault();
        // setLoader(true)
        //console.log(bulkLRError,bulkUpdateInvoiceError,bulkUpdateDispatchError,bulkUpdateExpectedError,bulkUpdateLastEventTimeError, bulkUpdateStatusError,bulkUpdateCurrentLocationErr,bulkUpdateEventError, bulkUpdateReasonErr, "bulkUpdateEventError");
        setLoadshowBulkTpt("show-m")
        setOverlayBulkTpt("show-m")
        setOverlay("show-m")
        if (gridApiTransporterConsignments.current) {
            gridApiTransporterConsignments.current.stopEditing();
            const gridRowData = [];
            gridApiTransporterConsignments.current.forEachNode((node) => {
                    gridRowData.push(node.data)
            })
            if (gridRowData.length > 0) {
                    await redirectURL.post("/bulkUploadTransportersConsignments", { consignments: gridRowData, email: decode(localStorageEmail) })
                    .then(response => {
                        
                        if (response.data.status == "Success") {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            setLoadshowBulkTpt("show-n")
                            setOverlayBulkTpt("show-n")
                            setModalBulkTransporterData([])
                            setOverlay("show-n")
                            setFile2(null); 
                            setshowBulkTransporterForm("")
                            // window.location.reload()

                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)
                            setLoadshowBulkTpt("show-n")
                            setOverlayBulkTpt("show-n")


                        }
                    })
                    .catch(err => console.log(err))
                
            }
                }
                
                
    }
    const uploadLRs = async (e) => {
        e.preventDefault();
        // setLoader(true)
        //console.log(bulkLRError,bulkUpdateInvoiceError,bulkUpdateDispatchError,bulkUpdateExpectedError,bulkUpdateLastEventTimeError, bulkUpdateStatusError,bulkUpdateCurrentLocationErr,bulkUpdateEventError, bulkUpdateReasonErr, "bulkUpdateEventError");
        setLoadshowBulkLr("show-m")
        setOverlay("show-m")
        setOverlayBulkUpload("show-m")
        if (gridApiLRConsignments.current) {
            gridApiLRConsignments.current.stopEditing();
            const gridRowData = [];
            gridApiLRConsignments.current.forEachNode((node) => {
                    gridRowData.push(node.data)
            })
            if (gridRowData.length > 0) {
                    await redirectURL.post("/bulkUploadLRConsignments", { consignments: gridRowData, email: decode(localStorageEmail) })
                    .then(response => {
                        
                        if (response.data.status == "Success") {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            setModalBulkLRData([])
                            setOverlay("show-n")
                            setFile3(null); 
                            setshowBulkLRForm("")
                            setLoadShow("show-n")
                            setLoadshowBulkLr("show-n")
                            setOverlayBulkUpload("show-n")

                            // window.location.reload()

                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)
                            setLoadShow("show-n")
                            setLoadshowBulkLr("show-n")
                            setOverlayBulkUpload("show-n")

                        }
                    })
                    .catch(err => console.log(err))
                
            }
                }
                
                
    }

    
//     const uploadDeliveryDateFormHandler = async (e) => {
//         e.preventDefault();

//         setLoadshowBulkDeliveryUpdate("show-m");
//         setOverlay("show-m");
//         setOverlayBulkDeliveryUpdate("show-m");
//         if (!gridApiDeliveryDateUpdate.current) return;
//         // gridApiDeliveryDateUpdate.current.stopEditing();

//         // const validationErrors = validateBulkDeliveryRows(
//         //     gridApiDeliveryDateUpdate.current
//         // );

//         // const gridRowData = [];
//         // gridApiDeliveryDateUpdate.current.forEachNode((node) => {
//         //     gridRowData.push(node.data);
//         // });
//         gridApiDeliveryDateUpdate.current.stopEditing();

//         gridApiDeliveryDateUpdate.current.forEachNode((node) => {
//             const row = node.data;

//             row.late_delivery_remarks =
//                 normalizeLateDeliveryRemarkFromExcel(row.late_delivery_remarks);

//             row.dispatch_date = normalizeDateToYYYYMMDDHHmm(row.dispatch_date);
//             row.delivery_datetime = normalizeDateToYYYYMMDDHHmm(row.delivery_datetime);
//             row.actual_delivery_date = normalizeDateToYYYYMMDDHHmm(row.actual_delivery_date);
//         });

//         // const validationErrors = validateBulkDeliveryRows(
//         //     gridApiDeliveryDateUpdate.current
//         // );

//         const gridRowData = [];
//         gridApiDeliveryDateUpdate.current.forEachNode((node) => {
//             gridRowData.push(node.data);
//         });
//         // ✅ Get delay info from MAIN grid
//         const deliveredLRMap = getDeliveredLRMap();

//         // 🚫 Block non-delay LRs
//         const nonDelayRows = gridRowData.filter(row => {
//             const lrInfo = deliveredLRMap.get(row.lr_no);

//             // If LR not found or not delay → block
//             return !lrInfo || lrInfo.isDelay !== true;
//         });

//         if (nonDelayRows.length > 0) {
//             const errors = nonDelayRows.map(
//                 r => `LR No: ${r.lr_no}\nBulk Delivery Date update is allowed only for Delay LRs`
//             );

//             setErrorQueue(errors);
//             setCurrentErrorIndex(0);
//             setShow(true);
//             setTitle(errors[0]);
//             setType("danger");

//             setLoadshowBulkDeliveryUpdate("show-n");
//             setOverlay("show-n");
//             setOverlayBulkDeliveryUpdate("show-n");
//             setLoader(false);
//             return;
//         }

// // 🔴 HARD BLOCK: Transporter mandatory Late Delivery Remarks
// if (isTransporter) {
//     const emptyRemarkRows = gridRowData.filter(
//         row => !row.late_delivery_remarks || !row.late_delivery_remarks.trim()
//     );

//     if (emptyRemarkRows.length > 0) {
//         const errors = emptyRemarkRows.map(
//             r => `LR No: ${r.lr_no}\nLate Delivery Remarks is mandatory for Transporter`
//         );

//         setErrorQueue(errors);
//         setCurrentErrorIndex(0);

//         setShow(true);
//         setTitle(errors[0]);
//         setType("danger");

//         setLoadshowBulkDeliveryUpdate("show-n");
//         setOverlay("show-n");
//         setOverlayBulkDeliveryUpdate("show-n");
//         setLoader(false);
//         return; // ⛔ STOP SUBMIT — THIS IS CRITICAL
//     }
// }


//         const invalidRows = gridRowData.filter(
//             row => row.isInvalidPerformance === true
//         );

//         if (invalidRows.length > 0) {
//             const errors = invalidRows.map(
//                 r => `LR No: ${r.lr_no}\n${r._errorReason}`
//             );

//             setErrorQueue(errors);
//             setCurrentErrorIndex(0);

//             setShow(true);
//             setTitle(errors[0]);
//             setType("danger");

//             setLoadshowBulkDeliveryUpdate("show-n");
//             setOverlay("show-n");
//             setOverlayBulkDeliveryUpdate("show-n");
//             setLoader(false);
//             return;

//         }
//         const cleanedPayload = gridRowData.map(row => {
//             const obj = {
//                 lr_no: row.lr_no,
//                 tracking_type: row.tracking_type,
//                 dispatch_date: row.dispatch_date,
//                 delivery_datetime: row.delivery_datetime,
//                 sla_considered: "No",
//                 transporter_name: row.transporter_name
//             };

//             // optional fields
//             if (
//                 row.actual_delivery_date &&
//                 row.actual_delivery_date !== "Invalid Date Format" &&
//                 row.actual_delivery_date.trim() !== ""
//             ) {
//                 obj.actual_delivery_date = row.actual_delivery_date;
//             }

//             if (
//                 row.late_delivery_remarks &&
//                 row.late_delivery_remarks.trim() !== ""
//             ) {
//                 obj.late_delivery_remarks = row.late_delivery_remarks.trim();
//             }

//             return obj;
//         });



//         if (gridRowData.length > 0 && validationErrors.length === 0) {
//             await redirectURL
//                 .post("/bulkUploadDeliveryDate", {
//                     lr_data: cleanedPayload,
//                     email: decode(localStorageEmail)
//                 })
//                 .then((response) => {
//                     if (response.data.status === "Success") {
//                         setShow(true);
//                         setTitle(response.data.message);
//                         setType("success");

//                         setModalBulkUpdateData([]);
//                         setFile1(null);
//                         setshowBulkUpdateForm("");
//                         setIsBulkUpdate(false);
//                     } else {
//                         setShow(true);
//                         setTitle(response.data.message);
//                         setType("danger");
//                     }

//                     setLoader(false);
//                     setLoadshowBulkDeliveryUpdate("show-n");
//                     setOverlay("show-n");
//                     setOverlayBulkDeliveryUpdate("show-n");
//                 })
//                 .catch((err) => console.log(err));
//         } else {
//             const error_msg = validationErrors[0];

//             setShow(true);
//             setTitle(error_msg);
//             setType("danger");

//             setOverlay("show-n");
//             setLoader(false);
//             setLoadshowBulkDeliveryUpdate("show-n");
//             setOverlayBulkDeliveryUpdate("show-n");
//         }
//     };
    const uploadDeliveryDateFormHandler = async (e) => {
        e.preventDefault();

        setLoadshowBulkDeliveryUpdate("show-m");
        setOverlay("show-m");
        setOverlayBulkDeliveryUpdate("show-m");
        const isAdmin = decode(localStorageRole) === "admin";
        if (!gridApiDeliveryDateUpdate.current) return;
        gridApiDeliveryDateUpdate.current.stopEditing();
        gridApiDeliveryDateUpdate.current.forEachNode((node) => {
            const row = node.data;
            row.late_delivery_remarks =
                normalizeLateDeliveryRemarkFromExcel(row.late_delivery_remarks);
            row.dispatch_date =
                normalizeDateToYYYYMMDDHHmm(row.dispatch_date);
            row.delivery_datetime =
                normalizeDateToYYYYMMDDHHmm(row.delivery_datetime);
            row.actual_delivery_date =
                normalizeDateToYYYYMMDDHHmm(row.actual_delivery_date);
            row.actual_dispatch_date =
                normalizeDateToYYYYMMDDHHmm(row.actual_dispatch_date);

        });

        validateBulkDeliveryRows(gridApiDeliveryDateUpdate.current);
        const gridRowData = [];
        gridApiDeliveryDateUpdate.current.forEachNode((node) => {
            gridRowData.push(node.data);
        });
        const deliveredLRMap = getDeliveredLRMap();
        // const nonDelayRows = gridRowData.filter(row => {
        //     const lrInfo = deliveredLRMap.get(row.lr_no);
        //     return !lrInfo || lrInfo.isDelay !== true;
        // });
        const nonDelayRows = gridRowData.filter(row => {

            const lr = row.lr_no?.trim()?.toUpperCase();

            if (!lr || !deliveredLRMap.has(lr)) return true;

            const records = deliveredLRMap.get(lr);
            const invoice = row.invoice_no?.trim();

            const matched = records.find(
                r => r.invoice_no === invoice
            );

            if (matched) {
                return matched.isDelay !== true;
            }

            const hasDelay = records.some(r => r.isDelay === true);

            return !hasDelay;
        });

        if (nonDelayRows.length > 0) {
            nonDelayRows.forEach(row => {
                row.isInvalidPerformance = true;
                row._errorReason =
                    "Bulk Delivery Date update is allowed only for Delay LRs";
            });
            setErrorQueue(
                nonDelayRows.map(
                    r => `LR No: ${r.lr_no}\n${r._errorReason}`
                )
            );
            setCurrentErrorIndex(0);
            setShow(true);
            setTitle(`LR No: ${nonDelayRows[0].lr_no}\n${nonDelayRows[0]._errorReason}`);
            setType("danger");
            setLoadshowBulkDeliveryUpdate("show-n");
            setOverlay("show-n");
            setOverlayBulkDeliveryUpdate("show-n");
            setLoader(false);
            return;
        }


        if (isTransporter) {
            const emptyRemarkRows = gridRowData.filter(
                row => !row.late_delivery_remarks || !row.late_delivery_remarks.trim()
            );

            if (emptyRemarkRows.length > 0) {
                emptyRemarkRows.forEach(row => {
                    row.isInvalidPerformance = true;
                    row._errorReason =
                        "Late Delivery Remarks is mandatory for Transporter";
                });
                setErrorQueue(
                    emptyRemarkRows.map(
                        r => `LR No: ${r.lr_no}\n${r._errorReason}`
                    )
                );
                setCurrentErrorIndex(0);
                setShow(true);
                setTitle(`LR No: ${emptyRemarkRows[0].lr_no}\n${emptyRemarkRows[0]._errorReason}`);
                setType("danger");

                setLoadshowBulkDeliveryUpdate("show-n");
                setOverlay("show-n");
                setOverlayBulkDeliveryUpdate("show-n");
                setLoader(false);
                return;
            }
        }

        const invalidRows = gridRowData.filter(
            row => row.isInvalidPerformance === true
        );

        if (invalidRows.length > 0) {
            setErrorQueue(
                invalidRows.map(
                    r => `LR No: ${r.lr_no}\n${r._errorReason}`
                )
            );
            setCurrentErrorIndex(0);

            setShow(true);
            setTitle(`LR No: ${invalidRows[0].lr_no}\n${invalidRows[0]._errorReason}`);
            setType("danger");

            setLoadshowBulkDeliveryUpdate("show-n");
            setOverlay("show-n");
            setOverlayBulkDeliveryUpdate("show-n");
            setLoader(false);
            return;
        }

        const cleanedPayload = gridRowData.map(row => {
            const obj = {
                lr_no: row.lr_no,
                tracking_type: row.tracking_type,
                dispatch_date: row.dispatch_date,
                delivery_datetime: row.delivery_datetime,
                sla_considered: "No",
                transporter_name: row.transporter_name
            };

            if (
                row.actual_delivery_date &&
                row.actual_delivery_date !== "Invalid Date Format" &&
                row.actual_delivery_date.trim() !== ""
            ) {
                obj.actual_delivery_date = row.actual_delivery_date;
            }
            if (
                isAdmin &&
                row.actual_dispatch_date &&
                row.actual_dispatch_date !== "Invalid Date Format" &&
                row.actual_dispatch_date.trim() !== ""
            ) {
                obj.actual_dispatch_date = row.actual_dispatch_date;
            }

            if (
                row.late_delivery_remarks &&
                row.late_delivery_remarks.trim() !== ""
            ) {
                obj.late_delivery_remarks =
                    row.late_delivery_remarks.trim();
            }

            return obj;
        });
        const bgTimer = setTimeout(() => {

            setLoader(false);

            setLoadshowBulkDeliveryUpdate("show-n");
            setOverlay("show-n");
            setOverlayBulkDeliveryUpdate("show-n");
            setBgAlertShown(true); 
            setShowBgAlert(true);

        }, 10000); // 10 sec
        try {

            const response = await redirectURL.post(
                "/bulkUploadDeliveryDate",
                {
                    lr_data: cleanedPayload,
                    email: decode(localStorageEmail),
                    role: decodedRole
                }
            );

            clearTimeout(bgTimer);


            if (response.data.status === "Success") {

                // Show success only if bg alert NOT shown
                if (!bgAlertShown) {

                    setShow(true);
                    setTitle(response.data.message);
                    setType("success");
                }

                setModalBulkUpdateData([]);
                setFile1(null);
                setshowBulkUpdateForm("");
                setIsBulkUpdate(false);
            }
            else {

                setShow(true);
                setTitle(response.data.message);
                setType("danger");
            }

        } catch (err) {

            clearTimeout(bgTimer);

            console.error(err);

            setShow(true);
            setTitle("Upload failed. Please try again.");
            setType("danger");

        } finally {
            setBgAlertShown(false);
            setLoader(false);

            setLoadshowBulkDeliveryUpdate("show-n");
            setOverlay("show-n");
            setOverlayBulkDeliveryUpdate("show-n");
        }
    };

    const onClickDeliveredSubmit = (e)=>{
        //console.log("   ");
        e.preventDefault();
        setOverlay("show-m")
        setLoadShow('show-m')
        //console.log(form2Details.selectedStatus.value, "selectedStatus222222");
        //console.log(selectedStatusUpdate, "selectedStatusUpdate");
        //console.log(form2Details.errorMessage, "errorMessage000");
        
        var uploadPod;
        if (
            form2Details.selectedStatus?.value === "Undelivered" &&
            (!form2Details.remark || !form2Details.remark.value)
        ) {
            setLoadShow('show-n')
            setShow(true);
            setType("warning");
            setTitle("Please select a reason for undelivered status.");
            return;
        };
        if(form2Details.errorMessage!==""){
            setLoadShow('show-n')
                setShow(true);
                setType("warning");
                setTitle("Please select status properly.");
                return;
        }

        // if(uploadPODTracking)
        if (uploadPODTracking && form2Details.selectedStatus.value === "Delivered") {
            {//console.log("trackingpodd");
            }
            // if (podremarks === "") {
            //     setLoadShow('show-n')
            //     setShow(true);
            //     setType("warning");
            //     setTitle("Please enter remarks");
            //     setPodRemarks("");
            //     return;
            // }
            // const formData = new FormData();

                const rowid = Dselected_row._id;
                uploadPod = savePodDocument(rowid);
                // const shipment_id = rownode?.[0]?.shipment_id || Dselected_row?.shipment_id;
                // const tracking_type = rownode?.[0]?.tracking_type || Dselected_row?.tracking_type;
                //     // const rownodes = rownode;
                
                // formData.append("shipmentId", shipment_id);
                // formData.append("podDoc", epodDoc);
                // formData.append("podremarks", podremarks);
                // formData.append("rowid", rowid);
                // // formData.append("rownodes", JSON.stringify(rownodes));
                // formData.append("damage", damage);
                // formData.append("short", short);
                // formData.append("excess", excess);
                // formData.append("pilferage", pilferage);
                // formData.append("trackingType", tracking_type);
                

                
                
        }


        
        const extractedLRs = selectedLRStoUpdateLr.map(e => e.value)
        var lrList  = extractedLRs.length>0;


        setLoadShow('show-m')


        // const formattedDate = moment(form2Details.delivered_date).format("YYYY-MM-DD HH:mm:ss");
        const formattedDate = moment(form2Details.delivered_date).format("YYYY-MM-DD");
        const formattedTime = moment(form2Details.delivered_time).format("HH:mm:ss");

        const formattedDate1 = `${formattedDate} ${formattedTime}`;
        


        
        let updatedDeliveredData = {
            // Conditionally include consignee_pincode based on isMoreInvoice
           
            tracking_type: selectedRecordType,
            lr_no: lrList ? extractedLRs : Dselected_row.lr_no,
            consignment_status: form2Details.selectedStatus.value,
            delivery_station: form2Details.event_location,
            delivery_datetime: formattedDate1,
            ...(bulkPtlUpdate ? {truck_no:selectedTruckUpdate,shipment_id: selectedShipmentUpdate} : { truck_no: Dselected_row.truck_no ,
                shipment_id:  Dselected_row.shipment_id,
            ...(isMoreInvoices
                ? { consignee_pincode: form2Details.selectedPincode.value }
                : { consignee_pincode: Dselected_row.consignee_pincode }),    
            invoice_no: Dselected_row.invoice_no,

                
            }),
        };
        
        if(ableRemark){
            updatedDeliveredData.remarks = form2Details.remark.value
        };
        if(form2Details.reason_for_delay.value !==""){
            updatedDeliveredData.reason_for_delay = form2Details.reason_for_delay.value
        }

        let combinedParams={
            updatedDeliveredData, formData,
            role: decodedRole,
            source_from: "web"   
        }
        let delayReasonMandatory = true;

        if ((combinedDate > new Date(Dselected_row.expected_trip_end || Dselected_row.expected_eta)) && (decode(localStorageRole) !=="admin")) {
            // If combinedDate is greater, reason_for_delay must not be empty
            if (form2Details.reason_for_delay.value === "") {
                delayReasonMandatory = false; // This makes the reason for delay mandatory
            }
        } else {
            // If combinedDate is not greater, it's okay if reason_for_delay is empty
            delayReasonMandatory = true;
        }
        
        if(delayReasonMandatory){
            redirectURL.post('/consignments/updateDeliveryDetails', combinedParams).then((resp) => {
                // console.log(resp.data, "failresponse777778");
    
                
                if (resp.data.status == 'success') {
                    if(uploadPODTracking && uploadPod){
                        
                    setTitle("Tracking status updated and POD uploaded successfully");
                    setShow(true)                
                    setType("success");
                    setLoadShow('show-n');
                    setOverlay('show-n');
                    setshowAddForm2('');
                    setIsMoreInvoices(false);
                    setUpdateTracking({label:"", value:""})
                    setUploadPODTracking(false)
                    setForm2Details({
                        event_status:statusOrderFtl,
                        selectedStatus: {value: 'In Transit', label: 'In Transit'},
                        selectedPincode: {value: '', label: ''},
                        event_location: "",
                        remark: {label:"", value:""},
                        reason_for_delay:{label:"", value:""},
                        delivered_date:new Date(),
                        delivered_time:new Date(),
                        errorMessage:''
                    })
                    setDselected_row({})
                    setBulkPtlUpdate(false)
                    document.getElementById("formPOD").reset();
                    setPodRemarks("");
                    setSliderShow("");
                    setEpodDoc([]);
                    setShort(0)
                    setExcess(0)
                    setDamage(0)
                    setPilferage(0)
    
                    }else{
                        setTitle(resp.data.message);
                        setShow(true)                
                        setType("success");
                        setLoadShow('show-n');
                        setshowAddForm2('');
                        setIsMoreInvoices(false);
                        setOverlay('show-n');

                        setUploadPODTracking(false)
                        setForm2Details({
                            event_status:statusOrderFtl,
                            selectedStatus: {value: 'In Transit', label: 'In Transit'},
                            selectedPincode: {value: '', label: ''},
                            event_location: "",
                            remark: {label:"", value:""},
                            reason_for_delay:{label:"", value:""},
                            delivered_date:new Date(),
                            delivered_time:new Date(),
                            errorMessage:''
                        })
                        setDselected_row({})
                        setBulkPtlUpdate(false)
                        document.getElementById("formPOD").reset();
                        setPodRemarks("");
                        setSliderShow("");
                        setEpodDoc([]);
                        setShort(0)
                        setExcess(0)
                        setDamage(0)
                        setPilferage(0)
        
                    }
                    
                    // window.location.reload();    
                }
                else if (resp.data.status =="Failure"){
                    //console.log("failupdateee7777");
                    
                    setShow(true)
                    // setTitle("Please upload valid details")
                    setTitle(resp.data.message)
                    setType("danger")
                    setLoadShow('show-n')
                    // deselectAllRows();
                    // setshowAddForm2('');
                    // setForm2Details({
                    //     event_status: [
                    //         { label: 'Delivered', value: 'Delivered' }, 
                    //         { label: 'In Transit', value: 'In Transit' },
                    //         { label: 'Out For Delivery', value: 'Out For Delivery' },
                    //         { label: 'Arrived At Destination', value: 'Arrived At Destination' },                    
                    //         { label: 'Undelivered', value: 'Undelivered' },
                    //     ],
                    //     selectedStatus: {value: 'In Transit', label: 'In Transit'},
                    //     selectedPincode: {value: '', label: ''},
                    //     event_location: "",
                    //     remark: "",
                    //     delivered_date:'',
                    // })
                    // setDselected_row({})
                } else{
                    //console.log("failupdateee7777");
                    
                    setShow(true)
                    setTitle(resp.data.message)
                    setType("danger")
                    setLoadShow('show-n')
                    deselectAllRows();
                    setshowAddForm2('');
                    setForm2Details({
                        event_status:statusOrderFtl,
                        selectedStatus: {value: 'In Transit', label: 'In Transit'},
                        selectedPincode: {value: '', label: ''},
                        event_location: "",
                        remark: {label:"", value:""},
                        reason_for_delay:{label:"", value:""},
                        delivered_date:new Date(),
                        delivered_time:new Date(),
                        errorMessage:''
                    })
                    setDselected_row({})
                }
            })
        }else{
            setShow(true)
            setTitle('Please fill mandatory fields')
            setType('danger') 
            setLoadShow('show-n')

        }
      
    }
    const changeHandleDate1 = (date) => {
        
        
        setForm2Details((prev) => ({
        ...prev,
        delivered_date: date,
        }))
        const deliveredDate = new Date(date); 
        const deliveredTime = new Date(form2Details.delivered_time);
        const timeString = deliveredTime.toTimeString().split(' ')[0];

        const combinedDate = new Date(
            deliveredDate.toDateString() + ' ' + timeString // Form a complete date-time string (e.g., "Tue Mar 25 2025 19:15:00")
          );
        
        setCombinedDate(combinedDate)
    
    };
    const changeHandleTime1 = (time) => {
        setForm2Details((prev) => ({
        ...prev,
        delivered_time: time,
        }))
        const deliveredDate = new Date(form2Details.delivered_date); 
        const deliveredTime = new Date(time);

        const timeString = deliveredTime.toTimeString().split(' ')[0];

        const combinedDate = new Date(
            deliveredDate.toDateString() + ' ' + timeString // Form a complete date-time string (e.g., "Tue Mar 25 2025 19:15:00")
          );
        setCombinedDate(combinedDate)
        
    
    };
    const onConfirm = () => {
        setShow(false);
        setLoader(false);

        if (shouldHardReload.current === true) {
            shouldHardReload.current = false; 
            window.location.reload();
            return;
        }
        if (searchViewType.value === "Invoice") {
            return;
        }
        if (type === "success") {
            window.location.reload();
        }
    };
    
    
    const updateDeliveredDate = async(e) => {
        setDselected_row(e.data);
        const deliveredDate = new Date(form2Details.delivered_date); // Assuming form2Details.delivered_date is 'delivered_Date222'
        const deliveredTime = new Date(form2Details.delivered_time); // Assuming Dselected_row.delivered_time is 'delivered time'

        // Extract the time (HH:mm:ss) from deliveredTime
        const timeString = deliveredTime.toTimeString().split(' ')[0]; // 'HH:mm:ss'

        // Combine the delivered date and the extracted time
        const combinedDate = new Date(
        deliveredDate.toDateString() + ' ' + timeString // Form a complete date-time string (e.g., "Tue Mar 25 2025 19:15:00")
        );   
        setCombinedDate(combinedDate)
        setSelectedRecordType(e.data.tracking_type)
        // const x = selectedRows.map((e)=> ({label:e.lr_no, value: e.lr_no}))
        
        setSelectLRSToUpdate([{label:e.data.lr_no, value:e.data.lr_no}]);
        setShipmentId(e.data.shipment_id)
        setshowAddForm2("slider-translate-30p");
        setOverlay("show-m");
        setUpdateTracking({label:e.data.consignment_status, value:e.data.consignment_status})
        setForm2Details((prev) => ({
            ...prev,
            selectedStatus: { label: e.data.consignment_status, value: e.data.consignment_status }, // Set the selected status from e.data
        }));        
        var params ={
            truck_no: e.data.truck_no
        }
        await redirectURL.post("consignments/getPincodes", params)
        .then(resp => {
            if (e.data.tracking_type === 'FTL'){
                if(resp.data.length> 0){
                    setIsMoreInvoices(true)
                    var data = resp.data;
                    
                    const uniquePincodesSet = new Set();

                    const updatedPincodesList = data
                        .map(e => e.consignee_pincode) // Extract only the pincode
                        .filter(pincode => {
                            // Only keep unique values
                            if (!uniquePincodesSet.has(pincode)) {
                                uniquePincodesSet.add(pincode);
                                return true; // Include this pincode in the result
                            }
                            return false; // Skip if it's a duplicate
                        })
                        .map(pincode => ({
                            label: pincode,
                            value: pincode
                        }));
                
                    setPincodesList(updatedPincodesList);
                } else {
                    setShow(true)
                    setTitle("No Records Found")
                    setType("danger")
                }          
              }
        })
        .catch(err => console.log(err))
        if(e.data.tracking_type === "PTL"){
            setSelectedStatusUpdate(e.data.consignment_status)
            const updatedStatusOrderPtl = e.data.consignment_status === "Undelivered"
            ? statusOrderPtl.filter(status => status.value !== "In Transit" && status.value !== "Arrived At Destination")
            : statusOrderPtl;

            setForm2Details((prev) => ({
                ...prev,
                event_status: updatedStatusOrderPtl,
                selectedStatus: {label:e.data.consignment_status, value: e.data.consignment_status}, // Add a new state variable to store the selected status
                selectedPincode: {label:'', value:''},
                event_location: "",
                remark: {label:"", value:""},
                reason_for_delay:{label:"", value:""},
                delivered_date:new Date(),
                errorMessage:''
            }))
        } else {
            const updatedStatusOrderFtl = [11, "Undelivered"].includes(e.data.status)
            ? statusOrderFtl.filter(status => status.value !== "In Transit" && status.value !== "Arrived At Destination")
            : statusOrderFtl;

            setForm2Details((prev) => ({
                ...prev,
                event_status: updatedStatusOrderFtl,
                selectedStatus: {label:e.data.status, value: e.data.status}, // Add a new state variable to store the selected status
                selectedPincode: {label:'', value:''},
                event_location: "",
                remark: {label:"", value:""},
                reason_for_delay:{label:"", value:""},
                delivered_date:new Date(),
                delivered_time:new Date(),
                errorMessage:''
            }))
            setSelectedStatusUpdate(e.data.status)
            switch (e.data.status) {
                case 0:
                    setSelectedStatusUpdate("At Source")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "At Source", label: "At Source" }
                    }));
                    break;
                case 1:
                        setSelectedStatusUpdate("Dispatched from Source")
    
                        setForm2Details((prev) => ({
                            ...prev,
                            selectedStatus: { value: "Dispatched from Source", label: "Dispatched from Source" }
                        }));
                        break;
                
                case 2:
                    setSelectedStatusUpdate("In Transit")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "In Transit", label: "In Transit" }
                    }));
                    break;
                case 3:
                    setSelectedStatusUpdate("Arrived At Destination")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "Arrived At Destination", label: "Arrived At Destination" }
                    }));
                    break;
                case 4:
                        setSelectedStatusUpdate("Out For Delivery")
    
                        setForm2Details((prev) => ({
                            ...prev,
                            selectedStatus: { value: "Out For Delivery", label: "Out For Delivery" }
                        }));
                        break;
                case 5:
                    setSelectedStatusUpdate("Delivered")

                    setForm2Details((prev) => ({
                        ...prev,
                        selectedStatus: { value: "Reached Destination", label: "Delivered" }
                    }));
                    break;
                case 10:
                        setSelectedStatusUpdate("Trip Created")
    
                        setForm2Details((prev) => ({
                            ...prev,
                            selectedStatus: { value: "Trip Created", label: "Trip Created" }
                        }));
                        break;   
                        case 11:
                            setSelectedStatusUpdate("Undelivered")
        
                            setForm2Details((prev) => ({
                                ...prev,
                                selectedStatus: { value: "Undelivered", label: "Undelivered" }
                            }));
                            break;   
                default:
                    // Optionally handle unexpected status values
                    console.warn(`Unknown status: ${e.data.status}`);
                    break;
            }
        }
      };
      const updateBulkPTLStatus = async() => {
        setshowBulkUpdateForm("slider-translate-84p")

        const x = selectedRows?.map((e)=> ({label:e.lr_no, value: e.lr_no}))
        const y =selectedRows?.map((e)=> (e.truck_no))
        const z =selectedRows?.map((e)=> (e.shipment_id))



        setIsBulkUpdate(true)

      

        // setForm2Details((prev) => ({
        //     ...prev,
        //     selectedStatus: { label: e.data.consignment_status, value: e.data.consignment_status }, // Set the selected status from e.data
        // })); 
        // if(tracking_type === "PTL"){
        //     var isValid1 = selectedRows.every(row=> row.consignment_status === selectedRows[0].consignment_status);
        //     if(!isValid1){
        //         setShow(true)
        //         setTitle("Please select the same status consignment")
        //         setType("danger")
        //         return "";
        //     }


        //     setSelectedStatusUpdate(selectedRows[0].consignment_status)
        //     setSelectLRSToUpdate(x);
        //     setSelectShipmentUpdate(z);
        //     setSelectTruckUpdate(y);


        //     setForm2Details((prev) => ({
        //         ...prev,
        //         event_status: statusOrderPtl,
        //         selectedStatus: {label:selectedRows[0].consignment_status, value: selectedRows[0].consignment_status}, // Add a new state variable to store the selected status
        //         selectedPincode: {label:'', value:''},
        //         event_location: "",
        //         remark: "",
        //         delivered_date:new Date(),
        //         errorMessage:''
        //     }))
        // } else {
        //     var isValid1 = selectedRows.every(row=> row.status === selectedRows[0].status);
        //     if(!isValid1){
        //         setShow(true)
        //         setTitle("Please select the same status consignment")
        //         setType("danger")
        //         return "";

        //     }
        //     setSelectLRSToUpdate(x);
        //     setSelectShipmentUpdate(z);
        //     setSelectTruckUpdate(y);
            
        //     setForm2Details((prev) => ({
        //         ...prev,
        //         event_status: statusOrderFtl,
        //         selectedStatus: "", // Add a new state variable to store the selected status
        //         selectedPincode: {label:'', value:''},
        //         event_location: "",
        //         remark: "",
        //         delivered_date:new Date(),
        //         errorMessage:''
        //     }))
        //     switch (selectedRows[0].status) {
        //         case 1:
        //             setSelectedStatusUpdate("At Source")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "At Source", label: "At Source" }
        //             }));
        //             break;
        //         case 2:
        //             setSelectedStatusUpdate("In Transit")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "In Transit", label: "In Transit" }
        //             }));
        //             break;
        //         case 3:
        //             setSelectedStatusUpdate("Near Destination")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "Near Destination", label: "Near Destination" }
        //             }));
        //             break;
        //         case 4:
        //             setSelectedStatusUpdate("Reached Destination")

        //             setForm2Details((prev) => ({
        //                 ...prev,
        //                 selectedStatus: { value: "Reached Destination", label: "Reached Destination" }
        //             }));
        //             break;
        //         default:
        //             // Optionally handle unexpected status values
        //             console.warn(`Unknown status: ${selectedRows[0].status}`);
        //             break;
        //     }
        // }    
        
        // setBulkPtlUpdate(true)
        // setShipmentId(e.data.shipment_id)
        // setshowAddForm2("slider-translate-30p");
        setOverlay("show-m");
      
            
     
           
      };  

    const updateBulkDeliveryDates = async () => {
        setshowBulkUpdateDeliveryForm("slider-translate-84p")
        const x = selectedRows?.map((e) => ({ label: e.lr_no, value: e.lr_no }))
        const y = selectedRows?.map((e) => (e.truck_no))
        const z = selectedRows?.map((e) => (e.shipment_id))
        setIsBulkUpdate(true)
        setOverlay("show-m");
    }; 

      const updateBulkTransporters = async() => {
        // const x = selectedRows.map((e)=> ({label:e.lr_no, value: e.lr_no}))
        // const y =selectedRows.map((e)=> (e.truck_no))
        // const z =selectedRows.map((e)=> (e.shipment_id))


        // var isValid = selectedRows.every(row=> row.tracking_type === selectedRows[0].tracking_type);
        // if(!isValid){
        //     setShow(true)
        //     setTitle("Please select the same tracking mode consignments")
        //     setType("danger")
        //     return "";
        // }
        // var tracking_type = selectedRows[0].tracking_type;

        // setBulkTrackingType(tracking_type)

      

        setshowBulkTransporterForm("slider-translate-84p")
        setOverlay("show-m");
      
            
     
           
      };
      const updateBulkLR = async() => {
        setshowBulkLRForm("slider-translate-84p")
        setOverlay("show-m");
      };  
    const onClickActive1 = (e) => {
    setselected_row(e.data);
    setshowAddForm1("slider-translate-30p");
    setOverlay("show-m");
    };
    const resetFilters = (setGridLoadshow=null) => {
    
        setSeachValue("");
        setLrNo("");
        setSearchInvoice("");
        setSearchVehicle({ value:"", label:"" });


        if(tabName.value!=="inactive" && tabName.value!=="transporter"){
            setCounterActive("Total")
            setSelectedCounter("Total")
            loadConsignmentsData(setGridLoadshow)
        }else if(tabName.value==="inactive"){
            loadNotTptConsignmentsData({
                sdate: moment.parseZone(new Date(moment().subtract(1, "month"))).format("YYYY-MM-DD"),
                edate: moment.parseZone(new Date()).format("YYYY-MM-DD"),
                date_type: "Invoice", // Default date type
              }, setGridLoadshow);
        }else if(tabName.value==="transporter"){
            loadTptConsignmentsData({
                sdate: moment.parseZone(new Date(moment().subtract(1, "month"))).format("YYYY-MM-DD"),
                edate: moment.parseZone(new Date()).format("YYYY-MM-DD"),
                date_type: "Invoice", // Default date type
              }, setGridLoadshow);
        }
        setcheckresetfilter(0);

        
         
    }
    const resetFilters1 = () => {
        setStartDate(new Date(moment.parseZone().subtract(1, "month")));
        setEndDate(new Date(moment.parseZone()));
        if(tabName.value!=="inactive" && tabName.value!=="transporter"){
            setCounterActive("Total")
            setSelectedCounter("Total")
            loadConsignmentsData(setGridLoadshow)
            
        }else if(tabName.value==="inactive"){
            loadNotTptConsignmentsData({
                sdate: moment.parseZone(new Date(moment().subtract(1, "month"))).format("YYYY-MM-DD"),
                edate: moment.parseZone(new Date()).format("YYYY-MM-DD"),
                date_type: "Invoice", // Default date type
              },setGridLoadshow);
        }else if(tabName.value==="transporter"){
            loadTptConsignmentsData({
                sdate: moment.parseZone(new Date(moment().subtract(1, "month"))).format("YYYY-MM-DD"),
                edate: moment.parseZone(new Date()).format("YYYY-MM-DD"),
                date_type: "Invoice", // Default date type
              },setGridLoadshow);
        }
        setSearchConsigner([]);
        setSearchTransporters([]);
        setSearchStates([]);
        setSearchEntity([]);
        setSearchCity([]);
        setSearchPodStatus([]);
        setSearchTrackingType({})
        setSearchPerformance({})
        setSearchDateType({ label: "Dispatch", value: "Dispatch"})
        setSearchConsigneeName([])
        
    }
    // secondboxfunction
    
//     const onGetConsignments = async (event) => {
        
//         let query = {}
//         if(searchDateType.value!==""){
//             query["date_type"] =searchDateType.value
//         }else{
//             query["date_type"] =searchDateType.value
//         }
//         // console.log("searchCity",searchCity)
//         if (searchCity && searchCity.length > 0) {
//             var citylist = []
//             searchCity.map((city) => {
//                 if(city.value !== ""){
//                     citylist.push(city.value)
//                 }
//             });
//             if(citylist.length > 0)
//             {
//                 query["consignee_city"] = citylist;
//             }
            
//         }
//         if (searchPodStatus && searchPodStatus.length > 0) {
//             query["pod_status"] = searchPodStatus.map((status) => status.value);
//         }
//         if (searchConsigneeName && searchConsigneeName.length > 0) {
//             query["customer_name"] = searchConsigneeName.map((name) => name.value);
//         }

//         if (startDate == '' || startDate == "NaN-NaN-NaN") {
//             var sDate = "";
//         }
//         else {
//             query["sdate"] = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
//         }

//         if (endDate == '' || endDate == "NaN-NaN-NaN") {
//             var eDate = "";
//         }
//         else {
//             query["edate"] = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
//         }

//         // if (searchConsigner == null || searchConsigner[0]?.value == '' || (searchConsigner.length == 1 && searchConsigner[0]?.value == 'all') ) {
//         // }
//         // else {
//         //     query["consigner_code"] = searchConsigner.map(e => e.value)
//         // }
//         if (searchConsigner && searchConsigner.length > 0) {
//             query["consigner_code"] = searchConsigner.map((e) => e.value);
//         }
//         if (searchState && searchState.length > 0) {
//             query["consignee_state"] = searchState.map((state) => state.value);
//         }
// if (searchEntity && searchEntity.length > 0) {
//     // Filter only the values in searchEntity that exist in entityConversionCase
   
//     // Only apply query if there are valid entities
//         query["truck_seal_entity"] = searchEntity.map((e) => e.value);  // Apply the valid entities to the query
    
// }

// // MY WH
// // ==========================
// // INVOICE TYPE FILTER LOGIC
// // ==========================

// // My Warehouse → show STOCK TRANSFER + DELIVERY CHALLAN
// if (
//     ["warehouse", "wh-inbound"].includes(decodedRoleCase) &&
//     processFlowType === "inbound" &&
//     warehouseTab.value === "my_warehouse"
// ) {
//     query.invoice_type = ["STOCK TRANSFER", "DELIVERY CHALLAN"];

//     if (
//         locationNameConversion &&
//         locationNameConversion.length > 0 &&
//         !locationNameConversion.includes("All Sites")
//     ) {
//         const resultPincodes = locationNameConversion
//             .map(city => locationToPincode[city.toUpperCase()])
//             .filter(Boolean);

//         if (resultPincodes.length > 0) {
//             query.consignee_pincode = resultPincodes;
//         }

//         query.consignee_name = locationNameConversion;
//     }
// }

// // My Region → hide Delivery Challan
// else if (warehouseTab.value === "my_region") {
//     query.exclude_invoice_type = "DELIVERY CHALLAN";
// }

//         // else {
//             if (zoneConversion && zoneConversion.length > 0 && !["all"].some((item) => zoneConversion.includes(item))) {
//                 if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {
//                     if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
//                         query.consignee_zone = zoneConversion;
//                     } else if (processFlowType === "inbound") {
//                         query.consignee_zone = zoneConversion;
//                     }
//                 }
//                 else {
//                     query.consignee_zone = zoneConversion;
//                 }
//             }


//             if (stateConversion && stateConversion.length > 0 && !["all"].some((item) => stateConversion.includes(item)) && (!searchState || searchState.length === 0)) {
//                 if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {
//                     if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
//                         query.consignee_state = stateConversion;
//                     }
//                     else if (processFlowType === "inbound") {
//                         query.consignee_state = stateConversion;
//                     }
//                 }
//                 else {
//                     query.consignee_state = stateConversion;
//                 }
//             }
//         // }
    
        
//         // Step 2: If `entityConversion` has values and `searchEntity` is empty, use `entityConversion`
//         if (entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item)) && (!searchEntity || searchEntity.length === 0)) {
//             query["truck_seal_entity"] = entityConversion;  // Apply entityConversion to the query if no filter is provided
//         }
//         if (searchTransporters && searchTransporters.length > 0) {
//             query["transporter_name"] = searchTransporters.map((tpt) => tpt.value);
//         }

//         if (searchPerformance.value!=="") {
//             query["ontime_status"] = searchPerformance.value
//         }

       
       
        
//         query.tabType = tabName.value;
//         query.data_type= counterActive;
       
//             query.tracking_type = searchTrackingType.value
//         if(decodedRoleCase === "transporter" && localStorage.getItem("transporter")!=="All"){
//             query.transporter_name = [localStorage.getItem("transporter")]
//         }
//         // if(localStorage.getItem("email").toLowerCase() === "patiltransport@live.com"){
//         //     query.transporter_name = "Patil Transport"
//         // }
//         // if(localStorage.getItem("email").toLowerCase() === "dilip.mishra@transolutions.com"){
//         //     query.transporter_name = "Transolution Pvt Ltd"
//         // }
//         // if(decode(localStorageRole).toLowerCase() === "user"){
//             if (
//                 locationNameConversion &&
//                 locationNameConversion.length > 0 &&
//                 !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
//         ) {            
//                 if(["user", "user-outbound", "wh-outbound", "warehouse"].includes(decodedRoleCase)){
//                    if(["user-outbound", "wh-outbound"].includes(decodedRoleCase)){
//                         query.consigner_name = locationNameConversion;
//                         query.consigner_code = locationNameConversion;
//                     }else if(processFlowType === "outbound"){
//                     query.consigner_name = locationNameConversion;
//                         query.consigner_code = locationNameConversion;
//                     } 
//             }
//         else{
//             query.consigner_name = locationNameConversion;
//             query.consigner_code = locationNameConversion;
//         }
//     }   
//             //  }
                  
                   
//         setLoadShow("show-m")  
//         if(tabName.value === "transporter"){
           
//             await redirectURL.post("consignments/filtertptConsignments", query)
//             .then(resp => {
//                 if(resp.data.tpt_assigned_details?.length>0){
//                     tptTabData(resp)
//                     setOverlay("show-n")
//                     setLoadShow("show-n")
    
//                 }else{
//                     setRowData([]);
//                     setLoadShow("show-n")
//                     setOverlay("show-n")
    
//                 }
//             })
//            }else if(tabName.value ==="inactive"){
//             await redirectURL.post("consignments/filterNotptConsignments", query)
//             .then(resp => {
//                 if(resp.data.tpt_not_assigned_details?.length>0){
//                     noTptTabData(resp)
//                     setOverlay("show-n")
//                     setLoadShow("show-n")
    
//                 }else{
//                     setRowData([]);
//                     setLoadShow("show-n")
//                     setOverlay("show-n")
    
//                 }
//             })
//            }
//         else{
//             await redirectURL.post("consignments/filterCombinedConsignments", query)
//             .then(resp => {
//                 if(resp.data.totalConsignments.length> 0 || resp.data.consignments.length > 0){
//                     fragmentData(resp)
    
//                 } else {
//                     setCountersActive({
//                         consignments: 0,
//                         inTransit: 0,
//                         transit_delays: 0,
//                         stoppages: 0,
//                         no_gps_data: 0,
//                         outfordelivery: 0,
//                         at_source:0,
//                         dispatched_from_source:0,
//                         arrived_at_destination:0
//                     })
//                     setCountersCompleted({
//                         consignments:0,
//                         // delivered: completed_delivered.length,
//                         onTime: 0,
//                         delayed: 0,
//                         podPending: 0,
//                         zeroToOneDays: 0,
//                         oneToTwoDays: 0,
//                         threeToFiveDays: 0,
//                         sixToTenDays: 0,
//                         gtTenDays: 0
//                     })
//                     setCountersAll({
//                         consignments:0,
//                         inTransit: 0,
//                         transit_delays: 0,
//                         no_gps_data: 0,
//                         stoppages: 0,
//                         disabled: 0,
//                         undelivered: 0,
//                         delivered: 0,
//                         outfordelivery:0,
//                         podPending: 0,
//                         at_source:0,
//                         dispatched_from_source:0,
//                         arrived_at_destination:0
        
//                     })
//                     setActiveTrips({
//                         all: [],
//                         inTransit: [],
//                         transit_delay: [],
//                         no_gps_data: [],
//                         stoppages: [],
//                         outForDelivery: [],
//                         undelivered: [],
//                         at_source: [],
//                         dispatched_from_source: [],
//                         arrived_at_destination: [],
//                         sim_issues: []
//                     })
//                     setCompletedTrips({
//                         all: [],
//                         // delivered: completed_delivered,
//                         onTime: [],
//                         delayed: [],
//                         podPending: [],
//                         zeroToOneDays:[],
//                         oneToTwoDays:[],
//                         threeToFiveDays:[],
//                         sixToTenDays:[],
//                         gtTenDays:[]
//                     })
//                     setAllTrips({               
//                         all: [],
//                         inTransit: [],
//                         transit_delay:[],
//                         no_gps_data: [],
//                         stoppages: [],
//                         disabled: [],
//                         undelivered: [],
//                         outForDelivery: [],
//                         delivered: [],
//                         podPending: [],
//                         at_source:[],
//                         dispatched_from_source: [],
//                         arrived_at_destination: [],
//                         sim_issues: []
        
//                     })
        
//                     // setShow(true)
//                     // setTitle("No Records Found")
//                     // setType("danger")
//                     setRowData([])
//                     setLoadShow("show-n")
    
//                 }
//             })
//             .catch(err => console.log(err))
//         }
        
       
//     }
    const onGetConsignments = async (event) => {
        let query = {};
        query.tab = warehouseTab.value;
        query.date_type = searchDateType.value !== "" ? searchDateType.value : "";
        if (startDate == '' || startDate == "NaN-NaN-NaN") {
            query.sdate = "";
        } else {
            query.sdate = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD");
        }
        if (endDate == '' || endDate == "NaN-NaN-NaN") {
            query.edate = "";
        } else {
            query.edate = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD");
        }
        query.tabType = tabName.value;
        query.data_type = counterActive;
        query.tracking_type = searchTrackingType.value;

        if (searchPerformance.value !== "") {
            query.ontime_status = searchPerformance.value;
        }

        if (decodedRoleCase === "transporter" && localStorage.getItem("transporter") !== "All") {
            query.transporter_name = [localStorage.getItem("transporter")];
        }
        if (searchTransporters && searchTransporters.length > 0) {
            query.transporter_name = searchTransporters.map((tpt) => tpt.value);
        }

        if (searchCity && searchCity.length > 0) {
            var citylist = [];
            searchCity.map((city) => {
                if (city.value !== "") citylist.push(city.value);
            });
            if (citylist.length > 0) query.consignee_city = citylist;
        }
        if (searchPodStatus && searchPodStatus.length > 0) {
            query.pod_status = searchPodStatus.map((status) => status.value);
        }
        if (searchConsigneeName && searchConsigneeName.length > 0) {
            query.customer_name = searchConsigneeName.map((name) => name.value);
        }
        if (searchConsigner && searchConsigner.length > 0) {
            query.consigner_code = searchConsigner.map((e) => e.value);
        }

        if (
            ["warehouse", "wh-inbound"].includes(decodedRoleCase) &&
            processFlowType === "inbound" &&
            warehouseTab.value === "my_warehouse" &&
            locationNameConversion &&
            !locationNameConversion.includes("All Sites")
        ) {
            const resultPincodes = locationNameConversion
                .map(city => locationToPincode[city.toUpperCase()])
                .filter(Boolean);

            if (resultPincodes.length > 0) {
                query.consignee_pincode = resultPincodes;
            }

            query.consignee_name = locationNameConversion;
            query.invoice_type = ["STOCK TRANSFER", "DELIVERY CHALLAN"];
        }

        if (warehouseTab.value === "my_region") {
            query.exclude_invoice_type = "DELIVERY CHALLAN";
        }

        if (
            locationNameConversion &&
            locationNameConversion.length > 0 &&
            !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
        ) {
            if (["user", "user-outbound", "wh-outbound", "warehouse"].includes(decodedRoleCase)) {
                if (["user-outbound", "wh-outbound"].includes(decodedRoleCase)) {
                    query.consigner_name = locationNameConversion;
                    query.consigner_code = locationNameConversion;
                } else if (processFlowType === "outbound") {
                    query.consigner_name = locationNameConversion;
                    query.consigner_code = locationNameConversion;
                }
            } else {
                query.consigner_name = locationNameConversion;
                query.consigner_code = locationNameConversion;
            }
        }

        if (zoneConversion && zoneConversion.length > 0 && !zoneConversion.includes("all")) {
            if (warehouseTab.value !== "my_warehouse" || !query.consignee_pincode) {
                if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {
                    if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
                        query.consignee_zone = zoneConversion;
                    } else if (processFlowType === "inbound") {
                        query.consignee_zone = zoneConversion;
                    }
                } else {
                    query.consignee_zone = zoneConversion;
                }
            }
        }

        if (searchState && searchState.length > 0) {
            query.consignee_state = searchState.map((state) => state.value);
        }
        else if (stateConversion && stateConversion.length > 0 && !stateConversion.includes("all")) {
            if (warehouseTab.value !== "my_warehouse" || !query.consignee_pincode) {
                if (["user", "user-inbound", "wh-inbound", "warehouse"].includes(decodedRoleCase)) {
                    if (["user-inbound", "wh-inbound"].includes(decodedRoleCase)) {
                        query.consignee_state = stateConversion;
                    } else if (processFlowType === "inbound") {
                        query.consignee_state = stateConversion;
                    }
                } else {
                    query.consignee_state = stateConversion;
                }
            }
        }
        if (searchEntity && searchEntity.length > 0) {
            query.truck_seal_entity = searchEntity.map((e) => e.value);
        }
        else if (entityConversion && entityConversion.length > 0 && !entityConversion.includes("all")) {
            query.truck_seal_entity = entityConversion;
        }

        setLoadShow("show-m");
        if (tabName.value === "transporter") {
            await redirectURL.post("consignments/filtertptConsignments", query)
                .then(resp => {
                    if (resp.data.tpt_assigned_details?.length > 0) {
                        tptTabData(resp);
                        setOverlay("show-n");
                        setLoadShow("show-n");
                    } else {
                        setRowData([]);
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                })
                .catch(err => console.log(err));
        }
        else if (tabName.value === "inactive") {
            await redirectURL.post("consignments/filterNotptConsignments", query)
                .then(resp => {
                    if (resp.data.tpt_not_assigned_details?.length > 0) {
                        noTptTabData(resp);
                        setOverlay("show-n");
                        setLoadShow("show-n");
                    } else {
                        setRowData([]);
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                })
                .catch(err => console.log(err));
        }
        else {
            // console.log(query, "FINAL FILTER QUERY TO BACKEND");
            await redirectURL.post("consignments/filterCombinedConsignments", query)
                .then(resp => {
                    if (resp.data.totalConsignments.length > 0 || resp.data.consignments.length > 0) {
                        fragmentData(resp);
                    } else {
                        setCountersActive({
                            consignments: 0, inTransit: 0, transit_delays: 0, stoppages: 0, no_gps_data: 0,
                            outfordelivery: 0, at_source: 0, dispatched_from_source: 0, arrived_at_destination: 0
                        });
                        setCountersCompleted({
                            consignments: 0, onTime: 0, delayed: 0, podPending: 0, zeroToOneDays: 0,
                            oneToTwoDays: 0, threeToFiveDays: 0, sixToTenDays: 0, gtTenDays: 0,
                            ftl_sim_issue: 0, consent_pending: 0
                        });
                        setCountersAll({
                            consignments: 0, inTransit: 0, transit_delays: 0, no_gps_data: 0, stoppages: 0,
                            disabled: 0, undelivered: 0, delivered: 0, outfordelivery: 0, podPending: 0,
                            at_source: 0, dispatched_from_source: 0, arrived_at_destination: 0
                        });
                        setActiveTrips({
                            all: [], inTransit: [], transit_delay: [], no_gps_data: [], stoppages: [],
                            outForDelivery: [], undelivered: [], at_source: [], dispatched_from_source: [],
                            arrived_at_destination: [], ftl_sim_issue: []
                        });
                        setCompletedTrips({
                            all: [], onTime: [], delayed: [], podPending: [], zeroToOneDays: [],
                            oneToTwoDays: [], threeToFiveDays: [], sixToTenDays: [], gtTenDays: [],
                            ftl_sim_issue: [], consent_pending: []
                        });
                        setAllTrips({
                            all: [], inTransit: [], transit_delay: [], no_gps_data: [], stoppages: [],
                            disabled: [], undelivered: [], outForDelivery: [], delivered: [], podPending: [],
                            at_source: [], dispatched_from_source: [], arrived_at_destination: [], ftl_sim_issue: []
                        });

                        setRowData([]);
                        setLoadShow("show-n");
                    }
                })
                .catch(err => console.log(err));
        }
    };
    const onClickShowForm=()=> {
        // setOverlay("show-m")
        // setErrorMssge("")
        // setSliderCreateConsignmentTranslate("slider-translate-30p")
        
        setOverlay("show-m")
        // setIsSliderOpen(true)
        navigate("/addConsignment")
	}
    const changeHandler = (event) => {
        const { name, value } = event.target;
        if (name === "driver_mobile_num" || name === "transit_days") {
            if (value !== "" && value !== undefined) {
                if (value > 0) {
                    setFormData(prevState => ({
                        ...prevState,
                        [name]: value.replace(/\D/g, '')
                    }));
                }
            } else {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: value.replace(/\D/g, '')
                }));
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };
    // const onClickHideAll=()=> {
	// 	var uploadfilebulk = $("#uploadfile").val(null)
	// 	this.setState({
	// 		loadshow: 'show-n',
	// 		overly: 'show-n',
	// 		slideuploadeway: '',
	// 		sliderRouteTranslate: '',
	// 		sliderSegmentTranslate: "",
	// 		tabsliderTranslate: '',
	// 		sliderTranslatesidebar: '',
	// 		sliderForceCloseTranslate: '',
	// 		sliderChangeDriverDetails:'',
	// 		sliderCommentTranslate: "",
	// 		bulkPrioritySlide: "",
	// 		sliderCreateConsignmentTranslate: "",
	// 		sliderRso:"",
	// 		sliderSimConsent:"",
	// 		uploadfilebulk:uploadfilebulk
	// 	});

	// }
    const onGridReady = useCallback((params) => {
        gridApi.current = params.api;
        gridApi2.current = params.columnApi;
    }, [tabName]);
    const onGridReadyBulkUpdate = useCallback((params) => {
        gridApiUpdateConsignments.current = params.api;
        // gridApiUpdateConsignments.current = params.columnApi;
    }, [tabName]);
    const onGridReadyBulkTransporter = useCallback((params) => {
        gridApiTransporterConsignments.current = params.api;
        // gridApiUpdateConsignments.current = params.columnApi;
    }, [tabName]);
    const onGridReadyBulkLR = useCallback((params) => {
        gridApiLRConsignments.current = params.api;
        // gridApiUpdateConsignments.current = params.columnApi;
    }, [tabName]);
    const onGridReadyDeliveryDateBulkUpdate = useCallback((params) => {
        gridApiDeliveryDateUpdate.current = params.api;
    }, [tabName]);


    function getExportableColumnKeys(columnDefs) {
        // Filter out the columns that contain custom renderers for icons or buttons
        return columnDefs.filter(col => !col.cellRenderer && !col.cellRendererSelector)
                         .map(col => col.field);
    }
    var exportParams={}
    if(tabName.value === "active"){
        const commonColumnsLR = ["tracking_type","sim_consent_status","lr_no", "invoice_no", "truck_no","status","gate_in_time","gate_out_time", "reason_for_delay","un_delivery_remark","un_delivery_datetime","invoice_time", "dispatch_date","created_date","consigner_name","consignee_code", "consginee_name", "truck_seal_entity", "invoice_type", "transporter_name", "consigner_city", "consigner_pincode",  "consigner_zone", "consignee_city", "consignee_pincode", "consignee_state",  "consignee_zone", "driver_mobile_no", "movement_type", "total_weight", "total_cbm", "tpt_category", "truck_type", "truck_seal_no", "origin_destination_area","transit_time","total_buffer_days","final_tat","last_location", "last_event_time","last_process_on", "expected_trip_end", "revised_trip_end","final_eta_dt","ontime_status", "transit_delay_days", "delay_days_bucket", "eway_bill_no",  "shipment_mode", "fuel_type", "no_of_boxes" ]
        const commonColumnsInvoice =["invoice_no","lr_no","tracking_type","sim_consent_status","truck_no","status","gate_in_time","gate_out_time","reason_for_delay","un_delivery_remark","un_delivery_datetime","invoice_time","dispatch_date","created_date","consigner_name","consignee_code","consginee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time","total_buffer_days","final_tat","last_location","last_event_time","last_process_on","expected_trip_end","revised_trip_end","final_eta_dt","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode","fuel_type","no_of_boxes","remarks" ]
        const selectedColumns = (searchViewType.value ==="LR") ? [...commonColumnsLR] : [...commonColumnsInvoice];
        if(enabledEDDEmailList?.includes(decode(localStorageEmail))){
         selectedColumns.splice(selectedColumns.indexOf("revised_trip_end")+1, 0, "estimated_delivery_date")
        }
        exportParams.columnKeys = selectedColumns;
    }
    else if (tabName.value ==="completed"){
        const commonColumnsLR = ["tracking_type","sim_consent_status","truck_no","lr_no","invoice_no","status","gate_in_time","gate_out_time","reason_for_delay","invoice_time","dispatch_date","created_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","last_location","delivery_station","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","pod_status","transit_time", "last_location", "last_event_time","last_process_on","expected_trip_end","delivery_datetime","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode","fuel_type","no_of_boxes" ]
        const commonColumnsInvoice = ["invoice_no","lr_no","tracking_type","sim_consent_status","truck_no","status","gate_in_time","gate_out_time","reason_for_delay","invoice_time","dispatch_date","created_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","last_location","delivery_station","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","pod_status","transit_time","last_event_time","last_process_on","expected_trip_end","delivery_datetime","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode","fuel_type","no_of_boxes" ]
        const selectedColumns = (searchViewType.value ==="LR") ? [...commonColumnsLR] : [...commonColumnsInvoice];
        if(enabledEDDEmailList?.includes(decode(localStorageEmail))){
         selectedColumns.splice(selectedColumns.indexOf("expected_trip_end")+1, 0, "estimated_delivery_date")
        }
        exportParams.columnKeys = selectedColumns;
    }
   
    else if(tabName.value ==="all"){
        const commonColumnsLR = ["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","gate_in_time","gate_out_time","reason_for_delay","un_delivery_remark","un_delivery_datetime","invoice_time","dispatch_date","created_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time","total_buffer_days","final_tat", "last_location", "last_event_time","last_process_on","expected_trip_end","revised_trip_end","final_eta_dt","delivery_datetime","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
            "fuel_type","no_of_boxes","remarks" ]  
        const commonColumnsInvoice = ["invoice_no","lr_no","tracking_type","sim_consent_status","truck_no","status","gate_in_time","gate_out_time","reason_for_delay","un_delivery_remark","un_delivery_datetime","invoice_time","dispatch_date","created_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time","total_buffer_days","final_tat","last_event_time","last_process_on","expected_trip_end","revised_trip_end","final_eta_dt","delivery_datetime","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode","fuel_type","no_of_boxes","remarks" ]
       const selectedColumns = (searchViewType.value ==="LR") ? [...commonColumnsLR] : [...commonColumnsInvoice];
       if(enabledEDDEmailList?.includes(decode(localStorageEmail))){
        selectedColumns.splice(selectedColumns.indexOf("revised_trip_end")+1, 0, "estimated_delivery_date")
       }
       exportParams.columnKeys = selectedColumns;
      
    }else if(tabName.value ==="force_close"){
        if(searchViewType.value ==="LR"){
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","gate_in_time","gate_out_time","reason_for_delay","invoice_time","dispatch_date","created_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "last_event_time","last_process_on","expected_trip_end","revised_trip_end","delivery_datetime","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        
        }else{
            exportParams.columnKeys=["tracking_type","sim_consent_status","lr_no","invoice_no","truck_no","status","gate_in_time","gate_out_time","reason_for_delay","invoice_time","dispatch_date","created_date","consigner_name","consignee_code","consignee_name","truck_seal_entity","invoice_type","transporter_name","consigner_city","consigner_pincode","consigner_zone","consignee_city","consignee_pincode","consignee_state","consignee_zone","driver_mobile_no","movement_type","total_weight","total_cbm","tpt_category","truck_type","truck_seal_no","origin_destination_area","transit_time", "last_location", "last_event_time","last_process_on","expected_trip_end","revised_trip_end","delivery_datetime","ontime_status","transit_delay_days","delay_days_bucket","eway_bill_no","shipment_mode",
                "fuel_type","no_of_boxes","remarks" ]        
        }
      
    }
    else if(tabName.value ==="inactive"){
        exportParams.columnKeys = ["invoice_no","invoice_time","status","invoice_upload_time","gate_in_time","gate_out_time","consigner_name","consignee_code","consignee_name","consignee_city","consignee_pincode","total_weight","total_cbm","truck_seal_entity","invoice_type","consigner_city","consigner_pincode","consigner_zone","consignee_state","consignee_zone"]
    }else if(tabName.value ==="transporter"){
        exportParams.columnKeys = ["tracking_type","invoice_no","invoice_time","status","tpt_assigned_at","gate_in_time","gate_out_time","consigner_name","consignee_code","consignee_name","consignee_city","consignee_pincode","total_weight","total_cbm","truck_seal_entity","invoice_type","consigner_city","consigner_pincode","consigner_zone","consignee_state","consignee_zone", "transporter_name"]
    }
    var updateExportParams ={}
    if(tabName.value === "active"){
        updateExportParams.columnKeys=["lr_no", "dispatch_date", "consignee_name", "consignee_city", "expected_trip_end", "status","last_location","last_event_time", "current_status", "current_location", "current_event_date_time", "reason_for_delay"]
    }
    else if(tabName.value === "completed"){
        updateExportParams.columnKeys=["lr_no", "transporter_name", "dispatch_date", "delivery_datetime", "tracking_type", "actual_delivery_date", "late_delivery_remarks","sla_considered"]
    }

    const getFormattedStatus=(row)=>{
        if((row.status) !== undefined){
            
            return statusMap[row.status] || "Not Available";
        }

        if(row.consignment_status !== undefined){
            return row.consignment_status || "Not Available"
        }

        return "Not Available";
    }
    
    const updateColDefs = (gridApi, additionalCols, selectedRows) => {
        const currentColDefs = gridApi.getColumnDefs();
    
        // Update or filter columns based on selected rows
        const updatedColumnDefs = selectedRows.length > 0
            ? [...currentColDefs, ...additionalCols] // Add additional columns
            : currentColDefs.filter(col => !["current_status", "current_location"].includes(col.field)); // Remove columns
    
        // Set updated column definitions
        gridApi.setColumnDefs(updatedColumnDefs);
    };

    const formatDate1 = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (isNaN(date.getTime())) return value; // Invalid date fallback

        const pad = (n) => n.toString().padStart(2, "0");
        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };

    const formatDate = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (isNaN(date.getTime())) return value;

        const pad = (n) => n.toString().padStart(2, "0");

        // Extract UTC components to avoid timezone offset
        const day = pad(date.getUTCDate());
        const month = pad(date.getUTCMonth() + 1);
        const year = date.getUTCFullYear();
        const hours = pad(date.getUTCHours());
        const minutes = pad(date.getUTCMinutes());

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };


   
        // const onExportClick = () => {
        //     const isAdmin = decodedRoleCase === "admin";
        //     const selectedRows = gridApiConsignments.current.getSelectedRows();

        //     const additionalColsForUpdate = [
        //         // {
        //         //     headerName: "Event Location",
        //         //     field: "last_location",
        //         //     width: 150,
        //         //     resizable: true,
        //         //     headerClass: 'bold-header',
        //         // },
        //         {
        //             headerName: "Current Status",
        //             field: "current_status",
        //             width: 150,
        //             resizable: true,
        //             headerClass: 'bold-header',
        //         },
        //         {
        //             headerName: "Current Location",
        //             field: "current_location",
        //             width: 150,
        //             resizable: true,
        //             headerClass: 'bold-header',
        //         },
        //         {
        //             headerName: "Current Event Date & Time",
        //             field: "current_event_date_time",
        //             width: 150,
        //             resizable: true,
        //             headerClass: 'bold-header',
        //         },
        //         {
        //             headerName: "Reason for delay",
        //             field: "reason_for_delay",
        //             width: 150,
        //             resizable: true,
        //             headerClass: 'bold-header',
        //         }
        //     ]

        //     let customHeaders = [];
        //     if (tabName.value === "completed" && selectedRows && selectedRows.length > 0) {
        //         const fieldToHeaderMap = {
        //             lr_no: "LR No",
        //             transporter_name: "Transporter Name",
        //             dispatch_date: "Dispatch Date",
        //             // actual_dispatch_date: "Actual Dispatch Date",
        //             delivery_datetime: "Delivery Date",
        //             tracking_type: "Tracking Mode",
        //             actual_delivery_date: "Actual Delivery Date",
        //             late_delivery_remarks: "Late Delivery Remarks",
        //             sla_considered: "SLA considered",
        //         };
        //         if (isAdmin) {
        //             fieldToHeaderMap.actual_dispatch_date = "Actual Dispatch Date";
        //         }

        //         customHeaders = updateExportParams.columnKeys.map(key => fieldToHeaderMap[key] || key);
        //     }

        //     if (tabName.value === "active" && selectedRows && selectedRows.length > 0) {
        //         const fieldToHeaderMap = {
        //             lr_no: "LR No",
        //             dispatch_date: "Dispatch Date",
        //             consignee_name: "Consignee Name",
        //             consignee_city: "Destination City",
        //             expected_trip_end: "Expected ETA",
        //             status: "Status",
        //             last_location: "Event Location",
        //             last_event_time: "Event Date & Time",
        //             current_status: "Current Status",
        //             current_location: "Current Location",
        //             current_event_date_time: "Current Event Date & Time",
        //             reason_for_delay: "Reason For Delay",

        //         };

        //         customHeaders = updateExportParams.columnKeys.map(key => fieldToHeaderMap[key] || key);
                

        //     }


        //     updateColDefs(gridApiConsignments.current, additionalColsForUpdate, selectedRows);
        //     setTimeout(() => {
        //         const exportData = selectedRows.length > 0 ? selectedRows : rowData;
        //         const params = selectedRows.length > 0 ? updateExportParams : exportParams;
        //         // console.log("Export column keys:", params.columnKeys);
        //         // if (isAdmin && tabName.value === "completed") {

        //         //     if (!params.columnKeys.includes("actual_dispatch_date")) {

        //         //         const insertAfter = "dispatch_date"; // change position if needed
        //         //         const index = params.columnKeys.indexOf(insertAfter);

        //         //         if (index !== -1) {
        //         //             params.columnKeys.splice(index + 1, 0, "actual_dispatch_date");
        //         //         } else {
        //         //             params.columnKeys.push("actual_dispatch_date");
        //         //         }
        //         //     }
        //         // }
        //         // ✅ ADMIN: Inject actual_dispatch_date BEFORE headers/data build
        //         if (isAdmin && tabName.value === "completed") {

        //             // Clone to avoid mutation bugs
        //             params.columnKeys = [...params.columnKeys];

        //             if (!params.columnKeys.includes("actual_dispatch_date")) {

        //                 const insertAfter = "dispatch_date";
        //                 const index = params.columnKeys.indexOf(insertAfter);

        //                 if (index !== -1) {
        //                     params.columnKeys.splice(index + 1, 0, "actual_dispatch_date");
        //                 } else {
        //                     params.columnKeys.push("actual_dispatch_date");
        //                 }
        //             }
        //         }


        //         const formattedData = exportData.map(row => ({
        //             ...row,
        //             status: getFormattedStatus(row),
        //             current_status: "",
        //             current_location: "",
        //             current_event_date_time: "",
        //             reason_for_delay: "",
        //         }));

        //         const filteredData = formattedData.map(row => {
        //             const filteredRow = {};

        //             (params.columnKeys || []).forEach(key => {
        //                 let value = row[key];
        //                 if (key === "expected_trip_end") {
        //                     value = value || row["expected_eta"];
        //                 }

        //                 if ((tabName.value === "completed" || tabName.value === "active") && ["dispatch_date","actual_dispatch_date", "expected_trip_end", "last_event_time", "delivery_datetime", "actual_delivery_date"].includes(key)) {
        //                     value = formatDate(value);  // Format as dd/mm/yyyy hh:mm
        //                 }
        //                 filteredRow[key] = value;
        //             });

        //             return filteredRow;
        //         });

        //         // console.log("Filtered data rows:", filteredData.length, filteredData);

        //         let wsMain;

        //         if ((tabName.value === "completed" || tabName.value === "active") && customHeaders.length > 0) {
        //             wsMain = XLSX.utils.aoa_to_sheet([customHeaders]);
        //             XLSX.utils.sheet_add_json(wsMain, filteredData, { skipHeader: true, origin: "A2" });
        //         } else {
        //             wsMain = XLSX.utils.json_to_sheet(filteredData, {
        //                 header: params.columnKeys,
        //             });
        //         }


        //         // Reference Sheet
        //         const referenceData = [
        //             ["* Status (status)"],
        //             ["Dispatched from source"],
        //             ["In Transit"],
        //             ["Arrived at destination"],
        //             ["Out for delivery"],
        //             ["Delivered"],
        //             ["UnDelivered"],
        //             [],

        //             ["* Reason For Delay (reason_for_delay)"],
        //             ["Local/Public holidays"],
        //             ["Natural Calamity"],
        //             ["Transporter Issue"],
        //             ["Customer Issue"],
        //             [],

        //             ["* Date & Time Format (current_event_date_time)"],
        //             ["DD-MM-YYYY HH:MM"],
        //             ["DD/MM/YYYY HH:MM"],
        //             ["e.g., 28-05-2025 14:30"]
        //         ];

        //         const wsReference = XLSX.utils.aoa_to_sheet(referenceData);

        //         const boldCells = ['A1', 'A9', 'A15'];

        //         boldCells.forEach(cell => {
        //             if (!wsReference[cell]) return;
        //             wsReference[cell].s = {
        //                 font: {
        //                     bold: true
        //                 }
        //             };
        //         });

        //         // Append both sheets to workbook
        //         const wb = XLSX.utils.book_new();
        //         XLSX.utils.book_append_sheet(wb, wsMain, "Consignments");

        //         if (selectedRows && selectedRows.length > 0 && tabName.value === "active") {
        //             XLSX.utils.book_append_sheet(wb, wsReference, "Reference File");
        //         }

        //         if (selectedRows && selectedRows.length > 0) {
        //             // Write file
        //             XLSX.writeFile(wb, "Consignments_Export.xlsx");
        //         }
        //         else {

        //             let updatedParams = { ...params };

        //             if (tabName.value === "completed") {

        //                 const insertAfter = "delivery_datetime";

        //                 let keys = [...updatedParams.columnKeys];

        //                 const insertIndex = keys.indexOf(insertAfter);

        //                 if (insertIndex !== -1) {

        //                     if (!keys.includes("actual_delivery_date")) {
        //                         keys.splice(insertIndex + 1, 0, "actual_delivery_date");
        //                     }

        //                     if (!keys.includes("late_delivery_remarks")) {
        //                         keys.splice(insertIndex + 2, 0, "late_delivery_remarks");
        //                     }

        //                 } else {
        //                     // fallback if delivery_datetime not found
        //                     if (!keys.includes("actual_delivery_date")) {
        //                         keys.push("actual_delivery_date");
        //                     }

        //                     if (!keys.includes("late_delivery_remarks")) {
        //                         keys.push("late_delivery_remarks");
        //                     }
        //                 }

        //                 updatedParams.columnKeys = keys;
        //             }



        //             gridApiConsignments.current.exportDataAsExcel(updatedParams);
        //         }



        //         gridApiConsignments.current.setRowData(formattedData);
        //     }, 0);
        // }
    const onExportClick = () => {
        const isAdmin = decodedRoleCase === "admin";
        const selectedRows = gridApiConsignments.current.getSelectedRows();

        const additionalColsForUpdate = [
            {
                headerName: "Current Status",
                field: "current_status",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            },
            {
                headerName: "Current Location",
                field: "current_location",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            },
            {
                headerName: "Current Event Date & Time",
                field: "current_event_date_time",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            },
            {
                headerName: "Reason for delay",
                field: "reason_for_delay",
                width: 150,
                resizable: true,
                headerClass: 'bold-header',
            }
        ];

        updateColDefs(gridApiConsignments.current, additionalColsForUpdate, selectedRows);

        setTimeout(() => {

            // const exportData = selectedRows.length > 0 ? selectedRows : rowData;
            let exportData = [];

            if (selectedRows.length > 0) {
                gridApiConsignments.current.forEachNode((node) => {
                    if (node.isSelected()) {
                        exportData.push(node.data); 
                    }
                });
            } else {
                gridApiConsignments.current.forEachNode((node) => {
                    exportData.push(node.data);
                });
            }
            const params = selectedRows.length > 0 ? updateExportParams : exportParams;
            if (isAdmin && tabName.value === "completed") {
                params.columnKeys = [...params.columnKeys];
                if (!params.columnKeys.includes("actual_dispatch_date")) {
                    const insertAfter = "dispatch_date";
                    const index = params.columnKeys.indexOf(insertAfter);
                    if (index !== -1) {
                        params.columnKeys.splice(index + 1, 0, "actual_dispatch_date");
                    } else {
                        params.columnKeys.push("actual_dispatch_date");
                    }
                }
            }
            let customHeaders = [];

            if (selectedRows.length > 0) {
                if (tabName.value === "completed") {
                    const fieldToHeaderMap = {
                        lr_no: "LR No",
                        transporter_name: "Transporter Name",
                        dispatch_date: "Dispatch Date",
                        delivery_datetime: "Delivery Date",
                        tracking_type: "Tracking Mode",
                        actual_delivery_date: "Actual Delivery Date",
                        late_delivery_remarks: "Late Delivery Remarks",
                        sla_considered: "SLA considered",
                    };
                    if (isAdmin) {
                        fieldToHeaderMap.actual_dispatch_date = "Actual Dispatch Date";
                    }
                    customHeaders = params.columnKeys.map(
                        key => fieldToHeaderMap[key] || key
                    );
                }
                if (tabName.value === "transporter") {
                    params.columnKeys = [
                        "invoice_no",
                        "transporter_name",
                        "lr_no",
                        "dispatch_date",
                        "vehicle_no",
                        "vehicle_type",
                        "fuel_type",
                        "tracking_type",
                        "eway_bill_no",
                        "mode",
                        "number_of_boxes",
                        "driver_mobile_no"
                    ];
                }
                if (tabName.value === "active") {

                    const fieldToHeaderMap = {
                        lr_no: "LR No",
                        dispatch_date: "Dispatch Date",
                        consignee_name: "Consignee Name",
                        consignee_city: "Destination City",
                        expected_trip_end: "Expected ETA",
                        status: "Status",
                        last_location: "Event Location",
                        last_event_time: "Event Date & Time",
                        current_status: "Current Status",
                        current_location: "Current Location",
                        current_event_date_time: "Current Event Date & Time",
                        reason_for_delay: "Reason For Delay",
                    };

                    customHeaders = params.columnKeys.map(
                        key => fieldToHeaderMap[key] || key
                    );
                }
            }
            const formattedData = exportData.map(row => ({
                ...row,
                status: getFormattedStatus(row),
                current_status: "",
                current_location: "",
                current_event_date_time: "",
                reason_for_delay: "",
            }));


            const filteredData = formattedData.map(row => {

                const filteredRow = {};
                (params.columnKeys || []).forEach(key => {

                    // let value = row[key];
                    let value = row[key] ?? "";
                    if (key === "expected_trip_end") {
                        value = value || row["expected_eta"];
                    }

                    if (
                        (tabName.value === "completed" || tabName.value === "active") &&
                        [
                            "dispatch_date",
                            "actual_dispatch_date",
                            "expected_trip_end",
                            "last_event_time",
                            "delivery_datetime",
                            "actual_delivery_date"
                        ].includes(key)
                    ) {
                        value = formatDate(value);
                    }

                    filteredRow[key] = value;
                });

                return filteredRow;
            });
            let wsMain;
            // if (tabName.value === "inactive") {
            //         const headers = [
            //             "Invoice No",
            //             "Transporter Name"
            //         ];

            //         const mappedData = exportData.map(row => [
            //             row.invoice_no || "",
            //             row.transporter_name || ""
            //         ]);

            //         wsMain = XLSX.utils.aoa_to_sheet([
            //             headers,
            //             ...mappedData
            //         ]);
            //     }
            // else 
                if (tabName.value === "transporter") {

                const headers = [
                    "Invoice No",
                    "Transporter Name",
                    "LR No",
                    "Dispatch Date",
                    "Vehicle No",
                    "Vehicle Type",
                    "Fuel Type",
                    "Tracking Mode (FTL/PTL)",
                    "E-Way Bill No",
                    "Mode",
                    "Number Of Boxes",
                    "Driver Mobile No"
                ];

                const mappedData = exportData.map(row => {
                    let fuelValue = "";

                    if (row.fuel_type && !Array.isArray(row.fuel_type)) {
                        fuelValue = row.fuel_type;
                    }

                    return [
                        row.invoice_no || "",
                        row.transporter_name || "",
                        row.lr_no || "",
                        row.dispatch_date || "",
                        row.vehicle_no || "",
                        row.vehicle_type || "",
                        fuelValue,
                        row.tracking_type || "",
                        row.eway_bill_no || "",
                        row.mode || "",
                        row.number_of_boxes || "",
                        row.driver_mobile_no || ""
                    ];
                });

                wsMain = XLSX.utils.aoa_to_sheet([
                    headers,
                    ...mappedData
                ]);

            }
            else if (
                (tabName.value === "completed" || tabName.value === "active") &&
                customHeaders.length > 0
            ) {

                wsMain = XLSX.utils.aoa_to_sheet([customHeaders]);

                XLSX.utils.sheet_add_json(
                    wsMain,
                    filteredData,
                    { skipHeader: true, origin: "A2" }
                );

            } 
            // else {

            //     wsMain = XLSX.utils.json_to_sheet(filteredData, {
            //         header: params.columnKeys,
            //     });
            // }
            else if (tabName.value !== "inactive") {

                wsMain = XLSX.utils.json_to_sheet(filteredData, {
                    header: params.columnKeys,
                });
            }


            const referenceData = [
                ["* Status (status)"],
                ["Dispatched from source"],
                ["In Transit"],
                ["Arrived at destination"],
                ["Out for delivery"],
                ["Delivered"],
                ["UnDelivered"],
                [],

                ["* Reason For Delay (reason_for_delay)"],
                ["Local/Public holidays"],
                ["Natural Calamity"],
                ["Transporter Issue"],
                ["Customer Issue"],
                [],

                ["* Date & Time Format (current_event_date_time)"],
                ["DD-MM-YYYY HH:MM"],
                ["DD/MM/YYYY HH:MM"],
                ["e.g., 28-05-2025 14:30"]
            ];

            const wsReference = XLSX.utils.aoa_to_sheet(referenceData);

            const boldCells = ['A1', 'A9', 'A15'];

            boldCells.forEach(cell => {
                if (!wsReference[cell]) return;
                wsReference[cell].s = {
                    font: { bold: true }
                };
            });

            const wb = XLSX.utils.book_new();
            // XLSX.utils.book_append_sheet(wb, wsMain, "Consignments");
            // if (tabName.value === "transporter") {
            //     XLSX.utils.book_append_sheet(wb, wsMain, "Sheet1");
            // } else {
            //     XLSX.utils.book_append_sheet(wb, wsMain, "Consignments");
            // }
            // if (
            //     tabName.value === "transporter" ||
            //     tabName.value === "inactive"
            // ) {
            //     XLSX.utils.book_append_sheet(wb, wsMain, "Sheet1");
            // } else {
            //     XLSX.utils.book_append_sheet(wb, wsMain, "Consignments");
            // }
            if (tabName.value === "transporter") {
                XLSX.utils.book_append_sheet(wb, wsMain, "Sheet1");
            }
            else if (tabName.value !== "inactive") {
                XLSX.utils.book_append_sheet(wb, wsMain, "Consignments");
            }
            if (selectedRows.length > 0 && tabName.value === "active") {
                XLSX.utils.book_append_sheet(
                    wb,
                    wsReference,
                    "Reference File"
                );
            }
            // if (selectedRows.length > 0 || tabName.value === "inactive") {

            //     XLSX.writeFile(wb, "Consignments_Export.xlsx");

            // } 
            // if (selectedRows.length > 0) {

            //     XLSX.writeFile(wb, "Consignments_Export.xlsx");

            // }
            if (selectedRows.length > 0) {
                if (tabName.value === "inactive") {
                    const headers = [
                        "Invoice No",
                        "Transporter Name"
                    ];
                    const mappedData = exportData.map(row => [
                        row.invoice_no || "",
                        row.transporter_name || ""
                    ]);
                    const wsInactive = XLSX.utils.aoa_to_sheet([
                        headers,
                        ...mappedData
                    ]);
                    const wbInactive = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(
                        wbInactive,
                        wsInactive,
                        "Sheet1"
                    );
                    XLSX.writeFile(
                        wbInactive,
                        "Consignments_Export.xlsx"
                    );
                } else {

                    XLSX.writeFile(wb, "Consignments_Export.xlsx");
                }
            }
            else if (tabName.value === "inactive") {
                const allColumns =
                    columnApiConsignments.current
                        .getColumns()
                        .filter(col => {
                            const header = col.getColDef().headerName;
                            const colId = col.getColId();

                            return (
                                header &&
                                header !== "Check" &&
                                colId !== "checkbox" &&
                                colId !== "actions"
                            );
                        })
                        .map(col => col.getColId());

                gridApiConsignments.current.exportDataAsExcel({
                    fileName: "Consignments_Export.xlsx",
                    columnKeys: allColumns
                });
            }
            else {

                let updatedParams = { ...params };

                if (tabName.value === "completed") {

                    const insertAfter = "delivery_datetime";

                    let keys = [...updatedParams.columnKeys];

                    const insertIndex = keys.indexOf(insertAfter);

                    if (insertIndex !== -1) {

                        if (!keys.includes("actual_delivery_date")) {
                            keys.splice(insertIndex + 1, 0, "actual_delivery_date");
                        }

                        if (!keys.includes("late_delivery_remarks")) {
                            keys.splice(insertIndex + 2, 0, "late_delivery_remarks");
                        }

                    } else {

                        if (!keys.includes("actual_delivery_date")) {
                            keys.push("actual_delivery_date");
                        }

                        if (!keys.includes("late_delivery_remarks")) {
                            keys.push("late_delivery_remarks");
                        }
                    }

                    updatedParams.columnKeys = keys;
                }


                // gridApiConsignments.current.exportDataAsExcel(updatedParams);
                if (!columnApiConsignments.current) {
                    console.error("Column API not ready");
                    return;
                }

                const displayedColumns =
                    columnApiConsignments.current
                        .getAllDisplayedColumns()
                        .filter(col => {
                            const header = col.getColDef().headerName;
                            const colId = col.getColId();

                            return (
                                header &&                   
                                header !== "Check" &&        
                                colId !== "checkbox" &&      
                                colId !== "actions"          
                            );
                        })
                        .map(col => col.getColId());

                gridApiConsignments.current.exportDataAsExcel({
                    ...updatedParams,
                    columnKeys: displayedColumns
                });



            }


            gridApiConsignments.current.setRowData(formattedData);

        }, 0);
    };
    const updateColumnVisibilityAndLock = () => {
        
        if (
            tabName.value === "completed" ||
            counterActive === "Undelivered" ||
            counterActive === "Stoppages" ||
            counterActive === "Tracking N/A" ||
            counterActive === "Disabled"
        ) {
            columnApiConsignments.current?.setColumnsVisible(["cancel_order"], false); // Hide cancel_order column

        }else{
            columnApiConsignments.current?.setColumnsVisible(["cancel_order"], true); // Hide cancel_order column
        }
    
        if ((tabName.value === "inactive" || tabName.value === "transporter") && warehouseDisableIcons) {
            columnApiConsignments.current?.setColumnsVisible(["checkbox", "cancel_order", "update_tpt"], false); // Hide checkbox and other columns
                    }else{
                        columnApiConsignments.current?.setColumnsVisible(["checkbox", "cancel_order", "update_tpt"], true); // Hide checkbox and other columns
                    }
    
        if ((tabName.value === "active" || tabName.value === "all") && warehouseDisableIcons) {
            columnApiConsignments.current?.setColumnsVisible(["update", "cancel_order"], false); // Hide update and cancel_order columns
        }else{
            columnApiConsignments.current?.setColumnsVisible(["update", "cancel_order"], true); // Hide update and cancel_order columns
        }

    };
    const onGridReadyConsignments = useCallback((params) => {
        // agGridRef.current = params;

    // Restore filters if available
    // const savedFilters = localStorage.getItem("gridFilters");
    // if (savedFilters) {
    //     const filterModel = JSON.parse(savedFilters);
    //     params.api.setFilterModel(filterModel);
    // }
        gridApiConsignments.current = params.api;
        columnApiConsignments.current = params.columnApi;
        setGridApif(params.api);

        updateColumnVisibilityAndLock()
    
        
        // const exportParams = {
        //     columnKeys:["tracking_type","lr_no", "invoice_no", "truck_no","consignment_status", "reason_for_delay", "invoice_time", "dispatch_date", "consginee_name", "truck_seal_entity", "invoice_type", "transporter_name", "consigner_city", "consigner_pincode",  "consigner_zone", "consignee_city", "consignee_pincode", "consignee_state",  "consignee_zone", "driver_mobile_no", "movement_type", "total_weight", "total_cbm", "tpt_category", "truck_type", "truck_seal_no", "origin_destination_area", "transit_time", "last_process_on", "expected_trip_end", "revised_trip_end", "delivery_performance", "eway_bill_no",  "shipment_mode", "fuel_type", "no_of_boxes" ]
        // };
        
        // gridApiConsignments.current.exportDataAsExcel(exportParams);
        
        
        // const exportParams = {
        //     columnKeys: params.api
        //         .getAllColumns()  // Get all columns
        //         .slice(2)  // Exclude the first column (index 0)
        //         .map(col => col.getColId())  // Map columns to their field (colId)
        // };
        // // // Replace default Excel export behavior with the custom one
        // params.api.gridOptionsWrapper.gridOptions.getContextMenuItems = () => {
        //     //console.log("Default Context Menu Items:", defaultItems); // Debug default items
        //     const customMenu = [
        //         // ...defaultItems, // Retain default items
        //         {
        //             name: "Export to Excel",
        //             action: () => {
        //                 //console.log("Export to Excel triggered"); // Debug when action is triggered
        //                 gridApiConsignments.current.exportDataAsExcel(exportParams);
        //             },
        //         },
        //     ];
        //     //console.log("Custom Menu Items:", customMenu); // Debug custom menu
        //     return customMenu; // Return modified menu
        // };

        }, [tabName.value, counterActive, processFlowType]);
    const onClickHideManualUpload = () => {
        setshowAddForm("");
        setOverlay("show-n");
        setmanualUploadDetails((prev) => ({
          ...prev,
          lr_no: "",
          lr_status: {label:"",value:''},
        }));
        setmanualUploadDetails1((prev)=> ({
            ...prev,
            lr_no: "",
            invoice_no: selected_row.invoice_no || '',
            consignee_name: "",
            consignee_city: "",
            consignee_state: "",
            consignee_pincode: "",
            total_weight: ""
        }))
    };
    const onCloseUpdateDetails= () => {
        setManualInTransitStatusUpdate({dispatch_time:""})
        // setManualInTransitStatusUpdate.dispatch_time("")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            lr_no: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setDselected_row({})        
        document.getElementById("uploadDoc").value = "";
        // document.getElementById("File").value = "";
        setSliderShow1("")
        setSliderShow("");
        setDocRemarks("")
        setshowAddForm2("")
        setForm2Details({
            event_status:statusOrderFtl,
            selectedStatus: {value: 'In Transit', label: 'In Transit'},
            selectedPincode: {value: '', label: ''},
            event_location: "",
            remark: {label:"", value:""},
            reason_for_delay:{label:"", value:""},
            delivered_date:new Date(),
            delivered_time:new Date(),
            errorMessage:''
        })
        setshowAddForm("")
        setshowAddForm3("")
        setErrorMssge("");
        setEnableSourceField(false);
        
        setShowUpdateLrForm("")
        setSliderCreateConsignmentTranslate("")
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setLoadShow("show-n")
        setSliderCreateConsignmentTranslate("")
        setManualTripUploadDetails([])
        setManualUpdateConsignment({
            driver_number: '',
            source: "",
            truck_no: "",
            truck_seal_no: "",
            vehicle_type: "",
            courier_partner:"",
            vehicle_capacity: "",
            consignee_name: "",
            lr_no: "",
            invoice_no: "",
            no_of_boxes: "",
            destination_pincode: "",
            destination_city:""
          })
        document.getElementById("epodDoc").value = "";
        setDamage("")
        setExcess("")
        setPilferage("")
        setShort("")
        setPodRemarks("")
        document.getElementById("formPOD").reset();
        setFormData({
            driver_mobile_no:'',
            source:'',
            other_source:'',
            other_source_pincode:'',
            truck_no:'',
            truck_seal_no:'',
            entity:'',
            vehicle_type:{label:'', value:''},
            courier_partner:{label:'', value:''},
            eway_bill_expiry_date:'',
            invoice_date:'',
            total_weight:'',
            total_cbm:'',
            // vehicle_capacity:{label:'', value:''},
            vehicle_capacity:'',
            consignee_name:'',
            consignee_name1:"",

            movement_type:'',
            lr_no:'',
            invoice_no:[],
            invoice_no_str:"",
            consigner_name:"",
            number_of_boxes:'',
            destination_pincode:'',
            destination_city:'',
            show: false,
            basicType: '',
            basicTitle: '',
            sliderCreateConsignmentTranslate: '',
            loadshow: 'show-n',
            overly: 'show-n',
            dispatch_time:new Date()
        })
    }
const onClickGateOutUpdate = (e)=>{
    e.preventDefault();
    setGateOutSlide("slide95")
    setOverlay("show-m")
    setGateOutRow(e.data)
}

const handleDispatchClick = (e) => {
    e.stopPropagation(); // Prevent the row from being selected
    // setselected_row(e.data);
    // setshowAddForm("slide30");
    
    setDispatchTime(!dispatchTime)// Call the provided function
};
// const changeHandleDate = (date) => {
//     // Ensure both 'date' and 'invoice_time' are Date objects
//     const invoice_time = new Date(Dselected_row.invoice_time);  // Invoice time from your data source
//     const selectedDate = new Date(date);  // The date you're passing to the function

//     // Reset time to midnight for both dates (ignoring time part)
//     invoice_time.setHours(0, 0, 0, 0);  // Set time to midnight for invoice time
//     selectedDate.setHours(0, 0, 0, 0);  // Set time to midnight for selected date

//     // Extract year, month, and day from both dates
//     const invoiceYear = invoice_time.getFullYear();
//     const invoiceMonth = invoice_time.getMonth(); // Months are zero-indexed, so January is 0
//     const invoiceDate = invoice_time.getDate();

//     const selectedYear = selectedDate.getFullYear();
//     const selectedMonth = selectedDate.getMonth();
//     const selectedDay = selectedDate.getDate();

//     //console.log(selectedYear, selectedMonth, selectedDay, "selectedDate");
//     //console.log(invoiceYear, invoiceMonth, invoiceDate, "invoiceTime");

//     // Compare the date parts (year, month, and day)
//     if (
//         selectedYear >= invoiceYear || 
//         (selectedYear === invoiceYear && selectedMonth >= invoiceMonth) || 
//         (selectedYear === invoiceYear && selectedMonth === invoiceMonth && selectedDay >= invoiceDate)
//     ) {
//         setManualInTransitStatusUpdate((prev) => ({
//             ...prev,
//             dispatch_time: selectedDate,
//         }));
//     } else {
//         setShow(true);
//         setTitle("Dispatch date should be greater than invoice date");
//         setType("danger");
//     }
// };
const changeHandleDate = (date) => {

    setManualInTransitStatusUpdate((prev) => ({
        ...prev,
        dispatch_time: date,
        }))};
        
        const changeHandleDate2 = (date) => {
            
                setManualUpdateLRConsignment((prev) => ({
                    ...prev,
                    dispatch_time: date,
                }));
                
        };


const hideGateoutSubmit = ()=>{
    setGateOutSlide("");
    setOverlay("show-n");

}
    const onClickHideManualUpload1 = () => {
        setshowAddForm("");
        showAddForm1("")
        setOverlay("show-n");
        setmanualUploadDetails1((prev) => ({
          ...prev,
          invoice_no:'',
          lr_no: "",
        }));
      };
    const onsubmitdata = (e) => {
        e.preventDefault()
        var data = {
            invoice_no: manualUploadDetails1.invoice_no,
            consignee_name: manualUploadDetails1.consignee_name,
            consignee_city:manualUploadDetails1.consignee_city,
            consignee_state: manualUploadDetails1.consignee_state,
            consignee_pincode:manualUploadDetails1.consignee_pincode,
            total_weight:manualUploadDetails1.total_weight
        }
        redirectURL.post('/consignments/updatePTLConsignments', data).then((resp) => {
            if (resp.data.message == 'success') {
                setShow(true)
                setTitle("PTL Consignments has been successfully updated!")
                setType("success")
                setLoadShow('show-n')
                setOverlay('show-n')
                setshowAddForm('')
                setmanualUploadDetails1({
                    lr_no: "",
                    invoice_no: selected_row.invoice_no || '',
                    consigner_name: "",
                    consignee_city: "",
                    consignee_state: "",
                    consignee_pincode: "",
                    total_weight: ""
                })
                // window.location.reload();
            }
            else{
                setShow(true)
                setTitle("Please Upload Valid Details")
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n')
                setmanualUploadDetails1({
                    lr_no: "",
                    invoice_no: selected_row.invoice_no || '',
                    consigner_name: "",
                    consignee_city: "",
                    consignee_state: "",
                    consignee_pincode: "",
                    total_weight: ""
                })
            }
        })
        setmanualUploadDetails((prev) => ({
            ...prev,
            lr_no: "",
            lr_status: {label:"",value:''},
            location: "",
            arrival_time: "",
            invoice_no: "",
          }));

    } 
    const updateDispatchTime = (dispatch_time) => {
        // Prepare the data to be sent in the POST request
        const data = {
            dispatch_time: moment.parseZone(dispatch_time).utcOffset("+05:30")._d,  // Convert the dispatch time to the desired timezone
            shipment_id: Dselected_row.shipment_id,
            truck_no: Dselected_row.truck_no,
            tracking_type: Dselected_row.tracking_type,
             source_from: "web"
        };
    
        // Send the request to the backend
        redirectURL.post('/consignments/updatedispatchtime', data)
            .then((resp) => {
                if (resp.data.message === 'success') {
                    // Success Response
                    setShow(true);
                    setTitle("Dispatch time has been successfully updated!");
                    setType("success");
                    setLoadShow('show-n');
                    setOverlay('show-n');
                    setshowAddForm1('');
                    setshowAddForm2('');
                    // Optionally reload the page or trigger any necessary UI updates
                    // window.location.reload();
                    // props.onRequest('2');
                    // setreloadcheck(true);
                } else {
                    // Failure Response
                    setShow(true);
                    setTitle("Please Upload Valid Details");
                    setType("danger");
                    setLoadShow('show-n');
                    setOverlay('show-n');
                }
            })
            .catch((error) => {
                // Handle any network or server errors
                setShow(true);
                setTitle("An error occurred while updating dispatch time.");
                setType("danger");
                setLoadShow('show-n');
                setOverlay('show-n');
                console.error('Error updating dispatch time:', error);
            });
    };
    
    const onsubmitdata1 = async(e) => {
        setGateOutSlide("")


        e.preventDefault()
        
        const invoice_time1 = moment(Dselected_row.invoice_time);  // Parse the date from your data source
        const adjustedTime = invoice_time1.subtract(5, 'hours').subtract(30, 'minutes');
        const invoice_time= adjustedTime.toDate()

        const selectedDate = new Date(manualInTransitStatusUpdate.dispatch_time);  // The date you're passing to the function
    
        // Log for debugging
        //console.log(selectedDate, invoice_time, "selectedDate and invoice_time");
    
        // Check if the selected date is the same day as the invoice date
        const isSameDay = selectedDate.toDateString() === invoice_time.toDateString();
        
    
        if (isSameDay) {
            // If the selected date is the same day, ensure the time is greater than or equal to the invoice time
            if (selectedDate >= invoice_time) {
                // If selected date and time is greater than or equal to invoice time
                updateDispatchTime(manualInTransitStatusUpdate.dispatch_time)
            } else {
                // If selected time is earlier than invoice time
                setShow(true);
                setTitle("Dispatch time should be greater than or equal to invoice time");
                setType("danger");
            }
        } else if (selectedDate > invoice_time) {
            // If the selected date is later than the invoice date, it's valid
            updateDispatchTime(manualInTransitStatusUpdate.dispatch_time)

        } else {
            // If the selected date is earlier than the invoice date, it's invalid
            setShow(true);
            setTitle("Dispatch date should be greater than invoice date");
            setType("danger");
        }        
      
        // }
        // else{
        //     setshow(true)
        //     setbasicTitle("Please Select Transporter")
        //     setbasicType("danger")
        //     setloadshow('show-n')
        //     setoverly('show-n')
        // }
        // setmanualUploadDetails14((prev) => ({
        //     ...prev,
        //     dispatch_time: "",
          
        //   }));

    } 
    const handleRemoveDropPoint = (id) => {        
        setManualTripUploadDetails((prevDetails) => prevDetails.filter(point => point.id !== id));
        setSelectedConsignees((prevSelected) => {
            const removedConsignee = manualTripUploadDetails.find(point => point.id === id)?.consignee_name;
            return prevSelected.filter(name => name !== removedConsignee);
        });
    };
    
    const handleConsigneeChange = (pointId, consigneeName) => {
        setManualTripUploadDetails((prevDetails) =>
            prevDetails.map((point) => {
                if (point.id === pointId) {
                    const updatedPoint = { ...point, consignee_name: consigneeName };
                    if (consigneeName === "Others") {
                        updatedPoint.destination_pincode = "";
                        updatedPoint.destination_city = "";
                        setShowCustomConsigneeInput((prev) => ({
                            ...prev,
                            [pointId]: true, 
                        }));
                    } else {
                        setShowCustomConsigneeInput((prev) => ({
                            ...prev,
                            [pointId]: false, 
                        }));
                    }
    
                    return updatedPoint;
                }
                return point;
            })
        );
    };
    
    const setShowCustomConsigneeInputFun = (pointId, isVisible) => {
        setShowCustomConsigneeInput(prev => ({
            ...prev,
            [pointId]: isVisible,
        }));
    };
    const fetchDestinationDetails = async (consigneeCode, pointId) => {
        try {
    
            const response = await redirectURL.post('/consignments/getDestinationDetails', { consignee_code: consigneeCode });
            const data = response.data.consigneeDetails[0]; 
            if (data) {
                setManualTripUploadDetails(prevDetails =>
                    prevDetails.map(point =>
                        point.id === pointId
                            ? {
                                  ...point,
                                  destination_pincode: data.consignee_pincode, 
                                  destination_city: data.consignee_city, 
                              }
                            : point
                    )
                );
            }
        } catch (error) {
            console.error("Error fetching destination details:", error);
        }
    };
    const handleInputChange = (id, field, value) => {
        const invoiceNumberPattern = /^\d+\/[A-Za-z]{3}$/;
    
        // Handle validation for invoice number
        if (field === 'invoice_no') {
            const invoicePattern = /^[A-Za-z0-9]+\/.*/;

            if(invoicePattern.test(value)){
                //console.log(invoiceNos, "invoicenossss");

                    const lowerCase = value.toLowerCase();
                    
                //     var isValid = invoiceNos.includes(lowerCase);
                //         if(isValid){
                //         setShow(true);
                //         setTitle("Please select unique invoice no")
                //         setType("danger")
                //         return;
                // }
                const invoiceSeries = value.split("/")[1].toLowerCase();
                const selectedSource = (formData.source.value).toLowerCase();
                //console.log(invoiceSeries, selectedSource, "889900");
                
                // if(selectedSource === invoiceSeries){
                //     setValidationErrors((prev) => ({
                //         ...prev,
                //         [id]: {
                //             ...prev[id],
                //             invoice_no: '',
                //         },
                //     }));
                //     setIsValid1(false)
                // }else{
                //     setValidationErrors((prev) => ({
                //         ...prev,
                //         [id]: {
                //             ...prev[id],
                //             invoice_no: 'Invalid Invoice number',
                //         },
                //     }));
                //     setIsValid1(true)
                // }
                
            }else if(!(invoicePattern.test(value))){
                setValidationErrors((prev) => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        invoice_no: '',
                    },
                }));
                // setIsValid1(true)

            }else{
                setValidationErrors((prev) => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        invoice_no: 'Invalid Invoice number',
                    },
                }));
                setIsValid1(true)
            }
            // const invoiceValue = value.split("/")
            // if (!validateInput(value)) {
            //     //console.log("Invalid invoice");
    
            //     // Set validation error for invoice_no
            //     setValidationErrors((prev) => ({
            //         ...prev,
            //         [id]: {
            //             ...prev[id],
            //             invoice_no: 'Invalid Invoice number',
            //         },
            //     }));
            // } else {
            //     // Clear validation error if valid
            //     setValidationErrors((prev) => ({
            //         ...prev,
            //         [id]: {
            //             ...prev[id],
            //             invoice_no: '',
            //         },
            //     }));
            // }
        }
    
        // Update manualTripUploadDetails
        setManualTripUploadDetails((prevDetails) =>
            prevDetails.map((point, idx) => {
                if (idx === id) {
                    const updatedPoint = { ...point, [field]: value };
    
                    // Check if consignee_name is "Others" and toggle visibility for the specific index
                    if (field === 'consignee_name') {
                        const isOthersSelected = value === "Others";
    
                        setShowOthersConsignee((prevVisibility) => {
                            const updatedVisibility = [...prevVisibility];
                            updatedVisibility[id] = isOthersSelected; // Set true for this index if "Others" is selected
                            return updatedVisibility;
                        });
    
                        // Initialize fields for "Others" if consignee_name is "Others"
                        if (isOthersSelected) {
                            updatedPoint.other_consignee_name = "";
                            updatedPoint.other_consignee_pincode = "";
                            updatedPoint.other_consignee_city = "";
                        } else {
                            // Clear "other" fields if "Others" is not selected
                            delete updatedPoint.other_consignee_name;
                            delete updatedPoint.other_consignee_pincode;
                            delete updatedPoint.other_consignee_city;
                        }
                    }
    
                    return updatedPoint;
                }
                return point;
            })
        );
    };
    
    const handleDriverNumberChange = (e) => {
        const { name, value } = e.target;
      
        // Allow only numeric input
        const numericValue = value.replace(/\D/g, '').slice(0, 10);
      
        // Validate the input length and content
        if (numericValue.length < 10) {
          setError1('Mobile number must be 10 digits long');
        } else if (numericValue.length > 10) {
          setError1('Mobile number cannot exceed 10 digits');
        } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
          setError1('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
        } else {
          setError1(''); // Clear error if the number is valid
        }
      
        // Update the state with the new value (allow only 10 digits max)
        if (numericValue.length <= 10) {
          if (name === 'driver_number_update') {
            setManualUpdateConsignment((prev) => ({ ...prev, driver_number: numericValue }));
          } else if (name === 'driver_mobile_no') {
            setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
          }
        }
      };
      function validateInput(input) {
        if (input === "" || input === null || input === undefined) {
            setSourceList(originalSourceList);
            return true;
        }
    
        const validateInvoice = (invoice) => {
            const regex = /^[A-Za-z0-9]+(\/[A-Za-z]+)?$/;
            return regex.test(invoice);
        };
        // Ensure all invoices are unique
        for (let i of input) {
            const lowerCase = i.toLowerCase();
            
          
            if (!validateInvoice(lowerCase)) {
                
                setShow(true);
                setTitle("All invoice's should be valid");
                setType("danger");
                return;
            }
        }
    
        let noSeries = true;
        for (let invoice of input) {
            if (invoice.includes("/")) {
                noSeries = false;
                break;
            }
        }
    
        if (noSeries) {
            setSourceList(originalSourceList);
            setInvoiceValid(false);
            return true;
        }
    
        if (input.length >= 1) {
            let finalSource = new Set();
    
            // Function to validate invoice format
            
    
            for (let i = 0; i < input.length; i++) {
                const currentInvoice = input[i];
                
               
    
                if (currentInvoice.includes("/")) {
                    const currentSeries = currentInvoice.split("/")[1];
                    
                    var isSeriesValid=seriesRecords.includes(currentSeries.toUpperCase())
                    if(!isSeriesValid){
                        setShow(true);
                        setTitle("Please enter valid series");
                        setType("danger");
                        setInvoiceValid(false);
                        return;
                    }
                    const seriesList = sourceSeriesList.find(
                        (e) => e.value.toLowerCase() === currentSeries.toLowerCase()
                    );
    
                    if (seriesList) {
                        finalSource.add(seriesList.label);
                    }
                }
            }
    
    
            if (finalSource.size === 1) {
                const [value] = finalSource;
                let filteredSource = originalSourceList.filter((e) => e.value === value);
                filteredSource.push({ label: "Others", value: "Others" });
    
                setSourceList(filteredSource);
                setFormData((prev) => ({
                    ...prev,
                    source: { label: filteredSource[0].label, value: filteredSource[0].value }
                }));
                setInvoiceValid(false);

                return true;
            }
        }
    }
    
      const validateSource = () => {
        if(formData.source.value==="Other"){
            setEnableSourceField(true)
        } else {
            setFormData(prev =>({...prev, other_source:""}))
            setEnableSourceField(false)
        }
      }
      const enableOtherField = (e) => {
        if(e === "vehicleType"){
            if(formData.vehicle_type.value === "Others"){
                setEnableVehicelType(true)
            } else {
                setFormData(prev =>({...prev, other_vehicle_type:"",other_vehicle_capacity:""}))
                setEnableVehicelType(false)
            }
        }
        else if(e === "transporter"){
            if(formData.courier_partner.value === "Others"){
                setEnableCourierType(true)
            } else {
                setFormData(prev =>({...prev, other_transporter:""}))
                setEnableCourierType(false)
            }
        } 
        // else if(e === "vehicleCapacity"){
        //     if(formData.vehicle_capacity.value === "Others"){
        //         setEnableVehicleCapacity(true)
        //     } else {
        //         setFormData(prev =>({...prev, other_vehicle_capacity:""}))
        //         setEnableVehicleCapacity(false)
        //     }
        // } 
        else if(e === "consigneeName"){
            if(formData.consignee_name.value === "Others"){
                
                setEnableConsigee(true)
            } else {
                
                setFormData(prev =>({...prev, other_consignee_name:""}))
                setEnableConsigee(false)
                let droppointconsigneelist = consignees.filter(e => e.value !== formData.consignee_name.value)
                setDropPointConsignee(droppointconsigneelist)
            }
        }
      }
      const validateOption = (fieldType) => {
        switch(fieldType){        
            case "vehicleType":
                enableOtherField("vehicleType");
                break;
            case "transporter":
                enableOtherField("transporter");
                break;            
            case "vehicleCapacity":
                enableOtherField("vehicleCapacity");
                break;
            case "consigneeName":
                enableOtherField("consigneeName");
                break;
            case "dropConsigneeName":
                enableOtherField("dropConsigneeName");
                break;
            default:
                break;

        }
      }
      const fetchVehicleDetails = (x,y) => {
        let data = {
            vehicle_type: y,
        }
        redirectURL.post('/consignments/fetchVehicleDetails', data).then((resp) => {
            //console.log(resp, "889900");
            
        
            setFormData(prev => ({...prev, vehicle_capacity:resp.data.vehicleDetails[0].vehicle_capacity}))
        })
      }
      const fetchVehicleDetails1 = (x,y) => {
        let data = {
            vehicle_type: y,
        }
        redirectURL.post('/consignments/fetchVehicleDetails', data).then((resp) => {
            //console.log(resp, "889900");
            
        
            setManualUpdateConsignment(prev => ({...prev, vehicle_capacity:resp.data.vehicleDetails[0].vehicle_capacity}))
        })
      }
     
      
      const fetchConsignerDetails = (x, y, isEdit = false) => {
        let data = {
            consigner_name: y,
            consigner_code: x
        };
    
        redirectURL.post('/consignments/fetchConsignerDetails', data).then((resp) => {
            if (isEdit) {
                setManualUpdateConsignment(prev => ({
                    ...prev, 
                    destination_pincode: resp.data.consignerDetails[0].consigner_pincode,  
                    destination_city: resp.data.consignerDetails[0].consigner_city
                }));
            } else {
                setFormData(prev => ({
                    ...prev, 
                    destination_pincode: resp.data.consignerDetails[0].consigner_pincode,  
                    destination_city: resp.data.consignerDetails[0].consigner_city
                }));
            }
        });
    };
    
      useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch EDD Enabled Emails
                const eddEnabledEmails = await redirectURL.post('/consignments/allEDDEnabledEmails', {});
                const emailsArr = eddEnabledEmails?.data[0]?.edd_emails;
                
                setEnabledEDDEmailList(emailsArr);
                // Fetch consigner city list
                const factoryResponse = await redirectURL.post('/consignments/allFactoryNames', {});
                const consignerArr = factoryResponse.data;
                const consignerCityList1 = consignerArr.map(e => e.consigner_city.toLowerCase());
                //console.log(consignerCityList1, "consignerCityList1");
                setConsignerCityList(consignerCityList1);
    
                // Fetch entity data
                const entityResponse = await redirectURL.post('/consignments/allEntityData', {});
                const entityArr = entityResponse.data;
                const entityData = entityArr.map(e => e.entity.toLowerCase());
                //console.log(entityData, "entityMasterData");
                setEntityMasterData(entityData);

                const vehicleResponse = await redirectURL.post('/consignments/allVehicleData', {});
                const vehicleArr = vehicleResponse.data;
                const vehicleData = vehicleArr.map(e => e.vehicle_type.toLowerCase());
                //console.log(vehicleData, "vehicleData");
                setVehicleMasterData(vehicleData);


                 const tptResponse = await redirectURL.post('/consignments/transportersbydept', {});
                const tptArr = tptResponse.data;
                const tptData1 = tptArr.map(e => e.transporter_name.toLowerCase());
                const tptNamenCategory = tptArr.map(e=> ({label:e.transporter_name, value:e.transporter_type}))

                //console.log(tptNamenCategory, "tptNamenCategory");
                setTptData(tptNamenCategory)
                setTptMasterData(tptData1);

                const invoiceResponse = await redirectURL.post('/invoicelist', {});
                //console.log(invoiceResponse, "invoiceResponse9999");
                
                const invoiceArr = invoiceResponse.data.records;
                const invoiceData = invoiceArr.map(e => e.invoice_category?.toLowerCase() || "");
                const invoiceSources =  invoiceArr.map(e => e.invoice_source?.toLowerCase() || "");
                const invoiceSeriesSource = invoiceArr.map(e=> ({label:e.invoice_series, value:e.invoice_source}))
                const invoiceSourceCategory = invoiceArr.map(e=> ({label:e.invoice_source, value:e.invoice_category}))
                //console.log(invoiceSeriesSource, "invoiceSeriesSource");
                setInvoiceSourceSeries(invoiceSeriesSource)
                setInvoiceSourceCategory(invoiceSourceCategory)
                setInvoiceMasterData(invoiceData);
                setInvoiceSourceData(invoiceSources);

                const reasons = await redirectURL.post(
                    "/consignments/reasonForDelayData",
                    {}
                );
                const reasonArr = reasons.data?.[0]?.master_data || [];
                const validReasons = reasonArr.map(e => ({
                    label: e,
                    value: e
                }));

                setValidReasonsDataArr(reasonArr);
                setValidReasonsOptions(validReasons);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    }, []);
    
      const fetchConsigneeDetails2 = (x,y) => {
        let data = {
            consignee_name: x,
            consignee_code: y
        }
        //console.log(data, "data1233");
        
        redirectURL.post('/consignments/fetchConsigneeDetails', data).then((resp) => {
            //console.log(resp.data,"fetchdetails2");
            
        
            setManualUpdateConsignment(prev => ({...prev, destination_pincode:resp.data.consigneeDetails[0].consignee_pincode,  destination_city:resp.data.consigneeDetails[0].consignee_city}))
        })
      }
      const fetchConsigneeDetails1 = (index, consigneeCode, consigneeName) => {
        let data = {
            consignee_name: consigneeName,
            consignee_code: consigneeCode
        };
    
        redirectURL.post('/consignments/fetchConsigneeDetails', data).then((resp) => {
            const { consignee_pincode, consignee_city } = resp.data.consigneeDetails[0];
    
            // Update only the specific index in ManualTripUploadDetails
            setManualTripUploadDetails((prevDetails) =>
                prevDetails.map((point, idx) => {
                    if (idx === index) {
                        // Only update destination_pincode and destination_city for the specific index
                        return {
                            ...point,
                            destination_pincode: consignee_pincode,
                            destination_city: consignee_city,
                        };
                    }
                    return point;
                })
            );
        }).catch((error) => {
            console.error("Error fetching consignee details:", error);
        });
    };
    
      const fetchConsigneeDetailsForDropPoints = (x,y) => {
        let data = {
            consignee_name: x,
            consignee_code: y
        }
        redirectURL.post('/consignments/fetchConsigneeDetails', data).then((resp) => {
        
            setManualTripUploadDetails(prev => ({...prev, destination_pincode:resp.data.consigneeDetails[0].consignee_pincode,  destination_city:resp.data.consigneeDetails[0].consignee_city}))
        })
      }
      const checkConsignee = () => {
        if(formData.consignee_name?.value !==""){
            
            setEnableEdit(false)
            setShow(true)
            setTitle("Select Consignee Name")
            setType("danger")
        } else {
            setEnableEdit(false)
        }
      }
      
      const validateTruckNoFun = (value) => {
        // Define the regex for the truck number format SN12TR2345
        const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,10}$/;        // Check if the input matches the regex pattern
        const isValid = regex.test(value);
        
        setValidTruckNo(isValid);
    };
      // Function that checks validation based on the field name
      const checkOtherConsigneeName = (fieldName, value) => {
        const pincodeRegex = /^[0-9]+$/;
        const cityRegex = /^[a-zA-Z\s]+$/;
    
        if (fieldName === "other_destination_city") {
            setValidCity(cityRegex.test(value));
        } else if (fieldName === "other_destination_pincode") {
            setValidPincode(pincodeRegex.test(value));
        } else if (fieldName === "other_consignee_pincode1") {
            setValidPincode1(pincodeRegex.test(value));
        } else if (fieldName === "other_consignee_city1") {
            setValidCity1(cityRegex.test(value));
        }

        if (formData.other_consignee_name !== "") {
            setIsOtherConsigneeName(false);
        }
    };

  

    const validateOtherConsignee = () => {
        const nameRegex = /^[a-zA-Z\s]+$/;;
        setValidateOtherConsignee(nameRegex.test(formData.other_consignee_name));
        if (nameRegex.test(formData.other_consignee_name)) {
            setIsOtherConsigneeName(true);
            setValidateOtherConsignee(true);
        } else {
            setValidateOtherConsignee(false);
        }
    };
      const validateVehicleCapacity = () => {
        const regex = /^[0-9]+$/;
        setValidVehicleCapacity(regex.test(formData.other_vehicle_capacity))

      }
      
    const filterSources = (invoiceNo) => {
        
        if (validateInput(invoiceNo)) {
            setErrorMssge("");    
            let invoiceNumber = invoiceNo[0]  
            let source = invoiceNumber.split('/')[1];  
            let filteredSource = sourceList.filter(e => {
                return e.value === source;
            });   
            // filteredSource.push({ label: "Others", value: "Others" });
            setSourceList(filteredSource); 
        } else {
            setErrorMssge("Invalid Invoice Number"); 
            setEnableSourceField(false); 
        }
    };
    const filterSources1 = (invoiceNo) => {
        if (validateInput(invoiceNo)) {
            setErrorMssge("");      
            // let source = invoiceNo.split('/')[1];  
            // let filteredSource = constSourceList.filter(e => {
            //     return e.value === source;
            // });   
            // filteredSource.push({ label: "Others", value: "Others" });
            // setSourceList(filteredSource); 
        } else {
            setErrorMssge("Invalid Invoice Number"); 
            // setEnableSourceField(false); 
        }
    };
    
      const handleInvoiceChange = (e) => {
        const value = e.target.value;

    
        const invoiceArray = value.split(',').map((item) => item.trim()).filter(Boolean);
        setFormData(prev => ({...prev, invoice_no_str: value, invoice_no: invoiceArray}));
        // if (invoiceArray.length > 0 && /[\/]/.test(invoiceArray[0])) {
        //     filterSources(invoiceArray);  // Call filterSources if the value contains a slash
        // } 
        // const isValid = validateInput(invoiceArray);
        // setIsValid(isValid);  
     };
     const handleLRChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;

        // Validate for alphanumeric characters
        // if (/^[a-zA-Z0-9]*$/.test(value)) {
        if (/^[^\s]*$/.test(value)) {
            if(name === "lr_no"){
                setmanualUploadDetails((prev) => ({ ...prev, lr_no: value }));
            }
            if(name==="lr_no2"){
                setUpdateLrNo(value)
            }
            setErrorMsg("");

             // Clear the error message if input is valid
        } else {
            setErrorMsg("Only alphanumeric characters are allowed.");
        }
    };
    const validateOtherSource = (source) => {
        const regex = /^[a-zA-Z]+$/;  // Only letters allowed
        const isValid = regex.test(source);
        setValidOtherSource(isValid);
    };
    const handleVehicleCapacityChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({...prev, other_vehicle_capacity: value}));
        validateVehicleCapacity(value);  // Validate in real-time on change
    };
    const handleTruckNoChange = (e) => {
        const {name, value} = e.target
        const value1 = value.toUpperCase();
        if(name=="truck_no"){
            setFormData(prev => ({...prev, truck_no: value1}));
        }else if(name=="lr_truck_no"){
            setManualUpdateLRConsignment(prev => ({...prev, truck_no: value1}));
        }

        validateTruckNoFun(value1);  
    };
   
    const handleAddConsignmentInputChange = (e) => {
        const { name, value } = e.target;
    
        setFormData((prev) => ({
            ...prev,
            [name]: value, // Dynamically set the key-value pair based on the name attribute
        }));
    
        if (name === "other_source") {
            validateOtherSource(value); // Trigger validation for 'other_source' if applicable
        }
    };
    
      const saveConsignmentData = async (event) => {
        event.preventDefault();
        setOverlay("show-m")
        
        let specialCharcters = 0;
        const { driver_mobile_no, source, truck_no, truck_seal_no, entity, vehicle_type, vehicle_capacity,courier_partner,eway_bill_expiry_date, consignee_name, movement_type, lr_no, invoice_no, number_of_boxes, destination_pincode, destination_city, other_source,other_source_pincode,total_cbm, total_weight, invoice_date, consigner_name,consignee_name1,dispatch_time,
            other_transporter,
            other_vehicle_type,
            other_consignee_name,
            other_vehicle_capacity,
            other_destination_pincode, other_destination_city } = formData;
        let add_consignment_params = {}
        if (specialCharcters === 0) {
            let fieldsChk = 0;
            const isGeneralFieldsFilled =dispatch_time && driver_mobile_no && !invoiceValid && source.value && truck_no && entity.value && vehicle_type.value 
            && courier_partner.value && movement_type.value && invoice_no && vehicle_capacity && invoice_date && total_weight!=="";
        
        // Check if consignee-related mandatory fields are filled based on the consignee selection
        const isConsigneeFilled = (consignee_name.value !== 'Others' && destination_city && destination_pincode) 
            || (consignee_name.value === 'Others' && other_consignee_name && other_destination_city && other_destination_pincode);
        const otherSource = (source.value ==="Others" && other_source && other_source_pincode) ||( source.value !=="Others" && true);
        var consigneeValidation=true;

        if(movement_type.value==="Customer Delivery"){
            if(!consignee_name1){
                consigneeValidation=false;
            }else{
                consigneeValidation=true;
            }
        }else{
            consigneeValidation=true;
        }
        
        if (isGeneralFieldsFilled && isConsigneeFilled && consigneeValidation && otherSource) {
            
            fieldsChk = 1;
        }
            // if(other_source){
            //     fieldsChk = 1;
            // }
        var invoice_date1 = new Date(invoice_date);
        var dispatch_time1 = new Date(dispatch_time);

        if(fieldsChk === 1){
            if (dispatch_time1 > invoice_date1) {
                

                add_consignment_params = {
                    driver_mobile_no, 
                    source: source.label ? source.label: "",
                    truck_no,
                    truck_seal_no,
                    entity: entity.value ? entity.value : "", 
                    vehicle_type: vehicle_type.value, 
                    courier_partner: courier_partner.value.toUpperCase(), 
                    eway_bill_expiry_date: eway_bill_expiry_date ? formatDateForSubmission1(eway_bill_expiry_date) : "",        
                    invoice_date: invoice_date ? formatDateForSubmission(invoice_date):"",
                    dispatch_date: dispatch_time ? formatDateForSubmission1(dispatch_time):"",
                    total_weight: total_weight,
                    total_cbm: total_cbm,

                    vehicle_capacity: vehicle_capacity.value,
                    movement_type: movement_type.value, 
                    lr_no, 
                    // invoice_no: `${invoice_no}`, 
                    invoice_no:invoice_no,
                    no_of_boxes: number_of_boxes,
                    consigner_name:consigner_name
                };
                

                if(movement_type.value==="Customer Delivery"){
                    
                    add_consignment_params.consignee_name = formData.consignee_name1
                    add_consignment_params.destination_pincode = formData.destination_pincode;
                    add_consignment_params.destination_city = formData.destination_city;
                }
               
                if(consignee_name.value === "Others"){
                    add_consignment_params.consignee_name = formData.other_consignee_name
                    add_consignment_params.destination_pincode = formData.other_destination_pincode
                    add_consignment_params.destination_city = formData.other_destination_city
                }
                if(consignee_name.value !=="Others" && consignee_name1===""){
                    add_consignment_params.consignee_name = formData.consignee_name.label;
                    add_consignment_params.destination_pincode = formData.destination_pincode;
                    add_consignment_params.destination_city = formData.destination_city;
                }
                if(add_consignment_params.vehicle_type === "Others"){
                    add_consignment_params.vehicle_type = formData.other_vehicle_type
                }
                if(add_consignment_params.vehicle_capacity === "Others"){
                    add_consignment_params.vehicle_capacity = formData.other_vehicle_capacity
                }
                if(add_consignment_params.courier_partner === "Others"){
                    add_consignment_params.courier_partner = formData.other_transporter.toUpperCase()
                }
                if(other_source){
                    if(validOtherSource){
                        add_consignment_params.source = other_source;
                        add_consignment_params.source_pincode = other_source_pincode;
                    }
                }
                
                if (manualTripUploadDetails.length >= 1){
                    add_consignment_params.add_dealer=1
                }

                const manualDropPoints = manualTripUploadDetails.map((point) => ({
                    consignee_name: point.consignee_name === "Others" ? point.other_consignee_name : point.consignee_name,
                    customer_mail_id: point.customer_mail_id,
                    destination_city: point.consignee_name === "Others" ? point.other_consignee_city : point.destination_city,
                    destination_pincode: point.consignee_name === "Others" ? point.other_consignee_pincode : point.destination_pincode,
                    invoice_no: point.invoice_no,
                    lr_no: formData.lr_no,  // assuming lr_no is consistent across all points
                    no_of_boxes: point.no_of_boxes,
                    id: point.id
                }));
                const combinedParams = {
                    add_consignment_params,            // First set of params for updating the collection
                    manualTripUploadDetails :  manualDropPoints,
                    email:decode(localStorageEmail)  // Second set of params to be sent to the backend API
                };
                try { 
                    const response = await redirectURL.post('/consignments/saveConsignmentData', combinedParams);
                  
                //     // Check if the response is successful
                    if (response.data.status.toLowerCase() === 'success') {
                      setShow(true);
                      setTitle('Successfully created consignment');
                      setType('success');
                      setLoadShow('show-n');
                      setOverlay('show-n');
                      setSliderCreateConsignmentTranslate('');
                      setInvoiceValid(false)
                            setValidTruckNo('')
                  
                //       // Clear form data
                      setFormData({
                        ...formData,
                        driver_mobile_no: '',
                        source: { label: "", value: "" },
                        truck_no: '',
                        truck_seal_no: '',
                        entity: '',
                        vehicle_type: { label: '', value: '' },
                        courier_partner: { label: '', value: '' },
                        eway_bill_expiry_date: '',
                        invoice_date:'',
                        total_weight:'',
                        total_cbm:'',
                        vehicle_capacity:'',
                        consignee_name: { label: "", value: "" },
                        movement_type: { label: "", value: "" },
                        lr_no: '',
                        invoice_no: [],
                        invoice_no_str:"",
                        consigner_name:"",
                        consignee_name1:"",
                       
                         number_of_boxes: '',
                        destination_pincode: '',
                        destination_city: '',
                        dispatch_time:new Date()
                      });
                      
                //       // Clear manual trip upload details
                      setManualTripUploadDetails([]);
                //     //   window.location.reload();
                    } else if (response.data.status.toLowerCase() === 'fail') {
                //       // Show error message returned from backend
                      setShow(true);
                      setTitle(response.data.message); // Display the error message from the backend
                      setType("danger");
                    } else {
                      setShow(true);
                      setTitle(response.data.message === 'Consignment Code Already Exists' ? 
                        'Consignment Code Already Exists' : 'Failed to create consignment');
                      setType('danger');
                      setSliderCreateConsignmentTranslate('');
                      setFormData({
                        ...formData,
                        driver_mobile_no: '',
                        source: '',
                        truck_no: '',
                        truck_seal_no: '',
                        entity: '',
                        vehicle_type: { label: '', value: '' },
                        courier_partner: { label: '', value: '' },
                        eway_bill_expiry_date: '',
                        invoice_date:'',
                        total_weight:'',
                        total_cbm:'',
                        vehicle_capacity: '',
                        consignee_name: '',
                        movement_type: '',
                        lr_no: '',
                        invoice_no: [],
                        invoice_no_str:"",
                        consigner_name:"",
                        consignee_name1:"",

                        number_of_boxes: '',
                        destination_pincode: '',
                        destination_city: '',
                        dispatch_time:new Date()
                      });
                      setManualTripUploadDetails([]);
                    }
                  } catch (error) {
                //     // Handle any network or unexpected errors
                  
                    setShow(true);
                    setTitle("An unexpected error occurred. Please try again.");
                    setType("danger");
                  }
                  
            } else {
                setShow(true)
                setTitle("Dispatch Date should be greater than invoice date")
                setType("danger")
                setLoadShow('show-n')
                // setOverlay('show-n')
                              
            }
        }else{
            setShow(true)
            setTitle('Please fill mandatory fields')
            setType('danger') 
        }
    }   
         else {
            setShow(true)
            setTitle('Special characters are not allowed')
            setType('danger')
           
        }
    
    };
      const onClickHideManualUpload3 = () => {
        setManualUpdateConsignment((prev) => ({
            ...prev,
            driver_number: '',
            source: "",
            truck_no: "",
            truck_seal_no: "",
            vehicle_type: "",
            courier_partner:"",
            vehicle_capacity: "",
            consignee_name: "",
            lr_no: "",
            invoice_no: "",
            destination_pincode: "",
            destination_city:""
        }))
        setManualTripUploadDetails([])
        setshowAddForm3("");
        setOverlay("show-n");
        setselected_row({});
      }
    const validatePincode = (pincode) => {
    // Make an API call to a pincode validation service or use a local database
    // For this example, we'll assume a simple validation where pincode should be 6 digits
    const isValid = /^\d{6}$/.test(pincode);
    return isValid;
    };
    const keysToInclude = ["consignee_name", "lr_no", "invoice_no", "consignee_pincode", "consignee_city", "consignment_uid"];
    
    const extractChangedFields = (originalDetails, updatedParams) => {
        const editDetails = {};
        
        for (const key in updatedParams) {
            if (originalDetails.hasOwnProperty(key)) {  
                if (Array.isArray(updatedParams[key])) {
                    if (JSON.stringify(updatedParams[key]) !== JSON.stringify(originalDetails[key])) {
                        editDetails[key] = updatedParams[key];
                    }
                } else if (typeof updatedParams[key] === 'object' && updatedParams[key] !== null) {
                    if (JSON.stringify(updatedParams[key]) !== JSON.stringify(originalDetails[key])) {
                        editDetails[key] = updatedParams[key];
                    }
                } else {
                    if (updatedParams[key] !== originalDetails[key]) {
                        editDetails[key] = updatedParams[key];
                    }
                }
            }
        }    
        return editDetails;
    };
    const compareAndExtractChanges = (originalEditData, compareParams) => {
        const updatedFields = {};
    
        for (const key in compareParams) {
            if (compareParams.hasOwnProperty(key)) {
                let originalValue = originalEditData[key];
                let newValue = compareParams[key];
    
                // Convert Date objects to ISO string for proper comparison
                if (originalValue instanceof Date) {
                    originalValue = originalValue.toISOString();
                }
                if (newValue instanceof Date) {
                    newValue = newValue.toISOString();
                }
    
                // Handle arrays containing a single element (convert to string for comparison)
                if (Array.isArray(originalValue) && originalValue.length === 1) {
                    originalValue = originalValue[0];
                }
                if (Array.isArray(newValue) && newValue.length === 1) {
                    newValue = newValue[0];
                }
    
                // Compare values and add only if they have changed
                if (!originalEditData.hasOwnProperty(key) || originalValue !== newValue) {
                    updatedFields[key] = compareParams[key];
                }
            }
        }
    
        return Object.keys(updatedFields).length > 0 ? updatedFields : {};
    };
          
      
      
      const extractChangedFields1 = (originalDetails, updatedParams) => {
        const changedDetails = [];
    
        for (let i = 0; i < originalDetails.length; i++) {
            const originalItem = originalDetails[i];
            const updatedItem = { ...updatedParams[i] };
    
            // Use `other_consignee_*` fields if available, otherwise use default fields
            updatedItem.consignee_name = updatedItem.other_consignee_name && updatedItem.other_consignee_name !== ""
                ? updatedItem.other_consignee_name
                : (updatedItem.consignee_name && typeof updatedItem.consignee_name === 'object'
                    ? updatedItem.consignee_name.label
                    : updatedItem.consignee_name);
    
            updatedItem.destination_city = updatedItem.other_consignee_city && updatedItem.other_consignee_city !== ""
                ? updatedItem.other_consignee_city
                : updatedItem.destination_city;
    
            updatedItem.destination_pincode = updatedItem.other_consignee_pincode && updatedItem.other_consignee_pincode !== ""
                ? updatedItem.other_consignee_pincode
                : updatedItem.destination_pincode;
    
            let hasChanges = false;
    
            for (const key in originalItem) {
                if (originalItem.hasOwnProperty(key) && updatedItem.hasOwnProperty(key)) {
                    if (originalItem[key] !== updatedItem[key]) {
                        hasChanges = true;
                        break;
                    }
                }
            }
    
            // If there are changes, rename keys, remove other_ fields, and push the updated record
            if (hasChanges) {
                const newItem = { ...updatedItem };
    
                // Rename keys for the backend if they exist in updatedItem
                if ('destination_pincode' in newItem) {
                    newItem.consignee_pincode = newItem.destination_pincode;
                    delete newItem.destination_pincode;
                }
    
                if ('destination_city' in newItem) {
                    newItem.consignee_city = newItem.destination_city;
                    delete newItem.destination_city;
                }
    
                // Remove `other_` fields from the newItem
                delete newItem.other_consignee_name;
                delete newItem.other_consignee_pincode;
                delete newItem.other_consignee_city;
    
                changedDetails.push(newItem); // Push the modified updated record
            }
        }
    
        return changedDetails;
    };
    
    
    
      
    // trip edit submit
    const onClickUpdateConsignment = async(e) => {
        e.preventDefault()
        
        
        var update_params = {
            driver_mobile_no: manualUpdateConsignment.driver_mobile_no,
            // source: manualUpdateConsignment.source?.value??"",
            truck_no: manualUpdateConsignment.truck_no,
            truck_seal_no: manualUpdateConsignment.truck_seal_no,
            truck_seal_entity: manualUpdateConsignment.entity.value,
            truck_type: manualUpdateConsignment.other_vehicle_type?.value && manualUpdateConsignment.other_vehicle_type.value !== ""
            ? manualUpdateConsignment.other_vehicle_type.value
            : manualUpdateConsignment.vehicle_type.value || "",           
            
            transporter_name: manualUpdateConsignment.other_transporter?.value && manualUpdateConsignment.other_transporter.value !== ""
            ? manualUpdateConsignment.other_transporter.value.toUpperCase()
            : manualUpdateConsignment.courier_partner.value.toUpperCase(),

            vehicle_capacity: manualUpdateConsignment.other_vehicle_capacity?.value && manualUpdateConsignment.other_vehicle_capacity.value !== ""
            ? manualUpdateConsignment.other_vehicle_capacity.value
            : manualUpdateConsignment.vehicle_capacity,    

            // consignee_name: manualUpdateConsignment.other_consignee_name && manualUpdateConsignment.other_consignee_name!== ""
            // ? manualUpdateConsignment.other_consignee_name
            // : manualUpdateConsignment.consignee_name.label,  
            customer_name: manualUpdateConsignment.other_consignee_name && manualUpdateConsignment.other_consignee_name!== ""
            ? manualUpdateConsignment.other_consignee_name
            : manualUpdateConsignment.consignee_name.label,           
            
            no_of_boxes: manualUpdateConsignment.no_of_boxes,
            lr_no: manualUpdateConsignment.lr_no,
            invoice_no: manualUpdateConsignment.invoice_no,
            shipment_id:shipmentId,
            movement_type: manualUpdateConsignment.movement_type.value,
            eway_bill_expiry_date: manualUpdateConsignment.eway_bill_expiry_date
            ? new Date(new Date(manualUpdateConsignment.eway_bill_expiry_date).getTime() + (5.5 * 60 * 60 * 1000)) 
            : null,
            // consignee_pincode: manualUpdateConsignment.destination_pincode[0],
            consignee_pincode: manualUpdateConsignment.other_destination_pincode && manualUpdateConsignment.other_destination_pincode !== ""
            ? manualUpdateConsignment.other_destination_pincode
            : manualUpdateConsignment.destination_pincode,

            consignee_city: manualUpdateConsignment.other_destination_city && manualUpdateConsignment.other_destination_city !== ""
        ? manualUpdateConsignment.other_destination_city
        : manualUpdateConsignment.destination_city, 
    } 

        //  from here add consignments add droppoint details
        // if (manualTripUploadDetails.length>=1){
        //     update_params.add_dealer=1
        // }

        //console.log(manualTripUploadDetails, dropPointArr,"manualTripUploadDetails");
        
        const transformedTripDetails = manualTripUploadDetails.map((detail) => {
            return {
                ...detail,
                consignee_name: detail.consignee_name && typeof detail.consignee_name === 'object' && detail.consignee_name.label
                    ? detail.consignee_name.label
                    : detail.consignee_name, // Use label if it's an object, otherwise keep it as is
            };
        });
        //console.log(transformedTripDetails, "transformedTripDetails")
        const combinedParams = {
            update_params,            // First set of params for updating the collection
            manualTripUploadDetails: transformedTripDetails
                };
        const shipment_id = orginalDetailsForEdit.shipment_id;
        const tracking_type = orginalDetailsForEdit.tracking_type;

        //console.log(orginalDetailsForEdit, "orginalDetailsForEdit");
        //console.log(combinedParams.update_params, "combinedParams.update_params");
        
       const editDetails = compareAndExtractChanges(orginalDetailsForEdit, combinedParams.update_params);
       
      
       if(editDetails!== undefined && editDetails !== null){

        editDetails.consignment_uid = consignmentUidForTruckLevel;
    }
       
       
       const update_data = extractChangedFields1(dropPointArr,combinedParams.manualTripUploadDetails )
    //    const result = combinedParams.manualTripUploadDetails.reduce((acc, manualDetail) => {
    //     // Find the matching dropPoint in dropPointArr based on lr_no
        
    //     const dropPoint = dropPointArr.find(dp => {
    //         return dp.lr_no === manualDetail.lr_no;  // Return the comparison result
    //     });
    
    //     if (dropPoint) {
    //         const changedDetails = { consignment_uid: dropPoint.consignment_uid }; // Start with consignment_uid only
    
    //         // Compare each field and add to changedDetails if it's different
    //         if (manualDetail.lr_no !== dropPoint.lr_no) {
    //             changedDetails.lr_no = manualDetail.lr_no;
    //         }
    //         if (manualDetail.invoice_no !== dropPoint.invoice_no) {
    //             changedDetails.invoice_no = manualDetail.invoice_no;
    //         }
    //         if (manualDetail.consignee_name !== dropPoint.consignee_name) {
    //             changedDetails.consignee_name = manualDetail.consignee_name;
    //         }
    //         if (manualDetail.destination_pincode !== dropPoint.destination_pincode) {
    //             changedDetails.consignee_pincode = manualDetail.destination_pincode;
    //         }
    //         if (manualDetail.destination_city !== dropPoint.destination_city) {
    //             changedDetails.consignee_city = manualDetail.destination_city;
    //         }
    
    //         // Only push changedDetails if there are changes other than consignment_uid
    //         if (Object.keys(changedDetails).length > 1) {
    //             acc.push(changedDetails);
    //         }
        
    
    //     }
    
    //         return acc;
    //     }, []);
        // truck_level_change
        // droppoint level changes
       
        let editTripDetails = {
            shipment_id,
            tracking_type,
            editDetails,
            update_data,
            email: decode(localStorageEmail)

        }
        // console.log(editTripDetails, "edittripdetails344");
        

        if(error2===""){
            redirectURL.post('/consignments/updateTripDetails', editTripDetails).then((resp) => {
                if (resp.data.status == 'success') {
                    setshowAddForm1('')
                    setshowAddForm2('')
                    setshowAddForm3('')
                    setManualTripUploadDetails([])
                    setManualUpdateConsignment(
                        {
                            driver_number: '',
                            source: "",
                            truck_no: "",
                            truck_seal_no: "",
                            vehicle_type: "",
                            courier_partner:"",
                            vehicle_capacity: "",
                            consignee_name: "",
                            lr_no: "",
                            invoice_no: "",
                            no_of_boxes: "",
                            destination_pincode: "",
                            destination_city:""
                          }
                    )
                    setShow(true)
                    setTitle("The consignment details have been successfully updated!")
                    setType("success")
                    setLoadShow('show-n')
                    setOverlay('show-n')
                    setError("")
                  
                    // window.location.reload();
                }
                else{
                    setShow(true)
                    setTitle(resp.data.message)
                    setType("danger")
                    setLoadShow('show-n')
                    // setOverlay('show-n')
                }
            })
        }else{
            setShow(true)
            setTitle("Please enter valid mobile number")
            setType("danger")
            setLoadShow('show-n')
        }
        
        
        // setManualUpdateConsignment((prev) => ({
        //     ...prev,
        //     driver_number: "",
        //     source: "",
        //     truck_no: "",
        //     truck_seal_no: "",
        //     vehicle_type: "",
        //     courier_partner:"",
        //     vehicle_capacity: "",
        //     consignee_name: "",
        //     lr_no: "",
        //     no_of_boxes:"",
        //     invoice_no: "",
        //     destination_pincode: "",
        //     destination_city:""
        //   }));
        // setManualTripUploadDetails([])

    } 
    const getSourceList = () => {
        if (manualUpdateConsignment.other_source !== "") {
          return [{ value: "Others", label: "Others" }];
        } else {
          const lastThreeLetters = manualUpdateConsignment.invoice_no.slice(-3);
          const matchingSource = sourceList.find((item) => item.value.endsWith(lastThreeLetters));
          if (matchingSource) {
            setManualUpdateConsignment((prev) => ({ ...prev, source: matchingSource }));
            return [matchingSource, { value: "Others", label: "Others" }];
          } else {
            return [{ value: "Others", label: "Others" }];
          }
        }
      };
    const isFormValid = () => {
        return (
          formData.invoice_no !== '' &&  formData.movement_type.value !== '' &&
          formData.driver_mobile_no !== '' && formData.source.value !== "" &&
          (formData.source.value === 'Others' ? !!formData.other_source : true) &&
          formData.truck_no !== '' &&
          formData.entity.value !== '' &&
          (formData.vehicle_type.value === 'Others' ? !!formData.other_vehicle_type : true) &&
          (formData.courier_partner.value === 'Others' ? !!formData.other_transporter : true) &&
          (formData.vehicle_capacity.value === 'Others' ? !!formData.vehicle_capacity : true) &&
          formData.consignee_name.value !== '' &&
          (formData.consignee_name.value === "Others" ? 
            (formData.other_consignee_name !== '' && 
             formData.other_destination_pincode !== '' && 
             formData.other_destination_city !== '') 
            : 
            (formData.destination_pincode !== '' && 
             formData.destination_city !== '')) &&
          formData.movement_type.value !== '' 
          
        );
    };
    const isManualTripUploadDetailsValid = () => {
        if (manualTripUploadDetails.length === 0) return true;
    
        // Get the most recent block
        const recentBlock = manualTripUploadDetails[manualTripUploadDetails.length - 1];
        const isOtherConsignee = recentBlock.consignee_name.length > 0 && recentBlock.consignee_name === 'Other';
        
        return (
            recentBlock.invoice_no !== '' &&  // Check if invoice_no is not empty
            recentBlock.consignee_name.length > 0 &&  // Check if there is at least one consignee name
            (!isOtherConsignee ||  // If the consignee is 'Other'
                (recentBlock.other_consignee_name !== '' &&  // Check if other_consignee_name is filled
                recentBlock.other_consignee_city !== '' &&  // Check if other_consignee_city is filled
                recentBlock.other_consignee_pincode !== ''))  // Check if other_consignee_pincode is filled
        );
    };
    const handleButtonClick = (e) => {
        e.stopPropagation();
    
        // Initialize an object to store validation errors for each drop point
        let errors = {};
    
        // manualTripUploadDetails.forEach((point, index) => {
        //     const currentErrors = {};
        //     // Check if required fields are filled
        //     if (!point.invoice_no) currentErrors.invoice_no = "Invoice No is required.";
        //     if (!point.consignee_name) currentErrors.consignee_name = "Consignee Name is required.";
        //     if (!point.destination_pincode) currentErrors.destination_pincode = "Destination Pincode is required.";
        //     if (!point.destination_city) currentErrors.destination_city = "Destination City is required.";
    
        //     if (Object.keys(currentErrors).length > 0) {
        //         errors[point.id] = currentErrors; // Add errors for the current drop point
        //     }
        // });
    
        // // If there are errors, update the validation state and do not add a new drop point
        // if (Object.keys(errors).length > 0) {
        //     setValidationErrors(errors);
        //     setShow(true);
        //     setTitle("Please fill all required details in each drop point.");
        //     setType("danger");
        //     return;
        // }
    
        // If no errors, proceed to add a new drop point
        const newTripDetail = {
            id: uuidv4(),
            lr_no: '',
            consignee_name: "",
            invoice_no: "",
            no_of_boxes: "",
            destination_pincode: "",
            destination_city: "",
            eway_bill_no: "",
            customer_mail_id: "",
            other_consignee_name: "",
            other_consignee_pincode:"",
            other_consignee_city: ""
        }        
        setManualTripUploadDetails((prevDetails) => [
            ...prevDetails,
            newTripDetail
        ])    
        setValidationErrors({});
    };

const onTabChange =(selectedtab)=>{
    setSelectedViewTab(selectedtab);
    onShowDocs1(selectedtab);
}
    
const formatDateForSubmission = (date) => {
        // Check if the input is a valid Date object
        if (!(date instanceof Date)) {
            // Try to convert it to a Date object if possible
            date = new Date(date);
        }
    
        // If the date is still invalid, handle the error
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date format");
        }
    
    const pad = (num) => num.toString().padStart(2, '0');
    return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
};
const formatDateForSubmission1 = (date) => {
    // Check if the input is a valid Date object
    if (!(date instanceof Date)) {
        // Try to convert it to a Date object if possible
        date = new Date(date);
    }

    // If the date is still invalid, handle the error
    if (isNaN(date.getTime())) {
        throw new Error("Invalid date format");
    }

const pad = (num) => num.toString().padStart(2, '0');
return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
const handleCloseSlider=()=>{
    setIsSliderOpen(false);
    setOverlay("show-n")

} 
 
    
    var filterClassName = "form-group col-xl-4 col-lg-4";
    return (
        <div>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            {showBgAlert && (
                <SweetAlert
                    info
                    title="Updating in Background"
                    confirmBtnText="OK"
                    onConfirm={() => {
                        setShowBgAlert(false);
                        window.location.reload();
                    }}
                >
                    Data is being updated in background.
                    <br />
                    Once completed, you will receive an email.
                </SweetAlert>
            )}
            {/* <Modal
                onHide={closeForceCloseModal}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={formForceCloseHandler}>
                            <div className="col-xl-12 col-lg-12">
                                <label className="custom-label">
                                    Reason
                                </label>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <textarea
                                    type="text"
                                    value={reasonForceClose}
                                    onChange={e => setReasonForceClose(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end", marginRight:"17px" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal> */}

            <Modal
                onHide={closeCancelModal}
                dialogClassName="my-modal"
                show={cancelModal}
                centered>
                <Modal.Header>
                    <Modal.Title>{(tabName.value !=="inactive" && tabName.value!=="transporter")? 'Disable Shipment' : "Delete Invoice"}</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeCancelModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={cancelFormCloseHandler}>
                            {(tabName.value !== "inactive" && tabName.value!=="transporter") && 
                                <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                    <label className="reason">LR No</label>
                                    <input type="text" name="reason" autoComplete="off" class="form-control" id="lrno" value={rownode.lr_no} />                                
                                </div>                          
                            } 
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label>Selected Invoices </label>
                                <Select 
                                    closeMenuOnSelect={false}
                                    value={lrNoOption}
                                    isMulti={tabName.value !== "inactive"}
                                    className="border-radius-0"
                                    isDisabled={tabName.value === "inactive"}                                    
                                    isSearchable={tabName.value !== "inactive"}
                                    style={{ borderRadius: "0px" }}
                                    readOnly={tabName.value === "inactive"}
                                    required 
                                />
                            </div>
                            <div className="col-xl-12 col-lg-12" style={{marginBottom:"20px"}}>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Withdrawal
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForCancellation}
                                    onChange={e => setReasonForCancellation(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end", marginRight:"17px" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => setForcecloseModal(false)}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Cancel LR </Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button
                            type="button"
                            className="btn btn-sm btn-icon btn-outline-primary"
                            onClick={() => setForcecloseModal(false)}
                        >
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body className="view-task">
                    <form onSubmit={processForceCloseHandler}>
                        <div className="mb-3">
                            <label className="custom-label">LR No</label>
                            <input
                                type="text"
                                className="form-control"
                                value={rownode?.lr_no || ""}
                                readOnly
                            />
                        </div>

                        <div className="mb-3">
                            <label>Invoices</label>
                            <Select
                                closeMenuOnSelect={false}
                                isMulti
                                value={selectedInvoices}
                                onChange={setSelectedInvoices}
                                options={invoiceNoList}
                                className="border-radius-0"
                                isSearchable
                                placeholder="Select invoices"
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="custom-label">
                                Reason <span style={{ color: '#EB1D54' }}>*</span>
                            </label>
                            <textarea
                                value={reasonForceClose}
                                onChange={e => setReasonForceClose(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                            <button type="submit" className="primary-button">Submit</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <CustomDialog
                isOpen={isSliderEmailOpen}
                onClose={onCloseEmail}
                onSubmitEmail={onSubmitEmail}
                email={email}
                changeEmail={changeEmail}
                whatsapp_no={whatsapp_no}
                changeWhatsapp={changeWhatsapp}
                expired_time={expired_time}
                changeExpiredTime={changeExpiredTime}
                handleKeyDown={handleKeyDown}
                setActiveForm={setActiveForm}
                activeForm={activeForm}
            /> 
             <CustomDialogForEditLogs
            isOpen={editLogsModalOpen}
            onClose={handleCloseModal}
            editLogsData={editLogsData}
            filteredLog={filteredLog}
            setFilteredLog={setFilteredLog}
        />
            {!trackingTimeline && <TimelineModal showModal={showModal} onClose={onCloseModal} truckCourier={true} timelineData={timelineData} expectedTripEndTimeStamp = {expectedTripEndTimeStamp} revisedTripEndTimeStamp = {revisedTripEndTimeStamp} actualDeliveryDate={actualDeliveryDate} deliveryDate={deliveryDate}/>}
            <CustomDialogForDocumentsViewing
                isOpen={isSliderDocumentOpen}
                onClose={onCloseDocument}
                documents={documents}
                trackingType={trackingType}
                onTabChange ={onTabChange}
                selectedTab={selectedViewTab}
                // PodRemark={viewRemark}
            /> 
            <CustomDialogForDocumentsViewing
                isOpen={isSliderPODDocumentOpen}
                onClose={onClosePodDocument}
                documents={podDocuments}
                PodRemark={viewPodRemark}
                pod={true}
            />
           
            <Modal
                onHide={closeforceCloseModal}
                dialogClassName="my-modal"
                show={forceCloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Disable Shipment</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeforceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={cancelForceCloseFormCloseHandler}>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label className="reason">Vehicle No</label>
                                <input type="text" name="reason" autoComplete="off" class="form-control" id="lrno" value={rownode.truck_no} />                                
                            </div>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label>Selected Invoices </label>
                                <Select 
                                    closeMenuOnSelect={false}
                                    value={invoiceNoList}
                                    isMulti={true}
                                    className="border-radius-0"
                                    style={{ borderRadius: "0px" }}
                                    required 
                                />
                            </div>
                            <div className="col-xl-12 col-lg-12" style={{marginBottom:"20px"}}>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Withdrawel
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForCancellation}
                                    onChange={e => setReasonForCancellation(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
        </Modal>

            <div className={"slide-r " + (sliderShow)}>
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Upload POD
                            <span
                                  className="float-right closebtn"
                                  style={{ marginRight: "10px" }}
                                  onClick={onCloseSliderDiv}          
                                        >
                                 X
                            </span>
                        </h4>
                    </div>
                    

                    <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" method="POST" id="formPOD" enctype="multipart/form-data" onSubmit={uploadDocument}>
                                <div className="row p-20p">
                                {Array.isArray(rownode) && rownode[0]?.tracking_type === "FTL" && (
                                            <div className="form-group col-sm-12 mb-20p">
                                                {/* <label>Select Invoice<span style={{ color: 'red' }}>*</span></label>
                                                
                                                <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select invoices..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={invoicesUploadList}
                                                    // required
                                                /> */}
                                                <label className="f16">LR No.
                                                    {/* <span style={{ color: 'red' }}>*</span> */}
                                                    </label>
                                                
                                                {/* <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select LR No's..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    // options={invoicesUploadList}
                                                    
                                                    // required
                                                /> */}
                                                     <input
                                                        type="text"
                                                        id="selectedLr"
                                                        className="border-radius-0"
                                                        readOnly // Makes the input non-editable

                                                        style={{
                                                            borderRadius: '5px',
                                                            fontSize: '13px',
                                                            padding: '8px',
                                                            width: '100%',
                                                            border: "2px solid lightgrey",
                                                        }}
                                                        value={invoicesUploadList}
                                                        
                                                    />
                                            </div>
                                        )}
                                    <div className="form-group col-sm-12">
                                        <label className="f16">Upload POD Document<span style={{color:'red'}}>*</span></label>
                                        
                                        <input type="file" name="epodDoc" id="epodDoc" className="form-control" accept=".pdf, image/*" onChange={changeFileHandlerForPod} required />
                                    </div>
                                   


                                    <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Damage
                                        </label><br />
                                        <input type='number' value={damage}  onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setDamage(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Excess
                                        </label><br />
                                        <input type='number' value={excess} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setExcess(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Pilferage
                                        </label><br />
                                        <input type='number' value={pilferage} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setPilferage(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group2 col-sm-6">
                                        <label className="f16">
                                            Short
                                        </label><br />
                                        <input type='number' value={short} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setShort(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label className="f16">Remarks</label>
                                        <textarea name="podremarks" id="podremarks" rows="3" value={podremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div> 
                                    
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlock}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm-12' style={{display:"flex",alignItems:"flex-end", justifyContent:"space-between"}}>
                        <h5 className='title-heading mb-10p' style={{marginTop:"-18px", fontWeight:"bold"}}>
                        <i className="icofont icofont-vehicle-delivery-van cus-i "></i> Consignments Information
                        </h5>
                        
                        <div style={{ marginRight: "-6px", marginTop:"-31px" }}>

                       
                            <i className="icofont icofont-filter filter-styling" style={{border:"1px solid #ccc", color:"#ccc",boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)" , background:"#fff"}} onClick={() => setFilterToggle(prev => !prev)} title="Filters"></i>
                            <i className="icofont icofont-refresh filter-styling" style={{border:"1px solid #ccc", color:"black",boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)" , background:"#fff"}} onClick={e=>resetFilters()} title="Reset searched value"></i>
                            {((tabName.value === "active" || tabName.value === "inactive" || tabName.value === "completed" || tabName.value === "transporter" || tabName.value === "all") &&(decodedRoleCase === "admin" || decodedRoleCase === "warehouse" || decodedRoleCase === "transporter" || decodedRoleCase === "user" ))?(
                            <span className="float-right">
                                    {(selectedOption1 && selectedOption1==="lr") && 
                                     (<div
                                     className="d-flex mt-14p ml-8p mr-10p"
                                     style={{ position: "relative" }}
                                 >
                                     <input
                                        type="text"
                                         style={{
                                             border: "1px solid #cccccc",
                                             borderRadius: "4px",
                                             height: "35px",
                                             outline: "none",
                                             paddingLeft: "6px",
                                             fontSize:"12px"
                                         }}
                                         onChange={(e)=> setLrNo(e.target.value)}
                                         value={lrNo}
                                         placeholder='Search LR No.'
                                     />
                                    {/* {checkresetfilter != 1 ? */}
                                    
                                
                                         
                                            <img
                                             src={SearchIcon}
                                             className="search_icon ml-2"
                                             onClick={getTruckConsignments}
                                         />  
                                 </div>)}
                                 
                                 {/* {checkresetfilter != 1 ? */}
                                         
                                 {(selectedOption1 && selectedOption1==="invoice") && 

                                 (<div
                                     className="d-flex mt-14p ml-8p mr-10p"
                                     style={{ position: "relative" }}
                                 >
                                     <input
                                        type="text"
                                         style={{
                                             border: "1px solid #cccccc",
                                             borderRadius: "4px",
                                             height: "35px",
                                             outline: "none",
                                             paddingLeft: "6px",
                                             fontSize:"12px"

                                         }}
                                         value={searchInvoice}
                                //  onChange={(e)=> setSearchInvoice(e.target.value)}
                                onChange={(e)=> handleInvoiceSearch(e.target.value)}
                                 placeholder='Search Invoice No.'

                                     />
                                     <img
                                             src={SearchIcon}
                                             className="search_icon ml-2"
                                            //  onClick={getTruckConsignments}
                                            onClick={() => handleInvoiceSearch(searchInvoice)}
                                         />  
                                 </div>)
                                 }

                            </span>
                        ):""}
                        
                            {( tabName.value !== "force_close") && 
                                    <>
                                        {/* <div className="col-xl-2 col-lg-2 float-right" style={{marginTop:"-30px"}}>
                                            <label style={{fontSize:"12px", fontWeight:"700"}}>Select View Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedView"
                                                value={searchViewType}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={(e)=>viewTypeChange(e)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={[
                                                    { label: "Invoice", value: "Invoice"},
                                                    { label: "LR", value: "LR"}
                                                ]}
                                                required />
                                         </div>  */}
                                         <span className="float-right">
                                         <label className="radio-buttons float-right f12 mt-10p">
                            <input
                                type="radio"
                                // name="option"
                                // value={selectedOption1}
                                checked={selectedOption1 === "invoice"}
                                onClick={handleViewInvoiceClick} // Toggle logic inside onClick
                            />
                            
                            <span className="mr-5p l-5p float-right" style={{marginTop:'-3px'}}>
                            &nbsp;
                            Invoice View</span>
                            </label>
                            {(tabName.value !=="inactive" && tabName.value !=="transporter") && 

                            (<label className="radio-buttons float-right f12 mt-10p">
                            <input
                                type="radio"
                                // name="option"
                                // value={selectedOption1}
                                checked={selectedOption1 === "lr"}
                                onClick={handleViewLRClick} // Attach onClick handler
                                
                            />
                            <span className="mr-5p l-5p float-right" style={{marginTop:'-3px'}}>
                            &nbsp;LR View</span>
                            </label>)}
                            
                            
                            </span>
                                         </>}
                                         {/* {(["user", "warehouse"].includes(decode(localStorageRole)) && !["all sites", "all shipments", "all numeric shipments"].includes(location)) &&
                                    <><span className=''>
                                        <div className="col-xl-2 col-lg-2 float-right" style={{marginTop:"-30px"}}>
                                            <label style={{fontSize:"12px", fontWeight:"700"}}>Select Process Flow Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedView"
                                                value={viewOptions.find(option=>option.value===processFlowType)}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '13px' }),
                                                    width:"100%"
                                                }}
                                                onChange={(e)=>SetProcessFlowType(e.value)}
                                                style={{ borderRadius: "0px", fontSize:"13px" }}
                                                options={viewOptions}
                                                required />
                                         </div> 
                                         </span>
                                       
                            
                                         </>} */}
                                  
                            {/* {((tabName.value === "active" || tabName.value === "inactive" || tabName.value === "completed" || tabName.value === "transporter" || tabName.value === "all") &&(decode(localStorageRole).toLowerCase() === "admin" || decode(localStorageRole).toLowerCase() === "warehouse" || decode(localStorageRole).toLowerCase() === "transporter" ))?(
                            <span className="float-right">
                            <label className="radio-buttons float-right f12 mt-10p">
                            <input
                                type="radio"
                                // name="option"
                                // value="search"
                                checked={selectedOption === "invoice"}
                                onClick={handleSearchInvoiceClick} // Toggle logic inside onClick
                            />
                            
                            <span className="mr-5p l-5p float-right" style={{marginTop:'-3px'}}>
                            &nbsp;
                            {tabName.value === 'inactive' || tabName.value === 'transporter' ? 'Search Invoice' : 'Search Invoice'}                            </span>
                            </label>
                            {(tabName.value !== "inactive" && tabName.value !== 'transporter') &&
                            (<label className="radio-buttons float-right f12 mt-10p">
                            <input
                                type="radio"
                                // name="option"
                                // value="filter"
                                checked={selectedOption === "lr"}
                                onClick={handleSearchLRClick} // Attach onClick handler
                                
                            />
                            <span className="mr-5p l-5p float-right" style={{marginTop:'-3px'}}>
                            &nbsp;Search LR</span>
                            </label>)}
                            
                            
                            </span>
                        ):""} */}
                         

                          
                                        
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-row justify-content-between mt-10p">
                {(["user", "user-inbound", "user-outbound", "wh-inbound", "wh-outbound", "warehouse"].includes(decode(localStorageRole)) && !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item)) || ["warehouse"].includes(decode(localStorageRole)))?  //Numeric Entity Warehouse Login Issue
                    <div className="">
                        <ul className={"nav nav-tabs"}>
                           { ["user-inbound", "wh-inbound", "user", "warehouse"].includes(decode(localStorageRole)) &&
                            <li className={"nav-item"} style={{width : "98px"}}>
                                <a className={`nav-link ${processFlowType == "inbound" ? "tab-active" : "" }`}
                                    aria-current="page"
                                    onClick={()=> {SetProcessFlowType('inbound'); 
                                        if ((!["transporter", "admin"].includes(decodedRoleCase)))  {
                                            setTabName({ label: "active", value: "active" });
                                            decodedRoleCase==="user" ? navigate("/consignments/active_inbound_consignments"): navigate("/consignments/active_consignments"); 
                                            // << Important
                                          }
                                     
                                        if(decodedRoleCase === "warehouse" && ["inactive", "transporter"].includes(tabName.value)){
                                            columnApiConsignments.current.setColumnsVisible(["checkbox", "cancel_order", "update_tpt"], false);
                                            // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible = true;
                                            // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = true;
                                            // columnApiConsignments.current.getColumn("update_tpt").colDef.lockVisible = true;

                                        } 
                                        if(decodedRoleCase === "warehouse" && ["active", "all"].includes(tabName.value)){
                                            columnApiConsignments.current.setColumnsVisible(["update", "cancel_order", "update_tpt"], false);
                                            // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible = true;
                                            // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = true;
                                            // columnApiConsignments.current.getColumn("update_tpt").colDef.lockVisible = true;
                                        }
                                        }}
                                    style={{
                                        color: processFlowType === "inbound" ? "#035efc" : "inherit",
                                        borderTop: "none",
                                        borderLeft: "none",
                                        borderRight: "none",
                                        borderBottom: processFlowType === "inbound" ? "2px solid #035efc" : "none",
                                        cursor:"pointer",
                                        fontSize:"16px",
                                        padding:"10px 15px"

                                    }}
                                >
                                    Inbound
                                </a>
                            </li>}
                            &nbsp;
                            { ["user-outbound", "wh-outbound", "user", "warehouse"].includes(decode(localStorageRole)) &&
                            <li className={"nav-item"} style={{width : "96px"}}>
                                <a
                                    className={`nav-link ${processFlowType == "outbound" ? "tab-active" : "" }`}
                                    onClick={() => { SetProcessFlowType("outbound");
                                        if ((!["transporter", "admin"].includes(decodedRoleCase))) {
                                            setTabName({ label: "inactive", value: "inactive" });
                                            decodedRoleCase==="user" ? navigate("/consignments/inactive_outbound_consignments"): navigate("/consignments/inactive_consignments"); 
                                          }
                                        if(decodedRoleCase === "warehouse" && ["inactive", "transporter"].includes(tabName.value)){
                                            columnApiConsignments.current.setColumnsVisible(["checkbox", "cancel_order", "update_tpt"], true);
                                            // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible = false;
                                            // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = false;
                                            // columnApiConsignments.current.getColumn("update_tpt").colDef.lockVisible = false;

                                        } 
                                        if(decodedRoleCase === "warehouse" && ["active", "all"].includes(tabName.value)){
                                            columnApiConsignments.current.setColumnsVisible(["update", "cancel_order","update_tpt"], true);
                                            // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible = false;
                                            // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = false;
                                            // columnApiConsignments.current.getColumn("update_tpt").colDef.lockVisible = false;
                                        }
                      
                                    }}
                                    style={{
                                        color: processFlowType === "outbound" ? "#035efc" : "inherit",
                                        borderBottom: processFlowType === "outbound" ? "2px solid #035efc" : "none",
                                        borderTop: "none",
                                        borderLeft: "none",
                                        borderRight: "none",
                                        cursor:"pointer",
                                        fontSize:"16px",
                                        padding:"10px 15px"
                                    }}
                                >
                                    Outbound
                                </a>
                            </li>}
                        </ul>
                    </div>
                : ""}
            </div>                   
            <>     
                <div className='mt-1 mb-1'>
                    {(["warehouse","wh-inbound"].includes(decodedRoleCase) && (processFlowType === "inbound")) &&
                    <button
                        onClick={() => {
                            handleInboundTabChange("my_warehouse")
                        }}
                        id="my_warehouse"
                        className={warehouseTab.value === "my_warehouse" ? "btn btn-sea pgtab" : "btn pgtab"}
                        // className={warehouseTab.value === "my_warehouse" ? "btn btn-v violet-tab" : "btn violet-tab"}
                        style={{
                            borderTopLeftRadius: "6px",
                            display: warehouseTab.value === "my_warehouse" ? "inline-flex" : "",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            width : "95px",
                            marginRight : "4px"
                        }}
                    >
                        My WH
                    </button>
                    }   
                    {(["warehouse","wh-inbound"].includes(decodedRoleCase) && (processFlowType === "inbound")) &&
                    <button
                        onClick={() => {
                            handleInboundTabChange("my_region");
                        }}
                        id="my_region"
                        className={warehouseTab.value === "my_region" ? "btn btn-sea pgtab" : "btn pgtab"}
                        // className={warehouseTab.value === "my_warehouse" ? "btn btn-sea sea-tab" : "btn sea-tab"}
                        style={{
                            borderTopLeftRadius: "6px",
                            display: warehouseTab.value === "my_region" ? "inline-flex" : "",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            width : "99px"
                        }}
                    >
                        My Region
                    </button>
                    }  
                </div>
            <div className="row col-xl-12 col-lg-12 justify-content-between" style={{ position: "relative" }}>
    <div>

        {(decodedRoleCase !== "transporter" && (processFlowType==="outbound") || (decodedRoleCase==="admin")) &&
        <button
            onClick={() => { handleTabChange("inactive"); 
                if(decodedRoleCase === "warehouse" && processFlowType==="inbound"){
                    
                    columnApiConsignments.current.setColumnsVisible(["checkbox", "cancel_order"], false);
                    // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible = true;
                    // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = true;
                }
            }}
            id="inactive"
            className={tabName.value === "inactive" ? "btn btn-h pgtab" : "btn pgtab"}
            style={{
                borderTopLeftRadius: "6px",
                display: tabName.value === "inactive" ? "inline-flex" : "",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
        >
            Invoice Details 
        </button>}
        {(decodedRoleCase !== "transporter" && (processFlowType==="outbound") ||  ["admin", "transporter"].includes(decodedRoleCase)) &&

        <button
            onClick={() => { handleTabChange("transporter");
                if(decodedRoleCase === "warehouse" && processFlowType==="inbound"){
                    columnApiConsignments.current.setColumnsVisible(["checkbox", "cancel_order"], false);
                    // columnApiConsignments.current.getColumn("checkbox").colDef.lockVisible = true;
                    // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = true;
                }
             }}
            id="transporter"
            className={tabName.value === "transporter" ? "btn btn-h pgtab" : "btn pgtab"}
            style={{
                display: tabName.value === "transporter" ? "inline-flex" : "",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
        >
            Transporter
        </button>}

        <button
            onClick={() => { handleTabChange("active"); 
                
                if(decodedRoleCase === "warehouse" && processFlowType==="inbound"){
                    
                    columnApiConsignments.current.setColumnsVisible(["update", "cancel_order"], false);
                    // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = true;
                    // columnApiConsignments.current.getColumn("update").colDef.lockVisible = true;

                } 
                
                
            }}
            id="active"
            className={tabName.value === "active" ? "btn btn-h pgtab" : "btn pgtab"}
            style={{
                display: tabName.value === "active" ? "inline-flex" : "",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
        >
            Active
        </button>

        <button
            onClick={() => { handleTabChange("delivered"); }}
            id="completed"
            className={tabName.value === "completed" ? "btn btn-h pgtab" : "btn pgtab"}
            style={{
                display: tabName.value === "completed" ? "inline-flex" : "",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
        >
            Delivered
        </button>

        <button
            onClick={() => { handleTabChange("all"); 
                if(decodedRoleCase === "warehouse" && processFlowType==="inbound"){
                    columnApiConsignments.current.setColumnsVisible(["update", "cancel_order"], false);
                    // columnApiConsignments.current.getColumn("cancel_order").colDef.lockVisible = true;
                    // columnApiConsignments.current.getColumn("update").colDef.lockVisible = true;
                }
            }}
            id="all"
            className={tabName.value === "all" ? "btn btn-h pgtab" : "btn pgtab"}
            style={{
                borderTopRightRadius: "6px",
                display: tabName.value === "all" ? "inline-flex" : "",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
        >
            All
        </button>
    </div>

    {((tabName.value === "active" || tabName.value === "inactive") &&
        (decodedRoleCase === "admin" || decodedRoleCase === "warehouse" || decodedRoleCase == "wh-outbound")) ? (
        <div style={{ position: "absolute", top: "0", right: "-15px", display: "flex", gap: "10px" }}>
            {((tabName.value ==="active") && (decodedRoleCase === "admin" || (decodedRoleCase === "warehouse" && processFlowType==="outbound") || decodedRoleCase == "wh-outbound")) && (
                <>
                <button 
                    type="button" 
                    className="btn btn-warning" 
                    onClick={onClickShowForm} 
                    style={{ fontSize: '13px' }}>
                    Add Consignment
                </button>
                {(isSliderOpen && 
                    courierPartnerList.length > 0 && 
                    vehicleFtlTypeList.length > 0 && 
                    consignees.length > 0 && sourceList.length>0 && originalSourceList.length>0 && seriesRecords.length>0 && sourceSeriesList.length>0) &&
                    (
                        <AddConsignmentSlider
                            isOpen={isSliderOpen}
                            onClose={handleCloseSlider}
                            courierPartnerList={courierPartnerList}
                            vehicleFtlTypeList={vehicleFtlTypeList}
                            consignees={consignees}
                            sourceList={sourceList}
                            originalSourceList={originalSourceList}
                            seriesRecords={seriesRecords}
                            sourceSeriesList={sourceSeriesList}
                            fuelTypeList={fuelTypeList}
                            tptNFuel={tptNFuel}
                        />
                )}

                </>
            )}
            {((tabName.value ==="inactive") && (decodedRoleCase === "admin" || (decodedRoleCase === "warehouse" && processFlowType==="outbound") || decodedRoleCase == "wh-outbound")) && (
            <button
                title="Bulk Upload"
                onClick={onClickOpenBulkUploadModal}
                className="btn btn-warning"
                type="button"
                style={{ fontSize: "13px" }}
            >
                <i className="fa fa-upload"></i>&nbsp;&nbsp;&nbsp;Upload Consignments
            </button>)
}
            
        </div>
    ) : ""}
</div>

            


                <div className={filterToggle ? "filter-in" : "filter-out"}>
                    
                        {filterToggle &&  
                        <div className={"col-xl-12 col-lg-12 d-flex flex-column"} style={{padding:"0px"}}>
                            <div className="card">
                                <div className="row card-body" style={filterCardStyle2}>
                                    <div className="row col-xl-12 col-lg-12" style={mnFilterClass}>
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Select Origin </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={searchConsigner}
                                                isMulti={true}
                                                className="border-radius-0"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'}),
                                                }}
                                                onChange={e => setSearchConsigner(e)}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                options={consignersList}
                                                required />

                                        </div>
                                        {((tabName.value ==="inactive" || tabName.value ==="transporter")) ? 
                                           <>
                                           {/* <div className="col-xl-4 col-lg-4 form-group" style={{padding:"0px"}}>

                                           <div className="col-xl-12 col-lg-12"><label style={{fontSize:"13px", fontWeight:"700"}}>Select Date Type</label></div>
                                                   <div className="col-xl-12 col-lg-12">
                                           <Select
                                               className="border-radius-0"
                                               isMulti={false}
                                               id="selectedFilter"
                                               value={searchDateType}
                                               styles={{
                                                   option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                   singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                   placeholder: (styles)=> ({...styles, fontSize:'12px'}),

                                                   width:"100%"
                                               }}
                                               onChange={e => setSearchDateType(e)}
                                               style={{ borderRadius: "0px", fontSize:"12px" }}
                                              
                                               options={dateTypeList}
                                               required />
                                       </div>
                                       </div> */}
                                               <div className="col-xl-2 col-lg-2 form-group date-container" style={{paddingLeft:"15px"}}>
                                                <label style={{fontSize:"13px", fontWeight:"700"}}>Invoice From Date</label>
                                                   {/* <div className="mt-14p">   */}
                                                    {/* <Datepicker id='date' onDatesSelected={handleDatesSelected} onRefreshSelected={refreshSelected} />
                                                            {checkresetfilter != 1 ?
                                                        <img
                                                            src={SearchIcon}
                                                            className="search_icon_for_dates pointer"
                                                            onClick={filterDatafordates}
                                                        /> 
                                                        : <img
                                                            src={RefreshIcon}
                                                            className="search_icon_for_dates pointer"
                                                            onClick={refreshData1}
                                                        />}
                                                        </div> */}
                                                       <DatePicker
                                                           selected={startDate}
                                                           onChange={handleStartDateChange}
                                                           name="startDate"
                                                           className="datepicker-custom2"
                                                           style={{ fontSize: "12px" }}
                                                           onKeyDown={(e) => e.preventDefault()}
                                                           dateFormat="dd-MM-yyyy"
                                                           showYearDropdown
                                                           showMonthDropdown
                                                        //    showYearPicker  // Enable Year Picker
                                                        //    showMonthYearPicker  // Enable Month & Year Picker (to directly pick month/year)
                                                        //    yearItemNumber={12}  // Number of years shown in the dropdown (optional, adjust as needed)
                                                        //    scrollableYearDropdown  // Allows scrolling through years (optional)
                                                        //    dropdownMode="select"  // Allows selection of year and month
                                                           
                                                       />
                                               </div>
                                               <div className="col-xl-2 col-lg-2 form-group date-container" style={{paddingLeft: "15px"}}>
                                                   <label style={{fontSize:"13px", fontWeight:"700"}}>Invoice To Date</label>
                                                       <DatePicker
                                                           selected={endDate}
                                                           onChange={handleEndDateChange}
                                                           name="endDate"
                                                           className="datepicker-custom2"
                                                           style={{fontSize:"12px"}}
                                                           onKeyDown={(e) => e.preventDefault()}
                                                           dateFormat="dd-MM-yyyy"
                                                           showYearDropdown
                                                           showMonthDropdown
                                                       />
                                               </div>
                                               <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Destination City</label>
                                            <Select closeMenuOnSelect={false}
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedCity"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'})

                                                }}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                value={searchCity}
                                                onChange={e => setSearchCity(e)}
                                                options={filterCities}
                                            />
                                        </div>
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Entity</label>
                                            {/* <Select
                                        isMulti={true}
                                        id="selectedEntity"
                                        styles={{
                                            control: (styles) => ({
                                            ...styles,
                                            width: "200px", // Increase the width of the select container
                                            display: "flex", // Flex to align content properly
                                            }),
                                            valueContainer: (styles) => ({
                                            ...styles,
                                            maxWidth: "380px", // Set max width for the selected values
                                            overflowX: "auto", // Enable horizontal scrolling
                                            whiteSpace: "nowrap", // Prevent wrapping of the selected values
                                            }),
                                            menu: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Maintain consistent font size in the dropdown options
                                            }),
                                            multiValue: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Ensure consistent font size for selected chips
                                            margin: "2px 4px", // Add space between chips
                                            }),
                                            multiValueLabel: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Font size for the text inside chips
                                            }),
                                            multiValueRemove: (styles) => ({
                                            ...styles,
                                            cursor: "pointer", // Make the remove button clickable
                                            }),
                                        }}
                                        value={searchEntity}
                                        onChange={(e) => setSearchEntity(e)}
                                        options={entityList}
                                        /> */}
                                        <Select closeMenuOnSelect={false}
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedEntity"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'})

                                                }}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                value={searchEntity}
                                                onChange={e => setSearchEntity(e)}
                                                options={entityList}
                                            />

                                        </div>
                                        {tabName.value ==="inactive" && 
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Consignee Name</label>
                                            <Select closeMenuOnSelect={false}
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedConsigneeName"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'})

                                                }}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                value={searchConsigneeName}
                                                onChange={e => setSearchConsigneeName(e)}
                                                options={filterConsigneeNames}
                                            />
                                        </div>}
                                        {tabName.value==="inactive" &&(
                                            <>
                                        <div className="form-group col-xl-1 col-lg-1" style={{ textAlign: "left", maxWidth:"77px",marginTop:"30px"  }}>
                                        <button type="button" className="btn btn-success" style={{borderRadius:"4px"}} onClick={onGetConsignments}>Submit</button>
                                    </div>
                                    <div className="form-group col-xl-1 col-lg-1" style={{ textAlign: "left", marginTop:"30px",borderRadius:"4px" }}>
                                        <button type="button" onClick={resetFilters1} style={{borderRadius:"4px"}} className="btn btn-default">Reset</button>
                                    </div>
                                    </>)}
                                           </>
                                        :
                                            <>
                                            <div className="col-xl-2 col-lg-2 form-group" style={{padding:"0px"}}>

                                            <div className="col-xl-12 col-lg-12"><label style={{fontSize:"13px", fontWeight:"700"}}>Select Date Type</label></div>
                                                    <div className="col-xl-12 col-lg-12">
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchDateType}
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'}),

                                                    width:"100%"
                                                }}
                                                onChange={e => setSearchDateType(e)}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                options={dateTypeList}

                                                required />
                                        </div>
                                        </div>
                                                <div className="col-xl-2 col-lg-2 form-group date-container" style={{padding:"0px"}}>
                                                    <div className="col-xl-12 col-lg-12"><label style={{fontSize:"13px", fontWeight:"700"}}>{`${searchDateType.value} From Date`}</label></div>
                                                    <div className="col-xl-12 col-lg-12">
                                                        <DatePicker
                                                            selected={startDate}
                                                            onChange={handleStartDateChange}
                                                            name="startDate"
                                                            className="datepicker-custom2"
                                                            style={{fontSize:"12px"}}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-2 col-lg-2 form-group date-container" style={{padding: "0px"}}>
                                                    <div className="col-xl-12 col-lg-12"> <label style={{fontSize:"13px", fontWeight:"700"}}>{`${searchDateType.value} To Date`}</label></div>
                                                    <div className="col-xl-12 col-lg-12">
                                                        <DatePicker
                                                            selected={endDate}
                                                            onChange={handleEndDateChange}
                                                            name="endDate"
                                                            className="datepicker-custom2"
                                                            style={{fontSize:"12px"}}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            dateFormat="dd-MM-yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                        />
                                                    </div>
                                                </div>
                                                {(tabName.value==="active" || tabName.value==="completed" || tabName.value==="all") && 
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Destination City</label>
                                            <Select closeMenuOnSelect={false}
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedCity"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'})

                                                }}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                value={searchCity}
                                                onChange={e => setSearchCity(e)}
                                                options={filterCities}
                                            />
                                        </div>}
                                            </>
                                        }
                                        {/* {tabName.value !== "inactive" ? 
                                                    
                                                    
                                        : ""} */}
                                        
                                        {(tabName.value !== "inactive" && ["warehouse", "user", "admin", "transporter"].includes(decodedRoleCase))? 
                                            (<div className="col-xl-2 col-lg-2 form-group">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Select Tracking Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchTrackingType}
                                                placeholder="Select Tracking Type"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'}),

                                                    width:"100%"
                                                }}
                                                onChange={e => setSearchTrackingType(e)}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                options={[
                                                    {label:"All", value:"All"},
                                                    { label: "PTL", value: "PTL"},
                                                    { label: "FTL", value: "FTL"},
                                                    
                                                ]}
                                                isDisabled={tabName.value === "inactive"}
                                                required />
                                        </div>)
                                        : ""}
                                        
                                    </div>
                                    <div className="row col-xl-12 col-lg-12" style={{ marginLeft: "0px", padding: "0px" }}>
                                      
                                       
                                        {(tabName.value!=="inactive") && 
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Destination State</label>
                                            <Select closeMenuOnSelect={false}
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedState"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'})

                                                }}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                value={searchState}
                                                onChange={e => setSearchStates(e)}
                                                options={filterStates}
                                            />
                                        </div>}
                                        {(tabName.value==="completed" || tabName.value==="all") &&  <div className="form-group col-xl-2 col-lg-2">
                                          <label style={{fontSize:"13px", fontWeight:"700"}}>Select POD Status</label>
                                          <Select 
                                              className="border-radius-0"
                                              isMulti={true}
                                              id="selectedPOD"
                                              styles={{
                                                  option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                  singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                  placeholder: (styles)=> ({...styles, fontSize:'12px'})

                                              }}
                                              style={{ borderRadius: "0px", fontSize:"12px" }}
                                              value={searchPodStatus}
                                              onChange={e => setSearchPodStatus(e)}
                                              options={podStatusList}
                                          />
                                      </div>}
                                       {(tabName.value!=="inactive"  && tabName.value !=="transporter") &&
                                        <div className="form-group col-xl-2 col-lg-2">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Entity</label>
                                            {/* <Select
                                        isMulti={true}
                                        id="selectedEntity"
                                        styles={{
                                            control: (styles) => ({
                                            ...styles,
                                            width: "200px", // Increase the width of the select container
                                            display: "flex", // Flex to align content properly
                                            }),
                                            valueContainer: (styles) => ({
                                            ...styles,
                                            maxWidth: "380px", // Set max width for the selected values
                                            overflowX: "auto", // Enable horizontal scrolling
                                            whiteSpace: "nowrap", // Prevent wrapping of the selected values
                                            }),
                                            menu: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Maintain consistent font size in the dropdown options
                                            }),
                                            multiValue: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Ensure consistent font size for selected chips
                                            margin: "2px 4px", // Add space between chips
                                            }),
                                            multiValueLabel: (styles) => ({
                                            ...styles,
                                            fontSize: "13px", // Font size for the text inside chips
                                            }),
                                            multiValueRemove: (styles) => ({
                                            ...styles,
                                            cursor: "pointer", // Make the remove button clickable
                                            }),
                                        }}
                                        value={searchEntity}
                                        onChange={(e) => setSearchEntity(e)}
                                        options={entityList}
                                        /> */}
                                        <Select closeMenuOnSelect={false}
                                                className="border-radius-0"
                                                isMulti={true}
                                                id="selectedEntity"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'})

                                                }}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                value={searchEntity}
                                                onChange={e => setSearchEntity(e)}
                                                options={entityList}
                                            />

                                        </div>}
                                        {["warehouse","user","admin"].includes(decodedRoleCase) && 
                            (tabName.value !== "inactive" )&&
                            (
                                <>
                                <div className="form-group col-xl-2 col-lg-2">
                                    <label style={{ fontSize: "13px", fontWeight: "700" }}>Transporter</label>
                                    <Select closeMenuOnSelect={false}
                                        className="border-radius-0"
                                        isMulti={true}
                                        id="selectedTransporter"
                                        styles={{
                                            option: (styles) => ({ ...styles, fontSize: "12px" }),
                                            singleValue: (styles) => ({ ...styles, fontSize: "12px" }),
                                            placeholder: (styles)=> ({...styles, fontSize:'12px'})
                                        }}
                                        style={{ borderRadius: "0px", fontSize: "12px" }}
                                        value={searchTransporters}
                                        onChange={(e) => setSearchTransporters(e)}
                                        options={filterTransporters}
                                    />
                                </div>
                                
                               
                             </>
                            )
}                                           
                                        {(decodedRoleCase === "user" || decodedRoleCase === "admin" || decodedRoleCase === "transporter") && 
                            (tabName.value !== "inactive" && tabName.value !== "transporter")&&
                                            <div className="col-xl-2 col-lg-2 form-group">
                                            <label style={{fontSize:"13px", fontWeight:"700"}}>Select Performance</label>
                                            <Select 
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchPerformance}
                                                placeholder="Select Performance"
                                                styles={{
                                                    option: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    singleValue: (styles) => ({ ...styles, fontSize: '12px' }),
                                                    placeholder: (styles)=> ({...styles, fontSize:'12px'}),
                                                    control: (styles) => ({ ...styles, width: '100%' })

                                                }}
                                                onChange={e => setSearchPerformance(e)}
                                                style={{ borderRadius: "0px", fontSize:"12px" }}
                                                options={[
                                                    {label:"All", value:"All"},
                                                    { label: "Ontime", value: "Ontime"},
                                                    { label: "Delay", value: "Delay"}
                                                ]}
                                                required />
                                        </div>}
                                        {tabName.value !=="inactive" && <>
                                        <div className="form-group col-xl-1 col-lg-1" style={{ textAlign: "left", maxWidth:"77px",marginTop:"30px"}}>
                                        <button type="button" className="btn btn-success" style={{borderRadius:"4px"}} onClick={onGetConsignments}>Submit</button>
                                    </div>
                                    <div className="form-group col-xl-1 col-lg-1" style={{ textAlign: "left",marginTop:"30px"}}>
                                        <button type="button" onClick={resetFilters1} style={{borderRadius:"4px"}} className="btn btn-default">Reset</button>
                                    </div>
                                    </>}
                                    </div>

                                 
                                   
                                </div>
                            </div>
                        </div>}
                        {/* } */}
                     {/* </div>  */}
                       
                    {/* } */}
                </div>
                { (tabName.value !== "inactive" && tabName.value !== "force_close" && tabName.value !== "transporter") &&
                    (<div className={""}>
                        <ConsolidatedCounters setCounter={CounterClick} selectedCounter={selectedCounter} setSelectedCounter={setSelectedCounter} data={tabName.value == "active" ? countersActive : (tabName.value == "completed" ? countersCompleted : (tabName.value == "all" ? countersAll : ""))} tabName={tabName}/>
                    </div>)
                }
                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-header" style={{borderBottom:"#ccc", borderBottom: "1px solid rgb(233 227 227)"}}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    {/* Left side content */}
                                    <h4 style={{ fontWeight: "600", fontSize: "18px" }}>
                                        {( tabName?.value === "inactive" || tabName?.value === "force_close" || tabName?.value === "transporter") ? "":<>
                                                                                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>
                                                                                <span>
                                                                                {`${tabName?.value === "completed" ? "Delivered" : tabName?.label}`} 
                                                                                {(tabName?.value === "inactive" || tabName?.value === "force_close" || tabName?.value === "transporter") ? "" : ` - ${counterActive}`}
                                                                                </span>
                                                                                </>
                                        }
                                    </h4>

                                    {/* Right side content */}
                                 
                                                                   
                        {/* <i className="icofont icofont-search filter-styling" style={{border:"1px solid #ccc", color:"#ccc",boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)" , background:"#fff"}} 
                        onClick={() =>loadConsignmentsData()}
                        ></i>
                                                                // </>} */}
                                    
                                    <div style={{ display: "flex", alignItems: "center" }}>

                                        {(tabName.value === "transporter" && selectedRows.length > 0) ? (
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px" }}
                                            title="Update LR"
                                            onClick={updateLrs}
                                            className="custom-btn white mr-2"
                                            type="button">
                                            Update LR
                                            </button>
                                        </div>
                                        // <div style={{ marginLeft: "10px" }}>
                                        //     <button
                                        //     style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "19px" }}
                                        //     title="Update LR"
                                        //     onClick={updateLrs}
                                        //     className="custom-btn white mr-2"
                                        //     type="button">
                                        //     <i className="icofont icofont-edit"></i>
                                        //     </button>
                                        // </div>
                                        ) : null} 
                                         {(tabName.value === "inactive" && selectedRows.length > 0) ? (
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px" }}
                                            title="Update Transporter"
                                            onClick={updateTransporter}
                                            className="custom-btn white mr-2"
                                            type="button">
                                            Update Transporter
                                            </button>
                                        </div>
                                        
                                        // <div style={{ marginLeft: "10px" }}>
                                        //     <button
                                        //     style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "19px" }}
                                        //     title="Update LR"
                                        //     onClick={updateLrs}
                                        //     className="custom-btn white mr-2"
                                        //     type="button">
                                        //     <i className="icofont icofont-edit"></i>
                                        //     </button>
                                        // </div>
                                        ) : null}
                                        {/* {(tabName.value === "inactive" && selectedRows.length > 0) ? ( */}
                                           
                                            <button type="button" className="btn-bulkupload mr-10p" onClick={resetFiltersGrid} title="Reset Filters" style={{ fontSize: "0.8rem" }}>
                                <img src={refreshIcon} alt="Refresh Icon" />
                            </button>
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px", cursor: "pointer", borderRadius:"4px" }}
                                            title="Excel Export"
                                            onClick={onExportClick}
                                            className="custom-btn white mr-2"
                                            type="button">
                                            Excel Export
                                            </button>
                                        </div>
                                        {/* // <div style={{ marginLeft: "10px" }}>
                                        //     <button */}
                                        {/* //     style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "19px" }}
                                        //     title="Update LR"
                                        //     onClick={updateLrs}
                                        //     className="custom-btn white mr-2"
                                        //     type="button">
                                        //     <i className="icofont icofont-edit"></i>
                                        //     </button>
                                        // </div>
                                        // ) : null} */}
                                        {(
                                            ["active", "all"].includes(tabName.value) &&
                                            !["user", "user-inbound", "user-outbound"].includes(decodedRoleCase) &&
                                            (
                                                tabName.value !== "all" ||
                                                (searchViewType?.value === "Invoice" && decodedRoleCase === "admin")
                                            )
                                        ) ? (
                                            <div style={{ marginLeft: "10px" }}>
                                                <button
                                                    style={{
                                                        marginRight: "20px",
                                                        backgroundColor: "#20c997",
                                                        fontSize: "12px",
                                                        padding: "8px",
                                                        borderRadius: "4px"
                                                    }}
                                                    title={
                                                        tabName.value === "all"
                                                            ? "Bulk Weight / Volume Update"
                                                            : "Update Multiple Status"
                                                    }
                                                    onClick={updateBulkPTLStatus}
                                                    className="btn btn-warning float-right action_btn"
                                                    type="button"
                                                >
                                                    <i className="fa fa-upload"></i>&nbsp;&nbsp;
                                                    {tabName.value === "all"
                                                        ? "Bulk Wt./Vol. Update"
                                                        : "Bulk Status Update"}
                                                </button>
                                            </div>
                                        ) : null}

                                         {(tabName.value === "completed" && !["user", "user-inbound", "user-outbound"].includes(decodedRoleCase)) ? (
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px", borderRadius:"4px" }}
                                            title="Update Delivery Date"
                                            onClick={updateBulkDeliveryDates}
                                            className={"btn btn-warning float-right action_btn"}
													type="button">
                                            <i className="fa fa-upload"></i>&nbsp;&nbsp;Bulk Late Delivery Remarks Update
                                            </button>
                                        </div>
                                         ) : null}
                                         {((tabName.value === "inactive") && ((decodedRoleCase==="admin") || (decodedRoleCase === "warehouse" && processFlowType==="outbound") || decodedRoleCase == "wh-outbound")) ? (
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px",borderRadius:"4px" }}
                                            title="Update Multiple Status"
                                            onClick={updateBulkTransporters}
                                            className={"btn btn-warning float-right action_btn"}
													type="button">
                                            <i className="fa fa-upload"></i>&nbsp;&nbsp;Bulk Upload Transporter
                                            </button>
                                        </div>
                                         ) : null}
                                           {((tabName.value === "transporter")  && ((decodedRoleCase==="admin") || (decodedRoleCase === "warehouse" && processFlowType==="outbound") || decodedRoleCase == "wh-outbound"))? (
                                        <div style={{ marginLeft: "10px" }}>
                                            <button
                                            style={{ marginRight: "20px", backgroundColor: "#20c997", fontSize: "12px", padding:"8px",borderRadius:"4px" }}
                                            title="Update Multiple Status"
                                            onClick={updateBulkLR}
                                            className={"btn btn-warning float-right action_btn"}
													type="button">
                                            <i className="fa fa-upload"></i>&nbsp;&nbsp;Bulk Upload LRs
                                            </button>
                                        </div>
                                         ) : null}
                                       <span className='layoutbtns float-right'>
                                      <div className="col-sm-12">
                                        <button
                                        type="button"
                                        title="Save Grid Layout"
                                        name="savegrid"
                                        className="btn btn-success float-right action_btn savegrid-border-radius"
                                        onClick={saveGrid}>
                                        <i className="fa fa-save"></i>
                                        </button>
                                        <button
                                        type="button"
                                        title="Reset Grid Layout"
                                        name="resetgrid"
                                        className="btn btn-info float-right action_btn resetgrid-border-radius"
                                        // style={{ marginLeft: "10px" }}
                                        onClick={resetGrid}>
                                        <i className="fa fa-reply"></i>
                                        </button>
                                        </div>
                                        </span> 
                                    </div>
                                    </div>
                            </div>
                          
                           <div className="row" style={{padding:"0 30px", paddingTop:"10px"}}>
                           {searchViewType.value ==="LR" && 
                           
                           
                                <div className="col-xl-12 col-lg-12">
                                <span className="float-right legendlist" style={{fontSize: "15px", fontWeight: 400,  fontSize:"13px"}}>
                                    {(tabName.value !== "inactive" && tabName.value !== "force_close" && tabName.value !== "transporter")  &&  <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="icofont icofont-map-pins" style={{fontSize: "12px", marginLeft:"0px"}}></i>&nbsp;&nbsp;View Route </button> }
                                    {/* <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-edit" style={{color:"#1cc88a",fontSize: "20px"}}></i>&nbsp;&nbsp;Dispatch Time Update </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-edit" style={{color:"#28bad4",fontSize: "20px"}}></i>&nbsp;&nbsp;Status Update </button> */}
                                    {(tabName.value !== "inactive" && tabName.value !== "force_close" && tabName.value !== "transporter") && <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="icofont icofont-site-map" style={{fontSize: "14px"}}></i>&nbsp;&nbsp;View Invoices </button> }
                                    {(tabName.value !=="inactive" && tabName.value !== "force_close" && tabName.value !== "transporter") && <button type='button' className='btn btn-default mybtn' style={{margin:"0px"}}><i className="icofont icofont-fast-delivery" style={{lineHeight:"25px", verticalAlign:"middle", fontSize:"18px"}}></i>&nbsp;&nbsp; Courier Consignments</button>}
                                    {/* {(tabName.value !=="inactive") && <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="fa fa-cubes" style={{ color: "#cccc"}}></i>&nbsp;&nbsp;KPIs Status </button> } */}
                                    {(tabName.value !=="inactive" && tabName.value !== "force_close" && tabName.value !== "transporter") && <button type="button" className="btn btn-default mybtn" style={{margin:"0px"}}>
                                    <i className="icofont icofont-clock-time" style={{color:"#ffc107", fontSize: "14px"}}></i>&nbsp;&nbsp;Transit Delays </button> }

                                    {/* <button type="button" className="btn btn-default mybtn"><i className="fa fa-th" style={{fontSize: "15px", color:"#FF5370"}}></i>&nbsp;&nbsp;KPI's Triggered</button> */}
                                  
                                    {((tabName.value !== "inactive" && tabName.value !== "force_close" && tabName.value !== "transporter") && 
                                        <button 
                                            type="button" 
                                            className="btn btn-default mybtn" 
                                            style={{ marginLeft: "-5px" }}
                                        >
                                            <i className="icofont icofont-social-google-map txt-danger" style={{ fontSize: "14px" }}></i>
                                            &nbsp;&nbsp;Tracking N/A 
                                        </button>
                                    )} 
                                    {(tabName.value === "active" || tabName.value === "all") ?  (
                                        <button 
                                            type="button" 
                                            className="btn btn-default mybtn" 
                                            style={{ marginLeft: "-5px" }}
                                        >
                                            <i className="icofont icofont-social-google-map " style={{ color:"#26c6da",fontSize: "14px" }}></i>
                                            &nbsp;&nbsp;Tracking not adequate 
                                        </button>
                                    ): null }  
                                       {(tabName.value !== "inactive" && tabName.value !== "force_close" && tabName.value !== "transporter" && !["user", "user-inbound", "user-outbound"].includes(decodedRoleCase)) && <button type="button" className="btn btn-default mybtn rm-br" style={{margin:"0px"}}>
                                       <i className="icofont icofont-pause maroon" style={{fontSize: "14px"}}></i>&nbsp;&nbsp;Stoppages </button> }
                                                                        {((tabName.value ==="active" || tabName.value === "all") && (decodedRoleCase!=="transporter")  &&(!warehouseDisableIcons))&& (<><img
                                        src={require("../../assets/images/Update.png")} 
                                        style={{marginLeft:"8px", height:"12px"}}
                                        alt="Update" // Add alt for accessibility
                                        title='Update'
                                    /> <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px",marginLeft:"2px", display:"inline-block", height:"20px"}}>Edit</span> </>)}
                                        {((tabName.value ==="active" || tabName.value === "all") && (decodedRoleCase==="admin")) && (<><img
                                        src={require("../../assets/images/edit_logs_black.png")} 
                                        style={{marginLeft:"0px", marginTop:"-2px",height:"16px"}}
                                        alt="Edit Logs" // Add alt for accessibility
                                        title='Edit Logs'
                                    /> <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px",marginLeft:"2px", display:"inline-block", height:"20px"}}>Edit Logs</span> </>)}


                                    {((tabName.value ==="active" || tabName.value === "all") && !["user", "user-inbound", "user-outbound"].includes(decodedRoleCase)) && (<><img
                                        src={require("../../assets/images/edit_location.png")} 
                                        style={{marginLeft:"5px", width:"14px"}}
                                        alt="Update Tracking Status " // Add alt for accessibility
                                        title='Update Tracking Status'
                                    /> <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Update Tracking Status</span> </>)}
                                                                        {((tabName.value ==="active" || tabName.value === "all") && !["user", "user-inbound", "user-outbound"].includes(decodedRoleCase)) && (<>
                                       
                                        <i className="icofont icofont-upload-alt f15" style={{ fontSize:"12px",color: "#3a3fa6",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Upload Documents'></i>
                                    <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Upload Documents</span> </>)}
                                    {(tabName.value ==="active" || tabName.value === "all") && (<>
                                       
                                       <i className="fa fa-eye f15" style={{ fontSize:"12px",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='View Documents'></i>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>View Documents</span> </>)}
                                   {((tabName.value ==="completed" || tabName.value === "all") && !["user", "user-inbound", "user-outbound"].includes(decodedRoleCase))&& (<>
                                       
                                       <i className="icofont icofont-upload f15" style={{ fontSize:"12px",color: "green",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Upload POD'></i>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Upload POD</span> </>)}
                                            {(tabName.value === "completed" || tabName.value === "all") && (<>

                                                <i className="fa fa-file f15" style={{ fontSize: "12px", marginLeft: "5px", marginRight: "5px", width: "14px" }} title='View POD'></i>
                                                <span style={{ fontSize: "12px", borderRight: "1px solid #ccc", paddingRight: "5px", display: "inline-block", height: "20px" }}>View POD</span> </>)}

                                            {((tabName.value === "active") && (!warehouseDisableIcons1 || decodedRoleCase === "transporter"|| decodedRoleCase === "warehouse")) && (
                                                <>
                                                    <i
                                                        className="icofont icofont-ban f15"
                                                        style={{ fontSize: "12px", marginLeft: "5px", marginRight: "5px", width: "14px" }}
                                                        title="Force Close"
                                                    ></i>
                                                    <span
                                                        style={{
                                                            fontSize: "12px",
                                                            borderRight: "1px solid #ccc",
                                                            paddingRight: "5px",
                                                            display: "inline-block",
                                                            height: "20px",
                                                        }}
                                                    >
                                                        Cancel LR
                                                    </span>
                                                </>
                                            )}

                                            {((tabName.value === "all") && (!warehouseDisableIcons1 || decodedRoleCase === "transporter")) && (
                                                <>
                                                    <i
                                                        className="icofont icofont-ban f15"
                                                        style={{ fontSize: "12px", marginLeft: "5px", marginRight: "5px", width: "14px" }}
                                                        title="Force Close"
                                                    ></i>
                                                    <span
                                                        style={{
                                                            fontSize: "12px",
                                                            borderRight: "1px solid #ccc",
                                                            paddingRight: "5px",
                                                            display: "inline-block",
                                                            height: "20px",
                                                        }}
                                                    >
                                                        Cancel LR
                                                    </span>
                                                </>
                                            )}



                                            {/* {(tabName.value ==="active" || tabName.value === "all") && (<>

                                       <img src={require("../../assets/images/share_icon.png")} style={{ fontSize:"12px",marginLeft:"5px", marginRight:"5px", width:"14px" }} title='Share Link'/>
                                   <span style={{fontSize:"12px", borderRight: "1px solid #ccc", paddingRight:"5px", display:"inline-block", height:"20px"}}>Share Link</span> </>)} */}


                                                                      {/* <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-social-google-map txt-secondary" style="font-size: 20px;"></i>&nbsp;GPS Data Not Adequate </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="fa fa-tachometer darkblue" style="font-size: 20px;"></i>&nbsp;&nbsp;Overspeeding </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-full-night txt-primary" style="font-size: 20px;"></i>&nbsp;&nbsp;Night Driving </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-truck-alt darkorange" style="font-size: 20px;"></i>&nbsp;&nbsp;Loading Delay </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-vehicle-delivery-van mildgreen" style="font-size: 20px;"></i>&nbsp;&nbsp;Unloading Delay </button> */}
                                 
                                    {/* <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-upload-alt " style={{fontSize: "20px", color:"#387ff2"}}></i>&nbsp;&nbsp;Upload Document </button>
                                    <button type="button" className="btn btn-default mybtn">
                                    <i className="icofont icofont-document-folder " style={{fontSize: "20px", color:"#00C292"}}></i>&nbsp;&nbsp;View Document </button> */}
                                </span>

                                </div>}
                                {/* <div className={"col-xl-12 mb-10p "}>
                                    <span className="layoutbtns">
                                        <button className="float-right custom-btn white btn-danger"
                                            // onClick={this.onClickSaveGridState}
                                            style={{fontSize:"12px"}}
                                            onClick={saveGrid}
                                        >
                                            <i className="icofont icofont-save"></i> Save Grid Layout
                                        </button>
                                        <button className="float-right custom-btn white btn-info" style={{ marginRight: "10px",fontSize:"12px" }}
                                            // onClick={this.resetState}
                                            onClick={resetGrid}
                                        >
                                            <i className="icofont icofont-refresh"></i> Reset Default Layout
                                        </button>
                                        
                                    </span>
                                </div> */}
                            </div>
                            
                          
                            <div className="card-body pt-10px" >
                                <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                    <AgGridReact
                                        onCellEditingStarted={handleEditable}
                                        ref={agGridRef}
                                        columnDefs={tabName.value === "inactive"?filterInActive: (tabName.value === "active"? filterActive: (tabName.value === "completed"? filterComplete:(tabName.value ==="force_close"? filterForceClose :  (tabName.value ==="transporter" ? filterTransporterDefs :filterAll ))))}
                                        rowData={rowData}                                        
                                        defaultColDef={defaultColDef}
                                        // onCellValueChanged={onCellValueChanged}
                                        pagination={true}
                                        paginationPageSize={50}
                                        onGridReady={onGridReadyConsignments}
                                        enableRangeSelection={true}
                                        enableCellContextMenu={true}
                                        masterDetail={true}
                                        detailCellRendererParams={detailCellRendererParams}
                                        // frameworkComponents ={{AddDealer:AddDealerConsignments}}
                                        sideBar={{
                                            toolPanels: [
                                                {
                                                    id: "columns",
                                                    labelDefault: "Columns",
                                                    labelKey: "columns",
                                                    iconKey: "columns",
                                                    toolPanel: "agColumnsToolPanel",
                                                    toolPanelParams: {
                                                        suppressPivotMode: true,
                                                        suppressRowGroups: true,
                                                        suppressValues: true,
                                                    }
                                                },
                                                {
                                                    id: "filters",
                                                    labelDefault: "Filters",
                                                    labelKey: "filters",
                                                    iconKey: "filter",
                                                    toolPanel: "agFiltersToolPanel"
                                                }
                                            ]
                                        }}
                                        statusBar={{
                                            statusPanels: [
                                                {
                                                    statusPanel: "agTotalAndFilteredRowCountComponent",
                                                    align: "left"
                                                },
                                                {
                                                    statusPanel: "agTotalRowCountComponent",
                                                    align: "center"
                                                },
                                                { statusPanel: "agFilteredRowCountComponent" },
                                                { statusPanel: "agSelectedRowCountComponent" },
                                                { statusPanel: "agAggregationComponent" }
                                            ]
                                        }}
                                        rowSelection="multiple"  // Enable multiple row selection
                                        onSelectionChanged={onSelectionChanged}
                                        suppressRowClickSelection={true}
                                    />
                                </div>
                        {/* Conditionally render timeline when data is available */}

                                     </div>
                                     {/* <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                    // onClick={onClickHideAll}
                ></div> */}
                {/* <div className={"dataLoadpage " + (gridLoadshow)}></div>
                <div className={"dataLoadpageimg " + (gridLoadshow)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div> */}
                        </div>

                    </div>
                </div>
                
                {openMap.sliderRouteTranslate != '' ?
                    <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                        <div className="slide-r-title">
                            <h4 className="slide-r-title">
                                {(openMap.lr_no)}
                                <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={closeMapModal} >X</span>
                            </h4>
                        </div>
                        <div className="slide-r-body" style={{ position: "relative" }}>
                            <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                              
                                <DrawMap
                                    rownode={openMap.rownode}
                                    mapFor={"consignment"}
                                    tolls={openMap.tolls}
                                    googleroutes={openMap.googelRoutes}
                                    truckno={openMap.maptruckno}
                                    dealer={openMap.dealer}
                                    mapinfo={openMap.mapinfo}
                                    deptcode={openMap.deptcode}
                                    defTransitCoords={openMap.defTransitCoords}
                                    baseRouteCoords={openMap.baseRouteCoords}
                                    geofence_coordinates={openMap.geofence_coordinates}
                                    parking_coordinates={openMap.parking_coordinates}
                                    showTrackingTimeline={showTrackingTimeline}
                                    expectedTripEndTimeStamp = {expectedTripEndTimeStamp}
                                    consignmentStatusForMap = {consignmentStatusForMap}
                                />
                                <div className="col-xl-12 col-lg-12 n-p-0">
                                    <div className="crm-numbers pb-0">
                                        <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                        <div className="col-xl-12 col-lg-12 row">
                                            <div className="col route-block">
                                                <label className="sidebar-label">Truck No</label>
                                                <div>{openMap.routeTruck.truck_no}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">Start Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">Last Tracked Timestamp</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                            </div>

                                            <div className="col route-block">
                                                <label className="sidebar-label">Travelled Distance</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                            </div>
                                            {/* {expectedDistance ? (
                                                <div className="col route-block">
                                                    <label className="sidebar-label">Distance Remaining</label>
                                                    <div>
                                                        {(!isEmpty(openMap.mapinfo.route_details))
                                                            ? Math.round(expectedDistance - (openMap.mapinfo.route_details.distance_without_google / 1000))
                                                            : "0"} Kms
                                                    </div>
                                                </div>
                                            ) : ""} */}
                                            {openMap.mapinfo.renaming_distance != null && (
                                                <div className="col route-block">
                                                    <label className="sidebar-label">Distance Remaining</label>
                                                    <div>
                                                        {Math.round(openMap.mapinfo.renaming_distance)} Kms
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <TimelineModal showModal={true} onClose={onCloseModal} truckCourier={false} timelineData={timelineData} expectedTripEndTimeStamp = {expectedTripEndTimeStamp} revisedTripEndTimeStamp = {revisedTripEndTimeStamp} actualDeliveryDate={actualDeliveryDate} deliveryDate={deliveryDate}/>

                        </div>

                    </div>
                    : ""
                }
                <div className={"ewewee slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                    <h3 className="subH">Bulk Upload Consignments
                        <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={closeBulkUploadModal} >X</span>
                    </h3>

                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft:"-30px" }}>
                            <form method="POST" id="upform" className="theme-form" style={{marginBottom:"20px"}}>
                                <div className='d-flex'>
                            <div className="col-xl-3 col-lg-3 form-group mt-30p">
								    <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format1.xlsx')} target="_blank"><i class="icofont icofont-download mr-10p"></i>Sample Template</a>
							    </div>
                            <div className="col-xl-9 col-lg-9 form-group">

                                    <label className="">Upload File</label>
                                    <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} style={{width:"500px"} }className="form-control"  value={file ? undefined : ""} required />
                                    
                                </div>
                                </div>
                                
                               {/* {transactionData !=="" &&   */}
                               {/* <div className="col-xl-3 col-lg-3 form-group">
								<button className="btn btn-warning" onClick={invalidFileData}>Invalid File Data</button>
							    </div> */}
                                {/* } */}
                            </form>
                            <div className="form-group1">
                                    <span style={{color:'red'}}>Note:</span>
                                    <div className='d-flex flex-col' style={{color:"#808080"}}>
                                        {/* Invoice No: It must begin with a numerical sequence, followed by  a forward slash (/), and then source identifier. <br/> */}
                                        {/* LR No: It must consist of numerical values only and can be left empty.<br/> */}
                                        Dates must be in the format of DD-MM-YYYY or DD/MM/YYYY.
                                    </div>
                                    {/* <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a> */}
                                </div>
                                </div>
                            <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop:"-50px"}}>
                                
                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div style={{marginTop:"-10px", marginRight:"-18px"}}><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div> */}
                                </div>
                            </div>
                            <div className="ag-theme-balham mt-2" style={{ height: '55vh', width: '100%', overflow:"auto" }}>
                                <AgGridReact
                                    columnDefs={columnDef}
                                    rowData={modalloadData}
                                    defaultColDef={defaultColDef}
                                    // onCellValueChanged={onCellValueChanged} 
                                    onGridReady={onGridReady}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    stopEditingWhenGridLosesFocus={true}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }} />
                            </div>
                            <br />
                            <div className="form-group">
                                <button type="submit" className="btn btn-success mr-20p border-radius1"  onClick={saveConsignments}>Submit</button>
                                &nbsp;
                                <button type="button" onClick={closeBulkUploadModal} className="btn btn-default border-radius1" style={{fontWeight:600}}>Cancel</button>
                            </div>
                            <br />
                            <br />
                        </div>
                    </div>
                    
                {/* <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                    onClick={onClickHideAll}
                ></div> */}
                <div className={"dataLoadpage " + (loadshowBulkupload)}></div>
                <div className={"dataLoadpageimg " + (loadshowBulkupload)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                </div>
                <div
                    className={"slide-r " + showAddForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Update Consignments<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload} >X</span></h4>
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                    <div className="col-sm-12">
                        <form onSubmit={onsubmitdata}>
                            <div className="slide-body">
                                <div className="row p-20p">
                                    <div className="form-group col-xl-12 col-lg-12"></div>{" "}
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Consignee Name<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consigner_name"
                                        id="consigner_name"
                                        value={manualUploadDetails1.consignee_name}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_name: e.target.value }))}
                                        required
                                    />                             
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination City<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_city"
                                        id="consignee_city"
                                        value={manualUploadDetails1.consignee_city}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_city: e.target.value }))}
                                        required
                                    /> 
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination State<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_state"
                                        id="consignee_state"
                                        value={manualUploadDetails1.consignee_state}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_state: e.target.value }))}
                                        required
                                    /> 
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination Pincode<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_pincode"
                                        id="consignee_pincode"
                                        value={manualUploadDetails1.consignee_pincode}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_pincode: e.target.value }))}
                                        required
                                    /> 
                                
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Total Weight<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="total_weight"
                                        id="total_weight"
                                        value={manualUploadDetails1.total_weight}
                                        className="form-control"
                                        // onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, total_weight: e.target.value }))}
                                        required
                                    />                             
                                </div>                            
                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success">
                                    Submit
                                    </button>
                                    
                                </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    </div>
                </div> 
                <div className={"slide-r " + showAddForm2} style={{ overflow: "auto",  }}>
                    <div className="slide-r-title">
                    <h4 className="slide-r-title">Update Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload2} >X</span></h4>          
                    </div> 
                    {/* { (Dselected_row.status === 1  || Dselected_row.consignment_status === "Dispatched from Source")? */}
                    {/* { (Dselected_row.status === 1 )? */}

                    {/* <>                          
                        <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form 
                            onSubmit={(e) => { */}
                                {/* e.preventDefault(); // Prevent default submit behavior
                                onClickGateOutUpdate(e); // Your custom submit logic
                            }}    
                            onKeyDown={(e) => {
                                if (e.key === "Enter") { */}
                                    {/* e.preventDefault(); // Prevent form submission on "Enter"
                                }
                            }} 
                            > */}
                            {/* <div className="slide-body">
                                <div className="row p-20p">                 
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Dispatch Time<span style={{color:'red'}}>*</span>
                                    </label>
                                <div id="datepicker1">
                                        <DatePicker
                                    selected={manualInTransitStatusUpdate.dispatch_time}
                                    onChange={changeHandleDate}
                                    name="dispatch_time"
                                    className="datepicker-custom-ptl3 form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm:ss"
                                    timeIntervals={15} 
                                    timeCaption="Time" */}
                                    {/* dateFormat="dd-MM-yyyy HH:mm:ss" 
                                    // placeholderText="Date" // Equivalent to placeholder in the original
                                //     id="dispatch_time"
                                //     autoComplete='off'
                                //     style={{width:"96%"}}
                                //     required
                                //     />
                                // </div>
                                
                                // </div> */}
                                
                                {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                                {/* <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success" style={{padding:"6px 20px", fontSize:"14px", marginRight:"10px"}}>
                                    Submit
                                    </button>
                                    <button type="button" onClick={onCloseUpdateDetails} className="btn btn-default" style={{}}>Cancel</button>
                                </div>
                                </div>
                            </div>
                            </form>
                        </div>
                        </div>
                    </>
                    : ""} */}
                    {((Dselected_row.status !== undefined && Dselected_row.status !== null) || (Dselected_row.consignment_status) || bulkPtlUpdate) ?

                    (<div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form 
                                onSubmit={(e) => {
                                    e.preventDefault(); // Prevent default submit behavior
                                    onClickDeliveredSubmit(e); // Your custom submit logic
                                }}    
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // Prevent form submission on "Enter"
                                    }
                                }}                        >
                            <div className="slide-body">
                                <div className="row p-20p">
                                {((Dselected_row.consignment_status || bulkPtlUpdate ||
                                    Dselected_row.status === 0 || Dselected_row.status === 10)) &&
                               <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            LR No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={selectedLRStoUpdateLr}
                                                isMulti={true}
                                                className="border-radius-0"
                                                // onChange={e => setInvoiceSelected(e)}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                // options={selectedLRStoUpdateLr}
                                                required 
                                            />
                           </div>
                                }
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Status<span style={{color:'red'}}>*</span>
                                    </label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={form2Details.selectedStatus} 
                                        onChange={handleStatusChange}
                                        style={{ borderRadius: "0px" }}
                                        styles={{
                                            control: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.8rem",
                                            color: "#6e707e",
                                            width:"100%"
                                            }),
                                            singleValue: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.9rem",
                                            }),
                                        }}
                                        options={form2Details.event_status} 
                                    />
                                      {/* {form2Details.errorMessage && (
                                    <div style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 0px" }}>
                                    {form2Details.errorMessage}
                                    </div>
                                )} */}
                                                            </div>
                              
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Current Location {!["Delivered", "Undelivered"].includes(form2Details.selectedStatus.value) && <span style={{color:'red'}}>*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        name="lr_no"
                                        id="lr_no"
                                        value={form2Details.event_location}
                                        className="form-control1"
                                        onChange={(e) => setForm2Details(prev => ({ ...prev, event_location: e.target.value }))}
                                        autoComplete='off'
                                        required={!["Delivered", "Undelivered"].includes(form2Details.selectedStatus.value)}
                                    />                  
                                </div>
                                {ableRemark && 
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Reason For Undelivered<span style={{color:'red'}}>*</span>
                                    </label>
                                
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={form2Details.remark} 
                                        onChange={(e)=> setForm2Details(prev=> ({...prev, remark: e}))}
                                        style={{ borderRadius: "0px" }}
                                        styles={{
                                            control: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.8rem",
                                            color: "#6e707e",
                                            width:"100%"
                                            }),
                                            singleValue: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.9rem",
                                            }),
                                        }}
                                        options={validReasonsOptions} 
                                    />
                                </div>
                                }

                                 {/* {((Dselected_row.status === 2 || Dselected_row.status === 3) && ((Dselected_row.invoice_list).length>1)) && 
                               <div className="form-group col-xl-12 col-lg-12">
                               <label className="mb-5p">
                               Pincode<span style={{color:'red'}}>*</span>
                               </label>
                               <Select
                                   closeMenuOnSelect={true}
                                   value={form2Details.selectedPincode} 
                                   onChange={(e) =>
                                       setForm2Details({ ...form2Details, selectedPincode: {label:e.value, value: e.value} })
                                   }
                                   style={{ borderRadius: "0px" }}
                                   styles={{
                                       control: (provided, state) => ({
                                       ...provided,
                                       fontSize: "0.8rem",
                                       color: "#6e707e",
                                       width:"100%"
                                       }),
                                       singleValue: (provided, state) => ({
                                       ...provided,
                                       fontSize: "0.9rem",
                                       }),
                                   }}
                                   options={pincodesList} 
                               />
                           </div>
                                } */}
                                            <div className="row ml-10p">
                                                <div className="form-group ml-5p">
                                                    <label className="mb-5p">
                                                        {`${form2Details.selectedStatus.label} Datetime`}<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div id="datepicker1">
                                                        <DatePicker
                                                            selected={form2Details.delivered_date}
                                                            onChange={changeHandleDate1}
                                                            name="delivered_date"
                                                            className="datepicker-custom-ptl5 form-control"
                                                            dateFormat="dd-MM-yyyy"
                                                            id="delivered_date"
                                                            autoComplete="off"
                                                            required
                                                            maxDate={maxDate1}
                                                            minDate={decodedRoleCase !=="admin" ? minDate1 : null}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group mt-5p">
                                                    <label className="mb-5p">
                                                    </label>
                                                    <div id="datepicker1">
                                                        <DatePicker
                                                            selected={form2Details.delivered_time}
                                                            onChange={changeHandleTime1}
                                                            name="delivered_time"
                                                            className="datepicker-custom-ptl5 form-control"
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeFormat="HH:mm:ss"
                                                            timeIntervals={15}
                                                            timeCaption="Time"
                                                            dateFormat="HH:mm:ss"
                                                            id="delivered_time"
                                                            autoComplete="off"
                                                            required
                                                            // minTime={decodedRoleCase === "admin" ? new Date().setHours(0, 0, 0, 0) : minTime1} 
                                                            // maxTime={maxTime1}
                                                            minTime={minTime1}
                                                            maxTime={maxTime1}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                {combinedDate > new Date(Dselected_row.expected_trip_end || Dselected_row.expected_eta) && (
                                    <div className="form-group col-xl-12 col-lg-12">
                                        <label className="mb-5p">
                                            Reason For Delay{(decode(localStorageRole)!=="admin") && <span style={{color:'red'}}>*</span>}
                                        </label>
                                        <Select
                                        closeMenuOnSelect={true}
                                        value={form2Details.reason_for_delay} 
                                        onChange={(e)=> setForm2Details(prev=> ({...prev, reason_for_delay: e}))}
                                        style={{ borderRadius: "0px" }}
                                        styles={{
                                            control: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.8rem",
                                            color: "#6e707e",
                                            width:"100%"
                                            }),
                                            singleValue: (provided, state) => ({
                                            ...provided,
                                            fontSize: "0.9rem",
                                            }),
                                        }}
                                        options={validReasonsOptions} 
                                    />
                                    </div>
                                )}
                                {(form2Details.selectedStatus.value === "Reached Destination" || form2Details.selectedStatus.value === "Delivered")  && 
                                 <div className="form-group col-sm-12 mb-20p text-left">
                                 <button type="button" className="btn btn-success" style={{ marginRight: "10px" }} onClick={uploadPODInTracking}>
                                     Upload POD
                                 </button></div>}
                                {uploadPODTracking && (form2Details.selectedStatus.value === "Reached Destination"  || form2Details.selectedStatus.value === "Delivered") && (<div className="row p-20p">
                                {Dselected_row.tracking_type === "FTL" && (
                                            <div className="form-group col-sm-11 mb-20p ml-15p">
                                                {/* <label>Select Invoice<span style={{ color: 'red' }}>*</span></label>
                                                
                                                <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select invoices..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={invoicesUploadList}
                                                    // required
                                                /> */}
                                                <label className="f16">LR No.
                                                    {/* <span style={{ color: 'red' }}>*</span> */}
                                                    </label>
                                                
                                                {/* <Select
                                                    isMulti // Enable multi-select
                                                    closeMenuOnSelect={false} // Keeps dropdown open for multiple selections
                                                    placeholder="Select LR No's..."
                                                    value={selectedInvoiceUpload} 
                                                    onChange={(selectedOptions) => setSelectedInvoiceUpload(selectedOptions || [])}
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.8rem",
                                                            color: "#6e707e",
                                                            width: "100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                            ...provided,
                                                            fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    // options={invoicesUploadList}
                                                    
                                                    // required
                                                /> */}
                                                     <input
                                                        type="text"
                                                        id="selectedLr"
                                                        className="border-radius-0"
                                                        readOnly // Makes the input non-editable

                                                        style={{
                                                            borderRadius: '5px',
                                                            fontSize: '13px',
                                                            padding: '8px',
                                                            width: '103%',
                                                            border: "2px solid lightgrey",
                                                        }}
                                                        value={Dselected_row.lr_no}
                                                        
                                                    />
                                            </div>
                                        )}
                                    <div className="form-group col-sm-11 mb-20p ml-15p">
                                        <label className="f16">Upload POD Document<span style={{color:'red'}}>*</span></label>
                                        
                                        <input type="file" name="epodDoc" id="epodDoc" style={{width:"103%"}} className="form-control" accept=".pdf, image/*" onChange={changeFileHandlerForPod} required />
                                    </div>
                                   


                                    <div className="ml-30p form-group" style={{width:"210px"}}>
                                        <label className="f16">
                                            Damage
                                        </label><br />
                                        <input type='number' value={damage}  onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setDamage(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group ml-30p" style={{width:"208px"}}>
                                        <label className="f16">
                                            Excess
                                        </label><br />
                                        <input type='number' value={excess} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setExcess(value);
                                            }
                                        }}
                                        className="form-control custom-input"  />
                                     </div>
                                     <div className="form-group ml-30p" style={{width:"210px"}}>
                                        <label className="f16">
                                            Pilferage
                                        </label><br />
                                        <input type='number' value={pilferage} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setPilferage(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group ml-30p" style={{width:"208px"}}>
                                        <label className="f16">
                                            Short
                                        </label><br />
                                        <input type='number' value={short} onChange={(e) => {
                                            // Allow only numbers 0 and above
                                            const value = e.target.value;
                                            if (value >= 0) {
                                                setShort(value);
                                            }
                                        }} 
                                        className="form-control custom-input" />
                                     </div>
                                    <div className="form-group col-sm-11 mb-20p ml-15p">
                                        <label className="f16">Remarks</label>
                                        <textarea name="podremarks" id="podremarks" rows="3" value={podremarks} onChange={changeHandler1} style={{width:"103%"}} className="form-control" ></textarea>
                                    </div> 
                                    
                                    
                                </div>)}
                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success" style={{padding:"6px 20px", fontSize:"14px", marginRight:"10px"}}>
                                    Submit
                                    </button>
                                    <button type="button" onClick={onCloseUpdateDetails} className="btn btn-default" style={{}}>Cancel</button>
                                </div>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>): ''}
                    
                    
                </div>

                {/* <div className={"slide-r " + showBulkUpdateForm} style={{ overflow: "auto",  }}>
                    <div className="slide-r-title">
                    <h4 className="slide-r-title">Bulk Update Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload4} >X</span></h4>          
                    </div> 
                    <div className="slide-r-body" style={{ position: "relative" }}>
						<div className="container-fluid">
							<form id="upform" className="theme-form" onSubmit={uploadFormHandler}>
								<div className="form-group mt-20p">
									<label className="">Upload File</label>
									<input type="file" name="uploadBulkFile" onChange={changeBulkStatusFileHandler} className="form-control" required />
								</div>
								<div className="form-group">
									<button type="submit" className="btn btn-success">Submit</button>
									<button type="button" onClick={onClickHideManualUpload4} className="btn btn-default">Cancel</button>
								</div>
							</form>
							{/* <div className="form-group">
								<p style={{ color: "#ff0000" }}>*Note: All fields related to ticket are mandatory</p>
								<p><b>Ticketing bulk update rules:</b></p>
								<p><b>Communication Type:</b> Email/Phone/Other</p>
								<p><b>Status: </b>Open/Closed/Invalid/On Hold/Closed - No response</p>
								<p><b>Satisfactory Response:</b> Yes/No</p>
							</div> */}
							{/* <div className="form-group">
								<a className="btn btn-primary" href={require('../../assets/files/Bulk_update_file.csv')} target="_blank">Sample Template</a>

							</div>

						</div>
					</div>
                    
                    
                </div> */} 
                <div className={"slide-r " + (showBulkUpdateForm)} style={{ overflow: "auto" }}>
                    <h3 className="subH">
                        {tabName.value === "all"
                            ? "Bulk Wt./Vol. Update Details"
                            : "Bulk Status Update Details"}
                        <span
                            className="float-right closebtn"
                            style={{ marginRight: "10px" }}
                            onClick={onClickHideManualUpload4}
                        >
                            X
                        </span>
                    </h3>

                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft: "-30px" }}>
                                <form method="POST" id="upform" className="theme-form" style={{ marginBottom: "20px" }}>
                                    <div className='d-flex'>
                                        <div className="col-xl-3 col-lg-3 form-group mt-30p">
                                            {/* <a className="btn btn-primary" href={require('../../assets/files/Bulk Update Status.xlsx')} target="_blank"><i class="icofont icofont-download mr-10p"></i>Sample Template</a> */}
                                            <a
                                                className="btn btn-primary"
                                                href={
                                                    tabName.value === "all"
                                                        ? require('../../assets/files/Bulk Update Invoice Weight CBM.xlsx')
                                                        : require('../../assets/files/Bulk Update Status.xlsx')
                                                }
                                                target="_blank"
                                            >
                                                <i className="icofont icofont-download mr-10p"></i>
                                                {tabName.value === "all"
                                                    ? "Sample Templete"
                                                    : "Sample Template"}
                                            </a>


                                        </div>
                                        <div className="col-xl-9 col-lg-9 form-group">
                                            <label className="">Upload File</label>
                                            <input type="file" name="uploadBulkFile" id="bulkUpdateCritical" onChange={changeBulkStatusFileHandler} style={{ width: "500px" }} className="form-control" value={file1 ? undefined : ""} required />
                                        </div>
                                    </div>
                                </form>
                                {tabName.value !== "all" && (
                                    <div className="form-group1">
                                        <span style={{ color: 'red' }}>Note:</span>
                                        <div className='d-flex flex-col' style={{ color: "#808080" }}>
                                            {/* Invoice No: It must begin with a numerical sequence, followed by  a forward slash (/), and then source identifier. <br/> 
                                         LR No: It must consist of numerical values only and can be left empty.<br/>  */}
                                            Dates must be in the format of DD-MM-YYYY HH:MM or DD/MM/YYYY HH:MM.
                                        </div>
                                        {/* <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>   */}
                                    </div>
                                )}
                            </div>
                            <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop: "-50px" }}>

                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div style={{ marginTop: "-15px", marginRight: "-18px" }}><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>  */}
                                </div>
                            </div>
                            <div className="ag-theme-balham mt-2" style={{ height: '55vh', width: '100%', overflow: "auto" }}>
                                <AgGridReact
                                    columnDefs={
                                        tabName.value === "all"
                                            ? columnBulkInvoiceWeightDef
                                            : columnBulkUpdateDef
                                    }
                                    rowData={modalBulkUpdateData}
                                    defaultColDef={defaultColDef}
                                    // onCellValueChanged={onCellValueChanged} 
                                    onGridReady={onGridReadyBulkUpdate}
                                    singleClickEdit={true}
                                    stopEditingWhenCellsLoseFocus={true}
                                    getRowStyle={(params) => {
                                        if (params.data?._hasError) {
                                            return {
                                                backgroundColor: "#ffe6e6",
                                                color: "#a70000"
                                            };
                                        }
                                        return null;
                                    }}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    stopEditingWhenGridLosesFocus={true}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }} />
                            </div>
                            <br />
                            <div className="form-group">
                                <button type="submit" className="btn btn-success border-radius1 mr-20p" onClick={uploadFormHandler}>Submit</button>
                                &nbsp;
                                <button type="button" onClick={onClickHideManualUpload4} className="btn btn-default border-radius1" style={{ fontWeight: 600 }}>Cancel</button>
                            </div>
                            <br />
                            <br />
                        </div>
                        <div className={"overlay-part " + (overlayBulkUpdate)} style={{ zIndex: "10" }}
                        ></div>
                        <div className={"dataLoadpage " + (loadshowBulkUpdate)}></div>
                        <div className={"dataLoadpageimg " + (loadshowBulkUpdate)} style={{ top: "21em" }}>
                            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                        </div>
                    </div>
                </div>   
                 <div className={"slide-r " + (showBulkTransporterForm)} style={{ overflow: "auto" }}>
                    <h3 className="subH">Bulk Upload Details
                        <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={onClickHideManualUpload5} >X</span>
                    </h3>

                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft:"-30px" }}>
                            <form method="POST" id="upform" className="theme-form" style={{marginBottom:"20px"}}>
                                <div className='d-flex'>
                            <div className="col-xl-3 col-lg-3 form-group mt-30p">
								    <a className="btn btn-primary" href={require('../../assets/files/Bulk Transporter.xlsx')} target="_blank"><i class="icofont icofont-download mr-10p"></i>Sample Template</a>
							    </div>
                                <div className="col-xl-9 col-lg-9 form-group">
                                    <label className="">Upload File</label>
                                    <input type="file" name="uploadBulkFile" id="bulkUpdateCritical" onChange={changeBulkTransporterFileHandler} style={{width:"500px"} }className="form-control"  value={file2 ? undefined : ""} required />
                                </div>
                                </div>
                            </form>
                            {/* <div className="form-group1">
                                     <span style={{color:'red'}}>Note:</span>
                                    <div className='d-flex flex-col' style={{color:"#808080"}}>
                                         {/* Invoice No: It must begin with a numerical sequence, followed by  a forward slash (/), and then source identifier. <br/> 
                                         LR No: It must consist of numerical values only and can be left empty.<br/>  */}
                                         {/* Dates must be in the format of DD-MM-YYYY HH:MM.
                                    </div>   */}
                                      {/* <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>   */} 
                                 {/* </div>  */}
                                </div> 
                             <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop:"-50px"}}>
                                
                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div style={{marginTop:"-15px", marginRight:"-18px"}}><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>  */}
                                 </div>
                            </div> 
                            <div className="ag-theme-balham mt-2" style={{ height: '55vh', width: '100%', overflow:"auto" }}>
                                <AgGridReact
                                    columnDefs={columnTransporterDef}
                                    rowData={modalBulkTransporterData}
                                    defaultColDef={defaultColDef}
                                    // onCellValueChanged={onCellValueChanged} 
                                    onGridReady={onGridReadyBulkTransporter}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    stopEditingWhenGridLosesFocus={true}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }} />
                            </div>
                            <br />
                            <div className="form-group"> 
                                <button type="submit" className="btn btn-success mr-20p border-radius1" onClick={uploadTransporters}>Submit</button> 
                                 <button type="button" onClick={onClickHideManualUpload5} className="btn btn-default border-radius1" style={{fontWeight:600}}>Cancel</button>
                            </div>
                            <br />
                            <br />
                        </div> 
                        <div className={"overlay-part " + (overlayBulkTpt)} style={{ zIndex: "10" }}
                ></div>
                <div className={"dataLoadpage " + (loadshowBulkTpt)}></div>
                <div className={"dataLoadpageimg " + (loadshowBulkTpt)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                                    </div>
                        
                    </div> 
                 </div>    
                 <div className={"slide-r " + (showBulkLRForm)} style={{ overflow: "auto" }}>
                    <h3 className="subH">Bulk Upload Details
                        <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={onClickHideManualUpload6} >X</span>
                    </h3>

                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft:"-30px" }}>
                            <form method="POST" id="upform" className="theme-form" style={{marginBottom:"20px"}}>
                                <div className='d-flex'>
                            <div className="col-xl-3 col-lg-3 form-group mt-30p">
								    <a className="btn btn-primary" href={require('../../assets/files/Bulk LR.xlsx')} target="_blank"><i class="icofont icofont-download mr-10p"></i>Sample Template</a>
							    </div>
                                <div className="col-xl-9 col-lg-9 form-group">
                                    <label className="">Upload File</label>
                                    <input type="file" name="uploadBulkFile" id="bulkUpdateCritical" onChange={changeBulkLRFileHandler} style={{width:"500px"} }className="form-control"  value={file3 ? undefined : ""} required />
                                    {/* <input type="file" name="uploadBulkFile" id="bulkUpdateCritical" onChange={changeBulkLRFileHandler} style={{width:"500px"} }className="form-control" required />
                                    <span style={{ marginLeft: "10px", color: "#555" }}>{fileName}</span> */}
                                </div>
                                </div>
                               
                            </form>
                             <div className="form-group1">
                                     <span style={{color:'red'}}>Note:</span>
                                    <div className='d-flex flex-col' style={{color:"#808080"}}> 
                                         {/* Invoice No: It must begin with a numerical sequence, followed by  a forward slash (/), and then source identifier. <br/> 
                                         LR No: It must consist of numerical values only and can be left empty.<br/>  */}
                                         Dates must be in the format of DD-MM-YYYY.
                                    </div>  
                                      {/* <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>   */} 
                                 </div> 
                                </div> 
                             <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop:"-50px"}}>
                                
                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div style={{marginTop:"-15px", marginRight:"-18px"}}><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>  */}
                                 </div>
                            </div> 
                            <div className="ag-theme-balham mt-2" style={{ height: '55vh', width: '100%', overflow:"auto" }}>
                                <AgGridReact
                                    columnDefs={columnLRDef}
                                    rowData={modalBulkLRData}
                                    defaultColDef={defaultColDef}
                                    // onCellValueChanged={onCellValueChanged} 
                                    onGridReady={onGridReadyBulkLR}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    stopEditingWhenGridLosesFocus={true}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }} />
                            </div>
                            <br />
                            <div className="form-group"> 
                                <button type="submit" className="btn btn-success border-radius1 mr-20p" onClick={uploadLRs}>Submit</button> 
                                &nbsp;
                                 <button type="button" onClick={onClickHideManualUpload6} className="btn btn-default border-radius1" style={{fontWeight:600}}>Cancel</button>
                            </div>
                            <br />
                            <br />
                        </div> 
                <div className={"overlay-part " + (overlayBulkUpload)} style={{ zIndex: "10" }}
                ></div>
                <div className={"dataLoadpage " + (loadshowBulkLr)}></div>
                <div className={"dataLoadpageimg " + (loadshowBulkLr)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                    </div> 
                 </div>    
 
                <div className={"slide-r " + showAddForm3} style={{ overflow: "auto",  }}>
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Update Trip Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload3} >X</span></h4>                    
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form onSubmit={onClickUpdateConsignment}>
                                <div className="slide-body">
                                    <div className="row p-20p">   
                                        {/* Lr no */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                LR No.
                                                {/* <span style={{color:'red'}}>*</span> */}
                                            </label>
                                            <input
                                                type="text"
                                                name="lr_no"
                                                id="lr_no"
                                                value={manualUpdateConsignment.lr_no}
                                                className="form-control"
                                                onChange={(e) => {
                                                    // Only update state if the input is a valid number
                                                    const value = e.target.value;
                                                    // if (/^\d*$/.test(value)) {  // This regex allows only numeric values
                                                        setManualUpdateConsignment(prev => ({ ...prev, lr_no: value }));
                                                    // }
                                                }}
                                                disabled={decodedRoleCase!=="admin"}

                                                required
                                            />                                     
                                        </div>
                                         {/* invoice no */}
                                         <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Invoice No
                                                {/* <span style={{color:'red'}}>*</span>   */}
                                                </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, invoice_no:e.target.value.toUpperCase() }))}
                                                value={manualUpdateConsignment.invoice_no}
                                                name="invoice_no"
                                                autoComplete='off'
                                                // pattern="\d+/[a-zA-Z]{3}"
                                                isDisabled={true}

                                                // onInvalid={(e) => {
                                                // e.target.setCustomValidity("Invalid invoice no format. Please enter 6 digits/ABC format.");
                                                // }}
                                                // onInput={(e) => {
                                                // e.target.setCustomValidity("");
                                                // }}
                                            />
                                            {/* {manualUpdateConsignment.invoice_no && !/^\d+\/[A-Z]{3}$/.test(manualUpdateConsignment.invoice_no) && (
                                                <div style={{ color: "red", fontSize: "12px", paddingLeft: "20px",paddingTop:"5px" }}>
                                                    Invalid invoice no format. Please enter digits followed by /ABC format (e.g., 300000/ACM).
                                                </div>
                                            )} */}

                                            </div>
                                        {/* driver mobile no */}
                                        {(selected_row.tracking_type ==="FTL") && 
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Driver Mobile No.<span style={{color:'red'}}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // onChange ={(e)=>  setManualUpdateConsignment((prev) => ({ ...prev, driver_mobile_no: e.target.value }))}
                                                onChange={(e) => {
                                                    const { name } = e.target;
                                                    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    
                                                    // Validate the input length and content
                                                    if (numericValue.length < 10) {
                                                        setError2('Mobile number must be 10 digits long');
                                                    } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
                                                        setError2('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
                                                    } else {
                                                        setError2(''); // Clear error if the number is valid
                                                    }

                                                    // Update the state with the new value (allow only 10 digits max)
                                                    if (numericValue.length <= 10) {
                                                       
                                                            setManualUpdateConsignment((prev) => ({ ...prev, driver_mobile_no: numericValue }));
                                                       
                                                    }
                                                }}                                               
                                                name="driver_mobile_no"
                                                autoComplete='off'
                                                value = {manualUpdateConsignment.driver_mobile_no}
                                            />
                                            {error2 && <span style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 20px" }}>{error2}</span>}                    
               
                                        </div>}
                                        {/* Source */}
                                        {
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">Source</label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.source}
                                                    style={{ borderRadius: '0px' }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: '0.8rem',
                                                        color: '#6e707e',
                                                        width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: '0.9rem',
                                                    }),
                                                    }}
                                                    // options={sourceOptions} 
                                                    isDisabled={true}
                                                    // onChange={(option) => {
                                                    // setManualUpdateConsignment((prev) => ({ ...prev, source: option }));
                                                    // }}
                                                />
                                            </div>
                                        }                                        
                                        {manualUpdateConsignment.other_source && (
                                            <>
                                                {/* Other Source Field */}
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">
                                                    Other Source
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                    const text = e.target.value;
                                                    if (/^[A-Za-z\s]*$/.test(text)) { // Allow only text and spaces
                                                        setManualUpdateConsignment((prev) => ({ ...prev, other_source: text }));
                                                    }
                                                    }}
                                                    value={manualUpdateConsignment.other_source}
                                                    name="other_source"
                                                    autoComplete="off"
                                                />
                                                {manualUpdateConsignment.other_source && !/^[A-Za-z\s]+$/.test(manualUpdateConsignment.other_source) && (
                                                    <div style={{ color: "red", fontSize: "12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid input. Only text is allowed.</div>
                                                )}
                                                </div>

                                                {/* Other Pincode Field */}
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">
                                                    Other Pincode
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={6}
                                                    onChange={(e) => {
                                                    const digits = e.target.value;
                                                    if (/^\d{0,6}$/.test(digits)) { // Allow only digits
                                                        setManualUpdateConsignment((prev) => ({ ...prev, other_pincode: digits }));
                                                    }
                                                    }}
                                                    value={manualUpdateConsignment.other_pincode}
                                                    name="other_pincode"
                                                    autoComplete="off"
                                                />
                                                {manualUpdateConsignment.other_pincode && !/^\d{0,6}$/.test(manualUpdateConsignment.other_pincode) && (
                                                    <div style={{ color: "red", fontSize: "12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid input. Only digits are allowed.</div>
                                                )}
                                                </div>
                                            </>
                                        )}
                                        {/* Truck No */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Truck No</label>
                                            <input
                                                type="text"
                                                className={`form-control`} // Add invalid styling if needed
                                                onChange={(e) => {
                                                    const value = e.target.value.toUpperCase().replace(/\s+/g,""); // Convert to uppercase for consistency
                                                    if (value.length <= 10) {
                                                        // Set the truck_no state
                                                        setManualUpdateConsignment((prev) => ({ ...prev, truck_no: value }));

                                                        // Validate the input
                                                        validateTruckNoFun(value);
                                                    }
                                                }}
                                                value={manualUpdateConsignment.truck_no}
                                                name="truck_no"
                                                autoComplete="off"
                                                maxLength={10} // Ensure max length of 10
                                                disabled={decode(localStorageRole)==="transporter"}

                                            />
                                            {/* Display validation error if invalid */}
                                            {manualUpdateConsignment.truck_no && !validateTruckNo && (
                                                <div style={{ color: "red", fontSize: "12px", paddingTop: "5px", paddingLeft: "20px" }}>
                                                    Invalid truck number format. Please enter 8 to 10 alphanumeric characters.
                                                </div>
                                            )}
                                        </div>

                                        {/* truck seal no */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Truck Seal No  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, truck_seal_no:e.target.value}))}
                                                value={manualUpdateConsignment.truck_seal_no}
                                                name="truck_seal_no"
                                                autoComplete='off'
                                                disabled={decode(localStorageRole)==="transporter"}

                                            />
                                        </div>
                                        {/* Entity */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Entity</label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateConsignment.entity}
                                                // onChange={(e)=> setManualUpdateConsignment((prev)=>({
                                                //     ...prev, 
                                                //     entity:{label:e.label, value: e.value}
                                                // }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                isDisabled={true}
                                                options={entityList}
                                            />
                                        </div>
                                        {/* Vehicle Type */}
                                        {
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                    Vehicle Type
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.vehicle_type}
                                                    onChange={(e) =>{
                                                    setManualUpdateConsignment((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value },
                                                    }))
                                                    if (e.value === "Others") {
                                                        setEnableVehicelType1(true);
                                                        setManualUpdateConsignment((prev) => ({ ...prev, other_vehicle_type: "" , other_vehicle_capacity:''}));

                                                    } else {
                                                        setEnableVehicelType1(false);
                                                        fetchVehicleDetails1(e.label, e.value)
                                                        
                                                    }
                                                }
                                                    }
                                                    style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={
                                                        (orginalDetailsForEdit.tracking_type) === "FTL"
                                                            ? vehicleFtlTypeList
                                                            : vehiclePtlTypeList
                                                    }
                                                    isDisabled={decode(localStorageRole)==="transporter"}

                                                />
                                            </div>  
                                        }
                                        {/* {!manualUpdateConsignment.other_vehicle_type && 
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                    Vehicle Type<span style={{color:'red'}}>*</span>
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.vehicle_type}
                                                    onChange={(e) =>
                                                    setManualUpdateConsignment((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value },
                                                    }))
                                                    }
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={vehicleTypeList}
                                                />
                                            </div>  
                                        }                                       */}
                                        {manualUpdateConsignment.vehicle_type && manualUpdateConsignment.vehicle_type.value === "Others" && (
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">
                                                    Other Vehicle Type
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={6}
                                                    onChange={(e) => { setManualUpdateConsignment((prev) => ({ ...prev, other_vehicle_type: e.target.value }))}}
                                                    value={manualUpdateConsignment.other_vehicle_type}
                                                    name="other_vehicle_type"
                                                    autoComplete="off"
                                                />
                                                {/* {manualUpdateConsignment.other_vehicle_type && (
                                                    <div style={{ color: "red", fontSize: "12px", paddingTop:"5px", paddingLeft:"20px" }}>Please Enter the Vehicle Type</div>
                                                )} */}
                                                </div>
                                        )}
                                        {/* Transporter - Courier Partner */}
                                        {manualUpdateConsignment.other_transporter &&
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                Transporter
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={{value:"Other", label:"Other"}}
                                                    onChange={(e)=>
                                                        setManualUpdateConsignment((prev)=>({
                                                            ...prev, 
                                                            courier_partner:{label:e.label, value: e.value}
                                                        }))
                                                    }
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={courierPartnerList}

                                                />
                                            </div>
                                        }
                                        {!manualUpdateConsignment.other_transporter &&
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p">
                                                Transporter
                                                </label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateConsignment.courier_partner}
                                                    onChange={(e)=>
                                                        setManualUpdateConsignment((prev)=>({
                                                            ...prev, 
                                                            courier_partner:{label:e.label, value: e.value}
                                                        }))
                                                    }
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                        control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                        }),
                                                        singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                        }),
                                                    }}
                                                    options={courierPartnerList}
                                                    isDisabled={true}

                                                />
                                            </div>
                                        }
                                        {manualUpdateConsignment.courier_partner && manualUpdateConsignment.courier_partner.value === "Others"  && <div className="col-xl-12 col-lg-12 row form-group">
                                            <label className="col-xl-12 col-lg-12">Other Transporter </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, other_transporter:e.target.value}))}
                                                value={manualUpdateConsignment.other_transporter}
                                                name="truck_no"
                                                autoComplete='off'
                                            />
                                        </div>}  
                                        {/* vehicle - capacity */}
                                    
                                      {  !enableVehicleType1 &&    <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p"> Vehicle Capacity</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    // onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={manualUpdateConsignment.vehicle_capacity}
                                                    name="vehicle_capacity"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={true}
                                                />
                                                {/* <Select
                                                    closeMenuOnSelect={true}
                                                    value={ manualUpdateConsignment.vehicle_capacity}
                                                    onChange={(e) => {
                                                    setManualUpdateConsignment((prev) => ({ ...prev, vehicle_capacity: { label: e.label, value: e.value } }));
                                                    }}
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={vehicleCapacityList}
                                                /> */}
                                            </div>}
                                        
                                        {/* {manualUpdateConsignment.other_vehicle_capacity && 
                                            <div className="form-group col-xl-12 col-lg-12">
                                                <label className="mb-5p"> Vehicle Capacity<span style={{color:'red'}}>*</span></label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={ {value: "Other", label: "Other" }}
                                                    onChange={(e) => {
                                                    setManualUpdateConsignment((prev) => ({ ...prev, vehicle_capacity: { label: e.label, value: e.value } }));
                                                    }}
                                                    className='custom-field-width'
                                                    style={{ borderRadius: "0px" }}
                                                    styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                    }}
                                                    options={vehicleCapacityList}
                                                />
                                            </div>
                                        }                                         */}
                                        {enableVehicleType1 && (
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Other Vehicle Capacity  </label>
                                                <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => setManualUpdateConsignment((prev) => ({ ...prev, other_vehicle_capacity: e.target.value }))}
                                                value={manualUpdateConsignment.other_vehicle_capacity}
                                                name="truck_no"
                                                autoComplete='off'
                                                
                                                />
                                            </div>
                                        )}
                                        {/* E-Way Bill */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">E-Way Bill Expiry Date</label>
                                            <div id="datepicker1">
                                                <DatePicker
                                                    selected={manualUpdateConsignment.eway_bill_expiry_date}
                                                    onChange={handleEwayDate}
                                                    name="eway_bill_expiry_date"
                                                    className="datepicker-custom-ptl1 form-control3"
                                                    showTimeSelect
                                                    timeFormat="HH:mm:ss"
                                                    timeIntervals={15} 
                                                    timeCaption="Time"
                                                    dateFormat="dd-MM-yyyy HH:mm:ss" 
                                                    minDate={new Date()} 
                                                    id="eway_bill_expiry_date"
                                                    autoComplete="off"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    disabled={decode(localStorageRole)==="transporter"}

                                                />
                                            </div>
                                        </div>
                                        {/* Consignee Name */}
                                        
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Consignee Name</label>
                                                <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateConsignment.consignee_name}
                                                onChange={(e) => {
                                                    setManualUpdateConsignment((prev) => ({ ...prev, consignee_name: { label: e.label, value: e.value } }));
                                                    fetchConsignerDetails(e.value, e.label, true)
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    })
                                                }}
                                                options={consignees}
                                                isDisabled={decode(localStorageRole)==="transporter"}

                                                />
                                            </div>
                                        
                                        {/* {!manualUpdateConsignment.other_consignee_name && (
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                            closeMenuOnSelect={true}
                                            value={manualUpdateConsignment.consignee_name}
                                            onChange={(e) => {
                                                setManualUpdateConsignment((prev) => ({ ...prev, consignee_name: { label: e.label, value: e.value } }));
                                            }}
                                            className='custom-field-width'
                                            style={{ borderRadius: "0px" }}
                                            styles={{
                                                control: (provided, state) => ({
                                                ...provided,
                                                fontSize: "0.8rem",
                                                color: "#6e707e",
                                                }),
                                                singleValue: (provided, state) => ({
                                                ...provided,
                                                fontSize: "0.9rem",
                                                })
                                            }}
                                            options={consignees}
                                            />
                                        </div>
                                        )} */}
                                        {manualUpdateConsignment.consignee_name && manualUpdateConsignment.consignee_name.value === "Others" && 
                                            (
                                                <>
                                                    <div className="col-xl-12 col-lg-12 form-group">
                                                        <label className="mb-5p">Other Consignee Name </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, other_consignee_name:e.target.value}))}
                                                            value={manualUpdateConsignment.other_consignee_name}
                                                            name="truck_no"
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                    <div className="col-xl-12 col-lg-12 form-group">
                                                        <label className="mb-5p">Other Destination City  </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e)=> setManualUpdateConsignment(prev =>({...prev, other_destination_city:e.target.value}))}
                                                            value={manualUpdateConsignment.other_destination_city}
                                                            name="truck_no"
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                    <div className="col-xl-12 col-lg-12 form-group">
                                                        <label className="mb-5p">Other Destination Pincode </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                            const pincode = e.target.value;
                                                            const isValid = validatePincode(pincode);
                                                            setManualUpdateConsignment((prev) => ({ ...prev, other_destination_pincode: pincode, isPincodeValid: isValid }));
                                                            }}
                                                            value={manualUpdateConsignment.other_destination_pincode}
                                                            name="truck_no"
                                                            autoComplete='off'
                                                        />
                                                        {manualUpdateConsignment.other_destination_pincode && !manualUpdateConsignment.isPincodeValid && (
                                                            <div style={{ color: 'red', fontSize:"12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid pincode</div>
                                                        )}
                                                    </div>
                                                </>
                                            )
                                        }
                                        {manualUpdateConsignment.consignee_name && manualUpdateConsignment.consignee_name.value!=="Others" && 
                                            <>                                             
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Destination City </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, destination_city:e.target.value }))}
                                                        value={manualUpdateConsignment.destination_city}
                                                        name="destination_city"
                                                        autoComplete='off'
                                                        disabled={decode(localStorageRole)==="transporter"}

                                                    />
                                                </div>                                     
                                                <div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Destination Pincode  </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                        const pincode = e.target.value;
                                                        const isValid = validatePincode(pincode);
                                                        setManualUpdateConsignment((prev) => ({ ...prev, destination_pincode: pincode, isPincodeValid: isValid }));
                                                        }}
                                                        value={manualUpdateConsignment.destination_pincode}
                                                        name="destination_pincode"
                                                        autoComplete='off'
                                                        disabled={decode(localStorageRole)==="transporter"}

                                                    />
                                                    {manualUpdateConsignment.destination_pincode && !validatePincode(manualUpdateConsignment.destination_pincode)  && (
                                                        <div style={{ color: 'red', fontSize:"12px", paddingTop:"5px", paddingLeft:"20px" }}>Invalid pincode</div>
                                                    )}
                                                </div>
                                            </>
                                        }
                                        {/* Movement Type */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Movement Type</label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateConsignment.movement_type}
                                                onChange={(e)=> setManualUpdateConsignment((prev)=>({
                                                    ...prev, 
                                                    movement_type:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={movementType}
                                                isDisabled={decode(localStorageRole)==="transporter"}

                                            />                                            
                                        </div>
                                        
                                        {/* No Of Boxes */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Number of Boxes  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, no_of_boxes:e.target.value }))}
                                                value={manualUpdateConsignment.no_of_boxes}
                                                name="number_of_boxes"
                                                autoComplete='off'
                                                disabled={decode(localStorageRole)==="transporter"}

                                            />
                                        </div>
{/*                                         
                                        <div style={{padding:"5px"}}>
                                            {//console.log(manualTripUploadDetails, "manualTripUploadDetails1111")}
                                        {manualTripUploadDetails.map((point, index) => {
                                            
                                            const isOtherConsignee = (!point.destination_pincode || !point.destination_city) && (!point.consignee_name || point.consignee_name.value === 'Other');
                                            //console.log(consignees, "11111");
                                            //console.log(consigneesForTrip, "22222"); */}
                                            
                                            {/* // const filteredConsigneeOptions = consignees.filter(
                                            //     (consignee) =>
                                            //         !consigneesForTrip.some(
                                            //             (detail) =>
                                            //                 detail.consignee_name === consignee.label || 
                                            //                 detail.destination_pincode === point.destination_pincode || 
                                            //                 detail.destination_city === point.destination_city
                                            //                 // detail.other_destination_pincode === point.other_consignee_pincode || 
                                            //                 // detail.other_destination_city === point.other_consignee_city
                                            //         )
                                            // );
                                            // const filteredConsigneeOptions = consignees.filter(
                                            //     (consignee) =>
                                                  !consigneesForTrip.some((detail) => { */}


{/* 
                                            //             const consigneePincode = Array.isArray(detail.destination_pincode)
                                            //                 ? detail.destination_pincode[0]
                                            //                 : detail.destination_pincode;
                                            //             return (
                                            //                 detail.consignee_name === consignee.label || 
                                            //                 consigneePincode === consignee.value || 
                                            //                 detail.destination_city === consignee.label
                                            //             );
                                            //         })
                                            // );
                                            // //console.log(filteredConsigneeOptions, "filteredConsigneeOptions");
                                            
                                            // return (
                                                // <div key={point._id} style={{ padding: '20px', border: '1px solid #ccc', marginBottom: '20px' }}> */}
                                                    {/* <div className="slide-body"> */}
                                                        {/* <div className="row p-20p"> */}
                                                            {/* <div className="col-xl-12 col-lg-12 d-flex justify-content-between align-items-center">
                                                            <h3>Drop Point {index + 1}</h3> */}
                                                            {/* <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => handleRemoveDropPoint(point.consignment_uid)}
                                                        >
                                                            Delete
                                                        </button> */}
                                                        {/* </div> */}
                                                            {/* LR No */}
                                                            {/* <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">LR No.</label>
                                                                <input
                                                                    type="text"
                                                                    name="lr_no"
                                                                    value={manualUpdateConsignment.lr_no}
                                                                    className="form-control"
                                                                    onChange={(e) => handleInputChange(point._id, 'lr_no', e.target.value)}
                                                                    required
                                                                />
                                                            </div> */}

                                                            {/* Invoice No */}
                                                            {/* <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">Invoice No</label>
                                                                <input */}
                                                                    {/* // type="text"
                                                                    // name="invoice_no"
                                                                    // value={point.invoice_no}
                                                                    // className="form-control"
                                                                    // onChange={(e) => { */}
                                                                    {/* //     const value = e.target.value;
                                                                    //     const invoicePattern = /^\d+\/[a-zA-Z]{3}$/;
                                                                    //     if (!invoicePattern.test(value)) { */}
                                                                    {/* //         e.target.setCustomValidity('Invoice number must be in digits/ABC format (e.g., 123456/XYZ)');
                                                                    //     } else { */}
                                                                    {/* //         e.target.setCustomValidity('');
                                                                    //     }
                                                                    //     handleInputChange(index, 'invoice_no', value);
                                                                    // }}
                                                                    // required
                                                                    // type="text"
                                                                    // className="form-control"
                                                                    // onChange={(e)=> setManualUpdateConsignment(prev => ({...prev, invoice_no:e.target.value.toUpperCase() }))}
                                                                    // value={point.invoice_no}
                                                                    // name="invoice_no"
                                                                    // autoComplete='off'
                                                                    // pattern="\d+/[a-zA-Z]{3}"
                                                            //         isDisabled={true} */}
                                                            {/* //     />
                                                            // </div> */}
                                                            {/* Other Consignee Name* */}
                                                            {/* Consignee Name */}
                                                            {/* <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">Consignee Name</label>
                                                                <Select
                                                                    closeMenuOnSelect={true}
                                                                    value={point.consignee_name ? { label: point.consignee_name, value: point.consignee_name } : null}                                                                    
                                                                    onChange={(e) => {handleInputChange(index, 'consignee_name', e.label)
                                                                        if (e.label !=="Others"){
                                                                            fetchConsigneeDetails1(index, e.value, e.label);
                                                                        }
                                                                }}
                                                                    options={[...filteredConsigneeOptions]}
                                                                    className="custom-field-width1"
                                                                />
                                                                
                                                            </div> */}

                                                            {/* Destination Pincode */}
                                                            {/* {!showOthersConsignee[index] && (
                                                                <div className="form-group col-xl-12 col-lg-12">
                                                                    <label className="mb-5p">Destination Pincode</label>
                                                                    <input
                                                                        type="text"
                                                                        name="destination_pincode"
                                                                        value={point.destination_pincode}
                                                                        className="form-control"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            const pincodePattern = /^\d{6}$/;

                                                                            if (!pincodePattern.test(value)) {
                                                                                e.target.setCustomValidity('Pincode must be exactly 6 digits.');
                                                                            } else {
                                                                                e.target.setCustomValidity('');  // Clear error
                                                                            }

                                                                            handleInputChange(index, 'destination_pincode', value);
                                                                        }}
                                                                        required
                                                                    />
                                                                </div>
                                                            )} */}

                                                            {/* Destination City */}
                                                            {/* {!showOthersConsignee[index] && (
                                                                <div className="form-group col-xl-12 col-lg-12">
                                                                    <label className="mb-5p">Destination City</label>
                                                                    <input
                                                                        type="text"
                                                                        name="destination_city"
                                                                        value={point.destination_city}
                                                                        className="form-control"
                                                                        onChange={(e) => handleInputChange(index, 'destination_city', e.target.value)}
                                                                        required
                                                                    />
                                                                </div>
                                                            )} */}

                                                            {/* Other Consignee Name */}
                                                            {/* {//console.log(showOthersConsignee[index], "showoooooo")} */}
                                                            
                                                            {/* {showOthersConsignee[index] && ( */}
                                                                {/* // <> */}
                                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                                        <label className="mb-5p">Other Consignee Name</label>
                                                                        <input
                                                                            type="text"
                                                                            name="other_consignee_name"
                                                                            value={point.other_consignee_name}
                                                                            className="form-control"
                                                                            onChange={(e) => handleInputChange(index, 'other_consignee_name', e.target.value)}
                                                                            autoComplete='off'
                                                                            // required
                                                                        />
                                                                    </div> */}

                                                                    {/* Other Destination Pincode */}
                                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                                        <label className="mb-5p">Other Destination Pincode</label>
                                                                        <input
                                                                            type="text"
                                                                            name="other_consignee_pincode"
                                                                            value={point.other_consignee_pincode}
                                                                            className="form-control"
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                const pincodePattern = /^\d{6}$/;

                                                                                if (!pincodePattern.test(value)) {
                                                                                    e.target.setCustomValidity('Pincode must be exactly 6 digits.');
                                                                                } else {
                                                                                    e.target.setCustomValidity('');  // Clear error
                                                                                }

                                                                                handleInputChange(index, 'other_consignee_pincode', value);
                                                                            }}
                                                                            autoComplete='off'

                                                                            required
                                                                        />
                                                                    </div> */}

                                                                    {/* Other Destination City */}
                                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                                        <label className="mb-5p">Other Destination City</label>
                                                                        <input
                                                                            type="text"
                                                                            name="other_consignee_city"
                                                                            value={point.other_consignee_city}
                                                                            className="form-control"
                                                                            onChange={(e) => handleInputChange(index, 'other_consignee_city', e.target.value)}
                                                                            autoComplete='off' */}

                                                                            {/* required */}
                                                                        {/* />
                                                                    </div> */}
                                                                {/* </> */}
                                                            {/* )} */}
                                                        {/* </div> 
                                                    </div>
                                                </div>
                                            );
                                         })} */}


                                        {/* </div> */}
                                        {/* //Edit */}
                                        <div className="form-group col-sm-12 mb-20p text-center">
                                            {/* <button
                                                type="button"
                                                className="btn btn-primary customAddBtn" // You can customize the button style
                                                onClick={handleButtonClick}
                                                style={{ padding: '9px 10px', fontSize: '12px', cursor: 'pointer', borderRadius:"none",marginRight:"20px" }} // Adjust the button style if needed
                                            >
                                                Add Drop Point
                                            </button> */}
                                            <button type="submit" className="btn btn-success">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> 
                
                <div className={"slide-r " + (sliderCreateConsignmentTranslate)} style={{ overflowX: "hidden", overflowY: "auto", maxHeight:"100vh" }}>
					<div className="slide-r-title">
						<h4 className="slide-r-title"> Add Consignment <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={onClickHideAll} >X</span></h4>
					</div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12"></div>
							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={saveConsignmentData}>
                                <div className="slide-body">
                                    <div className='row'>                                        
                                        {/* lr no */}
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">LR No
                                                <span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    // Only update state if the input is a valid number
                                                    const value = e.target.value;
                                                    // if ((/^[a-zA-Z0-9]*$/.test(value))) {  // This regex allows only numeric values /* PMS ID - 10259 */
                                                    if (/^[^\s]*$/.test(value)) {
                                                        setFormData(prev => ({ ...prev, lr_no: value }));
                                                    }
                                                }}
                                               
                                                value={formData.lr_no}
                                                name="lr_no"
                                                autoComplete="off"
                                                required
                                                // placeholder="Enter LR No"
                                            />
                                        </div>
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Transporter<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.courier_partner}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        courier_partner: { label: e.label, value: e.value }
                                                    }));

                                                    // Enable Other Transporter field when "Other" is selected
                                                    if (e.value === "Others") {
                                                        setEnableCourierType(true);
                                                    } else {
                                                        setFormData((prev) => ({ ...prev, other_transporter: "" }));
                                                        setEnableCourierType(false);
                                                    }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList}
                                            />
                                        </div>
                                        {enableCourierType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Transporter<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, other_transporter:e.target.value}))}
                                                value={formData.other_transporter}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}
                                          {/* driver mobile no */}
                                          <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Driver Mobile No.<span style={{color:'red'}}>*</span> </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const { name } = e.target;
                                                    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    
                                                    // Validate the input length and content
                                                    if (numericValue.length < 10) {
                                                        setError1('Mobile number must be 10 digits long');
                                                    } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
                                                        setError1('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
                                                    } else {
                                                        setError1(''); // Clear error if the number is valid
                                                    }

                                                    // Update the state with the new value (allow only 10 digits max)
                                                    if (numericValue.length <= 10) {
                                                        if (name === 'driver_number_update') {
                                                            setManualUpdateConsignment((prev) => ({ ...prev, driver_number: numericValue }));
                                                        } else if (name === 'driver_mobile_no') {
                                                            setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
                                                        }
                                                    }
                                                }}
                                                value={formData.driver_mobile_no}
                                                name="driver_mobile_no"
                                                autoComplete='off'
                                                required
                                            />
                                            {error1 && <span style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 0px" }}>{error1}</span>}                    
                                        </div>
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Dispatch Date<span style={{color:'red'}}>*</span>
                                            </label>
                                        <div id="datepicker1">
                                                <DatePicker
                                            selected={formData.dispatch_time}
                                            onChange={(date) => handleDispatchDate(date)} 
                                            name="dispatch_time"
                                            className="datepicker-custom-ptl4 form-control"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15} // Adjust this if you want different time intervals
                                            timeCaption="Time"
                                            dateFormat="dd-MM-yyyy HH:mm" // Adjusted format to match the original format
                                            // placeholderText="Date" // Equivalent to placeholder in the original
                                            id="dispatch_time"
                                            autoComplete='off'
                                            // style={{width:"100%"}}
                                            />
                                        </div>
                                        
                                        </div>
                                           {/* Movement Type */}
                                           <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Movement Type<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.movement_type}
                                                onChange={(e) => {
                                                    // Update formData and enableEdit state together
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        movement_type: { label: e.label, value: e.value },
                                                    }));
                                                    setFormData((prev) => ({
                                                        ...prev, 
                                                        consignee_name: {label: "", value: ""}
                                                    }));
                                            
                                                    // Update enableEdit state based on the selected value
                                                    if (e.value === "Customer Delivery") {
                                                        setEnableEdit(true);
                                                    } else {
                                                        setEnableEdit(false);
                                                    }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={movementType}
                                            />                                        
                                        </div>
                                           {/* source name */}
                                           <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">Source<span style={{color:'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.source}
                                                isDisabled={sourceValidation}
                                                onChange={(e) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            source: { label: e.label, value: e.value }
                                                        }));
                                                        if (e.value === "Others") {
                                                            setEnableSourceField(true);
                                                        } else {
                                                            setFormData((prev) => ({ ...prev, other_source: "" }));
                                                            setEnableSourceField(false);
                                                        }
                                                    // else {
                                                    //     setErrorMssge("Please fill in the invoice_no field first");
                                                    // }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={sourceList}
                                            />
                                             {sourceValidation && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>
                                             Please enter valid Invoice Numbers. The source will be auto-filled accordingly.                                            </span>}
                                        </div>
                                        {enableSourceField && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Other Source<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleAddConsignmentInputChange}
                                                value={formData.other_source}
                                                name="other_source"
                                                autoComplete="off"
                                                required
                                            />
                                            {validOtherSource === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"16px"}}>
                                                    Enter Valid Source Name
                                                </span>
                                            )}
                                        </div>}
                                        {enableSourceField && (
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Others Source Pincode<span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleAddConsignmentInputChange}
                                                value={formData.other_source_pincode}
                                                name="other_source_pincode"
                                                autoComplete="off"
                                                required
                                            />
                                            {/* Optionally display error message */}
                                            {/* {!/^[0-9]{6}$/.test(formData.other_source_pincode) && formData.other_source_pincode !== '' && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px", marginLeft: "16px" }}>
                                                    Pincode must be 6 digits.
                                                </span>
                                            )} */}
                                        </div>
                                    )}

                                     {/* invoice no */}
                                     <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Invoice No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => handleInvoiceChange(e)}
                                                onBlur={() => {
                                                    const isValid = validateInput(formData.invoice_no);
                                                    setIsValid(isValid);
                                                    if (!isValid) {
                                                        setSourceValidation(true)
                                                        setErrorMsg1(true)
                                                        setInvoiceValid(true)
                                                        console.error("Validation failed for invoice input.");
                                                    }else{
                                                        setSourceValidation(false)
                                                        setInvoiceValid(false)
                                                    }
                                                }}
                                                value={formData.invoice_no_str}
                                                name="invoice_no"
                                                autoComplete="off"
                                                required
                                            />
                                            {invoiceValid && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>
                                                Enter the Valid Invoice No's
                                            </span>}
                                        </div>


                                        <div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Consignor Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, consigner_name: value}));
                                                            // validateOtherConsignee(value);
                                                        }}
                                                        value={formData.consigner_name}
                                                        name="consigner_name"
                                                        autoComplete='off'
                                                    />
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>
                                         {/* truck no */}
                                         <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Truck No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleTruckNoChange}  
                                                value={formData.truck_no}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                            {validateTruckNo === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"0px"}}>
                                                    Enter Valid Truck Number
                                                </span>
                                            )}
                                        </div>
                                         {/* truck seal no */}
                                         <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Truck Seal No </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, truck_seal_no:e.target.value}))}
                                                value={formData.truck_seal_no}
                                                name="truck_seal_no"
                                                autoComplete='off'
                                            />
                                        </div>
                                          {/* entity */}
                                          <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Entity<span style={{color: 'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.entity}
                                                onChange={(e)=> setFormData((prev)=>({
                                                    ...prev, 
                                                    entity:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={entityList}
                                            />
                                        </div>
                                         {/* vehicle type */}
                                         <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Type<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.vehicle_type}
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value }
                                                    }));
                                                    if (e.value === "Others") {
                                                        setEnableVehicelType(true);
                                                        setFormData((prev) => ({ ...prev, other_vehicle_type: "" , other_vehicle_capacity:''}));

                                                    } else {
                                                        setEnableVehicelType(false);
                                                        fetchVehicleDetails(e.label, e.value)
                                                        
                                                    }
                                                }}
                                                style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={vehicleFtlTypeList}                                            />
                                        </div>
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Vehicle Type<span style={{color:'red'}}>*</span>  </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e)=> setFormData(prev =>({...prev, other_vehicle_type:e.target.value}))}
                                                value={formData.other_vehicle_type}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}
                                       
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">Invoice Date<span style={{color: 'red'}}>*</span></label>
                                            <div id="datepicker1">
                                                <DatePicker
                                                selected={formData.invoice_date}
                                                onChange={(date)=>handleInvoiceDate(date)}
                                                name="invoice_date"
                                                className="datepicker-custom-ptl4 form-control1"
                                                showTimeSelect={false}
                                                // timeFormat="HH:mm:ss"
                                                // timeIntervals={15} // Adjust this if you want different time intervals
                                                // timeCaption="Time"
                                                dateFormat="dd-MM-yyyy" // Adjusted format to match the original format
                                                maxDate={new Date()}
                                                id="invoice_date"
                                                autoComplete="off"
                                                onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </div> 
                                       
                                        {formData.movement_type.value ==="Customer Delivery" && (<div className="col-xl-12 col-lg-12 form-group">
                                                    <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, consignee_name1: value}));
                                                            // validateOtherConsignee(value);
                                                        }}
                                                        value={formData.consignee_name1}
                                                        name="other_consignee_name"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>) }
                                           {/* Consignee Name */}
                                          { formData.movement_type.value !=="Customer Delivery" && (  <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Consignee Name<span style={{color:'red'}}>*</span>  </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={formData.consignee_name}
                                                onChange={(e) => {                                                    
                                                    setFormData((prev) => ({
                                                        ...prev, 
                                                        consignee_name: {label: e.label, value: e.value}
                                                    }));
                                                    // Check if the selected option is "Other"
                                                    if (e.label !== "Others") {
                                                        fetchConsignerDetails(e.value, e.label);
                                                        setEnableConsigee(false)
                                                    } else {
                                                        setEnableConsigee(true)
                                                        setFormData(prev => ({...prev, destination_pincode: "", destination_city: ""}));
                                                    }

                                                    // Validate after updating the selection
                                                    validateOption("consigneeName");
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={consignees}
                                            />
                                           
                                            {formData.consignee_name.value ==="Others" && <>
                                                <div className="col-xl-12 col-lg-12 form-group" style={{marginTop:"20px", padding:"0px"}}>
                                                    <label className="mb-5p">Other Consignee Name<span style={{color:'red'}}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setFormData(prev => ({...prev, other_consignee_name: value}));
                                                            validateOtherConsignee(value);
                                                        }}
                                                        value={formData.other_consignee_name}
                                                        name="other_consignee_name"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>}
                                                </div>

                                                <div className="col-xl-12 col-lg-12 form-group" style={{ marginTop: "20px", padding: "0px" }}>
                                                    <label className="mb-5p">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const {value} = e.target

                                                            setFormData(prev => ({ ...prev, other_destination_city: value }));
                                                            checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                        }}
                                                        value={formData.other_destination_city}
                                                        name="other_destination_city"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validCity === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}
                                                </div>
                                                <div className="col-xl-12 col-lg-12 form-group" style={{ marginTop: "20px", padding: "0px" }}>
                                                    <label className="mb-5p">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            const {value} = e.target
                                                            setFormData(prev => ({ ...prev, other_destination_pincode: value }));
                                                            checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                        }}
                                                        value={formData.other_destination_pincode}
                                                        name="other_destination_pincode"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validPincode === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid Pincode</span>}
                                                </div>

                                            </>
                                            }

                                       
                                            
                                        </div>
                                      )}
                                         
                                     
                                       
                                       
                                      
                                       
                                        {/* courier partner - transporter */}
                                                                                
                                        {/* vehicle capacity */}
                                        {!enableVehicleType && <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Capacity<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <input
                                                    type="text"
                                                    className="form-control"
                                                    // onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={formData.vehicle_capacity}
                                                    name="vehicle_capacity"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={true}
                                                    
                                                />
                                            {/* <Select
                                                closeMenuOnSelect={true}
                                                value={formData.vehicle_capacity}
                                                className="custom-field-width"
                                                onChange={(e) => {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        vehicle_capacity: { label: e.label, value: e.value }
                                                    }));

                                                    // Enable Other Vehicle Capacity field when "Other" is selected
                                                    // if (e.value === "Others") {
                                                    //     setEnableVehicleCapacity(true);
                                                    // } else {
                                                    //     setFormData((prev) => ({ ...prev, other_vehicle_capacity: "" }));
                                                    //     setEnableVehicleCapacity(false);
                                                    // }
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                // options={vehicleCapacityList}
                                            /> */}
                                        </div>}
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Other Vehicle Capacity<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleVehicleCapacityChange} 
                                                value={formData.other_vehicle_capacity}
                                                name="other_vehicle_capacity"
                                                autoComplete='off'
                                                required
                                            />
                                            {validVehicleCapacity === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"16px"}}>
                                                    Enter Valid Vehicle Capacity
                                                </span>
                                            )}
                                        </div>}
                                            {/* No Of Boxes */}
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Number of Boxes</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setFormData((prev) => ({ ...prev, number_of_boxes: e.target.value }))
                                                    }
                                                    onInput={(e) => {
                                                        // Remove non-numeric characters
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                    }}
                                                    value={formData.number_of_boxes}
                                                    name="number_of_boxes"
                                                    autoComplete="off"
                                                />
                                            </div>

                                        {formData.consignee_name.value !=="Others" && 
                                        <>                                         
                                            <div className="col-xl-12 col-lg-12 form-group">
                                                <label className="mb-5p">Destination City<span style={{color:'red'}}>*</span>  </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e)=> setFormData(prev => ({...prev, destination_city:e.target.value }))}
                                                    value={formData.destination_city}
                                                    name="destination_city"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={!enableEdit}
                                                    required={enableEdit}
                                                />
                                            </div>                                    
                                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Destination Pincode<span style={{color:'red'}}>*</span>  </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                    value={formData.destination_pincode}
                                                    name="destination_pincode"
                                                    autoComplete='off'
                                                    // onFocus={checkConsignee}
                                                    disabled={!enableEdit}
                                                    required={enableEdit}
                                                />
                                                </div>

                                        </>
                                    }
                                        {/* Eway bill */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">E-Way Bill Expiry Date</label>
                                            <div id="datepicker1">
                                                <DatePicker
                                                selected={formData.eway_bill_expiry_date}
                                                onChange={handleEwayDate}
                                                name="eway_bill_expiry_date"
                                                className="datepicker-custom-ptl4 form-control1"
                                                showTimeSelect
                                                timeFormat="HH:mm:ss"
                                                timeIntervals={15} // Adjust this if you want different time intervals
                                                timeCaption="Time"
                                                dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                                minDate={new Date()} // Prevents past date selection
                                                id="eway_bill_expiry_date"
                                                autoComplete="off"
                                                onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </div> 
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total Weight <span style={{ color: 'red' }}>*</span> </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only numeric values (including empty string for clearing the input)
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        setFormData((prev) => ({ ...prev, total_weight: value }));
                                                    }
                                                }}
                                                value={formData.total_weight}
                                                name="total_weight"
                                                autoComplete="off"
                                                required
                                            />
                                            {!/^\d*\.?\d+$/.test(formData.total_weight) && formData.total_weight !== '' && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    Total Weight must be a numeric value.
                                                </span>
                                            )}
                                        </div>

                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total CBM</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only numeric values (including empty string for clearing the input)
                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                        setFormData((prev) => ({ ...prev, total_cbm: value }));
                                                    }
                                                }}
                                                value={formData.total_cbm}
                                                name="total_cbm"
                                                autoComplete="off"
                                            />
                                            {!/^\d*\.?\d+$/.test(formData.total_cbm) && formData.total_cbm !== '' && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                    Total CBM must be a numeric value.
                                                </span>
                                            )}
                                        </div>

                                        {/* No Of Boxes */}
                                       
                                     
                                      
                                    
                                     
                                   
                                    {/* <div style={{padding:"5px"}}>
                                    {manualTripUploadDetails.map((point, index) => (
                                        <div key={point.id} style={{ padding: '20px', border: '1px solid #ccc', marginBottom: '20px' }}> */}
                                            {/* <div className="slide-body">
                                                <div className="row p-20p"> */}
                                                    {/* <div className="col-xl-12 col-lg-12 d-flex justify-content-between align-items-center">
                                                        <h3>Drop Point {index + 1}</h3>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => handleRemoveDropPoint(point.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div> */}

                                                    {/* LR No Field */}
                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p"> */}
                                                            {/* LR No */}
                                                            {/* <span style={{ color: 'red' }}>*</span> */}
                                                        {/* </label> */}
                                                        {/* <input
                                                            type="text"
                                                            name="lr_no"
                                                            value={formData.lr_no}
                                                            className="form-control" */}
                                                            {/* // onChange={(e) => */}
                                                            {/* //     handleInputChange(point.id, 'lr_no', e.target.value)
                                                            // }
                                                            // required
                                                        // /> */}
                                                        {/* {validationErrors[point.id]?.lr_no && (
                                                            <span className="text-danger">{validationErrors[point.id].lr_no}</span>
                                                        )} */}
                                                    {/* </div> */}

                                                    {/* Invoice No Field */}
                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p">
                                                            Invoice No<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="invoice_no"
                                                            value={point.invoice_no}
                                                            className="form-control"
                                                            onChange={(e) =>
                                                                handleInputChange(index, 'invoice_no', e.target.value.toUpperCase())
                                                            }
                                                            autoComplete='off'
                                                            required
                                                        />
                                                        {validationErrors[index]?.invoice_no && (
                                                            <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[index].invoice_no}</span>
                                                        )}
                                                    </div> */}
                                                    {/* Consignee Name Field */}
                                                    {/* <div className="form-group col-xl-12 col-lg-12">
                                                        <label className="mb-5p">
                                                            Consignee Name<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            value={dropPointConsignee.find(option => option.value === point.consignee_name) || null}
                                                            options={dropPointConsignee.filter((option, optIndex) => {
                                                                // Filter out consignees that were selected in any previous blocks
                                                                const selectedInPreviousBlocks = manualTripUploadDetails
                                                                    .slice(0, index)
                                                                    .some(prevPoint => prevPoint.consignee_name === option.value);

                                                                return !selectedInPreviousBlocks;
                                                            })}
                                                            onChange={(selectedOption) => {
                                                                handleConsigneeChange(point.id, selectedOption.value);
                                                                if (selectedOption.value && selectedOption.value !== "Others") {
                                                                    fetchDestinationDetails(selectedOption.value, point.id);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                        {validationErrors[point.id]?.consignee_name && (
                                                            <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].consignee_name}</span>
                                                        )}

                                                        {showCustomConsigneeInput[point.id] && (
                                                        <>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_name"
                                                                    className="form-control"
                                                                    onChange={(e) => handleInputChange(index, 'other_consignee_name', e.target.value)}
                                                                    value={point.other_consignee_name || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_city"
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const {value} = e.target
                                                                        handleInputChange(index, 'other_consignee_city', value)
                                                                        checkOtherConsigneeName("other_consignee_city1", value)
                                                                    }}
                                                                    value={point.other_consignee_city || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                            {validCity1 === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}

                                                            </div>
                                                            <div className="form-group col-xl-12 col-lg-12" style={{ marginTop: "20px", padding: "0px" }}>
                                                                <label className="mb-5p">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="other_consignee_pincode"
                                                                    className="form-control"
                                                                    onChange={(e) => {
                                                                        const {value} = e.target
                                                                        handleInputChange(index, 'other_consignee_pincode', value)
                                                                        checkOtherConsigneeName("other_consignee_pincode1", value)
                                                                    }}
                                                                    value={point.other_consignee_pincode || ""}
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                    {validPincode1 === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid Pincode</span>}
                                                    </div>
                                                        </>
                                                        )}
                                                    </div> */}
                                                    {/* {!showCustomConsigneeInput[point.id] && (
                                                        <>                                                         */}
                                                            {/* Destination City Field */}
                                                            {/* <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">
                                                                    Destination City<span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="destination_city"
                                                                    value={point.destination_city}
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleInputChange(index, 'destination_city', e.target.value)
                                                                    }
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                                {validationErrors[point.id]?.destination_city && (
                                                                    <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].destination_city}</span>
                                                                )}
                                                            </div> */}
                                                            {/* Destination Pincode Field */}
                                                            {/* <div className="form-group col-xl-12 col-lg-12">
                                                                <label className="mb-5p">
                                                                    Destination Pincode<span style={{ color: 'red' }}>*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="destination_pincode"
                                                                    value={point.destination_pincode}
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        handleInputChange(index, 'destination_pincode', e.target.value)
                                                                    }
                                                                    autoComplete='off'
                                                                    required
                                                                />
                                                                {validationErrors[point.id]?.destination_pincode && (
                                                                    <span style={{color:"red", fontSize:"12px",marginTop:"5px"}}>{validationErrors[point.id].destination_pincode}</span>
                                                                )}
                                                            </div> */}
                                                        {/* </>
                                                    )} */}
                                                {/* </div>
                                            </div> */}
                                        {/* </div>
                                    ))}


                                    </div> */}
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        {/* <button
                                            type="button"
                                            className={`btn customAddBtn${isFormValid() && isManualTripUploadDetailsValid() && !invoiceValid? 'btn-primary' : 'btn-disabled'}`}
                                            onClick={handleButtonClick}
                                            style={{ padding: '9px 10px', fontSize: '12px', cursor: 'pointer',borderRadius:"none" ,marginRight:"20px" }}
                                            disabled={!isFormValid() || !isManualTripUploadDetailsValid() && invoiceValid}
                                            >
                                            Add Drop Point
                                        </button> */}
                                        <button
                                            type="submit"
                                            className={`btn ${((isFormValid() && isManualTripUploadDetailsValid() && !invoiceValid ) || !isValid1)? 'btn-success' : 'btn-disabled'}`}
                                            disabled={(!isFormValid() && !isManualTripUploadDetailsValid() && invoiceValid) || isValid1}
                                            >
                                            Submit
                                        </button>
                                    </div>

                                    
                                    </div>
                                </div>
							</form>
						</div>
				    </div>

                <div className={"slide-r " + (showBulkUpdateDeliveryDate)} style={{ overflow: "auto" }}>
                    <h3 className="subH">Bulk Late Delivery Remarks Update Details
                        <span className="float-right closebtn" style={{ marginRight: "10px" }} onClick={onClickHideManualUpload7} >X</span>
                    </h3>

                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft: "-30px" }}>
                                <form method="POST" id="upform" className="theme-form" style={{ marginBottom: "20px" }}>
                                    <div className='d-flex'>
                                        <div className="col-xl-3 col-lg-3 form-group mt-30p">
                                            {/* <a className="btn btn-primary" href={require('../../assets/files/bulk_delivery_date_update.xlsx')} target="_blank"><i class="icofont icofont-download mr-10p"></i>Sample Template</a> */}
                                            <a
                                                className="btn btn-primary"
                                                href={
                                                    isAdmin
                                                        ? require('../../assets/files/bulk_delivery_date_update_admin.xlsx')
                                                        : require('../../assets/files/bulk_delivery_date_update.xlsx')
                                                }
                                                target="_blank"
                                            >
                                                <i className="icofont icofont-download mr-10p"></i>
                                                Sample Template
                                            </a>

                                        </div>
                                        <div className="col-xl-9 col-lg-9 form-group">
                                            <label className="">Upload File</label>
                                            <input type="file" name="uploadBulkFile" id="bulkUpdateCritical" onChange={changeBulkDeliveryDateFileHandler} style={{ width: "500px" }} className="form-control" value={file4 ? undefined : ""} required />
                                        </div>
                                    </div>
                                </form>
                                <div className="form-group1">
                                    <span style={{ color: 'red' }}>Note:</span>
                                    <div className='d-flex flex-col' style={{ color: "#808080" }}>
                                        {/* Invoice No: It must begin with a numerical sequence, followed by  a forward slash (/), and then source identifier. <br/> 
                                         LR No: It must consist of numerical values only and can be left empty.<br/>  */}
                                        Dates must be in the format of DD-MM-YYYY HH:MM or DD/MM/YYYY HH:MM.
                                    </div>
                                    {/* <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a>   */}
                                </div>
                            </div>
                            <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop: "-50px" }}>

                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div style={{ marginTop: "-15px", marginRight: "-18px" }}><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>  */}
                                </div>
                            </div>
                            <div className="ag-theme-balham mt-2" style={{ height: '55vh', width: '100%', overflow: "auto" }}>
                                <AgGridReact
                                    columnDefs={columnBulkDeliveryDateDef}
                                    rowData={modalBulkDeliveryData}
                                    defaultColDef={defaultColDef}
                                    // onCellValueChanged={onCellValueChanged} 
                                    onGridReady={onGridReadyDeliveryDateBulkUpdate}
                                    // getRowStyle={getBulkDeliveryRowStyle}
                                     onCellValueChanged={onBulkDeliveryCellValueChanged}
                                    rowClassRules={{
                                        "bulk-error-row": params =>
                                            !!params.data && params.data.isInvalidPerformance === true
                                    }}
                                    domLayout="autoHeight"
                                    // pagination={false}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    stopEditingWhenGridLosesFocus={true}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }} />
                            </div>
                            <br />
                            <div className="form-group">
                                <button type="submit" className="btn btn-success border-radius1 mr-20p" onClick={uploadDeliveryDateFormHandler}>Submit</button>
                                &nbsp;
                                <button type="button" onClick={onClickHideManualUpload7} className="btn btn-default border-radius1" style={{ fontWeight: 600 }}>Cancel</button>
                            </div>
                            <br />
                            <br />
                        </div>
                        <div className={"overlay-part " + (overlayBulkDeliveryUpdate)} style={{ zIndex: "10" }}
                        ></div>
                        <div className={"dataLoadpage " + (loadshowBulkDeliveryUpdate)}></div>
                        <div className={"dataLoadpageimg " + (loadshowBulkDeliveryUpdate)} style={{ top: "21em" }}>
                            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                        </div>
                    </div>
                </div> 
                {/* <div className={"slide-r " + (sliderShow1)}>
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Upload Document
                            <span
                                  className="float-right closebtn"
                                  style={{ marginRight: "10px" }}
                                  onClick={onCloseSliderDiv1}          
                                        >
                                 X
                            </span>
                        </h4>
                    </div> */}
                    
                    <div className={"slide-r " + (sliderShow1)}>
            <div className="slide-r-title">
                <h4 className="slide-r-title">Upload Document
                    <span
                        className="float-right closebtn"
                        style={{ marginRight: "10px" }}
                        onClick={onCloseSliderDiv1}
                    >
                        X
                    </span>
                </h4>
            </div>

            <div className="col-sm-12">
                <div className="slide-r-body">
                    <div className="tabs1">
                        {/* Tab Navigation */}

                        {(rownode.length> 0 && rownode[0].tracking_type === "FTL") ?(
                            <>
                            <div className="tab-buttons">
                                {/* <button
                                    className={`tab-button ${(rownode[0].loading_doc !==1) ? "active" : ""}`}
                                    onClick={() => handleDocTab("loading")}
                                    disabled={rownode[0].loading_doc ===1} // Disable if loading_doc == 1
                                >
                                    Loading
                                </button> */}
                                <button 
                        className={selectedTab === "loading" ? "loading-button1 mr-10p" : "loading-button mr-10p" }
                        onClick={() => handleDocTab("loading")}
                        // disabled={rownode[0].loading_doc === 1}
                        >
                        Loading
                        {/* Only show dots if loading and button is not disabled */}
                        {/* {!rownode[0].loading_doc === 1 && ( */}
                        {/* { (
                            <div className="loading-dots">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                            </div>
                        )} */}
                        </button>

                        <button 
                        className={selectedTab === "unloading" ? "loading-button1" : "loading-button" }
                        onClick={() => handleDocTab("unloading")}
                        // disabled={rownode[0].consignment_status ? rownode[0].consignment_status !=="Arrived At Destination" : ""}
                        >
                        Unloading
                        {/* Only show dots if unloading and button is not disabled */}
                        {/* {(rownode[0].consignment_status ? (rownode[0].consignment_status !=="Arrived At Destination") : (rownode[0].status !==4)) ? "": (
                            <div className="loading-dots">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                            </div>
                        )} */}
                        </button>

                                                    </div>
                        

                        {/* Tab Content */}
                        <form className="theme-form" method="POST" id="formDocument" encType="multipart/form-data" onSubmit={uploadDocument1}>
                            <div className="row p-20p">
                                {/* {(!rownode[0].loading_doc && rownode[0].loading_doc !== 1) && ( */}
                                { (selectedTab ==="loading") && (

                                    <>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Upload Loading Document <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="file"
                                                name="loading"
                                                id="uploadDoc"
                                                className="form-control"
                                                accept=".pdf, image/*, .xls, .xlsx"
                                                multiple
                                                onChange={changeFileHandlerForUploadDoc}
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Remarks <span style={{ color: 'red' }}>*</span></label>
                                            <textarea
                                                name="loadingdocremarks"
                                                id="docremarks"
                                                rows="3"
                                                value={loadingdocremarks}
                                                onChange={changeHandler1}
                                                className="form-control"
                                            ></textarea>
                                        </div>
                                    </>
                                )}

                                {(
                                    // (rownode[0].consignment_status !=="Arrived At Destination" || rownode[0].status !==3)
                                    //   && 
                                selectedTab === "unloading" )&& (
                                    <>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Upload Unloading Document <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="file"
                                                name="unloading"
                                                id="uploadDoc"
                                                className="form-control"
                                                accept=".pdf, image/*, .xls, .xlsx"
                                                multiple
                                                onChange={changeFileHandlerForUploadDoc}
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-sm-12 mb-20p">
                                            <label className="f16">Remarks <span style={{ color: 'red' }}>*</span></label>
                                            <textarea
                                                name="unloadingdocremarks"
                                                id="docremarks"
                                                rows="3"
                                                value={unloadingdocremarks}
                                                onChange={changeHandler1}
                                                className="form-control"
                                            ></textarea>
                                        </div>
                                    </>
                                )}

                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success" style={{ marginRight: "10px" }}>
                                        Upload
                                    </button>
                                    <button type="button" className="btn btn-default" onClick={hideSlideBlockForDocument}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                        </>): <> 
                        <form className="theme-form" method="POST" id="formDocument" encType="multipart/form-data" onSubmit={uploadDocument1}>
                        <div className="row p-20p">
                                <div className="form-group col-sm-12 mb-20p">
                                        <label className="f16">Upload Document<span style={{color:'red'}}>*</span></label>
                                        <input type="file" name="uploadDoc" id="uploadDoc" className="form-control"  accept = ".pdf, image/*, .xls, .xlsx" multiple onChange={changeFileHandlerForUploadDoc} required />
                                    </div>

                                    <div className="form-group col-sm-12 mb-20p">
                                        <label className="f16">Remarks<span style={{color:'red'}}>*</span></label>
                                        <textarea name="docremarks" id="docremarks" rows="3" value={docremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div>

                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlockForDocument}>Cancel</button>
                                    </div>
                                    </div>
                        </form></>}
                    </div>
                </div>
            </div>
        </div>
                    {/* previousss */}
                    {/* <div className="col-sm-12">
                        <div className="slide-r-body">
                            <form className="theme-form" method="POST" id="formDocument" enctype="multipart/form-data" onSubmit={uploadDocument1}>
                                <div className="row p-20p">
                                    {/* <div className="form-group col-sm-12 mb-20p">
                                        <label>Delivered Date<span cl
                                        assName="rclr fbold">*</span></label>
                                        <input type="text" name="startDate" className="form-control" value={this.state.delivered_date} required />

                                    </div> */}
                                    {/* <div className="form-group col-sm-12 mb-20p">
                                        <label>Upload Document<span style={{color:'red'}}>*</span></label>
                                        <input type="file" name="uploadDoc" id="uploadDoc" className="form-control"  accept = ".pdf, image/*" multiple onChange={changeFileHandlerForUploadDoc} required />
                                    </div>
                                  
                                    <div className="form-group col-sm-12 mb-20p">
                                        <label>Remarks<span style={{color:'red'}}>*</span></label>
                                        <textarea name="docremarks" id="docremarks" rows="3" value={docremarks} onChange={changeHandler1} className="form-control" ></textarea>
                                    </div> 
                                    
                                    <div className="form-group col-sm-12 mb-20p text-center">
                                        <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Upload</button>
                                        <button type="button" className="btn btn-default" onClick={hideSlideBlockForDocument}>Cancel</button>
                                    </div> */}
                                {/* </div> */}
                            {/* </form> */}
                        {/* </div> */}
                    {/* // </div> */} 
                {/* </div>   */}
                {gateOutSlide
                 && 
                 <div className={"sliderBlock3 " + (gateOutSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideGateoutSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>
                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to submit ?</h1>
                            </div>
                </div>                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideGateoutSubmit} >Cancel</button>
                    <button className='btn_hover7' onClick={onsubmitdata1}>Submit</button>
                </div>

                </div>} 
                {tabName.value == 'inactive' && (
                    <div
                    className={"slide-r " + showAddForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                    <h4 className="slide-r-title">Single Update LR<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload1} >X</span></h4>
                    

                    </div>
                    <div className="row" style={{padding:"20px"}}>
                    <div className="col-sm-12">
                        <form 
                        onSubmit={onSubmitLrUpdateForm}
                        >
                        <div className="slide-body">
                            <div className="row p-20p">
                            <div className="form-group col-xl-12 col-lg-12">
                            </div>{" "}
                            <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                Invoice No<span style={{color:'red'}}>*</span>
                                </label>
                                <input
                                                        type="text"
                                                        name="lr_no"
                                                        id="lr_no"
                                                        value={manualUploadDetails.invoice_no}
                                                        className="form-control"
                                                        // onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, invoice_no: e.target.value }))}
                                                        required
                                                    /> 
                            
                            </div>
                            <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                LR No<span style={{color:'red'}}>*</span>
                                </label>
                                <input
                                                        type="text"
                                                        name="lr_no"
                                                        id="lr_no"
                                                        value={manualUploadDetails.lr_no}
                                                        className="form-control"
                                                        onChange={handleLRChange}
                                                        required
                                                    /> 
                            
                            </div>                
                            <div className="form-group col-sm-12 mb-20p text-center">
                                <button type="submit" className="btn btn-success">
                                Submit
                                </button>
                            </div>
                            </div>
                        </div>
                        </form>
                    </div>
                    </div>
                </div> 
                )} 
                {tabName.value == 'transporter' && (
                    <div
                    className={"slide-r " + showUpdateLrForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Update LR<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideLrUpdateForm} >X</span></h4>                  
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form onSubmit={onSubmitLrUpdateForm}>
                                <div className="slide-body">
                                    <div className="row p-20p">
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Invoice No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={selectedInvoicetoUpdateLr}
                                                isMulti={true}
                                                className="border-radius-0"
                                                // onChange={e => setInvoiceSelected(e)}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={selectedInvoicetoUpdateLr}
                                                required 
                                            />
                                        </div>
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            LR No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="lr_no2"
                                                value={updatelrNo}
                                                className="form-control1"
                                                onChange={handleLRChange}
                                                autoComplete='off'
                                                // required
                                            />                        
                                        </div>
                                        {/* {transporterValidation  &&  */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Transporter<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.courier_partner}
                                                onChange={(e) => {
                                                    setManualUpdateLRConsignment((prev) => ({
                                                        ...prev,
                                                        courier_partner: { label: e.label, value: e.value }
                                                    }));

                                                    // Enable Other Transporter field when "Other" is selected
                                                    if (e.value === "Others") {
                                                        setEnableCourierType(true);
                                                    } else {
                                                        setManualUpdateLRConsignment((prev) => ({ ...prev, other_transporter: "" }));
                                                        setEnableCourierType(false);
                                                    }
                                                }}
                                                isDisabled = {true}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList1}
                                            />
                                        </div>
                                        {/* } */}
                                        {/* {((lRTrackingType==="FTL" && truckNoValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null) && truckNoValidation)) &&  */}
                                      
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Dispatch Date<span style={{color:'red'}}>*</span>
                                            </label>
                                        <div id="datepicker1">
                                                <DatePicker
                                            selected={manualUpdateLRConsignment.dispatch_time}
                                            onChange={(date) => changeHandleDate2(date)} 
                                            name="dispatch_time"
                                            className="datepicker-custom-ptl6 form-control"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15} // Adjust this if you want different time intervals
                                            timeCaption="Time"
                                            dateFormat="dd-MM-yyyy HH:mm" // Adjusted format to match the original format
                                            // placeholderText="Date" // Equivalent to placeholder in the original
                                            id="dispatch_time"
                                            autoComplete='off'
                                            // style={{width:"100%"}}
                                            required
                                            />
                                        </div>
                                        
                                        </div>
                                       

                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">
                                                Truck No{(lRTrackingType==="FTL"|| manualUpdateLRConsignment.tracking_type_mutliple.value==="FTL") && <span style={{color:'red'}}>*</span>}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={handleTruckNoChange}  
                                                value={manualUpdateLRConsignment.truck_no}
                                                name="lr_truck_no"
                                                autoComplete='off'
                                                disabled={!truckNoValidation}
                                            />
                                            {validateTruckNo === false && (
                                                <span style={{color:"red", fontSize:"12px", marginTop:"5px", marginLeft:"0px"}}>
                                                    Enter Valid Truck Number
                                                </span>
                                            )}
                                        </div>
                                        {/* } */}
                                         {/* {((lRTrackingType==="FTL" && vehicleTypeValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null) &&(vehicleTypeValidation))) &&  */}
                                         <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Vehicle Type{(lRTrackingType==="FTL" || manualUpdateLRConsignment.tracking_type_mutliple.value==="FTL") && <span style={{color:'red'}}>*</span>}
                                                
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.vehicle_type}
                                                onChange={(e) => {
                                                    setManualUpdateLRConsignment((prev) => ({
                                                        ...prev,
                                                        vehicle_type: { label: e.label, value: e.value }
                                                    }));
                                                    if (e.value === "Others") {
                                                        setEnableVehicelType(true);
                                                        setManualUpdateLRConsignment((prev) => ({ ...prev, other_vehicle_type: "" , other_vehicle_capacity:''}));

                                                    } else {
                                                        setEnableVehicelType(false);
                                                        fetchVehicleDetails(e.label, e.value)
                                                        
                                                    }
                                                }}
                                                style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={(() => {
                                                    if (lRTrackingType === "FTL") {
                                                        return vehicleFtlTypeList; // Use FTL-specific list
                                                    } else if (lRTrackingType === "PTL") {
                                                        return vehiclePtlTypeList; // Use PTL-specific list
                                                    } else if (lRTrackingType === "FTL/PTL") {
                                                        return vehicleTypeList; // Use combined vehicle list
                                                    } else {
                                                        return []; // Default to an empty list if no match
                                                    }
                                                })()}                                                
                                                isDisabled={!vehicleTypeValidation}
                                            />
                                        </div>
                                        {/* } */}
                                        {enableVehicleType && <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Other Vehicle Type</label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev =>({...prev, other_vehicle_type:e.target.value}))}
                                                value={manualUpdateLRConsignment.other_vehicle_type}
                                                name="truck_no"
                                                autoComplete='off'
                                                required
                                            />
                                        </div>}
                                            {/* {fuelValidation &&  */}
                                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Fuel Type<span style={{color:'red'}}>*</span></label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.fuel_type}
                                                onChange={(e)=> setManualUpdateLRConsignment((prev)=>({
                                                    ...prev, 
                                                    fuel_type:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={fuelTypeListForUpdateLR}
                                                // isDisabled={!fuelValidation}
                                                required
                                            />
                                        </div>
                                        {/* }                                        */}
                                          {/* {modeValidation &&  */}
                                          {(lRTrackingType) &&
                                        lRTrackingType!=="FTL/PTL" && 
                                         ( <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Tracking Mode<span style={{color:'red'}}>*</span></label>
                                           <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, tracking_type:e.target.value }))}
                                                value={manualUpdateLRConsignment.tracking_type}
                                                name="tracking_type"
                                                autoComplete='off'
                                                disabled={true}
                                            />
                                            </div>)}
                                            {((lRTrackingType) &&
                                        (lRTrackingType ==="FTL/PTL") )&& (
                                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Tracking Mode<span style={{color:'red'}}>*</span></label>
                                            <Select
                                            closeMenuOnSelect={true}
                                            value={manualUpdateLRConsignment.tracking_type_mutliple}
                                            onChange={(e) =>
                                                setManualUpdateLRConsignment((prev) => ({
                                                ...prev,
                                                tracking_type_mutliple: { label: e.label, value: e.value },
                                                }))
                                            }
                                            style={{ borderRadius: "0px" }}
                                            styles={{
                                                control: (provided) => ({
                                                ...provided,
                                                fontSize: "0.8rem",
                                                color: "#6e707e",
                                                width: "100%",
                                                }),
                                                singleValue: (provided) => ({
                                                ...provided,
                                                fontSize: "0.9rem",
                                                }),
                                            }}
                                            options={TrackingTypeList}
                                            />
                                            </div>
                                        )}
                                        {/* {(lRTrackingType) &&
                                        lRTrackingType ==="FTL/PTL" && ftlValidWeight && (
                                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Tracking Mode<span style={{color:'red'}}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                value={"FTL"}
                                                name="tracking_type"
                                                autoComplete='off'
                                                disabled={true}
                                            />
                                            </div>
                                        )} */}
                                         {/* {(lRTrackingType) &&
                                        lRTrackingType ==="FTL/PTL" && ptlValidWeight && (
                                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Tracking Mode<span style={{color:'red'}}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                value={"PTL"}
                                                name="tracking_type"
                                                autoComplete='off'
                                                disabled={true}
                                            />
                                            </div>
                                        )} */}

                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">E-Way Bill No  </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, eway_bill_no:e.target.value }))}
                                                value={manualUpdateLRConsignment.eway_bill_no}
                                                name="eway_bill_no"
                                                autoComplete='off'
                                            />
                                        </div>
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Mode  <span style={{color:'red'}}>*</span></label>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    value={manualUpdateLRConsignment.mode}
                                                    onChange={(e) => !modeDisabled && setManualUpdateLRConsignment(prev => ({ ...prev, mode: e }))}
                                                    options={modeList}
                                                    isDisabled={modeDisabled}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            backgroundColor: modeDisabled ? "#f5f5f5" : "white",
                                                            cursor: modeDisabled ? "not-allowed" : "default"
                                                        })
                                                    }}
                                                />

                                        </div>
                                        {/* } */}
                                            {/* {noOfBoxesValidation &&  */}
                                            <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Number of Boxes  
                                            {(noOfBoxesMandatory && <span style={{color:'red'}}>*</span> )}

                                            </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, no_of_boxes:e.target.value }))}
                                                value={manualUpdateLRConsignment.no_of_boxes}
                                                name="no_of_boxes"
                                                autoComplete='off'
                                                // disabled={!noOfBoxesValidation}
                                            />
                                        </div>
                                        {/* } */}

                                        {/* {((lRTrackingType==="FTL" && driverNoValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null) && driverNoValidation) )&& */}
                                        {(lRTrackingType==="FTL" || manualUpdateLRConsignment.tracking_type_mutliple.value==="FTL") &&
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Driver Mobile No.
                                                {((driverNoMandatory || manualUpdateLRConsignment.tracking_type_mutliple.value==="FTL")&& <span style={{color:'red'}}>*</span> )}
                                                </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e) => {
                                                    const { name } = e.target;
                                                    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                    
                                                    // Validate the input length and content
                                                    if (numericValue.length < 10) {
                                                        setError1('Mobile number must be 10 digits long');
                                                    } else if (!/^[6-9]\d{9}$/.test(numericValue)) {
                                                        setError1('Mobile number must start with a digit between 6 and 9 and be 10 digits long');
                                                    } else {
                                                        setError1(''); // Clear error if the number is valid
                                                    }

                                                    // Update the state with the new value (allow only 10 digits max)
                                                    if (numericValue.length <= 10) {
                                                        setManualUpdateLRConsignment((prev) => ({ ...prev, driver_mobile_no: numericValue }));

                                                        // if (name === 'driver_number_update') {
                                                        //     setManualUpdateConsignment((prev) => ({ ...prev, driver_number: numericValue }));
                                                        // } else if (name === 'driver_mobile_no') {
                                                        //     setFormData((prev) => ({ ...prev, driver_mobile_no: numericValue }));
                                                        // }
                                                    }
                                                }}
                                                disabled={!driverNoValidation}
                                                value={manualUpdateLRConsignment.driver_mobile_no}
                                                name="driver_mobile_no"
                                                autoComplete='off'
                                                // required
                                            />
                                            {error1 && <span style={{ color: 'red', fontSize: "10px", margin: "10px 0px 0px 20px" }}>{error1}</span>}                    
                                        </div>}
                                        {/* } */}

                                        

                                        {/* {((lRTrackingType==="PTL" && entityValidation) || ((selectedRows[0]?.transporter_name ==="" || selectedRows[0]?.transporter_name ===undefined || selectedRows[0]?.transporter_name ===null) && (lRTrackingType ==="" || lRTrackingType ===undefined || lRTrackingType ===null)  && entityValidation)) &&  */}
                                        {/* <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Entity <span style={{color:'red'}}>*</span> </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.entity}
                                                onChange={(e)=> setManualUpdateLRConsignment((prev)=>({
                                                    ...prev, 
                                                    entity:{label:e.label, value: e.value}
                                                }))}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.8rem",
                                                    color: "#6e707e",
                                                    width:"100%"
                                                    }),
                                                    singleValue: (provided, state) => ({
                                                    ...provided,
                                                    fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={entityList}
                                                isDisabled={!entityValidation}
                                            />
                                        </div> */}
                                        {/* } */}

                                       
                                      
                                       

                                    
                                      
                                {/* {totalCBMValidation &&  */}
                                        {/* <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total CBM </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, total_cbm:e.target.value }))}
                                                value={manualUpdateLRConsignment.total_cbm}
                                                name="total_cbm"
                                                autoComplete='off'
                                                disabled={!totalCBMValidation}
                                            />
                                        </div>
                                        {/* } */}
                                        {/* {totalWeightValidation &&  */}
                                        {/* <div className="col-xl-12 col-lg-12 form-group">
                                            <label className="mb-5p">Total Weight </label>
                                            <input
                                                type="text"
                                                className="form-control1"
                                                onChange={(e)=> setManualUpdateLRConsignment(prev => ({...prev, total_weight:e.target.value }))}
                                                value={manualUpdateLRConsignment.total_weight}
                                                name="total_weight"
                                                autoComplete='off'
                                                disabled={!totalWeightValidation}
                                            />
                                        </div>  */}
                                        {/* } */}
                                        {/* {dispacthdateValidation && 
                                    <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Dispatch Time<span style={{color:'red'}}>*</span>
                                    </label>
                                    <div id="datepicker1">
                                        <DatePicker
                                    selected={manualUpdateLRConsignment.dispatch_time}
                                    onChange={changeHandleDate2}
                                    name="lr_dispatch_time"
                                    className="datepicker-custom-ptl3 form-control"
                                    showTimeSelect
                                    timeFormat="HH:mm:ss"
                                    timeIntervals={15} // Adjust this if you want different time intervals
                                    timeCaption="Time"
                                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                    // placeholderText="Date" // Equivalent to placeholder in the original
                                    id="dispatch_time"
                                    autoComplete='off'
                                    style={{width:"96%"}}
                                    // required
                                    />
                                </div>
                                
                                </div>} */}
                              
                                    
                                         {/* {invoiceTypeValidation && 
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Invoice Type<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={manualUpdateLRConsignment.invoice_type}
                                                onChange={(e) => {
                                                    setManualUpdateLRConsignment((prev) => ({
                                                        ...prev,
                                                        invoice_type: { label: e.label, value: e.value }
                                                    }));
                                                }}
                                                className="custom-field-width"
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"445px"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList}
                                            />
                                        </div>} */}
                                        <div className="form-group col-sm-12 mb-20p text-center">
                                            <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Submit</button>
                                            <button type="button" onClick={cancelUpdateLrNo} className="btn btn-default">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> 
                )} 
                  {(tabName.value == 'inactive' || tabName.value == 'transporter') && (
                    <div
                    className={"slide-r " + showUpdateTransporterForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                        <h4 className="slide-r-title">Update Transporter<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideTransporterUpdateForm} >X</span></h4>                  
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form onSubmit={onSubmitTransporterUpdateForm}>
                                <div className="slide-body">
                                    <div className="row p-20p">
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Invoice No<span style={{color:'red'}}>*</span>
                                            </label>
                                            <Select placeholder={"All"}
                                                value={selectInvoicesToTransporterUpdate}
                                                isMulti={true}
                                                className="border-radius-0"
                                                // onChange={e => setInvoiceSelected(e)}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={selectInvoicesToTransporterUpdate}
                                                required 
                                            />
                                        </div>
                                       
                                        {/* {transporterValidation  &&  */}
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                                Transporter<span style={{color: 'red'}}>*</span>
                                            </label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                value={selectedTransporter}
                                                onChange={(e) => {
                                                    setSelectedTransporter(e)
                                                }}
                                                style={{ borderRadius: "0px" }}
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.8rem",
                                                        color: "#6e707e",
                                                        width:"100%"

                                                    }),
                                                    singleValue: (provided, state) => ({
                                                        ...provided,
                                                        fontSize: "0.9rem",
                                                    }),
                                                }}
                                                options={courierPartnerList1}
                                            />
                                        </div>
                                        <div className="form-group col-sm-12 mb-20p text-center">
                                            <button type="submit" className="btn btn-success" style={{marginRight:"10px"}}>Submit</button>
                                            <button type="button" onClick={cancelUpdateTransporterNo} className="btn btn-default">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> 
                )} 
                
      <div
        className={"slide-r " + showAddForm1}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4 className="slide-r-title">Update Details<span className="float-right closebtn" style={{ marginRight: "10px"}} onClick={onClickHideManualUpload1} >X</span></h4>
          

        </div>
        <div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickGateOutUpdate}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                 
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Dispatch Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={manualUploadDetails14.dispatch_time}
                    onChange={changeHandleDate}
                    name="dispatch_time"
                    className="datepicker-custom-ptl1 form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="dispatch_time"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required
                    />
                  </div>
                  
                  </div>
                 
                  {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
                <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                    // onClick={onClickHideAll}
                ></div>
                <div className={"dataLoadpage " + (loadshow)}></div>
                <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
            </>
        </div>

    );
}
function DateEditor() { }

DateEditor.prototype.init = function (params) {
    this.eInput = document.createElement('input');
    this.eInput.style.width = "210px";

    const currentDate = new Date();
    let maxDate;
    let dateFormat = "yy-mm-dd"; // Default date format
    let timeFormat = "HH:mm";   // Default time format
    let showTimePicker = true;  // Default to showing time picker

    // Configure based on column ID
    if (params.column.getColId() === "current_event_date_time") {
        maxDate = new Date(currentDate.getTime() + 8 * 60 * 60 * 1000); // Current date + 8 hours
    } else if (params.column.getColId() === "delivery_datetime") {
        maxDate = new Date(currentDate);
        maxDate.setHours(23, 59, 59, 999); // End of the current day (23:59:59.999)
    } else if (params.column.getColId() === "invoice_date") {
        dateFormat = "dd-mm-yy"; // Use dd-MM-yyyy format for invoice_date
        showTimePicker = false; // Disable time picker for invoice_date
    }

    // Set initial value
    this.eInput.value = params.value ? params.value : "";

    // Initialize the datetime picker
    $(this.eInput).datetimepicker({
        dateFormat: dateFormat,           // Apply the dynamic date format
        timeFormat: showTimePicker ? timeFormat : "",         // Apply the dynamic time format
        changeMonth: true,
        changeYear: true,
        showSecond: showTimePicker,       // Only show seconds if time picker is enabled
        showTime: showTimePicker,         // Show/hide time picker based on column
        maxDate: maxDate,                 // Apply the dynamic max date
        hour: currentDate.getHours(),     // Default hour
        minute: currentDate.getMinutes(), // Default minute
        second: currentDate.getSeconds(), // Default second
    });
};


DateEditor.prototype.getGui = function () {
    return this.eInput;
};
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};
DateEditor.prototype.getValue = function () {
    return this.eInput.value;
    const selectedDate = new Date(inputValue);

    // Validate and return as ISO string in UTC
    if (!isNaN(selectedDate)) {
        const isoDate = selectedDate.toISOString(); // Convert to ISODate (UTC)
        console.log("ISODate returned:", isoDate); // Debugging
        return isoDate;
    }

    console.error("Invalid date selected:", inputValue);
    return null; 
};
DateEditor.prototype.destroy = function () {
};
DateEditor.prototype.isPopup = function () {
    return false;
};

export default Consignments;

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
function secondsToString(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays + " days " + numhours + " hours " + numminutes + " minutes ";
}



function secondsToDays(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
} 
function dateComparator(date1, date2) {
	if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
		var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
		date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
		var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
		date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
		var date1Number = monthToComparableNumber(date1);
		var date2Number = monthToComparableNumber(date2);
		if (date1Number === null && date2Number === null) {
			return 0;
		}
		if (date1Number === null) {
			return -1;
		}
		if (date2Number === null) {
			return 1;
		}
		return date1Number - date2Number;
	}
}
function getMonthNumber(monthName) {
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
	];
	var monthNum = months.indexOf(monthName) + 1;
	if (monthNum < 10) {
		monthNum = "0" + monthNum.toString();
	}
	return monthNum;
}
function monthToComparableNumber(date) {
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
 // Helper function to validate invoice number
 function validateInvoice(invoiceNo, sourceRecords) {
    // Regular expression to match the first 6 digits followed by a '/'
    const invoicePattern = /^[A-Za-z0-9]+\/.*/;

    // Validate the invoice number and return formatted result
    if (invoicePattern.test(invoiceNo)) {
        const invoiceSeries = invoiceNo.split("/")[1]
        const arr = Array.from(sourceRecords);
        const isValid = arr.includes(invoiceSeries.toUpperCase())
        if(isValid){
            return invoiceNo; // Valid format, return the invoice number
        }else{
            return ""
        }

    } else {
        return ""; // Invalid format, return error message
    }
}

function validateLRNo(lrNo) {
    // If the value is empty, allow it
    if (lrNo === "") {
        return lrNo; // Allow empty value
    }

    // Define the pattern for a valid LR No (only digits allowed)
    const pattern = /^\d+$/;

    if (!pattern.test(lrNo)) {
        return "Invalid LR No"; // Return invalid if LR No doesn't consist of only digits
    }
    return lrNo; // Return valid LR No if validation passes
}
function formatAdjustedDate(inputDate) {
    if (!inputDate) return ""; // Return an empty string if inputDate is falsy

    // Parse the input date with moment
    const date1 = moment(inputDate);

    // Subtract 5 hours and 30 minutes
    const adjustedDate = date1.subtract(5, "hours").subtract(30, "minutes");

    // Convert to a native Date object
    const adjustedTime = adjustedDate.toDate();
    var timeString = adjustedTime.toDateString()
    const date = new Date(timeString);

    // Format date as "DD-MM-YYYY HH:mm:ss"
    const formattedDate = `${adjustedTime.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    
    return formattedDate;
}
function formatDate(dateString) {
    const date = new Date(dateString);
  
    // Get individual components
    const day = String(date.getDate()).padStart(2, '0');  // Adds leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based, so add 1
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    // Combine into desired format
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }


function convertTpt(input) {
    return input
      .toLowerCase() // Convert all characters to lowercase
      .split(' ') // Split the string into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
      .join(' '); // Join the words back into a single string
  }

  function capitalizeWords(str) {
    if (typeof str !== 'string') return str;  // Ensure it's a string before processing
    return str
      .toLowerCase()  // Convert the whole string to lowercase
      .split(' ')  // Split by spaces to handle multiple words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))  // Capitalize the first letter of each word
      .join(' ');  // Join the words back into a single string
}
function capitalizeWordsForFilters(str) {
    if (typeof str !== "string") {
        console.warn("Invalid input to capitalizeWords:", str); // Log invalid inputs for debugging
        return ""; // Return an empty string for non-string inputs
    }
    return str
        .toLowerCase()
        .replace(/\b\w/g, char => char?.toUpperCase());
}; 
function extractUniqueValues(items = []) {
    const uniqueSet = new Set();
    return items
    .map(item => {
        let id = item._id;
        // Check if the item is a string before applying toUpperCase
        if (typeof id === 'string') {
            return id.toUpperCase();
        }
        return id;  // If it's not a string, just return the item as-is
    })
    .filter(value => {
        if (!uniqueSet.has(value)) {
            uniqueSet.add(value);
            return true;
        }
        return false;
    })
    .map(value => ({
        label: capitalizeWordsForFilters(value),
        value: capitalizeWordsForFilters(value)
      }));

};
function extractUniqueValuesOfLrnos(items = []) {
    const uniqueSet = new Set();
    
    return items
        .filter(item => {
            const id = item._id;
            const trackingType = item.tracking_type;
            
            // Ensure id and trackingType exist before proceeding
            if (id && trackingType) {
                const combinedValue = `${id}:${trackingType}`; // Create a unique combination to avoid duplicates
                if (!uniqueSet.has(combinedValue)) {
                    uniqueSet.add(combinedValue);
                    return true;
                }
            }
            return false;
        })
        .map(item => ({
            label: item._id,           // label is the invoice_no
            value: item.tracking_type  // value is the tracking_type
        }));
};
function extractUniqueValuesOfCities(items = [])  {
    const uniqueSet = new Set();
    return items
        .map(item => {
            const label = capitalizeWordsForFilters(item._id); // Capitalize words for label
            const value = item._id; // Keep value as is
            return { label, value };
        })
        .filter(item => {
            if (!uniqueSet.has(item.value)) {
                uniqueSet.add(item.value);
                return true;
            }
            return false;
        });
};
function getDelayDaysBucket(transitDelayDays, transitDelayHours, transitDelay) {
    const days = transitDelayDays; 
    const hrs = transitDelayHours;
    var day_one = hrs >= 1 && hrs <= 48;

    if (transitDelay === 1 && hrs === 0) {
        return '1-2 Days';
    } else if (hrs !== undefined && hrs !== null) {
        const dayValue = parseInt(days, 10); // Convert days to an integer if it's a string
        if (day_one || dayValue === 1 || dayValue === 2) {
            return '1-2 Days';
        } else if (dayValue === 3 || dayValue === 4 || dayValue === 5) {
            return '3-5 Days';
        } else if (dayValue >= 6 && dayValue <= 10) {
            return '6-10 Days';
        } else if (dayValue > 10) {
            return '>10 Days';
        }
    }
    return ''; // Return empty if no value or invalid range
}